'use strict';

var _objectWithoutProperties2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _defineProperty2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _taggedTemplateLiteral2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _assertThisInitialized2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
var _classCallCheck2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _slicedToArray2 = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _excluded = ["label", "description", "count"],
  _excluded2 = ["field", "id", "label"];
var _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;
function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _ownKeys(Object(source), !0).forEach(function (key) { _defineProperty2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }
function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct2(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn2(this, result); }; }
function _isNativeReflectConstruct2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
require("core-js/modules/esnext.global-this.js");
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
require("core-js/modules/es.promise.finally.js");
require("core-js/modules/es.object.from-entries.js");
require("core-js/modules/es.string.trim-start.js");
require("core-js/modules/es.string.trim-end.js");
var React = require('react');
var styled = require('styled-components');
var ReactDOM = require('react-dom');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);
var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var a = Object.defineProperty({}, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function get() {
        return n[k];
      }
    });
  });
  return a;
}
var propTypes = {
  exports: {}
};
var reactIs$2 = {
  exports: {}
};
var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1 = "function" === typeof Symbol && Symbol.for,
  c$1 = b$1 ? Symbol.for("react.element") : 60103,
  d$2 = b$1 ? Symbol.for("react.portal") : 60106,
  e$1 = b$1 ? Symbol.for("react.fragment") : 60107,
  f$2 = b$1 ? Symbol.for("react.strict_mode") : 60108,
  g$1 = b$1 ? Symbol.for("react.profiler") : 60114,
  h$1 = b$1 ? Symbol.for("react.provider") : 60109,
  k$3 = b$1 ? Symbol.for("react.context") : 60110,
  l$2 = b$1 ? Symbol.for("react.async_mode") : 60111,
  m$2 = b$1 ? Symbol.for("react.concurrent_mode") : 60111,
  n$2 = b$1 ? Symbol.for("react.forward_ref") : 60112,
  p$2 = b$1 ? Symbol.for("react.suspense") : 60113,
  q$3 = b$1 ? Symbol.for("react.suspense_list") : 60120,
  r$1 = b$1 ? Symbol.for("react.memo") : 60115,
  t$1 = b$1 ? Symbol.for("react.lazy") : 60116,
  v$1 = b$1 ? Symbol.for("react.block") : 60121,
  w$1 = b$1 ? Symbol.for("react.fundamental") : 60117,
  x$1 = b$1 ? Symbol.for("react.responder") : 60118,
  y$1 = b$1 ? Symbol.for("react.scope") : 60119;
function z$1(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c$1:
        switch (a = a.type, a) {
          case l$2:
          case m$2:
          case e$1:
          case g$1:
          case f$2:
          case p$2:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$3:
              case n$2:
              case t$1:
              case r$1:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d$2:
        return u;
    }
  }
}
function A$1(a) {
  return z$1(a) === m$2;
}
reactIs_production_min$1.AsyncMode = l$2;
reactIs_production_min$1.ConcurrentMode = m$2;
reactIs_production_min$1.ContextConsumer = k$3;
reactIs_production_min$1.ContextProvider = h$1;
reactIs_production_min$1.Element = c$1;
reactIs_production_min$1.ForwardRef = n$2;
reactIs_production_min$1.Fragment = e$1;
reactIs_production_min$1.Lazy = t$1;
reactIs_production_min$1.Memo = r$1;
reactIs_production_min$1.Portal = d$2;
reactIs_production_min$1.Profiler = g$1;
reactIs_production_min$1.StrictMode = f$2;
reactIs_production_min$1.Suspense = p$2;
reactIs_production_min$1.isAsyncMode = function (a) {
  return A$1(a) || z$1(a) === l$2;
};
reactIs_production_min$1.isConcurrentMode = A$1;
reactIs_production_min$1.isContextConsumer = function (a) {
  return z$1(a) === k$3;
};
reactIs_production_min$1.isContextProvider = function (a) {
  return z$1(a) === h$1;
};
reactIs_production_min$1.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c$1;
};
reactIs_production_min$1.isForwardRef = function (a) {
  return z$1(a) === n$2;
};
reactIs_production_min$1.isFragment = function (a) {
  return z$1(a) === e$1;
};
reactIs_production_min$1.isLazy = function (a) {
  return z$1(a) === t$1;
};
reactIs_production_min$1.isMemo = function (a) {
  return z$1(a) === r$1;
};
reactIs_production_min$1.isPortal = function (a) {
  return z$1(a) === d$2;
};
reactIs_production_min$1.isProfiler = function (a) {
  return z$1(a) === g$1;
};
reactIs_production_min$1.isStrictMode = function (a) {
  return z$1(a) === f$2;
};
reactIs_production_min$1.isSuspense = function (a) {
  return z$1(a) === p$2;
};
reactIs_production_min$1.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m$2 || a === g$1 || a === f$2 || a === p$2 || a === q$3 || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h$1 || a.$$typeof === k$3 || a.$$typeof === n$2 || a.$$typeof === w$1 || a.$$typeof === x$1 || a.$$typeof === y$1 || a.$$typeof === v$1);
};
reactIs_production_min$1.typeOf = z$1;
var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function () {
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development$1.AsyncMode = AsyncMode;
    reactIs_development$1.ConcurrentMode = ConcurrentMode;
    reactIs_development$1.ContextConsumer = ContextConsumer;
    reactIs_development$1.ContextProvider = ContextProvider;
    reactIs_development$1.Element = Element;
    reactIs_development$1.ForwardRef = ForwardRef;
    reactIs_development$1.Fragment = Fragment;
    reactIs_development$1.Lazy = Lazy;
    reactIs_development$1.Memo = Memo;
    reactIs_development$1.Portal = Portal;
    reactIs_development$1.Profiler = Profiler;
    reactIs_development$1.StrictMode = StrictMode;
    reactIs_development$1.Suspense = Suspense;
    reactIs_development$1.isAsyncMode = isAsyncMode;
    reactIs_development$1.isConcurrentMode = isConcurrentMode;
    reactIs_development$1.isContextConsumer = isContextConsumer;
    reactIs_development$1.isContextProvider = isContextProvider;
    reactIs_development$1.isElement = isElement;
    reactIs_development$1.isForwardRef = isForwardRef;
    reactIs_development$1.isFragment = isFragment;
    reactIs_development$1.isLazy = isLazy;
    reactIs_development$1.isMemo = isMemo;
    reactIs_development$1.isPortal = isPortal;
    reactIs_development$1.isProfiler = isProfiler;
    reactIs_development$1.isStrictMode = isStrictMode;
    reactIs_development$1.isSuspense = isSuspense;
    reactIs_development$1.isValidElementType = isValidElementType;
    reactIs_development$1.typeOf = typeOf;
  })();
}
if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$b = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }

    // Detect buggy property enumeration order in older V8 versions.

    // https://bugs.chromium.org/p/v8/issues/detail?id=4118
    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }

    // https://bugs.chromium.org/p/v8/issues/detail?id=3056
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty$b.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;
var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function printWarning$1() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {/**/}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$2.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
var classnames = {
  exports: {}
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
  /* global define */

  (function () {
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
      var classes = [];
      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;
        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner = classNames.apply(null, arg);
            if (inner) {
              classes.push(inner);
            }
          }
        } else if (argType === 'object') {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(' ');
    }
    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
})(classnames);
var classNames = classnames.exports;
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var _templateObject$a, _templateObject2$4;
var BREAKPOINTS = {
  DESKTOP: 992,
  TABLET: 768,
  PHONE: 376
};
var MEDIA = Object.keys(BREAKPOINTS).reduce(function (acc, label) {
  acc[label] = function () {
    return styled.css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    @media (max-width: ", "em) {\n      ", ";\n    }\n  "])), BREAKPOINTS[label] / 16, styled.css.apply(void 0, arguments));
  };
  acc["MIN_".concat(label)] = function () {
    return styled.css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    @media (min-width: ", "em) {\n      ", ";\n    }\n  "])), BREAKPOINTS[label] / 16, styled.css.apply(void 0, arguments));
  };
  return acc;
}, {});
var _templateObject$9, _templateObject2$3, _templateObject3$3, _templateObject4$1, _templateObject5$1;
var Result = styled__default["default"].article(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n\n  flex: 0 1;\n  p {\n    padding: 0;\n  }\n  ", "\n    .inner {\n      background: #fff;\n    height: 100%;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.25);\n    &:hover {\n      box-shadow: 0 0 16px rgba(0, 0, 0, 0.25);\n    }\n    color: rgba(26, 25, 25, 1);\n    transition: all 0.5s ease;\n    border: 1px solid ", ";\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n    ", "\n    &-image {\n      position: relative;\n      height: 200px;\n      width: 300px;\n      overflow: hidden;\n      box-shadow: 1px 0 4px rgba(0, 0, 0, 0.25);\n      img {\n        position: absolute;\n        top: 50%;\n        width: 100%;\n        min-height: 100%;\n        transform: translate(0, -50%);\n      }\n    }\n    &-content {\n      padding: 16px;\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n      justify-content: space-between;\n      max-width: 75ch;\n      h4 {\n        font-weight: bold;\n        padding: 4px 0 8px;\n        line-height: 2.2rem;\n        min-height: 4.2rem;\n        span {\n          color: rgba(0, 0, 0, 0.5);\n          font-size: 90%;\n        }\n      }\n      &--bottom {\n        display: flex;\n        padding: 8px 0;\n        justify-content: space-between;\n        align-items: center;\n      }\n    }\n  }\n"])), MEDIA.PHONE(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    min-width: auto;\n    width: 100%;\n    flex: 0;\n    "]))), function (props) {
  return props.theme.primaryColor;
}, MEDIA.PHONE(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n      flex-direction: column;\n      width: 100%;\n      overflow: hidden;\n    "]))));
var AssortedHousesContainer = styled__default["default"].section(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  background: #f6f6f6;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 50px 0;\n  padding: 16px 10%;\n  max-width: 1440px;\n  margin: 0 auto;\n", ";\n"])), MEDIA.PHONE(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  "]))));
var _templateObject$8;
var Svg$2 = styled__default["default"].svg(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  stroke-linejoin: round;\n  stroke-miterlimit: 1.41421;\n"])));
var Bedroom = function Bedroom(_ref) {
  var width = _ref.width,
    height = _ref.height,
    fill = _ref.fill;
  return /*#__PURE__*/React__default["default"].createElement(Svg$2, {
    width: width,
    height: height,
    fill: fill,
    viewBox: "0 0 84 60",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    transform: "matrix(1,0,0,1,-8,-20)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M92,56L92,77C92,78.657 90.657,80 89,80C87.343,80 86,78.657 86,77L86,74L14,74L14,77C14,78.657 12.657,80 11,80C9.343,80 8,78.657 8,77L8,56C8,51.037 12.037,47 17,47L83,47C87.963,47 92,51.037 92,56Z",
    style: {
      fillRule: 'nonzero'
    }
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17,41L17,23C17,21.343 18.343,20 20,20L80,20C81.657,20 83,21.343 83,23L83,41L74,41L74,38C74,34.691 71.309,32 68,32L59,32C55.691,32 53,34.691 53,38L53,41L47,41L47,38C47,34.691 44.309,32 41,32L32,32C28.691,32 26,34.691 26,38L26,41L17,41Z",
    style: {
      fillRule: 'nonzero'
    }
  })));
};
var _templateObject$7;
var Svg$1 = styled__default["default"].svg(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  stroke-linejoin: round;\n  stroke-miterlimit: 1.41421;\n"])));
var Bathroom = function Bathroom(_ref) {
  var width = _ref.width,
    height = _ref.height,
    fill = _ref.fill;
  return /*#__PURE__*/React__default["default"].createElement(Svg$1, {
    width: width,
    height: height,
    fill: fill,
    viewBox: "0 0 54 51",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    transform: "matrix(1,0,0,1,-5,-6.085)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M58,37L56,37L13,37L13,12C13,11.199 13.312,10.445 13.878,9.879C14.853,8.904 16.332,8.754 17.476,9.403C15.292,12.068 14.927,15.327 16.736,17.136C16.931,17.331 17.187,17.429 17.443,17.429C17.699,17.429 17.955,17.331 18.15,17.136L26.635,8.651C26.83,8.456 26.928,8.2 26.928,7.944C26.928,7.688 26.83,7.432 26.635,7.237C25.635,6.237 24.164,5.871 22.489,6.206C21.26,6.452 20.028,7.077 18.928,7.969C16.974,6.549 14.224,6.703 12.463,8.465C11.52,9.409 11,10.664 11,12L11,37L8,37L6,37C5.448,37 5,37.447 5,38C5,38.553 5.448,39 6,39L7.307,39L13.064,54.352C13.21,54.741 13.583,55 14,55L15,55L15,56C15,56.553 15.448,57 16,57C16.552,57 17,56.553 17,56L17,55L47,55L47,56C47,56.553 47.447,57 48,57C48.553,57 49,56.553 49,56L49,55L50,55C50.417,55 50.79,54.741 50.937,54.352L56.693,39L58,39C58.553,39 59,38.553 59,38C59,37.447 58.553,37 58,37Z",
    style: {
      fillRule: 'nonzero'
    }
  })));
};
var _templateObject$6;
var Svg = styled__default["default"].svg(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  stroke-linejoin: round;\n  stroke-miterlimit: 1.41421;\n  fill: ", ";\n"])), function (props) {
  return props.fill ? props.fill : 'inherit';
});
var Persons = function Persons(_ref) {
  var width = _ref.width,
    height = _ref.height,
    fill = _ref.fill;
  return /*#__PURE__*/React__default["default"].createElement(Svg, {
    width: width,
    height: height,
    fill: fill,
    viewBox: "0 0 101 77",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    transform: "matrix(1,0,0,1,0.000512728,-11.918)"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M50.083,48.696C53.206,48.696 55.738,46.165 55.738,43.041C55.738,39.918 53.206,37.386 50.083,37.386C46.96,37.386 44.428,39.918 44.428,43.041C44.428,46.165 46.96,48.696 50.083,48.696ZM50.083,48.696C53.206,48.696 55.738,46.165 55.738,43.041C55.738,39.918 53.206,37.386 50.083,37.386C46.96,37.386 44.428,39.918 44.428,43.041C44.428,46.165 46.96,48.696 50.083,48.696ZM43.18,47.973L40.133,41.285C37.004,34.814 34.895,30.374 28.664,30.374L17.566,30.374C11.335,30.374 9.226,34.814 6.097,41.285L0.356,53.115C-0.497,54.861 0.234,56.958 1.98,57.809C3.727,58.662 5.841,57.937 6.694,56.191L14.633,40.858L14.633,84.234C14.633,86.343 16.342,88.053 18.452,88.053C20.562,88.053 22.271,86.343 22.271,84.234L22.271,61.999L23.981,61.999L23.981,84.263C23.981,86.372 25.691,88.082 27.8,88.082C29.909,88.082 31.62,86.372 31.62,84.263L31.62,40.857L37.957,53.574C39.275,51.035 40.722,48.847 43.18,47.973ZM23.113,28.91C27.805,28.91 31.61,25.106 31.61,20.414C31.61,15.722 27.806,11.918 23.113,11.918C18.42,11.918 14.617,15.722 14.617,20.414C14.617,25.106 18.42,28.91 23.113,28.91ZM99.644,53.114L93.903,41.284C90.775,34.813 88.666,30.373 82.434,30.373L71.336,30.373C65.106,30.373 62.996,34.813 59.867,41.284L56.719,47.972C59.213,48.797 60.68,50.538 62.002,53.055L68.403,40.857L64.713,59.227L66.781,63.49C67.726,65.428 67.023,68.399 65.082,69.346C64.756,69.505 64.416,69.617 64.066,69.68L68.403,69.68L68.403,84.233C68.403,86.342 70.113,88.052 72.222,88.052C74.331,88.052 76.04,86.342 76.04,84.233L76.04,69.681L77.75,69.681L77.75,84.263C77.75,86.372 79.46,88.082 81.569,88.082C83.678,88.082 85.388,86.372 85.388,84.263L85.388,69.681L91.338,69.681L85.388,40.858L93.305,56.191C94.157,57.937 96.272,58.662 98.018,57.809C99.766,56.957 100.496,54.86 99.644,53.114ZM76.883,28.91C81.575,28.91 85.379,25.106 85.379,20.414C85.379,15.722 81.575,11.918 76.883,11.918C72.191,11.918 68.387,15.722 68.387,20.414C68.387,25.106 72.19,28.91 76.883,28.91ZM61.412,56.933C59.329,52.626 57.926,49.67 53.778,49.67L46.391,49.67C42.244,49.67 40.84,52.626 38.758,56.933L34.936,64.807C34.369,65.969 34.846,67.383 36.017,67.932C37.398,68.58 38.749,67.686 39.155,66.855L44.439,56.649L44.439,85.521C44.439,86.924 45.577,88.063 46.981,88.063C48.385,88.063 49.523,86.924 49.523,85.521L49.523,70.721L50.661,70.721L50.661,85.54C50.661,86.943 51.799,88.082 53.203,88.082C54.607,88.082 55.745,86.943 55.745,85.54L55.745,56.648L61.015,66.854C61.42,67.685 62.593,68.58 64.153,67.931C65.346,67.435 65.801,65.968 65.233,64.806L61.412,56.933Z",
    style: {
      fillRule: 'nonzero'
    }
  })));
};
var _templateObject$5;
var ButtonStyle = styled__default["default"].a(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 12px 24px !important;\n  border-radius: 12px;\n  color: #fff !important;\n  color: ", ";\n  border: 2px solid\n    ", ";\n  font-weight: bold;\n  text-decoration: none;\n  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.25);\n  transition: all 0.5s ease;\n  width: fit-content;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  cursor: pointer;\n  &:before {\n    background-color: ", " !important;;\n    width: 100% !important;\n    position: absolute;\n    right: 0;\n    top: 0;\n    content: '';\n    height: 100% !important;\n    z-index: -1;\n    transition: all 0.5s ease;\n  }\n  &:hover {\n    border: 2px solid\n      ", ";\n    box-shadow: -1px 1px 4px rgba(0, 0, 0, 0.25);\n    color: ", " !important;\n    &:before {\n      width: 1px !important;\n      right: -1px;\n    }\n  }\n"])), function (props) {
  return props.purple ? '#642C8F' : '#000';
}, function (props) {
  return props.theme.primaryColor ? props.theme.primaryColor : '#642C8F';
}, function (props) {
  return props.theme.primaryColor ? props.theme.primaryColor : props.theme.primaryColor;
}, function (props) {
  return props.purple ? '#642C8F' : props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});
var StyledButton = function StyledButton(_ref) {
  var to = _ref.to,
    children = _ref.children,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(ButtonStyle, {
    href: to,
    title: title,
    className: className
  }, /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children));
};
var HousePreview = function HousePreview(_ref) {
  var house = _ref.house,
    locale = _ref.locale;
  var data = JSON.parse(house.field);
  var img;
  if (data.images[0]) {
    if (data.images[0].reference) {
      if (data.brand === 'BUKAZU') {
        img = data.images[0].reference;
      } else {
        img = 'https://cms.burobork.nl/images/' + data.images[0].reference;
      }
    } else {
      if (data.brand === 'LEISURE') {
        img = 'https://' + data.images[0].preview;
      } else {
        img = data.images[0].preview;
      }
    }
  }

  // const
  var house_url;
  if (locale === 'nl') {
    house_url = '/' + data.slug + '-' + data.house_code;
  } else {
    house_url = '/' + locale + '/' + data.slug + '-' + data.house_code;
  }
  return /*#__PURE__*/React__default["default"].createElement(Result, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: "inner-image"
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: img,
    alt: house.name
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "inner-content"
  }, /*#__PURE__*/React__default["default"].createElement("h4", null, data.name, ", ", data.city), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      padding: '8px 0'
    },
    dangerouslySetInnerHTML: {
      __html: data["short_description_".concat(locale)] ? data["short_description_".concat(locale)] : ''
    }
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: "inner-content--bottom"
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Persons, {
    width: "32px",
    height: "16px"
  }), data.persons), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Bedroom, {
    width: "32px",
    height: "16px"
  }), data.bedrooms), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Bathroom, {
    width: "32px",
    height: "16px"
  }), data.bathrooms)), /*#__PURE__*/React__default["default"].createElement(StyledButton, {
    to: house_url,
    title: data.name
  }, data.name))));
};
function AssortedHouses(_ref) {
  var options = _ref.options,
    houses = _ref.houses,
    locale = _ref.locale;
  if (!houses) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  }
  return /*#__PURE__*/React__default["default"].createElement(AssortedHousesContainer, null, options.content.map(function (item) {
    var house = houses.find(function (e) {
      return e.node.id === item.toString();
    });
    if (house == null) {
      return /*#__PURE__*/React__default["default"].createElement("div", null);
    }
    return /*#__PURE__*/React__default["default"].createElement(HousePreview, {
      house: house.node,
      locale: locale,
      key: item
    });
  }));
}
function Button(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React__default["default"].createElement(StyledButton, {
    to: options.link
  }, options.text);
}
var js$1 = {};
var Carousel$1 = {};
var lib = {};
var reactSwipe = {};
(function (exports) {
  (function (global, factory) {
    {
      factory(exports, React__default["default"], propTypes.exports);
    }
  })(commonjsGlobal$1, function (exports, _react, _propTypes) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    function _objectWithoutProperties(obj, keys) {
      var target = {};
      for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var supportsCaptureOption = false;
    function setHasSupportToCaptureOption(hasSupport) {
      supportsCaptureOption = hasSupport;
    }
    try {
      addEventListener('test', null, Object.defineProperty({}, 'capture', {
        get: function get() {
          setHasSupportToCaptureOption(true);
        }
      }));
    } catch (e) {} // eslint-disable-line no-empty

    function getSafeEventHandlerOpts() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        capture: true
      };
      return supportsCaptureOption ? options : options.capture;
    }

    /**
     * [getPosition returns a position element that works for mouse or touch events]
     * @param  {[Event]} event [the received event]
     * @return {[Object]}      [x and y coords]
     */
    function getPosition(event) {
      if ('touches' in event) {
        var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;
        return {
          x: pageX,
          y: pageY
        };
      }
      var screenX = event.screenX,
        screenY = event.screenY;
      return {
        x: screenX,
        y: screenY
      };
    }
    var ReactSwipe = function (_Component) {
      _inherits(ReactSwipe, _Component);
      function ReactSwipe() {
        var _ref;
        _classCallCheck(this, ReactSwipe);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));
        _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
        _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
        _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);
        _this._onMouseDown = _this._onMouseDown.bind(_this);
        _this._onMouseMove = _this._onMouseMove.bind(_this);
        _this._onMouseUp = _this._onMouseUp.bind(_this);
        _this._setSwiperRef = _this._setSwiperRef.bind(_this);
        return _this;
      }
      _createClass(ReactSwipe, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.swiper) {
            this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
              capture: true,
              passive: false
            }));
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.swiper) {
            this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
              capture: true,
              passive: false
            }));
          }
        }
      }, {
        key: '_onMouseDown',
        value: function _onMouseDown(event) {
          if (!this.props.allowMouseEvents) {
            return;
          }
          this.mouseDown = true;
          document.addEventListener('mouseup', this._onMouseUp);
          document.addEventListener('mousemove', this._onMouseMove);
          this._handleSwipeStart(event);
        }
      }, {
        key: '_onMouseMove',
        value: function _onMouseMove(event) {
          if (!this.mouseDown) {
            return;
          }
          this._handleSwipeMove(event);
        }
      }, {
        key: '_onMouseUp',
        value: function _onMouseUp(event) {
          this.mouseDown = false;
          document.removeEventListener('mouseup', this._onMouseUp);
          document.removeEventListener('mousemove', this._onMouseMove);
          this._handleSwipeEnd(event);
        }
      }, {
        key: '_handleSwipeStart',
        value: function _handleSwipeStart(event) {
          var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;
          this.moveStart = {
            x: x,
            y: y
          };
          this.props.onSwipeStart(event);
        }
      }, {
        key: '_handleSwipeMove',
        value: function _handleSwipeMove(event) {
          if (!this.moveStart) {
            return;
          }
          var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;
          var deltaX = x - this.moveStart.x;
          var deltaY = y - this.moveStart.y;
          this.moving = true;

          // handling the responsability of cancelling the scroll to
          // the component handling the event
          var shouldPreventDefault = this.props.onSwipeMove({
            x: deltaX,
            y: deltaY
          }, event);
          if (shouldPreventDefault && event.cancelable) {
            event.preventDefault();
          }
          this.movePosition = {
            deltaX: deltaX,
            deltaY: deltaY
          };
        }
      }, {
        key: '_handleSwipeEnd',
        value: function _handleSwipeEnd(event) {
          this.props.onSwipeEnd(event);
          var tolerance = this.props.tolerance;
          if (this.moving && this.movePosition) {
            if (this.movePosition.deltaX < -tolerance) {
              this.props.onSwipeLeft(1, event);
            } else if (this.movePosition.deltaX > tolerance) {
              this.props.onSwipeRight(1, event);
            }
            if (this.movePosition.deltaY < -tolerance) {
              this.props.onSwipeUp(1, event);
            } else if (this.movePosition.deltaY > tolerance) {
              this.props.onSwipeDown(1, event);
            }
          }
          this.moveStart = null;
          this.moving = false;
          this.movePosition = null;
        }
      }, {
        key: '_setSwiperRef',
        value: function _setSwiperRef(node) {
          this.swiper = node;
          this.props.innerRef(node);
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props;
          _props.tagName;
          var className = _props.className,
            style = _props.style,
            children = _props.children;
          _props.allowMouseEvents;
          _props.onSwipeUp;
          _props.onSwipeDown;
          _props.onSwipeLeft;
          _props.onSwipeRight;
          _props.onSwipeStart;
          _props.onSwipeMove;
          _props.onSwipeEnd;
          _props.innerRef;
          _props.tolerance;
          var props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd', 'innerRef', 'tolerance']);
          return _react2.default.createElement(this.props.tagName, _extends({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props), children);
        }
      }]);
      return ReactSwipe;
    }(_react.Component);
    ReactSwipe.displayName = 'ReactSwipe';
    ReactSwipe.propTypes = {
      tagName: _propTypes2.default.string,
      className: _propTypes2.default.string,
      style: _propTypes2.default.object,
      children: _propTypes2.default.node,
      allowMouseEvents: _propTypes2.default.bool,
      onSwipeUp: _propTypes2.default.func,
      onSwipeDown: _propTypes2.default.func,
      onSwipeLeft: _propTypes2.default.func,
      onSwipeRight: _propTypes2.default.func,
      onSwipeStart: _propTypes2.default.func,
      onSwipeMove: _propTypes2.default.func,
      onSwipeEnd: _propTypes2.default.func,
      innerRef: _propTypes2.default.func,
      tolerance: _propTypes2.default.number.isRequired
    };
    ReactSwipe.defaultProps = {
      tagName: 'div',
      allowMouseEvents: false,
      onSwipeUp: function onSwipeUp() {},
      onSwipeDown: function onSwipeDown() {},
      onSwipeLeft: function onSwipeLeft() {},
      onSwipeRight: function onSwipeRight() {},
      onSwipeStart: function onSwipeStart() {},
      onSwipeMove: function onSwipeMove() {},
      onSwipeEnd: function onSwipeEnd() {},
      innerRef: function innerRef() {},
      tolerance: 0
    };
    exports.default = ReactSwipe;
  });
})(reactSwipe);
(function (exports) {
  (function (global, factory) {
    {
      factory(exports, reactSwipe);
    }
  })(commonjsGlobal$1, function (exports, _reactSwipe) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var _reactSwipe2 = _interopRequireDefault(_reactSwipe);
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    exports.default = _reactSwipe2.default;
  });
})(lib);
var cssClasses = {};
Object.defineProperty(cssClasses, "__esModule", {
  value: true
});
cssClasses.default = void 0;
var _classnames = _interopRequireDefault$4(classnames.exports);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var _default$3 = {
  ROOT: function ROOT(customClassName) {
    return (0, _classnames.default)(_defineProperty$3({
      'carousel-root': true
    }, customClassName || '', !!customClassName));
  },
  CAROUSEL: function CAROUSEL(isSlider) {
    return (0, _classnames.default)({
      carousel: true,
      'carousel-slider': isSlider
    });
  },
  WRAPPER: function WRAPPER(isSlider, axis) {
    return (0, _classnames.default)({
      'thumbs-wrapper': !isSlider,
      'slider-wrapper': isSlider,
      'axis-horizontal': axis === 'horizontal',
      'axis-vertical': axis !== 'horizontal'
    });
  },
  SLIDER: function SLIDER(isSlider, isSwiping) {
    return (0, _classnames.default)({
      thumbs: !isSlider,
      slider: isSlider,
      animated: !isSwiping
    });
  },
  ITEM: function ITEM(isSlider, selected, previous) {
    return (0, _classnames.default)({
      thumb: !isSlider,
      slide: isSlider,
      selected: selected,
      previous: previous
    });
  },
  ARROW_PREV: function ARROW_PREV(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-prev': true,
      'control-disabled': disabled
    });
  },
  ARROW_NEXT: function ARROW_NEXT(disabled) {
    return (0, _classnames.default)({
      'control-arrow control-next': true,
      'control-disabled': disabled
    });
  },
  DOT: function DOT(selected) {
    return (0, _classnames.default)({
      dot: true,
      selected: selected
    });
  }
};
cssClasses.default = _default$3;
var Thumbs$1 = {};
var dimensions = {};
Object.defineProperty(dimensions, "__esModule", {
  value: true
});
dimensions.outerWidth = void 0;
var outerWidth = function outerWidth(el) {
  var width = el.offsetWidth;
  var style = getComputedStyle(el);
  width += parseInt(style.marginLeft) + parseInt(style.marginRight);
  return width;
};
dimensions.outerWidth = outerWidth;
var CSSTranslate = {};
Object.defineProperty(CSSTranslate, "__esModule", {
  value: true
});
CSSTranslate.default = void 0;
var _default$2 = function _default(position, metric, axis) {
  var positionPercent = position === 0 ? position : position + metric;
  var positionCss = axis === 'horizontal' ? [positionPercent, 0, 0] : [0, positionPercent, 0];
  var transitionProp = 'translate3d';
  var translatedPosition = '(' + positionCss.join(',') + ')';
  return transitionProp + translatedPosition;
};
CSSTranslate.default = _default$2;
var window$1 = {};
Object.defineProperty(window$1, "__esModule", {
  value: true
});
window$1.default = void 0;
var _default$1 = function _default() {
  return window;
};
window$1.default = _default$1;
Object.defineProperty(Thumbs$1, "__esModule", {
  value: true
});
Thumbs$1.default = void 0;
var _react$3 = _interopRequireWildcard$1(React__default["default"]);
var _cssClasses$1 = _interopRequireDefault$3(cssClasses);
var _dimensions = dimensions;
var _CSSTranslate$2 = _interopRequireDefault$3(CSSTranslate);
var _reactEasySwipe$1 = _interopRequireDefault$3(lib);
var _window$1 = _interopRequireDefault$3(window$1);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache$1() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache$1 = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard$1(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof$1(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache$1();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$1(obj);
}
function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$2(self);
}
function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var isKeyboardEvent$1 = function isKeyboardEvent(e) {
  return e.hasOwnProperty('key');
};
var Thumbs = /*#__PURE__*/function (_Component) {
  _inherits$1(Thumbs, _Component);
  var _super = _createSuper$1(Thumbs);
  function Thumbs(_props) {
    var _this;
    _classCallCheck$1(this, Thumbs);
    _this = _super.call(this, _props);
    _defineProperty$2(_assertThisInitialized$2(_this), "itemsWrapperRef", void 0);
    _defineProperty$2(_assertThisInitialized$2(_this), "itemsListRef", void 0);
    _defineProperty$2(_assertThisInitialized$2(_this), "thumbsRef", void 0);
    _defineProperty$2(_assertThisInitialized$2(_this), "setItemsWrapperRef", function (node) {
      _this.itemsWrapperRef = node;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "setItemsListRef", function (node) {
      _this.itemsListRef = node;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "setThumbsRef", function (node, index) {
      if (!_this.thumbsRef) {
        _this.thumbsRef = [];
      }
      _this.thumbsRef[index] = node;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "updateSizes", function () {
      if (!_this.props.children || !_this.itemsWrapperRef || !_this.thumbsRef) {
        return;
      }
      var total = _react$3.Children.count(_this.props.children);
      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var itemSize = _this.props.thumbWidth ? _this.props.thumbWidth : (0, _dimensions.outerWidth)(_this.thumbsRef[0]);
      var visibleItems = Math.floor(wrapperSize / itemSize);
      var showArrows = visibleItems < total;
      var lastPosition = showArrows ? total - visibleItems : 0;
      _this.setState(function (_state, props) {
        return {
          itemSize: itemSize,
          visibleItems: visibleItems,
          firstItem: showArrows ? _this.getFirstItem(props.selectedItem) : 0,
          lastPosition: lastPosition,
          showArrows: showArrows
        };
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "handleClickItem", function (index, item, e) {
      if (!isKeyboardEvent$1(e) || e.key === 'Enter') {
        var handler = _this.props.onSelectItem;
        if (typeof handler === 'function') {
          handler(index, item);
        }
      }
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onSwipeStart", function () {
      _this.setState({
        swiping: true
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onSwipeEnd", function () {
      _this.setState({
        swiping: false
      });
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "onSwipeMove", function (delta) {
      var deltaX = delta.x;
      if (!_this.state.itemSize || !_this.itemsWrapperRef || !_this.state.visibleItems) {
        return false;
      }
      var leftBoundary = 0;
      var childrenLength = _react$3.Children.count(_this.props.children);
      var currentPosition = -(_this.state.firstItem * 100) / _this.state.visibleItems;
      var lastLeftItem = Math.max(childrenLength - _this.state.visibleItems, 0);
      var lastLeftBoundary = -lastLeftItem * 100 / _this.state.visibleItems; // prevent user from swiping left out of boundaries

      if (currentPosition === leftBoundary && deltaX > 0) {
        deltaX = 0;
      } // prevent user from swiping right out of boundaries

      if (currentPosition === lastLeftBoundary && deltaX < 0) {
        deltaX = 0;
      }
      var wrapperSize = _this.itemsWrapperRef.clientWidth;
      var position = currentPosition + 100 / (wrapperSize / deltaX); // if 3d isn't available we will use left to move

      if (_this.itemsListRef) {
        ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
          _this.itemsListRef.style[prop] = (0, _CSSTranslate$2.default)(position, '%', _this.props.axis);
        });
      }
      return true;
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "slideRight", function (positions) {
      _this.moveTo(_this.state.firstItem - (typeof positions === 'number' ? positions : 1));
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "slideLeft", function (positions) {
      _this.moveTo(_this.state.firstItem + (typeof positions === 'number' ? positions : 1));
    });
    _defineProperty$2(_assertThisInitialized$2(_this), "moveTo", function (position) {
      // position can't be lower than 0
      position = position < 0 ? 0 : position; // position can't be higher than last postion

      position = position >= _this.state.lastPosition ? _this.state.lastPosition : position;
      _this.setState({
        firstItem: position
      });
    });
    _this.state = {
      selectedItem: _props.selectedItem,
      swiping: false,
      showArrows: false,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    };
    return _this;
  }
  _createClass$1(Thumbs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedItem !== this.state.selectedItem) {
        this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        });
      }
      if (this.props.children === prevProps.children) {
        return;
      } // This will capture any size changes for arrow adjustments etc.
      // usually in the same render cycle so we don't see any flickers

      this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function setupThumbs() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window$1.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window$1.default)().addEventListener('DOMContentLoaded', this.updateSizes); // when the component is rendered we need to calculate
      // the container size to adjust the responsive behaviour

      this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function destroyThumbs() {
      // removing listeners
      (0, _window$1.default)().removeEventListener('resize', this.updateSizes);
      (0, _window$1.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function getFirstItem(selectedItem) {
      var firstItem = selectedItem;
      if (selectedItem >= this.state.lastPosition) {
        firstItem = this.state.lastPosition;
      }
      if (selectedItem < this.state.firstItem + this.state.visibleItems) {
        firstItem = this.state.firstItem;
      }
      if (selectedItem < this.state.firstItem) {
        firstItem = selectedItem;
      }
      return firstItem;
    }
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;
      return this.props.children.map(function (img, index) {
        var itemClass = _cssClasses$1.default.ITEM(false, index === _this2.state.selectedItem);
        var thumbProps = {
          key: index,
          ref: function ref(e) {
            return _this2.setThumbsRef(e, index);
          },
          className: itemClass,
          onClick: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          onKeyDown: _this2.handleClickItem.bind(_this2, index, _this2.props.children[index]),
          'aria-label': "".concat(_this2.props.labels.item, " ").concat(index + 1),
          style: {
            width: _this2.props.thumbWidth
          }
        };
        return /*#__PURE__*/_react$3.default.createElement("li", _extends$2({}, thumbProps, {
          role: "button",
          tabIndex: 0
        }), img);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.props.children) {
        return null;
      }
      var isSwipeable = _react$3.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = this.state.showArrows && this.state.firstItem > 0; // show right arrow

      var hasNext = this.state.showArrows && this.state.firstItem < this.state.lastPosition; // obj to hold the transformations and styles

      var itemListStyles = {};
      var currentPosition = -this.state.firstItem * (this.state.itemSize || 0);
      var transformProp = (0, _CSSTranslate$2.default)(currentPosition, 'px', this.props.axis);
      var transitionTime = this.props.transitionTime + 'ms';
      itemListStyles = {
        WebkitTransform: transformProp,
        MozTransform: transformProp,
        MsTransform: transformProp,
        OTransform: transformProp,
        transform: transformProp,
        msTransform: transformProp,
        WebkitTransitionDuration: transitionTime,
        MozTransitionDuration: transitionTime,
        MsTransitionDuration: transitionTime,
        OTransitionDuration: transitionTime,
        transitionDuration: transitionTime,
        msTransitionDuration: transitionTime
      };
      return /*#__PURE__*/_react$3.default.createElement("div", {
        className: _cssClasses$1.default.CAROUSEL(false)
      }, /*#__PURE__*/_react$3.default.createElement("div", {
        className: _cssClasses$1.default.WRAPPER(false),
        ref: this.setItemsWrapperRef
      }, /*#__PURE__*/_react$3.default.createElement("button", {
        type: "button",
        className: _cssClasses$1.default.ARROW_PREV(!hasPrev),
        onClick: function onClick() {
          return _this3.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), isSwipeable ? /*#__PURE__*/_react$3.default.createElement(_reactEasySwipe$1.default, {
        tagName: "ul",
        className: _cssClasses$1.default.SLIDER(false, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: itemListStyles,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /*#__PURE__*/_react$3.default.createElement("ul", {
        className: _cssClasses$1.default.SLIDER(false, this.state.swiping),
        ref: function ref(node) {
          return _this3.setItemsListRef(node);
        },
        style: itemListStyles
      }, this.renderItems()), /*#__PURE__*/_react$3.default.createElement("button", {
        type: "button",
        className: _cssClasses$1.default.ARROW_NEXT(!hasNext),
        onClick: function onClick() {
          return _this3.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]);
  return Thumbs;
}(_react$3.Component);
Thumbs$1.default = Thumbs;
_defineProperty$2(Thumbs, "displayName", 'Thumbs');
_defineProperty$2(Thumbs, "defaultProps", {
  axis: 'horizontal',
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var document$1 = {};
Object.defineProperty(document$1, "__esModule", {
  value: true
});
document$1.default = void 0;
var _default = function _default() {
  return document;
};
document$1.default = _default;
var utils = {};
Object.defineProperty(utils, "__esModule", {
  value: true
});
utils.setPosition = utils.getPosition = utils.isKeyboardEvent = utils.defaultStatusFormatter = utils.noop = void 0;
var _react$2 = React__default["default"];
var _CSSTranslate$1 = _interopRequireDefault$2(CSSTranslate);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var noop$2 = function noop() {};
utils.noop = noop$2;
var defaultStatusFormatter = function defaultStatusFormatter(current, total) {
  return "".concat(current, " of ").concat(total);
};
utils.defaultStatusFormatter = defaultStatusFormatter;
var isKeyboardEvent = function isKeyboardEvent(e) {
  return e ? e.hasOwnProperty('key') : false;
};
/**
 * Gets the list 'position' relative to a current index
 * @param index
 */

utils.isKeyboardEvent = isKeyboardEvent;
var getPosition = function getPosition(index, props) {
  if (props.infiniteLoop) {
    // index has to be added by 1 because of the first cloned slide
    ++index;
  }
  if (index === 0) {
    return 0;
  }
  var childrenLength = _react$2.Children.count(props.children);
  if (props.centerMode && props.axis === 'horizontal') {
    var currentPosition = -index * props.centerSlidePercentage;
    var lastPosition = childrenLength - 1;
    if (index && (index !== lastPosition || props.infiniteLoop)) {
      currentPosition += (100 - props.centerSlidePercentage) / 2;
    } else if (index === lastPosition) {
      currentPosition += 100 - props.centerSlidePercentage;
    }
    return currentPosition;
  }
  return -index * 100;
};
/**
 * Sets the 'position' transform for sliding animations
 * @param position
 * @param forceReflow
 */

utils.getPosition = getPosition;
var setPosition = function setPosition(position, axis) {
  var style = {};
  ['WebkitTransform', 'MozTransform', 'MsTransform', 'OTransform', 'transform', 'msTransform'].forEach(function (prop) {
    // @ts-ignore
    style[prop] = (0, _CSSTranslate$1.default)(position, '%', axis);
  });
  return style;
};
utils.setPosition = setPosition;
var animations = {};
Object.defineProperty(animations, "__esModule", {
  value: true
});
animations.fadeAnimationHandler = animations.slideStopSwipingHandler = animations.slideSwipeAnimationHandler = animations.slideAnimationHandler = void 0;
var _react$1 = React__default["default"];
var _CSSTranslate = _interopRequireDefault$1(CSSTranslate);
var _utils$1 = utils;
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Main animation handler for the default 'sliding' style animation
 * @param props
 * @param state
 */
var slideAnimationHandler = function slideAnimationHandler(props, state) {
  var returnStyles = {};
  var selectedItem = state.selectedItem;
  var previousItem = selectedItem;
  var lastPosition = _react$1.Children.count(props.children) - 1;
  var needClonedSlide = props.infiniteLoop && (selectedItem < 0 || selectedItem > lastPosition); // Handle list position if it needs a clone

  if (needClonedSlide) {
    if (previousItem < 0) {
      if (props.centerMode && props.centerSlidePercentage && props.axis === 'horizontal') {
        returnStyles.itemListStyle = (0, _utils$1.setPosition)(-(lastPosition + 2) * props.centerSlidePercentage - (100 - props.centerSlidePercentage) / 2, props.axis);
      } else {
        returnStyles.itemListStyle = (0, _utils$1.setPosition)(-(lastPosition + 2) * 100, props.axis);
      }
    } else if (previousItem > lastPosition) {
      returnStyles.itemListStyle = (0, _utils$1.setPosition)(0, props.axis);
    }
    return returnStyles;
  }
  var currentPosition = (0, _utils$1.getPosition)(selectedItem, props); // if 3d is available, let's take advantage of the performance of transform

  var transformProp = (0, _CSSTranslate.default)(currentPosition, '%', props.axis);
  var transitionTime = props.transitionTime + 'ms';
  returnStyles.itemListStyle = {
    WebkitTransform: transformProp,
    msTransform: transformProp,
    OTransform: transformProp,
    transform: transformProp
  };
  if (!state.swiping) {
    returnStyles.itemListStyle = _objectSpread$1(_objectSpread$1({}, returnStyles.itemListStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }
  return returnStyles;
};
/**
 * Swiping animation handler for the default 'sliding' style animation
 * @param delta
 * @param props
 * @param state
 * @param setState
 */

animations.slideAnimationHandler = slideAnimationHandler;
var slideSwipeAnimationHandler = function slideSwipeAnimationHandler(delta, props, state, setState) {
  var returnStyles = {};
  var isHorizontal = props.axis === 'horizontal';
  var childrenLength = _react$1.Children.count(props.children);
  var initialBoundry = 0;
  var currentPosition = (0, _utils$1.getPosition)(state.selectedItem, props);
  var finalBoundry = props.infiniteLoop ? (0, _utils$1.getPosition)(childrenLength - 1, props) - 100 : (0, _utils$1.getPosition)(childrenLength - 1, props);
  var axisDelta = isHorizontal ? delta.x : delta.y;
  var handledDelta = axisDelta; // prevent user from swiping left out of boundaries

  if (currentPosition === initialBoundry && axisDelta > 0) {
    handledDelta = 0;
  } // prevent user from swiping right out of boundaries

  if (currentPosition === finalBoundry && axisDelta < 0) {
    handledDelta = 0;
  }
  var position = currentPosition + 100 / (state.itemSize / handledDelta);
  var hasMoved = Math.abs(axisDelta) > props.swipeScrollTolerance;
  if (props.infiniteLoop && hasMoved) {
    // When allowing infinite loop, if we slide left from position 0 we reveal the cloned last slide that appears before it
    // if we slide even further we need to jump to other side so it can continue - and vice versa for the last slide
    if (state.selectedItem === 0 && position > -100) {
      position -= childrenLength * 100;
    } else if (state.selectedItem === childrenLength - 1 && position < -childrenLength * 100) {
      position += childrenLength * 100;
    }
  }
  if (!props.preventMovementUntilSwipeScrollTolerance || hasMoved || state.swipeMovementStarted) {
    if (!state.swipeMovementStarted) {
      setState({
        swipeMovementStarted: true
      });
    }
    returnStyles.itemListStyle = (0, _utils$1.setPosition)(position, props.axis);
  } //allows scroll if the swipe was within the tolerance

  if (hasMoved && !state.cancelClick) {
    setState({
      cancelClick: true
    });
  }
  return returnStyles;
};
/**
 * Default 'sliding' style animination handler for when a swipe action stops.
 * @param props
 * @param state
 */

animations.slideSwipeAnimationHandler = slideSwipeAnimationHandler;
var slideStopSwipingHandler = function slideStopSwipingHandler(props, state) {
  var currentPosition = (0, _utils$1.getPosition)(state.selectedItem, props);
  var itemListStyle = (0, _utils$1.setPosition)(currentPosition, props.axis);
  return {
    itemListStyle: itemListStyle
  };
};
/**
 * Main animation handler for the default 'fade' style animation
 * @param props
 * @param state
 */

animations.slideStopSwipingHandler = slideStopSwipingHandler;
var fadeAnimationHandler = function fadeAnimationHandler(props, state) {
  var transitionTime = props.transitionTime + 'ms';
  var transitionTimingFunction = 'ease-in-out';
  var slideStyle = {
    position: 'absolute',
    display: 'block',
    zIndex: -2,
    minHeight: '100%',
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: transitionTimingFunction,
    msTransitionTimingFunction: transitionTimingFunction,
    MozTransitionTimingFunction: transitionTimingFunction,
    WebkitTransitionTimingFunction: transitionTimingFunction,
    OTransitionTimingFunction: transitionTimingFunction
  };
  if (!state.swiping) {
    slideStyle = _objectSpread$1(_objectSpread$1({}, slideStyle), {}, {
      WebkitTransitionDuration: transitionTime,
      MozTransitionDuration: transitionTime,
      OTransitionDuration: transitionTime,
      transitionDuration: transitionTime,
      msTransitionDuration: transitionTime
    });
  }
  return {
    slideStyle: slideStyle,
    selectedStyle: _objectSpread$1(_objectSpread$1({}, slideStyle), {}, {
      opacity: 1,
      position: 'relative'
    }),
    prevStyle: _objectSpread$1({}, slideStyle)
  };
};
animations.fadeAnimationHandler = fadeAnimationHandler;
Object.defineProperty(Carousel$1, "__esModule", {
  value: true
});
Carousel$1.default = void 0;
var _react = _interopRequireWildcard(React__default["default"]);
var _reactEasySwipe = _interopRequireDefault(lib);
var _cssClasses = _interopRequireDefault(cssClasses);
var _Thumbs = _interopRequireDefault(Thumbs$1);
var _document = _interopRequireDefault(document$1);
var _window = _interopRequireDefault(window$1);
var _utils = utils;
var _animations = animations;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$1(self);
}
function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var Carousel = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);
  var _super = _createSuper(Carousel);

  // @ts-ignore
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized$1(_this), "thumbsRef", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "carouselWrapperRef", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "listRef", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "itemsRef", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "timer", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "animationHandler", void 0);
    _defineProperty(_assertThisInitialized$1(_this), "setThumbsRef", function (node) {
      _this.thumbsRef = node;
    });
    _defineProperty(_assertThisInitialized$1(_this), "setCarouselWrapperRef", function (node) {
      _this.carouselWrapperRef = node;
    });
    _defineProperty(_assertThisInitialized$1(_this), "setListRef", function (node) {
      _this.listRef = node;
    });
    _defineProperty(_assertThisInitialized$1(_this), "setItemsRef", function (node, index) {
      if (!_this.itemsRef) {
        _this.itemsRef = [];
      }
      _this.itemsRef[index] = node;
    });
    _defineProperty(_assertThisInitialized$1(_this), "autoPlay", function () {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }
      _this.clearAutoPlay();
      if (!_this.props.autoPlay) {
        return;
      }
      _this.timer = setTimeout(function () {
        _this.increment();
      }, _this.props.interval);
    });
    _defineProperty(_assertThisInitialized$1(_this), "clearAutoPlay", function () {
      if (_this.timer) clearTimeout(_this.timer);
    });
    _defineProperty(_assertThisInitialized$1(_this), "resetAutoPlay", function () {
      _this.clearAutoPlay();
      _this.autoPlay();
    });
    _defineProperty(_assertThisInitialized$1(_this), "stopOnHover", function () {
      _this.setState({
        isMouseEntered: true
      }, _this.clearAutoPlay);
    });
    _defineProperty(_assertThisInitialized$1(_this), "startOnLeave", function () {
      _this.setState({
        isMouseEntered: false
      }, _this.autoPlay);
    });
    _defineProperty(_assertThisInitialized$1(_this), "isFocusWithinTheCarousel", function () {
      if (!_this.carouselWrapperRef) {
        return false;
      }
      if ((0, _document.default)().activeElement === _this.carouselWrapperRef || _this.carouselWrapperRef.contains((0, _document.default)().activeElement)) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized$1(_this), "navigateWithKeyboard", function (e) {
      if (!_this.isFocusWithinTheCarousel()) {
        return;
      }
      var axis = _this.props.axis;
      var isHorizontal = axis === 'horizontal';
      var keyNames = {
        ArrowUp: 38,
        ArrowRight: 39,
        ArrowDown: 40,
        ArrowLeft: 37
      };
      var nextKey = isHorizontal ? keyNames.ArrowRight : keyNames.ArrowDown;
      var prevKey = isHorizontal ? keyNames.ArrowLeft : keyNames.ArrowUp;
      if (nextKey === e.keyCode) {
        _this.increment();
      } else if (prevKey === e.keyCode) {
        _this.decrement();
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "updateSizes", function () {
      if (!_this.state.initialized || !_this.itemsRef || _this.itemsRef.length === 0) {
        return;
      }
      var isHorizontal = _this.props.axis === 'horizontal';
      var firstItem = _this.itemsRef[0];
      if (!firstItem) {
        return;
      }
      var itemSize = isHorizontal ? firstItem.clientWidth : firstItem.clientHeight;
      _this.setState({
        itemSize: itemSize
      });
      if (_this.thumbsRef) {
        _this.thumbsRef.updateSizes();
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "setMountState", function () {
      _this.setState({
        hasMount: true
      });
      _this.updateSizes();
    });
    _defineProperty(_assertThisInitialized$1(_this), "handleClickItem", function (index, item) {
      if (_react.Children.count(_this.props.children) === 0) {
        return;
      }
      if (_this.state.cancelClick) {
        _this.setState({
          cancelClick: false
        });
        return;
      }
      _this.props.onClickItem(index, item);
      if (index !== _this.state.selectedItem) {
        _this.setState({
          selectedItem: index
        });
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "handleOnChange", function (index, item) {
      if (_react.Children.count(_this.props.children) <= 1) {
        return;
      }
      _this.props.onChange(index, item);
    });
    _defineProperty(_assertThisInitialized$1(_this), "handleClickThumb", function (index, item) {
      _this.props.onClickThumb(index, item);
      _this.moveTo(index);
    });
    _defineProperty(_assertThisInitialized$1(_this), "onSwipeStart", function (event) {
      _this.setState({
        swiping: true
      });
      _this.props.onSwipeStart(event);
    });
    _defineProperty(_assertThisInitialized$1(_this), "onSwipeEnd", function (event) {
      _this.setState({
        swiping: false,
        cancelClick: false,
        swipeMovementStarted: false
      });
      _this.props.onSwipeEnd(event);
      _this.clearAutoPlay();
      if (_this.state.autoPlay) {
        _this.autoPlay();
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "onSwipeMove", function (delta, event) {
      _this.props.onSwipeMove(event);
      var animationHandlerResponse = _this.props.swipeAnimationHandler(delta, _this.props, _this.state, _this.setState.bind(_assertThisInitialized$1(_this)));
      _this.setState(_objectSpread({}, animationHandlerResponse)); // If we have not moved, we should have an empty object returned
      // Return false to allow scrolling when not swiping

      return !!Object.keys(animationHandlerResponse).length;
    });
    _defineProperty(_assertThisInitialized$1(_this), "decrement", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      _this.moveTo(_this.state.selectedItem - (typeof positions === 'number' ? positions : 1));
    });
    _defineProperty(_assertThisInitialized$1(_this), "increment", function () {
      var positions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      _this.moveTo(_this.state.selectedItem + (typeof positions === 'number' ? positions : 1));
    });
    _defineProperty(_assertThisInitialized$1(_this), "moveTo", function (position) {
      if (typeof position !== 'number') {
        return;
      }
      var lastPosition = _react.Children.count(_this.props.children) - 1;
      if (position < 0) {
        position = _this.props.infiniteLoop ? lastPosition : 0;
      }
      if (position > lastPosition) {
        position = _this.props.infiniteLoop ? 0 : lastPosition;
      }
      _this.selectItem({
        // if it's not a slider, we don't need to set position here
        selectedItem: position
      }); // don't reset auto play when stop on hover is enabled, doing so will trigger a call to auto play more than once
      // and will result in the interval function not being cleared correctly.

      if (_this.state.autoPlay && _this.state.isMouseEntered === false) {
        _this.resetAutoPlay();
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "onClickNext", function () {
      _this.increment(1);
    });
    _defineProperty(_assertThisInitialized$1(_this), "onClickPrev", function () {
      _this.decrement(1);
    });
    _defineProperty(_assertThisInitialized$1(_this), "onSwipeForward", function () {
      _this.increment(1);
      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "onSwipeBackwards", function () {
      _this.decrement(1);
      if (_this.props.emulateTouch) {
        _this.setState({
          cancelClick: true
        });
      }
    });
    _defineProperty(_assertThisInitialized$1(_this), "changeItem", function (newIndex) {
      return function (e) {
        if (!(0, _utils.isKeyboardEvent)(e) || e.key === 'Enter') {
          _this.moveTo(newIndex);
        }
      };
    });
    _defineProperty(_assertThisInitialized$1(_this), "selectItem", function (state) {
      // Merge in the new state while updating updating previous item
      _this.setState(_objectSpread({
        previousItem: _this.state.selectedItem
      }, state), function () {
        // Run animation handler and update styles based on it
        _this.setState(_this.animationHandler(_this.props, _this.state));
      });
      _this.handleOnChange(state.selectedItem, _react.Children.toArray(_this.props.children)[state.selectedItem]);
    });
    _defineProperty(_assertThisInitialized$1(_this), "getInitialImage", function () {
      var selectedItem = _this.props.selectedItem;
      var item = _this.itemsRef && _this.itemsRef[selectedItem];
      var images = item && item.getElementsByTagName('img') || [];
      return images[0];
    });
    _defineProperty(_assertThisInitialized$1(_this), "getVariableItemHeight", function (position) {
      var item = _this.itemsRef && _this.itemsRef[position];
      if (_this.state.hasMount && item && item.children.length) {
        var slideImages = item.children[0].getElementsByTagName('img') || [];
        if (slideImages.length > 0) {
          var image = slideImages[0];
          if (!image.complete) {
            // if the image is still loading, the size won't be available so we trigger a new render after it's done
            var onImageLoad = function onImageLoad() {
              _this.forceUpdate();
              image.removeEventListener('load', onImageLoad);
            };
            image.addEventListener('load', onImageLoad);
          }
        } // try to get img first, if img not there find first display tag

        var displayItem = slideImages[0] || item.children[0];
        var height = displayItem.clientHeight;
        return height > 0 ? height : null;
      }
      return null;
    });
    var initState = {
      initialized: false,
      previousItem: props.selectedItem,
      selectedItem: props.selectedItem,
      hasMount: false,
      isMouseEntered: false,
      autoPlay: props.autoPlay,
      swiping: false,
      swipeMovementStarted: false,
      cancelClick: false,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    _this.animationHandler = typeof props.animationHandler === 'function' && props.animationHandler || props.animationHandler === 'fade' && _animations.fadeAnimationHandler || _animations.slideAnimationHandler;
    _this.state = _objectSpread(_objectSpread({}, initState), _this.animationHandler(props, initState));
    return _this;
  }
  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.children) {
        return;
      }
      this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.children && this.props.children && !this.state.initialized) {
        this.setupCarousel();
      }
      if (!prevProps.autoFocus && this.props.autoFocus) {
        this.forceFocus();
      }
      if (prevState.swiping && !this.state.swiping) {
        // We stopped swiping, ensure we are heading to the new/current slide and not stuck
        this.setState(_objectSpread({}, this.props.stopSwipingHandler(this.props, this.state)));
      }
      if (prevProps.selectedItem !== this.props.selectedItem || prevProps.centerMode !== this.props.centerMode) {
        this.updateSizes();
        this.moveTo(this.props.selectedItem);
      }
      if (prevProps.autoPlay !== this.props.autoPlay) {
        if (this.props.autoPlay) {
          this.setupAutoPlay();
        } else {
          this.destroyAutoPlay();
        }
        this.setState({
          autoPlay: this.props.autoPlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function setupCarousel() {
      var _this2 = this;
      this.bindEvents();
      if (this.state.autoPlay && _react.Children.count(this.props.children) > 1) {
        this.setupAutoPlay();
      }
      if (this.props.autoFocus) {
        this.forceFocus();
      }
      this.setState({
        initialized: true
      }, function () {
        var initialImage = _this2.getInitialImage();
        if (initialImage && !initialImage.complete) {
          // if it's a carousel of images, we set the mount state after the first image is loaded
          initialImage.addEventListener('load', _this2.setMountState);
        } else {
          _this2.setMountState();
        }
      });
    }
  }, {
    key: "destroyCarousel",
    value: function destroyCarousel() {
      if (this.state.initialized) {
        this.unbindEvents();
        this.destroyAutoPlay();
      }
    }
  }, {
    key: "setupAutoPlay",
    value: function setupAutoPlay() {
      this.autoPlay();
      var carouselWrapper = this.carouselWrapperRef;
      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.addEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.addEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "destroyAutoPlay",
    value: function destroyAutoPlay() {
      this.clearAutoPlay();
      var carouselWrapper = this.carouselWrapperRef;
      if (this.props.stopOnHover && carouselWrapper) {
        carouselWrapper.removeEventListener('mouseenter', this.stopOnHover);
        carouselWrapper.removeEventListener('mouseleave', this.startOnLeave);
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      // as the widths are calculated, we need to resize
      // the carousel when the window is resized
      (0, _window.default)().addEventListener('resize', this.updateSizes); // issue #2 - image loading smaller

      (0, _window.default)().addEventListener('DOMContentLoaded', this.updateSizes);
      if (this.props.useKeyboardArrows) {
        (0, _document.default)().addEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      // removing listeners
      (0, _window.default)().removeEventListener('resize', this.updateSizes);
      (0, _window.default)().removeEventListener('DOMContentLoaded', this.updateSizes);
      var initialImage = this.getInitialImage();
      if (initialImage) {
        initialImage.removeEventListener('load', this.setMountState);
      }
      if (this.props.useKeyboardArrows) {
        (0, _document.default)().removeEventListener('keydown', this.navigateWithKeyboard);
      }
    }
  }, {
    key: "forceFocus",
    value: function forceFocus() {
      var _this$carouselWrapper;
      (_this$carouselWrapper = this.carouselWrapperRef) === null || _this$carouselWrapper === void 0 ? void 0 : _this$carouselWrapper.focus();
    }
  }, {
    key: "renderItems",
    value: function renderItems(isClone) {
      var _this3 = this;
      if (!this.props.children) {
        return [];
      }
      return _react.Children.map(this.props.children, function (item, index) {
        var isSelected = index === _this3.state.selectedItem;
        var isPrevious = index === _this3.state.previousItem;
        var style = isSelected && _this3.state.selectedStyle || isPrevious && _this3.state.prevStyle || _this3.state.slideStyle || {};
        if (_this3.props.centerMode && _this3.props.axis === 'horizontal') {
          style = _objectSpread(_objectSpread({}, style), {}, {
            minWidth: _this3.props.centerSlidePercentage + '%'
          });
        }
        if (_this3.state.swiping && _this3.state.swipeMovementStarted) {
          style = _objectSpread(_objectSpread({}, style), {}, {
            pointerEvents: 'none'
          });
        }
        var slideProps = {
          ref: function ref(e) {
            return _this3.setItemsRef(e, index);
          },
          key: 'itemKey' + index + (isClone ? 'clone' : ''),
          className: _cssClasses.default.ITEM(true, index === _this3.state.selectedItem, index === _this3.state.previousItem),
          onClick: _this3.handleClickItem.bind(_this3, index, item),
          style: style
        };
        return /*#__PURE__*/_react.default.createElement("li", slideProps, _this3.props.renderItem(item, {
          isSelected: index === _this3.state.selectedItem,
          isPrevious: index === _this3.state.previousItem
        }));
      });
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this4 = this;
      var _this$props = this.props,
        showIndicators = _this$props.showIndicators,
        labels = _this$props.labels,
        renderIndicator = _this$props.renderIndicator,
        children = _this$props.children;
      if (!showIndicators) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "control-dots"
      }, _react.Children.map(children, function (_, index) {
        return renderIndicator && renderIndicator(_this4.changeItem(index), index === _this4.state.selectedItem, index, labels.item);
      }));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      if (!this.props.showStatus) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, _react.Children.count(this.props.children)));
    }
  }, {
    key: "renderThumbs",
    value: function renderThumbs() {
      if (!this.props.showThumbs || !this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_Thumbs.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      if (!this.props.children || _react.Children.count(this.props.children) === 0) {
        return null;
      }
      var isSwipeable = this.props.swipeable && _react.Children.count(this.props.children) > 1;
      var isHorizontal = this.props.axis === 'horizontal';
      var canShowArrows = this.props.showArrows && _react.Children.count(this.props.children) > 1; // show left arrow?

      var hasPrev = canShowArrows && (this.state.selectedItem > 0 || this.props.infiniteLoop) || false; // show right arrow

      var hasNext = canShowArrows && (this.state.selectedItem < _react.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || false;
      var itemsClone = this.renderItems(true);
      var firstClone = itemsClone.shift();
      var lastClone = itemsClone.pop();
      var swiperProps = {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      };
      var containerStyles = {};
      if (isHorizontal) {
        swiperProps.onSwipeLeft = this.onSwipeForward;
        swiperProps.onSwipeRight = this.onSwipeBackwards;
        if (this.props.dynamicHeight) {
          var itemHeight = this.getVariableItemHeight(this.state.selectedItem); // swiperProps.style.height = itemHeight || 'auto';

          containerStyles.height = itemHeight || 'auto';
        }
      } else {
        swiperProps.onSwipeUp = this.props.verticalSwipe === 'natural' ? this.onSwipeBackwards : this.onSwipeForward;
        swiperProps.onSwipeDown = this.props.verticalSwipe === 'natural' ? this.onSwipeForward : this.onSwipeBackwards;
        swiperProps.style = _objectSpread(_objectSpread({}, swiperProps.style), {}, {
          height: this.state.itemSize
        });
        containerStyles.height = this.state.itemSize;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: _cssClasses.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : undefined
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.CAROUSEL(true),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, hasPrev, this.props.labels.leftArrow), /*#__PURE__*/_react.default.createElement("div", {
        className: _cssClasses.default.WRAPPER(true, this.props.axis),
        style: containerStyles
      }, isSwipeable ? /*#__PURE__*/_react.default.createElement(_reactEasySwipe.default, _extends$1({
        tagName: "ul",
        innerRef: this.setListRef
      }, swiperProps, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone) : /*#__PURE__*/_react.default.createElement("ul", {
        className: _cssClasses.default.SLIDER(true, this.state.swiping),
        ref: function ref(node) {
          return _this5.setListRef(node);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && lastClone, this.renderItems(), this.props.infiniteLoop && firstClone)), this.props.renderArrowNext(this.onClickNext, hasNext, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]);
  return Carousel;
}(_react.default.Component);
Carousel$1.default = Carousel;
_defineProperty(Carousel, "displayName", 'Carousel');
_defineProperty(Carousel, "defaultProps", {
  ariaLabel: undefined,
  axis: 'horizontal',
  centerSlidePercentage: 80,
  interval: 3000,
  labels: {
    leftArrow: 'previous slide / item',
    rightArrow: 'next slide / item',
    item: 'slide item'
  },
  onClickItem: _utils.noop,
  onClickThumb: _utils.noop,
  onChange: _utils.noop,
  onSwipeStart: function onSwipeStart() {},
  onSwipeEnd: function onSwipeEnd() {},
  onSwipeMove: function onSwipeMove() {
    return false;
  },
  preventMovementUntilSwipeScrollTolerance: false,
  renderArrowPrev: function renderArrowPrev(onClickHandler, hasPrev, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_PREV(!hasPrev),
      onClick: onClickHandler
    });
  },
  renderArrowNext: function renderArrowNext(onClickHandler, hasNext, label) {
    return /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: _cssClasses.default.ARROW_NEXT(!hasNext),
      onClick: onClickHandler
    });
  },
  renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _cssClasses.default.DOT(isSelected),
      onClick: onClickHandler,
      onKeyDown: onClickHandler,
      value: index,
      key: index,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(label, " ").concat(index + 1)
    });
  },
  renderItem: function renderItem(item) {
    return item;
  },
  renderThumbs: function renderThumbs(children) {
    var images = _react.Children.map(children, function (item) {
      var img = item; // if the item is not an image, try to find the first image in the item's children.

      if (item.type !== 'img') {
        img = _react.Children.toArray(item.props.children).find(function (children) {
          return children.type === 'img';
        });
      }
      if (!img) {
        return undefined;
      }
      return img;
    });
    if (images.filter(function (image) {
      return image;
    }).length === 0) {
      console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md");
      return [];
    }
    return images;
  },
  statusFormatter: _utils.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: true,
  showIndicators: true,
  showStatus: true,
  showThumbs: true,
  stopOnHover: true,
  swipeScrollTolerance: 5,
  swipeable: true,
  transitionTime: 350,
  verticalSwipe: 'standard',
  width: '100%',
  animationHandler: 'slide',
  swipeAnimationHandler: _animations.slideSwipeAnimationHandler,
  stopSwipingHandler: _animations.slideStopSwipingHandler
});
var types = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var require$$1 = /*@__PURE__*/getAugmentedNamespace(types);
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "Carousel", {
    enumerable: true,
    get: function get() {
      return _Carousel.default;
    }
  });
  Object.defineProperty(exports, "CarouselProps", {
    enumerable: true,
    get: function get() {
      return _types.CarouselProps;
    }
  });
  Object.defineProperty(exports, "Thumbs", {
    enumerable: true,
    get: function get() {
      return _Thumbs.default;
    }
  });
  var _Carousel = _interopRequireDefault(Carousel$1);
  var _types = require$$1;
  var _Thumbs = _interopRequireDefault(Thumbs$1);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
})(js$1);
var _templateObject$4, _templateObject2$2, _templateObject3$2;
var SliderContainer = styled__default["default"].div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  width: 100%;\n  .carousel .control-arrow,\n  .carousel.carousel-slider .control-arrow {\n    -webkit-transition: all 0.25s ease-in;\n    -moz-transition: all 0.25s ease-in;\n    -ms-transition: all 0.25s ease-in;\n    -o-transition: all 0.25s ease-in;\n    transition: all 0.25s ease-in;\n    opacity: 0.4;\n    filter: alpha(opacity=40);\n    position: absolute;\n    z-index: 2;\n    top: 20px;\n    background: none;\n    border: 0;\n    font-size: 32px;\n    cursor: pointer;\n  }\n  .carousel .control-arrow:focus,\n  .carousel .control-arrow:hover {\n    opacity: 1;\n    filter: alpha(opacity=100);\n  }\n  .carousel .control-arrow:before,\n  .carousel.carousel-slider .control-arrow:before {\n    margin: 0 5px;\n    display: inline-block;\n    border-top: 8px solid transparent;\n    border-bottom: 8px solid transparent;\n    content: '';\n  }\n  .carousel .control-disabled.control-arrow {\n    opacity: 0;\n    filter: alpha(opacity=0);\n    cursor: inherit;\n    display: none;\n  }\n  .carousel .control-prev.control-arrow {\n    left: 0;\n  }\n  .carousel .control-prev.control-arrow:before {\n    border-right: 8px solid #fff;\n  }\n  .carousel .control-next.control-arrow {\n    right: 0;\n  }\n  .carousel .control-next.control-arrow:before {\n    border-left: 8px solid #fff;\n  }\n  .carousel-root {\n    outline: none;\n  }\n  .carousel {\n    position: relative;\n    width: 100%;\n  }\n  .carousel * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n  .carousel img {\n    width: 100%;\n    display: inline-block;\n    pointer-events: none;\n  }\n  .carousel .carousel {\n    position: relative;\n  }\n  .carousel .control-arrow {\n    outline: 0;\n    border: 0;\n    background: none;\n    top: 50%;\n    margin-top: -13px;\n    font-size: 18px;\n  }\n  .carousel .thumbs-wrapper {\n    margin: 20px;\n    overflow: hidden;\n  }\n  .carousel .thumbs {\n    -webkit-transition: all 0.15s ease-in;\n    -moz-transition: all 0.15s ease-in;\n    -ms-transition: all 0.15s ease-in;\n    -o-transition: all 0.15s ease-in;\n    transition: all 0.15s ease-in;\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n    position: relative;\n    list-style: none;\n    white-space: nowrap;\n  }\n  .carousel .thumb {\n    -webkit-transition: border 0.15s ease-in;\n    -moz-transition: border 0.15s ease-in;\n    -ms-transition: border 0.15s ease-in;\n    -o-transition: border 0.15s ease-in;\n    transition: border 0.15s ease-in;\n    display: inline-block;\n    margin-right: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    border: 3px solid #fff;\n    padding: 2px;\n  }\n  .carousel .thumb:focus {\n    border: 3px solid #ccc;\n    outline: none;\n  }\n  .carousel .thumb.selected,\n  .carousel .thumb:hover {\n    border: 3px solid #333;\n  }\n  .carousel .thumb img {\n    vertical-align: top;\n  }\n  .carousel.carousel-slider {\n    position: relative;\n    margin: 0;\n    overflow: hidden;\n  }\n  .carousel.carousel-slider .control-arrow {\n    top: 0;\n    color: #fff;\n    font-size: 26px;\n    bottom: 0;\n    margin-top: 0;\n    padding: 5px;\n  }\n  .carousel.carousel-slider .control-arrow:hover {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .carousel .slider-wrapper {\n    overflow: hidden;\n    margin: auto;\n    width: 100%;\n    -webkit-transition: height 0.15s ease-in;\n    -moz-transition: height 0.15s ease-in;\n    -ms-transition: height 0.15s ease-in;\n    -o-transition: height 0.15s ease-in;\n    transition: height 0.15s ease-in;\n  }\n  .carousel .slider-wrapper.axis-horizontal .slider {\n    -ms-box-orient: horizontal;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -moz-flex;\n    display: -webkit-flex;\n    display: flex;\n  }\n  .carousel .slider-wrapper.axis-horizontal .slider .slide {\n    flex-direction: column;\n    flex-flow: column;\n  }\n  .carousel .slider-wrapper.axis-vertical {\n    -ms-box-orient: horizontal;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -moz-flex;\n    display: -webkit-flex;\n    display: flex;\n  }\n  .carousel .slider-wrapper.axis-vertical .slider {\n    -webkit-flex-direction: column;\n    flex-direction: column;\n  }\n  .carousel .slider {\n    margin: 0;\n    padding: 0;\n    position: relative;\n    list-style: none;\n    width: 100%;\n  }\n  .carousel .slider.animated {\n    -webkit-transition: all 0.35s ease-in-out;\n    -moz-transition: all 0.35s ease-in-out;\n    -ms-transition: all 0.35s ease-in-out;\n    -o-transition: all 0.35s ease-in-out;\n    transition: all 0.35s ease-in-out;\n  }\n  .carousel .slide {\n    min-width: 100%;\n    margin: 0;\n    position: relative;\n    text-align: center;\n  }\n  .carousel .slide img {\n    width: 100%;\n    vertical-align: top;\n    border: 0;\n  }\n  .carousel .slide iframe {\n    display: inline-block;\n    width: calc(100% - 80px);\n    margin: 0 40px 40px;\n    border: 0;\n  }\n  .carousel .slide .legend {\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -ms-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    transition: all 0.5s ease-in-out;\n    position: absolute;\n    bottom: 40px;\n    left: 50%;\n    margin-left: -45%;\n    width: 90%;\n    border-radius: 10px;\n    background: #000;\n    color: #fff;\n    padding: 10px;\n    font-size: 12px;\n    text-align: center;\n    opacity: 0.25;\n    -webkit-transition: opacity 0.35s ease-in-out;\n    -moz-transition: opacity 0.35s ease-in-out;\n    -ms-transition: opacity 0.35s ease-in-out;\n    -o-transition: opacity 0.35s ease-in-out;\n    transition: opacity 0.35s ease-in-out;\n  }\n  .carousel .control-dots {\n    position: absolute;\n    bottom: 0;\n    margin: 10px 0;\n    padding: 0;\n    text-align: center;\n    width: 100%;\n    z-index: 1;\n  }\n  @media (min-width: 960px) {\n    .carousel .control-dots {\n      bottom: 0;\n    }\n  }\n  .carousel .control-dots .dot {\n    -webkit-transition: opacity 0.25s ease-in;\n    -moz-transition: opacity 0.25s ease-in;\n    -ms-transition: opacity 0.25s ease-in;\n    -o-transition: opacity 0.25s ease-in;\n    transition: opacity 0.25s ease-in;\n    opacity: 0.3;\n    filter: alpha(opacity=30);\n    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n    background: #fff;\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 8px;\n  }\n  .carousel .control-dots .dot.selected,\n  .carousel .control-dots .dot:hover {\n    opacity: 1;\n    filter: alpha(opacity=100);\n  }\n  .carousel .carousel-status {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 5px;\n    font-size: 10px;\n    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n    color: #fff;\n  }\n  .carousel:hover .slide .legend {\n    opacity: 1;\n  }\n  ul li {\n    padding: 0 !important;\n  }\n  div img {\n    object-fit: cover;\n  }\n  .carousel .thumbs-wrapper {\n    margin: 16px;\n  }\n  max-width: 100%;\n  width: 100%;\n  .carousel .thumbs {\n    padding: 0;\n  }\n"])));
styled__default["default"].section(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  position: relative;\n  &.full {\n    position: fixed;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    left: 0;\n    top: 0;\n    z-index: 9999;\n    max-height: 100vh;\n    overflow: hidden;\n    background: #fff;\n  }\n  .fullscreen-button {\n    cursor: ne-resize;\n    position: absolute;\n    left: 16px;\n    top: 16px;\n  }\n"])));
var NewGallery = styled__default["default"].div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  .image-gallery-icon {\n    color: #fff;\n    transition: all 0.3s ease-out;\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    cursor: pointer;\n    outline: none;\n    position: absolute;\n    z-index: 4;\n    filter: drop-shadow(0 2px 2px #1a1a1a);\n  }\n  @media (hover: hover) and (pointer: fine) {\n    .image-gallery-icon:hover {\n      color: #337ab7;\n    }\n    .image-gallery-icon:hover .image-gallery-svg {\n      transform: scale(1.1);\n    }\n  }\n  .image-gallery-icon:focus {\n    outline: 2px solid #337ab7;\n  }\n  .image-gallery-using-mouse .image-gallery-icon:focus {\n    outline: none;\n  }\n  .image-gallery-fullscreen-button,\n  .image-gallery-play-button {\n    bottom: 0;\n    padding: 20px;\n  }\n  .image-gallery-fullscreen-button .image-gallery-svg,\n  .image-gallery-play-button .image-gallery-svg {\n    height: 28px;\n    width: 28px;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-fullscreen-button,\n    .image-gallery-play-button {\n      padding: 15px;\n    }\n    .image-gallery-fullscreen-button .image-gallery-svg,\n    .image-gallery-play-button .image-gallery-svg {\n      height: 24px;\n      width: 24px;\n    }\n  }\n  @media (max-width: 480px) {\n    .image-gallery-fullscreen-button,\n    .image-gallery-play-button {\n      padding: 10px;\n    }\n    .image-gallery-fullscreen-button .image-gallery-svg,\n    .image-gallery-play-button .image-gallery-svg {\n      height: 16px;\n      width: 16px;\n    }\n  }\n  .image-gallery-fullscreen-button {\n    right: 0;\n  }\n  .image-gallery-play-button {\n    left: 0;\n  }\n  .image-gallery-left-nav,\n  .image-gallery-right-nav {\n    padding: 50px 10px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  .image-gallery-left-nav .image-gallery-svg,\n  .image-gallery-right-nav .image-gallery-svg {\n    height: 120px;\n    width: 60px;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-left-nav .image-gallery-svg,\n    .image-gallery-right-nav .image-gallery-svg {\n      height: 72px;\n      width: 36px;\n    }\n  }\n  @media (max-width: 480px) {\n    .image-gallery-left-nav .image-gallery-svg,\n    .image-gallery-right-nav .image-gallery-svg {\n      height: 48px;\n      width: 24px;\n    }\n  }\n  .image-gallery-left-nav[disabled],\n  .image-gallery-right-nav[disabled] {\n    cursor: disabled;\n    opacity: 0.6;\n    pointer-events: none;\n  }\n  .image-gallery-left-nav {\n    left: 0;\n  }\n  .image-gallery-right-nav {\n    right: 0;\n  }\n  .image-gallery {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    position: relative;\n  }\n  .image-gallery.fullscreen-modal {\n    background: #000;\n    bottom: 0;\n    height: 100%;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 100%;\n    z-index: 5;\n  }\n  .image-gallery.fullscreen-modal .image-gallery-content {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  .image-gallery-content {\n    position: relative;\n    line-height: 0;\n    top: 0;\n  }\n  .image-gallery-content.fullscreen {\n    background: #000;\n  }\n  .image-gallery-content .image-gallery-slide .image-gallery-image {\n    max-height: calc(100vh - 80px);\n  }\n  .image-gallery-content.image-gallery-thumbnails-left\n    .image-gallery-slide\n    .image-gallery-image,\n  .image-gallery-content.image-gallery-thumbnails-right\n    .image-gallery-slide\n    .image-gallery-image {\n    max-height: 100vh;\n  }\n  .image-gallery-slide-wrapper {\n    position: relative;\n  }\n  .image-gallery-slide-wrapper.image-gallery-thumbnails-left,\n  .image-gallery-slide-wrapper.image-gallery-thumbnails-right {\n    display: inline-block;\n    width: calc(100% - 110px);\n  }\n  @media (max-width: 768px) {\n    .image-gallery-slide-wrapper.image-gallery-thumbnails-left,\n    .image-gallery-slide-wrapper.image-gallery-thumbnails-right {\n      width: calc(100% - 87px);\n    }\n  }\n  .image-gallery-slide-wrapper.image-gallery-rtl {\n    direction: rtl;\n  }\n  .image-gallery-slides {\n    line-height: 0;\n    overflow: hidden;\n    position: relative;\n    white-space: nowrap;\n    text-align: center;\n  }\n  .image-gallery-slide {\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n  .image-gallery-slide.image-gallery-center {\n    position: relative;\n  }\n  .image-gallery-slide .image-gallery-image {\n    width: 100%;\n    object-fit: contain;\n  }\n  .image-gallery-slide .image-gallery-description {\n    background: rgba(0, 0, 0, 0.4);\n    bottom: 70px;\n    color: #fff;\n    left: 0;\n    line-height: 1;\n    padding: 10px 20px;\n    position: absolute;\n    white-space: normal;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-slide .image-gallery-description {\n      bottom: 45px;\n      font-size: 0.8em;\n      padding: 8px 15px;\n    }\n  }\n  .image-gallery-bullets {\n    bottom: 20px;\n    left: 0;\n    margin: 0 auto;\n    position: absolute;\n    right: 0;\n    width: 80%;\n    z-index: 4;\n  }\n  .image-gallery-bullets .image-gallery-bullets-container {\n    margin: 0;\n    padding: 0;\n    text-align: center;\n  }\n  .image-gallery-bullets .image-gallery-bullet {\n    appearance: none;\n    background-color: transparent;\n    border: 1px solid #fff;\n    border-radius: 50%;\n    box-shadow: 0 2px 2px #1a1a1a;\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 5px;\n    outline: none;\n    padding: 5px;\n    transition: all 0.2s ease-out;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-bullets .image-gallery-bullet {\n      margin: 0 3px;\n      padding: 3px;\n    }\n  }\n  @media (max-width: 480px) {\n    .image-gallery-bullets .image-gallery-bullet {\n      padding: 2.7px;\n    }\n  }\n  .image-gallery-bullets .image-gallery-bullet:focus {\n    transform: scale(1.2);\n    background: #337ab7;\n    border: 1px solid #337ab7;\n  }\n  .image-gallery-bullets .image-gallery-bullet.active {\n    transform: scale(1.2);\n    border: 1px solid #fff;\n    background: #fff;\n  }\n  @media (hover: hover) and (pointer: fine) {\n    .image-gallery-bullets .image-gallery-bullet:hover {\n      background: #337ab7;\n      border: 1px solid #337ab7;\n    }\n    .image-gallery-bullets .image-gallery-bullet.active:hover {\n      background: #337ab7;\n    }\n  }\n  .image-gallery-thumbnails-wrapper {\n    position: relative;\n  }\n  .image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {\n    touch-action: pan-y;\n  }\n  .image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {\n    touch-action: pan-x;\n  }\n  .image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {\n    direction: rtl;\n  }\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {\n    display: inline-block;\n    vertical-align: top;\n    width: 100px;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,\n    .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {\n      width: 81px;\n    }\n  }\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left\n    .image-gallery-thumbnails,\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right\n    .image-gallery-thumbnails {\n    height: 100%;\n    width: 100%;\n    left: 0;\n    padding: 0;\n    position: absolute;\n    top: 0;\n  }\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left\n    .image-gallery-thumbnails\n    .image-gallery-thumbnail,\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right\n    .image-gallery-thumbnails\n    .image-gallery-thumbnail {\n    display: block;\n    margin-right: 0;\n    padding: 0;\n  }\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left\n    .image-gallery-thumbnails\n    .image-gallery-thumbnail\n    + .image-gallery-thumbnail,\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right\n    .image-gallery-thumbnails\n    .image-gallery-thumbnail\n    + .image-gallery-thumbnail {\n    margin-left: 0;\n    margin-top: 2px;\n  }\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,\n  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {\n    margin: 0 5px;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,\n    .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {\n      margin: 0 3px;\n    }\n  }\n  .image-gallery-thumbnails {\n    overflow: hidden;\n    padding: 5px 0;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnails {\n      padding: 3px 0;\n    }\n  }\n  .image-gallery-thumbnails .image-gallery-thumbnails-container {\n    cursor: pointer;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .image-gallery-thumbnail {\n    display: inline-block;\n    border: 4px solid transparent;\n    transition: border 0.3s ease-out;\n    width: 100px;\n    background: transparent;\n    padding: 0;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnail {\n      border: 3px solid transparent;\n      width: 81px;\n    }\n  }\n  .image-gallery-thumbnail + .image-gallery-thumbnail {\n    margin-left: 2px;\n  }\n  .image-gallery-thumbnail .image-gallery-thumbnail-inner {\n    display: block;\n    position: relative;\n  }\n  .image-gallery-thumbnail .image-gallery-thumbnail-image {\n    vertical-align: middle;\n    width: 100%;\n    line-height: 0;\n  }\n  .image-gallery-thumbnail.active,\n  .image-gallery-thumbnail:focus {\n    outline: none;\n    border: 4px solid #337ab7;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnail.active,\n    .image-gallery-thumbnail:focus {\n      border: 3px solid #337ab7;\n    }\n  }\n  @media (hover: hover) and (pointer: fine) {\n    .image-gallery-thumbnail:hover {\n      outline: none;\n      border: 4px solid #337ab7;\n    }\n  }\n  @media (hover: hover) and (pointer: fine) and (max-width: 768px) {\n    .image-gallery-thumbnail:hover {\n      border: 3px solid #337ab7;\n    }\n  }\n  .image-gallery-thumbnail-label {\n    box-sizing: border-box;\n    color: #fff;\n    font-size: 1em;\n    left: 0;\n    line-height: 1em;\n    padding: 5%;\n    position: absolute;\n    top: 50%;\n    text-shadow: 0 2px 2px #1a1a1a;\n    transform: translateY(-50%);\n    white-space: normal;\n    width: 100%;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-thumbnail-label {\n      font-size: 0.8em;\n      line-height: 0.8em;\n    }\n  }\n  .image-gallery-index {\n    background: rgba(0, 0, 0, 0.4);\n    color: #fff;\n    line-height: 1;\n    padding: 10px 20px;\n    position: absolute;\n    right: 0;\n    top: 0;\n    z-index: 4;\n  }\n  @media (max-width: 768px) {\n    .image-gallery-index {\n      font-size: 0.8em;\n      padding: 5px 10px;\n    }\n  }\n"])));
function CustomSlider(_ref) {
  var options = _ref.options;
  options.content;
  return /*#__PURE__*/React__default["default"].createElement(SliderContainer, null, /*#__PURE__*/React__default["default"].createElement(js$1.Carousel, {
    showThumbs: false,
    swipeable: true,
    showStatus: true,
    dynamicHeight: false,
    showArrows: true,
    width: "100%",
    infiniteLoop: true,
    emulateTouch: true,
    interval: 2000
    // showIndicators={content.length > 1 ? true : false}
  }, options.content.map(function (slide, index) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: index,
      dangerouslySetInnerHTML: {
        __html: slide.content
      }
    });
  })));
}
function Embed(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React__default["default"].createElement("embed", {
    src: 'https://cms.burobork.nl/images/' + options.content[0].reference,
    width: options.embedWidth,
    height: options.embedHeight,
    type: options.embedType
  });
}
var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  Object.keys(source).forEach(function (key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    } else {
      destination[key] = deepmerge(target[key], source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }
  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
  objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
var isArray$2 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';
function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$2(a),
      arrB = isArray$2(b),
      i,
      length,
      key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
      dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) return false;
    for (i = length; i-- !== 0;) if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element) return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }
  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};
var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== 'undefined') {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {}
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$2 = getNative(root$1, 'Map');
var Map$3 = Map$2;

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$3 || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$3 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$1(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray$1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$4 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$4 = '[object Set]',
  stringTag$2 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;
    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();
var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
    isArg = !isArr && isArguments$1(value),
    isBuff = !isArr && !isArg && isBuffer$1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$1.Buffer : undefined,
  allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
    result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};
var getSymbolsIn$1 = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$1, 'DataView');
var DataView$1 = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$3 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
  mapCtorString = toSource(Map$3),
  promiseCtorString = toSource(Promise$2),
  setCtorString = toSource(Set$2),
  weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$3 && getTag(new Map$3()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag$2 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag$1 = '[object Symbol]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$2;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$1);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length,
    result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
      key = resolver ? resolver.apply(this, args) : args[0],
      cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
  symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString(value)));
}
var reactIs$1 = {
  exports: {}
};
var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d$1 = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f$1 = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k$2 = b ? Symbol.for("react.context") : 60110,
  l$1 = b ? Symbol.for("react.async_mode") : 60111,
  m$1 = b ? Symbol.for("react.concurrent_mode") : 60111,
  n$1 = b ? Symbol.for("react.forward_ref") : 60112,
  p$1 = b ? Symbol.for("react.suspense") : 60113,
  q$2 = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l$1:
          case m$1:
          case e:
          case g:
          case f$1:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k$2:
              case n$1:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d$1:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m$1;
}
reactIs_production_min.AsyncMode = l$1;
reactIs_production_min.ConcurrentMode = m$1;
reactIs_production_min.ContextConsumer = k$2;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n$1;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d$1;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f$1;
reactIs_production_min.Suspense = p$1;
reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l$1;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k$2;
};
reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n$1;
};
reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function (a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function (a) {
  return z(a) === d$1;
};
reactIs_production_min.isProfiler = function (a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f$1;
};
reactIs_production_min.isSuspense = function (a) {
  return z(a) === p$1;
};
reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m$1 || a === g || a === f$1 || a === p$1 || a === q$2 || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k$2 || a.$$typeof === n$1 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function () {
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development.AsyncMode = AsyncMode;
    reactIs_development.ConcurrentMode = ConcurrentMode;
    reactIs_development.ContextConsumer = ContextConsumer;
    reactIs_development.ContextProvider = ContextProvider;
    reactIs_development.Element = Element;
    reactIs_development.ForwardRef = ForwardRef;
    reactIs_development.Fragment = Fragment;
    reactIs_development.Lazy = Lazy;
    reactIs_development.Memo = Memo;
    reactIs_development.Portal = Portal;
    reactIs_development.Profiler = Profiler;
    reactIs_development.StrictMode = StrictMode;
    reactIs_development.Suspense = Suspense;
    reactIs_development.isAsyncMode = isAsyncMode;
    reactIs_development.isConcurrentMode = isConcurrentMode;
    reactIs_development.isContextConsumer = isContextConsumer;
    reactIs_development.isContextProvider = isContextProvider;
    reactIs_development.isElement = isElement;
    reactIs_development.isForwardRef = isForwardRef;
    reactIs_development.isFragment = isFragment;
    reactIs_development.isLazy = isLazy;
    reactIs_development.isMemo = isMemo;
    reactIs_development.isPortal = isPortal;
    reactIs_development.isProfiler = isProfiler;
    reactIs_development.isStrictMode = isStrictMode;
    reactIs_development.isSuspense = isSuspense;
    reactIs_development.isValidElementType = isValidElementType;
    reactIs_development.typeOf = typeOf;
  })();
}
if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var FormikContext = /*#__PURE__*/React.createContext(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = React.useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return React.Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }
  var path = toPath(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  } // check if path is not in the end

  if (p !== path.length && !obj) {
    return def;
  }
  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));
    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current

  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }
  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.

  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }
  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];
    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }
  return response;
}
function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });
    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });
    case 'SET_ERRORS':
      if (reactFastCompare(state.errors, msg.payload)) {
        return state;
      }
      return _extends({}, state, {
        errors: msg.payload
      });
    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });
    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });
    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });
    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });
    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });
    case 'RESET_FORM':
      return _extends({}, state, msg.payload);
    case 'SET_FORMIK_STATE':
      return msg.payload(state);
    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });
    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });
    default:
      return state;
  }
} // Initial empty states // objects

var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
    validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
    _ref$validateOnBlur = _ref.validateOnBlur,
    validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
    _ref$validateOnMount = _ref.validateOnMount,
    validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
    isInitialValid = _ref.isInitialValid,
    _ref$enableReinitiali = _ref.enableReinitialize,
    enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
    onSubmit = _ref.onSubmit,
    rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);
  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);
  var initialValues = React.useRef(props.initialValues);
  var initialErrors = React.useRef(props.initialErrors || emptyErrors);
  var initialTouched = React.useRef(props.initialTouched || emptyTouched);
  var initialStatus = React.useRef(props.initialStatus);
  var isMounted = React.useRef(false);
  var fieldRegistry = React.useRef({});
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }
  React.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var _React$useState = React.useState(0),
    setIteration = _React$useState[1];
  var stateRef = React.useRef({
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  });
  var state = stateRef.current;
  var dispatch = React.useCallback(function (action) {
    var prev = stateRef.current;
    stateRef.current = formikReducer(prev, action); // force rerender

    if (prev !== stateRef.current) setIteration(function (x) {
      return x + 1;
    });
  }, []);
  var runValidateHandler = React.useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);
      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }
          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = React.useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }
          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = React.useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = React.useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }
        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }
        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = React.useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
        schemaErrors = _ref2[1],
        validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }
    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }
      return combinedErrors;
    });
  });
  React.useEffect(function () {
    if (validateOnMount && isMounted.current === true && reactFastCompare(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = React.useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;
    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };
    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  React.useEffect(function () {
    if (isMounted.current === true && !reactFastCompare(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
        if (validateOnMount) {
          validateFormWithHighPriority(initialValues.current);
        }
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  React.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !reactFastCompare(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);
      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: getIn(error, name)
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }
    return Promise.resolve();
  });
  var registerField = React.useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = React.useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = React.useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = React.useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = React.useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }
      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
        name = target.name,
        id = target.id,
        value = target.value,
        checked = target.checked,
        outerHTML = target.outerHTML,
        options = target.options,
        multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;
      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }
      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }
    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }
    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = React.useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }
    var _e$target = e.target,
      name = _e$target.name,
      id = _e$target.id,
      outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;
    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }
    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = React.useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = React.useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = React.useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;
        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }
        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }
          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }
      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.

    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();
      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }
    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }
    resetForm();
  });
  var getFieldMeta = React.useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = React.useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = React.useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };
    if (isAnObject) {
      var type = nameOrOptions.type,
        valueProp = nameOrOptions.value,
        is = nameOrOptions.as,
        multiple = nameOrOptions.multiple;
      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }
    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = React.useMemo(function () {
    return !reactFastCompare(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = React.useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);
  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });
  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
    children = props.children,
    render = props.render,
    innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  React.useImperativeHandle(innerRef, function () {
    return formikbag;
  });
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }
  return React.createElement(FormikProvider, {
    value: formikbag
  }, component ? React.createElement(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? React.Children.only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
    documentationAnchorLink = _ref4.documentationAnchorLink,
    handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */

function yupToFormErrors(yupError) {
  var errors = {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }
    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;
      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }
      var err = _ref5;
      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }
  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }
  var normalizedValues = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};
  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);
      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }
  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */

function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */

function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array

  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;
  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values

  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values

  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array

  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? React.useLayoutEffect : React.useEffect;
function useEventCallback(fn) {
  var ref = React.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}
var Form$1 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
    rest = _objectWithoutPropertiesLoose(props, ["action"]);
  var _action = action != null ? action : '#';
  var _useFormikContext = useFormikContext(),
    handleReset = _useFormikContext.handleReset,
    handleSubmit = _useFormikContext.handleSubmit;
  return React.createElement("form", _extends({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form$1.displayName = 'Form';

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
  var fn = typeof alteration === 'function' ? alteration : defaultFunction;
  return function (data) {
    if (Array.isArray(data) || isObject(data)) {
      var clone = copyArrayLike(data);
      return fn(clone);
    } // This can be assumed to be a primitive, which
    // is a case for top level validation errors

    return data;
  };
};
var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);
  function FieldArrayInner(props) {
    var _this;
    _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
        name = _this$props.name,
        setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = createAlterationHandler(alterErrors, fn);
        var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }
        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }
        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };
    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [cloneDeep(value)]);
      }, false, false);
    };
    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };
    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };
    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };
    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };
    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };
    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };
    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };
    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };
    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };
    _this.unshift = function (value) {
      var length = -1;
      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];
        length = arr.length;
        return arr;
      }, function (array) {
        return array ? [null].concat(array) : [null];
      }, function (array) {
        return array ? [null].concat(array) : [null];
      });
      return length;
    };
    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };
    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };
    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };
    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = FieldArrayInner.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !reactFastCompare(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };
  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField(
    // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];
      if (!result) {
        result = copy[index];
      }
      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      } // if the array only includes undefined values we have to return an empty array

      return isFunction(copy.every) ? copy.every(function (v) {
        return v === undefined;
      }) ? [] : copy : copy;
    }, true, true);
    return result;
  };
  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField(
    // so this gets call 3 times
    function (array) {
      var tmp = array.slice();
      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }
      return tmp;
    }, true, true);
    return result;
  };
  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };
    var _this$props2 = this.props,
      component = _this$props2.component,
      render = _this$props2.render,
      children = _this$props2.children,
      name = _this$props2.name,
      _this$props2$formik = _this$props2.formik,
      restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);
    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });
    return component ? React.createElement(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? React.Children.only(children) : null : null;
  };
  return FieldArrayInner;
}(React.Component);
FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var _templateObject$3;
styled__default["default"].button(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  display: block;\n  padding: 12px 24px !important;\n  border-radius: 12px;\n  color: #fff !important;\n  color: ", ";\n  border: 2px solid\n    ", ";\n  font-weight: bold;\n  text-decoration: none;\n  box-shadow: -2px 2px 4px rgba(0, 0, 0, 0.25);\n  transition: all 0.5s ease;\n  width: fit-content;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n  cursor: pointer;\n  &:before {\n    background-color: ", " !important;\n    width: 100% !important;\n    position: absolute;\n    right: 0;\n    top: 0;\n    content: '';\n    height: 100% !important;\n    z-index: -1;\n    transition: all 0.5s ease;\n  }\n  &:hover {\n    border: 2px solid\n      ", ";\n    box-shadow: -1px 1px 4px rgba(0, 0, 0, 0.25);\n    color: ", " !important;\n    &:before {\n      width: 1px !important;\n      right: -1px;\n    }\n  }\n"])), function (props) {
  return props.purple ? '#642C8F' : '#000';
}, function (props) {
  return props.theme.primaryColor ? props.theme.primaryColor : '#642C8F';
}, function (props) {
  return props.theme.primaryColor ? props.theme.primaryColor : props.theme.primaryColor;
}, function (props) {
  return props.purple ? '#642C8F' : props.theme.primaryColor;
}, function (props) {
  return props.theme.primaryColor;
});
var _templateObject$2;
var Form = function Form(_ref) {
  var options = _ref.options;
  var form = options.content;
  return /*#__PURE__*/React__default["default"].createElement(Formik, {
    initialValues: {},
    onSubmit: function onSubmit(values, actions) {
      setTimeout(function () {
        fetch("https://cms.burobork.nl/recieve/form/".concat(form.id), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            form: {
              locale: 'nl',
              content: values
            }
          })
        }).then(function (resp) {
          if (resp.ok === true) {
            alert('Form has been sent!');
            actions.resetForm({
              values: {}
            });
          } else {
            alert('Please try again later.');
          }
        });
        actions.setSubmitting(false);
      }, 1000);
    },
    render: function render(_ref2) {
      var values = _ref2.values,
        errors = _ref2.errors,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/React__default["default"].createElement(FormContainer, null, /*#__PURE__*/React__default["default"].createElement("form", {
        onSubmit: handleSubmit
      }, form.options.fields.map(function (field) {
        if (field.type === 'select') {
          return /*#__PURE__*/React__default["default"].createElement("div", {
            key: field.model
          }, /*#__PURE__*/React__default["default"].createElement("label", {
            htmlFor: field.model
          }, field.label), /*#__PURE__*/React__default["default"].createElement("select", {
            id: field.model,
            onChange: handleChange,
            onBlur: handleBlur,
            value: values[field.model],
            name: field.model
          }, field.values.map(function (opt) {
            return /*#__PURE__*/React__default["default"].createElement("option", {
              key: opt.option_value,
              value: opt.option_value
            }, opt.label);
          })));
        } else if (field.type === 'textarea') {
          return /*#__PURE__*/React__default["default"].createElement("div", {
            key: field.model
          }, /*#__PURE__*/React__default["default"].createElement("label", {
            htmlFor: field.model
          }, field.label), /*#__PURE__*/React__default["default"].createElement("textarea", {
            id: field.model,
            onChange: handleChange,
            onBlur: handleBlur,
            value: values[field.model],
            name: field.model,
            rows: "5"
          }));
        } else {
          return /*#__PURE__*/React__default["default"].createElement("div", {
            key: field.model
          }, /*#__PURE__*/React__default["default"].createElement("label", {
            htmlFor: field.model
          }, field.label, /*#__PURE__*/React__default["default"].createElement("input", {
            id: field.model,
            type: "text",
            onChange: handleChange,
            onBlur: handleBlur,
            value: values[field.model],
            name: field.model,
            required: field.required
          })), errors[field.name] && /*#__PURE__*/React__default["default"].createElement("div", {
            id: "feedback"
          }, errors[field.name]));
        }
      }), /*#__PURE__*/React__default["default"].createElement("button", {
        type: "submit"
      }, "Verzenden")));
    }
  });
};
Form.propTypes = {
  options: PropTypes.object.isRequired
};
var FormContainer = styled__default["default"].div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 100%;\n  select {\n    appearance: none;\n    background: #fff;\n    background-image: linear-gradient(45deg, transparent 50%, gray 50%),\n      linear-gradient(135deg, gray 50%, transparent 50%),\n      linear-gradient(to right, #ccc, #ccc);\n    background-position: calc(100% - 20px) calc(1em),\n      calc(100% - 15px) calc(1em), calc(100% - 2.5em);\n    background-size: 5px 5px, 5px 5px, 1px 1.5em;\n    background-repeat: no-repeat;\n  }\n\n  label {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    width: 100%;\n    margin: 8px 0;\n  }\n  input,\n  select,\n  textarea {\n    display: block;\n    box-sizing: border-box;\n    margin: 8px 0;\n    padding: 8px;\n    width: 100%;\n    appearance: none;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n  }  \n"])));
function Image(_ref) {
  var _options$style, _options$style2;
  var options = _ref.options;
  return /*#__PURE__*/React__default["default"].createElement("img", {
    style: {
      objectFit: 'contain',
      width: (_options$style = options.style) === null || _options$style === void 0 ? void 0 : _options$style.width,
      height: (_options$style2 = options.style) === null || _options$style2 === void 0 ? void 0 : _options$style2.height
    },
    src: options.content[0] ? 'https://cms.burobork.nl/images/' + options.content[0].reference : null,
    alt: options.content[0] ? options.content[0].title : null
  });
}
var imageGallery = {
  exports: {}
};
(function (module, exports) {
  !function (e, t) {
    module.exports = t(React__default["default"]);
  }(commonjsGlobal$1, function (e) {
    return function () {
      var t = {
          703: function _(e, t, n) {
            var i = n(414);
            function r() {}
            function a() {}
            a.resetWarningCache = r, e.exports = function () {
              function e(e, t, n, r, a, s) {
                if (s !== i) {
                  var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                  throw o.name = "Invariant Violation", o;
                }
              }
              function t() {
                return e;
              }
              e.isRequired = e;
              var n = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: a,
                resetWarningCache: r
              };
              return n.PropTypes = n, n;
            };
          },
          697: function _(e, t, n) {
            e.exports = n(703)();
          },
          414: function _(e) {
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
          },
          590: function _(e) {
            var t = "undefined" != typeof Element,
              n = "function" == typeof Map,
              i = "function" == typeof Set,
              r = "function" == typeof ArrayBuffer && !!ArrayBuffer.isView;
            function a(e, s) {
              if (e === s) return !0;
              if (e && s && "object" == typeof e && "object" == typeof s) {
                if (e.constructor !== s.constructor) return !1;
                var o, l, u, c;
                if (Array.isArray(e)) {
                  if ((o = e.length) != s.length) return !1;
                  for (l = o; 0 != l--;) if (!a(e[l], s[l])) return !1;
                  return !0;
                }
                if (n && e instanceof Map && s instanceof Map) {
                  if (e.size !== s.size) return !1;
                  for (c = e.entries(); !(l = c.next()).done;) if (!s.has(l.value[0])) return !1;
                  for (c = e.entries(); !(l = c.next()).done;) if (!a(l.value[1], s.get(l.value[0]))) return !1;
                  return !0;
                }
                if (i && e instanceof Set && s instanceof Set) {
                  if (e.size !== s.size) return !1;
                  for (c = e.entries(); !(l = c.next()).done;) if (!s.has(l.value[0])) return !1;
                  return !0;
                }
                if (r && ArrayBuffer.isView(e) && ArrayBuffer.isView(s)) {
                  if ((o = e.length) != s.length) return !1;
                  for (l = o; 0 != l--;) if (e[l] !== s[l]) return !1;
                  return !0;
                }
                if (e.constructor === RegExp) return e.source === s.source && e.flags === s.flags;
                if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === s.valueOf();
                if (e.toString !== Object.prototype.toString) return e.toString() === s.toString();
                if ((o = (u = Object.keys(e)).length) !== Object.keys(s).length) return !1;
                for (l = o; 0 != l--;) if (!Object.prototype.hasOwnProperty.call(s, u[l])) return !1;
                if (t && e instanceof Element) return !1;
                for (l = o; 0 != l--;) if (("_owner" !== u[l] && "__v" !== u[l] && "__o" !== u[l] || !e.$$typeof) && !a(e[u[l]], s[u[l]])) return !1;
                return !0;
              }
              return e != e && s != s;
            }
            e.exports = function (e, t) {
              try {
                return a(e, t);
              } catch (e) {
                if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
                throw e;
              }
            };
          },
          37: function _(e, t, n) {
            !function (e, t) {
              function n() {
                return n = Object.assign || function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                  }
                  return e;
                }, n.apply(this, arguments);
              }
              var i = "Left",
                r = "Right",
                a = "Down",
                s = {
                  delta: 10,
                  preventDefaultTouchmoveEvent: !1,
                  rotationAngle: 0,
                  trackMouse: !1,
                  trackTouch: !0
                },
                o = {
                  first: !0,
                  initial: [0, 0],
                  start: 0,
                  swiping: !1,
                  xy: [0, 0]
                },
                l = "mousemove",
                u = "mouseup";
              function c(e, t) {
                if (0 === t) return e;
                var n = Math.PI / 180 * t;
                return [e[0] * Math.cos(n) + e[1] * Math.sin(n), e[1] * Math.cos(n) - e[0] * Math.sin(n)];
              }
              function h(e, t) {
                var s = function s(t) {
                    t && "touches" in t && t.touches.length > 1 || e(function (e, i) {
                      i.trackMouse && (document.addEventListener(l, h), document.addEventListener(u, f));
                      var r = "touches" in t ? t.touches[0] : t,
                        a = c([r.clientX, r.clientY], i.rotationAngle);
                      return n({}, e, o, {
                        initial: [].concat(a),
                        xy: a,
                        start: t.timeStamp || 0
                      });
                    });
                  },
                  h = function h(t) {
                    e(function (e, s) {
                      if ("touches" in t && t.touches.length > 1) return e;
                      var o = "touches" in t ? t.touches[0] : t,
                        l = c([o.clientX, o.clientY], s.rotationAngle),
                        u = l[0],
                        h = l[1],
                        d = u - e.xy[0],
                        f = h - e.xy[1],
                        p = Math.abs(d),
                        m = Math.abs(f),
                        g = (t.timeStamp || 0) - e.start,
                        v = Math.sqrt(p * p + m * m) / (g || 1),
                        b = [d / (g || 1), f / (g || 1)];
                      if (p < s.delta && m < s.delta && !e.swiping) return e;
                      var y = function (e, t, n, s) {
                          return e > t ? n > 0 ? r : i : s > 0 ? a : "Up";
                        }(p, m, d, f),
                        w = {
                          absX: p,
                          absY: m,
                          deltaX: d,
                          deltaY: f,
                          dir: y,
                          event: t,
                          first: e.first,
                          initial: e.initial,
                          velocity: v,
                          vxvy: b
                        };
                      s.onSwiping && s.onSwiping(w);
                      var T = !1;
                      return (s.onSwiping || s.onSwiped || "onSwiped" + y in s) && (T = !0), T && s.preventDefaultTouchmoveEvent && s.trackTouch && t.cancelable && t.preventDefault(), n({}, e, {
                        first: !1,
                        eventData: w,
                        swiping: !0
                      });
                    });
                  },
                  d = function d(t) {
                    e(function (e, i) {
                      var r;
                      if (e.swiping && e.eventData) {
                        r = n({}, e.eventData, {
                          event: t
                        }), i.onSwiped && i.onSwiped(r);
                        var a = "onSwiped" + r.dir;
                        a in i && i[a](r);
                      } else i.onTap && i.onTap({
                        event: t
                      });
                      return n({}, e, o, {
                        eventData: r
                      });
                    });
                  },
                  f = function f(e) {
                    document.removeEventListener(l, h), document.removeEventListener(u, f), d(e);
                  },
                  p = function p(e, t) {
                    var n = function n() {};
                    if (e && e.addEventListener) {
                      var i = [["touchstart", s], ["touchmove", h], ["touchend", d]];
                      i.forEach(function (n) {
                        var i = n[0],
                          r = n[1];
                        return e.addEventListener(i, r, {
                          passive: t
                        });
                      }), n = function n() {
                        return i.forEach(function (t) {
                          var n = t[0],
                            i = t[1];
                          return e.removeEventListener(n, i);
                        });
                      };
                    }
                    return n;
                  },
                  m = {
                    ref: function ref(t) {
                      null !== t && e(function (e, i) {
                        if (e.el === t) return e;
                        var r = {};
                        return e.el && e.el !== t && e.cleanUpTouch && (e.cleanUpTouch(), r.cleanUpTouch = void 0), i.trackTouch && t && (r.cleanUpTouch = p(t, !i.preventDefaultTouchmoveEvent)), n({}, e, {
                          el: t
                        }, r);
                      });
                    }
                  };
                return t.trackMouse && (m.onMouseDown = s), [m, p];
              }
              e.DOWN = a, e.LEFT = i, e.RIGHT = r, e.UP = "Up", e.useSwipeable = function (e) {
                var i = e.trackMouse,
                  r = t.useRef(n({}, o)),
                  a = t.useRef(n({}, s));
                a.current = n({}, s, e);
                var l = t.useMemo(function () {
                    return h(function (e) {
                      return r.current = e(r.current, a.current);
                    }, {
                      trackMouse: i
                    });
                  }, [i]),
                  u = l[0],
                  c = l[1];
                return r.current = function (e, t, i) {
                  var r = {};
                  return !t.trackTouch && e.cleanUpTouch ? (e.cleanUpTouch(), r.cleanUpTouch = void 0) : t.trackTouch && !e.cleanUpTouch && e.el && (r.cleanUpTouch = i(e.el, !t.preventDefaultTouchmoveEvent)), n({}, e, r);
                }(r.current, a.current, c), u;
              };
            }(t, n(888));
          },
          888: function _(t) {
            t.exports = e;
          }
        },
        n = {};
      function i(e) {
        var r = n[e];
        if (void 0 !== r) return r.exports;
        var a = n[e] = {
          exports: {}
        };
        return t[e].call(a.exports, a, a.exports, i), a.exports;
      }
      i.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return i.d(t, {
          a: t
        }), t;
      }, i.d = function (e, t) {
        for (var n in t) i.o(t, n) && !i.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }, i.g = function () {
        if ("object" == typeof globalThis) return globalThis;
        try {
          return this || new Function("return this")();
        } catch (e) {
          if ("object" == typeof window) return window;
        }
      }(), i.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, i.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
      var r = {};
      return function () {
        function e(t) {
          var n,
            i,
            r = "";
          if ("string" == typeof t || "number" == typeof t) r += t;else if ("object" == typeof t) if (Array.isArray(t)) for (n = 0; n < t.length; n++) t[n] && (i = e(t[n])) && (r && (r += " "), r += i);else for (n in t) t[n] && (r && (r += " "), r += n);
          return r;
        }
        function t() {
          for (var t, n, i = 0, r = ""; i < arguments.length;) (t = arguments[i++]) && (n = e(t)) && (r && (r += " "), r += n);
          return r;
        }
        i.r(r), i.d(r, {
          default: function _default() {
            return Pe;
          }
        });
        var n = i(888),
          a = i.n(n);
        var s = function s(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
          },
          o = "object" == typeof commonjsGlobal$1 && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
        var l = "object" == typeof self && self && self.Object === Object && self;
        var u = o || l || Function("return this")(),
          c = function c() {
            return u.Date.now();
          };
        var h = /\s/;
        var d = /^\s+/;
        var f = function f(e) {
            return e ? e.slice(0, function (e) {
              for (var t = e.length; t-- && h.test(e.charAt(t)););
              return t;
            }(e) + 1).replace(d, "") : e;
          },
          p = u.Symbol;
        var m = Object.prototype,
          g = m.hasOwnProperty,
          v = m.toString,
          b = p ? p.toStringTag : void 0;
        var y = Object.prototype.toString;
        var w = p ? p.toStringTag : void 0;
        var T = function T(e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : w && w in Object(e) ? function (e) {
            var t = g.call(e, b),
              n = e[b];
            try {
              e[b] = void 0;
              var i = !0;
            } catch (e) {}
            var r = v.call(e);
            return i && (t ? e[b] = n : delete e[b]), r;
          }(e) : function (e) {
            return y.call(e);
          }(e);
        };
        var S = /^[-+]0x[0-9a-f]+$/i,
          O = /^0b[01]+$/i,
          E = /^0o[0-7]+$/i,
          k = parseInt;
        var I = function I(e) {
          if ("number" == typeof e) return e;
          if (function (e) {
            return "symbol" == typeof e || function (e) {
              return null != e && "object" == typeof e;
            }(e) && "[object Symbol]" == T(e);
          }(e)) return NaN;
          if (s(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = s(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = f(e);
          var n = O.test(e);
          return n || E.test(e) ? k(e.slice(2), n ? 2 : 8) : S.test(e) ? NaN : +e;
        };
        var x = Math.max,
          _ = Math.min;
        var R = function R(e, t, n) {
            var i,
              r,
              a,
              o,
              l,
              u,
              h = 0,
              d = !1,
              f = !1,
              p = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            function m(t) {
              var n = i,
                a = r;
              return i = r = void 0, h = t, o = e.apply(a, n);
            }
            function g(e) {
              return h = e, l = setTimeout(b, t), d ? m(e) : o;
            }
            function v(e) {
              var n = e - u;
              return void 0 === u || n >= t || n < 0 || f && e - h >= a;
            }
            function b() {
              var e = c();
              if (v(e)) return y(e);
              l = setTimeout(b, function (e) {
                var n = t - (e - u);
                return f ? _(n, a - (e - h)) : n;
              }(e));
            }
            function y(e) {
              return l = void 0, p && i ? m(e) : (i = r = void 0, o);
            }
            function w() {
              var e = c(),
                n = v(e);
              if (i = arguments, r = this, u = e, n) {
                if (void 0 === l) return g(u);
                if (f) return clearTimeout(l), l = setTimeout(b, t), m(u);
              }
              return void 0 === l && (l = setTimeout(b, t)), o;
            }
            return t = I(t) || 0, s(n) && (d = !!n.leading, a = (f = "maxWait" in n) ? x(I(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p), w.cancel = function () {
              void 0 !== l && clearTimeout(l), h = 0, i = u = r = l = void 0;
            }, w.flush = function () {
              return void 0 === l ? o : y(c());
            }, w;
          },
          L = function L(e, t, n) {
            var i = !0,
              r = !0;
            if ("function" != typeof e) throw new TypeError("Expected a function");
            return s(n) && (i = "leading" in n ? !!n.leading : i, r = "trailing" in n ? !!n.trailing : r), R(e, t, {
              leading: i,
              maxWait: t,
              trailing: r
            });
          };
        var P = i(590),
          M = i.n(P),
          W = function () {
            if ("undefined" != typeof Map) return Map;
            function e(e, t) {
              var n = -1;
              return e.some(function (e, i) {
                return e[0] === t && (n = i, !0);
              }), n;
            }
            return function () {
              function t() {
                this.__entries__ = [];
              }
              return Object.defineProperty(t.prototype, "size", {
                get: function get() {
                  return this.__entries__.length;
                },
                enumerable: !0,
                configurable: !0
              }), t.prototype.get = function (t) {
                var n = e(this.__entries__, t),
                  i = this.__entries__[n];
                return i && i[1];
              }, t.prototype.set = function (t, n) {
                var i = e(this.__entries__, t);
                ~i ? this.__entries__[i][1] = n : this.__entries__.push([t, n]);
              }, t.prototype.delete = function (t) {
                var n = this.__entries__,
                  i = e(n, t);
                ~i && n.splice(i, 1);
              }, t.prototype.has = function (t) {
                return !!~e(this.__entries__, t);
              }, t.prototype.clear = function () {
                this.__entries__.splice(0);
              }, t.prototype.forEach = function (e, t) {
                void 0 === t && (t = null);
                for (var n = 0, i = this.__entries__; n < i.length; n++) {
                  var r = i[n];
                  e.call(t, r[1], r[0]);
                }
              }, t;
            }();
          }(),
          D = "undefined" != typeof window && "undefined" != typeof document && window.document === document,
          F = void 0 !== i.g && i.g.Math === Math ? i.g : "undefined" != typeof self && self.Math === Math ? self : "undefined" != typeof window && window.Math === Math ? window : Function("return this")(),
          C = "function" == typeof requestAnimationFrame ? requestAnimationFrame.bind(F) : function (e) {
            return setTimeout(function () {
              return e(Date.now());
            }, 1e3 / 60);
          },
          N = ["top", "right", "bottom", "left", "width", "height", "size", "weight"],
          z = "undefined" != typeof MutationObserver,
          j = function () {
            function e() {
              this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = function (e, t) {
                var n = !1,
                  i = !1,
                  r = 0;
                function a() {
                  n && (n = !1, e()), i && o();
                }
                function s() {
                  C(a);
                }
                function o() {
                  var e = Date.now();
                  if (n) {
                    if (e - r < 2) return;
                    i = !0;
                  } else n = !0, i = !1, setTimeout(s, 20);
                  r = e;
                }
                return o;
              }(this.refresh.bind(this));
            }
            return e.prototype.addObserver = function (e) {
              ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
            }, e.prototype.removeObserver = function (e) {
              var t = this.observers_,
                n = t.indexOf(e);
              ~n && t.splice(n, 1), !t.length && this.connected_ && this.disconnect_();
            }, e.prototype.refresh = function () {
              this.updateObservers_() && this.refresh();
            }, e.prototype.updateObservers_ = function () {
              var e = this.observers_.filter(function (e) {
                return e.gatherActive(), e.hasActive();
              });
              return e.forEach(function (e) {
                return e.broadcastActive();
              }), e.length > 0;
            }, e.prototype.connect_ = function () {
              D && !this.connected_ && (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), z ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                attributes: !0,
                childList: !0,
                characterData: !0,
                subtree: !0
              })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
            }, e.prototype.disconnect_ = function () {
              D && this.connected_ && (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
            }, e.prototype.onTransitionEnd_ = function (e) {
              var t = e.propertyName,
                n = void 0 === t ? "" : t;
              N.some(function (e) {
                return !!~n.indexOf(e);
              }) && this.refresh();
            }, e.getInstance = function () {
              return this.instance_ || (this.instance_ = new e()), this.instance_;
            }, e.instance_ = null, e;
          }(),
          B = function B(e, t) {
            for (var n = 0, i = Object.keys(t); n < i.length; n++) {
              var r = i[n];
              Object.defineProperty(e, r, {
                value: t[r],
                enumerable: !1,
                writable: !1,
                configurable: !0
              });
            }
            return e;
          },
          A = function A(e) {
            return e && e.ownerDocument && e.ownerDocument.defaultView || F;
          },
          G = V(0, 0, 0, 0);
        function U(e) {
          return parseFloat(e) || 0;
        }
        function H(e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          return t.reduce(function (t, n) {
            return t + U(e["border-" + n + "-width"]);
          }, 0);
        }
        var q = "undefined" != typeof SVGGraphicsElement ? function (e) {
          return e instanceof A(e).SVGGraphicsElement;
        } : function (e) {
          return e instanceof A(e).SVGElement && "function" == typeof e.getBBox;
        };
        function K(e) {
          return D ? q(e) ? function (e) {
            var t = e.getBBox();
            return V(0, 0, t.width, t.height);
          }(e) : function (e) {
            var t = e.clientWidth,
              n = e.clientHeight;
            if (!t && !n) return G;
            var i = A(e).getComputedStyle(e),
              r = function (e) {
                for (var t = {}, n = 0, i = ["top", "right", "bottom", "left"]; n < i.length; n++) {
                  var r = i[n],
                    a = e["padding-" + r];
                  t[r] = U(a);
                }
                return t;
              }(i),
              a = r.left + r.right,
              s = r.top + r.bottom,
              o = U(i.width),
              l = U(i.height);
            if ("border-box" === i.boxSizing && (Math.round(o + a) !== t && (o -= H(i, "left", "right") + a), Math.round(l + s) !== n && (l -= H(i, "top", "bottom") + s)), !function (e) {
              return e === A(e).document.documentElement;
            }(e)) {
              var u = Math.round(o + a) - t,
                c = Math.round(l + s) - n;
              1 !== Math.abs(u) && (o -= u), 1 !== Math.abs(c) && (l -= c);
            }
            return V(r.left, r.top, o, l);
          }(e) : G;
        }
        function V(e, t, n, i) {
          return {
            x: e,
            y: t,
            width: n,
            height: i
          };
        }
        var X = function () {
            function e(e) {
              this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = V(0, 0, 0, 0), this.target = e;
            }
            return e.prototype.isActive = function () {
              var e = K(this.target);
              return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
            }, e.prototype.broadcastRect = function () {
              var e = this.contentRect_;
              return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
            }, e;
          }(),
          Y = function Y(e, t) {
            var n,
              i,
              r,
              a,
              s,
              o,
              l,
              u = (i = (n = t).x, r = n.y, a = n.width, s = n.height, o = "undefined" != typeof DOMRectReadOnly ? DOMRectReadOnly : Object, l = Object.create(o.prototype), B(l, {
                x: i,
                y: r,
                width: a,
                height: s,
                top: r,
                right: i + a,
                bottom: s + r,
                left: i
              }), l);
            B(this, {
              target: e,
              contentRect: u
            });
          },
          $ = function () {
            function e(e, t, n) {
              if (this.activeObservations_ = [], this.observations_ = new W(), "function" != typeof e) throw new TypeError("The callback provided as parameter 1 is not a function.");
              this.callback_ = e, this.controller_ = t, this.callbackCtx_ = n;
            }
            return e.prototype.observe = function (e) {
              if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
              if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(e instanceof A(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) || (t.set(e, new X(e)), this.controller_.addObserver(this), this.controller_.refresh());
              }
            }, e.prototype.unobserve = function (e) {
              if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
              if ("undefined" != typeof Element && Element instanceof Object) {
                if (!(e instanceof A(e).Element)) throw new TypeError('parameter 1 is not of type "Element".');
                var t = this.observations_;
                t.has(e) && (t.delete(e), t.size || this.controller_.removeObserver(this));
              }
            }, e.prototype.disconnect = function () {
              this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
            }, e.prototype.gatherActive = function () {
              var e = this;
              this.clearActive(), this.observations_.forEach(function (t) {
                t.isActive() && e.activeObservations_.push(t);
              });
            }, e.prototype.broadcastActive = function () {
              if (this.hasActive()) {
                var e = this.callbackCtx_,
                  t = this.activeObservations_.map(function (e) {
                    return new Y(e.target, e.broadcastRect());
                  });
                this.callback_.call(e, t, e), this.clearActive();
              }
            }, e.prototype.clearActive = function () {
              this.activeObservations_.splice(0);
            }, e.prototype.hasActive = function () {
              return this.activeObservations_.length > 0;
            }, e;
          }(),
          J = "undefined" != typeof WeakMap ? new WeakMap() : new W(),
          Q = function e(t) {
            if (!(this instanceof e)) throw new TypeError("Cannot call a class as a function.");
            if (!arguments.length) throw new TypeError("1 argument required, but only 0 present.");
            var n = j.getInstance(),
              i = new $(t, n, this);
            J.set(this, i);
          };
        ["observe", "unobserve", "disconnect"].forEach(function (e) {
          Q.prototype[e] = function () {
            var t;
            return (t = J.get(this))[e].apply(t, arguments);
          };
        });
        var Z = void 0 !== F.ResizeObserver ? F.ResizeObserver : Q;
        var ee = i(37),
          te = i(697),
          ne = a().memo(function (e) {
            var t = e.description,
              n = e.fullscreen,
              i = e.handleImageLoaded,
              r = e.isFullscreen,
              s = e.onImageError,
              o = e.original,
              l = e.originalAlt,
              u = e.originalHeight,
              c = e.originalWidth,
              h = e.originalTitle,
              d = e.sizes,
              f = e.srcSet,
              p = e.loading,
              m = r && n || o;
            return a().createElement(a().Fragment, null, a().createElement("img", {
              className: "image-gallery-image",
              src: m,
              alt: l,
              srcSet: f,
              height: u,
              width: c,
              sizes: d,
              title: h,
              onLoad: function onLoad(e) {
                return i(e, o);
              },
              onError: s,
              loading: p
            }), t && a().createElement("span", {
              className: "image-gallery-description"
            }, t));
          });
        ne.displayName = "Item", ne.propTypes = {
          description: te.string,
          fullscreen: te.string,
          handleImageLoaded: te.func.isRequired,
          isFullscreen: te.bool,
          onImageError: te.func.isRequired,
          original: te.string.isRequired,
          originalAlt: te.string,
          originalHeight: te.string,
          originalWidth: te.string,
          originalTitle: te.string,
          sizes: te.string,
          srcSet: te.string,
          loading: te.string
        }, ne.defaultProps = {
          description: "",
          fullscreen: "",
          isFullscreen: !1,
          originalAlt: "",
          originalHeight: "",
          originalWidth: "",
          originalTitle: "",
          sizes: "",
          srcSet: "",
          loading: "eager"
        };
        var ie = ne;
        var re = {
            left: a().createElement("polyline", {
              points: "15 18 9 12 15 6"
            }),
            right: a().createElement("polyline", {
              points: "9 18 15 12 9 6"
            }),
            maximize: a().createElement("path", {
              d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"
            }),
            minimize: a().createElement("path", {
              d: "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"
            }),
            play: a().createElement("polygon", {
              points: "5 3 19 12 5 21 5 3"
            }),
            pause: a().createElement(a().Fragment, null, a().createElement("rect", {
              x: "6",
              y: "4",
              width: "4",
              height: "16"
            }), a().createElement("rect", {
              x: "14",
              y: "4",
              width: "4",
              height: "16"
            }))
          },
          ae = function ae(e) {
            var t = e.strokeWidth,
              n = e.viewBox,
              i = e.icon;
            return a().createElement("svg", {
              className: "image-gallery-svg",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: n,
              fill: "none",
              stroke: "currentColor",
              strokeWidth: t,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }, re[i]);
          };
        ae.propTypes = {
          strokeWidth: te.number,
          viewBox: te.string,
          icon: (0, te.oneOf)(["left", "right", "maximize", "minimize", "play", "pause"]).isRequired
        }, ae.defaultProps = {
          strokeWidth: 1,
          viewBox: "0 0 24 24"
        };
        var se = ae;
        var oe = a().memo(function (e) {
          var t = e.isFullscreen,
            n = e.onClick;
          return a().createElement("button", {
            type: "button",
            className: "image-gallery-icon image-gallery-fullscreen-button",
            onClick: n,
            "aria-label": "Open Fullscreen"
          }, a().createElement(se, {
            strokeWidth: 2,
            icon: t ? "minimize" : "maximize"
          }));
        });
        oe.displayName = "Fullscreen", oe.propTypes = {
          isFullscreen: te.bool.isRequired,
          onClick: te.func.isRequired
        };
        var le = oe;
        var ue = a().memo(function (e) {
          var t = e.disabled,
            n = e.onClick;
          return a().createElement("button", {
            type: "button",
            className: "image-gallery-icon image-gallery-left-nav",
            disabled: t,
            onClick: n,
            "aria-label": "Previous Slide"
          }, a().createElement(se, {
            icon: "left",
            viewBox: "6 0 12 24"
          }));
        });
        ue.displayName = "LeftNav", ue.propTypes = {
          disabled: te.bool.isRequired,
          onClick: te.func.isRequired
        };
        var ce = ue;
        var he = a().memo(function (e) {
          var t = e.disabled,
            n = e.onClick;
          return a().createElement("button", {
            type: "button",
            className: "image-gallery-icon image-gallery-right-nav",
            disabled: t,
            onClick: n,
            "aria-label": "Next Slide"
          }, a().createElement(se, {
            icon: "right",
            viewBox: "6 0 12 24"
          }));
        });
        he.displayName = "RightNav", he.propTypes = {
          disabled: te.bool.isRequired,
          onClick: te.func.isRequired
        };
        var de = he;
        var fe = a().memo(function (e) {
          var t = e.isPlaying,
            n = e.onClick;
          return a().createElement("button", {
            type: "button",
            className: "image-gallery-icon image-gallery-play-button",
            onClick: n,
            "aria-label": "Play or Pause Slideshow"
          }, a().createElement(se, {
            strokeWidth: 2,
            icon: t ? "pause" : "play"
          }));
        });
        fe.displayName = "PlayPause", fe.propTypes = {
          isPlaying: te.bool.isRequired,
          onClick: te.func.isRequired
        };
        var pe = fe;
        function me() {
          return me = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
            }
            return e;
          }, me.apply(this, arguments);
        }
        var ge = function ge(e) {
          var t = e.children,
            n = e.className,
            i = e.delta,
            r = e.onSwiping,
            s = e.onSwiped,
            o = (0, ee.useSwipeable)({
              delta: i,
              onSwiping: r,
              onSwiped: s
            });
          return a().createElement("div", me({}, o, {
            className: n
          }), t);
        };
        ge.propTypes = {
          children: te.node.isRequired,
          className: te.string,
          delta: te.number,
          onSwiped: te.func,
          onSwiping: te.func
        }, ge.defaultProps = {
          className: "",
          delta: 0,
          onSwiping: function onSwiping() {},
          onSwiped: function onSwiped() {}
        };
        var ve = ge;
        function be(e) {
          return be = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, be(e);
        }
        function ye(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            t && (i = i.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, i);
          }
          return n;
        }
        function we(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ye(Object(n), !0).forEach(function (t) {
              Te(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function Te(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function Se(e, t) {
          for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
          }
        }
        function Oe(e, t) {
          return Oe = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, Oe(e, t);
        }
        function Ee(e, t) {
          return !t || "object" !== be(t) && "function" != typeof t ? ke(e) : t;
        }
        function ke(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function Ie(e) {
          return Ie = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, Ie(e);
        }
        var xe = ["fullscreenchange", "MSFullscreenChange", "mozfullscreenchange", "webkitfullscreenchange"],
          _e = (0, te.arrayOf)((0, te.shape)({
            srcSet: te.string,
            media: te.string
          }));
        function Re(e) {
          var t = parseInt(e.keyCode || e.which || 0, 10);
          return 66 === t || 62 === t;
        }
        var Le = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && Oe(e, t);
          }(l, e);
          var n,
            i,
            r,
            s,
            o = (r = l, s = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = Ie(r);
              if (s) {
                var n = Ie(this).constructor;
                e = Reflect.construct(t, arguments, n);
              } else e = t.apply(this, arguments);
              return Ee(this, e);
            });
          function l(e) {
            var t;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, l), (t = o.call(this, e)).state = {
              currentIndex: e.startIndex,
              thumbsTranslate: 0,
              thumbsSwipedTranslate: 0,
              currentSlideOffset: 0,
              galleryWidth: 0,
              thumbnailsWrapperWidth: 0,
              thumbnailsWrapperHeight: 0,
              thumbsStyle: {
                transition: "all ".concat(e.slideDuration, "ms ease-out")
              },
              isFullscreen: !1,
              isSwipingThumbnail: !1,
              isPlaying: !1
            }, t.loadedImages = {}, t.imageGallery = a().createRef(), t.thumbnailsWrapper = a().createRef(), t.thumbnails = a().createRef(), t.imageGallerySlideWrapper = a().createRef(), t.handleImageLoaded = t.handleImageLoaded.bind(ke(t)), t.handleKeyDown = t.handleKeyDown.bind(ke(t)), t.handleMouseDown = t.handleMouseDown.bind(ke(t)), t.handleResize = t.handleResize.bind(ke(t)), t.handleTouchMove = t.handleTouchMove.bind(ke(t)), t.handleOnSwiped = t.handleOnSwiped.bind(ke(t)), t.handleScreenChange = t.handleScreenChange.bind(ke(t)), t.handleSwiping = t.handleSwiping.bind(ke(t)), t.handleThumbnailSwiping = t.handleThumbnailSwiping.bind(ke(t)), t.handleOnThumbnailSwiped = t.handleOnThumbnailSwiped.bind(ke(t)), t.onThumbnailMouseLeave = t.onThumbnailMouseLeave.bind(ke(t)), t.handleImageError = t.handleImageError.bind(ke(t)), t.pauseOrPlay = t.pauseOrPlay.bind(ke(t)), t.renderThumbInner = t.renderThumbInner.bind(ke(t)), t.renderItem = t.renderItem.bind(ke(t)), t.slideLeft = t.slideLeft.bind(ke(t)), t.slideRight = t.slideRight.bind(ke(t)), t.toggleFullScreen = t.toggleFullScreen.bind(ke(t)), t.togglePlay = t.togglePlay.bind(ke(t)), t.unthrottledSlideToIndex = t.slideToIndex, t.slideToIndex = L(t.unthrottledSlideToIndex, e.slideDuration, {
              trailing: !1
            }), e.lazyLoad && (t.lazyLoaded = []), t;
          }
          return n = l, i = [{
            key: "componentDidMount",
            value: function value() {
              var e = this.props,
                t = e.autoPlay,
                n = e.useWindowKeyDown;
              t && this.play(), n ? window.addEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.addEventListener("keydown", this.handleKeyDown), window.addEventListener("mousedown", this.handleMouseDown), window.addEventListener("touchmove", this.handleTouchMove, {
                passive: !1
              }), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), this.addScreenChangeEvent();
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e, t) {
              var n = this.props,
                i = n.items,
                r = n.lazyLoad,
                a = n.slideDuration,
                s = n.slideInterval,
                o = n.startIndex,
                l = n.thumbnailPosition,
                u = n.showThumbnails,
                c = n.useWindowKeyDown,
                h = this.state,
                d = h.currentIndex,
                f = h.isPlaying,
                p = e.items.length !== i.length,
                m = !M()(e.items, i),
                g = e.startIndex !== o,
                v = e.thumbnailPosition !== l,
                b = e.showThumbnails !== u;
              s === e.slideInterval && a === e.slideDuration || f && (this.pause(), this.play()), v && (this.removeResizeObserver(), this.initSlideWrapperResizeObserver(this.imageGallerySlideWrapper), this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper)), b && u && this.initThumbnailWrapperResizeObserver(this.thumbnailsWrapper), b && !u && this.removeThumbnailsResizeObserver(), (p || b) && this.handleResize(), t.currentIndex !== d && this.slideThumbnailBar(), e.slideDuration !== a && (this.slideToIndex = L(this.unthrottledSlideToIndex, a, {
                trailing: !1
              })), !r || e.lazyLoad && !m || (this.lazyLoaded = []), c !== e.useWindowKeyDown && (c ? (this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown), window.addEventListener("keydown", this.handleKeyDown)) : (window.removeEventListener("keydown", this.handleKeyDown), this.imageGallery.current.addEventListener("keydown", this.handleKeyDown))), (g || m) && this.setState({
                currentIndex: o,
                slideStyle: {
                  transition: "none"
                }
              });
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              var e = this.props.useWindowKeyDown;
              window.removeEventListener("mousedown", this.handleMouseDown), window.removeEventListener("touchmove", this.handleTouchMove), this.removeScreenChangeEvent(), this.removeResizeObserver(), this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null), this.transitionTimer && window.clearTimeout(this.transitionTimer), e ? window.removeEventListener("keydown", this.handleKeyDown) : this.imageGallery.current.removeEventListener("keydown", this.handleKeyDown);
            }
          }, {
            key: "onSliding",
            value: function value() {
              var e = this,
                t = this.state,
                n = t.currentIndex,
                i = t.isTransitioning,
                r = this.props,
                a = r.onSlide,
                s = r.slideDuration;
              this.transitionTimer = window.setTimeout(function () {
                i && (e.setState({
                  isTransitioning: !i,
                  isSwipingThumbnail: !1
                }), a && a(n));
              }, s + 50);
            }
          }, {
            key: "onThumbnailClick",
            value: function value(e, t) {
              var n = this.props.onThumbnailClick;
              e.target.parentNode.parentNode.blur(), this.slideToIndex(t, e), n && n(e, t);
            }
          }, {
            key: "onThumbnailMouseOver",
            value: function value(e, t) {
              var n = this;
              this.thumbnailMouseOverTimer && (window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null), this.thumbnailMouseOverTimer = window.setTimeout(function () {
                n.slideToIndex(t), n.pause();
              }, 300);
            }
          }, {
            key: "onThumbnailMouseLeave",
            value: function value() {
              if (this.thumbnailMouseOverTimer) {
                var e = this.props.autoPlay;
                window.clearTimeout(this.thumbnailMouseOverTimer), this.thumbnailMouseOverTimer = null, e && this.play();
              }
            }
          }, {
            key: "setThumbsTranslate",
            value: function value(e) {
              this.setState({
                thumbsTranslate: e
              });
            }
          }, {
            key: "setModalFullscreen",
            value: function value(e) {
              var t = this.props.onScreenChange;
              this.setState({
                modalFullscreen: e
              }), t && t(e);
            }
          }, {
            key: "getThumbsTranslate",
            value: function value(e) {
              var t,
                n = this.props,
                i = n.disableThumbnailScroll,
                r = n.items,
                a = this.state,
                s = a.thumbnailsWrapperWidth,
                o = a.thumbnailsWrapperHeight,
                l = this.thumbnails && this.thumbnails.current;
              if (i) return 0;
              if (l) {
                if (this.isThumbnailVertical()) {
                  if (l.scrollHeight <= o) return 0;
                  t = l.scrollHeight - o;
                } else {
                  if (l.scrollWidth <= s || s <= 0) return 0;
                  t = l.scrollWidth - s;
                }
                return e * (t / (r.length - 1));
              }
              return 0;
            }
          }, {
            key: "getThumbnailPositionClassName",
            value: function value(e) {
              switch (e) {
                case "left":
                  e = " ".concat("image-gallery-thumbnails-left");
                  break;
                case "right":
                  e = " ".concat("image-gallery-thumbnails-right");
                  break;
                case "bottom":
                  e = " ".concat("image-gallery-thumbnails-bottom");
                  break;
                case "top":
                  e = " ".concat("image-gallery-thumbnails-top");
              }
              return e;
            }
          }, {
            key: "getAlignmentClassName",
            value: function value(e) {
              var t = this.state.currentIndex,
                n = this.props,
                i = n.infinite,
                r = n.items,
                a = "",
                s = "image-gallery-left",
                o = "image-gallery-right";
              switch (e) {
                case t - 1:
                  a = " ".concat(s);
                  break;
                case t:
                  a = " ".concat("image-gallery-center");
                  break;
                case t + 1:
                  a = " ".concat(o);
              }
              return r.length >= 3 && i && (0 === e && t === r.length - 1 ? a = " ".concat(o) : e === r.length - 1 && 0 === t && (a = " ".concat(s))), a;
            }
          }, {
            key: "getTranslateXForTwoSlide",
            value: function value(e) {
              var t = this.state,
                n = t.currentIndex,
                i = t.currentSlideOffset,
                r = t.previousIndex,
                a = n !== r,
                s = 0 === e && 0 === r,
                o = 1 === e && 1 === r,
                l = 0 === e && 1 === n,
                u = 1 === e && 0 === n,
                c = 0 === i,
                h = -100 * n + 100 * e + i;
              return i > 0 ? this.direction = "left" : i < 0 && (this.direction = "right"), u && i > 0 && (h = -100 + i), l && i < 0 && (h = 100 + i), a ? s && c && "left" === this.direction ? h = 100 : o && c && "right" === this.direction && (h = -100) : (u && c && "left" === this.direction && (h = -100), l && c && "right" === this.direction && (h = 100)), h;
            }
          }, {
            key: "getThumbnailBarHeight",
            value: function value() {
              return this.isThumbnailVertical() ? {
                height: this.state.gallerySlideWrapperHeight
              } : {};
            }
          }, {
            key: "getSlideStyle",
            value: function value(e) {
              var t = this.state,
                n = t.currentIndex,
                i = t.currentSlideOffset,
                r = t.slideStyle,
                a = this.props,
                s = a.infinite,
                o = a.items,
                l = a.useTranslate3D,
                u = a.isRTL,
                c = -100 * n,
                h = o.length - 1,
                d = (c + 100 * e) * (u ? -1 : 1) + i;
              s && o.length > 2 && (0 === n && e === h ? d = -100 * (u ? -1 : 1) + i : n === h && 0 === e && (d = 100 * (u ? -1 : 1) + i)), s && 2 === o.length && (d = this.getTranslateXForTwoSlide(e));
              var f = "translate(".concat(d, "%, 0)");
              return l && (f = "translate3d(".concat(d, "%, 0, 0)")), we({
                display: this.isSlideVisible(e) ? "inherit" : "none",
                WebkitTransform: f,
                MozTransform: f,
                msTransform: f,
                OTransform: f,
                transform: f
              }, r);
            }
          }, {
            key: "getCurrentIndex",
            value: function value() {
              return this.state.currentIndex;
            }
          }, {
            key: "getThumbnailStyle",
            value: function value() {
              var e,
                t = this.props,
                n = t.useTranslate3D,
                i = t.isRTL,
                r = this.state,
                a = r.thumbsTranslate,
                s = r.thumbsStyle,
                o = i ? -1 * a : a;
              return this.isThumbnailVertical() ? (e = "translate(0, ".concat(a, "px)"), n && (e = "translate3d(0, ".concat(a, "px, 0)"))) : (e = "translate(".concat(o, "px, 0)"), n && (e = "translate3d(".concat(o, "px, 0, 0)"))), we({
                WebkitTransform: e,
                MozTransform: e,
                msTransform: e,
                OTransform: e,
                transform: e
              }, s);
            }
          }, {
            key: "getSlideItems",
            value: function value() {
              var e = this,
                n = this.state.currentIndex,
                i = this.props,
                r = i.items,
                s = i.slideOnThumbnailOver,
                o = i.onClick,
                l = i.lazyLoad,
                u = i.onTouchMove,
                c = i.onTouchEnd,
                h = i.onTouchStart,
                d = i.onMouseOver,
                f = i.onMouseLeave,
                p = i.renderItem,
                m = i.renderThumbInner,
                g = i.showThumbnails,
                v = i.showBullets,
                b = [],
                y = [],
                w = [];
              return r.forEach(function (i, r) {
                var T = e.getAlignmentClassName(r),
                  S = i.originalClass ? " ".concat(i.originalClass) : "",
                  O = i.thumbnailClass ? " ".concat(i.thumbnailClass) : "",
                  E = i.renderItem || p || e.renderItem,
                  k = i.renderThumbInner || m || e.renderThumbInner,
                  I = !l || T || e.lazyLoaded[r];
                I && l && !e.lazyLoaded[r] && (e.lazyLoaded[r] = !0);
                var x = e.getSlideStyle(r),
                  _ = a().createElement("div", {
                    "aria-label": "Go to Slide ".concat(r + 1),
                    key: "slide-".concat(r),
                    tabIndex: "-1",
                    className: "image-gallery-slide ".concat(T, " ").concat(S),
                    style: x,
                    onClick: o,
                    onKeyUp: e.handleSlideKeyUp,
                    onTouchMove: u,
                    onTouchEnd: c,
                    onTouchStart: h,
                    onMouseOver: d,
                    onFocus: d,
                    onMouseLeave: f,
                    role: "button"
                  }, I ? E(i) : a().createElement("div", {
                    style: {
                      height: "100%"
                    }
                  }));
                if (b.push(_), g && i.thumbnail) {
                  var R = t("image-gallery-thumbnail", O, {
                    active: n === r
                  });
                  y.push(a().createElement("button", {
                    key: "thumbnail-".concat(r),
                    type: "button",
                    tabIndex: "0",
                    "aria-pressed": n === r ? "true" : "false",
                    "aria-label": "Go to Slide ".concat(r + 1),
                    className: R,
                    onMouseLeave: s ? e.onThumbnailMouseLeave : null,
                    onMouseOver: function onMouseOver(t) {
                      return e.handleThumbnailMouseOver(t, r);
                    },
                    onFocus: function onFocus(t) {
                      return e.handleThumbnailMouseOver(t, r);
                    },
                    onKeyUp: function onKeyUp(t) {
                      return e.handleThumbnailKeyUp(t, r);
                    },
                    onClick: function onClick(t) {
                      return e.onThumbnailClick(t, r);
                    }
                  }, k(i)));
                }
                if (v) {
                  var L = t("image-gallery-bullet", i.bulletClass, {
                    active: n === r
                  });
                  w.push(a().createElement("button", {
                    type: "button",
                    key: "bullet-".concat(r),
                    className: L,
                    onClick: function onClick(t) {
                      return i.bulletOnClick && i.bulletOnClick({
                        item: i,
                        itemIndex: r,
                        currentIndex: n
                      }), t.target.blur(), e.slideToIndex.call(e, r, t);
                    },
                    "aria-pressed": n === r ? "true" : "false",
                    "aria-label": "Go to Slide ".concat(r + 1)
                  }));
                }
              }), {
                slides: b,
                thumbnails: y,
                bullets: w
              };
            }
          }, {
            key: "ignoreIsTransitioning",
            value: function value() {
              var e = this.props.items,
                t = this.state,
                n = t.previousIndex,
                i = t.currentIndex,
                r = e.length - 1;
              return Math.abs(n - i) > 1 && !(0 === n && i === r) && !(n === r && 0 === i);
            }
          }, {
            key: "isFirstOrLastSlide",
            value: function value(e) {
              return e === this.props.items.length - 1 || 0 === e;
            }
          }, {
            key: "slideIsTransitioning",
            value: function value(e) {
              var t = this.state,
                n = t.isTransitioning,
                i = t.previousIndex,
                r = t.currentIndex;
              return n && !(e === i || e === r);
            }
          }, {
            key: "isSlideVisible",
            value: function value(e) {
              return !this.slideIsTransitioning(e) || this.ignoreIsTransitioning() && !this.isFirstOrLastSlide(e);
            }
          }, {
            key: "slideThumbnailBar",
            value: function value() {
              var e = this.state,
                t = e.currentIndex,
                n = e.isSwipingThumbnail,
                i = -this.getThumbsTranslate(t);
              n || (0 === t ? this.setState({
                thumbsTranslate: 0,
                thumbsSwipedTranslate: 0
              }) : this.setState({
                thumbsTranslate: i,
                thumbsSwipedTranslate: i
              }));
            }
          }, {
            key: "canSlide",
            value: function value() {
              return this.props.items.length >= 2;
            }
          }, {
            key: "canSlideLeft",
            value: function value() {
              var e = this.props,
                t = e.infinite,
                n = e.isRTL;
              return t || (n ? this.canSlideNext() : this.canSlidePrevious());
            }
          }, {
            key: "canSlideRight",
            value: function value() {
              var e = this.props,
                t = e.infinite,
                n = e.isRTL;
              return t || (n ? this.canSlidePrevious() : this.canSlideNext());
            }
          }, {
            key: "canSlidePrevious",
            value: function value() {
              return this.state.currentIndex > 0;
            }
          }, {
            key: "canSlideNext",
            value: function value() {
              return this.state.currentIndex < this.props.items.length - 1;
            }
          }, {
            key: "handleSwiping",
            value: function value(e) {
              var t = e.event,
                n = e.absX,
                i = e.dir,
                r = this.props,
                a = r.disableSwipe,
                s = r.stopPropagation,
                o = this.state,
                l = o.galleryWidth,
                u = o.isTransitioning,
                c = o.swipingUpDown,
                h = o.swipingLeftRight;
              if (i !== ee.UP && i !== ee.DOWN && !c || h) {
                if (i !== ee.LEFT && i !== ee.RIGHT || h || this.setState({
                  swipingLeftRight: !0
                }), !a) {
                  var d = this.props.swipingTransitionDuration;
                  if (s && t.preventDefault(), u) this.setState({
                    currentSlideOffset: 0
                  });else {
                    var f = i === ee.RIGHT ? 1 : -1,
                      p = n / l * 100;
                    Math.abs(p) >= 100 && (p = 100);
                    var m = {
                      transition: "transform ".concat(d, "ms ease-out")
                    };
                    this.setState({
                      currentSlideOffset: f * p,
                      slideStyle: m
                    });
                  }
                }
              } else c || this.setState({
                swipingUpDown: !0
              });
            }
          }, {
            key: "handleThumbnailSwiping",
            value: function value(e) {
              var t = e.event,
                n = e.absX,
                i = e.absY,
                r = e.dir,
                a = this.props,
                s = a.stopPropagation,
                o = a.swipingThumbnailTransitionDuration,
                l = this.state,
                u = l.thumbsSwipedTranslate,
                c = l.thumbnailsWrapperHeight,
                h = l.thumbnailsWrapperWidth,
                d = l.swipingUpDown,
                f = l.swipingLeftRight;
              if (this.isThumbnailVertical()) {
                if ((r === ee.LEFT || r === ee.RIGHT || f) && !d) return void (f || this.setState({
                  swipingLeftRight: !0
                }));
                r !== ee.UP && r !== ee.DOWN || d || this.setState({
                  swipingUpDown: !0
                });
              } else {
                if ((r === ee.UP || r === ee.DOWN || d) && !f) return void (d || this.setState({
                  swipingUpDown: !0
                }));
                r !== ee.LEFT && r !== ee.RIGHT || f || this.setState({
                  swipingLeftRight: !0
                });
              }
              var p,
                m,
                g,
                v,
                b,
                y = this.thumbnails && this.thumbnails.current;
              if (this.isThumbnailVertical() ? (p = u + (r === ee.DOWN ? i : -i), m = y.scrollHeight - c + 20, g = Math.abs(p) > m, v = p > 20, b = y.scrollHeight <= c) : (p = u + (r === ee.RIGHT ? n : -n), m = y.scrollWidth - h + 20, g = Math.abs(p) > m, v = p > 20, b = y.scrollWidth <= h), !b && (r !== ee.LEFT && r !== ee.UP || !g) && (r !== ee.RIGHT && r !== ee.DOWN || !v)) {
                s && t.stopPropagation();
                var w = {
                  transition: "transform ".concat(o, "ms ease-out")
                };
                this.setState({
                  thumbsTranslate: p,
                  thumbsStyle: w
                });
              }
            }
          }, {
            key: "handleOnThumbnailSwiped",
            value: function value() {
              var e = this.state.thumbsTranslate,
                t = this.props.slideDuration;
              this.resetSwipingDirection(), this.setState({
                isSwipingThumbnail: !0,
                thumbsSwipedTranslate: e,
                thumbsStyle: {
                  transition: "all ".concat(t, "ms ease-out")
                }
              });
            }
          }, {
            key: "sufficientSwipe",
            value: function value() {
              var e = this.state.currentSlideOffset,
                t = this.props.swipeThreshold;
              return Math.abs(e) > t;
            }
          }, {
            key: "resetSwipingDirection",
            value: function value() {
              var e = this.state,
                t = e.swipingUpDown,
                n = e.swipingLeftRight;
              t && this.setState({
                swipingUpDown: !1
              }), n && this.setState({
                swipingLeftRight: !1
              });
            }
          }, {
            key: "handleOnSwiped",
            value: function value(e) {
              var t = e.event,
                n = e.dir,
                i = e.velocity,
                r = this.props,
                a = r.disableSwipe,
                s = r.stopPropagation,
                o = r.flickThreshold;
              if (!a) {
                var l = this.props.isRTL;
                s && t.stopPropagation(), this.resetSwipingDirection();
                var u = (n === ee.LEFT ? 1 : -1) * (l ? -1 : 1),
                  c = n === ee.UP || n === ee.DOWN,
                  h = i > o && !c;
                this.handleOnSwipedTo(u, h);
              }
            }
          }, {
            key: "handleOnSwipedTo",
            value: function value(e, t) {
              var n = this.state,
                i = n.currentIndex,
                r = n.isTransitioning,
                a = i;
              !this.sufficientSwipe() && !t || r || (a += e), (-1 === e && !this.canSlideLeft() || 1 === e && !this.canSlideRight()) && (a = i), this.unthrottledSlideToIndex(a);
            }
          }, {
            key: "handleTouchMove",
            value: function value(e) {
              this.state.swipingLeftRight && e.preventDefault();
            }
          }, {
            key: "handleMouseDown",
            value: function value() {
              this.imageGallery.current.classList.add("image-gallery-using-mouse");
            }
          }, {
            key: "handleKeyDown",
            value: function value(e) {
              var t = this.props,
                n = t.disableKeyDown,
                i = t.useBrowserFullscreen,
                r = this.state.isFullscreen;
              if (this.imageGallery.current.classList.remove("image-gallery-using-mouse"), !n) switch (parseInt(e.keyCode || e.which || 0, 10)) {
                case 37:
                  this.canSlideLeft() && !this.playPauseIntervalId && this.slideLeft(e);
                  break;
                case 39:
                  this.canSlideRight() && !this.playPauseIntervalId && this.slideRight(e);
                  break;
                case 27:
                  r && !i && this.exitFullScreen();
              }
            }
          }, {
            key: "handleImageError",
            value: function value(e) {
              var t = this.props.onErrorImageURL;
              t && -1 === e.target.src.indexOf(t) && (e.target.src = t);
            }
          }, {
            key: "removeThumbnailsResizeObserver",
            value: function value() {
              this.resizeThumbnailWrapperObserver && this.thumbnailsWrapper && this.thumbnailsWrapper.current && (this.resizeThumbnailWrapperObserver.unobserve(this.thumbnailsWrapper.current), this.resizeThumbnailWrapperObserver = null);
            }
          }, {
            key: "removeResizeObserver",
            value: function value() {
              this.resizeSlideWrapperObserver && this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && (this.resizeSlideWrapperObserver.unobserve(this.imageGallerySlideWrapper.current), this.resizeSlideWrapperObserver = null), this.removeThumbnailsResizeObserver();
            }
          }, {
            key: "handleResize",
            value: function value() {
              var e = this.state.currentIndex;
              this.imageGallery && (this.imageGallery && this.imageGallery.current && this.setState({
                galleryWidth: this.imageGallery.current.offsetWidth
              }), this.imageGallerySlideWrapper && this.imageGallerySlideWrapper.current && this.setState({
                gallerySlideWrapperHeight: this.imageGallerySlideWrapper.current.offsetHeight
              }), this.setThumbsTranslate(-this.getThumbsTranslate(e)));
            }
          }, {
            key: "initSlideWrapperResizeObserver",
            value: function value(e) {
              var t = this;
              e && !e.current || (this.resizeSlideWrapperObserver = new Z(R(function (e) {
                e && e.forEach(function (e) {
                  t.setState({
                    thumbnailsWrapperWidth: e.contentRect.width
                  }, t.handleResize);
                });
              }, 50)), this.resizeSlideWrapperObserver.observe(e.current));
            }
          }, {
            key: "initThumbnailWrapperResizeObserver",
            value: function value(e) {
              var t = this;
              e && !e.current || (this.resizeThumbnailWrapperObserver = new Z(R(function (e) {
                e && e.forEach(function (e) {
                  t.setState({
                    thumbnailsWrapperHeight: e.contentRect.height
                  }, t.handleResize);
                });
              }, 50)), this.resizeThumbnailWrapperObserver.observe(e.current));
            }
          }, {
            key: "toggleFullScreen",
            value: function value() {
              this.state.isFullscreen ? this.exitFullScreen() : this.fullScreen();
            }
          }, {
            key: "togglePlay",
            value: function value() {
              this.playPauseIntervalId ? this.pause() : this.play();
            }
          }, {
            key: "handleScreenChange",
            value: function value() {
              var e = this.props,
                t = e.onScreenChange,
                n = e.useBrowserFullscreen,
                i = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement,
                r = this.imageGallery.current === i;
              t && t(r), n && this.setState({
                isFullscreen: r
              });
            }
          }, {
            key: "slideToIndex",
            value: function value(e, t) {
              var n = this.state,
                i = n.currentIndex,
                r = n.isTransitioning,
                a = this.props,
                s = a.items,
                o = a.slideDuration,
                l = a.onBeforeSlide;
              if (!r) {
                t && this.playPauseIntervalId && (this.pause(!1), this.play(!1));
                var u = s.length - 1,
                  c = e;
                e < 0 ? c = u : e > u && (c = 0), l && c !== i && l(c), this.setState({
                  previousIndex: i,
                  currentIndex: c,
                  isTransitioning: c !== i,
                  currentSlideOffset: 0,
                  slideStyle: {
                    transition: "all ".concat(o, "ms ease-out")
                  }
                }, this.onSliding);
              }
            }
          }, {
            key: "slideLeft",
            value: function value(e) {
              var t = this.props.isRTL;
              this.slideTo(e, t ? "right" : "left");
            }
          }, {
            key: "slideRight",
            value: function value(e) {
              var t = this.props.isRTL;
              this.slideTo(e, t ? "left" : "right");
            }
          }, {
            key: "slideTo",
            value: function value(e, t) {
              var n = this,
                i = this.state,
                r = i.currentIndex,
                a = i.currentSlideOffset,
                s = i.isTransitioning,
                o = this.props.items,
                l = r + ("left" === t ? -1 : 1);
              s || (2 === o.length ? this.setState({
                currentSlideOffset: a + ("left" === t ? .001 : -.001),
                slideStyle: {
                  transition: "none"
                }
              }, function () {
                window.setTimeout(function () {
                  return n.slideToIndex(l, e);
                }, 25);
              }) : this.slideToIndex(l, e));
            }
          }, {
            key: "handleThumbnailMouseOver",
            value: function value(e, t) {
              this.props.slideOnThumbnailOver && this.onThumbnailMouseOver(e, t);
            }
          }, {
            key: "handleThumbnailKeyUp",
            value: function value(e, t) {
              Re(e) && this.onThumbnailClick(e, t);
            }
          }, {
            key: "handleSlideKeyUp",
            value: function value(e) {
              Re(e) && (0, this.props.onClick)(e);
            }
          }, {
            key: "isThumbnailVertical",
            value: function value() {
              var e = this.props.thumbnailPosition;
              return "left" === e || "right" === e;
            }
          }, {
            key: "addScreenChangeEvent",
            value: function value() {
              var e = this;
              xe.forEach(function (t) {
                document.addEventListener(t, e.handleScreenChange);
              });
            }
          }, {
            key: "removeScreenChangeEvent",
            value: function value() {
              var e = this;
              xe.forEach(function (t) {
                document.removeEventListener(t, e.handleScreenChange);
              });
            }
          }, {
            key: "fullScreen",
            value: function value() {
              var e = this.props.useBrowserFullscreen,
                t = this.imageGallery.current;
              e ? t.requestFullscreen ? t.requestFullscreen() : t.msRequestFullscreen ? t.msRequestFullscreen() : t.mozRequestFullScreen ? t.mozRequestFullScreen() : t.webkitRequestFullscreen ? t.webkitRequestFullscreen() : this.setModalFullscreen(!0) : this.setModalFullscreen(!0), this.setState({
                isFullscreen: !0
              });
            }
          }, {
            key: "exitFullScreen",
            value: function value() {
              var e = this.state.isFullscreen,
                t = this.props.useBrowserFullscreen;
              e && (t ? document.exitFullscreen ? document.exitFullscreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.msExitFullscreen ? document.msExitFullscreen() : this.setModalFullscreen(!1) : this.setModalFullscreen(!1), this.setState({
                isFullscreen: !1
              }));
            }
          }, {
            key: "pauseOrPlay",
            value: function value() {
              var e = this.props.infinite,
                t = this.state.currentIndex;
              e || this.canSlideRight() ? this.slideToIndex(t + 1) : this.pause();
            }
          }, {
            key: "play",
            value: function value() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                t = this.props,
                n = t.onPlay,
                i = t.slideInterval,
                r = t.slideDuration,
                a = this.state.currentIndex;
              this.playPauseIntervalId || (this.setState({
                isPlaying: !0
              }), this.playPauseIntervalId = window.setInterval(this.pauseOrPlay, Math.max(i, r)), n && e && n(a));
            }
          }, {
            key: "pause",
            value: function value() {
              var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0],
                t = this.props.onPause,
                n = this.state.currentIndex;
              this.playPauseIntervalId && (window.clearInterval(this.playPauseIntervalId), this.playPauseIntervalId = null, this.setState({
                isPlaying: !1
              }), t && e && t(n));
            }
          }, {
            key: "isImageLoaded",
            value: function value(e) {
              return !!this.loadedImages[e.original] || (this.loadedImages[e.original] = !0, !1);
            }
          }, {
            key: "handleImageLoaded",
            value: function value(e, t) {
              var n = this.props.onImageLoad;
              !this.loadedImages[t] && n && (this.loadedImages[t] = !0, n(e));
            }
          }, {
            key: "renderItem",
            value: function value(e) {
              var t = this.state.isFullscreen,
                n = this.props.onImageError || this.handleImageError;
              return a().createElement(ie, {
                description: e.description,
                fullscreen: e.fullscreen,
                handleImageLoaded: this.handleImageLoaded,
                isFullscreen: t,
                onImageError: n,
                original: e.original,
                originalAlt: e.originalAlt,
                originalHeight: e.originalHeight,
                originalWidth: e.originalWidth,
                originalTitle: e.originalTitle,
                sizes: e.sizes,
                loading: e.loading,
                srcSet: e.srcSet
              });
            }
          }, {
            key: "renderThumbInner",
            value: function value(e) {
              var t = this.props.onThumbnailError || this.handleImageError;
              return a().createElement("span", {
                className: "image-gallery-thumbnail-inner"
              }, a().createElement("img", {
                className: "image-gallery-thumbnail-image",
                src: e.thumbnail,
                height: e.thumbnailHeight,
                width: e.thumbnailWidth,
                alt: e.thumbnailAlt,
                title: e.thumbnailTitle,
                loading: e.thumbnailLoading,
                onError: t
              }), e.thumbnailLabel && a().createElement("div", {
                className: "image-gallery-thumbnail-label"
              }, e.thumbnailLabel));
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.state,
                n = e.currentIndex,
                i = e.isFullscreen,
                r = e.modalFullscreen,
                s = e.isPlaying,
                o = this.props,
                l = o.additionalClass,
                u = o.disableThumbnailSwipe,
                c = o.indexSeparator,
                h = o.isRTL,
                d = o.items,
                f = o.thumbnailPosition,
                p = o.renderFullscreenButton,
                m = o.renderCustomControls,
                g = o.renderLeftNav,
                v = o.renderRightNav,
                b = o.showBullets,
                y = o.showFullscreenButton,
                w = o.showIndex,
                T = o.showThumbnails,
                S = o.showNav,
                O = o.showPlayButton,
                E = o.renderPlayPauseButton,
                k = this.getThumbnailStyle(),
                I = this.getSlideItems(),
                x = I.slides,
                _ = I.thumbnails,
                R = I.bullets,
                L = t("image-gallery-slide-wrapper", this.getThumbnailPositionClassName(f), {
                  "image-gallery-rtl": h
                }),
                P = a().createElement("div", {
                  ref: this.imageGallerySlideWrapper,
                  className: L
                }, m && m(), this.canSlide() ? a().createElement(a().Fragment, null, S && a().createElement(a().Fragment, null, g(this.slideLeft, !this.canSlideLeft()), v(this.slideRight, !this.canSlideRight())), a().createElement(ve, {
                  className: "image-gallery-swipe",
                  delta: 0,
                  onSwiping: this.handleSwiping,
                  onSwiped: this.handleOnSwiped
                }, a().createElement("div", {
                  className: "image-gallery-slides"
                }, x))) : a().createElement("div", {
                  className: "image-gallery-slides"
                }, x), O && E(this.togglePlay, s), b && a().createElement("div", {
                  className: "image-gallery-bullets"
                }, a().createElement("div", {
                  className: "image-gallery-bullets-container",
                  role: "navigation",
                  "aria-label": "Bullet Navigation"
                }, R)), y && p(this.toggleFullScreen, i), w && a().createElement("div", {
                  className: "image-gallery-index"
                }, a().createElement("span", {
                  className: "image-gallery-index-current"
                }, n + 1), a().createElement("span", {
                  className: "image-gallery-index-separator"
                }, c), a().createElement("span", {
                  className: "image-gallery-index-total"
                }, d.length))),
                M = t("image-gallery", l, {
                  "fullscreen-modal": r
                }),
                W = t("image-gallery-content", this.getThumbnailPositionClassName(f), {
                  fullscreen: i
                }),
                D = t("image-gallery-thumbnails-wrapper", this.getThumbnailPositionClassName(f), {
                  "thumbnails-wrapper-rtl": !this.isThumbnailVertical() && h
                }, {
                  "thumbnails-swipe-horizontal": !this.isThumbnailVertical() && !u
                }, {
                  "thumbnails-swipe-vertical": this.isThumbnailVertical() && !u
                });
              return a().createElement("div", {
                ref: this.imageGallery,
                className: M,
                "aria-live": "polite"
              }, a().createElement("div", {
                className: W
              }, ("bottom" === f || "right" === f) && P, T && _.length > 0 ? a().createElement(ve, {
                className: D,
                delta: 0,
                onSwiping: !u && this.handleThumbnailSwiping,
                onSwiped: !u && this.handleOnThumbnailSwiped
              }, a().createElement("div", {
                className: "image-gallery-thumbnails",
                ref: this.thumbnailsWrapper,
                style: this.getThumbnailBarHeight()
              }, a().createElement("nav", {
                ref: this.thumbnails,
                className: "image-gallery-thumbnails-container",
                style: k,
                "aria-label": "Thumbnail Navigation"
              }, _))) : null, ("top" === f || "left" === f) && P));
            }
          }], i && Se(n.prototype, i), l;
        }(a().Component);
        Le.propTypes = {
          flickThreshold: te.number,
          items: (0, te.arrayOf)((0, te.shape)({
            bulletClass: te.string,
            bulletOnClick: te.func,
            description: te.string,
            original: te.string,
            originalHeight: te.number,
            originalWidth: te.number,
            loading: te.string,
            thumbnailHeight: te.number,
            thumbnailWidth: te.number,
            thumbnailLoading: te.string,
            fullscreen: te.string,
            originalAlt: te.string,
            originalTitle: te.string,
            thumbnail: te.string,
            thumbnailAlt: te.string,
            thumbnailLabel: te.string,
            thumbnailTitle: te.string,
            originalClass: te.string,
            thumbnailClass: te.string,
            renderItem: te.func,
            renderThumbInner: te.func,
            imageSet: _e,
            srcSet: te.string,
            sizes: te.string
          })).isRequired,
          showNav: te.bool,
          autoPlay: te.bool,
          lazyLoad: te.bool,
          infinite: te.bool,
          showIndex: te.bool,
          showBullets: te.bool,
          showThumbnails: te.bool,
          showPlayButton: te.bool,
          showFullscreenButton: te.bool,
          disableThumbnailScroll: te.bool,
          disableKeyDown: te.bool,
          disableSwipe: te.bool,
          disableThumbnailSwipe: te.bool,
          useBrowserFullscreen: te.bool,
          onErrorImageURL: te.string,
          indexSeparator: te.string,
          thumbnailPosition: (0, te.oneOf)(["top", "bottom", "left", "right"]),
          startIndex: te.number,
          slideDuration: te.number,
          slideInterval: te.number,
          slideOnThumbnailOver: te.bool,
          swipeThreshold: te.number,
          swipingTransitionDuration: te.number,
          swipingThumbnailTransitionDuration: te.number,
          onSlide: te.func,
          onBeforeSlide: te.func,
          onScreenChange: te.func,
          onPause: te.func,
          onPlay: te.func,
          onClick: te.func,
          onImageLoad: te.func,
          onImageError: te.func,
          onTouchMove: te.func,
          onTouchEnd: te.func,
          onTouchStart: te.func,
          onMouseOver: te.func,
          onMouseLeave: te.func,
          onThumbnailError: te.func,
          onThumbnailClick: te.func,
          renderCustomControls: te.func,
          renderLeftNav: te.func,
          renderRightNav: te.func,
          renderPlayPauseButton: te.func,
          renderFullscreenButton: te.func,
          renderItem: te.func,
          renderThumbInner: te.func,
          stopPropagation: te.bool,
          additionalClass: te.string,
          useTranslate3D: te.bool,
          isRTL: te.bool,
          useWindowKeyDown: te.bool
        }, Le.defaultProps = {
          onErrorImageURL: "",
          additionalClass: "",
          showNav: !0,
          autoPlay: !1,
          lazyLoad: !1,
          infinite: !0,
          showIndex: !1,
          showBullets: !1,
          showThumbnails: !0,
          showPlayButton: !0,
          showFullscreenButton: !0,
          disableThumbnailScroll: !1,
          disableKeyDown: !1,
          disableSwipe: !1,
          disableThumbnailSwipe: !1,
          useTranslate3D: !0,
          isRTL: !1,
          useBrowserFullscreen: !0,
          flickThreshold: .4,
          stopPropagation: !1,
          indexSeparator: " / ",
          thumbnailPosition: "bottom",
          startIndex: 0,
          slideDuration: 450,
          swipingTransitionDuration: 0,
          swipingThumbnailTransitionDuration: 0,
          onSlide: null,
          onBeforeSlide: null,
          onScreenChange: null,
          onPause: null,
          onPlay: null,
          onClick: null,
          onImageLoad: null,
          onImageError: null,
          onTouchMove: null,
          onTouchEnd: null,
          onTouchStart: null,
          onMouseOver: null,
          onMouseLeave: null,
          onThumbnailError: null,
          onThumbnailClick: null,
          renderCustomControls: null,
          renderThumbInner: null,
          renderItem: null,
          slideInterval: 3e3,
          slideOnThumbnailOver: !1,
          swipeThreshold: 30,
          renderLeftNav: function renderLeftNav(e, t) {
            return a().createElement(ce, {
              onClick: e,
              disabled: t
            });
          },
          renderRightNav: function renderRightNav(e, t) {
            return a().createElement(de, {
              onClick: e,
              disabled: t
            });
          },
          renderPlayPauseButton: function renderPlayPauseButton(e, t) {
            return a().createElement(pe, {
              onClick: e,
              isPlaying: t
            });
          },
          renderFullscreenButton: function renderFullscreenButton(e, t) {
            return a().createElement(le, {
              onClick: e,
              isFullscreen: t
            });
          },
          useWindowKeyDown: !0
        };
        var Pe = Le;
      }(), r;
    }();
  });
})(imageGallery);
var Gallery = /*@__PURE__*/getDefaultExportFromCjs(imageGallery.exports);
function ImageGallery(_ref) {
  var options = _ref.options;
  if (!options.content || options.content.length < 1) {
    return /*#__PURE__*/React__default["default"].createElement("div", null);
  }
  var items = options.content.map(transform);
  return /*#__PURE__*/React__default["default"].createElement(NewGallery, null, /*#__PURE__*/React__default["default"].createElement(Gallery, {
    items: items,
    showThumbnails: true,
    thumbnailPosition: "right"
  }));
}
function transform(item) {
  return {
    original: "https://cms.burobork.nl/images/".concat(item.reference),
    thumbnail: "https://cms.burobork.nl/images/".concat(item.reference),
    originalAlt: item.alt,
    originalTitle: item.title,
    lazyLoad: true
  };
}
function ImageSlider(_ref) {
  var options = _ref.options;
  var content = options.content;
  return /*#__PURE__*/React__default["default"].createElement(SliderContainer, null, /*#__PURE__*/React__default["default"].createElement(js$1.Carousel, {
    showThumbs: false,
    swipeable: true,
    showStatus: false,
    dynamicHeight: false,
    width: "100%",
    showIndicators: content.length > 1 ? true : false
  }, options.content.map(function (slide) {
    if (!slide.active) return;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: slide.image[0].reference,
      style: {
        height: options.height ? parseInt(options.height) : 600
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: slide ? 'https://cms.burobork.nl/images/' + slide.image[0].reference : null,
      alt: slide.title,
      style: {
        height: options.height ? parseInt(options.height) : 600
      }
    }));
  })));
}
var jsxRuntime = {
  exports: {}
};
var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default["default"],
  k$1 = Symbol.for("react.element"),
  l = Symbol.for("react.fragment"),
  m = Object.prototype.hasOwnProperty,
  n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
  };
function q$1(c, a, g) {
  var b,
    d = {},
    e = null,
    h = null;
  void 0 !== g && (e = "" + g);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (h = a.ref);
  for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
  return {
    $$typeof: k$1,
    type: c,
    key: e,
    ref: h,
    props: d,
    _owner: n.current
  };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function () {
    var React = React__default["default"];

    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
      if (maybeIterable === null || typeof maybeIterable !== 'object') {
        return null;
      }
      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
      if (typeof maybeIterator === 'function') {
        return maybeIterator;
      }
      return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
      {
        {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          printWarning('error', format, args);
        }
      }
    }
    function printWarning(level, format, args) {
      // When changing this logic, you might want to also
      // update consoleWithStackDev.www.js as well.
      {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
          format += '%s';
          args = args.concat([stack]);
        } // eslint-disable-next-line react-internal/safe-string-coercion

        var argsWithFormat = args.map(function (item) {
          return String(item);
        }); // Careful: RN currently depends on this prefix

        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging

        Function.prototype.apply.call(console[level], console, argsWithFormat);
      }
    }

    // -----------------------------------------------------------------------------

    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing

    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.

    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

    var REACT_MODULE_REFERENCE;
    {
      REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    }
    function isValidElementType(type) {
      if (typeof type === 'string' || typeof type === 'function') {
        return true;
      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).

      if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
        return true;
      }
      if (typeof type === 'object' && type !== null) {
        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE ||
        // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
          return true;
        }
      }
      return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
      var displayName = outerType.displayName;
      if (displayName) {
        return displayName;
      }
      var functionName = innerType.displayName || innerType.name || '';
      return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber

    function getContextName(type) {
      return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.

    function getComponentNameFromType(type) {
      if (type == null) {
        // Host root, text node or just invalid type.
        return null;
      }
      {
        if (typeof type.tag === 'number') {
          error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
        }
      }
      if (typeof type === 'function') {
        return type.displayName || type.name || null;
      }
      if (typeof type === 'string') {
        return type;
      }
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return 'Fragment';
        case REACT_PORTAL_TYPE:
          return 'Portal';
        case REACT_PROFILER_TYPE:
          return 'Profiler';
        case REACT_STRICT_MODE_TYPE:
          return 'StrictMode';
        case REACT_SUSPENSE_TYPE:
          return 'Suspense';
        case REACT_SUSPENSE_LIST_TYPE:
          return 'SuspenseList';
      }
      if (typeof type === 'object') {
        switch (type.$$typeof) {
          case REACT_CONTEXT_TYPE:
            var context = type;
            return getContextName(context) + '.Consumer';
          case REACT_PROVIDER_TYPE:
            var provider = type;
            return getContextName(provider._context) + '.Provider';
          case REACT_FORWARD_REF_TYPE:
            return getWrappedName(type, type.render, 'ForwardRef');
          case REACT_MEMO_TYPE:
            var outerName = type.displayName || null;
            if (outerName !== null) {
              return outerName;
            }
            return getComponentNameFromType(type.type) || 'Memo';
          case REACT_LAZY_TYPE:
            {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }

          // eslint-disable-next-line no-fallthrough
        }
      }

      return null;
    }
    var assign = Object.assign;

    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
      {
        if (disabledDepth === 0) {
          /* eslint-disable react-internal/no-production-logging */
          prevLog = console.log;
          prevInfo = console.info;
          prevWarn = console.warn;
          prevError = console.error;
          prevGroup = console.group;
          prevGroupCollapsed = console.groupCollapsed;
          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

          var props = {
            configurable: true,
            enumerable: true,
            value: disabledLog,
            writable: true
          }; // $FlowFixMe Flow thinks console is immutable.

          Object.defineProperties(console, {
            info: props,
            log: props,
            warn: props,
            error: props,
            group: props,
            groupCollapsed: props,
            groupEnd: props
          });
          /* eslint-enable react-internal/no-production-logging */
        }

        disabledDepth++;
      }
    }
    function reenableLogs() {
      {
        disabledDepth--;
        if (disabledDepth === 0) {
          /* eslint-disable react-internal/no-production-logging */
          var props = {
            configurable: true,
            enumerable: true,
            writable: true
          }; // $FlowFixMe Flow thinks console is immutable.

          Object.defineProperties(console, {
            log: assign({}, props, {
              value: prevLog
            }),
            info: assign({}, props, {
              value: prevInfo
            }),
            warn: assign({}, props, {
              value: prevWarn
            }),
            error: assign({}, props, {
              value: prevError
            }),
            group: assign({}, props, {
              value: prevGroup
            }),
            groupCollapsed: assign({}, props, {
              value: prevGroupCollapsed
            }),
            groupEnd: assign({}, props, {
              value: prevGroupEnd
            })
          });
          /* eslint-enable react-internal/no-production-logging */
        }

        if (disabledDepth < 0) {
          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
        }
      }
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
      {
        if (prefix === undefined) {
          // Extract the VM specific prefix used by each line.
          try {
            throw Error();
          } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
          }
        } // We use the prefix to ensure our stacks line up with native stack frames.

        return '\n' + prefix + name;
      }
    }
    var reentry = false;
    var componentFrameCache;
    {
      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
      componentFrameCache = new PossiblyWeakMap();
    }
    function describeNativeComponentFrame(fn, construct) {
      // If something asked for a stack inside a fake render, it should get ignored.
      if (!fn || reentry) {
        return '';
      }
      {
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) {
          return frame;
        }
      }
      var control;
      reentry = true;
      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

      Error.prepareStackTrace = undefined;
      var previousDispatcher;
      {
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.

        ReactCurrentDispatcher.current = null;
        disableLogs();
      }
      try {
        // This should throw.
        if (construct) {
          // Something should be setting the props in the constructor.
          var Fake = function Fake() {
            throw Error();
          }; // $FlowFixMe

          Object.defineProperty(Fake.prototype, 'props', {
            set: function set() {
              // We use a throwing setter instead of frozen or non-writable props
              // because that won't throw in a non-strict mode function.
              throw Error();
            }
          });
          if (typeof Reflect === 'object' && Reflect.construct) {
            // We construct a different control for this case to include any extra
            // frames added by the construct call.
            try {
              Reflect.construct(Fake, []);
            } catch (x) {
              control = x;
            }
            Reflect.construct(fn, [], Fake);
          } else {
            try {
              Fake.call();
            } catch (x) {
              control = x;
            }
            fn.call(Fake.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (x) {
            control = x;
          }
          fn();
        }
      } catch (sample) {
        // This is inlined manually because closure doesn't do it for us.
        if (sample && control && typeof sample.stack === 'string') {
          // This extracts the first frame from the sample that isn't also in the control.
          // Skipping one frame that we assume is the frame that calls the two.
          var sampleLines = sample.stack.split('\n');
          var controlLines = control.stack.split('\n');
          var s = sampleLines.length - 1;
          var c = controlLines.length - 1;
          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
            // We expect at least one stack frame to be shared.
            // Typically this will be the root most one. However, stack frames may be
            // cut off due to maximum stack limits. In this case, one maybe cut off
            // earlier than the other. We assume that the sample is longer or the same
            // and there for cut off earlier. So we should find the root most frame in
            // the sample somewhere in the control.
            c--;
          }
          for (; s >= 1 && c >= 0; s--, c--) {
            // Next we find the first one that isn't the same which should be the
            // frame that called our sample function and the control.
            if (sampleLines[s] !== controlLines[c]) {
              // In V8, the first line is describing the message but other VMs don't.
              // If we're about to return the first line, and the control is also on the same
              // line, that's a pretty good indicator that our sample threw at same line as
              // the control. I.e. before we entered the sample frame. So we ignore this result.
              // This can happen if you passed a class to function component, or non-function.
              if (s !== 1 || c !== 1) {
                do {
                  s--;
                  c--; // We may still have similar intermediate frames from the construct call.
                  // The next one that isn't the same should be our match though.

                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                    // but we have a user-provided "displayName"
                    // splice it in to make the stack more readable.

                    if (fn.displayName && _frame.includes('<anonymous>')) {
                      _frame = _frame.replace('<anonymous>', fn.displayName);
                    }
                    {
                      if (typeof fn === 'function') {
                        componentFrameCache.set(fn, _frame);
                      }
                    } // Return the line we found.

                    return _frame;
                  }
                } while (s >= 1 && c >= 0);
              }
              break;
            }
          }
        }
      } finally {
        reentry = false;
        {
          ReactCurrentDispatcher.current = previousDispatcher;
          reenableLogs();
        }
        Error.prepareStackTrace = previousPrepareStackTrace;
      } // Fallback to just using the name if we couldn't make it throw.

      var name = fn ? fn.displayName || fn.name : '';
      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
      {
        if (typeof fn === 'function') {
          componentFrameCache.set(fn, syntheticFrame);
        }
      }
      return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
      {
        return describeNativeComponentFrame(fn, false);
      }
    }
    function shouldConstruct(Component) {
      var prototype = Component.prototype;
      return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
      if (type == null) {
        return '';
      }
      if (typeof type === 'function') {
        {
          return describeNativeComponentFrame(type, shouldConstruct(type));
        }
      }
      if (typeof type === 'string') {
        return describeBuiltInComponentFrame(type);
      }
      switch (type) {
        case REACT_SUSPENSE_TYPE:
          return describeBuiltInComponentFrame('Suspense');
        case REACT_SUSPENSE_LIST_TYPE:
          return describeBuiltInComponentFrame('SuspenseList');
      }
      if (typeof type === 'object') {
        switch (type.$$typeof) {
          case REACT_FORWARD_REF_TYPE:
            return describeFunctionComponentFrame(type.render);
          case REACT_MEMO_TYPE:
            // Memo may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
          case REACT_LAZY_TYPE:
            {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                // Lazy may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {}
            }
        }
      }
      return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
      {
        if (element) {
          var owner = element._owner;
          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
          ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else {
          ReactDebugCurrentFrame.setExtraStackFrame(null);
        }
      }
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
      {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.

            try {
              // This is intentionally an invariant that gets caught. It's the same
              // behavior as without this statement except with a better message.
              if (typeof typeSpecs[typeSpecName] !== 'function') {
                // eslint-disable-next-line react-internal/prod-error-codes
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
              }
              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
              error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
              setCurrentlyValidatingElement(element);
              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
              setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
              // Only monitor this failure once because there tends to be a lot of the
              // same error.
              loggedTypeFailures[error$1.message] = true;
              setCurrentlyValidatingElement(element);
              error('Failed %s type: %s', location, error$1.message);
              setCurrentlyValidatingElement(null);
            }
          }
        }
      }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

    function isArray(a) {
      return isArrayImpl(a);
    }

    /*
     * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
     * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
     *
     * The functions in this module will throw an easier-to-understand,
     * easier-to-debug exception with a clear errors message message explaining the
     * problem. (Instead of a confusing exception thrown inside the implementation
     * of the `value` object).
     */
    // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
      {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
      }
    } // $FlowFixMe only called in DEV, so void return is not possible.

    function willCoercionThrow(value) {
      {
        try {
          testStringCoercion(value);
          return false;
        } catch (e) {
          return true;
        }
      }
    }
    function testStringCoercion(value) {
      // If you ended up here by following an exception call stack, here's what's
      // happened: you supplied an object or symbol value to React (as a prop, key,
      // DOM attribute, CSS property, string ref, etc.) and when React tried to
      // coerce it to a string using `'' + value`, an exception was thrown.
      //
      // The most common types that will cause this exception are `Symbol` instances
      // and Temporal objects like `Temporal.Instant`. But any object that has a
      // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
      // exception. (Library authors do this to prevent users from using built-in
      // numeric operators like `+` or comparison operators like `>=` because custom
      // methods are needed to perform accurate arithmetic or comparison.)
      //
      // To fix the problem, coerce this object or symbol value to a string before
      // passing it to React. The most reliable way is usually `String(value)`.
      //
      // To find which value is throwing, check the browser or debugger console.
      // Before this exception was thrown, there should be `console.error` output
      // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
      // problem and how that type was used: key, atrribute, input value prop, etc.
      // In most cases, this console output also shows the component and its
      // ancestor components where the exception happened.
      //
      // eslint-disable-next-line react-internal/safe-string-coercion
      return '' + value;
    }
    function checkKeyStringCoercion(value) {
      {
        if (willCoercionThrow(value)) {
          error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));
          return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
      }
    }

    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    {
      didWarnAboutStringRefs = {};
    }
    function hasValidRef(config) {
      {
        if (hasOwnProperty.call(config, 'ref')) {
          var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
          if (getter && getter.isReactWarning) {
            return false;
          }
        }
      }
      return config.ref !== undefined;
    }
    function hasValidKey(config) {
      {
        if (hasOwnProperty.call(config, 'key')) {
          var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
          if (getter && getter.isReactWarning) {
            return false;
          }
        }
      }
      return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
      {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
          var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
          if (!didWarnAboutStringRefs[componentName]) {
            error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
            didWarnAboutStringRefs[componentName] = true;
          }
        }
      }
    }
    function defineKeyPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingKey = function warnAboutAccessingKey() {
          if (!specialPropKeyWarningShown) {
            specialPropKeyWarningShown = true;
            error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
          }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
          get: warnAboutAccessingKey,
          configurable: true
        });
      }
    }
    function defineRefPropWarningGetter(props, displayName) {
      {
        var warnAboutAccessingRef = function warnAboutAccessingRef() {
          if (!specialPropRefWarningShown) {
            specialPropRefWarningShown = true;
            error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
          }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
          get: warnAboutAccessingRef,
          configurable: true
        });
      }
    }
    /**
     * Factory method to create a new React element. This no longer adheres to
     * the class pattern, so do not use new to call it. Also, instanceof check
     * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
     * if something is a React Element.
     *
     * @param {*} type
     * @param {*} props
     * @param {*} key
     * @param {string|object} ref
     * @param {*} owner
     * @param {*} self A *temporary* helper to detect places where `this` is
     * different from the `owner` when React.createElement is called, so that we
     * can warn. We want to get rid of owner and replace string `ref`s with arrow
     * functions, and as long as `this` and owner are the same, there will be no
     * change in behavior.
     * @param {*} source An annotation object (added by a transpiler or otherwise)
     * indicating filename, line number, and/or other information.
     * @internal
     */

    var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
      var element = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: REACT_ELEMENT_TYPE,
        // Built-in properties that belong on the element
        type: type,
        key: key,
        ref: ref,
        props: props,
        // Record the component responsible for creating this element.
        _owner: owner
      };
      {
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.

        Object.defineProperty(element._store, 'validated', {
          configurable: false,
          enumerable: false,
          writable: true,
          value: false
        }); // self and source are DEV only properties.

        Object.defineProperty(element, '_self', {
          configurable: false,
          enumerable: false,
          writable: false,
          value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.

        Object.defineProperty(element, '_source', {
          configurable: false,
          enumerable: false,
          writable: false,
          value: source
        });
        if (Object.freeze) {
          Object.freeze(element.props);
          Object.freeze(element);
        }
      }
      return element;
    };
    /**
     * https://github.com/reactjs/rfcs/pull/107
     * @param {*} type
     * @param {object} props
     * @param {string} key
     */

    function jsxDEV(type, config, maybeKey, source, self) {
      {
        var propName; // Reserved names are extracted

        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.

        if (maybeKey !== undefined) {
          {
            checkKeyStringCoercion(maybeKey);
          }
          key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
          {
            checkKeyStringCoercion(config.key);
          }
          key = '' + config.key;
        }
        if (hasValidRef(config)) {
          ref = config.ref;
          warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object

        for (propName in config) {
          if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
            props[propName] = config[propName];
          }
        } // Resolve default props

        if (type && type.defaultProps) {
          var defaultProps = type.defaultProps;
          for (propName in defaultProps) {
            if (props[propName] === undefined) {
              props[propName] = defaultProps[propName];
            }
          }
        }
        if (key || ref) {
          var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
          if (key) {
            defineKeyPropWarningGetter(props, displayName);
          }
          if (ref) {
            defineRefPropWarningGetter(props, displayName);
          }
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
      }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
      {
        if (element) {
          var owner = element._owner;
          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
          ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else {
          ReactDebugCurrentFrame$1.setExtraStackFrame(null);
        }
      }
    }
    var propTypesMisspellWarningShown;
    {
      propTypesMisspellWarningShown = false;
    }
    /**
     * Verifies the object is a ReactElement.
     * See https://reactjs.org/docs/react-api.html#isvalidelement
     * @param {?object} object
     * @return {boolean} True if `object` is a ReactElement.
     * @final
     */

    function isValidElement(object) {
      {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
    }
    function getDeclarationErrorAddendum() {
      {
        if (ReactCurrentOwner$1.current) {
          var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
          if (name) {
            return '\n\nCheck the render method of `' + name + '`.';
          }
        }
        return '';
      }
    }
    function getSourceInfoErrorAddendum(source) {
      {
        if (source !== undefined) {
          var fileName = source.fileName.replace(/^.*[\\\/]/, '');
          var lineNumber = source.lineNumber;
          return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
      }
    }
    /**
     * Warn if there's no key explicitly set on dynamic arrays of children or
     * object keys are not valid. This allows us to keep track of children between
     * updates.
     */

    var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
      {
        var info = getDeclarationErrorAddendum();
        if (!info) {
          var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
          if (parentName) {
            info = "\n\nCheck the top-level render call using <" + parentName + ">.";
          }
        }
        return info;
      }
    }
    /**
     * Warn if the element doesn't have an explicit key assigned to it.
     * This element is in an array. The array could grow and shrink or be
     * reordered. All children that haven't already been validated are required to
     * have a "key" property assigned to it. Error statuses are cached so a warning
     * will only be shown once.
     *
     * @internal
     * @param {ReactElement} element Element that requires a key.
     * @param {*} parentType element's parent's type.
     */

    function validateExplicitKey(element, parentType) {
      {
        if (!element._store || element._store.validated || element.key != null) {
          return;
        }
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
          return;
        }
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.

        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
          // Give the component that originally created this child.
          childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        }
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
      }
    }
    /**
     * Ensure that every element either is passed in a static location, in an
     * array with an explicit keys property defined, or in an object literal
     * with valid key property.
     *
     * @internal
     * @param {ReactNode} node Statically passed child of any type.
     * @param {*} parentType node's parent's type.
     */

    function validateChildKeys(node, parentType) {
      {
        if (typeof node !== 'object') {
          return;
        }
        if (isArray(node)) {
          for (var i = 0; i < node.length; i++) {
            var child = node[i];
            if (isValidElement(child)) {
              validateExplicitKey(child, parentType);
            }
          }
        } else if (isValidElement(node)) {
          // This element was passed in a valid location.
          if (node._store) {
            node._store.validated = true;
          }
        } else if (node) {
          var iteratorFn = getIteratorFn(node);
          if (typeof iteratorFn === 'function') {
            // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            if (iteratorFn !== node.entries) {
              var iterator = iteratorFn.call(node);
              var step;
              while (!(step = iterator.next()).done) {
                if (isValidElement(step.value)) {
                  validateExplicitKey(step.value, parentType);
                }
              }
            }
          }
        }
      }
    }
    /**
     * Given an element, validate that its props follow the propTypes definition,
     * provided by the type.
     *
     * @param {ReactElement} element
     */

    function validatePropTypes(element) {
      {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') {
          return;
        }
        var propTypes;
        if (typeof type === 'function') {
          propTypes = type.propTypes;
        } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE ||
        // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) {
          propTypes = type.propTypes;
        } else {
          return;
        }
        if (propTypes) {
          // Intentionally inside to avoid triggering lazy initializers:
          var name = getComponentNameFromType(type);
          checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
          propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

          var _name = getComponentNameFromType(type);
          error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
          error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
        }
      }
    }
    /**
     * Given a fragment, validate that it can only be provided with fragment props
     * @param {ReactElement} fragment
     */

    function validateFragmentProps(fragment) {
      {
        var keys = Object.keys(fragment.props);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (key !== 'children' && key !== 'key') {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
            setCurrentlyValidatingElement$1(null);
            break;
          }
        }
        if (fragment.ref !== null) {
          setCurrentlyValidatingElement$1(fragment);
          error('Invalid attribute `ref` supplied to `React.Fragment`.');
          setCurrentlyValidatingElement$1(null);
        }
      }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
      {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.

        if (!validType) {
          var info = '';
          if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
            info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
          }
          var sourceInfo = getSourceInfoErrorAddendum(source);
          if (sourceInfo) {
            info += sourceInfo;
          } else {
            info += getDeclarationErrorAddendum();
          }
          var typeString;
          if (type === null) {
            typeString = 'null';
          } else if (isArray(type)) {
            typeString = 'array';
          } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
            typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
            info = ' Did you accidentally export a JSX literal instead of a component?';
          } else {
            typeString = typeof type;
          }
          error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.

        if (element == null) {
          return element;
        } // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)

        if (validType) {
          var children = props.children;
          if (children !== undefined) {
            if (isStaticChildren) {
              if (isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                  validateChildKeys(children[i], type);
                }
                if (Object.freeze) {
                  Object.freeze(children);
                }
              } else {
                error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
              }
            } else {
              validateChildKeys(children, type);
            }
          }
        }
        if (type === REACT_FRAGMENT_TYPE) {
          validateFragmentProps(element);
        } else {
          validatePropTypes(element);
        }
        return element;
      }
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.

    function jsxWithValidationStatic(type, props, key) {
      {
        return jsxWithValidation(type, props, key, true);
      }
    }
    function jsxWithValidationDynamic(type, props, key) {
      {
        return jsxWithValidation(type, props, key, false);
      }
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions

    var jsxs = jsxWithValidationStatic;
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = jsx;
    reactJsxRuntime_development.jsxs = jsxs;
  })();
}
if (process.env.NODE_ENV === 'production') {
  jsxRuntime.exports = reactJsxRuntime_production_min;
} else {
  jsxRuntime.exports = reactJsxRuntime_development;
}
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;
var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }
  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};
var invariant_1 = invariant;
var MapContext = React.createContext(null);
function useGoogleMap() {
  invariant_1(!!React.useContext, 'useGoogleMap is React hook and requires React version 16.8+');
  var map = React.useContext(MapContext);
  invariant_1(!!map, 'useGoogleMap needs a GoogleMap available up in the tree');
  return map;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forEach(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

/* global google */
function applyUpdaterToNextProps(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
updaterMap,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
prevProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nextProps,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var map = {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var iter = function iter(fn, key) {
    var nextValue = nextProps[key];
    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };
  forEach(updaterMap, iter);
  return map;
}
function registerEvents(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props,
// eslint-disable-next-line @typescript-eslint/no-explicit-any
instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);
  return registeredList;
}
function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}
function unregisterEvents() {
  var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  events.forEach(unregisterEvent);
}
function applyUpdatersToPropsAndRegisterEvents(_ref6) {
  var updaterMap = _ref6.updaterMap,
    eventMap = _ref6.eventMap,
    prevProps = _ref6.prevProps,
    nextProps = _ref6.nextProps,
    instance = _ref6.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}
var eventMap$i = {
  onDblClick: 'dblclick',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMapTypeIdChanged: 'maptypeid_changed',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseDown: 'mousedown',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onTilesLoaded: 'tilesloaded',
  onBoundsChanged: 'bounds_changed',
  onCenterChanged: 'center_changed',
  onClick: 'click',
  onDrag: 'drag',
  onHeadingChanged: 'heading_changed',
  onIdle: 'idle',
  onProjectionChanged: 'projection_changed',
  onResize: 'resize',
  onTiltChanged: 'tilt_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$i = {
  extraMapTypes: function extraMapTypes(map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  clickableIcons: function clickableIcons(map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};
// TODO: unfinished!
function GoogleMapFunctional(_ref7) {
  var children = _ref7.children,
    options = _ref7.options,
    id = _ref7.id,
    mapContainerStyle = _ref7.mapContainerStyle,
    mapContainerClassName = _ref7.mapContainerClassName,
    center = _ref7.center,
    onClick = _ref7.onClick,
    onDblClick = _ref7.onDblClick,
    onDrag = _ref7.onDrag,
    onDragEnd = _ref7.onDragEnd,
    onDragStart = _ref7.onDragStart,
    onMouseMove = _ref7.onMouseMove,
    onMouseOut = _ref7.onMouseOut,
    onMouseOver = _ref7.onMouseOver,
    onMouseDown = _ref7.onMouseDown,
    onMouseUp = _ref7.onMouseUp,
    onRightClick = _ref7.onRightClick,
    onCenterChanged = _ref7.onCenterChanged,
    onLoad = _ref7.onLoad,
    onUnmount = _ref7.onUnmount;
  var _React$useState2 = React.useState(null),
    _React$useState3 = _slicedToArray2(_React$useState2, 2),
    map = _React$useState3[0],
    setMap = _React$useState3[1];
  var ref = React.useRef(null);
  // const [extraMapTypesListener, setExtraMapTypesListener] = useState<google.maps.MapsEventListener | null>(null)
  var _React$useState4 = React.useState(null),
    _React$useState5 = _slicedToArray2(_React$useState4, 2),
    centerChangedListener = _React$useState5[0],
    setCenterChangedListener = _React$useState5[1];
  var _React$useState6 = React.useState(null),
    _React$useState7 = _slicedToArray2(_React$useState6, 2),
    dblclickListener = _React$useState7[0],
    setDblclickListener = _React$useState7[1];
  var _React$useState8 = React.useState(null),
    _React$useState9 = _slicedToArray2(_React$useState8, 2),
    dragendListener = _React$useState9[0],
    setDragendListener = _React$useState9[1];
  var _React$useState10 = React.useState(null),
    _React$useState11 = _slicedToArray2(_React$useState10, 2),
    dragstartListener = _React$useState11[0],
    setDragstartListener = _React$useState11[1];
  var _React$useState12 = React.useState(null),
    _React$useState13 = _slicedToArray2(_React$useState12, 2),
    mousedownListener = _React$useState13[0],
    setMousedownListener = _React$useState13[1];
  var _React$useState14 = React.useState(null),
    _React$useState15 = _slicedToArray2(_React$useState14, 2),
    mousemoveListener = _React$useState15[0],
    setMousemoveListener = _React$useState15[1];
  var _React$useState16 = React.useState(null),
    _React$useState17 = _slicedToArray2(_React$useState16, 2),
    mouseoutListener = _React$useState17[0],
    setMouseoutListener = _React$useState17[1];
  var _React$useState18 = React.useState(null),
    _React$useState19 = _slicedToArray2(_React$useState18, 2),
    mouseoverListener = _React$useState19[0],
    setMouseoverListener = _React$useState19[1];
  var _React$useState20 = React.useState(null),
    _React$useState21 = _slicedToArray2(_React$useState20, 2),
    mouseupListener = _React$useState21[0],
    setMouseupListener = _React$useState21[1];
  var _React$useState22 = React.useState(null),
    _React$useState23 = _slicedToArray2(_React$useState22, 2),
    rightclickListener = _React$useState23[0],
    setRightclickListener = _React$useState23[1];
  var _React$useState24 = React.useState(null),
    _React$useState25 = _slicedToArray2(_React$useState24, 2),
    clickListener = _React$useState25[0],
    setClickListener = _React$useState25[1];
  var _React$useState26 = React.useState(null),
    _React$useState27 = _slicedToArray2(_React$useState26, 2),
    dragListener = _React$useState27[0],
    setDragListener = _React$useState27[1];
  // Order does matter
  React.useEffect(function () {
    if (options && map !== null) {
      map.setOptions(options);
    }
  }, [map, options]);
  React.useEffect(function () {
    if (map !== null && typeof center !== 'undefined') {
      map.setCenter(center);
    }
  }, [map, center]);
  React.useEffect(function () {
    if (map && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(map, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (map && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(map, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (map && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(map, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (map && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(map, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (map && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(map, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (map && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(map, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (map && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(map, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (map && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(map, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (map && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(map, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (map && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(map, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (map && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(map, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (map && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }
      setCenterChangedListener(google.maps.event.addListener(map, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  React.useEffect(function () {
    var map = ref.current === null ? null : new google.maps.Map(ref.current, options);
    setMap(map);
    if (map !== null && onLoad) {
      onLoad(map);
    }
    return function () {
      if (map !== null) {
        if (onUnmount) {
          onUnmount(map);
        }
      }
    };
  }, []);
  return jsxRuntime.exports.jsx("div", Object.assign({
    id: id,
    ref: ref,
    style: mapContainerStyle,
    className: mapContainerClassName
  }, {
    children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
      value: map
    }, {
      children: map !== null ? children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
    }))
  }));
}
React.memo(GoogleMapFunctional);
var GoogleMap = /*#__PURE__*/function (_React$PureComponent) {
  _inherits2(GoogleMap, _React$PureComponent);
  var _super2 = _createSuper2(GoogleMap);
  function GoogleMap() {
    var _this6;
    _classCallCheck2(this, GoogleMap);
    _this6 = _super2.apply(this, arguments);
    _this6.state = {
      map: null
    };
    _this6.registeredEvents = [];
    _this6.mapRef = null;
    _this6.getInstance = function () {
      if (_this6.mapRef === null) {
        return null;
      }
      return new google.maps.Map(_this6.mapRef, _this6.props.options);
    };
    _this6.panTo = function (latLng) {
      var map = _this6.getInstance();
      if (map) {
        map.panTo(latLng);
      }
    };
    _this6.setMapCallback = function () {
      if (_this6.state.map !== null) {
        if (_this6.props.onLoad) {
          _this6.props.onLoad(_this6.state.map);
        }
      }
    };
    _this6.getRef = function (ref) {
      _this6.mapRef = ref;
    };
    return _this6;
  }
  _createClass2(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var map = this.getInstance();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: {},
        nextProps: this.props,
        instance: map
      });
      this.setState(function setMap() {
        return {
          map: map
        };
      }, this.setMapCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.map !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$i,
          eventMap: eventMap$i,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.map
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.map !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.map);
        }
        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        id: this.props.id,
        ref: this.getRef,
        style: this.props.mapContainerStyle,
        className: this.props.mapContainerClassName
      }, {
        children: jsxRuntime.exports.jsx(MapContext.Provider, Object.assign({
          value: this.state.map
        }, {
          children: this.state.map !== null ? this.props.children : jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {})
        }))
      }));
    }
  }]);
  return GoogleMap;
}(React.PureComponent);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest$1(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var isBrowser = typeof document !== 'undefined';
function injectScript(_ref8) {
  var url = _ref8.url,
    id = _ref8.id,
    nonce = _ref8.nonce;
  if (!isBrowser) {
    return Promise.reject(new Error('document is undefined'));
  }
  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;
    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');
      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap = windowWithGoogleMap.initMap;
          var originalErrorCallback = existingScript.onerror;
          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap) {
              originalInitMap();
            }
            resolve(id);
          };
          existingScript.onerror = function (err) {
            if (originalErrorCallback) {
              originalErrorCallback(err);
            }
            reject(err);
          };
          return;
        }
      }
      // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
        existingScript.remove();
      }
    }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;
    script.nonce = nonce;
    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };
    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };
    document.head.appendChild(script);
  }).catch(function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
}
function isGoogleFontStyle(element) {
  // 'Roboto' or 'Google Sans Text' font download
  var href = element.href;
  if (href && (href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0 || href.indexOf('https://fonts.googleapis.com/css?family=Google+Sans+Text') === 0)) {
    return true;
  }
  // font style elements
  if (element.tagName.toLowerCase() === 'style' &&
  // @ts-ignore
  element.styleSheet &&
  // @ts-ignore
  element.styleSheet.cssText &&
  // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  }
  // font style elements for other browsers
  if (element.tagName.toLowerCase() === 'style' && element.innerHTML && element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    element.innerHTML = '';
    return true;
  }
  // when google tries to add empty style
  if (element.tagName.toLowerCase() === 'style' &&
  // @ts-ignore
  !element.styleSheet && !element.innerHTML) {
    return true;
  }
  return false;
}
// Preventing the Google Maps library from downloading an extra font
function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  var trueInsertBefore = head.insertBefore.bind(head);
  // TODO: adding return before reflect solves the TS issue
  // @ts-ignore
  head.insertBefore = function insertBefore(newElement, referenceElement) {
    if (!isGoogleFontStyle(newElement)) {
      Reflect.apply(trueInsertBefore, head, [newElement, referenceElement]);
    }
  };
  var trueAppend = head.appendChild.bind(head);
  // TODO: adding return before reflect solves the TS issue
  // @ts-ignore
  head.appendChild = function appendChild(textNode) {
    if (!isGoogleFontStyle(textNode)) {
      Reflect.apply(trueAppend, head, [textNode]);
    }
  };
}
function makeLoadScriptUrl(_ref9) {
  var googleMapsApiKey = _ref9.googleMapsApiKey,
    googleMapsClientId = _ref9.googleMapsClientId,
    _ref9$version = _ref9.version,
    version = _ref9$version === void 0 ? 'weekly' : _ref9$version,
    language = _ref9.language,
    region = _ref9.region,
    libraries = _ref9.libraries,
    channel = _ref9.channel,
    mapIds = _ref9.mapIds,
    authReferrerPolicy = _ref9.authReferrerPolicy;
  var params = [];
  invariant_1(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId), 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.');
  if (googleMapsApiKey) {
    params.push("key=".concat(googleMapsApiKey));
  } else if (googleMapsClientId) {
    params.push("client=".concat(googleMapsClientId));
  }
  if (version) {
    params.push("v=".concat(version));
  }
  if (language) {
    params.push("language=".concat(language));
  }
  if (region) {
    params.push("region=".concat(region));
  }
  if (libraries && libraries.length) {
    params.push("libraries=".concat(libraries.sort().join(',')));
  }
  if (channel) {
    params.push("channel=".concat(channel));
  }
  if (mapIds && mapIds.length) {
    params.push("map_ids=".concat(mapIds.join(',')));
  }
  if (authReferrerPolicy) {
    params.push("auth_referrer_policy=".concat(authReferrerPolicy));
  }
  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?".concat(params.join('&'));
}
var cleaningUp = false;
function DefaultLoadingElement() {
  return jsxRuntime.exports.jsx("div", {
    children: "Loading..."
  });
}
var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};
var LoadScript = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits2(LoadScript, _React$PureComponent2);
  var _super3 = _createSuper2(LoadScript);
  function LoadScript() {
    var _this7;
    _classCallCheck2(this, LoadScript);
    _this7 = _super3.apply(this, arguments);
    _this7.check = React.createRef();
    _this7.state = {
      loaded: false
    };
    _this7.cleanupCallback = function () {
      // @ts-ignore
      delete window.google.maps;
      _this7.injectScript();
    };
    _this7.isCleaningUp = function () {
      return __awaiter(_assertThisInitialized2(_this7), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var promiseCallback;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              promiseCallback = function _promiseCallback(resolve) {
                if (!cleaningUp) {
                  resolve();
                } else {
                  if (isBrowser) {
                    var timer = window.setInterval(function interval() {
                      if (!cleaningUp) {
                        window.clearInterval(timer);
                        resolve();
                      }
                    }, 1);
                  }
                }
                return;
              };
              return _context.abrupt("return", new Promise(promiseCallback));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    _this7.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this7.props.id);
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
      Array.prototype.slice.call(document.getElementsByTagName('script')).filter(function filter(script) {
        return typeof script.src === 'string' && script.src.includes('maps.googleapis');
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('link')).filter(function filter(link) {
        return link.href === 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans';
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName('style')).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes('.gm-');
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    };
    _this7.injectScript = function () {
      if (_this7.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }
      invariant_1(!!_this7.props.id, 'LoadScript requires "id" prop to be a string: %s', _this7.props.id);
      var injectScriptOptions = {
        id: _this7.props.id,
        nonce: _this7.props.nonce,
        url: makeLoadScriptUrl(_this7.props)
      };
      injectScript(injectScriptOptions).then(function () {
        if (_this7.props.onLoad) {
          _this7.props.onLoad();
        }
        _this7.setState(function setLoaded() {
          return {
            loaded: true
          };
        });
        return;
      }).catch(function (err) {
        if (_this7.props.onError) {
          _this7.props.onError(err);
        }
        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(_this7.props.googleMapsApiKey || '-', ") or Client ID (").concat(_this7.props.googleMapsClientId || '-', ") to <LoadScript />\n          Otherwise it is a Network issue.\n        "));
      });
    };
    return _this7;
  }
  _createClass2(LoadScript, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isBrowser) {
        if (window.google && window.google.maps && !cleaningUp) {
          console.error('google api is already presented');
          return;
        }
        this.isCleaningUp().then(this.injectScript).catch(function error(err) {
          console.error('Error at injecting script after cleaning up: ', err);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.libraries !== prevProps.libraries) {
        console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
      }
      if (isBrowser && prevProps.language !== this.props.language) {
        this.cleanup();
        // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(function setLoaded() {
          return {
            loaded: false
          };
        }, this.cleanupCallback);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this8 = this;
      if (isBrowser) {
        this.cleanup();
        var timeoutCallback = function timeoutCallback() {
          if (!_this8.check.current) {
            // @ts-ignore
            delete window.google;
            cleaningUp = false;
          }
        };
        window.setTimeout(timeoutCallback, 1);
        if (this.props.onUnmount) {
          this.props.onUnmount();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsxs(jsxRuntime.exports.Fragment, {
        children: [jsxRuntime.exports.jsx("div", {
          ref: this.check
        }), this.state.loaded ? this.props.children : this.props.loadingElement || jsxRuntime.exports.jsx(DefaultLoadingElement, {})]
      });
    }
  }]);
  return LoadScript;
}(React.PureComponent);
LoadScript.defaultProps = defaultLoadScriptProps;

/* eslint-disable filenames/match-regex */
var previouslyLoadedUrl;
function useLoadScript(_ref10) {
  var _ref10$id = _ref10.id,
    id = _ref10$id === void 0 ? defaultLoadScriptProps.id : _ref10$id,
    _ref10$version = _ref10.version,
    version = _ref10$version === void 0 ? defaultLoadScriptProps.version : _ref10$version,
    nonce = _ref10.nonce,
    googleMapsApiKey = _ref10.googleMapsApiKey,
    googleMapsClientId = _ref10.googleMapsClientId,
    language = _ref10.language,
    region = _ref10.region,
    libraries = _ref10.libraries,
    preventGoogleFontsLoading = _ref10.preventGoogleFontsLoading,
    channel = _ref10.channel,
    mapIds = _ref10.mapIds,
    authReferrerPolicy = _ref10.authReferrerPolicy;
  var isMounted = React.useRef(false);
  var _React$useState28 = React.useState(false),
    _React$useState29 = _slicedToArray2(_React$useState28, 2),
    isLoaded = _React$useState29[0],
    setLoaded = _React$useState29[1];
  var _React$useState30 = React.useState(undefined),
    _React$useState31 = _slicedToArray2(_React$useState30, 2),
    loadError = _React$useState31[0],
    setLoadError = _React$useState31[1];
  React.useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  React.useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  React.useEffect(function validateLoadedState() {
    if (isLoaded) {
      invariant_1(!!window.google, 'useLoadScript was marked as loaded, but window.google is not present. Something went wrong.');
    }
  }, [isLoaded]);
  var url = makeLoadScriptUrl({
    version: version,
    googleMapsApiKey: googleMapsApiKey,
    googleMapsClientId: googleMapsClientId,
    language: language,
    region: region,
    libraries: libraries,
    channel: channel,
    mapIds: mapIds,
    authReferrerPolicy: authReferrerPolicy
  });
  React.useEffect(function loadScriptAndModifyLoadedState() {
    if (!isBrowser) {
      return;
    }
    function setLoadedIfMounted() {
      if (isMounted.current) {
        setLoaded(true);
        previouslyLoadedUrl = url;
      }
    }
    if (window.google && window.google.maps && previouslyLoadedUrl === url) {
      setLoadedIfMounted();
      return;
    }
    injectScript({
      id: id,
      url: url,
      nonce: nonce
    }).then(setLoadedIfMounted).catch(function handleInjectError(err) {
      if (isMounted.current) {
        setLoadError(err);
      }
      console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (".concat(googleMapsApiKey || '-', ") or Client ID (").concat(googleMapsClientId || '-', ")\n        Otherwise it is a Network issue.\n      "));
      console.error(err);
    });
  }, [id, url, nonce]);
  var prevLibraries = React.useRef();
  React.useEffect(function checkPerformance() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }
    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError,
    url: url
  };
}
var defaultLoadingElement = jsxRuntime.exports.jsx(DefaultLoadingElement, {});
function LoadScriptNext(_a) {
  var loadingElement = _a.loadingElement,
    onLoad = _a.onLoad,
    onError = _a.onError,
    onUnmount = _a.onUnmount,
    children = _a.children,
    hookOptions = __rest$1(_a, ["loadingElement", "onLoad", "onError", "onUnmount", "children"]);
  var _useLoadScript = useLoadScript(hookOptions),
    isLoaded = _useLoadScript.isLoaded,
    loadError = _useLoadScript.loadError;
  React.useEffect(function handleOnLoad() {
    if (isLoaded && typeof onLoad === 'function') {
      onLoad();
    }
  }, [isLoaded, onLoad]);
  React.useEffect(function handleOnError() {
    if (loadError && typeof onError === 'function') {
      onError(loadError);
    }
  }, [loadError, onError]);
  React.useEffect(function handleOnUnmount() {
    return function () {
      if (onUnmount) {
        onUnmount();
      }
    };
  }, [onUnmount]);
  return isLoaded ? children : loadingElement || defaultLoadingElement;
}
React.memo(LoadScriptNext);

// do not edit .js files directly - edit src/index.jst

var fastDeepEqual$1 = function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }
    return true;
  }

  // true if both NaN, false otherwise
  return a !== a && b !== b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
  LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
  LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
  LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
  LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
var Loader = /*#__PURE__*/function () {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  function Loader(_ref11) {
    var apiKey = _ref11.apiKey,
      authReferrerPolicy = _ref11.authReferrerPolicy,
      channel = _ref11.channel,
      client = _ref11.client,
      _ref11$id = _ref11.id,
      id = _ref11$id === void 0 ? DEFAULT_ID : _ref11$id,
      language = _ref11.language,
      _ref11$libraries = _ref11.libraries,
      libraries = _ref11$libraries === void 0 ? [] : _ref11$libraries,
      mapIds = _ref11.mapIds,
      nonce = _ref11.nonce,
      region = _ref11.region,
      _ref11$retries = _ref11.retries,
      retries = _ref11$retries === void 0 ? 3 : _ref11$retries,
      _ref11$url = _ref11.url,
      url = _ref11$url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _ref11$url,
      version = _ref11.version;
    _classCallCheck2(this, Loader);
    this.CALLBACK = "__googleMapsCallback";
    this.callbacks = [];
    this.done = false;
    this.loading = false;
    this.errors = [];
    this.apiKey = apiKey;
    this.authReferrerPolicy = authReferrerPolicy;
    this.channel = channel;
    this.client = client;
    this.id = id || DEFAULT_ID; // Do not allow empty string
    this.language = language;
    this.libraries = libraries;
    this.mapIds = mapIds;
    this.nonce = nonce;
    this.region = region;
    this.retries = retries;
    this.url = url;
    this.version = version;
    if (Loader.instance) {
      if (!fastDeepEqual$1(this.options, Loader.instance.options)) {
        throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(Loader.instance.options)));
      }
      return Loader.instance;
    }
    Loader.instance = this;
  }
  _createClass2(Loader, [{
    key: "options",
    get: function get() {
      return {
        version: this.version,
        apiKey: this.apiKey,
        channel: this.channel,
        client: this.client,
        id: this.id,
        libraries: this.libraries,
        language: this.language,
        region: this.region,
        mapIds: this.mapIds,
        nonce: this.nonce,
        url: this.url,
        authReferrerPolicy: this.authReferrerPolicy
      };
    }
  }, {
    key: "status",
    get: function get() {
      if (this.errors.length) {
        return LoaderStatus.FAILURE;
      }
      if (this.done) {
        return LoaderStatus.SUCCESS;
      }
      if (this.loading) {
        return LoaderStatus.LOADING;
      }
      return LoaderStatus.INITIALIZED;
    }
  }, {
    key: "failed",
    get: function get() {
      return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
  }, {
    key: "createUrl",
    value: function createUrl() {
      var url = this.url;
      url += "?callback=".concat(this.CALLBACK);
      if (this.apiKey) {
        url += "&key=".concat(this.apiKey);
      }
      if (this.channel) {
        url += "&channel=".concat(this.channel);
      }
      if (this.client) {
        url += "&client=".concat(this.client);
      }
      if (this.libraries.length > 0) {
        url += "&libraries=".concat(this.libraries.join(","));
      }
      if (this.language) {
        url += "&language=".concat(this.language);
      }
      if (this.region) {
        url += "&region=".concat(this.region);
      }
      if (this.version) {
        url += "&v=".concat(this.version);
      }
      if (this.mapIds) {
        url += "&map_ids=".concat(this.mapIds.join(","));
      }
      if (this.authReferrerPolicy) {
        url += "&auth_referrer_policy=".concat(this.authReferrerPolicy);
      }
      return url;
    }
  }, {
    key: "deleteScript",
    value: function deleteScript() {
      var script = document.getElementById(this.id);
      if (script) {
        script.remove();
      }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */
  }, {
    key: "load",
    value: function load() {
      return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */
  }, {
    key: "loadPromise",
    value: function loadPromise() {
      var _this9 = this;
      return new Promise(function (resolve, reject) {
        _this9.loadCallback(function (err) {
          if (!err) {
            resolve(window.google);
          } else {
            reject(err.error);
          }
        });
      });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */
  }, {
    key: "loadCallback",
    value: function loadCallback(fn) {
      this.callbacks.push(fn);
      this.execute();
    }
    /**
     * Set the script on document.
     */
  }, {
    key: "setScript",
    value: function setScript() {
      if (document.getElementById(this.id)) {
        // TODO wrap onerror callback for cases where the script was loaded elsewhere
        this.callback();
        return;
      }
      var url = this.createUrl();
      var script = document.createElement("script");
      script.id = this.id;
      script.type = "text/javascript";
      script.src = url;
      script.onerror = this.loadErrorCallback.bind(this);
      script.defer = true;
      script.async = true;
      if (this.nonce) {
        script.nonce = this.nonce;
      }
      document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */
  }, {
    key: "reset",
    value: function reset() {
      this.deleteScript();
      this.done = false;
      this.loading = false;
      this.errors = [];
      this.onerrorEvent = null;
    }
  }, {
    key: "resetIfRetryingFailed",
    value: function resetIfRetryingFailed() {
      if (this.failed) {
        this.reset();
      }
    }
  }, {
    key: "loadErrorCallback",
    value: function loadErrorCallback(e) {
      var _this10 = this;
      this.errors.push(e);
      if (this.errors.length <= this.retries) {
        var delay = this.errors.length * Math.pow(2, this.errors.length);
        console.log("Failed to load Google Maps script, retrying in ".concat(delay, " ms."));
        setTimeout(function () {
          _this10.deleteScript();
          _this10.setScript();
        }, delay);
      } else {
        this.onerrorEvent = e;
        this.callback();
      }
    }
  }, {
    key: "setCallback",
    value: function setCallback() {
      window.__googleMapsCallback = this.callback.bind(this);
    }
  }, {
    key: "callback",
    value: function callback() {
      var _this11 = this;
      this.done = true;
      this.loading = false;
      this.callbacks.forEach(function (cb) {
        cb(_this11.onerrorEvent);
      });
      this.callbacks = [];
    }
  }, {
    key: "execute",
    value: function execute() {
      this.resetIfRetryingFailed();
      if (this.done) {
        this.callback();
      } else {
        // short circuit and warn if google.maps is already loaded
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." + "This may result in undesirable behavior as options and script parameters may not match.");
          this.callback();
          return;
        }
        if (this.loading) ;else {
          this.loading = true;
          this.setCallback();
          this.setScript();
        }
      }
    }
  }]);
  return Loader;
}();
function useJsApiLoader(_ref12) {
  var _ref12$id = _ref12.id,
    id = _ref12$id === void 0 ? defaultLoadScriptProps.id : _ref12$id,
    _ref12$version = _ref12.version,
    version = _ref12$version === void 0 ? defaultLoadScriptProps.version : _ref12$version,
    nonce = _ref12.nonce,
    googleMapsApiKey = _ref12.googleMapsApiKey,
    language = _ref12.language,
    region = _ref12.region,
    libraries = _ref12.libraries,
    preventGoogleFontsLoading = _ref12.preventGoogleFontsLoading,
    mapIds = _ref12.mapIds,
    authReferrerPolicy = _ref12.authReferrerPolicy;
  var isMounted = React.useRef(false);
  var _React$useState32 = React.useState(false),
    _React$useState33 = _slicedToArray2(_React$useState32, 2),
    isLoaded = _React$useState33[0],
    setLoaded = _React$useState33[1];
  var _React$useState34 = React.useState(undefined),
    _React$useState35 = _slicedToArray2(_React$useState34, 2),
    loadError = _React$useState35[0],
    setLoadError = _React$useState35[1];
  React.useEffect(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  var loader = React.useMemo(function memo() {
    return new Loader({
      id: id,
      apiKey: googleMapsApiKey,
      version: version,
      libraries: libraries,
      language: language,
      region: region,
      mapIds: mapIds,
      nonce: nonce,
      authReferrerPolicy: authReferrerPolicy
    });
  }, [id, googleMapsApiKey, version, libraries, language, region, mapIds, nonce, authReferrerPolicy]);
  React.useEffect(function effect() {
    if (isLoaded) {
      return;
    } else {
      loader.load().then(function then() {
        if (isMounted.current) setLoaded(true);
      }).catch(function onrejected(error) {
        setLoadError(error);
      });
    }
  }, []);
  React.useEffect(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  var prevLibraries = React.useRef();
  React.useEffect(function effect() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }
    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError
  };
}
var eventMap$h = {};
var updaterMap$h = {
  options: function options(instance, _options2) {
    instance.setOptions(_options2);
  }
};
function TrafficLayerFunctional(_ref13) {
  var options = _ref13.options,
    onLoad = _ref13.onLoad,
    onUnmount = _ref13.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState36 = React.useState(null),
    _React$useState37 = _slicedToArray2(_React$useState36, 2),
    instance = _React$useState37[0],
    setInstance = _React$useState37[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    setInstance(trafficLayer);
    if (onLoad) {
      onLoad(trafficLayer);
    }
    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        }
        instance.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(TrafficLayerFunctional);
var TrafficLayer = /*#__PURE__*/function (_React$PureComponent3) {
  _inherits2(TrafficLayer, _React$PureComponent3);
  var _super4 = _createSuper2(TrafficLayer);
  function TrafficLayer() {
    var _this12;
    _classCallCheck2(this, TrafficLayer);
    _this12 = _super4.apply(this, arguments);
    _this12.state = {
      trafficLayer: null
    };
    _this12.setTrafficLayerCallback = function () {
      if (_this12.state.trafficLayer !== null && _this12.props.onLoad) {
        _this12.props.onLoad(_this12.state.trafficLayer);
      }
    };
    _this12.registeredEvents = [];
    return _this12;
  }
  _createClass2(TrafficLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var trafficLayer = new google.maps.TrafficLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: {},
        nextProps: this.props,
        instance: trafficLayer
      });
      this.setState(function setTrafficLayer() {
        return {
          trafficLayer: trafficLayer
        };
      }, this.setTrafficLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.trafficLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$h,
          eventMap: eventMap$h,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.trafficLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.trafficLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.trafficLayer);
        }
        unregisterEvents(this.registeredEvents);
        // @ts-ignore
        this.state.trafficLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return TrafficLayer;
}(React.PureComponent);
TrafficLayer.contextType = MapContext;
function BicyclingLayerFunctional(_ref14) {
  var onLoad = _ref14.onLoad,
    onUnmount = _ref14.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState38 = React.useState(null),
    _React$useState39 = _slicedToArray2(_React$useState38, 2),
    instance = _React$useState39[0],
    setInstance = _React$useState39[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    var bicyclingLayer = new google.maps.BicyclingLayer();
    setInstance(bicyclingLayer);
    bicyclingLayer.setMap(map);
    if (onLoad) {
      onLoad(bicyclingLayer);
    }
    return function () {
      if (bicyclingLayer !== null) {
        if (onUnmount) {
          onUnmount(bicyclingLayer);
        }
        bicyclingLayer.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(BicyclingLayerFunctional);
var BicyclingLayer = /*#__PURE__*/function (_React$PureComponent4) {
  _inherits2(BicyclingLayer, _React$PureComponent4);
  var _super5 = _createSuper2(BicyclingLayer);
  function BicyclingLayer() {
    var _this13;
    _classCallCheck2(this, BicyclingLayer);
    _this13 = _super5.apply(this, arguments);
    _this13.state = {
      bicyclingLayer: null
    };
    _this13.setBicyclingLayerCallback = function () {
      if (_this13.state.bicyclingLayer !== null) {
        _this13.state.bicyclingLayer.setMap(_this13.context);
        if (_this13.props.onLoad) {
          _this13.props.onLoad(_this13.state.bicyclingLayer);
        }
      }
    };
    return _this13;
  }
  _createClass2(BicyclingLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var bicyclingLayer = new google.maps.BicyclingLayer();
      this.setState(function () {
        return {
          bicyclingLayer: bicyclingLayer
        };
      }, this.setBicyclingLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.bicyclingLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.bicyclingLayer);
        }
        this.state.bicyclingLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return BicyclingLayer;
}(React.PureComponent);
BicyclingLayer.contextType = MapContext;
function TransitLayerFunctional(_ref15) {
  var _this14 = this;
  var onLoad = _ref15.onLoad,
    onUnmount = _ref15.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState40 = React.useState(null),
    _React$useState41 = _slicedToArray2(_React$useState40, 2),
    instance = _React$useState41[0],
    setInstance = _React$useState41[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    var transitLayer = new google.maps.TransitLayer();
    setInstance(transitLayer);
    transitLayer.setMap(map);
    if (onLoad) {
      onLoad(transitLayer);
    }
    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        }
        // @ts-ignore
        _this14.state.transitLayer.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(TransitLayerFunctional);
var TransitLayer = /*#__PURE__*/function (_React$PureComponent5) {
  _inherits2(TransitLayer, _React$PureComponent5);
  var _super6 = _createSuper2(TransitLayer);
  function TransitLayer() {
    var _this15;
    _classCallCheck2(this, TransitLayer);
    _this15 = _super6.apply(this, arguments);
    _this15.state = {
      transitLayer: null
    };
    _this15.setTransitLayerCallback = function () {
      if (_this15.state.transitLayer !== null) {
        // @ts-ignore
        _this15.state.transitLayer.setMap(_this15.context);
        if (_this15.props.onLoad) {
          // @ts-ignore
          _this15.props.onLoad(_this15.state.transitLayer);
        }
      }
    };
    return _this15;
  }
  _createClass2(TransitLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var transitLayer = new google.maps.TransitLayer();
      this.setState(function setTransitLayer() {
        return {
          transitLayer: transitLayer
        };
      }, this.setTransitLayerCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.transitLayer !== null) {
        if (this.props.onUnmount) {
          // @ts-ignore
          this.props.onUnmount(this.state.transitLayer);
        }
        // @ts-ignore
        this.state.transitLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return TransitLayer;
}(React.PureComponent);
TransitLayer.contextType = MapContext;

/* globals google */
var eventMap$g = {
  onCircleComplete: 'circlecomplete',
  onMarkerComplete: 'markercomplete',
  onOverlayComplete: 'overlaycomplete',
  onPolygonComplete: 'polygoncomplete',
  onPolylineComplete: 'polylinecomplete',
  onRectangleComplete: 'rectanglecomplete'
};
var updaterMap$g = {
  drawingMode: function drawingMode(instance, _drawingMode) {
    instance.setDrawingMode(_drawingMode);
  },
  options: function options(instance, _options3) {
    instance.setOptions(_options3);
  }
};
function DrawingManagerFunctional(_ref16) {
  var options = _ref16.options,
    drawingMode = _ref16.drawingMode,
    onCircleComplete = _ref16.onCircleComplete,
    onMarkerComplete = _ref16.onMarkerComplete,
    onOverlayComplete = _ref16.onOverlayComplete,
    onPolygonComplete = _ref16.onPolygonComplete,
    onPolylineComplete = _ref16.onPolylineComplete,
    onRectangleComplete = _ref16.onRectangleComplete,
    onLoad = _ref16.onLoad,
    onUnmount = _ref16.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState42 = React.useState(null),
    _React$useState43 = _slicedToArray2(_React$useState42, 2),
    instance = _React$useState43[0],
    setInstance = _React$useState43[1];
  var _React$useState44 = React.useState(null),
    _React$useState45 = _slicedToArray2(_React$useState44, 2),
    circlecompleteListener = _React$useState45[0],
    setCircleCompleteListener = _React$useState45[1];
  var _React$useState46 = React.useState(null),
    _React$useState47 = _slicedToArray2(_React$useState46, 2),
    markercompleteListener = _React$useState47[0],
    setMarkerCompleteListener = _React$useState47[1];
  var _React$useState48 = React.useState(null),
    _React$useState49 = _slicedToArray2(_React$useState48, 2),
    overlaycompleteListener = _React$useState49[0],
    setOverlayCompleteListener = _React$useState49[1];
  var _React$useState50 = React.useState(null),
    _React$useState51 = _slicedToArray2(_React$useState50, 2),
    polygoncompleteListener = _React$useState51[0],
    setPolygonCompleteListener = _React$useState51[1];
  var _React$useState52 = React.useState(null),
    _React$useState53 = _slicedToArray2(_React$useState52, 2),
    polylinecompleteListener = _React$useState53[0],
    setPolylineCompleteListener = _React$useState53[1];
  var _React$useState54 = React.useState(null),
    _React$useState55 = _slicedToArray2(_React$useState54, 2),
    rectanglecompleteListener = _React$useState55[0],
    setRectangleCompleteListener = _React$useState55[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (drawingMode && instance !== null) {
      instance.setDrawingMode(drawingMode);
    }
  }, [instance, drawingMode]);
  React.useEffect(function () {
    if (instance && onCircleComplete) {
      if (circlecompleteListener !== null) {
        google.maps.event.removeListener(circlecompleteListener);
      }
      setCircleCompleteListener(google.maps.event.addListener(instance, 'circlecomplete', onCircleComplete));
    }
  }, [instance, onCircleComplete]);
  React.useEffect(function () {
    if (instance && onMarkerComplete) {
      if (markercompleteListener !== null) {
        google.maps.event.removeListener(markercompleteListener);
      }
      setMarkerCompleteListener(google.maps.event.addListener(instance, 'markercomplete', onMarkerComplete));
    }
  }, [instance, onMarkerComplete]);
  React.useEffect(function () {
    if (instance && onOverlayComplete) {
      if (overlaycompleteListener !== null) {
        google.maps.event.removeListener(overlaycompleteListener);
      }
      setOverlayCompleteListener(google.maps.event.addListener(instance, 'overlaycomplete', onOverlayComplete));
    }
  }, [instance, onOverlayComplete]);
  React.useEffect(function () {
    if (instance && onPolygonComplete) {
      if (polygoncompleteListener !== null) {
        google.maps.event.removeListener(polygoncompleteListener);
      }
      setPolygonCompleteListener(google.maps.event.addListener(instance, 'polygoncomplete', onPolygonComplete));
    }
  }, [instance, onPolygonComplete]);
  React.useEffect(function () {
    if (instance && onPolylineComplete) {
      if (polylinecompleteListener !== null) {
        google.maps.event.removeListener(polylinecompleteListener);
      }
      setPolylineCompleteListener(google.maps.event.addListener(instance, 'polylinecomplete', onPolylineComplete));
    }
  }, [instance, onPolylineComplete]);
  React.useEffect(function () {
    if (instance && onRectangleComplete) {
      if (rectanglecompleteListener !== null) {
        google.maps.event.removeListener(rectanglecompleteListener);
      }
      setRectangleCompleteListener(google.maps.event.addListener(instance, 'rectanglecomplete', onRectangleComplete));
    }
  }, [instance, onRectangleComplete]);
  React.useEffect(function () {
    invariant_1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    if (drawingMode) {
      drawingManager.setDrawingMode(drawingMode);
    }
    if (onCircleComplete) {
      setCircleCompleteListener(google.maps.event.addListener(drawingManager, 'circlecomplete', onCircleComplete));
    }
    if (onMarkerComplete) {
      setMarkerCompleteListener(google.maps.event.addListener(drawingManager, 'markercomplete', onMarkerComplete));
    }
    if (onOverlayComplete) {
      setOverlayCompleteListener(google.maps.event.addListener(drawingManager, 'overlaycomplete', onOverlayComplete));
    }
    if (onPolygonComplete) {
      setPolygonCompleteListener(google.maps.event.addListener(drawingManager, 'polygoncomplete', onPolygonComplete));
    }
    if (onPolylineComplete) {
      setPolylineCompleteListener(google.maps.event.addListener(drawingManager, 'polylinecomplete', onPolylineComplete));
    }
    if (onRectangleComplete) {
      setRectangleCompleteListener(google.maps.event.addListener(drawingManager, 'rectanglecomplete', onRectangleComplete));
    }
    setInstance(drawingManager);
    if (onLoad) {
      onLoad(drawingManager);
    }
    return function () {
      if (instance !== null) {
        if (circlecompleteListener) {
          google.maps.event.removeListener(circlecompleteListener);
        }
        if (markercompleteListener) {
          google.maps.event.removeListener(markercompleteListener);
        }
        if (overlaycompleteListener) {
          google.maps.event.removeListener(overlaycompleteListener);
        }
        if (polygoncompleteListener) {
          google.maps.event.removeListener(polygoncompleteListener);
        }
        if (polylinecompleteListener) {
          google.maps.event.removeListener(polylinecompleteListener);
        }
        if (rectanglecompleteListener) {
          google.maps.event.removeListener(rectanglecompleteListener);
        }
        if (onUnmount) {
          onUnmount(instance);
        }
        instance.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(DrawingManagerFunctional);
var DrawingManager = /*#__PURE__*/function (_React$PureComponent6) {
  _inherits2(DrawingManager, _React$PureComponent6);
  var _super7 = _createSuper2(DrawingManager);
  function DrawingManager(props) {
    var _this16;
    _classCallCheck2(this, DrawingManager);
    _this16 = _super7.call(this, props);
    _this16.registeredEvents = [];
    _this16.state = {
      drawingManager: null
    };
    _this16.setDrawingManagerCallback = function () {
      if (_this16.state.drawingManager !== null && _this16.props.onLoad) {
        _this16.props.onLoad(_this16.state.drawingManager);
      }
    };
    invariant_1(!!google.maps.drawing, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing);
    return _this16;
  }
  _createClass2(DrawingManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var drawingManager = new google.maps.drawing.DrawingManager(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: {},
        nextProps: this.props,
        instance: drawingManager
      });
      this.setState(function setDrawingManager() {
        return {
          drawingManager: drawingManager
        };
      }, this.setDrawingManagerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.drawingManager !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$g,
          eventMap: eventMap$g,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.drawingManager
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.drawingManager !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.drawingManager);
        }
        unregisterEvents(this.registeredEvents);
        this.state.drawingManager.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return DrawingManager;
}(React.PureComponent);
DrawingManager.contextType = MapContext;
var eventMap$f = {
  onAnimationChanged: 'animation_changed',
  onClick: 'click',
  onClickableChanged: 'clickable_changed',
  onCursorChanged: 'cursor_changed',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDraggableChanged: 'draggable_changed',
  onDragStart: 'dragstart',
  onFlatChanged: 'flat_changed',
  onIconChanged: 'icon_changed',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onPositionChanged: 'position_changed',
  onRightClick: 'rightclick',
  onShapeChanged: 'shape_changed',
  onTitleChanged: 'title_changed',
  onVisibleChanged: 'visible_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$f = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation);
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable);
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon);
  },
  label: function label(instance, _label) {
    instance.setLabel(_label);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  },
  options: function options(instance, _options4) {
    instance.setOptions(_options4);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var defaultOptions$5 = {};
function MarkerFunctional(_ref17) {
  var position = _ref17.position,
    options = _ref17.options,
    clusterer = _ref17.clusterer,
    noClustererRedraw = _ref17.noClustererRedraw,
    children = _ref17.children,
    draggable = _ref17.draggable,
    visible = _ref17.visible,
    animation = _ref17.animation,
    clickable = _ref17.clickable,
    cursor = _ref17.cursor,
    icon = _ref17.icon,
    label = _ref17.label,
    opacity = _ref17.opacity,
    shape = _ref17.shape,
    title = _ref17.title,
    zIndex = _ref17.zIndex,
    onClick = _ref17.onClick,
    onDblClick = _ref17.onDblClick,
    onDrag = _ref17.onDrag,
    onDragEnd = _ref17.onDragEnd,
    onDragStart = _ref17.onDragStart,
    onMouseOut = _ref17.onMouseOut,
    onMouseOver = _ref17.onMouseOver,
    onMouseUp = _ref17.onMouseUp,
    onMouseDown = _ref17.onMouseDown,
    onRightClick = _ref17.onRightClick,
    onClickableChanged = _ref17.onClickableChanged,
    onCursorChanged = _ref17.onCursorChanged,
    onAnimationChanged = _ref17.onAnimationChanged,
    onDraggableChanged = _ref17.onDraggableChanged,
    onFlatChanged = _ref17.onFlatChanged,
    onIconChanged = _ref17.onIconChanged,
    onPositionChanged = _ref17.onPositionChanged,
    onShapeChanged = _ref17.onShapeChanged,
    onTitleChanged = _ref17.onTitleChanged,
    onVisibleChanged = _ref17.onVisibleChanged,
    onZindexChanged = _ref17.onZindexChanged,
    onLoad = _ref17.onLoad,
    onUnmount = _ref17.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState56 = React.useState(null),
    _React$useState57 = _slicedToArray2(_React$useState56, 2),
    instance = _React$useState57[0],
    setInstance = _React$useState57[1];
  var _React$useState58 = React.useState(null),
    _React$useState59 = _slicedToArray2(_React$useState58, 2),
    dblclickListener = _React$useState59[0],
    setDblclickListener = _React$useState59[1];
  var _React$useState60 = React.useState(null),
    _React$useState61 = _slicedToArray2(_React$useState60, 2),
    dragendListener = _React$useState61[0],
    setDragendListener = _React$useState61[1];
  var _React$useState62 = React.useState(null),
    _React$useState63 = _slicedToArray2(_React$useState62, 2),
    dragstartListener = _React$useState63[0],
    setDragstartListener = _React$useState63[1];
  var _React$useState64 = React.useState(null),
    _React$useState65 = _slicedToArray2(_React$useState64, 2),
    mousedownListener = _React$useState65[0],
    setMousedownListener = _React$useState65[1];
  var _React$useState66 = React.useState(null),
    _React$useState67 = _slicedToArray2(_React$useState66, 2),
    mouseoutListener = _React$useState67[0],
    setMouseoutListener = _React$useState67[1];
  var _React$useState68 = React.useState(null),
    _React$useState69 = _slicedToArray2(_React$useState68, 2),
    mouseoverListener = _React$useState69[0],
    setMouseoverListener = _React$useState69[1];
  var _React$useState70 = React.useState(null),
    _React$useState71 = _slicedToArray2(_React$useState70, 2),
    mouseupListener = _React$useState71[0],
    setMouseupListener = _React$useState71[1];
  var _React$useState72 = React.useState(null),
    _React$useState73 = _slicedToArray2(_React$useState72, 2),
    rightclickListener = _React$useState73[0],
    setRightclickListener = _React$useState73[1];
  var _React$useState74 = React.useState(null),
    _React$useState75 = _slicedToArray2(_React$useState74, 2),
    clickListener = _React$useState75[0],
    setClickListener = _React$useState75[1];
  var _React$useState76 = React.useState(null),
    _React$useState77 = _slicedToArray2(_React$useState76, 2),
    dragListener = _React$useState77[0],
    setDragListener = _React$useState77[1];
  var _React$useState78 = React.useState(null),
    _React$useState79 = _slicedToArray2(_React$useState78, 2),
    clickableChangedListener = _React$useState79[0],
    setClickableChangedListener = _React$useState79[1];
  var _React$useState80 = React.useState(null),
    _React$useState81 = _slicedToArray2(_React$useState80, 2),
    cursorChangedListener = _React$useState81[0],
    setCursorChangedListener = _React$useState81[1];
  var _React$useState82 = React.useState(null),
    _React$useState83 = _slicedToArray2(_React$useState82, 2),
    animationChangedListener = _React$useState83[0],
    setAnimationChangedListener = _React$useState83[1];
  var _React$useState84 = React.useState(null),
    _React$useState85 = _slicedToArray2(_React$useState84, 2),
    draggableChangedListener = _React$useState85[0],
    setDraggableChangedListener = _React$useState85[1];
  var _React$useState86 = React.useState(null),
    _React$useState87 = _slicedToArray2(_React$useState86, 2),
    flatChangedListener = _React$useState87[0],
    setFlatChangedListener = _React$useState87[1];
  var _React$useState88 = React.useState(null),
    _React$useState89 = _slicedToArray2(_React$useState88, 2),
    iconChangedListener = _React$useState89[0],
    setIconChangedListener = _React$useState89[1];
  var _React$useState90 = React.useState(null),
    _React$useState91 = _slicedToArray2(_React$useState90, 2),
    positionChangedListener = _React$useState91[0],
    setPositionChangedListener = _React$useState91[1];
  var _React$useState92 = React.useState(null),
    _React$useState93 = _slicedToArray2(_React$useState92, 2),
    shapeChangedListener = _React$useState93[0],
    setShapeChangedListener = _React$useState93[1];
  var _React$useState94 = React.useState(null),
    _React$useState95 = _slicedToArray2(_React$useState94, 2),
    titleChangedListener = _React$useState95[0],
    setTitleChangedListener = _React$useState95[1];
  var _React$useState96 = React.useState(null),
    _React$useState97 = _slicedToArray2(_React$useState96, 2),
    visibleChangedListener = _React$useState97[0],
    setVisibleChangedListener = _React$useState97[1];
  var _React$useState98 = React.useState(null),
    _React$useState99 = _slicedToArray2(_React$useState98, 2),
    zIndexChangedListener = _React$useState99[0],
    setZindexChangedListener = _React$useState99[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [instance, position]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (animation && instance !== null) {
      instance.setAnimation(animation);
    }
  }, [instance, animation]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onClickableChanged) {
      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }
      setClickableChangedListener(google.maps.event.addListener(instance, 'clickable_changed', onClickableChanged));
    }
  }, [onClickableChanged]);
  React.useEffect(function () {
    if (instance && onCursorChanged) {
      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }
      setCursorChangedListener(google.maps.event.addListener(instance, 'cursor_changed', onCursorChanged));
    }
  }, [onCursorChanged]);
  React.useEffect(function () {
    if (instance && onAnimationChanged) {
      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }
      setAnimationChangedListener(google.maps.event.addListener(instance, 'animation_changed', onAnimationChanged));
    }
  }, [onAnimationChanged]);
  React.useEffect(function () {
    if (instance && onDraggableChanged) {
      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }
      setDraggableChangedListener(google.maps.event.addListener(instance, 'draggable_changed', onDraggableChanged));
    }
  }, [onDraggableChanged]);
  React.useEffect(function () {
    if (instance && onFlatChanged) {
      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }
      setFlatChangedListener(google.maps.event.addListener(instance, 'flat_changed', onFlatChanged));
    }
  }, [onFlatChanged]);
  React.useEffect(function () {
    if (instance && onIconChanged) {
      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }
      setIconChangedListener(google.maps.event.addListener(instance, 'icon_changed', onIconChanged));
    }
  }, [onIconChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }
      setPositionChangedListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onShapeChanged) {
      if (shapeChangedListener !== null) {
        google.maps.event.removeListener(shapeChangedListener);
      }
      setShapeChangedListener(google.maps.event.addListener(instance, 'shape_changed', onShapeChanged));
    }
  }, [onShapeChanged]);
  React.useEffect(function () {
    if (instance && onTitleChanged) {
      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }
      setTitleChangedListener(google.maps.event.addListener(instance, 'title_changed', onTitleChanged));
    }
  }, [onTitleChanged]);
  React.useEffect(function () {
    if (instance && onVisibleChanged) {
      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }
      setVisibleChangedListener(google.maps.event.addListener(instance, 'visible_changed', onVisibleChanged));
    }
  }, [onVisibleChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }
      setZindexChangedListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    var markerOptions = Object.assign(Object.assign(Object.assign({}, options || defaultOptions$5), clusterer ? defaultOptions$5 : {
      map: map
    }), {
      position: position
    });
    var marker = new google.maps.Marker(markerOptions);
    if (clusterer) {
      clusterer.addMarker(marker, !!noClustererRedraw);
    } else {
      marker.setMap(map);
    }
    if (position) {
      marker.setPosition(position);
    }
    if (typeof visible !== 'undefined') {
      marker.setVisible(visible);
    }
    if (typeof draggable !== 'undefined') {
      marker.setDraggable(draggable);
    }
    if (typeof clickable !== 'undefined') {
      marker.setClickable(clickable);
    }
    if (typeof cursor === 'string') {
      marker.setCursor(cursor);
    }
    if (icon) {
      marker.setIcon(icon);
    }
    if (typeof label !== 'undefined') {
      marker.setLabel(label);
    }
    if (typeof opacity !== 'undefined') {
      marker.setOpacity(opacity);
    }
    if (shape) {
      marker.setShape(shape);
    }
    if (typeof title === 'string') {
      marker.setTitle(title);
    }
    if (typeof zIndex === 'number') {
      marker.setZIndex(zIndex);
    }
    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(marker, 'dblclick', onDblClick));
    }
    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(marker, 'dragend', onDragEnd));
    }
    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(marker, 'dragstart', onDragStart));
    }
    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(marker, 'mousedown', onMouseDown));
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(marker, 'mouseout', onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(marker, 'mouseover', onMouseOver));
    }
    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(marker, 'mouseup', onMouseUp));
    }
    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(marker, 'rightclick', onRightClick));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(marker, 'click', onClick));
    }
    if (onDrag) {
      setDragListener(google.maps.event.addListener(marker, 'drag', onDrag));
    }
    if (onClickableChanged) {
      setClickableChangedListener(google.maps.event.addListener(marker, 'clickable_changed', onClickableChanged));
    }
    if (onCursorChanged) {
      setCursorChangedListener(google.maps.event.addListener(marker, 'cursor_changed', onCursorChanged));
    }
    if (onAnimationChanged) {
      setAnimationChangedListener(google.maps.event.addListener(marker, 'animation_changed', onAnimationChanged));
    }
    if (onDraggableChanged) {
      setDraggableChangedListener(google.maps.event.addListener(marker, 'draggable_changed', onDraggableChanged));
    }
    if (onFlatChanged) {
      setFlatChangedListener(google.maps.event.addListener(marker, 'flat_changed', onFlatChanged));
    }
    if (onIconChanged) {
      setIconChangedListener(google.maps.event.addListener(marker, 'icon_changed', onIconChanged));
    }
    if (onPositionChanged) {
      setPositionChangedListener(google.maps.event.addListener(marker, 'position_changed', onPositionChanged));
    }
    if (onShapeChanged) {
      setShapeChangedListener(google.maps.event.addListener(marker, 'shape_changed', onShapeChanged));
    }
    if (onTitleChanged) {
      setTitleChangedListener(google.maps.event.addListener(marker, 'title_changed', onTitleChanged));
    }
    if (onVisibleChanged) {
      setVisibleChangedListener(google.maps.event.addListener(marker, 'visible_changed', onVisibleChanged));
    }
    if (onZindexChanged) {
      setZindexChangedListener(google.maps.event.addListener(marker, 'zindex_changed', onZindexChanged));
    }
    setInstance(marker);
    if (onLoad) {
      onLoad(marker);
    }
    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (clickableChangedListener !== null) {
        google.maps.event.removeListener(clickableChangedListener);
      }
      if (cursorChangedListener !== null) {
        google.maps.event.removeListener(cursorChangedListener);
      }
      if (animationChangedListener !== null) {
        google.maps.event.removeListener(animationChangedListener);
      }
      if (draggableChangedListener !== null) {
        google.maps.event.removeListener(draggableChangedListener);
      }
      if (flatChangedListener !== null) {
        google.maps.event.removeListener(flatChangedListener);
      }
      if (iconChangedListener !== null) {
        google.maps.event.removeListener(iconChangedListener);
      }
      if (positionChangedListener !== null) {
        google.maps.event.removeListener(positionChangedListener);
      }
      if (titleChangedListener !== null) {
        google.maps.event.removeListener(titleChangedListener);
      }
      if (visibleChangedListener !== null) {
        google.maps.event.removeListener(visibleChangedListener);
      }
      if (zIndexChangedListener !== null) {
        google.maps.event.removeListener(zIndexChangedListener);
      }
      if (onUnmount) {
        onUnmount(marker);
      }
      if (clusterer) {
        clusterer.removeMarker(marker, !!noClustererRedraw);
      } else if (marker) {
        marker.setMap(null);
      }
    };
  }, []);
  var chx = React.useMemo(function () {
    return children ? React.Children.map(children, function (child) {
      if (!React.isValidElement(child)) {
        return child;
      }
      var elementChild = child;
      return React.cloneElement(elementChild, {
        anchor: instance
      });
    }) : null;
  }, [children, instance]);
  return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {
    children: chx
  }) || null;
}
React.memo(MarkerFunctional);
var Marker = /*#__PURE__*/function (_React$PureComponent7) {
  _inherits2(Marker, _React$PureComponent7);
  var _super8 = _createSuper2(Marker);
  function Marker() {
    var _this17;
    _classCallCheck2(this, Marker);
    _this17 = _super8.apply(this, arguments);
    _this17.registeredEvents = [];
    return _this17;
  }
  _createClass2(Marker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var markerOptions = Object.assign(Object.assign(Object.assign({}, this.props.options || defaultOptions$5), this.props.clusterer ? defaultOptions$5 : {
        map: this.context
      }), {
        position: this.props.position
      });
      // Unfortunately we can't just do this in the contstructor, because the
      // `MapContext` might not be filled in yet.
      this.marker = new google.maps.Marker(markerOptions);
      if (this.props.clusterer) {
        this.props.clusterer.addMarker(this.marker, !!this.props.noClustererRedraw);
      } else {
        this.marker.setMap(this.context);
      }
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: {},
        nextProps: this.props,
        instance: this.marker
      });
      if (this.props.onLoad) {
        this.props.onLoad(this.marker);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.marker) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$f,
          eventMap: eventMap$f,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.marker
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.marker) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.marker);
        }
        unregisterEvents(this.registeredEvents);
        if (this.props.clusterer) {
          this.props.clusterer.removeMarker(this.marker, !!this.props.noClustererRedraw);
        } else {
          this.marker && this.marker.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this18 = this;
      var children = null;
      if (this.props.children) {
        children = React.Children.map(this.props.children, function (child) {
          if (!React.isValidElement(child)) {
            return child;
          }
          var elementChild = child;
          return React.cloneElement(elementChild, {
            anchor: _this18.marker
          });
        });
      }
      return children || null;
    }
  }]);
  return Marker;
}(React.PureComponent);
Marker.contextType = MapContext;
var ClusterIcon = /** @class */function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.clusterClassName = this.cluster.getClusterer().getClusterClass();
    this.className = this.clusterClassName;
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0';
    this.cMouseDownInCluster = null;
    this.cDraggingMapByCluster = null;
    this.timeOut = null;
    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
    this.onBoundsChanged = this.onBoundsChanged.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.draw = this.draw.bind(this);
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.useStyle = this.useStyle.bind(this);
    this.setCenter = this.setCenter.bind(this);
    this.getPosFromLatLng = this.getPosFromLatLng.bind(this);
  }
  ClusterIcon.prototype.onBoundsChanged = function () {
    this.cDraggingMapByCluster = this.cMouseDownInCluster;
  };
  ClusterIcon.prototype.onMouseDown = function () {
    this.cMouseDownInCluster = true;
    this.cDraggingMapByCluster = false;
  };
  ClusterIcon.prototype.onClick = function (event) {
    this.cMouseDownInCluster = false;
    if (!this.cDraggingMapByCluster) {
      var markerClusterer_1 = this.cluster.getClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(markerClusterer_1, 'click', this.cluster);
      google.maps.event.trigger(markerClusterer_1, 'clusterclick', this.cluster); // deprecated name
      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (markerClusterer_1.getZoomOnClick()) {
        // Zoom into the cluster.
        var maxZoom_1 = markerClusterer_1.getMaxZoom();
        var bounds_1 = this.cluster.getBounds();
        var map = markerClusterer_1.getMap();
        if (map !== null && 'fitBounds' in map) {
          map.fitBounds(bounds_1);
        }
        // There is a fix for Issue 170 here:
        this.timeOut = window.setTimeout(function () {
          var map = markerClusterer_1.getMap();
          if (map !== null) {
            if ('fitBounds' in map) {
              map.fitBounds(bounds_1);
            }
            var zoom = map.getZoom() || 0;
            // Don't zoom beyond the max zoom level
            if (maxZoom_1 !== null && zoom > maxZoom_1) {
              map.setZoom(maxZoom_1 + 1);
            }
          }
        }, 100);
      }
      // Prevent event propagation to the map:
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    }
  };
  ClusterIcon.prototype.onMouseOver = function () {
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseover', this.cluster);
  };
  ClusterIcon.prototype.onMouseOut = function () {
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(this.cluster.getClusterer(), 'mouseout', this.cluster);
  };
  ClusterIcon.prototype.onAdd = function () {
    var _a;
    this.div = document.createElement('div');
    this.div.className = this.className;
    if (this.visible) {
      this.show();
    }
    (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a.overlayMouseTarget.appendChild(this.div);
    var map = this.getMap();
    if (map !== null) {
      // Fix for Issue 157
      this.boundsChangedListener = google.maps.event.addListener(map, 'bounds_changed', this.onBoundsChanged);
      this.div.addEventListener('mousedown', this.onMouseDown);
      this.div.addEventListener('click', this.onClick);
      this.div.addEventListener('mouseover', this.onMouseOver);
      this.div.addEventListener('mouseout', this.onMouseOut);
    }
  };
  ClusterIcon.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.hide();
      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }
      this.div.removeEventListener('mousedown', this.onMouseDown);
      this.div.removeEventListener('click', this.onClick);
      this.div.removeEventListener('mouseover', this.onMouseOver);
      this.div.removeEventListener('mouseout', this.onMouseOut);
      this.div.parentNode.removeChild(this.div);
      if (this.timeOut !== null) {
        window.clearTimeout(this.timeOut);
        this.timeOut = null;
      }
      this.div = null;
    }
  };
  ClusterIcon.prototype.draw = function () {
    if (this.visible && this.div !== null && this.center) {
      var pos = this.getPosFromLatLng(this.center);
      this.div.style.top = pos !== null ? "".concat(pos.y, "px") : '0';
      this.div.style.left = pos !== null ? "".concat(pos.x, "px") : '0';
    }
  };
  ClusterIcon.prototype.hide = function () {
    if (this.div) {
      this.div.style.display = 'none';
    }
    this.visible = false;
  };
  ClusterIcon.prototype.show = function () {
    var _a, _b, _c, _d;
    if (this.div && this.center) {
      var divTitle = this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '' ? this.cluster.getClusterer().getTitle() : this.sums.title;
      // NOTE: values must be specified in px units
      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ''), 10);
      var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ''), 10);
      var pos = this.getPosFromLatLng(this.center);
      this.div.className = this.className;
      this.div.setAttribute('style', "cursor: pointer; position: absolute; top: ".concat(pos !== null ? "".concat(pos.y, "px") : '0', "; left: ").concat(pos !== null ? "".concat(pos.x, "px") : '0', "; width: ").concat(this.width, "px; height: ").concat(this.height, "px; "));
      var img = document.createElement('img');
      img.alt = divTitle;
      img.src = this.url;
      img.width = this.width;
      img.height = this.height;
      img.setAttribute('style', "position: absolute; top: ".concat(spriteV, "px; left: ").concat(spriteH, "px"));
      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img.style.clip = "rect(-".concat(spriteV, "px, -").concat(spriteH + this.width, "px, -").concat(spriteV + this.height, ", -").concat(spriteH, ")");
      }
      var textElm = document.createElement('div');
      textElm.setAttribute('style', "position: absolute; top: ".concat(this.anchorText[0], "px; left: ").concat(this.anchorText[1], "px; color: ").concat(this.textColor, "; font-size: ").concat(this.textSize, "px; font-family: ").concat(this.fontFamily, "; font-weight: ").concat(this.fontWeight, "; fontStyle: ").concat(this.fontStyle, "; text-decoration: ").concat(this.textDecoration, "; text-align: center; width: ").concat(this.width, "px; line-height: ").concat(this.height, "px"));
      if ((_a = this.sums) === null || _a === void 0 ? void 0 : _a.text) textElm.innerText = "".concat((_b = this.sums) === null || _b === void 0 ? void 0 : _b.text);
      if ((_c = this.sums) === null || _c === void 0 ? void 0 : _c.html) textElm.innerHTML = "".concat((_d = this.sums) === null || _d === void 0 ? void 0 : _d.html);
      this.div.innerHTML = '';
      this.div.appendChild(img);
      this.div.appendChild(textElm);
      this.div.title = divTitle;
      this.div.style.display = '';
    }
    this.visible = true;
  };
  ClusterIcon.prototype.useStyle = function (sums) {
    this.sums = sums;
    var styles = this.cluster.getClusterer().getStyles();
    var style = styles[Math.min(styles.length - 1, Math.max(0, sums.index - 1))];
    this.url = style.url;
    this.height = style.height;
    this.width = style.width;
    if (style.className) this.className = "".concat(this.clusterClassName, " ").concat(style.className);
    this.anchorText = style.anchorText || [0, 0];
    this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
    this.textColor = style.textColor || 'black';
    this.textSize = style.textSize || 11;
    this.textDecoration = style.textDecoration || 'none';
    this.fontWeight = style.fontWeight || 'bold';
    this.fontStyle = style.fontStyle || 'normal';
    this.fontFamily = style.fontFamily || 'Arial,sans-serif';
    this.backgroundPosition = style.backgroundPosition || '0 0';
  };
  ClusterIcon.prototype.setCenter = function (center) {
    this.center = center;
  };
  ClusterIcon.prototype.getPosFromLatLng = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    if (pos !== null) {
      pos.x -= this.anchorIcon[1];
      pos.y -= this.anchorIcon[0];
    }
    return pos;
  };
  return ClusterIcon;
}();
var Cluster$1 = /** @class */function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer;
    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
    this.getSize = this.getSize.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.getMap = this.getMap.bind(this);
    this.getClusterer = this.getClusterer.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.remove = this.remove.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.isMarkerInClusterBounds = this.isMarkerInClusterBounds.bind(this);
    this.calculateBounds = this.calculateBounds.bind(this);
    this.updateIcon = this.updateIcon.bind(this);
    this.isMarkerAlreadyAdded = this.isMarkerAlreadyAdded.bind(this);
  }
  Cluster.prototype.getSize = function () {
    return this.markers.length;
  };
  Cluster.prototype.getMarkers = function () {
    return this.markers;
  };
  Cluster.prototype.getCenter = function () {
    return this.center;
  };
  Cluster.prototype.getMap = function () {
    return this.map;
  };
  Cluster.prototype.getClusterer = function () {
    return this.markerClusterer;
  };
  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();
    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    return bounds;
  };
  Cluster.prototype.remove = function () {
    this.clusterIcon.setMap(null);
    this.markers = [];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete this.markers;
  };
  Cluster.prototype.addMarker = function (marker) {
    var _a;
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }
    if (!this.center) {
      var position = marker.getPosition();
      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var position = marker.getPosition();
        if (position) {
          var length_1 = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length_1 - 1) + position.lat()) / length_1, (this.center.lng() * (length_1 - 1) + position.lng()) / length_1);
          this.calculateBounds();
        }
      }
    }
    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var i = 0; i < mCount; i++) {
        this.markers[i].setMap(null);
      }
    } else {
      marker.setMap(null);
    }
    return true;
  };
  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();
      if (position) {
        return this.bounds.contains(position);
      }
    }
    return false;
  };
  Cluster.prototype.calculateBounds = function () {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };
  Cluster.prototype.updateIcon = function () {
    var _a;
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();
    var zoom = (_a = this.map) === null || _a === void 0 ? void 0 : _a.getZoom();
    if (maxZoom !== null && typeof zoom !== 'undefined' && zoom > maxZoom) {
      this.clusterIcon.hide();
      return;
    }
    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }
    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }
    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };
  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers.includes) {
      return this.markers.includes(marker);
    }
    for (var i = 0; i < this.markers.length; i++) {
      if (marker === this.markers[i]) {
        return true;
      }
    }
    return false;
  };
  return Cluster;
}();

/* global google */
/**
 * Supports up to 9007199254740991 (Number.MAX_SAFE_INTEGER) markers
 * which is not a problem as max array length is 4294967296 (2**32)
 */
function CALCULATOR(markers, numStyles) {
  var count = markers.length;
  var numberOfDigits = count.toString().length;
  var index = Math.min(numberOfDigits, numStyles);
  return {
    text: count.toString(),
    index: index,
    title: ''
  };
}
var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';
var Clusterer = /** @class */function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }
    if (optOptions === void 0) {
      optOptions = {};
    }
    this.getMinimumClusterSize = this.getMinimumClusterSize.bind(this);
    this.setMinimumClusterSize = this.setMinimumClusterSize.bind(this);
    this.getEnableRetinaIcons = this.getEnableRetinaIcons.bind(this);
    this.setEnableRetinaIcons = this.setEnableRetinaIcons.bind(this);
    this.addToClosestCluster = this.addToClosestCluster.bind(this);
    this.getImageExtension = this.getImageExtension.bind(this);
    this.setImageExtension = this.setImageExtension.bind(this);
    this.getExtendedBounds = this.getExtendedBounds.bind(this);
    this.getAverageCenter = this.getAverageCenter.bind(this);
    this.setAverageCenter = this.setAverageCenter.bind(this);
    this.getTotalClusters = this.getTotalClusters.bind(this);
    this.fitMapToMarkers = this.fitMapToMarkers.bind(this);
    this.getIgnoreHidden = this.getIgnoreHidden.bind(this);
    this.setIgnoreHidden = this.setIgnoreHidden.bind(this);
    this.getClusterClass = this.getClusterClass.bind(this);
    this.setClusterClass = this.setClusterClass.bind(this);
    this.getTotalMarkers = this.getTotalMarkers.bind(this);
    this.getZoomOnClick = this.getZoomOnClick.bind(this);
    this.setZoomOnClick = this.setZoomOnClick.bind(this);
    this.getBatchSizeIE = this.getBatchSizeIE.bind(this);
    this.setBatchSizeIE = this.setBatchSizeIE.bind(this);
    this.createClusters = this.createClusters.bind(this);
    this.onZoomChanged = this.onZoomChanged.bind(this);
    this.getImageSizes = this.getImageSizes.bind(this);
    this.setImageSizes = this.setImageSizes.bind(this);
    this.getCalculator = this.getCalculator.bind(this);
    this.setCalculator = this.setCalculator.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this);
    this.resetViewport = this.resetViewport.bind(this);
    this.getImagePath = this.getImagePath.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.pushMarkerTo = this.pushMarkerTo.bind(this);
    this.removeMarker = this.removeMarker.bind(this);
    this.clearMarkers = this.clearMarkers.bind(this);
    this.setupStyles = this.setupStyles.bind(this);
    this.getGridSize = this.getGridSize.bind(this);
    this.setGridSize = this.setGridSize.bind(this);
    this.getClusters = this.getClusters.bind(this);
    this.getMaxZoom = this.getMaxZoom.bind(this);
    this.setMaxZoom = this.setMaxZoom.bind(this);
    this.getMarkers = this.getMarkers.bind(this);
    this.addMarkers = this.addMarkers.bind(this);
    this.getStyles = this.getStyles.bind(this);
    this.setStyles = this.setStyles.bind(this);
    this.addMarker = this.addMarker.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.repaint = this.repaint.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.redraw = this.redraw.bind(this);
    this.extend = this.extend.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.draw = this.draw.bind(this);
    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;
    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }
    this.averageCenter = false;
    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }
    this.ignoreHidden = false;
    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }
    this.enableRetinaIcons = false;
    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }
    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;
    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }
    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true);
    this.setMap(map); // Note: this causes onAdd to be called
  }

  Clusterer.prototype.onZoomChanged = function () {
    var _a, _b;
    this.resetViewport(false);
    // Workaround for this Google bug: when map is at level 0 and "-" of
    // zoom slider is clicked, a "zoom_changed" event is fired even though
    // the map doesn't zoom out any further. In this situation, no "idle"
    // event is triggered so the cluster markers that have been removed
    // do not get redrawn. Same goes for a zoom in at maxZoom.
    if (((_a = this.getMap()) === null || _a === void 0 ? void 0 : _a.getZoom()) === (this.get('minZoom') || 0) || ((_b = this.getMap()) === null || _b === void 0 ? void 0 : _b.getZoom()) === this.get('maxZoom')) {
      google.maps.event.trigger(this, 'idle');
    }
  };
  Clusterer.prototype.onIdle = function () {
    this.redraw();
  };
  Clusterer.prototype.onAdd = function () {
    var map = this.getMap();
    this.activeMap = map;
    this.ready = true;
    this.repaint();
    if (map !== null) {
      // Add the map event listeners
      this.listeners = [google.maps.event.addListener(map, 'zoom_changed', this.onZoomChanged), google.maps.event.addListener(map, 'idle', this.onIdle)];
    }
  };
  Clusterer.prototype.onRemove = function () {
    // Put all the managed markers back on the map:
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i].getMap() !== this.activeMap) {
        this.markers[i].setMap(this.activeMap);
      }
    }
    // Remove all clusters:
    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }
    this.clusters = [];
    // Remove map event listeners:
    for (var i = 0; i < this.listeners.length; i++) {
      google.maps.event.removeListener(this.listeners[i]);
    }
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  };
  Clusterer.prototype.draw = function () {
    return;
  };
  Clusterer.prototype.setupStyles = function () {
    if (this.styles.length > 0) {
      return;
    }
    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: "".concat(this.imagePath + (i + 1), ".").concat(this.imageExtension),
        height: this.imageSizes[i],
        width: this.imageSizes[i]
      });
    }
  };
  Clusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();
      if (position) {
        bounds.extend(position);
      }
    }
    var map = this.getMap();
    if (map !== null && 'fitBounds' in map) {
      map.fitBounds(bounds);
    }
  };
  Clusterer.prototype.getGridSize = function () {
    return this.gridSize;
  };
  Clusterer.prototype.setGridSize = function (gridSize) {
    this.gridSize = gridSize;
  };
  Clusterer.prototype.getMinimumClusterSize = function () {
    return this.minClusterSize;
  };
  Clusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };
  Clusterer.prototype.getMaxZoom = function () {
    return this.maxZoom;
  };
  Clusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom = maxZoom;
  };
  Clusterer.prototype.getStyles = function () {
    return this.styles;
  };
  Clusterer.prototype.setStyles = function (styles) {
    this.styles = styles;
  };
  Clusterer.prototype.getTitle = function () {
    return this.title;
  };
  Clusterer.prototype.setTitle = function (title) {
    this.title = title;
  };
  Clusterer.prototype.getZoomOnClick = function () {
    return this.zoomOnClick;
  };
  Clusterer.prototype.setZoomOnClick = function (zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };
  Clusterer.prototype.getAverageCenter = function () {
    return this.averageCenter;
  };
  Clusterer.prototype.setAverageCenter = function (averageCenter) {
    this.averageCenter = averageCenter;
  };
  Clusterer.prototype.getIgnoreHidden = function () {
    return this.ignoreHidden;
  };
  Clusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };
  Clusterer.prototype.getEnableRetinaIcons = function () {
    return this.enableRetinaIcons;
  };
  Clusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };
  Clusterer.prototype.getImageExtension = function () {
    return this.imageExtension;
  };
  Clusterer.prototype.setImageExtension = function (imageExtension) {
    this.imageExtension = imageExtension;
  };
  Clusterer.prototype.getImagePath = function () {
    return this.imagePath;
  };
  Clusterer.prototype.setImagePath = function (imagePath) {
    this.imagePath = imagePath;
  };
  Clusterer.prototype.getImageSizes = function () {
    return this.imageSizes;
  };
  Clusterer.prototype.setImageSizes = function (imageSizes) {
    this.imageSizes = imageSizes;
  };
  Clusterer.prototype.getCalculator = function () {
    return this.calculator;
  };
  Clusterer.prototype.setCalculator = function (calculator) {
    this.calculator = calculator;
  };
  Clusterer.prototype.getBatchSizeIE = function () {
    return this.batchSizeIE;
  };
  Clusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };
  Clusterer.prototype.getClusterClass = function () {
    return this.clusterClass;
  };
  Clusterer.prototype.setClusterClass = function (clusterClass) {
    this.clusterClass = clusterClass;
  };
  Clusterer.prototype.getMarkers = function () {
    return this.markers;
  };
  Clusterer.prototype.getTotalMarkers = function () {
    return this.markers.length;
  };
  Clusterer.prototype.getClusters = function () {
    return this.clusters;
  };
  Clusterer.prototype.getTotalClusters = function () {
    return this.clusters.length;
  };
  Clusterer.prototype.addMarker = function (marker, optNoDraw) {
    this.pushMarkerTo(marker);
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.addMarkers = function (markers, optNoDraw) {
    for (var key in markers) {
      if (Object.prototype.hasOwnProperty.call(markers, key)) {
        this.pushMarkerTo(markers[key]);
      }
    }
    if (!optNoDraw) {
      this.redraw();
    }
  };
  Clusterer.prototype.pushMarkerTo = function (marker) {
    var _this = this;
    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this.ready) {
          marker.isAdded = false;
          _this.repaint();
        }
      });
    }
    marker.isAdded = false;
    this.markers.push(marker);
  };
  Clusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }
    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }
    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers
    return true;
  };
  Clusterer.prototype.removeMarker = function (marker, optNoDraw) {
    var removed = this.removeMarker_(marker);
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.removeMarkers = function (markers, optNoDraw) {
    var removed = false;
    for (var i = 0; i < markers.length; i++) {
      removed = removed || this.removeMarker_(markers[i]);
    }
    if (!optNoDraw && removed) {
      this.repaint();
    }
    return removed;
  };
  Clusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers = [];
  };
  Clusterer.prototype.repaint = function () {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw();
    // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.
    setTimeout(function timeout() {
      for (var i = 0; i < oldClusters.length; i++) {
        oldClusters[i].remove();
      }
    }, 0);
  };
  Clusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();
    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
    if (trPix !== null) {
      trPix.x += this.gridSize;
      trPix.y -= this.gridSize;
    }
    var blPix = projection.fromLatLngToDivPixel(
    // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
    if (blPix !== null) {
      blPix.x -= this.gridSize;
      blPix.y += this.gridSize;
    }
    // Extend the bounds to contain the new bounds.
    if (trPix !== null) {
      // Convert the pixel points back to LatLng nw
      var point1 = projection.fromDivPixelToLatLng(trPix);
      if (point1 !== null) {
        bounds.extend(point1);
      }
    }
    if (blPix !== null) {
      // Convert the pixel points back to LatLng sw
      var point2 = projection.fromDivPixelToLatLng(blPix);
      if (point2 !== null) {
        bounds.extend(point2);
      }
    }
    return bounds;
  };
  Clusterer.prototype.redraw = function () {
    // Redraws all the clusters.
    this.createClusters(0);
  };
  Clusterer.prototype.resetViewport = function (optHide) {
    // Remove all the clusters
    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }
    this.clusters = [];
    // Reset the markers to not be added and to be removed from the map.
    for (var i = 0; i < this.markers.length; i++) {
      var marker = this.markers[i];
      marker.isAdded = false;
      if (optHide) {
        marker.setMap(null);
      }
    }
  };
  Clusterer.prototype.distanceBetweenPoints = function (p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };
  Clusterer.prototype.isMarkerInBounds = function (marker, bounds) {
    var position = marker.getPosition();
    if (position) {
      return bounds.contains(position);
    }
    return false;
  };
  Clusterer.prototype.addToClosestCluster = function (marker) {
    var cluster;
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    for (var i = 0; i < this.clusters.length; i++) {
      cluster = this.clusters[i];
      var center = cluster.getCenter();
      var position = marker.getPosition();
      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);
        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }
    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster$1(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };
  Clusterer.prototype.createClusters = function (iFirst) {
    var _this = this;
    if (!this.ready) {
      return;
    }
    // Cancel previous batch processing if we're working on the first batch:
    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);
      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        delete this.timerRefStatic;
      }
    }
    var map = this.getMap();
    var bounds = map !== null && 'getBounds' in map ? map.getBounds() : null;
    var zoom = (map === null || map === void 0 ? void 0 : map.getZoom()) || 0;
    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
    var mapBounds = zoom > 3 ? new google.maps.LatLngBounds(bounds === null || bounds === void 0 ? void 0 : bounds.getSouthWest(), bounds === null || bounds === void 0 ? void 0 : bounds.getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var extendedMapBounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);
    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];
      if (!marker.isAdded && this.isMarkerInBounds(marker, extendedMapBounds) && (!this.ignoreHidden || this.ignoreHidden && marker.getVisible())) {
        this.addToClosestCluster(marker);
      }
    }
    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout(function () {
        _this.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringend', this);
      for (var i = 0; i < this.clusters.length; i++) {
        this.clusters[i].updateIcon();
      }
    }
  };
  Clusterer.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        // @ts-ignore
        this.prototype[property] = object.prototype[property];
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return Clusterer;
}();
var eventMap$e = {
  onClick: 'click',
  onClusteringBegin: 'clusteringbegin',
  onClusteringEnd: 'clusteringend',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover'
};
var updaterMap$e = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter);
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE);
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator);
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass);
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons);
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize);
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden);
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension);
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath);
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes);
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom);
  },
  minimumClusterSize: function minimumClusterSize(instance, _minimumClusterSize) {
    instance.setMinimumClusterSize(_minimumClusterSize);
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles);
  },
  title: function title(instance, _title2) {
    instance.setTitle(_title2);
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick);
  }
};
var defaultOptions$4 = {};
function MarkerClustererFunctional(props) {
  var children = props.children,
    options = props.options,
    averageCenter = props.averageCenter,
    batchSizeIE = props.batchSizeIE,
    calculator = props.calculator,
    clusterClass = props.clusterClass,
    enableRetinaIcons = props.enableRetinaIcons,
    gridSize = props.gridSize,
    ignoreHidden = props.ignoreHidden,
    imageExtension = props.imageExtension,
    imagePath = props.imagePath,
    imageSizes = props.imageSizes,
    maxZoom = props.maxZoom,
    minimumClusterSize = props.minimumClusterSize,
    styles = props.styles,
    title = props.title,
    zoomOnClick = props.zoomOnClick,
    onClick = props.onClick,
    onClusteringBegin = props.onClusteringBegin,
    onClusteringEnd = props.onClusteringEnd,
    onMouseOver = props.onMouseOver,
    onMouseOut = props.onMouseOut,
    onLoad = props.onLoad,
    onUnmount = props.onUnmount;
  var _React$useState100 = React.useState(null),
    _React$useState101 = _slicedToArray2(_React$useState100, 2),
    instance = _React$useState101[0],
    setInstance = _React$useState101[1];
  var map = React.useContext(MapContext);
  var _React$useState102 = React.useState(null),
    _React$useState103 = _slicedToArray2(_React$useState102, 2),
    clickListener = _React$useState103[0],
    setClickListener = _React$useState103[1];
  var _React$useState104 = React.useState(null),
    _React$useState105 = _slicedToArray2(_React$useState104, 2),
    clusteringBeginListener = _React$useState105[0],
    setClusteringBeginListener = _React$useState105[1];
  var _React$useState106 = React.useState(null),
    _React$useState107 = _slicedToArray2(_React$useState106, 2),
    clusteringEndListener = _React$useState107[0],
    setClusteringEndListener = _React$useState107[1];
  var _React$useState108 = React.useState(null),
    _React$useState109 = _slicedToArray2(_React$useState108, 2),
    mouseoutListener = _React$useState109[0],
    setMouseoutListener = _React$useState109[1];
  var _React$useState110 = React.useState(null),
    _React$useState111 = _slicedToArray2(_React$useState110, 2),
    mouseoverListener = _React$useState111[0],
    setMouseoverListener = _React$useState111[1];
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, eventMap$e.onMouseOut, onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, eventMap$e.onMouseOver, onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, eventMap$e.onClick, onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onClusteringBegin) {
      if (clusteringBeginListener !== null) {
        google.maps.event.removeListener(clusteringBeginListener);
      }
      setClusteringBeginListener(google.maps.event.addListener(instance, eventMap$e.onClusteringBegin, onClusteringBegin));
    }
  }, [onClusteringBegin]);
  React.useEffect(function () {
    if (instance && onClusteringEnd) {
      if (clusteringEndListener !== null) {
        google.maps.event.removeListener(clusteringEndListener);
      }
      setClusteringBeginListener(google.maps.event.addListener(instance, eventMap$e.onClusteringEnd, onClusteringEnd));
    }
  }, [onClusteringEnd]);
  React.useEffect(function () {
    if (typeof averageCenter !== 'undefined' && instance !== null) {
      updaterMap$e.averageCenter(instance, averageCenter);
    }
  }, [instance, averageCenter]);
  React.useEffect(function () {
    if (typeof batchSizeIE !== 'undefined' && instance !== null) {
      updaterMap$e.batchSizeIE(instance, batchSizeIE);
    }
  }, [instance, batchSizeIE]);
  React.useEffect(function () {
    if (typeof calculator !== 'undefined' && instance !== null) {
      updaterMap$e.calculator(instance, calculator);
    }
  }, [instance, calculator]);
  React.useEffect(function () {
    if (typeof clusterClass !== 'undefined' && instance !== null) {
      updaterMap$e.clusterClass(instance, clusterClass);
    }
  }, [instance, clusterClass]);
  React.useEffect(function () {
    if (typeof enableRetinaIcons !== 'undefined' && instance !== null) {
      updaterMap$e.enableRetinaIcons(instance, enableRetinaIcons);
    }
  }, [instance, enableRetinaIcons]);
  React.useEffect(function () {
    if (typeof gridSize !== 'undefined' && instance !== null) {
      updaterMap$e.gridSize(instance, gridSize);
    }
  }, [instance, gridSize]);
  React.useEffect(function () {
    if (typeof ignoreHidden !== 'undefined' && instance !== null) {
      updaterMap$e.ignoreHidden(instance, ignoreHidden);
    }
  }, [instance, ignoreHidden]);
  React.useEffect(function () {
    if (typeof imageExtension !== 'undefined' && instance !== null) {
      updaterMap$e.imageExtension(instance, imageExtension);
    }
  }, [instance, imageExtension]);
  React.useEffect(function () {
    if (typeof imagePath !== 'undefined' && instance !== null) {
      updaterMap$e.imagePath(instance, imagePath);
    }
  }, [instance, imagePath]);
  React.useEffect(function () {
    if (typeof imageSizes !== 'undefined' && instance !== null) {
      updaterMap$e.imageSizes(instance, imageSizes);
    }
  }, [instance, imageSizes]);
  React.useEffect(function () {
    if (typeof maxZoom !== 'undefined' && instance !== null) {
      updaterMap$e.maxZoom(instance, maxZoom);
    }
  }, [instance, maxZoom]);
  React.useEffect(function () {
    if (typeof minimumClusterSize !== 'undefined' && instance !== null) {
      updaterMap$e.minimumClusterSize(instance, minimumClusterSize);
    }
  }, [instance, minimumClusterSize]);
  React.useEffect(function () {
    if (typeof styles !== 'undefined' && instance !== null) {
      updaterMap$e.styles(instance, styles);
    }
  }, [instance, styles]);
  React.useEffect(function () {
    if (typeof title !== 'undefined' && instance !== null) {
      updaterMap$e.title(instance, title);
    }
  }, [instance, title]);
  React.useEffect(function () {
    if (typeof zoomOnClick !== 'undefined' && instance !== null) {
      updaterMap$e.zoomOnClick(instance, zoomOnClick);
    }
  }, [instance, zoomOnClick]);
  React.useEffect(function () {
    if (!map) return;
    var clustererOptions = Object.assign({}, options || defaultOptions$4);
    var clusterer = new Clusterer(map, [], clustererOptions);
    if (averageCenter) {
      updaterMap$e.averageCenter(clusterer, averageCenter);
    }
    if (batchSizeIE) {
      updaterMap$e.batchSizeIE(clusterer, batchSizeIE);
    }
    if (calculator) {
      updaterMap$e.calculator(clusterer, calculator);
    }
    if (clusterClass) {
      updaterMap$e.clusterClass(clusterer, clusterClass);
    }
    if (enableRetinaIcons) {
      updaterMap$e.enableRetinaIcons(clusterer, enableRetinaIcons);
    }
    if (gridSize) {
      updaterMap$e.gridSize(clusterer, gridSize);
    }
    if (ignoreHidden) {
      updaterMap$e.ignoreHidden(clusterer, ignoreHidden);
    }
    if (imageExtension) {
      updaterMap$e.imageExtension(clusterer, imageExtension);
    }
    if (imagePath) {
      updaterMap$e.imagePath(clusterer, imagePath);
    }
    if (imageSizes) {
      updaterMap$e.imageSizes(clusterer, imageSizes);
    }
    if (maxZoom) {
      updaterMap$e.maxZoom(clusterer, maxZoom);
    }
    if (minimumClusterSize) {
      updaterMap$e.minimumClusterSize(clusterer, minimumClusterSize);
    }
    if (styles) {
      updaterMap$e.styles(clusterer, styles);
    }
    if (title) {
      updaterMap$e.title(clusterer, title);
    }
    if (zoomOnClick) {
      updaterMap$e.zoomOnClick(clusterer, zoomOnClick);
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(clusterer, eventMap$e.onMouseOut, onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(clusterer, eventMap$e.onMouseOver, onMouseOver));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(clusterer, eventMap$e.onClick, onClick));
    }
    if (onClusteringBegin) {
      setClusteringBeginListener(google.maps.event.addListener(clusterer, eventMap$e.onClusteringBegin, onClusteringBegin));
    }
    if (onClusteringEnd) {
      setClusteringEndListener(google.maps.event.addListener(clusterer, eventMap$e.onClusteringEnd, onClusteringEnd));
    }
    setInstance(clusterer);
    if (onLoad) {
      onLoad(clusterer);
    }
    return function () {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (clusteringBeginListener !== null) {
        google.maps.event.removeListener(clusteringBeginListener);
      }
      if (clusteringEndListener !== null) {
        google.maps.event.removeListener(clusteringEndListener);
      }
      if (onUnmount) {
        onUnmount(clusterer);
      }
    };
  }, []);
  return instance !== null ? children(instance) || null : null;
}
React.memo(MarkerClustererFunctional);
var ClustererComponent = /*#__PURE__*/function (_React$PureComponent8) {
  _inherits2(ClustererComponent, _React$PureComponent8);
  var _super9 = _createSuper2(ClustererComponent);
  function ClustererComponent() {
    var _this19;
    _classCallCheck2(this, ClustererComponent);
    _this19 = _super9.apply(this, arguments);
    _this19.registeredEvents = [];
    _this19.state = {
      markerClusterer: null
    };
    _this19.setClustererCallback = function () {
      if (_this19.state.markerClusterer !== null && _this19.props.onLoad) {
        _this19.props.onLoad(_this19.state.markerClusterer);
      }
    };
    return _this19;
  }
  _createClass2(ClustererComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context) {
        var markerClusterer = new Clusterer(this.context, [], this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: {},
          nextProps: this.props,
          instance: markerClusterer
        });
        this.setState(function () {
          return {
            markerClusterer: markerClusterer
          };
        }, this.setClustererCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.markerClusterer) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$e,
          eventMap: eventMap$e,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.markerClusterer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.markerClusterer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.markerClusterer);
        }
        unregisterEvents(this.registeredEvents);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.state.markerClusterer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
    }
  }]);
  return ClustererComponent;
}(React.PureComponent);
ClustererComponent.contextType = MapContext;

// This handler prevents an event in the InfoBox from being passed on to the map.
function cancelHandler(event) {
  event.cancelBubble = true;
  if (event.stopPropagation) {
    event.stopPropagation();
  }
}
var InfoBox = /** @class */function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }
    this.getCloseClickHandler = this.getCloseClickHandler.bind(this);
    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.createInfoBoxDiv = this.createInfoBoxDiv.bind(this);
    this.addClickHandler = this.addClickHandler.bind(this);
    this.getCloseBoxImg = this.getCloseBoxImg.bind(this);
    this.getBoxWidths = this.getBoxWidths.bind(this);
    this.setBoxStyle = this.setBoxStyle.bind(this);
    this.setPosition = this.setPosition.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.setOptions = this.setOptions.bind(this);
    this.setContent = this.setContent.bind(this);
    this.setVisible = this.setVisible.bind(this);
    this.getContent = this.getContent.bind(this);
    this.getVisible = this.getVisible.bind(this);
    this.setZIndex = this.setZIndex.bind(this);
    this.getZIndex = this.getZIndex.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.panBox = this.panBox.bind(this);
    this.extend = this.extend.bind(this);
    this.close = this.close.bind(this);
    this.draw = this.draw.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.open = this.open.bind(this);
    this.extend(InfoBox, google.maps.OverlayView);
    // Standard options (in common with google.maps.InfoWindow):
    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null;
    // Additional options (unique to InfoBox):
    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';
    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }
    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);
    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }
    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }
  InfoBox.prototype.createInfoBoxDiv = function () {
    var _this = this;
    // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.
    var ignoreHandler = function ignoreHandler(event) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };
    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();
      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      }
      var panes = this.getPanes();
      if (panes !== null) {
        panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM
      }

      this.addClickHandler();
      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }
      this.panBox(this.disableAutoPan);
      if (!this.enableEventPropagation) {
        this.eventListeners = [];
        // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)
        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];
        for (var i = 0; i < events.length; i++) {
          this.eventListeners.push(google.maps.event.addListener(this.div, events[i], cancelHandler));
        }
        // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.
        this.eventListeners.push(google.maps.event.addListener(this.div, 'mouseover', function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }
      this.contextListener = google.maps.event.addListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */
      google.maps.event.trigger(this, 'domready');
    }
  };
  InfoBox.prototype.getCloseBoxImg = function () {
    var img = '';
    if (this.closeBoxURL !== '') {
      img = '<img alt=""';
      img += ' aria-hidden="true"';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'
      img += " style='";
      img += ' position: relative;'; // Required by MSIE
      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }
    return img;
  };
  InfoBox.prototype.addClickHandler = function () {
    this.closeListener = this.div && this.div.firstChild && this.closeBoxURL !== '' ? google.maps.event.addListener(this.div.firstChild, 'click', this.getCloseClickHandler()) : null;
  };
  InfoBox.prototype.closeClickHandler = function (event) {
    // 1.0.3 fix: Always prevent propagation of a close box click to the map:
    event.cancelBubble = true;
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    /**
     * This event is fired when the InfoBox's close box is clicked.
     * @name InfoBox#closeclick
     * @event
     */
    google.maps.event.trigger(this, 'closeclick');
    this.close();
  };
  InfoBox.prototype.getCloseClickHandler = function () {
    return this.closeClickHandler;
  };
  InfoBox.prototype.panBox = function (disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var map = this.getMap();
      // Only pan if attached to map, not panorama
      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();
        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }
        var mapDiv = map.getDiv();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapWidth = mapDiv.offsetWidth;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);
        if (pixPosition !== null) {
          if (pixPosition.x < -iwOffsetX + padX) {
            xOffset = pixPosition.x + iwOffsetX - padX;
          } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
            xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
          }
          if (this.alignBottom) {
            if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
              yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
            } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
            }
          } else {
            if (pixPosition.y < -iwOffsetY + padY) {
              yOffset = pixPosition.y + iwOffsetY - padY;
            } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
              yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
            }
          }
        }
        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };
  InfoBox.prototype.setBoxStyle = function () {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass;
      // Clear existing inline style values:
      this.div.style.cssText = '';
      // Apply style values defined in the boxStyle parameter:
      var boxStyle = this.boxStyle;
      for (var i in boxStyle) {
        if (Object.prototype.hasOwnProperty.call(boxStyle, i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      }
      // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad
      this.div.style.webkitTransform = 'translateZ(0)';
      // Fix up opacity style for benefit of MSIE
      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || '');
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      }
      // Apply required styles
      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';
      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }
      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };
  InfoBox.prototype.getBoxWidths = function () {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    if (!this.div) {
      return bw;
    }
    if (document.defaultView) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;
      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var currentStyle = this.div.currentStyle;
      if (currentStyle) {
        // The current styles may not be in pixel units, but assume they are (bad!)
        bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
      }
    }
    return bw;
  };
  InfoBox.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };
  InfoBox.prototype.draw = function () {
    this.createInfoBoxDiv();
    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);
      if (pixPosition !== null) {
        this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';
        if (this.alignBottom) {
          this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
        } else {
          this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
        }
      }
      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };
  InfoBox.prototype.setOptions = function (options) {
    if (options === void 0) {
      options = {};
    }
    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }
    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }
    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }
    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }
    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }
    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }
    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }
    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }
    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }
    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }
    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }
    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }
    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }
    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }
    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }
    if (this.div) {
      this.draw();
    }
  };
  InfoBox.prototype.setContent = function (content) {
    this.content = content;
    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      }
      // Odd code required to make things work with MSIE.
      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }
      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      }
      // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)
      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';
        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }
      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */
    google.maps.event.trigger(this, 'content_changed');
  };
  InfoBox.prototype.setPosition = function (latLng) {
    this.position = latLng;
    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */
    google.maps.event.trigger(this, 'position_changed');
  };
  InfoBox.prototype.setVisible = function (isVisible) {
    this.isHidden = !isVisible;
    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };
  InfoBox.prototype.setZIndex = function (index) {
    this.zIndex = index;
    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */
    google.maps.event.trigger(this, 'zindex_changed');
  };
  InfoBox.prototype.getContent = function () {
    return this.content;
  };
  InfoBox.prototype.getPosition = function () {
    return this.position;
  };
  InfoBox.prototype.getZIndex = function () {
    return this.zIndex;
  };
  InfoBox.prototype.getVisible = function () {
    var map = this.getMap();
    return typeof map === 'undefined' || map === null ? false : !this.isHidden;
  };
  InfoBox.prototype.show = function () {
    this.isHidden = false;
    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };
  InfoBox.prototype.hide = function () {
    this.isHidden = true;
    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };
  InfoBox.prototype.open = function (map, anchor) {
    var _this = this;
    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var position = anchor.getPosition();
        _this.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        _this.setMap(anchor.map);
      });
    }
    this.setMap(map);
    if (this.div) {
      this.panBox();
    }
  };
  InfoBox.prototype.close = function () {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }
    if (this.eventListeners) {
      for (var i = 0; i < this.eventListeners.length; i++) {
        google.maps.event.removeListener(this.eventListeners[i]);
      }
      this.eventListeners = null;
    }
    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }
    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.setMap(null);
  };
  InfoBox.prototype.extend = function (obj1, obj2) {
    return function applyExtend(object) {
      for (var property in object.prototype) {
        if (!Object.prototype.hasOwnProperty.call(this, property)) {
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  return InfoBox;
}();
var eventMap$d = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$d = {
  options: function options(instance, _options5) {
    instance.setOptions(_options5);
  },
  position: function position(instance, _position2) {
    if (_position2 instanceof google.maps.LatLng) {
      instance.setPosition(_position2);
    } else {
      instance.setPosition(new google.maps.LatLng(_position2.lat, _position2.lng));
    }
  },
  visible: function visible(instance, _visible2) {
    instance.setVisible(_visible2);
  },
  zIndex: function zIndex(instance, _zIndex2) {
    instance.setZIndex(_zIndex2);
  }
};
var defaultOptions$3 = {};
function InfoBoxFunctional(_ref18) {
  var children = _ref18.children,
    anchor = _ref18.anchor,
    options = _ref18.options,
    position = _ref18.position,
    zIndex = _ref18.zIndex,
    onCloseClick = _ref18.onCloseClick,
    onDomReady = _ref18.onDomReady,
    onContentChanged = _ref18.onContentChanged,
    onPositionChanged = _ref18.onPositionChanged,
    onZindexChanged = _ref18.onZindexChanged,
    onLoad = _ref18.onLoad,
    onUnmount = _ref18.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState112 = React.useState(null),
    _React$useState113 = _slicedToArray2(_React$useState112, 2),
    instance = _React$useState113[0],
    setInstance = _React$useState113[1];
  var _React$useState114 = React.useState(null),
    _React$useState115 = _slicedToArray2(_React$useState114, 2),
    closeclickListener = _React$useState115[0],
    setCloseClickListener = _React$useState115[1];
  var _React$useState116 = React.useState(null),
    _React$useState117 = _slicedToArray2(_React$useState116, 2),
    domreadyclickListener = _React$useState117[0],
    setDomReadyClickListener = _React$useState117[1];
  var _React$useState118 = React.useState(null),
    _React$useState119 = _slicedToArray2(_React$useState118, 2),
    contentchangedclickListener = _React$useState119[0],
    setContentChangedClickListener = _React$useState119[1];
  var _React$useState120 = React.useState(null),
    _React$useState121 = _slicedToArray2(_React$useState120, 2),
    positionchangedclickListener = _React$useState121[0],
    setPositionChangedClickListener = _React$useState121[1];
  var _React$useState122 = React.useState(null),
    _React$useState123 = _slicedToArray2(_React$useState122, 2),
    zindexchangedclickListener = _React$useState123[0],
    setZindexChangedClickListener = _React$useState123[1];
  var containerElementRef = React.useRef(null);
  // Order does matter
  React.useEffect(function () {
    if (map && instance !== null) {
      instance.close();
      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (position && instance !== null) {
      var positionLatLng = position instanceof google.maps.LatLng ? position
      // @ts-ignore
      : new google.maps.LatLng(position.lat, position.lng);
      instance.setPosition(positionLatLng);
    }
  }, [position]);
  React.useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  React.useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }
      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  React.useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }
      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  React.useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }
      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }
      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }
      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    if (map) {
      var _a2 = options || defaultOptions$3,
        _position3 = _a2.position,
        infoBoxOptions = __rest$1(_a2, ["position"]);
      var positionLatLng;
      if (_position3 && !(_position3 instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(_position3.lat, _position3.lng);
      }
      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      containerElementRef.current = document.createElement('div');
      setInstance(infoBox);
      if (onCloseClick) {
        setCloseClickListener(google.maps.event.addListener(infoBox, 'closeclick', onCloseClick));
      }
      if (onDomReady) {
        setDomReadyClickListener(google.maps.event.addListener(infoBox, 'domready', onDomReady));
      }
      if (onContentChanged) {
        setContentChangedClickListener(google.maps.event.addListener(infoBox, 'content_changed', onContentChanged));
      }
      if (onPositionChanged) {
        setPositionChangedClickListener(google.maps.event.addListener(infoBox, 'position_changed', onPositionChanged));
      }
      if (onZindexChanged) {
        setZindexChangedClickListener(google.maps.event.addListener(infoBox, 'zindex_changed', onZindexChanged));
      }
      infoBox.setContent(containerElementRef.current);
      if (anchor) {
        infoBox.open(map, anchor);
      } else if (infoBox.getPosition()) {
        infoBox.open(map);
      } else {
        invariant_1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
      if (onLoad) {
        onLoad(infoBox);
      }
    }
    return function () {
      if (instance !== null) {
        if (closeclickListener) {
          google.maps.event.removeListener(closeclickListener);
        }
        if (contentchangedclickListener) {
          google.maps.event.removeListener(contentchangedclickListener);
        }
        if (domreadyclickListener) {
          google.maps.event.removeListener(domreadyclickListener);
        }
        if (positionchangedclickListener) {
          google.maps.event.removeListener(positionchangedclickListener);
        }
        if (zindexchangedclickListener) {
          google.maps.event.removeListener(zindexchangedclickListener);
        }
        if (onUnmount) {
          onUnmount(instance);
        }
        instance.close();
      }
    };
  }, []);
  return containerElementRef.current ? ReactDOM.createPortal(React.Children.only(children), containerElementRef.current) : null;
}
React.memo(InfoBoxFunctional);
var InfoBoxComponent = /*#__PURE__*/function (_React$PureComponent9) {
  _inherits2(InfoBoxComponent, _React$PureComponent9);
  var _super10 = _createSuper2(InfoBoxComponent);
  function InfoBoxComponent() {
    var _this20;
    _classCallCheck2(this, InfoBoxComponent);
    _this20 = _super10.apply(this, arguments);
    _this20.registeredEvents = [];
    _this20.containerElement = null;
    _this20.state = {
      infoBox: null
    };
    _this20.open = function (infoBox, anchor) {
      if (anchor) {
        // @ts-ignore
        infoBox.open(_this20.context, anchor);
      } else if (infoBox.getPosition()) {
        // @ts-ignore
        infoBox.open(_this20.context);
      } else {
        invariant_1(false, 'You must provide either an anchor or a position prop for <InfoBox>.');
      }
    };
    _this20.setInfoBoxCallback = function () {
      if (_this20.state.infoBox !== null && _this20.containerElement !== null) {
        _this20.state.infoBox.setContent(_this20.containerElement);
        _this20.open(_this20.state.infoBox, _this20.props.anchor);
        if (_this20.props.onLoad) {
          _this20.props.onLoad(_this20.state.infoBox);
        }
      }
    };
    return _this20;
  }
  _createClass2(InfoBoxComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _a = this.props.options || {},
        position = _a.position,
        infoBoxOptions = __rest$1(_a, ["position"]);
      var positionLatLng;
      if (position && !(position instanceof google.maps.LatLng)) {
        // @ts-ignore
        positionLatLng = new google.maps.LatLng(position.lat, position.lng);
      }
      var infoBox = new InfoBox(Object.assign(Object.assign({}, infoBoxOptions), positionLatLng ? {
        position: positionLatLng
      } : {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: {},
        nextProps: this.props,
        instance: infoBox
      });
      this.setState({
        infoBox: infoBox
      }, this.setInfoBoxCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var infoBox = this.state.infoBox;
      if (infoBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$d,
          eventMap: eventMap$d,
          prevProps: prevProps,
          nextProps: this.props,
          instance: infoBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;
      var infoBox = this.state.infoBox;
      if (infoBox !== null) {
        if (onUnmount) {
          onUnmount(infoBox);
        }
        unregisterEvents(this.registeredEvents);
        infoBox.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? ReactDOM.createPortal(React.Children.only(this.props.children), this.containerElement) : null;
    }
  }]);
  return InfoBoxComponent;
}(React.PureComponent);
InfoBoxComponent.contextType = MapContext;

// do not edit .js files directly - edit src/index.jst

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }
    return true;
  }

  // true if both NaN, false otherwise
  return a !== a && b !== b;
};
var kdbush = {
  exports: {}
};
(function (module, exports) {
  (function (global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function () {
    function sortKD(ids, coords, nodeSize, left, right, depth) {
      if (right - left <= nodeSize) {
        return;
      }
      var m = left + right >> 1;
      select(ids, coords, m, left, right, depth % 2);
      sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
      sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
    }
    function select(ids, coords, k, left, right, inc) {
      while (right > left) {
        if (right - left > 600) {
          var n = right - left + 1;
          var m = k - left + 1;
          var z = Math.log(n);
          var s = 0.5 * Math.exp(2 * z / 3);
          var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
          var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
          var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
          select(ids, coords, k, newLeft, newRight, inc);
        }
        var t = coords[2 * k + inc];
        var i = left;
        var j = right;
        swapItem(ids, coords, left, k);
        if (coords[2 * right + inc] > t) {
          swapItem(ids, coords, left, right);
        }
        while (i < j) {
          swapItem(ids, coords, i, j);
          i++;
          j--;
          while (coords[2 * i + inc] < t) {
            i++;
          }
          while (coords[2 * j + inc] > t) {
            j--;
          }
        }
        if (coords[2 * left + inc] === t) {
          swapItem(ids, coords, left, j);
        } else {
          j++;
          swapItem(ids, coords, j, right);
        }
        if (j <= k) {
          left = j + 1;
        }
        if (k <= j) {
          right = j - 1;
        }
      }
    }
    function swapItem(ids, coords, i, j) {
      swap(ids, i, j);
      swap(coords, 2 * i, 2 * j);
      swap(coords, 2 * i + 1, 2 * j + 1);
    }
    function swap(arr, i, j) {
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var x, y;
      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();
        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            x = coords[2 * i];
            y = coords[2 * i + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
              result.push(ids[i]);
            }
          }
          continue;
        }
        var m = Math.floor((left + right) / 2);
        x = coords[2 * m];
        y = coords[2 * m + 1];
        if (x >= minX && x <= maxX && y >= minY && y <= maxY) {
          result.push(ids[m]);
        }
        var nextAxis = (axis + 1) % 2;
        if (axis === 0 ? minX <= x : minY <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }
      return result;
    }
    function within(ids, coords, qx, qy, r, nodeSize) {
      var stack = [0, ids.length - 1, 0];
      var result = [];
      var r2 = r * r;
      while (stack.length) {
        var axis = stack.pop();
        var right = stack.pop();
        var left = stack.pop();
        if (right - left <= nodeSize) {
          for (var i = left; i <= right; i++) {
            if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) {
              result.push(ids[i]);
            }
          }
          continue;
        }
        var m = Math.floor((left + right) / 2);
        var x = coords[2 * m];
        var y = coords[2 * m + 1];
        if (sqDist(x, y, qx, qy) <= r2) {
          result.push(ids[m]);
        }
        var nextAxis = (axis + 1) % 2;
        if (axis === 0 ? qx - r <= x : qy - r <= y) {
          stack.push(left);
          stack.push(m - 1);
          stack.push(nextAxis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
          stack.push(m + 1);
          stack.push(right);
          stack.push(nextAxis);
        }
      }
      return result;
    }
    function sqDist(ax, ay, bx, by) {
      var dx = ax - bx;
      var dy = ay - by;
      return dx * dx + dy * dy;
    }
    var defaultGetX = function defaultGetX(p) {
      return p[0];
    };
    var defaultGetY = function defaultGetY(p) {
      return p[1];
    };
    var KDBush = function KDBush(points, getX, getY, nodeSize, ArrayType) {
      if (getX === void 0) getX = defaultGetX;
      if (getY === void 0) getY = defaultGetY;
      if (nodeSize === void 0) nodeSize = 64;
      if (ArrayType === void 0) ArrayType = Float64Array;
      this.nodeSize = nodeSize;
      this.points = points;
      var IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;
      var ids = this.ids = new IndexArrayType(points.length);
      var coords = this.coords = new ArrayType(points.length * 2);
      for (var i = 0; i < points.length; i++) {
        ids[i] = i;
        coords[2 * i] = getX(points[i]);
        coords[2 * i + 1] = getY(points[i]);
      }
      sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
    };
    KDBush.prototype.range = function range$1(minX, minY, maxX, maxY) {
      return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    };
    KDBush.prototype.within = function within$1(x, y, r) {
      return within(this.ids, this.coords, x, y, r, this.nodeSize);
    };
    return KDBush;
  });
})(kdbush);
var KDBush = kdbush.exports;
var defaultOptions$2 = {
  minZoom: 0,
  // min zoom to generate clusters on
  maxZoom: 16,
  // max zoom level to cluster the points on
  minPoints: 2,
  // minimum points to form a cluster
  radius: 40,
  // cluster radius in pixels
  extent: 512,
  // tile extent (radius is calculated relative to it)
  nodeSize: 64,
  // size of the KD-tree leaf node, affects performance
  log: false,
  // whether to log timing info

  // whether to generate numeric ids for input features (in vector tiles)
  generateId: false,
  // a reduce function for calculating custom cluster properties
  reduce: null,
  // (accumulated, props) => { accumulated.sum += props.sum; }

  // properties to use for individual points when running the reducer
  map: function map(props) {
    return props;
  } // props => ({sum: props.my_value})
};

var fround = Math.fround || function (tmp) {
  return function (x) {
    tmp[0] = +x;
    return tmp[0];
  };
}(new Float32Array(1));
var Supercluster = /*#__PURE__*/function () {
  function Supercluster(options) {
    _classCallCheck2(this, Supercluster);
    this.options = extend$1(Object.create(defaultOptions$2), options);
    this.trees = new Array(this.options.maxZoom + 1);
  }
  _createClass2(Supercluster, [{
    key: "load",
    value: function load(points) {
      var _this$options = this.options,
        log = _this$options.log,
        minZoom = _this$options.minZoom,
        maxZoom = _this$options.maxZoom,
        nodeSize = _this$options.nodeSize;
      if (log) console.time('total time');
      var timerId = "prepare ".concat(points.length, " points");
      if (log) console.time(timerId);
      this.points = points;

      // generate a cluster object for each point and index input points into a KD-tree
      var clusters = [];
      for (var i = 0; i < points.length; i++) {
        if (!points[i].geometry) continue;
        clusters.push(createPointCluster(points[i], i));
      }
      this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
      if (log) console.timeEnd(timerId);

      // cluster points on max zoom, then cluster the results on previous zoom, etc.;
      // results in a cluster hierarchy across zoom levels
      for (var _z2 = maxZoom; _z2 >= minZoom; _z2--) {
        var now = +Date.now();

        // create a new set of clusters for the zoom and index them with a KD-tree
        clusters = this._cluster(clusters, _z2);
        this.trees[_z2] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);
        if (log) console.log('z%d: %d clusters in %dms', _z2, clusters.length, +Date.now() - now);
      }
      if (log) console.timeEnd('total time');
      return this;
    }
  }, {
    key: "getClusters",
    value: function getClusters(bbox, zoom) {
      var minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
      var minLat = Math.max(-90, Math.min(90, bbox[1]));
      var maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
      var maxLat = Math.max(-90, Math.min(90, bbox[3]));
      if (bbox[2] - bbox[0] >= 360) {
        minLng = -180;
        maxLng = 180;
      } else if (minLng > maxLng) {
        var easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
        var westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
        return easternHem.concat(westernHem);
      }
      var tree = this.trees[this._limitZoom(zoom)];
      var ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
      var clusters = [];
      var _iterator2 = _createForOfIteratorHelper(ids),
        _step;
      try {
        for (_iterator2.s(); !(_step = _iterator2.n()).done;) {
          var _id = _step.value;
          var _c2 = tree.points[_id];
          clusters.push(_c2.numPoints ? getClusterJSON(_c2) : this.points[_c2.index]);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return clusters;
    }
  }, {
    key: "getChildren",
    value: function getChildren(clusterId) {
      var originId = this._getOriginId(clusterId);
      var originZoom = this._getOriginZoom(clusterId);
      var errorMsg = 'No cluster with the specified id.';
      var index = this.trees[originZoom];
      if (!index) throw new Error(errorMsg);
      var origin = index.points[originId];
      if (!origin) throw new Error(errorMsg);
      var r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
      var ids = index.within(origin.x, origin.y, r);
      var children = [];
      var _iterator3 = _createForOfIteratorHelper(ids),
        _step2;
      try {
        for (_iterator3.s(); !(_step2 = _iterator3.n()).done;) {
          var _id2 = _step2.value;
          var _c3 = index.points[_id2];
          if (_c3.parentId === clusterId) {
            children.push(_c3.numPoints ? getClusterJSON(_c3) : this.points[_c3.index]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (children.length === 0) throw new Error(errorMsg);
      return children;
    }
  }, {
    key: "getLeaves",
    value: function getLeaves(clusterId, limit, offset) {
      limit = limit || 10;
      offset = offset || 0;
      var leaves = [];
      this._appendLeaves(leaves, clusterId, limit, offset, 0);
      return leaves;
    }
  }, {
    key: "getTile",
    value: function getTile(z, x, y) {
      var tree = this.trees[this._limitZoom(z)];
      var z2 = Math.pow(2, z);
      var _this$options2 = this.options,
        extent = _this$options2.extent,
        radius = _this$options2.radius;
      var p = radius / extent;
      var top = (y - p) / z2;
      var bottom = (y + 1 + p) / z2;
      var tile = {
        features: []
      };
      this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.points, x, y, z2, tile);
      if (x === 0) {
        this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.points, z2, y, z2, tile);
      }
      if (x === z2 - 1) {
        this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.points, -1, y, z2, tile);
      }
      return tile.features.length ? tile : null;
    }
  }, {
    key: "getClusterExpansionZoom",
    value: function getClusterExpansionZoom(clusterId) {
      var expansionZoom = this._getOriginZoom(clusterId) - 1;
      while (expansionZoom <= this.options.maxZoom) {
        var children = this.getChildren(clusterId);
        expansionZoom++;
        if (children.length !== 1) break;
        clusterId = children[0].properties.cluster_id;
      }
      return expansionZoom;
    }
  }, {
    key: "_appendLeaves",
    value: function _appendLeaves(result, clusterId, limit, offset, skipped) {
      var children = this.getChildren(clusterId);
      var _iterator4 = _createForOfIteratorHelper(children),
        _step3;
      try {
        for (_iterator4.s(); !(_step3 = _iterator4.n()).done;) {
          var child = _step3.value;
          var props = child.properties;
          if (props && props.cluster) {
            if (skipped + props.point_count <= offset) {
              // skip the whole cluster
              skipped += props.point_count;
            } else {
              // enter the cluster
              skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
              // exit the cluster
            }
          } else if (skipped < offset) {
            // skip a single point
            skipped++;
          } else {
            // add a single point
            result.push(child);
          }
          if (result.length === limit) break;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return skipped;
    }
  }, {
    key: "_addTileFeatures",
    value: function _addTileFeatures(ids, points, x, y, z2, tile) {
      var _iterator5 = _createForOfIteratorHelper(ids),
        _step4;
      try {
        for (_iterator5.s(); !(_step4 = _iterator5.n()).done;) {
          var i = _step4.value;
          var _c4 = points[i];
          var isCluster = _c4.numPoints;
          var tags = void 0,
            _px = void 0,
            _py = void 0;
          if (isCluster) {
            tags = getClusterProperties(_c4);
            _px = _c4.x;
            _py = _c4.y;
          } else {
            var _p2 = this.points[_c4.index];
            tags = _p2.properties;
            _px = lngX(_p2.geometry.coordinates[0]);
            _py = latY(_p2.geometry.coordinates[1]);
          }
          var _f2 = {
            type: 1,
            geometry: [[Math.round(this.options.extent * (_px * z2 - x)), Math.round(this.options.extent * (_py * z2 - y))]],
            tags: tags
          };

          // assign id
          var _id3 = void 0;
          if (isCluster) {
            _id3 = _c4.id;
          } else if (this.options.generateId) {
            // optionally generate id
            _id3 = _c4.index;
          } else if (this.points[_c4.index].id) {
            // keep id if already assigned
            _id3 = this.points[_c4.index].id;
          }
          if (_id3 !== undefined) _f2.id = _id3;
          tile.features.push(_f2);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "_limitZoom",
    value: function _limitZoom(z) {
      return Math.max(this.options.minZoom, Math.min(+z, this.options.maxZoom + 1));
    }
  }, {
    key: "_cluster",
    value: function _cluster(points, zoom) {
      var clusters = [];
      var _this$options3 = this.options,
        radius = _this$options3.radius,
        extent = _this$options3.extent,
        reduce = _this$options3.reduce,
        minPoints = _this$options3.minPoints;
      var r = radius / (extent * Math.pow(2, zoom));

      // loop through each point
      for (var i = 0; i < points.length; i++) {
        var _p3 = points[i];
        // if we've already visited the point at this zoom level, skip it
        if (_p3.zoom <= zoom) continue;
        _p3.zoom = zoom;

        // find all nearby points
        var tree = this.trees[zoom + 1];
        var neighborIds = tree.within(_p3.x, _p3.y, r);
        var numPointsOrigin = _p3.numPoints || 1;
        var numPoints = numPointsOrigin;

        // count the number of points in a potential cluster
        var _iterator6 = _createForOfIteratorHelper(neighborIds),
          _step5;
        try {
          for (_iterator6.s(); !(_step5 = _iterator6.n()).done;) {
            var _neighborId2 = _step5.value;
            var _b4 = tree.points[_neighborId2];
            // filter out neighbors that are already processed
            if (_b4.zoom > zoom) numPoints += _b4.numPoints || 1;
          }

          // if there were neighbors to merge, and there are enough points to form a cluster
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        if (numPoints > numPointsOrigin && numPoints >= minPoints) {
          var _wx = _p3.x * numPointsOrigin;
          var _wy = _p3.y * numPointsOrigin;
          var clusterProperties = reduce && numPointsOrigin > 1 ? this._map(_p3, true) : null;

          // encode both zoom and point index on which the cluster originated -- offset by total length of features
          var _id4 = (i << 5) + (zoom + 1) + this.points.length;
          var _iterator7 = _createForOfIteratorHelper(neighborIds),
            _step6;
          try {
            for (_iterator7.s(); !(_step6 = _iterator7.n()).done;) {
              var neighborId = _step6.value;
              var _b2 = tree.points[neighborId];
              if (_b2.zoom <= zoom) continue;
              _b2.zoom = zoom; // save the zoom (so it doesn't get processed twice)

              var numPoints2 = _b2.numPoints || 1;
              _wx += _b2.x * numPoints2; // accumulate coordinates for calculating weighted center
              _wy += _b2.y * numPoints2;
              _b2.parentId = _id4;
              if (reduce) {
                if (!clusterProperties) clusterProperties = this._map(_p3, true);
                reduce(clusterProperties, this._map(_b2));
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
          _p3.parentId = _id4;
          clusters.push(createCluster(_wx / numPoints, _wy / numPoints, _id4, numPoints, clusterProperties));
        } else {
          // left points as unclustered
          clusters.push(_p3);
          if (numPoints > 1) {
            var _iterator8 = _createForOfIteratorHelper(neighborIds),
              _step7;
            try {
              for (_iterator8.s(); !(_step7 = _iterator8.n()).done;) {
                var _neighborId = _step7.value;
                var _b3 = tree.points[_neighborId];
                if (_b3.zoom <= zoom) continue;
                _b3.zoom = zoom;
                clusters.push(_b3);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        }
      }
      return clusters;
    }

    // get index of the point from which the cluster originated
  }, {
    key: "_getOriginId",
    value: function _getOriginId(clusterId) {
      return clusterId - this.points.length >> 5;
    }

    // get zoom of the point from which the cluster originated
  }, {
    key: "_getOriginZoom",
    value: function _getOriginZoom(clusterId) {
      return (clusterId - this.points.length) % 32;
    }
  }, {
    key: "_map",
    value: function _map(point, clone) {
      if (point.numPoints) {
        return clone ? extend$1({}, point.properties) : point.properties;
      }
      var original = this.points[point.index].properties;
      var result = this.options.map(original);
      return clone && result === original ? extend$1({}, result) : result;
    }
  }]);
  return Supercluster;
}();
function createCluster(x, y, id, numPoints, properties) {
  return {
    x: fround(x),
    // weighted cluster center; round for consistency with Float32Array index
    y: fround(y),
    zoom: Infinity,
    // the last zoom the cluster was processed at
    id: id,
    // encodes index of the first child of the cluster and its zoom level
    parentId: -1,
    // parent cluster id
    numPoints: numPoints,
    properties: properties
  };
}
function createPointCluster(p, id) {
  var _p$geometry$coordinat = _slicedToArray2(p.geometry.coordinates, 2),
    x = _p$geometry$coordinat[0],
    y = _p$geometry$coordinat[1];
  return {
    x: fround(lngX(x)),
    // projected point coordinates
    y: fround(latY(y)),
    zoom: Infinity,
    // the last zoom the point was processed at
    index: id,
    // index of the source feature in the original input array,
    parentId: -1 // parent cluster id
  };
}

function getClusterJSON(cluster) {
  return {
    type: 'Feature',
    id: cluster.id,
    properties: getClusterProperties(cluster),
    geometry: {
      type: 'Point',
      coordinates: [xLng(cluster.x), yLat(cluster.y)]
    }
  };
}
function getClusterProperties(cluster) {
  var count = cluster.numPoints;
  var abbrev = count >= 10000 ? "".concat(Math.round(count / 1000), "k") : count >= 1000 ? "".concat(Math.round(count / 100) / 10, "k") : count;
  return extend$1(extend$1({}, cluster.properties), {
    cluster: true,
    cluster_id: cluster.id,
    point_count: count,
    point_count_abbreviated: abbrev
  });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
  return lng / 360 + 0.5;
}
function latY(lat) {
  var sin = Math.sin(lat * Math.PI / 180);
  var y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
  return y < 0 ? 0 : y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
  return (x - 0.5) * 360;
}
function yLat(y) {
  var y2 = (180 - y * 360) * Math.PI / 180;
  return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}
function extend$1(dest, src) {
  for (var _id5 in src) dest[_id5] = src[_id5];
  return dest;
}
function getX(p) {
  return p.x;
}
function getY(p) {
  return p.y;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Cluster = /*#__PURE__*/function () {
  function Cluster(_ref19) {
    var markers = _ref19.markers,
      position = _ref19.position;
    _classCallCheck2(this, Cluster);
    this.markers = markers;
    if (position) {
      if (position instanceof google.maps.LatLng) {
        this._position = position;
      } else {
        this._position = new google.maps.LatLng(position);
      }
    }
  }
  _createClass2(Cluster, [{
    key: "bounds",
    get: function get() {
      if (this.markers.length === 0 && !this._position) {
        return undefined;
      }
      return this.markers.reduce(function (bounds, marker) {
        return bounds.extend(marker.getPosition());
      }, new google.maps.LatLngBounds(this._position, this._position));
    }
  }, {
    key: "position",
    get: function get() {
      return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */
  }, {
    key: "count",
    get: function get() {
      return this.markers.filter(function (m) {
        return m.getVisible();
      }).length;
    }
    /**
     * Add a marker to the cluster.
     */
  }, {
    key: "push",
    value: function push(marker) {
      this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */
  }, {
    key: "delete",
    value: function _delete() {
      if (this.marker) {
        this.marker.setMap(null);
        delete this.marker;
      }
      this.markers.length = 0;
    }
  }]);
  return Cluster;
}();
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @hidden
 */
var AbstractAlgorithm = /*#__PURE__*/function () {
  function AbstractAlgorithm(_ref20) {
    var _ref20$maxZoom = _ref20.maxZoom,
      maxZoom = _ref20$maxZoom === void 0 ? 16 : _ref20$maxZoom;
    _classCallCheck2(this, AbstractAlgorithm);
    this.maxZoom = maxZoom;
  }
  /**
   * Helper function to bypass clustering based upon some map state such as
   * zoom, number of markers, etc.
   *
   * ```typescript
   *  cluster({markers, map}: AlgorithmInput): Cluster[] {
   *    if (shouldBypassClustering(map)) {
   *      return this.noop({markers, map})
   *    }
   * }
   * ```
   */
  _createClass2(AbstractAlgorithm, [{
    key: "noop",
    value: function noop(_ref21) {
      var markers = _ref21.markers;
      return noop$1(markers);
    }
  }]);
  return AbstractAlgorithm;
}();
/**
 * @hidden
 */
var noop$1 = function noop$1(markers) {
  var clusters = markers.map(function (marker) {
    return new Cluster({
      position: marker.getPosition(),
      markers: [marker]
    });
  });
  return clusters;
};

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */
var SuperClusterAlgorithm = /*#__PURE__*/function (_AbstractAlgorithm) {
  _inherits2(SuperClusterAlgorithm, _AbstractAlgorithm);
  var _super11 = _createSuper2(SuperClusterAlgorithm);
  function SuperClusterAlgorithm(_a) {
    var _this21;
    _classCallCheck2(this, SuperClusterAlgorithm);
    var maxZoom = _a.maxZoom,
      _a$radius = _a.radius,
      radius = _a$radius === void 0 ? 60 : _a$radius,
      options = __rest(_a, ["maxZoom", "radius"]);
    _this21 = _super11.call(this, {
      maxZoom: maxZoom
    });
    _this21.superCluster = new Supercluster(Object.assign({
      maxZoom: _this21.maxZoom,
      radius: radius
    }, options));
    _this21.state = {
      zoom: null
    };
    return _this21;
  }
  _createClass2(SuperClusterAlgorithm, [{
    key: "calculate",
    value: function calculate(input) {
      var changed = false;
      if (!fastDeepEqual(input.markers, this.markers)) {
        changed = true;
        // TODO use proxy to avoid copy?
        this.markers = _toConsumableArray(input.markers);
        var points = this.markers.map(function (marker) {
          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [marker.getPosition().lng(), marker.getPosition().lat()]
            },
            properties: {
              marker: marker
            }
          };
        });
        this.superCluster.load(points);
      }
      var state = {
        zoom: input.map.getZoom()
      };
      if (!changed) {
        if (this.state.zoom > this.maxZoom && state.zoom > this.maxZoom) ;else {
          changed = changed || !fastDeepEqual(this.state, state);
        }
      }
      this.state = state;
      if (changed) {
        this.clusters = this.cluster(input);
      }
      return {
        clusters: this.clusters,
        changed: changed
      };
    }
  }, {
    key: "cluster",
    value: function cluster(_ref22) {
      var map = _ref22.map;
      return this.superCluster.getClusters([-180, -90, 180, 90], Math.round(map.getZoom())).map(this.transformCluster.bind(this));
    }
  }, {
    key: "transformCluster",
    value: function transformCluster(_ref23) {
      var _ref23$geometry$coord = _slicedToArray2(_ref23.geometry.coordinates, 2),
        lng = _ref23$geometry$coord[0],
        lat = _ref23$geometry$coord[1],
        properties = _ref23.properties;
      if (properties.cluster) {
        return new Cluster({
          markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map(function (leaf) {
            return leaf.properties.marker;
          }),
          position: new google.maps.LatLng({
            lat: lat,
            lng: lng
          })
        });
      } else {
        var marker = properties.marker;
        return new Cluster({
          markers: [marker],
          position: marker.getPosition()
        });
      }
    }
  }]);
  return SuperClusterAlgorithm;
}(AbstractAlgorithm);
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */
var ClusterStats = /*#__PURE__*/_createClass2(function ClusterStats(markers, clusters) {
  _classCallCheck2(this, ClusterStats);
  this.markers = {
    sum: markers.length
  };
  var clusterMarkerCounts = clusters.map(function (a) {
    return a.count;
  });
  var clusterMarkerSum = clusterMarkerCounts.reduce(function (a, b) {
    return a + b;
  }, 0);
  this.clusters = {
    count: clusters.length,
    markers: {
      mean: clusterMarkerSum / clusters.length,
      sum: clusterMarkerSum,
      min: Math.min.apply(Math, _toConsumableArray(clusterMarkerCounts)),
      max: Math.max.apply(Math, _toConsumableArray(clusterMarkerCounts))
    }
  };
});
var DefaultRenderer = /*#__PURE__*/function () {
  function DefaultRenderer() {
    _classCallCheck2(this, DefaultRenderer);
  }
  _createClass2(DefaultRenderer, [{
    key: "render",
    value:
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */
    function render(_ref24, stats) {
      var count = _ref24.count,
        position = _ref24.position;
      // change color if this cluster has more markers than the mean cluster
      var color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
      // create svg url with fill color
      var svg = window.btoa("\n  <svg fill=\"".concat(color, "\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 240 240\">\n    <circle cx=\"120\" cy=\"120\" opacity=\".6\" r=\"70\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".3\" r=\"90\" />\n    <circle cx=\"120\" cy=\"120\" opacity=\".2\" r=\"110\" />\n  </svg>"));
      // create marker using svg icon
      return new google.maps.Marker({
        position: position,
        icon: {
          url: "data:image/svg+xml;base64,".concat(svg),
          scaledSize: new google.maps.Size(45, 45)
        },
        label: {
          text: String(count),
          color: "rgba(255,255,255,0.9)",
          fontSize: "12px"
        },
        title: "Cluster of ".concat(count, " markers"),
        // adjust zIndex to be above other markers
        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
      });
    }
  }]);
  return DefaultRenderer;
}();
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extend(type1, type2) {
  /* istanbul ignore next */
  // eslint-disable-next-line prefer-const
  for (var property in type2.prototype) {
    type1.prototype[property] = type2.prototype[property];
  }
}
/**
 * @ignore
 */
var OverlayViewSafe = /*#__PURE__*/_createClass2(function OverlayViewSafe() {
  _classCallCheck2(this, OverlayViewSafe);
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  extend(OverlayViewSafe, google.maps.OverlayView);
});
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MarkerClustererEvents;
(function (MarkerClustererEvents) {
  MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
  MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
  MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})(MarkerClustererEvents || (MarkerClustererEvents = {}));
var defaultOnClusterClickHandler = function defaultOnClusterClickHandler(_, cluster, map) {
  map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */
var MarkerClusterer = /*#__PURE__*/function (_OverlayViewSafe) {
  _inherits2(MarkerClusterer, _OverlayViewSafe);
  var _super12 = _createSuper2(MarkerClusterer);
  function MarkerClusterer(_ref25) {
    var _this22;
    var map = _ref25.map,
      _ref25$markers = _ref25.markers,
      markers = _ref25$markers === void 0 ? [] : _ref25$markers,
      _ref25$algorithm = _ref25.algorithm,
      algorithm = _ref25$algorithm === void 0 ? new SuperClusterAlgorithm({}) : _ref25$algorithm,
      _ref25$renderer = _ref25.renderer,
      renderer = _ref25$renderer === void 0 ? new DefaultRenderer() : _ref25$renderer,
      _ref25$onClusterClick = _ref25.onClusterClick,
      onClusterClick = _ref25$onClusterClick === void 0 ? defaultOnClusterClickHandler : _ref25$onClusterClick;
    _classCallCheck2(this, MarkerClusterer);
    _this22 = _super12.call(this);
    _this22.markers = _toConsumableArray(markers);
    _this22.clusters = [];
    _this22.algorithm = algorithm;
    _this22.renderer = renderer;
    _this22.onClusterClick = onClusterClick;
    if (map) {
      _this22.setMap(map);
    }
    return _this22;
  }
  _createClass2(MarkerClusterer, [{
    key: "addMarker",
    value: function addMarker(marker, noDraw) {
      if (this.markers.includes(marker)) {
        return;
      }
      this.markers.push(marker);
      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "addMarkers",
    value: function addMarkers(markers, noDraw) {
      var _this23 = this;
      markers.forEach(function (marker) {
        _this23.addMarker(marker, true);
      });
      if (!noDraw) {
        this.render();
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(marker, noDraw) {
      var index = this.markers.indexOf(marker);
      if (index === -1) {
        // Marker is not in our list of markers, so do nothing:
        return false;
      }
      marker.setMap(null);
      this.markers.splice(index, 1); // Remove the marker from the list of managed markers
      if (!noDraw) {
        this.render();
      }
      return true;
    }
  }, {
    key: "removeMarkers",
    value: function removeMarkers(markers, noDraw) {
      var _this24 = this;
      var removed = false;
      markers.forEach(function (marker) {
        removed = _this24.removeMarker(marker, true) || removed;
      });
      if (removed && !noDraw) {
        this.render();
      }
      return removed;
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers(noDraw) {
      this.markers.length = 0;
      if (!noDraw) {
        this.render();
      }
    }
    /**
     * Recalculates and draws all the marker clusters.
     */
  }, {
    key: "render",
    value: function render() {
      var map = this.getMap();
      if (map instanceof google.maps.Map && this.getProjection()) {
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_BEGIN, this);
        var _this$algorithm$calcu = this.algorithm.calculate({
            markers: this.markers,
            map: map,
            mapCanvasProjection: this.getProjection()
          }),
          clusters = _this$algorithm$calcu.clusters,
          changed = _this$algorithm$calcu.changed;
        // allow algorithms to return flag on whether the clusters/markers have changed
        if (changed || changed == undefined) {
          // reset visibility of markers and clusters
          this.reset();
          // store new clusters
          this.clusters = clusters;
          this.renderClusters();
        }
        google.maps.event.trigger(this, MarkerClustererEvents.CLUSTERING_END, this);
      }
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
      this.render();
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      google.maps.event.removeListener(this.idleListener);
      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.markers.forEach(function (marker) {
        return marker.setMap(null);
      });
      this.clusters.forEach(function (cluster) {
        return cluster.delete();
      });
      this.clusters = [];
    }
  }, {
    key: "renderClusters",
    value: function renderClusters() {
      var _this25 = this;
      // generate stats to pass to renderers
      var stats = new ClusterStats(this.markers, this.clusters);
      var map = this.getMap();
      this.clusters.forEach(function (cluster) {
        if (cluster.markers.length === 1) {
          cluster.marker = cluster.markers[0];
        } else {
          cluster.marker = _this25.renderer.render(cluster, stats);
          if (_this25.onClusterClick) {
            cluster.marker.addListener("click", /* istanbul ignore next */
            function (event) {
              google.maps.event.trigger(_this25, MarkerClustererEvents.CLUSTER_CLICK, cluster);
              _this25.onClusterClick(event, cluster, map);
            });
          }
        }
        cluster.marker.setMap(map);
      });
    }
  }]);
  return MarkerClusterer;
}(OverlayViewSafe);
function useGoogleMarkerClusterer(options) {
  var map = useGoogleMap();
  var _React$useState124 = React.useState(null),
    _React$useState125 = _slicedToArray2(_React$useState124, 2),
    markerClusterer = _React$useState125[0],
    setMarkerClusterer = _React$useState125[1];
  React.useEffect(function () {
    if (map && markerClusterer === null) {
      var markerCluster = new MarkerClusterer(Object.assign(Object.assign({}, options), {
        map: map
      }));
      setMarkerClusterer(markerCluster);
    }
  }, [map]);
  return markerClusterer;
}
/** Wrapper around [@googlemaps/markerclusterer](https://github.com/googlemaps/js-markerclusterer)
 *
 * Accepts {@link  MarkerClustererOptionsSubset} which is a subset of  {@link MarkerClustererOptions}
 */
function GoogleMarkerClusterer(_ref26) {
  var children = _ref26.children,
    options = _ref26.options;
  var markerClusterer = useGoogleMarkerClusterer(options);
  return markerClusterer !== null ? children(markerClusterer) : null;
}
React.memo(GoogleMarkerClusterer);

/* global google */
var eventMap$c = {
  onCloseClick: 'closeclick',
  onContentChanged: 'content_changed',
  onDomReady: 'domready',
  onPositionChanged: 'position_changed',
  onZindexChanged: 'zindex_changed'
};
var updaterMap$c = {
  options: function options(instance, _options6) {
    instance.setOptions(_options6);
  },
  position: function position(instance, _position4) {
    instance.setPosition(_position4);
  },
  zIndex: function zIndex(instance, _zIndex3) {
    instance.setZIndex(_zIndex3);
  }
};
function InfoWindowFunctional(_ref27) {
  var children = _ref27.children,
    anchor = _ref27.anchor,
    options = _ref27.options,
    position = _ref27.position,
    zIndex = _ref27.zIndex,
    onCloseClick = _ref27.onCloseClick,
    onDomReady = _ref27.onDomReady,
    onContentChanged = _ref27.onContentChanged,
    onPositionChanged = _ref27.onPositionChanged,
    onZindexChanged = _ref27.onZindexChanged,
    onLoad = _ref27.onLoad,
    onUnmount = _ref27.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState126 = React.useState(null),
    _React$useState127 = _slicedToArray2(_React$useState126, 2),
    instance = _React$useState127[0],
    setInstance = _React$useState127[1];
  var _React$useState128 = React.useState(null),
    _React$useState129 = _slicedToArray2(_React$useState128, 2),
    closeclickListener = _React$useState129[0],
    setCloseClickListener = _React$useState129[1];
  var _React$useState130 = React.useState(null),
    _React$useState131 = _slicedToArray2(_React$useState130, 2),
    domreadyclickListener = _React$useState131[0],
    setDomReadyClickListener = _React$useState131[1];
  var _React$useState132 = React.useState(null),
    _React$useState133 = _slicedToArray2(_React$useState132, 2),
    contentchangedclickListener = _React$useState133[0],
    setContentChangedClickListener = _React$useState133[1];
  var _React$useState134 = React.useState(null),
    _React$useState135 = _slicedToArray2(_React$useState134, 2),
    positionchangedclickListener = _React$useState135[0],
    setPositionChangedClickListener = _React$useState135[1];
  var _React$useState136 = React.useState(null),
    _React$useState137 = _slicedToArray2(_React$useState136, 2),
    zindexchangedclickListener = _React$useState137[0],
    setZindexChangedClickListener = _React$useState137[1];
  var containerElementRef = React.useRef(null);
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.close();
      if (anchor) {
        instance.open(map, anchor);
      } else if (instance.getPosition()) {
        instance.open(map);
      }
    }
  }, [map, instance, anchor]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (position && instance !== null) {
      instance.setPosition(position);
    }
  }, [position]);
  React.useEffect(function () {
    if (typeof zIndex === 'number' && instance !== null) {
      instance.setZIndex(zIndex);
    }
  }, [zIndex]);
  React.useEffect(function () {
    if (instance && onCloseClick) {
      if (closeclickListener !== null) {
        google.maps.event.removeListener(closeclickListener);
      }
      setCloseClickListener(google.maps.event.addListener(instance, 'closeclick', onCloseClick));
    }
  }, [onCloseClick]);
  React.useEffect(function () {
    if (instance && onDomReady) {
      if (domreadyclickListener !== null) {
        google.maps.event.removeListener(domreadyclickListener);
      }
      setDomReadyClickListener(google.maps.event.addListener(instance, 'domready', onDomReady));
    }
  }, [onDomReady]);
  React.useEffect(function () {
    if (instance && onContentChanged) {
      if (contentchangedclickListener !== null) {
        google.maps.event.removeListener(contentchangedclickListener);
      }
      setContentChangedClickListener(google.maps.event.addListener(instance, 'content_changed', onContentChanged));
    }
  }, [onContentChanged]);
  React.useEffect(function () {
    if (instance && onPositionChanged) {
      if (positionchangedclickListener !== null) {
        google.maps.event.removeListener(positionchangedclickListener);
      }
      setPositionChangedClickListener(google.maps.event.addListener(instance, 'position_changed', onPositionChanged));
    }
  }, [onPositionChanged]);
  React.useEffect(function () {
    if (instance && onZindexChanged) {
      if (zindexchangedclickListener !== null) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }
      setZindexChangedClickListener(google.maps.event.addListener(instance, 'zindex_changed', onZindexChanged));
    }
  }, [onZindexChanged]);
  React.useEffect(function () {
    var infoWindow = new google.maps.InfoWindow(Object.assign({}, options || {}));
    setInstance(infoWindow);
    containerElementRef.current = document.createElement('div');
    if (onCloseClick) {
      setCloseClickListener(google.maps.event.addListener(infoWindow, 'closeclick', onCloseClick));
    }
    if (onDomReady) {
      setDomReadyClickListener(google.maps.event.addListener(infoWindow, 'domready', onDomReady));
    }
    if (onContentChanged) {
      setContentChangedClickListener(google.maps.event.addListener(infoWindow, 'content_changed', onContentChanged));
    }
    if (onPositionChanged) {
      setPositionChangedClickListener(google.maps.event.addListener(infoWindow, 'position_changed', onPositionChanged));
    }
    if (onZindexChanged) {
      setZindexChangedClickListener(google.maps.event.addListener(infoWindow, 'zindex_changed', onZindexChanged));
    }
    infoWindow.setContent(containerElementRef.current);
    if (position) {
      infoWindow.setPosition(position);
    }
    if (zIndex) {
      infoWindow.setZIndex(zIndex);
    }
    if (anchor) {
      infoWindow.open(map, anchor);
    } else if (infoWindow.getPosition()) {
      infoWindow.open(map);
    } else {
      invariant_1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
    }
    if (onLoad) {
      onLoad(infoWindow);
    }
    return function () {
      if (closeclickListener) {
        google.maps.event.removeListener(closeclickListener);
      }
      if (contentchangedclickListener) {
        google.maps.event.removeListener(contentchangedclickListener);
      }
      if (domreadyclickListener) {
        google.maps.event.removeListener(domreadyclickListener);
      }
      if (positionchangedclickListener) {
        google.maps.event.removeListener(positionchangedclickListener);
      }
      if (zindexchangedclickListener) {
        google.maps.event.removeListener(zindexchangedclickListener);
      }
      if (onUnmount) {
        onUnmount(infoWindow);
      }
      infoWindow.close();
    };
  }, []);
  return containerElementRef.current ? ReactDOM.createPortal(React.Children.only(children), containerElementRef.current) : null;
}
React.memo(InfoWindowFunctional);
var InfoWindow = /*#__PURE__*/function (_React$PureComponent10) {
  _inherits2(InfoWindow, _React$PureComponent10);
  var _super13 = _createSuper2(InfoWindow);
  function InfoWindow() {
    var _this26;
    _classCallCheck2(this, InfoWindow);
    _this26 = _super13.apply(this, arguments);
    _this26.registeredEvents = [];
    _this26.containerElement = null;
    _this26.state = {
      infoWindow: null
    };
    _this26.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this26.context, anchor);
      } else if (infoWindow.getPosition()) {
        // @ts-ignore
        infoWindow.open(_this26.context);
      } else {
        invariant_1(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.");
      }
    };
    _this26.setInfoWindowCallback = function () {
      if (_this26.state.infoWindow !== null && _this26.containerElement !== null) {
        _this26.state.infoWindow.setContent(_this26.containerElement);
        _this26.open(_this26.state.infoWindow, _this26.props.anchor);
        if (_this26.props.onLoad) {
          _this26.props.onLoad(_this26.state.infoWindow);
        }
      }
    };
    return _this26;
  }
  _createClass2(InfoWindow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var infoWindow = new google.maps.InfoWindow(Object.assign({}, this.props.options || {}));
      this.containerElement = document.createElement('div');
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: {},
        nextProps: this.props,
        instance: infoWindow
      });
      this.setState(function () {
        return {
          infoWindow: infoWindow
        };
      }, this.setInfoWindowCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$c,
          eventMap: eventMap$c,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.infoWindow
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.infoWindow !== null) {
        unregisterEvents(this.registeredEvents);
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.infoWindow);
        }
        this.state.infoWindow.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.containerElement ? ReactDOM.createPortal(React.Children.only(this.props.children), this.containerElement) : null;
    }
  }]);
  return InfoWindow;
}(React.PureComponent);
InfoWindow.contextType = MapContext;
var eventMap$b = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$b = {
  draggable: function draggable(instance, _draggable2) {
    instance.setDraggable(_draggable2);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map2) {
    instance.setMap(_map2);
  },
  options: function options(instance, _options7) {
    instance.setOptions(_options7);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  visible: function visible(instance, _visible3) {
    instance.setVisible(_visible3);
  }
};
var defaultOptions$1 = {};
function PolylineFunctional(_ref28) {
  var options = _ref28.options,
    draggable = _ref28.draggable,
    editable = _ref28.editable,
    visible = _ref28.visible,
    path = _ref28.path,
    onDblClick = _ref28.onDblClick,
    onDragEnd = _ref28.onDragEnd,
    onDragStart = _ref28.onDragStart,
    onMouseDown = _ref28.onMouseDown,
    onMouseMove = _ref28.onMouseMove,
    onMouseOut = _ref28.onMouseOut,
    onMouseOver = _ref28.onMouseOver,
    onMouseUp = _ref28.onMouseUp,
    onRightClick = _ref28.onRightClick,
    onClick = _ref28.onClick,
    onDrag = _ref28.onDrag,
    onLoad = _ref28.onLoad,
    onUnmount = _ref28.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState138 = React.useState(null),
    _React$useState139 = _slicedToArray2(_React$useState138, 2),
    instance = _React$useState139[0],
    setInstance = _React$useState139[1];
  var _React$useState140 = React.useState(null),
    _React$useState141 = _slicedToArray2(_React$useState140, 2),
    dblclickListener = _React$useState141[0],
    setDblclickListener = _React$useState141[1];
  var _React$useState142 = React.useState(null),
    _React$useState143 = _slicedToArray2(_React$useState142, 2),
    dragendListener = _React$useState143[0],
    setDragendListener = _React$useState143[1];
  var _React$useState144 = React.useState(null),
    _React$useState145 = _slicedToArray2(_React$useState144, 2),
    dragstartListener = _React$useState145[0],
    setDragstartListener = _React$useState145[1];
  var _React$useState146 = React.useState(null),
    _React$useState147 = _slicedToArray2(_React$useState146, 2),
    mousedownListener = _React$useState147[0],
    setMousedownListener = _React$useState147[1];
  var _React$useState148 = React.useState(null),
    _React$useState149 = _slicedToArray2(_React$useState148, 2),
    mousemoveListener = _React$useState149[0],
    setMousemoveListener = _React$useState149[1];
  var _React$useState150 = React.useState(null),
    _React$useState151 = _slicedToArray2(_React$useState150, 2),
    mouseoutListener = _React$useState151[0],
    setMouseoutListener = _React$useState151[1];
  var _React$useState152 = React.useState(null),
    _React$useState153 = _slicedToArray2(_React$useState152, 2),
    mouseoverListener = _React$useState153[0],
    setMouseoverListener = _React$useState153[1];
  var _React$useState154 = React.useState(null),
    _React$useState155 = _slicedToArray2(_React$useState154, 2),
    mouseupListener = _React$useState155[0],
    setMouseupListener = _React$useState155[1];
  var _React$useState156 = React.useState(null),
    _React$useState157 = _slicedToArray2(_React$useState156, 2),
    rightclickListener = _React$useState157[0],
    setRightclickListener = _React$useState157[1];
  var _React$useState158 = React.useState(null),
    _React$useState159 = _slicedToArray2(_React$useState158, 2),
    clickListener = _React$useState159[0],
    setClickListener = _React$useState159[1];
  var _React$useState160 = React.useState(null),
    _React$useState161 = _slicedToArray2(_React$useState160, 2),
    dragListener = _React$useState161[0],
    setDragListener = _React$useState161[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, options || defaultOptions$1), {
      map: map
    }));
    if (path) {
      polyline.setPath(path);
    }
    if (typeof visible !== 'undefined') {
      polyline.setVisible(visible);
    }
    if (typeof editable !== 'undefined') {
      polyline.setEditable(editable);
    }
    if (typeof draggable !== 'undefined') {
      polyline.setDraggable(draggable);
    }
    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polyline, 'dblclick', onDblClick));
    }
    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polyline, 'dragend', onDragEnd));
    }
    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polyline, 'dragstart', onDragStart));
    }
    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polyline, 'mousedown', onMouseDown));
    }
    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polyline, 'mousemove', onMouseMove));
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polyline, 'mouseout', onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polyline, 'mouseover', onMouseOver));
    }
    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polyline, 'mouseup', onMouseUp));
    }
    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polyline, 'rightclick', onRightClick));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(polyline, 'click', onClick));
    }
    if (onDrag) {
      setDragListener(google.maps.event.addListener(polyline, 'drag', onDrag));
    }
    setInstance(polyline);
    if (onLoad) {
      onLoad(polyline);
    }
    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (onUnmount) {
        onUnmount(polyline);
      }
      polyline.setMap(null);
    };
  }, []);
  return null;
}
React.memo(PolylineFunctional);
var Polyline = /*#__PURE__*/function (_React$PureComponent11) {
  _inherits2(Polyline, _React$PureComponent11);
  var _super14 = _createSuper2(Polyline);
  function Polyline() {
    var _this27;
    _classCallCheck2(this, Polyline);
    _this27 = _super14.apply(this, arguments);
    _this27.registeredEvents = [];
    _this27.state = {
      polyline: null
    };
    _this27.setPolylineCallback = function () {
      if (_this27.state.polyline !== null && _this27.props.onLoad) {
        _this27.props.onLoad(_this27.state.polyline);
      }
    };
    return _this27;
  }
  _createClass2(Polyline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polyline = new google.maps.Polyline(Object.assign(Object.assign({}, this.props.options || {}), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: {},
        nextProps: this.props,
        instance: polyline
      });
      this.setState(function setPolyline() {
        return {
          polyline: polyline
        };
      }, this.setPolylineCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polyline !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$b,
          eventMap: eventMap$b,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polyline
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polyline !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polyline);
        }
        unregisterEvents(this.registeredEvents);
        this.state.polyline.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Polyline;
}(React.PureComponent);
Polyline.contextType = MapContext;

/* global google */
var eventMap$a = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$a = {
  draggable: function draggable(instance, _draggable3) {
    instance.setDraggable(_draggable3);
  },
  editable: function editable(instance, _editable2) {
    instance.setEditable(_editable2);
  },
  map: function map(instance, _map3) {
    instance.setMap(_map3);
  },
  options: function options(instance, _options8) {
    instance.setOptions(_options8);
  },
  path: function path(instance, _path2) {
    instance.setPath(_path2);
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths);
  },
  visible: function visible(instance, _visible4) {
    instance.setVisible(_visible4);
  }
};
function PolygonFunctional(_ref29) {
  var options = _ref29.options,
    draggable = _ref29.draggable,
    editable = _ref29.editable,
    visible = _ref29.visible,
    path = _ref29.path,
    paths = _ref29.paths,
    onDblClick = _ref29.onDblClick,
    onDragEnd = _ref29.onDragEnd,
    onDragStart = _ref29.onDragStart,
    onMouseDown = _ref29.onMouseDown,
    onMouseMove = _ref29.onMouseMove,
    onMouseOut = _ref29.onMouseOut,
    onMouseOver = _ref29.onMouseOver,
    onMouseUp = _ref29.onMouseUp,
    onRightClick = _ref29.onRightClick,
    onClick = _ref29.onClick,
    onDrag = _ref29.onDrag,
    onLoad = _ref29.onLoad,
    onUnmount = _ref29.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState162 = React.useState(null),
    _React$useState163 = _slicedToArray2(_React$useState162, 2),
    instance = _React$useState163[0],
    setInstance = _React$useState163[1];
  var _React$useState164 = React.useState(null),
    _React$useState165 = _slicedToArray2(_React$useState164, 2),
    dblclickListener = _React$useState165[0],
    setDblclickListener = _React$useState165[1];
  var _React$useState166 = React.useState(null),
    _React$useState167 = _slicedToArray2(_React$useState166, 2),
    dragendListener = _React$useState167[0],
    setDragendListener = _React$useState167[1];
  var _React$useState168 = React.useState(null),
    _React$useState169 = _slicedToArray2(_React$useState168, 2),
    dragstartListener = _React$useState169[0],
    setDragstartListener = _React$useState169[1];
  var _React$useState170 = React.useState(null),
    _React$useState171 = _slicedToArray2(_React$useState170, 2),
    mousedownListener = _React$useState171[0],
    setMousedownListener = _React$useState171[1];
  var _React$useState172 = React.useState(null),
    _React$useState173 = _slicedToArray2(_React$useState172, 2),
    mousemoveListener = _React$useState173[0],
    setMousemoveListener = _React$useState173[1];
  var _React$useState174 = React.useState(null),
    _React$useState175 = _slicedToArray2(_React$useState174, 2),
    mouseoutListener = _React$useState175[0],
    setMouseoutListener = _React$useState175[1];
  var _React$useState176 = React.useState(null),
    _React$useState177 = _slicedToArray2(_React$useState176, 2),
    mouseoverListener = _React$useState177[0],
    setMouseoverListener = _React$useState177[1];
  var _React$useState178 = React.useState(null),
    _React$useState179 = _slicedToArray2(_React$useState178, 2),
    mouseupListener = _React$useState179[0],
    setMouseupListener = _React$useState179[1];
  var _React$useState180 = React.useState(null),
    _React$useState181 = _slicedToArray2(_React$useState180, 2),
    rightclickListener = _React$useState181[0],
    setRightclickListener = _React$useState181[1];
  var _React$useState182 = React.useState(null),
    _React$useState183 = _slicedToArray2(_React$useState182, 2),
    clickListener = _React$useState183[0],
    setClickListener = _React$useState183[1];
  var _React$useState184 = React.useState(null),
    _React$useState185 = _slicedToArray2(_React$useState184, 2),
    dragListener = _React$useState185[0],
    setDragListener = _React$useState185[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof path !== 'undefined' && instance !== null) {
      instance.setPath(path);
    }
  }, [instance, path]);
  React.useEffect(function () {
    if (typeof paths !== 'undefined' && instance !== null) {
      instance.setPaths(paths);
    }
  }, [instance, paths]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    if (path) {
      polygon.setPath(path);
    }
    if (paths) {
      polygon.setPaths(paths);
    }
    if (typeof visible !== 'undefined') {
      polygon.setVisible(visible);
    }
    if (typeof editable !== 'undefined') {
      polygon.setEditable(editable);
    }
    if (typeof draggable !== 'undefined') {
      polygon.setDraggable(draggable);
    }
    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(polygon, 'dblclick', onDblClick));
    }
    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(polygon, 'dragend', onDragEnd));
    }
    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(polygon, 'dragstart', onDragStart));
    }
    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(polygon, 'mousedown', onMouseDown));
    }
    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(polygon, 'mousemove', onMouseMove));
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(polygon, 'mouseout', onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(polygon, 'mouseover', onMouseOver));
    }
    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(polygon, 'mouseup', onMouseUp));
    }
    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(polygon, 'rightclick', onRightClick));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(polygon, 'click', onClick));
    }
    if (onDrag) {
      setDragListener(google.maps.event.addListener(polygon, 'drag', onDrag));
    }
    setInstance(polygon);
    if (onLoad) {
      onLoad(polygon);
    }
    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (onUnmount) {
        onUnmount(polygon);
      }
      polygon.setMap(null);
    };
  }, []);
  return null;
}
React.memo(PolygonFunctional);
var Polygon = /*#__PURE__*/function (_React$PureComponent12) {
  _inherits2(Polygon, _React$PureComponent12);
  var _super15 = _createSuper2(Polygon);
  function Polygon() {
    var _this28;
    _classCallCheck2(this, Polygon);
    _this28 = _super15.apply(this, arguments);
    _this28.registeredEvents = [];
    _this28.state = {
      polygon: null
    };
    _this28.setPolygonCallback = function () {
      if (_this28.state.polygon !== null && _this28.props.onLoad) {
        _this28.props.onLoad(_this28.state.polygon);
      }
    };
    return _this28;
  }
  _createClass2(Polygon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var polygon = new google.maps.Polygon(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: {},
        nextProps: this.props,
        instance: polygon
      });
      this.setState(function setPolygon() {
        return {
          polygon: polygon
        };
      }, this.setPolygonCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.polygon !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$a,
          eventMap: eventMap$a,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.polygon
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.polygon !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.polygon);
        }
        unregisterEvents(this.registeredEvents);
        this.state.polygon && this.state.polygon.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Polygon;
}(React.PureComponent);
Polygon.contextType = MapContext;
var eventMap$9 = {
  onBoundsChanged: 'bounds_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$9 = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  draggable: function draggable(instance, _draggable4) {
    instance.setDraggable(_draggable4);
  },
  editable: function editable(instance, _editable3) {
    instance.setEditable(_editable3);
  },
  map: function map(instance, _map4) {
    instance.setMap(_map4);
  },
  options: function options(instance, _options9) {
    instance.setOptions(_options9);
  },
  visible: function visible(instance, _visible5) {
    instance.setVisible(_visible5);
  }
};
function RectangleFunctional(_ref30) {
  var options = _ref30.options,
    bounds = _ref30.bounds,
    draggable = _ref30.draggable,
    editable = _ref30.editable,
    visible = _ref30.visible,
    onDblClick = _ref30.onDblClick,
    onDragEnd = _ref30.onDragEnd,
    onDragStart = _ref30.onDragStart,
    onMouseDown = _ref30.onMouseDown,
    onMouseMove = _ref30.onMouseMove,
    onMouseOut = _ref30.onMouseOut,
    onMouseOver = _ref30.onMouseOver,
    onMouseUp = _ref30.onMouseUp,
    onRightClick = _ref30.onRightClick,
    onClick = _ref30.onClick,
    onDrag = _ref30.onDrag,
    onBoundsChanged = _ref30.onBoundsChanged,
    onLoad = _ref30.onLoad,
    onUnmount = _ref30.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState186 = React.useState(null),
    _React$useState187 = _slicedToArray2(_React$useState186, 2),
    instance = _React$useState187[0],
    setInstance = _React$useState187[1];
  var _React$useState188 = React.useState(null),
    _React$useState189 = _slicedToArray2(_React$useState188, 2),
    dblclickListener = _React$useState189[0],
    setDblclickListener = _React$useState189[1];
  var _React$useState190 = React.useState(null),
    _React$useState191 = _slicedToArray2(_React$useState190, 2),
    dragendListener = _React$useState191[0],
    setDragendListener = _React$useState191[1];
  var _React$useState192 = React.useState(null),
    _React$useState193 = _slicedToArray2(_React$useState192, 2),
    dragstartListener = _React$useState193[0],
    setDragstartListener = _React$useState193[1];
  var _React$useState194 = React.useState(null),
    _React$useState195 = _slicedToArray2(_React$useState194, 2),
    mousedownListener = _React$useState195[0],
    setMousedownListener = _React$useState195[1];
  var _React$useState196 = React.useState(null),
    _React$useState197 = _slicedToArray2(_React$useState196, 2),
    mousemoveListener = _React$useState197[0],
    setMousemoveListener = _React$useState197[1];
  var _React$useState198 = React.useState(null),
    _React$useState199 = _slicedToArray2(_React$useState198, 2),
    mouseoutListener = _React$useState199[0],
    setMouseoutListener = _React$useState199[1];
  var _React$useState200 = React.useState(null),
    _React$useState201 = _slicedToArray2(_React$useState200, 2),
    mouseoverListener = _React$useState201[0],
    setMouseoverListener = _React$useState201[1];
  var _React$useState202 = React.useState(null),
    _React$useState203 = _slicedToArray2(_React$useState202, 2),
    mouseupListener = _React$useState203[0],
    setMouseupListener = _React$useState203[1];
  var _React$useState204 = React.useState(null),
    _React$useState205 = _slicedToArray2(_React$useState204, 2),
    rightclickListener = _React$useState205[0],
    setRightclickListener = _React$useState205[1];
  var _React$useState206 = React.useState(null),
    _React$useState207 = _slicedToArray2(_React$useState206, 2),
    clickListener = _React$useState207[0],
    setClickListener = _React$useState207[1];
  var _React$useState208 = React.useState(null),
    _React$useState209 = _slicedToArray2(_React$useState208, 2),
    dragListener = _React$useState209[0],
    setDragListener = _React$useState209[1];
  var _React$useState210 = React.useState(null),
    _React$useState211 = _slicedToArray2(_React$useState210, 2),
    boundsChangedListener = _React$useState211[0],
    setBoundsChangedListener = _React$useState211[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof bounds !== 'undefined' && instance !== null) {
      instance.setBounds(bounds);
    }
  }, [instance, bounds]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onBoundsChanged) {
      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }
      setBoundsChangedListener(google.maps.event.addListener(instance, 'bounds_changed', onBoundsChanged));
    }
  }, [onBoundsChanged]);
  React.useEffect(function () {
    var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, options || {}), {
      map: map
    }));
    if (typeof visible !== 'undefined') {
      rectangle.setVisible(visible);
    }
    if (typeof editable !== 'undefined') {
      rectangle.setEditable(editable);
    }
    if (typeof draggable !== 'undefined') {
      rectangle.setDraggable(draggable);
    }
    if (typeof bounds !== 'undefined') {
      rectangle.setBounds(bounds);
    }
    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(rectangle, 'dblclick', onDblClick));
    }
    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(rectangle, 'dragend', onDragEnd));
    }
    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(rectangle, 'dragstart', onDragStart));
    }
    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(rectangle, 'mousedown', onMouseDown));
    }
    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(rectangle, 'mousemove', onMouseMove));
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(rectangle, 'mouseout', onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(rectangle, 'mouseover', onMouseOver));
    }
    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(rectangle, 'mouseup', onMouseUp));
    }
    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(rectangle, 'rightclick', onRightClick));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(rectangle, 'click', onClick));
    }
    if (onDrag) {
      setDragListener(google.maps.event.addListener(rectangle, 'drag', onDrag));
    }
    if (onBoundsChanged) {
      setBoundsChangedListener(google.maps.event.addListener(rectangle, 'bounds_changed', onBoundsChanged));
    }
    setInstance(rectangle);
    if (onLoad) {
      onLoad(rectangle);
    }
    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      if (boundsChangedListener !== null) {
        google.maps.event.removeListener(boundsChangedListener);
      }
      if (onUnmount) {
        onUnmount(rectangle);
      }
      rectangle.setMap(null);
    };
  }, []);
  return null;
}
React.memo(RectangleFunctional);
var Rectangle = /*#__PURE__*/function (_React$PureComponent13) {
  _inherits2(Rectangle, _React$PureComponent13);
  var _super16 = _createSuper2(Rectangle);
  function Rectangle() {
    var _this29;
    _classCallCheck2(this, Rectangle);
    _this29 = _super16.apply(this, arguments);
    _this29.registeredEvents = [];
    _this29.state = {
      rectangle: null
    };
    _this29.setRectangleCallback = function () {
      if (_this29.state.rectangle !== null && _this29.props.onLoad) {
        _this29.props.onLoad(_this29.state.rectangle);
      }
    };
    return _this29;
  }
  _createClass2(Rectangle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var rectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: {},
        nextProps: this.props,
        instance: rectangle
      });
      this.setState(function setRectangle() {
        return {
          rectangle: rectangle
        };
      }, this.setRectangleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.rectangle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$9,
          eventMap: eventMap$9,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.rectangle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.rectangle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.rectangle);
        }
        unregisterEvents(this.registeredEvents);
        this.state.rectangle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Rectangle;
}(React.PureComponent);
Rectangle.contextType = MapContext;
var eventMap$8 = {
  onCenterChanged: 'center_changed',
  onRadiusChanged: 'radius_changed',
  onClick: 'click',
  onDblClick: 'dblclick',
  onDrag: 'drag',
  onDragEnd: 'dragend',
  onDragStart: 'dragstart',
  onMouseDown: 'mousedown',
  onMouseMove: 'mousemove',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick'
};
var updaterMap$8 = {
  center: function center(instance, _center2) {
    instance.setCenter(_center2);
  },
  draggable: function draggable(instance, _draggable5) {
    instance.setDraggable(_draggable5);
  },
  editable: function editable(instance, _editable4) {
    instance.setEditable(_editable4);
  },
  map: function map(instance, _map5) {
    instance.setMap(_map5);
  },
  options: function options(instance, _options10) {
    instance.setOptions(_options10);
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius);
  },
  visible: function visible(instance, _visible6) {
    instance.setVisible(_visible6);
  }
};
var defaultOptions = {};
function CircleFunctional(_ref31) {
  var options = _ref31.options,
    center = _ref31.center,
    radius = _ref31.radius,
    draggable = _ref31.draggable,
    editable = _ref31.editable,
    visible = _ref31.visible,
    onDblClick = _ref31.onDblClick,
    onDragEnd = _ref31.onDragEnd,
    onDragStart = _ref31.onDragStart,
    onMouseDown = _ref31.onMouseDown,
    onMouseMove = _ref31.onMouseMove,
    onMouseOut = _ref31.onMouseOut,
    onMouseOver = _ref31.onMouseOver,
    onMouseUp = _ref31.onMouseUp,
    onRightClick = _ref31.onRightClick,
    onClick = _ref31.onClick,
    onDrag = _ref31.onDrag,
    onCenterChanged = _ref31.onCenterChanged,
    onRadiusChanged = _ref31.onRadiusChanged,
    onLoad = _ref31.onLoad,
    onUnmount = _ref31.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState212 = React.useState(null),
    _React$useState213 = _slicedToArray2(_React$useState212, 2),
    instance = _React$useState213[0],
    setInstance = _React$useState213[1];
  var _React$useState214 = React.useState(null),
    _React$useState215 = _slicedToArray2(_React$useState214, 2),
    dblclickListener = _React$useState215[0],
    setDblclickListener = _React$useState215[1];
  var _React$useState216 = React.useState(null),
    _React$useState217 = _slicedToArray2(_React$useState216, 2),
    dragendListener = _React$useState217[0],
    setDragendListener = _React$useState217[1];
  var _React$useState218 = React.useState(null),
    _React$useState219 = _slicedToArray2(_React$useState218, 2),
    dragstartListener = _React$useState219[0],
    setDragstartListener = _React$useState219[1];
  var _React$useState220 = React.useState(null),
    _React$useState221 = _slicedToArray2(_React$useState220, 2),
    mousedownListener = _React$useState221[0],
    setMousedownListener = _React$useState221[1];
  var _React$useState222 = React.useState(null),
    _React$useState223 = _slicedToArray2(_React$useState222, 2),
    mousemoveListener = _React$useState223[0],
    setMousemoveListener = _React$useState223[1];
  var _React$useState224 = React.useState(null),
    _React$useState225 = _slicedToArray2(_React$useState224, 2),
    mouseoutListener = _React$useState225[0],
    setMouseoutListener = _React$useState225[1];
  var _React$useState226 = React.useState(null),
    _React$useState227 = _slicedToArray2(_React$useState226, 2),
    mouseoverListener = _React$useState227[0],
    setMouseoverListener = _React$useState227[1];
  var _React$useState228 = React.useState(null),
    _React$useState229 = _slicedToArray2(_React$useState228, 2),
    mouseupListener = _React$useState229[0],
    setMouseupListener = _React$useState229[1];
  var _React$useState230 = React.useState(null),
    _React$useState231 = _slicedToArray2(_React$useState230, 2),
    rightclickListener = _React$useState231[0],
    setRightclickListener = _React$useState231[1];
  var _React$useState232 = React.useState(null),
    _React$useState233 = _slicedToArray2(_React$useState232, 2),
    clickListener = _React$useState233[0],
    setClickListener = _React$useState233[1];
  var _React$useState234 = React.useState(null),
    _React$useState235 = _slicedToArray2(_React$useState234, 2),
    dragListener = _React$useState235[0],
    setDragListener = _React$useState235[1];
  var _React$useState236 = React.useState(null),
    _React$useState237 = _slicedToArray2(_React$useState236, 2),
    centerChangedListener = _React$useState237[0],
    setCenterChangedListener = _React$useState237[1];
  var _React$useState238 = React.useState(null),
    _React$useState239 = _slicedToArray2(_React$useState238, 2),
    radiusChangedListener = _React$useState239[0],
    setRadiusChangedListener = _React$useState239[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof options !== 'undefined' && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    if (typeof draggable !== 'undefined' && instance !== null) {
      instance.setDraggable(draggable);
    }
  }, [instance, draggable]);
  React.useEffect(function () {
    if (typeof editable !== 'undefined' && instance !== null) {
      instance.setEditable(editable);
    }
  }, [instance, editable]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && instance !== null) {
      instance.setVisible(visible);
    }
  }, [instance, visible]);
  React.useEffect(function () {
    if (typeof radius === 'number' && instance !== null) {
      instance.setRadius(radius);
    }
  }, [instance, radius]);
  React.useEffect(function () {
    if (typeof center !== 'undefined' && instance !== null) {
      instance.setCenter(center);
    }
  }, [instance, center]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onDragEnd) {
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      setDragendListener(google.maps.event.addListener(instance, 'dragend', onDragEnd));
    }
  }, [onDragEnd]);
  React.useEffect(function () {
    if (instance && onDragStart) {
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      setDragstartListener(google.maps.event.addListener(instance, 'dragstart', onDragStart));
    }
  }, [onDragStart]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onDrag) {
      if (dragListener !== null) {
        google.maps.event.removeListener(dragListener);
      }
      setDragListener(google.maps.event.addListener(instance, 'drag', onDrag));
    }
  }, [onDrag]);
  React.useEffect(function () {
    if (instance && onCenterChanged) {
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }
      setCenterChangedListener(google.maps.event.addListener(instance, 'center_changed', onCenterChanged));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onRadiusChanged) {
      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }
      setRadiusChangedListener(google.maps.event.addListener(instance, 'radius_changed', onRadiusChanged));
    }
  }, [onRadiusChanged]);
  React.useEffect(function () {
    var circle = new google.maps.Circle(Object.assign(Object.assign({}, options || defaultOptions), {
      map: map
    }));
    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }
    if (typeof center !== 'undefined') {
      circle.setCenter(center);
    }
    if (typeof radius === 'number') {
      circle.setRadius(radius);
    }
    if (typeof visible !== 'undefined') {
      circle.setVisible(visible);
    }
    if (typeof editable !== 'undefined') {
      circle.setEditable(editable);
    }
    if (typeof draggable !== 'undefined') {
      circle.setDraggable(draggable);
    }
    if (onDblClick) {
      setDblclickListener(google.maps.event.addListener(circle, 'dblclick', onDblClick));
    }
    if (onDragEnd) {
      setDragendListener(google.maps.event.addListener(circle, 'dragend', onDragEnd));
    }
    if (onDragStart) {
      setDragstartListener(google.maps.event.addListener(circle, 'dragstart', onDragStart));
    }
    if (onMouseDown) {
      setMousedownListener(google.maps.event.addListener(circle, 'mousedown', onMouseDown));
    }
    if (onMouseMove) {
      setMousemoveListener(google.maps.event.addListener(circle, 'mousemove', onMouseMove));
    }
    if (onMouseOut) {
      setMouseoutListener(google.maps.event.addListener(circle, 'mouseout', onMouseOut));
    }
    if (onMouseOver) {
      setMouseoverListener(google.maps.event.addListener(circle, 'mouseover', onMouseOver));
    }
    if (onMouseUp) {
      setMouseupListener(google.maps.event.addListener(circle, 'mouseup', onMouseUp));
    }
    if (onRightClick) {
      setRightclickListener(google.maps.event.addListener(circle, 'rightclick', onRightClick));
    }
    if (onClick) {
      setClickListener(google.maps.event.addListener(circle, 'click', onClick));
    }
    if (onDrag) {
      setDragListener(google.maps.event.addListener(circle, 'drag', onDrag));
    }
    if (onCenterChanged) {
      setCenterChangedListener(google.maps.event.addListener(circle, 'center_changed', onCenterChanged));
    }
    if (onRadiusChanged) {
      setRadiusChangedListener(google.maps.event.addListener(circle, 'radius_changed', onRadiusChanged));
    }
    setInstance(circle);
    if (onLoad) {
      onLoad(circle);
    }
    return function () {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      if (dragendListener !== null) {
        google.maps.event.removeListener(dragendListener);
      }
      if (dragstartListener !== null) {
        google.maps.event.removeListener(dragstartListener);
      }
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      if (centerChangedListener !== null) {
        google.maps.event.removeListener(centerChangedListener);
      }
      if (radiusChangedListener !== null) {
        google.maps.event.removeListener(radiusChangedListener);
      }
      if (onUnmount) {
        onUnmount(circle);
      }
      circle.setMap(null);
    };
  }, []);
  return null;
}
React.memo(CircleFunctional);
var Circle = /*#__PURE__*/function (_React$PureComponent14) {
  _inherits2(Circle, _React$PureComponent14);
  var _super17 = _createSuper2(Circle);
  function Circle() {
    var _this30;
    _classCallCheck2(this, Circle);
    _this30 = _super17.apply(this, arguments);
    _this30.registeredEvents = [];
    _this30.state = {
      circle: null
    };
    _this30.setCircleCallback = function () {
      if (_this30.state.circle !== null && _this30.props.onLoad) {
        _this30.props.onLoad(_this30.state.circle);
      }
    };
    return _this30;
  }
  _createClass2(Circle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var circle = new google.maps.Circle(Object.assign(Object.assign({}, this.props.options || {}), {
        // @ts-ignore
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: {},
        nextProps: this.props,
        instance: circle
      });
      this.setState(function setCircle() {
        return {
          circle: circle
        };
      }, this.setCircleCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.circle !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$8,
          eventMap: eventMap$8,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.circle
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.circle !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.circle);
        }
        unregisterEvents(this.registeredEvents);
        this.state.circle && this.state.circle.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Circle;
}(React.PureComponent);
Circle.contextType = MapContext;
var eventMap$7 = {
  onClick: 'click',
  onDblClick: 'dblclick',
  onMouseDown: 'mousedown',
  onMouseOut: 'mouseout',
  onMouseOver: 'mouseover',
  onMouseUp: 'mouseup',
  onRightClick: 'rightclick',
  onAddFeature: 'addfeature',
  onRemoveFeature: 'removefeature',
  onRemoveProperty: 'removeproperty',
  onSetGeometry: 'setgeometry',
  onSetProperty: 'setproperty'
};
var updaterMap$7 = {
  add: function add(instance, feature) {
    instance.add(feature);
  },
  addgeojson: function addgeojson(instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function contains(instance, feature) {
    instance.contains(feature);
  },
  foreach: function foreach(instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function loadgeojson(instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function overridestyle(instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function remove(instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function revertstyle(instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function controlposition(instance, controlPosition) {
    instance.setControlPosition(controlPosition);
  },
  controls: function controls(instance, _controls) {
    instance.setControls(_controls);
  },
  drawingmode: function drawingmode(instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function map(instance, _map6) {
    instance.setMap(_map6);
  },
  style: function style(instance, _style) {
    instance.setStyle(_style);
  },
  togeojson: function togeojson(instance, callback) {
    instance.toGeoJson(callback);
  }
};
function DataFunctional(_ref32) {
  var options = _ref32.options,
    onClick = _ref32.onClick,
    onDblClick = _ref32.onDblClick,
    onMouseDown = _ref32.onMouseDown,
    onMouseMove = _ref32.onMouseMove,
    onMouseOut = _ref32.onMouseOut,
    onMouseOver = _ref32.onMouseOver,
    onMouseUp = _ref32.onMouseUp,
    onRightClick = _ref32.onRightClick,
    onAddFeature = _ref32.onAddFeature,
    onRemoveFeature = _ref32.onRemoveFeature,
    onRemoveProperty = _ref32.onRemoveProperty,
    onSetGeometry = _ref32.onSetGeometry,
    onSetProperty = _ref32.onSetProperty,
    onLoad = _ref32.onLoad,
    onUnmount = _ref32.onUnmount;
  var map = React.useContext(MapContext);
  var _React$useState240 = React.useState(null),
    _React$useState241 = _slicedToArray2(_React$useState240, 2),
    instance = _React$useState241[0],
    setInstance = _React$useState241[1];
  var _React$useState242 = React.useState(null),
    _React$useState243 = _slicedToArray2(_React$useState242, 2),
    dblclickListener = _React$useState243[0],
    setDblclickListener = _React$useState243[1];
  var _React$useState244 = React.useState(null),
    _React$useState245 = _slicedToArray2(_React$useState244, 2),
    mousedownListener = _React$useState245[0],
    setMousedownListener = _React$useState245[1];
  var _React$useState246 = React.useState(null),
    _React$useState247 = _slicedToArray2(_React$useState246, 2),
    mousemoveListener = _React$useState247[0],
    setMousemoveListener = _React$useState247[1];
  var _React$useState248 = React.useState(null),
    _React$useState249 = _slicedToArray2(_React$useState248, 2),
    mouseoutListener = _React$useState249[0],
    setMouseoutListener = _React$useState249[1];
  var _React$useState250 = React.useState(null),
    _React$useState251 = _slicedToArray2(_React$useState250, 2),
    mouseoverListener = _React$useState251[0],
    setMouseoverListener = _React$useState251[1];
  var _React$useState252 = React.useState(null),
    _React$useState253 = _slicedToArray2(_React$useState252, 2),
    mouseupListener = _React$useState253[0],
    setMouseupListener = _React$useState253[1];
  var _React$useState254 = React.useState(null),
    _React$useState255 = _slicedToArray2(_React$useState254, 2),
    rightclickListener = _React$useState255[0],
    setRightclickListener = _React$useState255[1];
  var _React$useState256 = React.useState(null),
    _React$useState257 = _slicedToArray2(_React$useState256, 2),
    clickListener = _React$useState257[0],
    setClickListener = _React$useState257[1];
  var _React$useState258 = React.useState(null),
    _React$useState259 = _slicedToArray2(_React$useState258, 2),
    addFeatureListener = _React$useState259[0],
    setAddFeatureListener = _React$useState259[1];
  var _React$useState260 = React.useState(null),
    _React$useState261 = _slicedToArray2(_React$useState260, 2),
    removeFeatureListener = _React$useState261[0],
    setRemoveFeatureListener = _React$useState261[1];
  var _React$useState262 = React.useState(null),
    _React$useState263 = _slicedToArray2(_React$useState262, 2),
    removePropertyListener = _React$useState263[0],
    setRemovePropertyListener = _React$useState263[1];
  var _React$useState264 = React.useState(null),
    _React$useState265 = _slicedToArray2(_React$useState264, 2),
    setGeometryListener = _React$useState265[0],
    setSetGeometryListener = _React$useState265[1];
  var _React$useState266 = React.useState(null),
    _React$useState267 = _slicedToArray2(_React$useState266, 2),
    setPropertyListener = _React$useState267[0],
    setSetPropertyListener = _React$useState267[1];
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (instance && onDblClick) {
      if (dblclickListener !== null) {
        google.maps.event.removeListener(dblclickListener);
      }
      setDblclickListener(google.maps.event.addListener(instance, 'dblclick', onDblClick));
    }
  }, [onDblClick]);
  React.useEffect(function () {
    if (instance && onMouseDown) {
      if (mousedownListener !== null) {
        google.maps.event.removeListener(mousedownListener);
      }
      setMousedownListener(google.maps.event.addListener(instance, 'mousedown', onMouseDown));
    }
  }, [onMouseDown]);
  React.useEffect(function () {
    if (instance && onMouseMove) {
      if (mousemoveListener !== null) {
        google.maps.event.removeListener(mousemoveListener);
      }
      setMousemoveListener(google.maps.event.addListener(instance, 'mousemove', onMouseMove));
    }
  }, [onMouseMove]);
  React.useEffect(function () {
    if (instance && onMouseOut) {
      if (mouseoutListener !== null) {
        google.maps.event.removeListener(mouseoutListener);
      }
      setMouseoutListener(google.maps.event.addListener(instance, 'mouseout', onMouseOut));
    }
  }, [onMouseOut]);
  React.useEffect(function () {
    if (instance && onMouseOver) {
      if (mouseoverListener !== null) {
        google.maps.event.removeListener(mouseoverListener);
      }
      setMouseoverListener(google.maps.event.addListener(instance, 'mouseover', onMouseOver));
    }
  }, [onMouseOver]);
  React.useEffect(function () {
    if (instance && onMouseUp) {
      if (mouseupListener !== null) {
        google.maps.event.removeListener(mouseupListener);
      }
      setMouseupListener(google.maps.event.addListener(instance, 'mouseup', onMouseUp));
    }
  }, [onMouseUp]);
  React.useEffect(function () {
    if (instance && onRightClick) {
      if (rightclickListener !== null) {
        google.maps.event.removeListener(rightclickListener);
      }
      setRightclickListener(google.maps.event.addListener(instance, 'rightclick', onRightClick));
    }
  }, [onRightClick]);
  React.useEffect(function () {
    if (instance && onClick) {
      if (clickListener !== null) {
        google.maps.event.removeListener(clickListener);
      }
      setClickListener(google.maps.event.addListener(instance, 'click', onClick));
    }
  }, [onClick]);
  React.useEffect(function () {
    if (instance && onAddFeature) {
      if (addFeatureListener !== null) {
        google.maps.event.removeListener(addFeatureListener);
      }
      setAddFeatureListener(google.maps.event.addListener(instance, 'addfeature', onAddFeature));
    }
  }, [onAddFeature]);
  React.useEffect(function () {
    if (instance && onRemoveFeature) {
      if (removeFeatureListener !== null) {
        google.maps.event.removeListener(removeFeatureListener);
      }
      setRemoveFeatureListener(google.maps.event.addListener(instance, 'removefeature', onRemoveFeature));
    }
  }, [onRemoveFeature]);
  React.useEffect(function () {
    if (instance && onRemoveProperty) {
      if (removePropertyListener !== null) {
        google.maps.event.removeListener(removePropertyListener);
      }
      setRemovePropertyListener(google.maps.event.addListener(instance, 'removeproperty', onRemoveProperty));
    }
  }, [onRemoveProperty]);
  React.useEffect(function () {
    if (instance && onSetGeometry) {
      if (setGeometryListener !== null) {
        google.maps.event.removeListener(setGeometryListener);
      }
      setSetGeometryListener(google.maps.event.addListener(instance, 'setgeometry', onSetGeometry));
    }
  }, [onSetGeometry]);
  React.useEffect(function () {
    if (instance && onSetProperty) {
      if (setPropertyListener !== null) {
        google.maps.event.removeListener(setPropertyListener);
      }
      setSetPropertyListener(google.maps.event.addListener(instance, 'setproperty', onSetProperty));
    }
  }, [onSetProperty]);
  React.useEffect(function () {
    if (map !== null) {
      var data = new google.maps.Data(Object.assign(Object.assign({}, options || {}), {
        map: map
      }));
      if (onDblClick) {
        setDblclickListener(google.maps.event.addListener(data, 'dblclick', onDblClick));
      }
      if (onMouseDown) {
        setMousedownListener(google.maps.event.addListener(data, 'mousedown', onMouseDown));
      }
      if (onMouseMove) {
        setMousemoveListener(google.maps.event.addListener(data, 'mousemove', onMouseMove));
      }
      if (onMouseOut) {
        setMouseoutListener(google.maps.event.addListener(data, 'mouseout', onMouseOut));
      }
      if (onMouseOver) {
        setMouseoverListener(google.maps.event.addListener(data, 'mouseover', onMouseOver));
      }
      if (onMouseUp) {
        setMouseupListener(google.maps.event.addListener(data, 'mouseup', onMouseUp));
      }
      if (onRightClick) {
        setRightclickListener(google.maps.event.addListener(data, 'rightclick', onRightClick));
      }
      if (onClick) {
        setClickListener(google.maps.event.addListener(data, 'click', onClick));
      }
      if (onAddFeature) {
        setAddFeatureListener(google.maps.event.addListener(data, 'addfeature', onAddFeature));
      }
      if (onRemoveFeature) {
        setRemoveFeatureListener(google.maps.event.addListener(data, 'removefeature', onRemoveFeature));
      }
      if (onRemoveProperty) {
        setRemovePropertyListener(google.maps.event.addListener(data, 'removeproperty', onRemoveProperty));
      }
      if (onSetGeometry) {
        setSetGeometryListener(google.maps.event.addListener(data, 'setgeometry', onSetGeometry));
      }
      if (onSetProperty) {
        setSetPropertyListener(google.maps.event.addListener(data, 'setproperty', onSetProperty));
      }
      setInstance(data);
      if (onLoad) {
        onLoad(data);
      }
    }
    return function () {
      if (instance) {
        if (dblclickListener !== null) {
          google.maps.event.removeListener(dblclickListener);
        }
        if (mousedownListener !== null) {
          google.maps.event.removeListener(mousedownListener);
        }
        if (mousemoveListener !== null) {
          google.maps.event.removeListener(mousemoveListener);
        }
        if (mouseoutListener !== null) {
          google.maps.event.removeListener(mouseoutListener);
        }
        if (mouseoverListener !== null) {
          google.maps.event.removeListener(mouseoverListener);
        }
        if (mouseupListener !== null) {
          google.maps.event.removeListener(mouseupListener);
        }
        if (rightclickListener !== null) {
          google.maps.event.removeListener(rightclickListener);
        }
        if (clickListener !== null) {
          google.maps.event.removeListener(clickListener);
        }
        if (addFeatureListener !== null) {
          google.maps.event.removeListener(addFeatureListener);
        }
        if (removeFeatureListener !== null) {
          google.maps.event.removeListener(removeFeatureListener);
        }
        if (removePropertyListener !== null) {
          google.maps.event.removeListener(removePropertyListener);
        }
        if (setGeometryListener !== null) {
          google.maps.event.removeListener(setGeometryListener);
        }
        if (setPropertyListener !== null) {
          google.maps.event.removeListener(setPropertyListener);
        }
        if (onUnmount) {
          onUnmount(instance);
        }
        instance.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(DataFunctional);
var Data = /*#__PURE__*/function (_React$PureComponent15) {
  _inherits2(Data, _React$PureComponent15);
  var _super18 = _createSuper2(Data);
  function Data() {
    var _this31;
    _classCallCheck2(this, Data);
    _this31 = _super18.apply(this, arguments);
    _this31.registeredEvents = [];
    _this31.state = {
      data: null
    };
    _this31.setDataCallback = function () {
      if (_this31.state.data !== null && _this31.props.onLoad) {
        _this31.props.onLoad(_this31.state.data);
      }
    };
    return _this31;
  }
  _createClass2(Data, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.context !== null) {
        var data = new google.maps.Data(Object.assign(Object.assign({}, this.props.options || {}), {
          map: this.context
        }));
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: {},
          nextProps: this.props,
          instance: data
        });
        this.setState(function () {
          return {
            data: data
          };
        }, this.setDataCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.data !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$7,
          eventMap: eventMap$7,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.data
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.data !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.data);
        }
        unregisterEvents(this.registeredEvents);
        if (this.state.data) {
          this.state.data.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Data;
}(React.PureComponent);
Data.contextType = MapContext;
var eventMap$6 = {
  onClick: 'click',
  onDefaultViewportChanged: 'defaultviewport_changed',
  onStatusChanged: 'status_changed'
};
var updaterMap$6 = {
  options: function options(instance, _options11) {
    instance.setOptions(_options11);
  },
  url: function url(instance, _url) {
    instance.setUrl(_url);
  },
  zIndex: function zIndex(instance, _zIndex4) {
    instance.setZIndex(_zIndex4);
  }
};
var KmlLayer = /*#__PURE__*/function (_React$PureComponent16) {
  _inherits2(KmlLayer, _React$PureComponent16);
  var _super19 = _createSuper2(KmlLayer);
  function KmlLayer() {
    var _this32;
    _classCallCheck2(this, KmlLayer);
    _this32 = _super19.apply(this, arguments);
    _this32.registeredEvents = [];
    _this32.state = {
      kmlLayer: null
    };
    _this32.setKmlLayerCallback = function () {
      if (_this32.state.kmlLayer !== null && _this32.props.onLoad) {
        _this32.props.onLoad(_this32.state.kmlLayer);
      }
    };
    return _this32;
  }
  _createClass2(KmlLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var kmlLayer = new google.maps.KmlLayer(Object.assign(Object.assign({}, this.props.options), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: {},
        nextProps: this.props,
        instance: kmlLayer
      });
      this.setState(function setLmlLayer() {
        return {
          kmlLayer: kmlLayer
        };
      }, this.setKmlLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.kmlLayer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$6,
          eventMap: eventMap$6,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.kmlLayer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.kmlLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.kmlLayer);
        }
        unregisterEvents(this.registeredEvents);
        this.state.kmlLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return KmlLayer;
}(React.PureComponent);
KmlLayer.contextType = MapContext;
function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === 'function' ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {
    x: 0,
    y: 0
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ensureOfType(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}
function ensureOfTypeBounds(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
}
function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  if (ne && sw) {
    return {
      left: "".concat(sw.x + offset.x, "px"),
      top: "".concat(ne.y + offset.y, "px"),
      width: "".concat(ne.x - sw.x - offset.x, "px"),
      height: "".concat(sw.y - ne.y - offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection && mapCanvasProjection.fromLatLngToDivPixel(position);
  if (point) {
    var _x2 = point.x,
      _y2 = point.y;
    return {
      left: "".concat(_x2 + offset.x, "px"),
      top: "".concat(_y2 + offset.y, "px")
    };
  }
  return {
    left: '-9999px',
    top: '-9999px'
  };
}
function getLayoutStyles(mapCanvasProjection, offset, bounds, position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfTypeBounds(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
}
function arePositionsEqual(currentPosition, previousPosition) {
  return currentPosition.left === previousPosition.left && currentPosition.top === previousPosition.top && currentPosition.width === previousPosition.height && currentPosition.height === previousPosition.height;
}
function createOverlay(container, pane, position, bounds, getPixelPositionOffset) {
  var Overlay = /*#__PURE__*/function (_google$maps$OverlayV) {
    _inherits2(Overlay, _google$maps$OverlayV);
    var _super20 = _createSuper2(Overlay);
    function Overlay(container, pane, position, bounds) {
      var _this33;
      _classCallCheck2(this, Overlay);
      _this33 = _super20.call(this);
      _this33.container = container;
      _this33.pane = pane;
      _this33.position = position;
      _this33.bounds = bounds;
      return _this33;
    }
    _createClass2(Overlay, [{
      key: "onAdd",
      value: function onAdd() {
        var _a;
        var pane = (_a = this.getPanes()) === null || _a === void 0 ? void 0 : _a[this.pane];
        pane === null || pane === void 0 ? void 0 : pane.appendChild(this.container);
      }
    }, {
      key: "draw",
      value: function draw() {
        var projection = this.getProjection();
        var offset = Object.assign({}, this.container ? getOffsetOverride(this.container, getPixelPositionOffset) : {
          x: 0,
          y: 0
        });
        var layoutStyles = getLayoutStyles(projection, offset, this.bounds, this.position);
        for (var _i2 = 0, _Object$entries = Object.entries(layoutStyles); _i2 < _Object$entries.length; _i2++) {
          var _Object$entries$_i = _slicedToArray2(_Object$entries[_i2], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          this.container.style[key] = value;
        }
      }
    }, {
      key: "onRemove",
      value: function onRemove() {
        if (this.container.parentNode !== null) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }]);
    return Overlay;
  }(google.maps.OverlayView);
  return new Overlay(container, pane, position, bounds);
}
function convertToLatLngString(latLngLike) {
  if (!latLngLike) {
    return '';
  }
  var latLng = latLngLike instanceof google.maps.LatLng ? latLngLike : new google.maps.LatLng(latLngLike.lat, latLngLike.lng);
  return latLng + '';
}
function convertToLatLngBoundsString(latLngBoundsLike) {
  if (!latLngBoundsLike) {
    return '';
  }
  var latLngBounds = latLngBoundsLike instanceof google.maps.LatLngBounds ? latLngBoundsLike : new google.maps.LatLngBounds(new google.maps.LatLng(latLngBoundsLike.south, latLngBoundsLike.east), new google.maps.LatLng(latLngBoundsLike.north, latLngBoundsLike.west));
  return latLngBounds + '';
}
function OverlayViewFunctional(_ref33) {
  var position = _ref33.position,
    bounds = _ref33.bounds,
    mapPaneName = _ref33.mapPaneName,
    zIndex = _ref33.zIndex,
    onLoad = _ref33.onLoad,
    onUnmount = _ref33.onUnmount,
    getPixelPositionOffset = _ref33.getPixelPositionOffset,
    children = _ref33.children;
  var map = React.useContext(MapContext);
  var container = React.useMemo(function () {
    var div = document.createElement('div');
    div.style.position = 'absolute';
    return div;
  }, []);
  var overlay = React.useMemo(function () {
    return createOverlay(container, mapPaneName, position, bounds, getPixelPositionOffset);
  }, [container, mapPaneName, position, bounds]);
  React.useEffect(function () {
    onLoad === null || onLoad === void 0 ? void 0 : onLoad(overlay);
    overlay === null || overlay === void 0 ? void 0 : overlay.setMap(map);
    return function () {
      onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount(overlay);
      overlay === null || overlay === void 0 ? void 0 : overlay.setMap(null);
    };
  }, [map, overlay]);
  // to move the container to the foreground and background
  React.useEffect(function () {
    container.style.zIndex = "".concat(zIndex);
  }, [zIndex, container]);
  return ReactDOM__namespace.createPortal(children, container);
}
React.memo(OverlayViewFunctional);
var OverlayView = /*#__PURE__*/function (_React$PureComponent17) {
  _inherits2(OverlayView, _React$PureComponent17);
  var _super21 = _createSuper2(OverlayView);
  function OverlayView(props) {
    var _this34;
    _classCallCheck2(this, OverlayView);
    _this34 = _super21.call(this, props);
    _this34.state = {
      paneEl: null,
      containerStyle: {
        // set initial position
        position: 'absolute'
      }
    };
    _this34.updatePane = function () {
      var mapPaneName = _this34.props.mapPaneName;
      // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
      var mapPanes = _this34.overlayView.getPanes();
      invariant_1(!!mapPaneName, "OverlayView requires props.mapPaneName but got %s", mapPaneName);
      if (mapPanes) {
        _this34.setState({
          paneEl: mapPanes[mapPaneName]
        });
      } else {
        _this34.setState({
          paneEl: null
        });
      }
    };
    _this34.onAdd = function () {
      var _a, _b;
      _this34.updatePane();
      (_b = (_a = _this34.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, _this34.overlayView);
    };
    _this34.onPositionElement = function () {
      var mapCanvasProjection = _this34.overlayView.getProjection();
      var offset = Object.assign({
        x: 0,
        y: 0
      }, _this34.containerRef.current ? getOffsetOverride(_this34.containerRef.current, _this34.props.getPixelPositionOffset) : {});
      var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this34.props.bounds, _this34.props.position);
      var _this34$state$contain = _this34.state.containerStyle,
        left = _this34$state$contain.left,
        top = _this34$state$contain.top,
        width = _this34$state$contain.width,
        height = _this34$state$contain.height;
      if (!arePositionsEqual(layoutStyles, {
        left: left,
        top: top,
        width: width,
        height: height
      })) {
        _this34.setState({
          containerStyle: Object.assign(Object.assign({}, layoutStyles), {
            position: 'absolute'
          })
        });
      }
    };
    _this34.draw = function () {
      _this34.onPositionElement();
    };
    _this34.onRemove = function () {
      var _a, _b;
      _this34.setState(function () {
        return {
          paneEl: null
        };
      });
      // this.mapPaneEl = null
      (_b = (_a = _this34.props).onUnmount) === null || _b === void 0 ? void 0 : _b.call(_a, _this34.overlayView);
    };
    _this34.containerRef = React.createRef();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    var overlayView = new google.maps.OverlayView();
    overlayView.onAdd = _this34.onAdd;
    overlayView.draw = _this34.draw;
    overlayView.onRemove = _this34.onRemove;
    _this34.overlayView = overlayView;
    return _this34;
  }
  _createClass2(OverlayView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // You must call setMap() with a valid Map object to trigger the call to
      // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      this.overlayView.setMap(this.context);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevPositionString = convertToLatLngString(prevProps.position);
      var positionString = convertToLatLngString(this.props.position);
      var prevBoundsString = convertToLatLngBoundsString(prevProps.bounds);
      var boundsString = convertToLatLngBoundsString(this.props.bounds);
      if (prevPositionString !== positionString || prevBoundsString !== boundsString) {
        this.overlayView.draw();
      }
      if (prevProps.mapPaneName !== this.props.mapPaneName) {
        this.updatePane();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.overlayView.setMap(null);
    }
  }, {
    key: "render",
    value: function render() {
      var paneEl = this.state.paneEl;
      if (paneEl) {
        return ReactDOM__namespace.createPortal(jsxRuntime.exports.jsx("div", Object.assign({
          ref: this.containerRef,
          style: this.state.containerStyle
        }, {
          children: React.Children.only(this.props.children)
        })), paneEl);
      } else {
        return null;
      }
    }
  }]);
  return OverlayView;
}(React.PureComponent);
OverlayView.FLOAT_PANE = "floatPane";
OverlayView.MAP_PANE = "mapPane";
OverlayView.MARKER_LAYER = "markerLayer";
OverlayView.OVERLAY_LAYER = "overlayLayer";
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
OverlayView.contextType = MapContext;
function noop() {
  return;
}
var eventMap$5 = {
  onDblClick: 'dblclick',
  onClick: 'click'
};
var updaterMap$5 = {
  opacity: function opacity(instance, _opacity2) {
    instance.setOpacity(_opacity2);
  }
};
function GroundOverlayFunctional(_ref34) {
  var url = _ref34.url,
    bounds = _ref34.bounds,
    options = _ref34.options,
    visible = _ref34.visible;
  var map = React.useContext(MapContext);
  var imageBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
  var groundOverlay = React.useMemo(function () {
    var overlay = new google.maps.GroundOverlay(url, imageBounds, Object.assign({}, options));
    return overlay;
  }, []);
  React.useEffect(function () {
    if (groundOverlay !== null) {
      groundOverlay.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (typeof url !== 'undefined' && groundOverlay !== null) {
      groundOverlay.set("url", url);
      groundOverlay.setMap(map);
    }
  }, [groundOverlay, url]);
  React.useEffect(function () {
    if (typeof visible !== 'undefined' && groundOverlay !== null) {
      groundOverlay.setOpacity(visible ? 1 : 0);
    }
  }, [groundOverlay, visible]);
  React.useEffect(function () {
    var newBounds = new google.maps.LatLngBounds(new google.maps.LatLng(bounds.south, bounds.west), new google.maps.LatLng(bounds.north, bounds.east));
    if (typeof bounds !== 'undefined' && groundOverlay !== null) {
      groundOverlay.set("bounds", newBounds);
      groundOverlay.setMap(map);
    }
  }, [groundOverlay, bounds]);
  return null;
}
React.memo(GroundOverlayFunctional);
var GroundOverlay = /*#__PURE__*/function (_React$PureComponent18) {
  _inherits2(GroundOverlay, _React$PureComponent18);
  var _super22 = _createSuper2(GroundOverlay);
  function GroundOverlay() {
    var _this35;
    _classCallCheck2(this, GroundOverlay);
    _this35 = _super22.apply(this, arguments);
    _this35.registeredEvents = [];
    _this35.state = {
      groundOverlay: null
    };
    _this35.setGroundOverlayCallback = function () {
      if (_this35.state.groundOverlay !== null && _this35.props.onLoad) {
        _this35.props.onLoad(_this35.state.groundOverlay);
      }
    };
    return _this35;
  }
  _createClass2(GroundOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!this.props.url || !!this.props.bounds, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655");
      var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, Object.assign(Object.assign({}, this.props.options), {
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: {},
        nextProps: this.props,
        instance: groundOverlay
      });
      this.setState(function setGroundOverlay() {
        return {
          groundOverlay: groundOverlay
        };
      }, this.setGroundOverlayCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.groundOverlay !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$5,
          eventMap: eventMap$5,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.groundOverlay
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.groundOverlay) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.groundOverlay);
        }
        this.state.groundOverlay.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return GroundOverlay;
}(React.PureComponent);
GroundOverlay.defaultProps = {
  onLoad: noop
};
GroundOverlay.contextType = MapContext;
var eventMap$4 = {};
var updaterMap$4 = {
  data: function data(instance, _data) {
    instance.setData(_data);
  },
  map: function map(instance, _map7) {
    instance.setMap(_map7);
  },
  options: function options(instance, _options12) {
    instance.setOptions(_options12);
  }
};
function HeatmapLayerFunctional(_ref35) {
  var data = _ref35.data,
    onLoad = _ref35.onLoad,
    onUnmount = _ref35.onUnmount,
    options = _ref35.options;
  var map = React.useContext(MapContext);
  var _React$useState268 = React.useState(null),
    _React$useState269 = _slicedToArray2(_React$useState268, 2),
    instance = _React$useState269[0],
    setInstance = _React$useState269[1];
  React.useEffect(function () {
    if (!google.maps.visualization) {
      invariant_1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} in useJsApiScript? %s', google.maps.visualization);
    }
  }, []);
  React.useEffect(function () {
    invariant_1(!!data, 'data property is required in HeatmapLayer %s', data);
  }, [data]);
  // Order does matter
  React.useEffect(function () {
    if (instance !== null) {
      instance.setMap(map);
    }
  }, [map]);
  React.useEffect(function () {
    if (options && instance !== null) {
      instance.setOptions(options);
    }
  }, [instance, options]);
  React.useEffect(function () {
    var heatmapLayer = new google.maps.visualization.HeatmapLayer(Object.assign(Object.assign({}, options || {}), {
      data: data,
      map: map
    }));
    setInstance(heatmapLayer);
    if (onLoad) {
      onLoad(heatmapLayer);
    }
    return function () {
      if (instance !== null) {
        if (onUnmount) {
          onUnmount(instance);
        }
        instance.setMap(null);
      }
    };
  }, []);
  return null;
}
React.memo(HeatmapLayerFunctional);
var HeatmapLayer = /*#__PURE__*/function (_React$PureComponent19) {
  _inherits2(HeatmapLayer, _React$PureComponent19);
  var _super23 = _createSuper2(HeatmapLayer);
  function HeatmapLayer() {
    var _this36;
    _classCallCheck2(this, HeatmapLayer);
    _this36 = _super23.apply(this, arguments);
    _this36.registeredEvents = [];
    _this36.state = {
      heatmapLayer: null
    };
    _this36.setHeatmapLayerCallback = function () {
      if (_this36.state.heatmapLayer !== null && _this36.props.onLoad) {
        _this36.props.onLoad(_this36.state.heatmapLayer);
      }
    };
    return _this36;
  }
  _createClass2(HeatmapLayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.visualization, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization);
      invariant_1(!!this.props.data, 'data property is required in HeatmapLayer %s', this.props.data);
      var heatmapLayer = new google.maps.visualization.HeatmapLayer(Object.assign(Object.assign({}, this.props.options || {}), {
        data: this.props.data,
        map: this.context
      }));
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: {},
        nextProps: this.props,
        instance: heatmapLayer
      });
      this.setState(function setHeatmapLayer() {
        return {
          heatmapLayer: heatmapLayer
        };
      }, this.setHeatmapLayerCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.heatmapLayer
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.heatmapLayer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.heatmapLayer);
        }
        unregisterEvents(this.registeredEvents);
        this.state.heatmapLayer.setMap(null);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return HeatmapLayer;
}(React.PureComponent);
HeatmapLayer.contextType = MapContext;
var eventMap$3 = {
  onCloseClick: 'closeclick',
  onPanoChanged: 'pano_changed',
  onPositionChanged: 'position_changed',
  onPovChanged: 'pov_changed',
  onResize: 'resize',
  onStatusChanged: 'status_changed',
  onVisibleChanged: 'visible_changed',
  onZoomChanged: 'zoom_changed'
};
var updaterMap$3 = {
  register: function register(instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function links(instance, _links) {
    instance.setLinks(_links);
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking);
  },
  options: function options(instance, _options13) {
    instance.setOptions(_options13);
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano);
  },
  position: function position(instance, _position5) {
    instance.setPosition(_position5);
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov);
  },
  visible: function visible(instance, _visible7) {
    instance.setVisible(_visible7);
  },
  zoom: function zoom(instance, _zoom2) {
    instance.setZoom(_zoom2);
  }
};
var StreetViewPanorama = /*#__PURE__*/function (_React$PureComponent20) {
  _inherits2(StreetViewPanorama, _React$PureComponent20);
  var _super24 = _createSuper2(StreetViewPanorama);
  function StreetViewPanorama() {
    var _this37;
    _classCallCheck2(this, StreetViewPanorama);
    _this37 = _super24.apply(this, arguments);
    _this37.registeredEvents = [];
    _this37.state = {
      streetViewPanorama: null
    };
    _this37.setStreetViewPanoramaCallback = function () {
      if (_this37.state.streetViewPanorama !== null && _this37.props.onLoad) {
        _this37.props.onLoad(_this37.state.streetViewPanorama);
      }
    };
    return _this37;
  }
  _createClass2(StreetViewPanorama, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // @ts-ignore
      var streetViewPanorama = this.context.getStreetView();
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: {},
        nextProps: this.props,
        instance: streetViewPanorama
      });
      this.setState(function () {
        return {
          streetViewPanorama: streetViewPanorama
        };
      }, this.setStreetViewPanoramaCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.streetViewPanorama !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$3,
          eventMap: eventMap$3,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.streetViewPanorama
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewPanorama !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.streetViewPanorama);
        }
        unregisterEvents(this.registeredEvents);
        this.state.streetViewPanorama.setVisible(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return StreetViewPanorama;
}(React.PureComponent);
StreetViewPanorama.contextType = MapContext;
var StreetViewService = /*#__PURE__*/function (_React$PureComponent21) {
  _inherits2(StreetViewService, _React$PureComponent21);
  var _super25 = _createSuper2(StreetViewService);
  function StreetViewService() {
    var _this38;
    _classCallCheck2(this, StreetViewService);
    _this38 = _super25.apply(this, arguments);
    _this38.state = {
      streetViewService: null
    };
    _this38.setStreetViewServiceCallback = function () {
      if (_this38.state.streetViewService !== null && _this38.props.onLoad) {
        _this38.props.onLoad(_this38.state.streetViewService);
      }
    };
    return _this38;
  }
  _createClass2(StreetViewService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var streetViewService = new google.maps.StreetViewService();
      this.setState(function setStreetViewService() {
        return {
          streetViewService: streetViewService
        };
      }, this.setStreetViewServiceCallback);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.streetViewService !== null && this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewService);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return StreetViewService;
}(React.PureComponent);
StreetViewService.contextType = MapContext;
var eventMap$2 = {
  onDirectionsChanged: 'directions_changed'
};
var updaterMap$2 = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions);
  },
  map: function map(instance, _map8) {
    instance.setMap(_map8);
  },
  options: function options(instance, _options14) {
    instance.setOptions(_options14);
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel);
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex);
  }
};
var DirectionsRenderer = /*#__PURE__*/function (_React$PureComponent22) {
  _inherits2(DirectionsRenderer, _React$PureComponent22);
  var _super26 = _createSuper2(DirectionsRenderer);
  function DirectionsRenderer() {
    var _this39;
    _classCallCheck2(this, DirectionsRenderer);
    _this39 = _super26.apply(this, arguments);
    _this39.registeredEvents = [];
    _this39.state = {
      directionsRenderer: null
    };
    _this39.setDirectionsRendererCallback = function () {
      if (_this39.state.directionsRenderer !== null) {
        // @ts-ignore
        _this39.state.directionsRenderer.setMap(_this39.context);
        if (_this39.props.onLoad) {
          _this39.props.onLoad(_this39.state.directionsRenderer);
        }
      }
    };
    return _this39;
  }
  _createClass2(DirectionsRenderer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: {},
        nextProps: this.props,
        instance: directionsRenderer
      });
      this.setState(function setDirectionsRenderer() {
        return {
          directionsRenderer: directionsRenderer
        };
      }, this.setDirectionsRendererCallback);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.directionsRenderer !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$2,
          eventMap: eventMap$2,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.directionsRenderer
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.directionsRenderer !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.directionsRenderer);
        }
        unregisterEvents(this.registeredEvents);
        if (this.state.directionsRenderer) {
          this.state.directionsRenderer.setMap(null);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx(jsxRuntime.exports.Fragment, {});
    }
  }]);
  return DirectionsRenderer;
}(React.PureComponent);
DirectionsRenderer.contextType = MapContext;
var eventMap$1 = {
  onPlacesChanged: 'places_changed'
};
var updaterMap$1 = {
  bounds: function bounds(instance, _bounds2) {
    instance.setBounds(_bounds2);
  }
};
var StandaloneSearchBox = /*#__PURE__*/function (_React$PureComponent23) {
  _inherits2(StandaloneSearchBox, _React$PureComponent23);
  var _super27 = _createSuper2(StandaloneSearchBox);
  function StandaloneSearchBox() {
    var _this40;
    _classCallCheck2(this, StandaloneSearchBox);
    _this40 = _super27.apply(this, arguments);
    _this40.registeredEvents = [];
    _this40.containerElement = React.createRef();
    _this40.state = {
      searchBox: null
    };
    _this40.setSearchBoxCallback = function () {
      if (_this40.state.searchBox !== null && _this40.props.onLoad) {
        _this40.props.onLoad(_this40.state.searchBox);
      }
    };
    return _this40;
  }
  _createClass2(StandaloneSearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
      if (this.containerElement !== null && this.containerElement.current !== null) {
        var input = this.containerElement.current.querySelector('input');
        if (input !== null) {
          var searchBox = new google.maps.places.SearchBox(input, this.props.options);
          this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
            updaterMap: updaterMap$1,
            eventMap: eventMap$1,
            prevProps: {},
            nextProps: this.props,
            instance: searchBox
          });
          this.setState(function setSearchBox() {
            return {
              searchBox: searchBox
            };
          }, this.setSearchBoxCallback);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.state.searchBox !== null) {
        unregisterEvents(this.registeredEvents);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$1,
          eventMap: eventMap$1,
          prevProps: prevProps,
          nextProps: this.props,
          instance: this.state.searchBox
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.searchBox !== null) {
        if (this.props.onUnmount) {
          this.props.onUnmount(this.state.searchBox);
        }
        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement
      }, {
        children: React.Children.only(this.props.children)
      }));
    }
  }]);
  return StandaloneSearchBox;
}(React.PureComponent);
StandaloneSearchBox.contextType = MapContext;
var eventMap = {
  onPlaceChanged: 'place_changed'
};
var updaterMap = {
  bounds: function bounds(instance, _bounds3) {
    instance.setBounds(_bounds3);
  },
  restrictions: function restrictions(instance, _restrictions) {
    instance.setComponentRestrictions(_restrictions);
  },
  fields: function fields(instance, _fields) {
    instance.setFields(_fields);
  },
  options: function options(instance, _options15) {
    instance.setOptions(_options15);
  },
  types: function types(instance, _types2) {
    instance.setTypes(_types2);
  }
};
var Autocomplete = /*#__PURE__*/function (_React$PureComponent24) {
  _inherits2(Autocomplete, _React$PureComponent24);
  var _super28 = _createSuper2(Autocomplete);
  function Autocomplete() {
    var _this41;
    _classCallCheck2(this, Autocomplete);
    _this41 = _super28.apply(this, arguments);
    _this41.registeredEvents = [];
    _this41.containerElement = React.createRef();
    _this41.state = {
      autocomplete: null
    };
    _this41.setAutocompleteCallback = function () {
      if (_this41.state.autocomplete !== null && _this41.props.onLoad) {
        _this41.props.onLoad(_this41.state.autocomplete);
      }
    };
    return _this41;
  }
  _createClass2(Autocomplete, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      invariant_1(!!google.maps.places, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places);
      // TODO: why current could be equal null?
      // @ts-ignore
      var input = this.containerElement.current.querySelector('input');
      if (input) {
        var autocomplete = new google.maps.places.Autocomplete(input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap,
          eventMap: eventMap,
          prevProps: {},
          nextProps: this.props,
          instance: autocomplete
        });
        this.setState(function () {
          return {
            autocomplete: autocomplete
          };
        }, this.setAutocompleteCallback);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.autocomplete
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.autocomplete !== null) {
        unregisterEvents(this.registeredEvents);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return jsxRuntime.exports.jsx("div", Object.assign({
        ref: this.containerElement,
        className: this.props.className
      }, {
        children: React.Children.only(this.props.children)
      }));
    }
  }]);
  return Autocomplete;
}(React.PureComponent);
Autocomplete.defaultProps = {
  className: ''
};
Autocomplete.contextType = MapContext;
var isClient = typeof window !== 'undefined';
function Map$1(_ref) {
  var options = _ref.options;
  var location = options.location;
  var center = {
    lat: parseFloat(location.lat),
    lng: parseFloat(location.lng)
  };
  var _useJsApiLoader = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: "AIzaSyDnzyZ8cUsl2pcSJWUXqgj3nRg_EO1lY6Q"
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  // const [map, setMap] = React.useState(null)

  // const onLoad = React.useCallback(function callback(map) {
  //   const bounds = new window.google.maps.LatLngBounds();
  //   map.fitBounds(bounds);
  //   setMap(map)
  // }, [])

  // const onUnmount = React.useCallback(function callback(map) {
  //   setMap(null)
  // }, [])

  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      height: '500px',
      width: '100%'
    }
  }, isClient && isLoaded ? /*#__PURE__*/React__default["default"].createElement(GoogleMap, {
    mapContainerStyle: {
      height: '500px',
      width: '100%'
    },
    center: center,
    zoom: 10
    // onLoad={onLoad}
    // onUnmount={onUnmount}
  }, /*#__PURE__*/React__default["default"].createElement(Marker, {
    position: center,
    icon: "https://cms.burobork.nl/marker.svg"
  })) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null));
}

// const Marker = () => (
// 	<>
// 		<img src='https://cms.burobork.nl/marker.svg' style={{
//       height: 32,
//       width: 32,
//       minWidth: 32
//     }} />
// 	</>
// );

var _templateObject$1, _templateObject2$1, _templateObject3$1;
var ModalContainer = styled__default["default"].div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  position: fixed;\n\n  display: ", ";\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.05);\n  top: 0;\n  left: 0;\n  z-index: 9998;\n"])), function (props) {
  return props.show ? 'flex' : 'none';
});
var ModalContent = styled__default["default"].div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 80%;\n  background-color: #fff;\n  z-index: 9999;\n  padding: 32px;\n  border-radius: 8px;\n  margin-top: 5%;\n"])));
var ModalButton = styled__default["default"].button(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  background: inherit;\n  border: 0;\n  z-index: 10000;\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n"])));
function Modal(_ref) {
  var options = _ref.options;
  var initialOpen = options.initialOpen,
    content = options.content,
    buttonText = options.buttonText;
  var _useState = React.useState(initialOpen || false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ButtonStyle, {
    onClick: function onClick() {
      return setVisible(true);
    }
  }, buttonText), /*#__PURE__*/React__default["default"].createElement(ModalContainer, {
    show: visible,
    onClick: function onClick() {
      return setVisible(false);
    }
  }, /*#__PURE__*/React__default["default"].createElement(ModalContent, null, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(ModalButton, {
    onClick: function onClick() {
      return setVisible(false);
    }
  }, "X")), /*#__PURE__*/React__default["default"].createElement("div", null, content))));
}
var Hr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function kn(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function (r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), n;
}
var na = {},
  Y_ = {
    get exports() {
      return na;
    },
    set exports(e) {
      na = e;
    }
  },
  or = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ud;
function Q_() {
  if (ud) return or;
  ud = 1;
  var e = React__default["default"],
    t = 60103;
  if (or.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), or.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    a = Object.prototype.hasOwnProperty,
    i = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    };
  function o(s, u, l) {
    var c,
      f = {},
      h = null,
      p = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (c in u) a.call(u, c) && !i.hasOwnProperty(c) && (f[c] = u[c]);
    if (s && s.defaultProps) for (c in u = s.defaultProps, u) f[c] === void 0 && (f[c] = u[c]);
    return {
      $$typeof: t,
      type: s,
      key: h,
      ref: p,
      props: f,
      _owner: r.current
    };
  }
  return or.jsx = o, or.jsxs = o, or;
}
var ms = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ld;
function K_() {
  return ld || (ld = 1, function (e) {
    process.env.NODE_ENV !== "production" && function () {
      var t = React__default["default"],
        n = 60103,
        r = 60106;
      e.Fragment = 60107;
      var a = 60108,
        i = 60114,
        o = 60109,
        s = 60110,
        u = 60112,
        l = 60113,
        c = 60120,
        f = 60115,
        h = 60116,
        p = 60121,
        v = 60122,
        m = 60117,
        g = 60129,
        b = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var y = Symbol.for;
        n = y("react.element"), r = y("react.portal"), e.Fragment = y("react.fragment"), a = y("react.strict_mode"), i = y("react.profiler"), o = y("react.provider"), s = y("react.context"), u = y("react.forward_ref"), l = y("react.suspense"), c = y("react.suspense_list"), f = y("react.memo"), h = y("react.lazy"), p = y("react.block"), v = y("react.server.block"), m = y("react.fundamental"), y("react.scope"), y("react.opaque.id"), g = y("react.debug_trace_mode"), y("react.offscreen"), b = y("react.legacy_hidden");
      }
      var E = typeof Symbol == "function" && Symbol.iterator,
        w = "@@iterator";
      function _(S) {
        if (S === null || typeof S != "object") return null;
        var V = E && S[E] || S[w];
        return typeof V == "function" ? V : null;
      }
      var C = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function D(S) {
        {
          for (var V = arguments.length, X = new Array(V > 1 ? V - 1 : 0), pe = 1; pe < V; pe++) X[pe - 1] = arguments[pe];
          U("error", S, X);
        }
      }
      function U(S, V, X) {
        {
          var pe = C.ReactDebugCurrentFrame,
            Te = "";
          if (ce) {
            var ke = ie(ce.type),
              be = ce._owner;
            Te += Y(ke, ce._source, be && ie(be.type));
          }
          Te += pe.getStackAddendum(), Te !== "" && (V += "%s", X = X.concat([Te]));
          var Se = X.map(function (Ue) {
            return "" + Ue;
          });
          Se.unshift("Warning: " + V), Function.prototype.apply.call(console[S], console, Se);
        }
      }
      var Z = !1;
      function me(S) {
        return !!(typeof S == "string" || typeof S == "function" || S === e.Fragment || S === i || S === g || S === a || S === l || S === c || S === b || Z || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === f || S.$$typeof === o || S.$$typeof === s || S.$$typeof === u || S.$$typeof === m || S.$$typeof === p || S[0] === v));
      }
      var ye = /^(.*)[\\\/]/;
      function Y(S, V, X) {
        var pe = "";
        if (V) {
          var Te = V.fileName,
            ke = Te.replace(ye, "");
          if (/^index\./.test(ke)) {
            var be = Te.match(ye);
            if (be) {
              var Se = be[1];
              if (Se) {
                var Ue = Se.replace(ye, "");
                ke = Ue + "/" + ke;
              }
            }
          }
          pe = " (at " + ke + ":" + V.lineNumber + ")";
        } else X && (pe = " (created by " + X + ")");
        return "\n    in " + (S || "Unknown") + pe;
      }
      var K = 1;
      function ee(S) {
        return S._status === K ? S._result : null;
      }
      function ne(S, V, X) {
        var pe = V.displayName || V.name || "";
        return S.displayName || (pe !== "" ? X + "(" + pe + ")" : X);
      }
      function ie(S) {
        if (S == null) return null;
        if (typeof S.tag == "number" && D("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof S == "function") return S.displayName || S.name || null;
        if (typeof S == "string") return S;
        switch (S) {
          case e.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case i:
            return "Profiler";
          case a:
            return "StrictMode";
          case l:
            return "Suspense";
          case c:
            return "SuspenseList";
        }
        if (typeof S == "object") switch (S.$$typeof) {
          case s:
            return "Context.Consumer";
          case o:
            return "Context.Provider";
          case u:
            return ne(S, S.render, "ForwardRef");
          case f:
            return ie(S.type);
          case p:
            return ie(S.render);
          case h:
            {
              var V = S,
                X = ee(V);
              if (X) return ie(X);
              break;
            }
        }
        return null;
      }
      var fe = {};
      C.ReactDebugCurrentFrame;
      var ce = null;
      function H(S) {
        ce = S;
      }
      function O(S, V, X, pe, Te) {
        {
          var ke = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var be in S) if (ke(S, be)) {
            var Se = void 0;
            try {
              if (typeof S[be] != "function") {
                var Ue = Error((pe || "React class") + ": " + X + " type `" + be + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S[be] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ue.name = "Invariant Violation", Ue;
              }
              Se = S[be](V, be, pe, X, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ht) {
              Se = ht;
            }
            Se && !(Se instanceof Error) && (H(Te), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", pe || "React class", X, be, typeof Se), H(null)), Se instanceof Error && !(Se.message in fe) && (fe[Se.message] = !0, H(Te), D("Failed %s type: %s", X, Se.message), H(null));
          }
        }
      }
      var I = C.ReactCurrentOwner,
        B = Object.prototype.hasOwnProperty,
        W = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0
        },
        G,
        ue,
        se;
      se = {};
      function x(S) {
        if (B.call(S, "ref")) {
          var V = Object.getOwnPropertyDescriptor(S, "ref").get;
          if (V && V.isReactWarning) return !1;
        }
        return S.ref !== void 0;
      }
      function A(S) {
        if (B.call(S, "key")) {
          var V = Object.getOwnPropertyDescriptor(S, "key").get;
          if (V && V.isReactWarning) return !1;
        }
        return S.key !== void 0;
      }
      function M(S, V) {
        if (typeof S.ref == "string" && I.current && V && I.current.stateNode !== V) {
          var X = ie(I.current.type);
          se[X] || (D('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', ie(I.current.type), S.ref), se[X] = !0);
        }
      }
      function N(S, V) {
        {
          var X = function X() {
            G || (G = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
          };
          X.isReactWarning = !0, Object.defineProperty(S, "key", {
            get: X,
            configurable: !0
          });
        }
      }
      function Q(S, V) {
        {
          var X = function X() {
            ue || (ue = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", V));
          };
          X.isReactWarning = !0, Object.defineProperty(S, "ref", {
            get: X,
            configurable: !0
          });
        }
      }
      var L = function L(S, V, X, pe, Te, ke, be) {
        var Se = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: S,
          key: V,
          ref: X,
          props: be,
          // Record the component responsible for creating this element.
          _owner: ke
        };
        return Se._store = {}, Object.defineProperty(Se._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Se, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: pe
        }), Object.defineProperty(Se, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Te
        }), Object.freeze && (Object.freeze(Se.props), Object.freeze(Se)), Se;
      };
      function ve(S, V, X, pe, Te) {
        {
          var ke,
            be = {},
            Se = null,
            Ue = null;
          X !== void 0 && (Se = "" + X), A(V) && (Se = "" + V.key), x(V) && (Ue = V.ref, M(V, Te));
          for (ke in V) B.call(V, ke) && !W.hasOwnProperty(ke) && (be[ke] = V[ke]);
          if (S && S.defaultProps) {
            var ht = S.defaultProps;
            for (ke in ht) be[ke] === void 0 && (be[ke] = ht[ke]);
          }
          if (Se || Ue) {
            var Ot = typeof S == "function" ? S.displayName || S.name || "Unknown" : S;
            Se && N(be, Ot), Ue && Q(be, Ot);
          }
          return L(S, Se, Ue, Te, pe, I.current, be);
        }
      }
      var re = C.ReactCurrentOwner;
      C.ReactDebugCurrentFrame;
      function _e(S) {
        ce = S;
      }
      var xe;
      xe = !1;
      function Ee(S) {
        return typeof S == "object" && S !== null && S.$$typeof === n;
      }
      function tt() {
        {
          if (re.current) {
            var S = ie(re.current.type);
            if (S) return "\n\nCheck the render method of `" + S + "`.";
          }
          return "";
        }
      }
      function nt(S) {
        {
          if (S !== void 0) {
            var V = S.fileName.replace(/^.*[\\\/]/, ""),
              X = S.lineNumber;
            return "\n\nCheck your code at " + V + ":" + X + ".";
          }
          return "";
        }
      }
      var $ = {};
      function oe(S) {
        {
          var V = tt();
          if (!V) {
            var X = typeof S == "string" ? S : S.displayName || S.name;
            X && (V = "\n\nCheck the top-level render call using <" + X + ">.");
          }
          return V;
        }
      }
      function T(S, V) {
        {
          if (!S._store || S._store.validated || S.key != null) return;
          S._store.validated = !0;
          var X = oe(V);
          if ($[X]) return;
          $[X] = !0;
          var pe = "";
          S && S._owner && S._owner !== re.current && (pe = " It was passed a child from " + ie(S._owner.type) + "."), _e(S), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', X, pe), _e(null);
        }
      }
      function R(S, V) {
        {
          if (typeof S != "object") return;
          if (Array.isArray(S)) for (var X = 0; X < S.length; X++) {
            var pe = S[X];
            Ee(pe) && T(pe, V);
          } else if (Ee(S)) S._store && (S._store.validated = !0);else if (S) {
            var Te = _(S);
            if (typeof Te == "function" && Te !== S.entries) for (var ke = Te.call(S), be; !(be = ke.next()).done;) Ee(be.value) && T(be.value, V);
          }
        }
      }
      function z(S) {
        {
          var V = S.type;
          if (V == null || typeof V == "string") return;
          var X;
          if (typeof V == "function") X = V.propTypes;else if (typeof V == "object" && (V.$$typeof === u ||
          // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          V.$$typeof === f)) X = V.propTypes;else return;
          if (X) {
            var pe = ie(V);
            O(X, S.props, "prop", pe, S);
          } else if (V.PropTypes !== void 0 && !xe) {
            xe = !0;
            var Te = ie(V);
            D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Te || "Unknown");
          }
          typeof V.getDefaultProps == "function" && !V.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function j(S) {
        {
          for (var V = Object.keys(S.props), X = 0; X < V.length; X++) {
            var pe = V[X];
            if (pe !== "children" && pe !== "key") {
              _e(S), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), _e(null);
              break;
            }
          }
          S.ref !== null && (_e(S), D("Invalid attribute `ref` supplied to `React.Fragment`."), _e(null));
        }
      }
      function ae(S, V, X, pe, Te, ke) {
        {
          var be = me(S);
          if (!be) {
            var Se = "";
            (S === void 0 || typeof S == "object" && S !== null && Object.keys(S).length === 0) && (Se += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ue = nt(Te);
            Ue ? Se += Ue : Se += tt();
            var ht;
            S === null ? ht = "null" : Array.isArray(S) ? ht = "array" : S !== void 0 && S.$$typeof === n ? (ht = "<" + (ie(S.type) || "Unknown") + " />", Se = " Did you accidentally export a JSX literal instead of a component?") : ht = typeof S, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ht, Se);
          }
          var Ot = ve(S, V, X, Te, ke);
          if (Ot == null) return Ot;
          if (be) {
            var ir = V.children;
            if (ir !== void 0) if (pe) {
              if (Array.isArray(ir)) {
                for (var ps = 0; ps < ir.length; ps++) R(ir[ps], S);
                Object.freeze && Object.freeze(ir);
              } else D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else R(ir, S);
          }
          return S === e.Fragment ? j(Ot) : z(Ot), Ot;
        }
      }
      function ge(S, V, X) {
        return ae(S, V, X, !0);
      }
      function Pe(S, V, X) {
        return ae(S, V, X, !1);
      }
      var de = Pe,
        Oe = ge;
      e.jsx = de, e.jsxs = Oe;
    }();
  }(ms)), ms;
}
(function (e) {
  process.env.NODE_ENV === "production" ? e.exports = Q_() : e.exports = K_();
})(Y_);
var vt = na.Fragment,
  d = na.jsx,
  F = na.jsxs,
  Dn = function Dn() {
    return /* @__PURE__ */F("svg", {
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      width: "24px",
      height: "30px",
      viewBox: "0 0 24 30",
      enableBackground: "new 0 0 50 50",
      xmlSpace: "preserve",
      children: [/* @__PURE__ */F("rect", {
        x: "0",
        y: "10",
        width: "4",
        height: "10",
        fill: "#333",
        opacity: "0.2",
        children: [/* @__PURE__ */d("animate", {
          attributeName: "opacity",
          attributeType: "XML",
          values: "0.2; 1; .2",
          begin: "0s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "height",
          attributeType: "XML",
          values: "10; 20; 10",
          begin: "0s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "y",
          attributeType: "XML",
          values: "10; 5; 10",
          begin: "0s",
          dur: "0.6s",
          repeatCount: "indefinite"
        })]
      }), /* @__PURE__ */F("rect", {
        x: "8",
        y: "10",
        width: "4",
        height: "10",
        fill: "#333",
        opacity: "0.2",
        children: [/* @__PURE__ */d("animate", {
          attributeName: "opacity",
          attributeType: "XML",
          values: "0.2; 1; .2",
          begin: "0.15s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "height",
          attributeType: "XML",
          values: "10; 20; 10",
          begin: "0.15s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "y",
          attributeType: "XML",
          values: "10; 5; 10",
          begin: "0.15s",
          dur: "0.6s",
          repeatCount: "indefinite"
        })]
      }), /* @__PURE__ */F("rect", {
        x: "16",
        y: "10",
        width: "4",
        height: "10",
        fill: "#333",
        opacity: "0.2",
        children: [/* @__PURE__ */d("animate", {
          attributeName: "opacity",
          attributeType: "XML",
          values: "0.2; 1; .2",
          begin: "0.3s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "height",
          attributeType: "XML",
          values: "10; 20; 10",
          begin: "0.3s",
          dur: "0.6s",
          repeatCount: "indefinite"
        }), /* @__PURE__ */d("animate", {
          attributeName: "y",
          attributeType: "XML",
          values: "10; 5; 10",
          begin: "0.3s",
          dur: "0.6s",
          repeatCount: "indefinite"
        })]
      })]
    });
  };
var _ou = function ou(e, t) {
  return _ou = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (n, r) {
    n.__proto__ = r;
  } || function (n, r) {
    for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, _ou(e, t);
};
function et(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  _ou(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var _P2 = function P() {
  return _P2 = Object.assign || function (t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, _P2.apply(this, arguments);
};
function Mt(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++) t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function mn(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function (o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function (i, o) {
    function s(c) {
      try {
        l(r.next(c));
      } catch (f) {
        o(f);
      }
    }
    function u(c) {
      try {
        l(r.throw(c));
      } catch (f) {
        o(f);
      }
    }
    function l(c) {
      c.done ? i(c.value) : a(c.value).then(s, u);
    }
    l((r = r.apply(e, t || [])).next());
  });
}
function vn(e, t) {
  var n = {
      label: 0,
      sent: function sent() {
        if (i[0] & 1) throw i[1];
        return i[1];
      },
      trys: [],
      ops: []
    },
    r,
    a,
    i,
    o;
  return o = {
    next: s(0),
    throw: s(1),
    return: s(2)
  }, typeof Symbol == "function" && (o[Symbol.iterator] = function () {
    return this;
  }), o;
  function s(l) {
    return function (c) {
      return u([l, c]);
    };
  }
  function u(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, l[0] && (n = 0)), n;) try {
      if (r = 1, a && (i = l[0] & 2 ? a.return : l[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, l[1])).done) return i;
      switch (a = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return n.label++, {
            value: l[1],
            done: !1
          };
        case 5:
          n.label++, a = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = l;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(l);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (c) {
      l = [6, c], a = 0;
    } finally {
      r = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return {
      value: l[0] ? l[1] : void 0,
      done: !0
    };
  }
}
function xt(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, a = t.length, i; r < a; r++) (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var vs = "Invariant Violation",
  cd = Object.setPrototypeOf,
  J_ = cd === void 0 ? function (e, t) {
    return e.__proto__ = t, e;
  } : cd,
  Ne = /** @class */
  function (e) {
    et(t, e);
    function t(n) {
      n === void 0 && (n = vs);
      var r = e.call(this, typeof n == "number" ? vs + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = vs, J_(r, t.prototype), r;
    }
    return t;
  }(Error);
function te(e, t) {
  if (!e) throw new Ne(t);
}
var Tv = ["debug", "log", "warn", "error", "silent"],
  X_ = Tv.indexOf("log");
function Fa(e) {
  return function () {
    if (Tv.indexOf(e) >= X_) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function (e) {
  e.debug = Fa("debug"), e.log = Fa("log"), e.warn = Fa("warn"), e.error = Fa("error");
})(te || (te = {}));
function Lt(e) {
  try {
    return e();
  } catch (_unused) {}
}
var fd = Lt(function () {
  return globalThis;
}) || Lt(function () {
  return window;
}) || Lt(function () {
  return self;
}) || Lt(function () {
  return global;
}) || Lt(function () {
  return Lt.constructor("return this")();
});
var dd = "__",
  hd = [dd, dd].join("DEV");
function Z_() {
  try {
    return Boolean(__DEV__);
  } catch (_unused2) {
    return Object.defineProperty(fd, hd, {
      value: Lt(function () {
        return process.env.NODE_ENV;
      }) !== "production",
      enumerable: !1,
      configurable: !0,
      writable: !0
    }), fd[hd];
  }
}
var ys = Z_();
function yn(e) {
  try {
    return e();
  } catch (_unused3) {}
}
var su = yn(function () {
    return globalThis;
  }) || yn(function () {
    return window;
  }) || yn(function () {
    return self;
  }) || yn(function () {
    return global;
  }) ||
  // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  yn(function () {
    return yn.constructor("return this")();
  }),
  uu = !1;
function ew() {
  su && !yn(function () {
    return process.env.NODE_ENV;
  }) && !yn(function () {
    return process;
  }) && (Object.defineProperty(su, "process", {
    value: {
      env: {
        // This default needs to be "production" instead of "development", to
        // avoid the problem https://github.com/graphql/graphql-js/pull/2894
        // will eventually solve, once merged and released.
        NODE_ENV: "production"
      }
    },
    // Let anyone else change global.process as they see fit, but hide it from
    // Object.keys(global) enumeration.
    configurable: !0,
    enumerable: !1,
    writable: !0
  }), uu = !0);
}
ew();
function pd() {
  uu && (delete su.process, uu = !1);
}
function Ya(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ya = function Ya(n) {
    return typeof n;
  } : Ya = function Ya(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ya(e);
}
function tw(e) {
  return Ya(e) == "object" && e !== null;
}
var kv = typeof Symbol == "function" && Symbol.toStringTag != null ? Symbol.toStringTag : "@@toStringTag";
function lu(e, t) {
  for (var n = /\r\n|[\n\r]/g, r = 1, a = t + 1, i; (i = n.exec(e.body)) && i.index < t;) r += 1, a = t + 1 - (i.index + i[0].length);
  return {
    line: r,
    column: a
  };
}
function nw(e) {
  return Dv(e.source, lu(e.source, e.start));
}
function Dv(e, t) {
  var n = e.locationOffset.column - 1,
    r = Qa(n) + e.body,
    a = t.line - 1,
    i = e.locationOffset.line - 1,
    o = t.line + i,
    s = t.line === 1 ? n : 0,
    u = t.column + s,
    l = "".concat(e.name, ":").concat(o, ":").concat(u, "\n"),
    c = r.split(/\r\n|[\n\r]/g),
    f = c[a];
  if (f.length > 120) {
    for (var h = Math.floor(u / 80), p = u % 80, v = [], m = 0; m < f.length; m += 80) v.push(f.slice(m, m + 80));
    return l + md([["".concat(o), v[0]]].concat(v.slice(1, h + 1).map(function (g) {
      return ["", g];
    }), [[" ", Qa(p - 1) + "^"], ["", v[h + 1]]]));
  }
  return l + md([
  // Lines specified like this: ["prefix", "string"],
  ["".concat(o - 1), c[a - 1]], ["".concat(o), f], ["", Qa(u - 1) + "^"], ["".concat(o + 1), c[a + 1]]]);
}
function md(e) {
  var t = e.filter(function (r) {
      r[0];
      var a = r[1];
      return a !== void 0;
    }),
    n = Math.max.apply(Math, t.map(function (r) {
      var a = r[0];
      return a.length;
    }));
  return t.map(function (r) {
    var a = r[0],
      i = r[1];
    return rw(n, a) + (i ? " | " + i : " |");
  }).join("\n");
}
function Qa(e) {
  return Array(e + 1).join(" ");
}
function rw(e, t) {
  return Qa(e - t.length) + t;
}
function Ka(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ka = function Ka(n) {
    return typeof n;
  } : Ka = function Ka(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ka(e);
}
function vd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function aw(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vd(Object(n), !0).forEach(function (r) {
      iw(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vd(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function iw(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ow(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function yd(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function sw(e, t, n) {
  return t && yd(e.prototype, t), n && yd(e, n), e;
}
function uw(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && ra(e, t);
}
function lw(e) {
  var t = $v();
  return function () {
    var r = aa(e),
      a;
    if (t) {
      var i = aa(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return xv(this, a);
  };
}
function xv(e, t) {
  return t && (Ka(t) === "object" || typeof t == "function") ? t : Wr(e);
}
function Wr(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cu(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */new Map() : void 0;
  return cu = function cu(r) {
    if (r === null || !cw(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, a);
    }
    function a() {
      return Ja(r, arguments, aa(this).constructor);
    }
    return a.prototype = Object.create(r.prototype, {
      constructor: {
        value: a,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ra(a, r);
  }, cu(e);
}
function Ja(e, t, n) {
  return $v() ? Ja = Reflect.construct : Ja = function Ja(a, i, o) {
    var s = [null];
    s.push.apply(s, i);
    var u = Function.bind.apply(a, s),
      l = new u();
    return o && ra(l, o.prototype), l;
  }, Ja.apply(null, arguments);
}
function $v() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (_unused4) {
    return !1;
  }
}
function cw(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ra(e, t) {
  return ra = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, ra(e, t);
}
function aa(e) {
  return aa = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, aa(e);
}
var fw = /* @__PURE__ */function (e) {
  uw(n, e);
  var t = lw(n);
  function n(r, a, i, o, s, u, l) {
    var c, f, h, p;
    ow(this, n), p = t.call(this, r), p.name = "GraphQLError", p.originalError = u !== null && u !== void 0 ? u : void 0, p.nodes = gd(Array.isArray(a) ? a : a ? [a] : void 0);
    for (var v = [], m = 0, g = (b = p.nodes) !== null && b !== void 0 ? b : []; m < g.length; m++) {
      var b,
        y = g[m],
        E = y.loc;
      E != null && v.push(E);
    }
    v = gd(v), p.source = i !== null && i !== void 0 ? i : (c = v) === null || c === void 0 ? void 0 : c[0].source, p.positions = o !== null && o !== void 0 ? o : (f = v) === null || f === void 0 ? void 0 : f.map(function (_) {
      return _.start;
    }), p.locations = o && i ? o.map(function (_) {
      return lu(i, _);
    }) : (h = v) === null || h === void 0 ? void 0 : h.map(function (_) {
      return lu(_.source, _.start);
    }), p.path = s !== null && s !== void 0 ? s : void 0;
    var w = u == null ? void 0 : u.extensions;
    return l == null && tw(w) ? p.extensions = aw({}, w) : p.extensions = l !== null && l !== void 0 ? l : {}, Object.defineProperties(Wr(p), {
      message: {
        enumerable: !0
      },
      locations: {
        enumerable: p.locations != null
      },
      path: {
        enumerable: p.path != null
      },
      extensions: {
        enumerable: p.extensions != null && Object.keys(p.extensions).length > 0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), u != null && u.stack ? (Object.defineProperty(Wr(p), "stack", {
      value: u.stack,
      writable: !0,
      configurable: !0
    }), xv(p)) : (Error.captureStackTrace ? Error.captureStackTrace(Wr(p), n) : Object.defineProperty(Wr(p), "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    }), p);
  }
  return sw(n, [{
    key: "toString",
    value: function value() {
      return dw(this);
    }
    // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  }, {
    key: kv,
    get: function get() {
      return "Object";
    }
  }]), n;
}( /* @__PURE__ */cu(Error));
function gd(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function dw(e) {
  var t = e.message;
  if (e.nodes) for (var n = 0, r = e.nodes; n < r.length; n++) {
    var a = r[n];
    a.loc && (t += "\n\n" + nw(a.loc));
  } else if (e.source && e.locations) for (var i = 0, o = e.locations; i < o.length; i++) {
    var s = o[i];
    t += "\n\n" + Dv(e.source, s);
  }
  return t;
}
function At(e, t, n) {
  return new fw("Syntax Error: ".concat(n), void 0, e, [t]);
}
var we = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function hw(e, t) {
  var n = Boolean(e);
  if (!n) throw new Error(t !== null && t !== void 0 ? t : "Unexpected invariant triggered.");
}
var pw = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
var fu = pw;
function Cv(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || hw(0), e.prototype.inspect = t, fu && (e.prototype[fu] = t);
}
var Rv = /* @__PURE__ */function () {
  function e(n, r, a) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = a;
  }
  var t = e.prototype;
  return t.toJSON = function () {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
}();
Cv(Rv);
var at = /* @__PURE__ */function () {
  function e(n, r, a, i, o, s, u) {
    this.kind = n, this.start = r, this.end = a, this.line = i, this.column = o, this.value = u, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function () {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
}();
Cv(at);
function bd(e) {
  return e != null && typeof e.kind == "string";
}
var q = Object.freeze({
  SOF: "<SOF>",
  EOF: "<EOF>",
  BANG: "!",
  DOLLAR: "$",
  AMP: "&",
  PAREN_L: "(",
  PAREN_R: ")",
  SPREAD: "...",
  COLON: ":",
  EQUALS: "=",
  AT: "@",
  BRACKET_L: "[",
  BRACKET_R: "]",
  BRACE_L: "{",
  PIPE: "|",
  BRACE_R: "}",
  NAME: "Name",
  INT: "Int",
  FLOAT: "Float",
  STRING: "String",
  BLOCK_STRING: "BlockString",
  COMMENT: "Comment"
});
function Xa(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xa = function Xa(n) {
    return typeof n;
  } : Xa = function Xa(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Xa(e);
}
var mw = 10,
  Nv = 2;
function Ic(e) {
  return Uo(e, []);
}
function Uo(e, t) {
  switch (Xa(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : vw(e, t);
    default:
      return String(e);
  }
}
function vw(e, t) {
  if (t.indexOf(e) !== -1) return "[Circular]";
  var n = [].concat(t, [e]),
    r = bw(e);
  if (r !== void 0) {
    var a = r.call(e);
    if (a !== e) return typeof a == "string" ? a : Uo(a, n);
  } else if (Array.isArray(e)) return gw(e, n);
  return yw(e, n);
}
function yw(e, t) {
  var n = Object.keys(e);
  if (n.length === 0) return "{}";
  if (t.length > Nv) return "[" + _w(e) + "]";
  var r = n.map(function (a) {
    var i = Uo(e[a], t);
    return a + ": " + i;
  });
  return "{ " + r.join(", ") + " }";
}
function gw(e, t) {
  if (e.length === 0) return "[]";
  if (t.length > Nv) return "[Array]";
  for (var n = Math.min(mw, e.length), r = e.length - n, a = [], i = 0; i < n; ++i) a.push(Uo(e[i], t));
  return r === 1 ? a.push("... 1 more item") : r > 1 && a.push("... ".concat(r, " more items")), "[" + a.join(", ") + "]";
}
function bw(e) {
  var t = e[String(fu)];
  if (typeof t == "function") return t;
  if (typeof e.inspect == "function") return e.inspect;
}
function _w(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "") return n;
  }
  return t;
}
function gs(e, t) {
  var n = Boolean(e);
  if (!n) throw new Error(t);
}
function Za(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Za = function Za(n) {
    return typeof n;
  } : Za = function Za(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Za(e);
}
var ww = process.env.NODE_ENV === "production" ?
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function (t, n) {
  return t instanceof n;
} :
// eslint-disable-next-line no-shadow
function (t, n) {
  if (t instanceof n) return !0;
  if (Za(t) === "object" && t !== null) {
    var r,
      a = n.prototype[Symbol.toStringTag],
      i =
      // We still need to support constructor's name to detect conflicts with older versions of this library.
      Symbol.toStringTag in t ? t[Symbol.toStringTag] : (r = t.constructor) === null || r === void 0 ? void 0 : r.name;
    if (a === i) {
      var o = Ic(t);
      throw new Error("Cannot use ".concat(a, ' "').concat(o, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }
  return !1;
};
function _d(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ow(e, t, n) {
  return t && _d(e.prototype, t), n && _d(e, n), e;
}
var Mc = /* @__PURE__ */function () {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GraphQL request",
      r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        line: 1,
        column: 1
      };
    typeof t == "string" || gs(0, "Body must be a string. Received: ".concat(Ic(t), ".")), this.body = t, this.name = n, this.locationOffset = r, this.locationOffset.line > 0 || gs(0, "line in locationOffset is 1-indexed and must be positive."), this.locationOffset.column > 0 || gs(0, "column in locationOffset is 1-indexed and must be positive.");
  }
  return Ow(e, [{
    key: kv,
    get: function get() {
      return "Source";
    }
  }]), e;
}();
function Sw(e) {
  return ww(e, Mc);
}
var Ew = Object.freeze({
  // Request Definitions
  QUERY: "QUERY",
  MUTATION: "MUTATION",
  SUBSCRIPTION: "SUBSCRIPTION",
  FIELD: "FIELD",
  FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
  FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
  INLINE_FRAGMENT: "INLINE_FRAGMENT",
  VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
  // Type System Definitions
  SCHEMA: "SCHEMA",
  SCALAR: "SCALAR",
  OBJECT: "OBJECT",
  FIELD_DEFINITION: "FIELD_DEFINITION",
  ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
  INTERFACE: "INTERFACE",
  UNION: "UNION",
  ENUM: "ENUM",
  ENUM_VALUE: "ENUM_VALUE",
  INPUT_OBJECT: "INPUT_OBJECT",
  INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});
function Pw(e) {
  var t = e.split(/\r\n|[\n\r]/g),
    n = Tw(e);
  if (n !== 0) for (var r = 1; r < t.length; r++) t[r] = t[r].slice(n);
  for (var a = 0; a < t.length && wd(t[a]);) ++a;
  for (var i = t.length; i > a && wd(t[i - 1]);) --i;
  return t.slice(a, i).join("\n");
}
function wd(e) {
  for (var t = 0; t < e.length; ++t) if (e[t] !== " " && e[t] !== "	") return !1;
  return !0;
}
function Tw(e) {
  for (var t, n = !0, r = !0, a = 0, i = null, o = 0; o < e.length; ++o) switch (e.charCodeAt(o)) {
    case 13:
      e.charCodeAt(o + 1) === 10 && ++o;
    case 10:
      n = !1, r = !0, a = 0;
      break;
    case 9:
    case 32:
      ++a;
      break;
    default:
      r && !n && (i === null || a < i) && (i = a), r = !1;
  }
  return (t = i) !== null && t !== void 0 ? t : 0;
}
function kw(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "",
    n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1,
    r = e.indexOf("\n") === -1,
    a = e[0] === " " || e[0] === "	",
    i = e[e.length - 1] === '"',
    o = e[e.length - 1] === "\\",
    s = !r || i || o || n,
    u = "";
  return s && !(r && a) && (u += "\n" + t), u += t ? e.replace(/\n/g, "\n" + t) : e, s && (u += "\n"), '"""' + u.replace(/"""/g, '\\"""') + '"""';
}
var Dw = /* @__PURE__ */function () {
  function e(n) {
    var r = new at(q.SOF, 0, 0, 0, 0, null);
    this.source = n, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  var t = e.prototype;
  return t.advance = function () {
    this.lastToken = this.token;
    var r = this.token = this.lookahead();
    return r;
  }, t.lookahead = function () {
    var r = this.token;
    if (r.kind !== q.EOF) do {
      var a;
      r = (a = r.next) !== null && a !== void 0 ? a : r.next = $w(this, r);
    } while (r.kind === q.COMMENT);
    return r;
  }, e;
}();
function xw(e) {
  return e === q.BANG || e === q.DOLLAR || e === q.AMP || e === q.PAREN_L || e === q.PAREN_R || e === q.SPREAD || e === q.COLON || e === q.EQUALS || e === q.AT || e === q.BRACKET_L || e === q.BRACKET_R || e === q.BRACE_L || e === q.PIPE || e === q.BRACE_R;
}
function qn(e) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(e) ? q.EOF :
    // Trust JSON for ASCII.
    e < 127 ? JSON.stringify(String.fromCharCode(e)) :
    // Otherwise print the escaped form.
    "\"\\u".concat(("00" + e.toString(16).toUpperCase()).slice(-4), '"')
  );
}
function $w(e, t) {
  for (var n = e.source, r = n.body, a = r.length, i = t.end; i < a;) {
    var o = r.charCodeAt(i),
      s = e.line,
      u = 1 + i - e.lineStart;
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 33:
        return new at(q.BANG, i, i + 1, s, u, t);
      case 35:
        return Rw(n, i, s, u, t);
      case 36:
        return new at(q.DOLLAR, i, i + 1, s, u, t);
      case 38:
        return new at(q.AMP, i, i + 1, s, u, t);
      case 40:
        return new at(q.PAREN_L, i, i + 1, s, u, t);
      case 41:
        return new at(q.PAREN_R, i, i + 1, s, u, t);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46) return new at(q.SPREAD, i, i + 3, s, u, t);
        break;
      case 58:
        return new at(q.COLON, i, i + 1, s, u, t);
      case 61:
        return new at(q.EQUALS, i, i + 1, s, u, t);
      case 64:
        return new at(q.AT, i, i + 1, s, u, t);
      case 91:
        return new at(q.BRACKET_L, i, i + 1, s, u, t);
      case 93:
        return new at(q.BRACKET_R, i, i + 1, s, u, t);
      case 123:
        return new at(q.BRACE_L, i, i + 1, s, u, t);
      case 124:
        return new at(q.PIPE, i, i + 1, s, u, t);
      case 125:
        return new at(q.BRACE_R, i, i + 1, s, u, t);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? Iw(n, i, s, u, t, e) : Aw(n, i, s, u, t);
      case 45:
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
        return Nw(n, i, o, s, u, t);
      case 65:
      case 66:
      case 67:
      case 68:
      case 69:
      case 70:
      case 71:
      case 72:
      case 73:
      case 74:
      case 75:
      case 76:
      case 77:
      case 78:
      case 79:
      case 80:
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 95:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
      case 106:
      case 107:
      case 108:
      case 109:
      case 110:
      case 111:
      case 112:
      case 113:
      case 114:
      case 115:
      case 116:
      case 117:
      case 118:
      case 119:
      case 120:
      case 121:
      case 122:
        return Fw(n, i, s, u, t);
    }
    throw At(n, i, Cw(o));
  }
  var l = e.line,
    c = 1 + i - e.lineStart;
  return new at(q.EOF, a, a, l, c, t);
}
function Cw(e) {
  return e < 32 && e !== 9 && e !== 10 && e !== 13 ? "Cannot contain the invalid character ".concat(qn(e), ".") : e === 39 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : "Cannot parse the unexpected character ".concat(qn(e), ".");
}
function Rw(e, t, n, r, a) {
  var i = e.body,
    o,
    s = t;
  do o = i.charCodeAt(++s); while (!isNaN(o) && (
  // SourceCharacter but not LineTerminator
  o > 31 || o === 9));
  return new at(q.COMMENT, t, s, n, r, a, i.slice(t + 1, s));
}
function Nw(e, t, n, r, a, i) {
  var o = e.body,
    s = n,
    u = t,
    l = !1;
  if (s === 45 && (s = o.charCodeAt(++u)), s === 48) {
    if (s = o.charCodeAt(++u), s >= 48 && s <= 57) throw At(e, u, "Invalid number, unexpected digit after 0: ".concat(qn(s), "."));
  } else u = bs(e, u, s), s = o.charCodeAt(u);
  if (s === 46 && (l = !0, s = o.charCodeAt(++u), u = bs(e, u, s), s = o.charCodeAt(u)), (s === 69 || s === 101) && (l = !0, s = o.charCodeAt(++u), (s === 43 || s === 45) && (s = o.charCodeAt(++u)), u = bs(e, u, s), s = o.charCodeAt(u)), s === 46 || Lw(s)) throw At(e, u, "Invalid number, expected digit but got: ".concat(qn(s), "."));
  return new at(l ? q.FLOAT : q.INT, t, u, r, a, i, o.slice(t, u));
}
function bs(e, t, n) {
  var r = e.body,
    a = t,
    i = n;
  if (i >= 48 && i <= 57) {
    do i = r.charCodeAt(++a); while (i >= 48 && i <= 57);
    return a;
  }
  throw At(e, a, "Invalid number, expected digit but got: ".concat(qn(i), "."));
}
function Aw(e, t, n, r, a) {
  for (var i = e.body, o = t + 1, s = o, u = 0, l = ""; o < i.length && !isNaN(u = i.charCodeAt(o)) &&
  // not LineTerminator
  u !== 10 && u !== 13;) {
    if (u === 34) return l += i.slice(s, o), new at(q.STRING, t, o + 1, n, r, a, l);
    if (u < 32 && u !== 9) throw At(e, o, "Invalid character within String: ".concat(qn(u), "."));
    if (++o, u === 92) {
      switch (l += i.slice(s, o - 1), u = i.charCodeAt(o), u) {
        case 34:
          l += '"';
          break;
        case 47:
          l += "/";
          break;
        case 92:
          l += "\\";
          break;
        case 98:
          l += "\b";
          break;
        case 102:
          l += "\f";
          break;
        case 110:
          l += "\n";
          break;
        case 114:
          l += "\r";
          break;
        case 116:
          l += "	";
          break;
        case 117:
          {
            var c = Mw(i.charCodeAt(o + 1), i.charCodeAt(o + 2), i.charCodeAt(o + 3), i.charCodeAt(o + 4));
            if (c < 0) {
              var f = i.slice(o + 1, o + 5);
              throw At(e, o, "Invalid character escape sequence: \\u".concat(f, "."));
            }
            l += String.fromCharCode(c), o += 4;
            break;
          }
        default:
          throw At(e, o, "Invalid character escape sequence: \\".concat(String.fromCharCode(u), "."));
      }
      ++o, s = o;
    }
  }
  throw At(e, o, "Unterminated string.");
}
function Iw(e, t, n, r, a, i) {
  for (var o = e.body, s = t + 3, u = s, l = 0, c = ""; s < o.length && !isNaN(l = o.charCodeAt(s));) {
    if (l === 34 && o.charCodeAt(s + 1) === 34 && o.charCodeAt(s + 2) === 34) return c += o.slice(u, s), new at(q.BLOCK_STRING, t, s + 3, n, r, a, Pw(c));
    if (l < 32 && l !== 9 && l !== 10 && l !== 13) throw At(e, s, "Invalid character within String: ".concat(qn(l), "."));
    l === 10 ? (++s, ++i.line, i.lineStart = s) : l === 13 ? (o.charCodeAt(s + 1) === 10 ? s += 2 : ++s, ++i.line, i.lineStart = s) : /* Escape Triple-Quote (\""") */l === 92 && o.charCodeAt(s + 1) === 34 && o.charCodeAt(s + 2) === 34 && o.charCodeAt(s + 3) === 34 ? (c += o.slice(u, s) + '"""', s += 4, u = s) : ++s;
  }
  throw At(e, s, "Unterminated string.");
}
function Mw(e, t, n, r) {
  return La(e) << 12 | La(t) << 8 | La(n) << 4 | La(r);
}
function La(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function Fw(e, t, n, r, a) {
  for (var i = e.body, o = i.length, s = t + 1, u = 0; s !== o && !isNaN(u = i.charCodeAt(s)) && (u === 95 ||
  // _
  u >= 48 && u <= 57 ||
  // 0-9
  u >= 65 && u <= 90 ||
  // A-Z
  u >= 97 && u <= 122);) ++s;
  return new at(q.NAME, t, s, n, r, a, i.slice(t, s));
}
function Lw(e) {
  return e === 95 || e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
function jw(e, t) {
  var n = new Bw(e, t);
  return n.parseDocument();
}
var Bw = /* @__PURE__ */function () {
  function e(n, r) {
    var a = Sw(n) ? n : new Mc(n);
    this._lexer = new Dw(a), this._options = r;
  }
  var t = e.prototype;
  return t.parseName = function () {
    var r = this.expectToken(q.NAME);
    return {
      kind: we.NAME,
      value: r.value,
      loc: this.loc(r)
    };
  }, t.parseDocument = function () {
    var r = this._lexer.token;
    return {
      kind: we.DOCUMENT,
      definitions: this.many(q.SOF, this.parseDefinition, q.EOF),
      loc: this.loc(r)
    };
  }, t.parseDefinition = function () {
    if (this.peek(q.NAME)) switch (this._lexer.token.value) {
      case "query":
      case "mutation":
      case "subscription":
        return this.parseOperationDefinition();
      case "fragment":
        return this.parseFragmentDefinition();
      case "schema":
      case "scalar":
      case "type":
      case "interface":
      case "union":
      case "enum":
      case "input":
      case "directive":
        return this.parseTypeSystemDefinition();
      case "extend":
        return this.parseTypeSystemExtension();
    } else {
      if (this.peek(q.BRACE_L)) return this.parseOperationDefinition();
      if (this.peekDescription()) return this.parseTypeSystemDefinition();
    }
    throw this.unexpected();
  }, t.parseOperationDefinition = function () {
    var r = this._lexer.token;
    if (this.peek(q.BRACE_L)) return {
      kind: we.OPERATION_DEFINITION,
      operation: "query",
      name: void 0,
      variableDefinitions: [],
      directives: [],
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(r)
    };
    var a = this.parseOperationType(),
      i;
    return this.peek(q.NAME) && (i = this.parseName()), {
      kind: we.OPERATION_DEFINITION,
      operation: a,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(r)
    };
  }, t.parseOperationType = function () {
    var r = this.expectToken(q.NAME);
    switch (r.value) {
      case "query":
        return "query";
      case "mutation":
        return "mutation";
      case "subscription":
        return "subscription";
    }
    throw this.unexpected(r);
  }, t.parseVariableDefinitions = function () {
    return this.optionalMany(q.PAREN_L, this.parseVariableDefinition, q.PAREN_R);
  }, t.parseVariableDefinition = function () {
    var r = this._lexer.token;
    return {
      kind: we.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(q.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(q.EQUALS) ? this.parseValueLiteral(!0) : void 0,
      directives: this.parseDirectives(!0),
      loc: this.loc(r)
    };
  }, t.parseVariable = function () {
    var r = this._lexer.token;
    return this.expectToken(q.DOLLAR), {
      kind: we.VARIABLE,
      name: this.parseName(),
      loc: this.loc(r)
    };
  }, t.parseSelectionSet = function () {
    var r = this._lexer.token;
    return {
      kind: we.SELECTION_SET,
      selections: this.many(q.BRACE_L, this.parseSelection, q.BRACE_R),
      loc: this.loc(r)
    };
  }, t.parseSelection = function () {
    return this.peek(q.SPREAD) ? this.parseFragment() : this.parseField();
  }, t.parseField = function () {
    var r = this._lexer.token,
      a = this.parseName(),
      i,
      o;
    return this.expectOptionalToken(q.COLON) ? (i = a, o = this.parseName()) : o = a, {
      kind: we.FIELD,
      alias: i,
      name: o,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(q.BRACE_L) ? this.parseSelectionSet() : void 0,
      loc: this.loc(r)
    };
  }, t.parseArguments = function (r) {
    var a = r ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(q.PAREN_L, a, q.PAREN_R);
  }, t.parseArgument = function () {
    var r = this._lexer.token,
      a = this.parseName();
    return this.expectToken(q.COLON), {
      kind: we.ARGUMENT,
      name: a,
      value: this.parseValueLiteral(!1),
      loc: this.loc(r)
    };
  }, t.parseConstArgument = function () {
    var r = this._lexer.token;
    return {
      kind: we.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(q.COLON), this.parseValueLiteral(!0)),
      loc: this.loc(r)
    };
  }, t.parseFragment = function () {
    var r = this._lexer.token;
    this.expectToken(q.SPREAD);
    var a = this.expectOptionalKeyword("on");
    return !a && this.peek(q.NAME) ? {
      kind: we.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1),
      loc: this.loc(r)
    } : {
      kind: we.INLINE_FRAGMENT,
      typeCondition: a ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(r)
    };
  }, t.parseFragmentDefinition = function () {
    var r,
      a = this._lexer.token;
    return this.expectKeyword("fragment"), ((r = this._options) === null || r === void 0 ? void 0 : r.experimentalFragmentVariables) === !0 ? {
      kind: we.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(a)
    } : {
      kind: we.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(a)
    };
  }, t.parseFragmentName = function () {
    if (this._lexer.token.value === "on") throw this.unexpected();
    return this.parseName();
  }, t.parseValueLiteral = function (r) {
    var a = this._lexer.token;
    switch (a.kind) {
      case q.BRACKET_L:
        return this.parseList(r);
      case q.BRACE_L:
        return this.parseObject(r);
      case q.INT:
        return this._lexer.advance(), {
          kind: we.INT,
          value: a.value,
          loc: this.loc(a)
        };
      case q.FLOAT:
        return this._lexer.advance(), {
          kind: we.FLOAT,
          value: a.value,
          loc: this.loc(a)
        };
      case q.STRING:
      case q.BLOCK_STRING:
        return this.parseStringLiteral();
      case q.NAME:
        switch (this._lexer.advance(), a.value) {
          case "true":
            return {
              kind: we.BOOLEAN,
              value: !0,
              loc: this.loc(a)
            };
          case "false":
            return {
              kind: we.BOOLEAN,
              value: !1,
              loc: this.loc(a)
            };
          case "null":
            return {
              kind: we.NULL,
              loc: this.loc(a)
            };
          default:
            return {
              kind: we.ENUM,
              value: a.value,
              loc: this.loc(a)
            };
        }
      case q.DOLLAR:
        if (!r) return this.parseVariable();
        break;
    }
    throw this.unexpected();
  }, t.parseStringLiteral = function () {
    var r = this._lexer.token;
    return this._lexer.advance(), {
      kind: we.STRING,
      value: r.value,
      block: r.kind === q.BLOCK_STRING,
      loc: this.loc(r)
    };
  }, t.parseList = function (r) {
    var a = this,
      i = this._lexer.token,
      o = function o() {
        return a.parseValueLiteral(r);
      };
    return {
      kind: we.LIST,
      values: this.any(q.BRACKET_L, o, q.BRACKET_R),
      loc: this.loc(i)
    };
  }, t.parseObject = function (r) {
    var a = this,
      i = this._lexer.token,
      o = function o() {
        return a.parseObjectField(r);
      };
    return {
      kind: we.OBJECT,
      fields: this.any(q.BRACE_L, o, q.BRACE_R),
      loc: this.loc(i)
    };
  }, t.parseObjectField = function (r) {
    var a = this._lexer.token,
      i = this.parseName();
    return this.expectToken(q.COLON), {
      kind: we.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(r),
      loc: this.loc(a)
    };
  }, t.parseDirectives = function (r) {
    for (var a = []; this.peek(q.AT);) a.push(this.parseDirective(r));
    return a;
  }, t.parseDirective = function (r) {
    var a = this._lexer.token;
    return this.expectToken(q.AT), {
      kind: we.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(r),
      loc: this.loc(a)
    };
  }, t.parseTypeReference = function () {
    var r = this._lexer.token,
      a;
    return this.expectOptionalToken(q.BRACKET_L) ? (a = this.parseTypeReference(), this.expectToken(q.BRACKET_R), a = {
      kind: we.LIST_TYPE,
      type: a,
      loc: this.loc(r)
    }) : a = this.parseNamedType(), this.expectOptionalToken(q.BANG) ? {
      kind: we.NON_NULL_TYPE,
      type: a,
      loc: this.loc(r)
    } : a;
  }, t.parseNamedType = function () {
    var r = this._lexer.token;
    return {
      kind: we.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(r)
    };
  }, t.parseTypeSystemDefinition = function () {
    var r = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === q.NAME) switch (r.value) {
      case "schema":
        return this.parseSchemaDefinition();
      case "scalar":
        return this.parseScalarTypeDefinition();
      case "type":
        return this.parseObjectTypeDefinition();
      case "interface":
        return this.parseInterfaceTypeDefinition();
      case "union":
        return this.parseUnionTypeDefinition();
      case "enum":
        return this.parseEnumTypeDefinition();
      case "input":
        return this.parseInputObjectTypeDefinition();
      case "directive":
        return this.parseDirectiveDefinition();
    }
    throw this.unexpected(r);
  }, t.peekDescription = function () {
    return this.peek(q.STRING) || this.peek(q.BLOCK_STRING);
  }, t.parseDescription = function () {
    if (this.peekDescription()) return this.parseStringLiteral();
  }, t.parseSchemaDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("schema");
    var i = this.parseDirectives(!0),
      o = this.many(q.BRACE_L, this.parseOperationTypeDefinition, q.BRACE_R);
    return {
      kind: we.SCHEMA_DEFINITION,
      description: a,
      directives: i,
      operationTypes: o,
      loc: this.loc(r)
    };
  }, t.parseOperationTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseOperationType();
    this.expectToken(q.COLON);
    var i = this.parseNamedType();
    return {
      kind: we.OPERATION_TYPE_DEFINITION,
      operation: a,
      type: i,
      loc: this.loc(r)
    };
  }, t.parseScalarTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("scalar");
    var i = this.parseName(),
      o = this.parseDirectives(!0);
    return {
      kind: we.SCALAR_TYPE_DEFINITION,
      description: a,
      name: i,
      directives: o,
      loc: this.loc(r)
    };
  }, t.parseObjectTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("type");
    var i = this.parseName(),
      o = this.parseImplementsInterfaces(),
      s = this.parseDirectives(!0),
      u = this.parseFieldsDefinition();
    return {
      kind: we.OBJECT_TYPE_DEFINITION,
      description: a,
      name: i,
      interfaces: o,
      directives: s,
      fields: u,
      loc: this.loc(r)
    };
  }, t.parseImplementsInterfaces = function () {
    var r;
    if (!this.expectOptionalKeyword("implements")) return [];
    if (((r = this._options) === null || r === void 0 ? void 0 : r.allowLegacySDLImplementsInterfaces) === !0) {
      var a = [];
      this.expectOptionalToken(q.AMP);
      do a.push(this.parseNamedType()); while (this.expectOptionalToken(q.AMP) || this.peek(q.NAME));
      return a;
    }
    return this.delimitedMany(q.AMP, this.parseNamedType);
  }, t.parseFieldsDefinition = function () {
    var r;
    return ((r = this._options) === null || r === void 0 ? void 0 : r.allowLegacySDLEmptyFields) === !0 && this.peek(q.BRACE_L) && this._lexer.lookahead().kind === q.BRACE_R ? (this._lexer.advance(), this._lexer.advance(), []) : this.optionalMany(q.BRACE_L, this.parseFieldDefinition, q.BRACE_R);
  }, t.parseFieldDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription(),
      i = this.parseName(),
      o = this.parseArgumentDefs();
    this.expectToken(q.COLON);
    var s = this.parseTypeReference(),
      u = this.parseDirectives(!0);
    return {
      kind: we.FIELD_DEFINITION,
      description: a,
      name: i,
      arguments: o,
      type: s,
      directives: u,
      loc: this.loc(r)
    };
  }, t.parseArgumentDefs = function () {
    return this.optionalMany(q.PAREN_L, this.parseInputValueDef, q.PAREN_R);
  }, t.parseInputValueDef = function () {
    var r = this._lexer.token,
      a = this.parseDescription(),
      i = this.parseName();
    this.expectToken(q.COLON);
    var o = this.parseTypeReference(),
      s;
    this.expectOptionalToken(q.EQUALS) && (s = this.parseValueLiteral(!0));
    var u = this.parseDirectives(!0);
    return {
      kind: we.INPUT_VALUE_DEFINITION,
      description: a,
      name: i,
      type: o,
      defaultValue: s,
      directives: u,
      loc: this.loc(r)
    };
  }, t.parseInterfaceTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("interface");
    var i = this.parseName(),
      o = this.parseImplementsInterfaces(),
      s = this.parseDirectives(!0),
      u = this.parseFieldsDefinition();
    return {
      kind: we.INTERFACE_TYPE_DEFINITION,
      description: a,
      name: i,
      interfaces: o,
      directives: s,
      fields: u,
      loc: this.loc(r)
    };
  }, t.parseUnionTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("union");
    var i = this.parseName(),
      o = this.parseDirectives(!0),
      s = this.parseUnionMemberTypes();
    return {
      kind: we.UNION_TYPE_DEFINITION,
      description: a,
      name: i,
      directives: o,
      types: s,
      loc: this.loc(r)
    };
  }, t.parseUnionMemberTypes = function () {
    return this.expectOptionalToken(q.EQUALS) ? this.delimitedMany(q.PIPE, this.parseNamedType) : [];
  }, t.parseEnumTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("enum");
    var i = this.parseName(),
      o = this.parseDirectives(!0),
      s = this.parseEnumValuesDefinition();
    return {
      kind: we.ENUM_TYPE_DEFINITION,
      description: a,
      name: i,
      directives: o,
      values: s,
      loc: this.loc(r)
    };
  }, t.parseEnumValuesDefinition = function () {
    return this.optionalMany(q.BRACE_L, this.parseEnumValueDefinition, q.BRACE_R);
  }, t.parseEnumValueDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription(),
      i = this.parseName(),
      o = this.parseDirectives(!0);
    return {
      kind: we.ENUM_VALUE_DEFINITION,
      description: a,
      name: i,
      directives: o,
      loc: this.loc(r)
    };
  }, t.parseInputObjectTypeDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("input");
    var i = this.parseName(),
      o = this.parseDirectives(!0),
      s = this.parseInputFieldsDefinition();
    return {
      kind: we.INPUT_OBJECT_TYPE_DEFINITION,
      description: a,
      name: i,
      directives: o,
      fields: s,
      loc: this.loc(r)
    };
  }, t.parseInputFieldsDefinition = function () {
    return this.optionalMany(q.BRACE_L, this.parseInputValueDef, q.BRACE_R);
  }, t.parseTypeSystemExtension = function () {
    var r = this._lexer.lookahead();
    if (r.kind === q.NAME) switch (r.value) {
      case "schema":
        return this.parseSchemaExtension();
      case "scalar":
        return this.parseScalarTypeExtension();
      case "type":
        return this.parseObjectTypeExtension();
      case "interface":
        return this.parseInterfaceTypeExtension();
      case "union":
        return this.parseUnionTypeExtension();
      case "enum":
        return this.parseEnumTypeExtension();
      case "input":
        return this.parseInputObjectTypeExtension();
    }
    throw this.unexpected(r);
  }, t.parseSchemaExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    var a = this.parseDirectives(!0),
      i = this.optionalMany(q.BRACE_L, this.parseOperationTypeDefinition, q.BRACE_R);
    if (a.length === 0 && i.length === 0) throw this.unexpected();
    return {
      kind: we.SCHEMA_EXTENSION,
      directives: a,
      operationTypes: i,
      loc: this.loc(r)
    };
  }, t.parseScalarTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    var a = this.parseName(),
      i = this.parseDirectives(!0);
    if (i.length === 0) throw this.unexpected();
    return {
      kind: we.SCALAR_TYPE_EXTENSION,
      name: a,
      directives: i,
      loc: this.loc(r)
    };
  }, t.parseObjectTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    var a = this.parseName(),
      i = this.parseImplementsInterfaces(),
      o = this.parseDirectives(!0),
      s = this.parseFieldsDefinition();
    if (i.length === 0 && o.length === 0 && s.length === 0) throw this.unexpected();
    return {
      kind: we.OBJECT_TYPE_EXTENSION,
      name: a,
      interfaces: i,
      directives: o,
      fields: s,
      loc: this.loc(r)
    };
  }, t.parseInterfaceTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    var a = this.parseName(),
      i = this.parseImplementsInterfaces(),
      o = this.parseDirectives(!0),
      s = this.parseFieldsDefinition();
    if (i.length === 0 && o.length === 0 && s.length === 0) throw this.unexpected();
    return {
      kind: we.INTERFACE_TYPE_EXTENSION,
      name: a,
      interfaces: i,
      directives: o,
      fields: s,
      loc: this.loc(r)
    };
  }, t.parseUnionTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    var a = this.parseName(),
      i = this.parseDirectives(!0),
      o = this.parseUnionMemberTypes();
    if (i.length === 0 && o.length === 0) throw this.unexpected();
    return {
      kind: we.UNION_TYPE_EXTENSION,
      name: a,
      directives: i,
      types: o,
      loc: this.loc(r)
    };
  }, t.parseEnumTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    var a = this.parseName(),
      i = this.parseDirectives(!0),
      o = this.parseEnumValuesDefinition();
    if (i.length === 0 && o.length === 0) throw this.unexpected();
    return {
      kind: we.ENUM_TYPE_EXTENSION,
      name: a,
      directives: i,
      values: o,
      loc: this.loc(r)
    };
  }, t.parseInputObjectTypeExtension = function () {
    var r = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    var a = this.parseName(),
      i = this.parseDirectives(!0),
      o = this.parseInputFieldsDefinition();
    if (i.length === 0 && o.length === 0) throw this.unexpected();
    return {
      kind: we.INPUT_OBJECT_TYPE_EXTENSION,
      name: a,
      directives: i,
      fields: o,
      loc: this.loc(r)
    };
  }, t.parseDirectiveDefinition = function () {
    var r = this._lexer.token,
      a = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(q.AT);
    var i = this.parseName(),
      o = this.parseArgumentDefs(),
      s = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    var u = this.parseDirectiveLocations();
    return {
      kind: we.DIRECTIVE_DEFINITION,
      description: a,
      name: i,
      arguments: o,
      repeatable: s,
      locations: u,
      loc: this.loc(r)
    };
  }, t.parseDirectiveLocations = function () {
    return this.delimitedMany(q.PIPE, this.parseDirectiveLocation);
  }, t.parseDirectiveLocation = function () {
    var r = this._lexer.token,
      a = this.parseName();
    if (Ew[a.value] !== void 0) return a;
    throw this.unexpected(r);
  }, t.loc = function (r) {
    var a;
    if (((a = this._options) === null || a === void 0 ? void 0 : a.noLocation) !== !0) return new Rv(r, this._lexer.lastToken, this._lexer.source);
  }, t.peek = function (r) {
    return this._lexer.token.kind === r;
  }, t.expectToken = function (r) {
    var a = this._lexer.token;
    if (a.kind === r) return this._lexer.advance(), a;
    throw At(this._lexer.source, a.start, "Expected ".concat(Av(r), ", found ").concat(_s(a), "."));
  }, t.expectOptionalToken = function (r) {
    var a = this._lexer.token;
    if (a.kind === r) return this._lexer.advance(), a;
  }, t.expectKeyword = function (r) {
    var a = this._lexer.token;
    if (a.kind === q.NAME && a.value === r) this._lexer.advance();else throw At(this._lexer.source, a.start, 'Expected "'.concat(r, '", found ').concat(_s(a), "."));
  }, t.expectOptionalKeyword = function (r) {
    var a = this._lexer.token;
    return a.kind === q.NAME && a.value === r ? (this._lexer.advance(), !0) : !1;
  }, t.unexpected = function (r) {
    var a = r !== null && r !== void 0 ? r : this._lexer.token;
    return At(this._lexer.source, a.start, "Unexpected ".concat(_s(a), "."));
  }, t.any = function (r, a, i) {
    this.expectToken(r);
    for (var o = []; !this.expectOptionalToken(i);) o.push(a.call(this));
    return o;
  }, t.optionalMany = function (r, a, i) {
    if (this.expectOptionalToken(r)) {
      var o = [];
      do o.push(a.call(this)); while (!this.expectOptionalToken(i));
      return o;
    }
    return [];
  }, t.many = function (r, a, i) {
    this.expectToken(r);
    var o = [];
    do o.push(a.call(this)); while (!this.expectOptionalToken(i));
    return o;
  }, t.delimitedMany = function (r, a) {
    this.expectOptionalToken(r);
    var i = [];
    do i.push(a.call(this)); while (this.expectOptionalToken(r));
    return i;
  }, e;
}();
function _s(e) {
  var t = e.value;
  return Av(e.kind) + (t != null ? ' "'.concat(t, '"') : "");
}
function Av(e) {
  return xw(e) ? '"'.concat(e, '"') : e;
}
var Vw = {
    Name: [],
    Document: ["definitions"],
    OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
    VariableDefinition: ["variable", "type", "defaultValue", "directives"],
    Variable: ["name"],
    SelectionSet: ["selections"],
    Field: ["alias", "name", "arguments", "directives", "selectionSet"],
    Argument: ["name", "value"],
    FragmentSpread: ["name", "directives"],
    InlineFragment: ["typeCondition", "directives", "selectionSet"],
    FragmentDefinition: ["name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions", "typeCondition", "directives", "selectionSet"],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: ["values"],
    ObjectValue: ["fields"],
    ObjectField: ["name", "value"],
    Directive: ["name", "arguments"],
    NamedType: ["name"],
    ListType: ["type"],
    NonNullType: ["type"],
    SchemaDefinition: ["description", "directives", "operationTypes"],
    OperationTypeDefinition: ["type"],
    ScalarTypeDefinition: ["description", "name", "directives"],
    ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
    FieldDefinition: ["description", "name", "arguments", "type", "directives"],
    InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
    InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
    UnionTypeDefinition: ["description", "name", "directives", "types"],
    EnumTypeDefinition: ["description", "name", "directives", "values"],
    EnumValueDefinition: ["description", "name", "directives"],
    InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
    DirectiveDefinition: ["description", "name", "arguments", "locations"],
    SchemaExtension: ["directives", "operationTypes"],
    ScalarTypeExtension: ["name", "directives"],
    ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
    InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
    UnionTypeExtension: ["name", "directives", "types"],
    EnumTypeExtension: ["name", "directives", "values"],
    InputObjectTypeExtension: ["name", "directives", "fields"]
  },
  Fc = Object.freeze({});
function tn(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Vw,
    r = void 0,
    a = Array.isArray(e),
    i = [e],
    o = -1,
    s = [],
    u = void 0,
    l = void 0,
    c = void 0,
    f = [],
    h = [],
    p = e;
  do {
    o++;
    var v = o === i.length,
      m = v && s.length !== 0;
    if (v) {
      if (l = h.length === 0 ? void 0 : f[f.length - 1], u = c, c = h.pop(), m) {
        if (a) u = u.slice();else {
          for (var g = {}, b = 0, y = Object.keys(u); b < y.length; b++) {
            var E = y[b];
            g[E] = u[E];
          }
          u = g;
        }
        for (var w = 0, _ = 0; _ < s.length; _++) {
          var C = s[_][0],
            D = s[_][1];
          a && (C -= w), a && D === null ? (u.splice(C, 1), w++) : u[C] = D;
        }
      }
      o = r.index, i = r.keys, s = r.edits, a = r.inArray, r = r.prev;
    } else {
      if (l = c ? a ? o : i[o] : void 0, u = c ? c[l] : p, u == null) continue;
      c && f.push(l);
    }
    var U = void 0;
    if (!Array.isArray(u)) {
      if (!bd(u)) throw new Error("Invalid AST Node: ".concat(Ic(u), "."));
      var Z = qw(t, u.kind, v);
      if (Z) {
        if (U = Z.call(t, u, l, c, f, h), U === Fc) break;
        if (U === !1) {
          if (!v) {
            f.pop();
            continue;
          }
        } else if (U !== void 0 && (s.push([l, U]), !v)) if (bd(U)) u = U;else {
          f.pop();
          continue;
        }
      }
    }
    if (U === void 0 && m && s.push([l, u]), v) f.pop();else {
      var me;
      r = {
        inArray: a,
        index: o,
        keys: i,
        edits: s,
        prev: r
      }, a = Array.isArray(u), i = a ? u : (me = n[u.kind]) !== null && me !== void 0 ? me : [], o = -1, s = [], c && h.push(c), c = u;
    }
  } while (r !== void 0);
  return s.length !== 0 && (p = s[s.length - 1][1]), p;
}
function qw(e, t, n) {
  var r = e[t];
  if (r) {
    if (!n && typeof r == "function") return r;
    var a = n ? r.leave : r.enter;
    if (typeof a == "function") return a;
  } else {
    var i = n ? e.leave : e.enter;
    if (i) {
      if (typeof i == "function") return i;
      var o = i[t];
      if (typeof o == "function") return o;
    }
  }
}
function Uw(e) {
  return tn(e, {
    leave: Hw
  });
}
var zw = 80,
  Hw = {
    Name: function Name(t) {
      return t.value;
    },
    Variable: function Variable(t) {
      return "$" + t.name;
    },
    // Document
    Document: function Document(t) {
      return he(t.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(t) {
      var n = t.operation,
        r = t.name,
        a = Xe("(", he(t.variableDefinitions, ", "), ")"),
        i = he(t.directives, " "),
        o = t.selectionSet;
      return !r && !i && !a && n === "query" ? o : he([n, he([r, a]), i, o], " ");
    },
    VariableDefinition: function VariableDefinition(t) {
      var n = t.variable,
        r = t.type,
        a = t.defaultValue,
        i = t.directives;
      return n + ": " + r + Xe(" = ", a) + Xe(" ", he(i, " "));
    },
    SelectionSet: function SelectionSet(t) {
      var n = t.selections;
      return Ut(n);
    },
    Field: function Field(t) {
      var n = t.alias,
        r = t.name,
        a = t.arguments,
        i = t.directives,
        o = t.selectionSet,
        s = Xe("", n, ": ") + r,
        u = s + Xe("(", he(a, ", "), ")");
      return u.length > zw && (u = s + Xe("(\n", ei(he(a, "\n")), "\n)")), he([u, he(i, " "), o], " ");
    },
    Argument: function Argument(t) {
      var n = t.name,
        r = t.value;
      return n + ": " + r;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(t) {
      var n = t.name,
        r = t.directives;
      return "..." + n + Xe(" ", he(r, " "));
    },
    InlineFragment: function InlineFragment(t) {
      var n = t.typeCondition,
        r = t.directives,
        a = t.selectionSet;
      return he(["...", Xe("on ", n), he(r, " "), a], " ");
    },
    FragmentDefinition: function FragmentDefinition(t) {
      var n = t.name,
        r = t.typeCondition,
        a = t.variableDefinitions,
        i = t.directives,
        o = t.selectionSet;
      return (
        // Note: fragment variable definitions are experimental and may be changed
        // or removed in the future.
        "fragment ".concat(n).concat(Xe("(", he(a, ", "), ")"), " ") + "on ".concat(r, " ").concat(Xe("", he(i, " "), " ")) + o
      );
    },
    // Value
    IntValue: function IntValue(t) {
      var n = t.value;
      return n;
    },
    FloatValue: function FloatValue(t) {
      var n = t.value;
      return n;
    },
    StringValue: function StringValue(t, n) {
      var r = t.value,
        a = t.block;
      return a ? kw(r, n === "description" ? "" : "  ") : JSON.stringify(r);
    },
    BooleanValue: function BooleanValue(t) {
      var n = t.value;
      return n ? "true" : "false";
    },
    NullValue: function NullValue() {
      return "null";
    },
    EnumValue: function EnumValue(t) {
      var n = t.value;
      return n;
    },
    ListValue: function ListValue(t) {
      var n = t.values;
      return "[" + he(n, ", ") + "]";
    },
    ObjectValue: function ObjectValue(t) {
      var n = t.fields;
      return "{" + he(n, ", ") + "}";
    },
    ObjectField: function ObjectField(t) {
      var n = t.name,
        r = t.value;
      return n + ": " + r;
    },
    // Directive
    Directive: function Directive(t) {
      var n = t.name,
        r = t.arguments;
      return "@" + n + Xe("(", he(r, ", "), ")");
    },
    // Type
    NamedType: function NamedType(t) {
      var n = t.name;
      return n;
    },
    ListType: function ListType(t) {
      var n = t.type;
      return "[" + n + "]";
    },
    NonNullType: function NonNullType(t) {
      var n = t.type;
      return n + "!";
    },
    // Type System Definitions
    SchemaDefinition: qt(function (e) {
      var t = e.directives,
        n = e.operationTypes;
      return he(["schema", he(t, " "), Ut(n)], " ");
    }),
    OperationTypeDefinition: function OperationTypeDefinition(t) {
      var n = t.operation,
        r = t.type;
      return n + ": " + r;
    },
    ScalarTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.directives;
      return he(["scalar", t, he(n, " ")], " ");
    }),
    ObjectTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.interfaces,
        r = e.directives,
        a = e.fields;
      return he(["type", t, Xe("implements ", he(n, " & ")), he(r, " "), Ut(a)], " ");
    }),
    FieldDefinition: qt(function (e) {
      var t = e.name,
        n = e.arguments,
        r = e.type,
        a = e.directives;
      return t + (Od(n) ? Xe("(\n", ei(he(n, "\n")), "\n)") : Xe("(", he(n, ", "), ")")) + ": " + r + Xe(" ", he(a, " "));
    }),
    InputValueDefinition: qt(function (e) {
      var t = e.name,
        n = e.type,
        r = e.defaultValue,
        a = e.directives;
      return he([t + ": " + n, Xe("= ", r), he(a, " ")], " ");
    }),
    InterfaceTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.interfaces,
        r = e.directives,
        a = e.fields;
      return he(["interface", t, Xe("implements ", he(n, " & ")), he(r, " "), Ut(a)], " ");
    }),
    UnionTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.directives,
        r = e.types;
      return he(["union", t, he(n, " "), r && r.length !== 0 ? "= " + he(r, " | ") : ""], " ");
    }),
    EnumTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.directives,
        r = e.values;
      return he(["enum", t, he(n, " "), Ut(r)], " ");
    }),
    EnumValueDefinition: qt(function (e) {
      var t = e.name,
        n = e.directives;
      return he([t, he(n, " ")], " ");
    }),
    InputObjectTypeDefinition: qt(function (e) {
      var t = e.name,
        n = e.directives,
        r = e.fields;
      return he(["input", t, he(n, " "), Ut(r)], " ");
    }),
    DirectiveDefinition: qt(function (e) {
      var t = e.name,
        n = e.arguments,
        r = e.repeatable,
        a = e.locations;
      return "directive @" + t + (Od(n) ? Xe("(\n", ei(he(n, "\n")), "\n)") : Xe("(", he(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + he(a, " | ");
    }),
    SchemaExtension: function SchemaExtension(t) {
      var n = t.directives,
        r = t.operationTypes;
      return he(["extend schema", he(n, " "), Ut(r)], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(t) {
      var n = t.name,
        r = t.directives;
      return he(["extend scalar", n, he(r, " ")], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(t) {
      var n = t.name,
        r = t.interfaces,
        a = t.directives,
        i = t.fields;
      return he(["extend type", n, Xe("implements ", he(r, " & ")), he(a, " "), Ut(i)], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(t) {
      var n = t.name,
        r = t.interfaces,
        a = t.directives,
        i = t.fields;
      return he(["extend interface", n, Xe("implements ", he(r, " & ")), he(a, " "), Ut(i)], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(t) {
      var n = t.name,
        r = t.directives,
        a = t.types;
      return he(["extend union", n, he(r, " "), a && a.length !== 0 ? "= " + he(a, " | ") : ""], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(t) {
      var n = t.name,
        r = t.directives,
        a = t.values;
      return he(["extend enum", n, he(r, " "), Ut(a)], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(t) {
      var n = t.name,
        r = t.directives,
        a = t.fields;
      return he(["extend input", n, he(r, " "), Ut(a)], " ");
    }
  };
function qt(e) {
  return function (t) {
    return he([t.description, e(t)], "\n");
  };
}
function he(e) {
  var t,
    n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e == null ? void 0 : e.filter(function (r) {
    return r;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function Ut(e) {
  return Xe("{\n", ei(he(e, "\n")), "\n}");
}
function Xe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function ei(e) {
  return Xe("  ", e.replace(/\n/g, "\n  "));
}
function Ww(e) {
  return e.indexOf("\n") !== -1;
}
function Od(e) {
  return e != null && e.some(Ww);
}
function Gw() {
  return pd();
}
function Yw() {
  __DEV__ ? te(typeof ys == "boolean", ys) : te(typeof ys == "boolean", 38);
}
Gw();
Yw();
function zo(e, t) {
  var n = e.directives;
  return !n || !n.length ? !0 : Jw(n).every(function (r) {
    var a = r.directive,
      i = r.ifArgument,
      o = !1;
    return i.value.kind === "Variable" ? (o = t && t[i.value.name.value], __DEV__ ? te(o !== void 0, "Invalid variable referenced in @".concat(a.name.value, " directive.")) : te(o !== void 0, 39)) : o = i.value.value, a.name.value === "skip" ? !o : o;
  });
}
function Lc(e, t, n) {
  var r = new Set(e),
    a = r.size;
  return tn(t, {
    Directive: function Directive(i) {
      if (r.delete(i.name.value) && (!n || !r.size)) return Fc;
    }
  }), n ? !r.size : r.size < a;
}
function Qw(e) {
  return e && Lc(["client", "export"], e, !0);
}
function Kw(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function Jw(e) {
  var t = [];
  return e && e.length && e.forEach(function (n) {
    if (Kw(n)) {
      var r = n.arguments,
        a = n.name.value;
      __DEV__ ? te(r && r.length === 1, "Incorrect number of arguments for the @".concat(a, " directive.")) : te(r && r.length === 1, 40);
      var i = r[0];
      __DEV__ ? te(i.name && i.name.value === "if", "Invalid argument for the @".concat(a, " directive.")) : te(i.name && i.name.value === "if", 41);
      var o = i.value;
      __DEV__ ? te(o && (o.kind === "Variable" || o.kind === "BooleanValue"), "Argument for the @".concat(a, " directive must be a variable or a boolean value.")) : te(o && (o.kind === "Variable" || o.kind === "BooleanValue"), 42), t.push({
        directive: n,
        ifArgument: i
      });
    }
  }), t;
}
function Xw(e, t) {
  var n = t,
    r = [];
  e.definitions.forEach(function (i) {
    if (i.kind === "OperationDefinition") throw __DEV__ ? new Ne("Found a ".concat(i.operation, " operation").concat(i.name ? " named '".concat(i.name.value, "'") : "", ". ") + "No operations are allowed when using a fragment as a query. Only fragments are allowed.") : new Ne(43);
    i.kind === "FragmentDefinition" && r.push(i);
  }), typeof n > "u" && (__DEV__ ? te(r.length === 1, "Found ".concat(r.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : te(r.length === 1, 44), n = r[0].name.value);
  var a = _P2(_P2({}, e), {
    definitions: xt([{
      kind: "OperationDefinition",
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [{
          kind: "FragmentSpread",
          name: {
            kind: "Name",
            value: n
          }
        }]
      }
    }], e.definitions, !0)
  });
  return a;
}
function jc(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function (n) {
    t[n.name.value] = n;
  }), t;
}
function Bc(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread":
      {
        var n = e.name.value;
        if (typeof t == "function") return t(n);
        var r = t && t[n];
        return __DEV__ ? te(r, "No fragment named ".concat(n)) : te(r, 45), r || null;
      }
    default:
      return null;
  }
}
function it(e) {
  return e !== null && typeof e == "object";
}
function pr(e) {
  return {
    __ref: String(e)
  };
}
function Ve(e) {
  return Boolean(e && typeof e == "object" && typeof e.__ref == "string");
}
function Zw(e) {
  return it(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function e0(e) {
  return e.kind === "StringValue";
}
function t0(e) {
  return e.kind === "BooleanValue";
}
function n0(e) {
  return e.kind === "IntValue";
}
function r0(e) {
  return e.kind === "FloatValue";
}
function a0(e) {
  return e.kind === "Variable";
}
function i0(e) {
  return e.kind === "ObjectValue";
}
function o0(e) {
  return e.kind === "ListValue";
}
function s0(e) {
  return e.kind === "EnumValue";
}
function u0(e) {
  return e.kind === "NullValue";
}
function br(e, t, n, r) {
  if (n0(n) || r0(n)) e[t.value] = Number(n.value);else if (t0(n) || e0(n)) e[t.value] = n.value;else if (i0(n)) {
    var a = {};
    n.fields.map(function (o) {
      return br(a, o.name, o.value, r);
    }), e[t.value] = a;
  } else if (a0(n)) {
    var i = (r || {})[n.name.value];
    e[t.value] = i;
  } else if (o0(n)) e[t.value] = n.values.map(function (o) {
    var s = {};
    return br(s, t, o, r), s[t.value];
  });else if (s0(n)) e[t.value] = n.value;else if (u0(n)) e[t.value] = null;else throw __DEV__ ? new Ne('The inline argument "'.concat(t.value, '" of kind "').concat(n.kind, '"') + "is not supported. Use variables instead of inline arguments to overcome this limitation.") : new Ne(54);
}
function l0(e, t) {
  var n = null;
  e.directives && (n = {}, e.directives.forEach(function (a) {
    n[a.name.value] = {}, a.arguments && a.arguments.forEach(function (i) {
      var o = i.name,
        s = i.value;
      return br(n[a.name.value], o, s, t);
    });
  }));
  var r = null;
  return e.arguments && e.arguments.length && (r = {}, e.arguments.forEach(function (a) {
    var i = a.name,
      o = a.value;
    return br(r, i, o, t);
  })), Vc(e.name.value, r, n);
}
var c0 = ["connection", "include", "skip", "client", "rest", "export"],
  Vc = Object.assign(function (e, t, n) {
    if (t && n && n.connection && n.connection.key) if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var a = {};
      return r.forEach(function (s) {
        a[s] = t[s];
      }), "".concat(n.connection.key, "(").concat(Lr(a), ")");
    } else return n.connection.key;
    var i = e;
    if (t) {
      var o = Lr(t);
      i += "(".concat(o, ")");
    }
    return n && Object.keys(n).forEach(function (s) {
      c0.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? i += "@".concat(s, "(").concat(Lr(n[s]), ")") : i += "@".concat(s));
    }), i;
  }, {
    setStringify: function setStringify(e) {
      var t = Lr;
      return Lr = e, t;
    }
  }),
  Lr = function Lr(t) {
    return JSON.stringify(t, f0);
  };
function f0(e, t) {
  return it(t) && !Array.isArray(t) && (t = Object.keys(t).sort().reduce(function (n, r) {
    return n[r] = t[r], n;
  }, {})), t;
}
function Ho(e, t) {
  if (e.arguments && e.arguments.length) {
    var n = {};
    return e.arguments.forEach(function (r) {
      var a = r.name,
        i = r.value;
      return br(n, a, i, t);
    }), n;
  }
  return null;
}
function Un(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function du(e, t, n) {
  if (typeof e.__typename == "string") return e.__typename;
  for (var r = 0, a = t.selections; r < a.length; r++) {
    var i = a[r];
    if (sn(i)) {
      if (i.name.value === "__typename") return e[Un(i)];
    } else {
      var o = du(e, Bc(i, n).selectionSet, n);
      if (typeof o == "string") return o;
    }
  }
}
function sn(e) {
  return e.kind === "Field";
}
function Iv(e) {
  return e.kind === "InlineFragment";
}
function Wo(e) {
  __DEV__ ? te(e && e.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : te(e && e.kind === "Document", 46);
  var t = e.definitions.filter(function (n) {
    return n.kind !== "FragmentDefinition";
  }).map(function (n) {
    if (n.kind !== "OperationDefinition") throw __DEV__ ? new Ne('Schema type definitions not allowed in queries. Found: "'.concat(n.kind, '"')) : new Ne(47);
    return n;
  });
  return __DEV__ ? te(t.length <= 1, "Ambiguous GraphQL document: contains ".concat(t.length, " operations")) : te(t.length <= 1, 48), e;
}
function _a(e) {
  return Wo(e), e.definitions.filter(function (t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function hu(e) {
  return e.definitions.filter(function (t) {
    return t.kind === "OperationDefinition" && t.name;
  }).map(function (t) {
    return t.name.value;
  })[0] || null;
}
function qc(e) {
  return e.definitions.filter(function (t) {
    return t.kind === "FragmentDefinition";
  });
}
function Mv(e) {
  var t = _a(e);
  return __DEV__ ? te(t && t.operation === "query", "Must contain a query definition.") : te(t && t.operation === "query", 49), t;
}
function d0(e) {
  __DEV__ ? te(e.kind === "Document", 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql') : te(e.kind === "Document", 50), __DEV__ ? te(e.definitions.length <= 1, "Fragment must have exactly one definition.") : te(e.definitions.length <= 1, 51);
  var t = e.definitions[0];
  return __DEV__ ? te(t.kind === "FragmentDefinition", "Must be a fragment definition.") : te(t.kind === "FragmentDefinition", 52), t;
}
function Uc(e) {
  Wo(e);
  for (var t, n = 0, r = e.definitions; n < r.length; n++) {
    var a = r[n];
    if (a.kind === "OperationDefinition") {
      var i = a.operation;
      if (i === "query" || i === "mutation" || i === "subscription") return a;
    }
    a.kind === "FragmentDefinition" && !t && (t = a);
  }
  if (t) return t;
  throw __DEV__ ? new Ne("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.") : new Ne(53);
}
function zc(e) {
  var t = /* @__PURE__ */Object.create(null),
    n = e && e.variableDefinitions;
  return n && n.length && n.forEach(function (r) {
    r.defaultValue && br(t, r.variable.name, r.defaultValue);
  }), t;
}
function Sd(e, t, n) {
  var r = 0;
  return e.forEach(function (a, i) {
    t.call(this, a, i, e) && (e[r++] = a);
  }, n), e.length = r, e;
}
var Ed = {
  kind: "Field",
  name: {
    kind: "Name",
    value: "__typename"
  }
};
function Fv(e, t) {
  return !e || e.selectionSet.selections.every(function (n) {
    return n.kind === "FragmentSpread" && Fv(t[n.name.value], t);
  });
}
function Hc(e) {
  return Fv(_a(e) || d0(e), jc(qc(e))) ? null : e;
}
function Pd(e) {
  return function (n) {
    return e.some(function (r) {
      return r.name && r.name === n.name.value || r.test && r.test(n);
    });
  };
}
function Lv(e, t) {
  var n = /* @__PURE__ */Object.create(null),
    r = [],
    a = /* @__PURE__ */Object.create(null),
    i = [],
    o = Hc(tn(t, {
      Variable: {
        enter: function enter(s, u, l) {
          l.kind !== "VariableDefinition" && (n[s.name.value] = !0);
        }
      },
      Field: {
        enter: function enter(s) {
          if (e && s.directives) {
            var u = e.some(function (l) {
              return l.remove;
            });
            if (u && s.directives && s.directives.some(Pd(e))) return s.arguments && s.arguments.forEach(function (l) {
              l.value.kind === "Variable" && r.push({
                name: l.value.name.value
              });
            }), s.selectionSet && jv(s.selectionSet).forEach(function (l) {
              i.push({
                name: l.name.value
              });
            }), null;
          }
        }
      },
      FragmentSpread: {
        enter: function enter(s) {
          a[s.name.value] = !0;
        }
      },
      Directive: {
        enter: function enter(s) {
          if (Pd(e)(s)) return null;
        }
      }
    }));
  return o && Sd(r, function (s) {
    return !!s.name && !n[s.name];
  }).length && (o = v0(r, o)), o && Sd(i, function (s) {
    return !!s.name && !a[s.name];
  }).length && (o = y0(i, o)), o;
}
var Wc = Object.assign(function (e) {
    return tn(e, {
      SelectionSet: {
        enter: function enter(t, n, r) {
          if (!(r && r.kind === "OperationDefinition")) {
            var a = t.selections;
            if (a) {
              var i = a.some(function (s) {
                return sn(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
              });
              if (!i) {
                var o = r;
                if (!(sn(o) && o.directives && o.directives.some(function (s) {
                  return s.name.value === "export";
                }))) return _P2(_P2({}, t), {
                  selections: xt(xt([], a, !0), [Ed], !1)
                });
              }
            }
          }
        }
      }
    });
  }, {
    added: function added(e) {
      return e === Ed;
    }
  }),
  h0 = {
    test: function test(e) {
      var t = e.name.value === "connection";
      return t && (!e.arguments || !e.arguments.some(function (n) {
        return n.name.value === "key";
      })) && __DEV__ && te.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."), t;
    }
  };
function p0(e) {
  return Lv([h0], Wo(e));
}
function m0(e) {
  return function (n) {
    return e.some(function (r) {
      return n.value && n.value.kind === "Variable" && n.value.name && (r.name === n.value.name.value || r.test && r.test(n));
    });
  };
}
function v0(e, t) {
  var n = m0(e);
  return Hc(tn(t, {
    OperationDefinition: {
      enter: function enter(r) {
        return _P2(_P2({}, r), {
          variableDefinitions: r.variableDefinitions ? r.variableDefinitions.filter(function (a) {
            return !e.some(function (i) {
              return i.name === a.variable.name.value;
            });
          }) : []
        });
      }
    },
    Field: {
      enter: function enter(r) {
        var a = e.some(function (o) {
          return o.remove;
        });
        if (a) {
          var i = 0;
          if (r.arguments && r.arguments.forEach(function (o) {
            n(o) && (i += 1);
          }), i === 1) return null;
        }
      }
    },
    Argument: {
      enter: function enter(r) {
        if (n(r)) return null;
      }
    }
  }));
}
function y0(e, t) {
  function n(r) {
    if (e.some(function (a) {
      return a.name === r.name.value;
    })) return null;
  }
  return Hc(tn(t, {
    FragmentSpread: {
      enter: n
    },
    FragmentDefinition: {
      enter: n
    }
  }));
}
function jv(e) {
  var t = [];
  return e.selections.forEach(function (n) {
    (sn(n) || Iv(n)) && n.selectionSet ? jv(n.selectionSet).forEach(function (r) {
      return t.push(r);
    }) : n.kind === "FragmentSpread" && t.push(n);
  }), t;
}
function g0(e) {
  var t = Uc(e),
    n = t.operation;
  if (n === "query") return e;
  var r = tn(e, {
    OperationDefinition: {
      enter: function enter(a) {
        return _P2(_P2({}, a), {
          operation: "query"
        });
      }
    }
  });
  return r;
}
function b0(e) {
  Wo(e);
  var t = Lv([{
    test: function test(n) {
      return n.name.value === "client";
    },
    remove: !0
  }], e);
  return t && (t = tn(t, {
    FragmentDefinition: {
      enter: function enter(n) {
        if (n.selectionSet) {
          var r = n.selectionSet.selections.every(function (a) {
            return sn(a) && a.name.value === "__typename";
          });
          if (r) return null;
        }
      }
    }
  })), t;
}
var _0 = Object.prototype.hasOwnProperty;
function Td() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  return Gc(e);
}
function Gc(e) {
  var t = e[0] || {},
    n = e.length;
  if (n > 1) for (var r = new wn(), a = 1; a < n; ++a) t = r.merge(t, e[a]);
  return t;
}
var w0 = function w0(e, t, n) {
    return this.merge(e[n], t[n]);
  },
  wn = function () {
    function e(t) {
      t === void 0 && (t = w0), this.reconciler = t, this.isObject = it, this.pastCopies = /* @__PURE__ */new Set();
    }
    return e.prototype.merge = function (t, n) {
      for (var r = this, a = [], i = 2; i < arguments.length; i++) a[i - 2] = arguments[i];
      return it(n) && it(t) ? (Object.keys(n).forEach(function (o) {
        if (_0.call(t, o)) {
          var s = t[o];
          if (n[o] !== s) {
            var u = r.reconciler.apply(r, xt([t, n, o], a, !1));
            u !== s && (t = r.shallowCopyForMerge(t), t[o] = u);
          }
        } else t = r.shallowCopyForMerge(t), t[o] = n[o];
      }), t) : n;
    }, e.prototype.shallowCopyForMerge = function (t) {
      return it(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = _P2({
        __proto__: Object.getPrototypeOf(t)
      }, t), this.pastCopies.add(t))), t;
    }, e;
  }();
function O0(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = S0(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function () {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function S0(e, t) {
  if (e) {
    if (typeof e == "string") return kd(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kd(e, t);
  }
}
function kd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Dd(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Yc(e, t, n) {
  return t && Dd(e.prototype, t), n && Dd(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var Qc = function Qc() {
    return typeof Symbol == "function";
  },
  Kc = function Kc(e) {
    return Qc() && Boolean(Symbol[e]);
  },
  Jc = function Jc(e) {
    return Kc(e) ? Symbol[e] : "@@" + e;
  };
Qc() && !Kc("observable") && (Symbol.observable = Symbol("observable"));
var E0 = Jc("iterator"),
  pu = Jc("observable"),
  Bv = Jc("species");
function Hi(e, t) {
  var n = e[t];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function jr(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[Bv], t === null && (t = void 0)), t !== void 0 ? t : Ye;
}
function P0(e) {
  return e instanceof Ye;
}
function _r(e) {
  _r.log ? _r.log(e) : setTimeout(function () {
    throw e;
  });
}
function ti(e) {
  Promise.resolve().then(function () {
    try {
      e();
    } catch (t) {
      _r(t);
    }
  });
}
function Vv(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t)) try {
    if (typeof t == "function") t();else {
      var n = Hi(t, "unsubscribe");
      n && n.call(t);
    }
  } catch (r) {
    _r(r);
  }
}
function mu(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function T0(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var n = 0; n < t.length && (qv(e, t[n].type, t[n].value), e._state !== "closed"); ++n);
  }
}
function qv(e, t, n) {
  e._state = "running";
  var r = e._observer;
  try {
    var a = Hi(r, t);
    switch (t) {
      case "next":
        a && a.call(r, n);
        break;
      case "error":
        if (mu(e), a) a.call(r, n);else throw n;
        break;
      case "complete":
        mu(e), a && a.call(r);
        break;
    }
  } catch (i) {
    _r(i);
  }
  e._state === "closed" ? Vv(e) : e._state === "running" && (e._state = "ready");
}
function ws(e, t, n) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: n
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: n
      }], ti(function () {
        return T0(e);
      });
      return;
    }
    qv(e, t, n);
  }
}
var k0 = /* @__PURE__ */function () {
    function e(n, r) {
      this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
      var a = new D0(this);
      try {
        this._cleanup = r.call(void 0, a);
      } catch (i) {
        a.error(i);
      }
      this._state === "initializing" && (this._state = "ready");
    }
    var t = e.prototype;
    return t.unsubscribe = function () {
      this._state !== "closed" && (mu(this), Vv(this));
    }, Yc(e, [{
      key: "closed",
      get: function get() {
        return this._state === "closed";
      }
    }]), e;
  }(),
  D0 = /* @__PURE__ */function () {
    function e(n) {
      this._subscription = n;
    }
    var t = e.prototype;
    return t.next = function (r) {
      ws(this._subscription, "next", r);
    }, t.error = function (r) {
      ws(this._subscription, "error", r);
    }, t.complete = function () {
      ws(this._subscription, "complete");
    }, Yc(e, [{
      key: "closed",
      get: function get() {
        return this._subscription._state === "closed";
      }
    }]), e;
  }(),
  Ye = /* @__PURE__ */function () {
    function e(n) {
      if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
      if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
      this._subscriber = n;
    }
    var t = e.prototype;
    return t.subscribe = function (r) {
      return (typeof r != "object" || r === null) && (r = {
        next: r,
        error: arguments[1],
        complete: arguments[2]
      }), new k0(r, this._subscriber);
    }, t.forEach = function (r) {
      var a = this;
      return new Promise(function (i, o) {
        if (typeof r != "function") {
          o(new TypeError(r + " is not a function"));
          return;
        }
        function s() {
          u.unsubscribe(), i();
        }
        var u = a.subscribe({
          next: function next(l) {
            try {
              r(l, s);
            } catch (c) {
              o(c), u.unsubscribe();
            }
          },
          error: o,
          complete: i
        });
      });
    }, t.map = function (r) {
      var a = this;
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      var i = jr(this);
      return new i(function (o) {
        return a.subscribe({
          next: function next(s) {
            try {
              s = r(s);
            } catch (u) {
              return o.error(u);
            }
            o.next(s);
          },
          error: function error(s) {
            o.error(s);
          },
          complete: function complete() {
            o.complete();
          }
        });
      });
    }, t.filter = function (r) {
      var a = this;
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      var i = jr(this);
      return new i(function (o) {
        return a.subscribe({
          next: function next(s) {
            try {
              if (!r(s)) return;
            } catch (u) {
              return o.error(u);
            }
            o.next(s);
          },
          error: function error(s) {
            o.error(s);
          },
          complete: function complete() {
            o.complete();
          }
        });
      });
    }, t.reduce = function (r) {
      var a = this;
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      var i = jr(this),
        o = arguments.length > 1,
        s = !1,
        u = arguments[1],
        l = u;
      return new i(function (c) {
        return a.subscribe({
          next: function next(f) {
            var h = !s;
            if (s = !0, !h || o) try {
              l = r(l, f);
            } catch (p) {
              return c.error(p);
            } else l = f;
          },
          error: function error(f) {
            c.error(f);
          },
          complete: function complete() {
            if (!s && !o) return c.error(new TypeError("Cannot reduce an empty sequence"));
            c.next(l), c.complete();
          }
        });
      });
    }, t.concat = function () {
      for (var r = this, a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      var s = jr(this);
      return new s(function (u) {
        var l,
          c = 0;
        function f(h) {
          l = h.subscribe({
            next: function next(p) {
              u.next(p);
            },
            error: function error(p) {
              u.error(p);
            },
            complete: function complete() {
              c === i.length ? (l = void 0, u.complete()) : f(s.from(i[c++]));
            }
          });
        }
        return f(r), function () {
          l && (l.unsubscribe(), l = void 0);
        };
      });
    }, t.flatMap = function (r) {
      var a = this;
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      var i = jr(this);
      return new i(function (o) {
        var s = [],
          u = a.subscribe({
            next: function next(c) {
              if (r) try {
                c = r(c);
              } catch (h) {
                return o.error(h);
              }
              var f = i.from(c).subscribe({
                next: function next(h) {
                  o.next(h);
                },
                error: function error(h) {
                  o.error(h);
                },
                complete: function complete() {
                  var h = s.indexOf(f);
                  h >= 0 && s.splice(h, 1), l();
                }
              });
              s.push(f);
            },
            error: function error(c) {
              o.error(c);
            },
            complete: function complete() {
              l();
            }
          });
        function l() {
          u.closed && s.length === 0 && o.complete();
        }
        return function () {
          s.forEach(function (c) {
            return c.unsubscribe();
          }), u.unsubscribe();
        };
      });
    }, t[pu] = function () {
      return this;
    }, e.from = function (r) {
      var a = typeof this == "function" ? this : e;
      if (r == null) throw new TypeError(r + " is not an object");
      var i = Hi(r, pu);
      if (i) {
        var o = i.call(r);
        if (Object(o) !== o) throw new TypeError(o + " is not an object");
        return P0(o) && o.constructor === a ? o : new a(function (s) {
          return o.subscribe(s);
        });
      }
      if (Kc("iterator") && (i = Hi(r, E0), i)) return new a(function (s) {
        ti(function () {
          if (!s.closed) {
            for (var u = O0(i.call(r)), l; !(l = u()).done;) {
              var c = l.value;
              if (s.next(c), s.closed) return;
            }
            s.complete();
          }
        });
      });
      if (Array.isArray(r)) return new a(function (s) {
        ti(function () {
          if (!s.closed) {
            for (var u = 0; u < r.length; ++u) if (s.next(r[u]), s.closed) return;
            s.complete();
          }
        });
      });
      throw new TypeError(r + " is not observable");
    }, e.of = function () {
      for (var r = arguments.length, a = new Array(r), i = 0; i < r; i++) a[i] = arguments[i];
      var o = typeof this == "function" ? this : e;
      return new o(function (s) {
        ti(function () {
          if (!s.closed) {
            for (var u = 0; u < a.length; ++u) if (s.next(a[u]), s.closed) return;
            s.complete();
          }
        });
      });
    }, Yc(e, null, [{
      key: Bv,
      get: function get() {
        return this;
      }
    }]), e;
  }();
Qc() && Object.defineProperty(Ye, Symbol("extensions"), {
  value: {
    symbol: pu,
    hostReportError: _r
  },
  configurable: !0
});
function x0(e) {
  var t,
    n = e.Symbol;
  if (typeof n == "function") {
    if (n.observable) t = n.observable;else {
      typeof n.for == "function" ? t = n.for("https://github.com/benlesh/symbol-observable") : t = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = t;
      } catch (_unused5) {}
    }
  } else t = "@@observable";
  return t;
}
var ur;
typeof self < "u" ? ur = self : typeof window < "u" ? ur = window : typeof global < "u" ? ur = global : typeof module < "u" ? ur = module : ur = Function("return this")();
x0(ur);
var xd = Ye.prototype,
  $d = "@@observable";
xd[$d] || (xd[$d] = function () {
  return this;
});
var $0 = Object.prototype.toString;
function Uv(e) {
  return vu(e);
}
function vu(e, t) {
  switch ($0.call(e)) {
    case "[object Array]":
      {
        if (t = t || /* @__PURE__ */new Map(), t.has(e)) return t.get(e);
        var n = e.slice(0);
        return t.set(e, n), n.forEach(function (a, i) {
          n[i] = vu(a, t);
        }), n;
      }
    case "[object Object]":
      {
        if (t = t || /* @__PURE__ */new Map(), t.has(e)) return t.get(e);
        var r = Object.create(Object.getPrototypeOf(e));
        return t.set(e, r), Object.keys(e).forEach(function (a) {
          r[a] = vu(e[a], t);
        }), r;
      }
    default:
      return e;
  }
}
function C0(e) {
  var t = /* @__PURE__ */new Set([e]);
  return t.forEach(function (n) {
    it(n) && R0(n) === n && Object.getOwnPropertyNames(n).forEach(function (r) {
      it(n[r]) && t.add(n[r]);
    });
  }), e;
}
function R0(e) {
  if (__DEV__ && !Object.isFrozen(e)) try {
    Object.freeze(e);
  } catch (t) {
    if (t instanceof TypeError) return null;
    throw t;
  }
  return e;
}
function ia(e) {
  return __DEV__ && C0(e), e;
}
function Kr(e, t, n) {
  var r = [];
  e.forEach(function (a) {
    return a[t] && r.push(a);
  }), r.forEach(function (a) {
    return a[t](n);
  });
}
function Os(e, t, n) {
  return new Ye(function (r) {
    var a = r.next,
      i = r.error,
      o = r.complete,
      s = 0,
      u = !1,
      l = {
        then: function then(p) {
          return new Promise(function (v) {
            return v(p());
          });
        }
      };
    function c(p, v) {
      return p ? function (m) {
        ++s;
        var g = function g() {
          return p(m);
        };
        l = l.then(g, g).then(function (b) {
          --s, a && a.call(r, b), u && f.complete();
        }, function (b) {
          throw --s, b;
        }).catch(function (b) {
          i && i.call(r, b);
        });
      } : function (m) {
        return v && v.call(r, m);
      };
    }
    var f = {
        next: c(t, a),
        error: c(n, i),
        complete: function complete() {
          u = !0, s || o && o.call(r);
        }
      },
      h = e.subscribe(f);
    return function () {
      return h.unsubscribe();
    };
  });
}
var xn = typeof WeakMap == "function" && Lt(function () {
    return navigator.product;
  }) !== "ReactNative",
  zv = typeof WeakSet == "function",
  Xc = typeof Symbol == "function" && typeof Symbol.for == "function",
  Go = Xc && Symbol.asyncIterator,
  N0 = typeof Lt(function () {
    return window.document.createElement;
  }) == "function",
  A0 = Lt(function () {
    return navigator.userAgent.indexOf("jsdom") >= 0;
  }) || !1,
  I0 = N0 && !A0;
function Hv(e) {
  function t(n) {
    Object.defineProperty(e, n, {
      value: Ye
    });
  }
  return Xc && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function Cd(e) {
  return e && typeof e.then == "function";
}
var Gr = function (e) {
  et(t, e);
  function t(n) {
    var r = e.call(this, function (a) {
      return r.addObserver(a), function () {
        return r.removeObserver(a);
      };
    }) || this;
    return r.observers = /* @__PURE__ */new Set(), r.promise = new Promise(function (a, i) {
      r.resolve = a, r.reject = i;
    }), r.handlers = {
      next: function next(a) {
        r.sub !== null && (r.latest = ["next", a], r.notify("next", a), Kr(r.observers, "next", a));
      },
      error: function error(a) {
        var i = r.sub;
        i !== null && (i && setTimeout(function () {
          return i.unsubscribe();
        }), r.sub = null, r.latest = ["error", a], r.reject(a), r.notify("error", a), Kr(r.observers, "error", a));
      },
      complete: function complete() {
        var a = r.sub;
        if (a !== null) {
          var i = r.sources.shift();
          i ? Cd(i) ? i.then(function (o) {
            return r.sub = o.subscribe(r.handlers);
          }) : r.sub = i.subscribe(r.handlers) : (a && setTimeout(function () {
            return a.unsubscribe();
          }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), Kr(r.observers, "complete"));
        }
      }
    }, r.nextResultListeners = /* @__PURE__ */new Set(), r.cancel = function (a) {
      r.reject(a), r.sources = [], r.handlers.complete();
    }, r.promise.catch(function (a) {}), typeof n == "function" && (n = [new Ye(n)]), Cd(n) ? n.then(function (a) {
      return r.start(a);
    }, r.handlers.error) : r.start(n), r;
  }
  return t.prototype.start = function (n) {
    this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
  }, t.prototype.deliverLastMessage = function (n) {
    if (this.latest) {
      var r = this.latest[0],
        a = n[r];
      a && a.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
    }
  }, t.prototype.addObserver = function (n) {
    this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n));
  }, t.prototype.removeObserver = function (n) {
    this.observers.delete(n) && this.observers.size < 1 && this.handlers.complete();
  }, t.prototype.notify = function (n, r) {
    var a = this.nextResultListeners;
    a.size && (this.nextResultListeners = /* @__PURE__ */new Set(), a.forEach(function (i) {
      return i(n, r);
    }));
  }, t.prototype.beforeNext = function (n) {
    var r = !1;
    this.nextResultListeners.add(function (a, i) {
      r || (r = !0, n(a, i));
    });
  }, t;
}(Ye);
Hv(Gr);
function Ct(e) {
  return Array.isArray(e) && e.length > 0;
}
function mr(e) {
  return "incremental" in e;
}
function M0(e) {
  return "hasNext" in e && "data" in e;
}
function F0(e) {
  return mr(e) || M0(e);
}
function Wv(e, t) {
  var n = e,
    r = new wn();
  return mr(t) && Ct(t.incremental) && t.incremental.forEach(function (a) {
    for (var i = a.data, o = a.path, s = o.length - 1; s >= 0; --s) {
      var u = o[s],
        l = !isNaN(+u),
        c = l ? [] : {};
      c[u] = i, i = c;
    }
    n = r.merge(n, i);
  }), n;
}
function ni(e) {
  var t = yu(e);
  return Ct(t);
}
function yu(e) {
  var t = Ct(e.errors) ? e.errors.slice(0) : [];
  return mr(e) && Ct(e.incremental) && e.incremental.forEach(function (n) {
    n.errors && t.push.apply(t, n.errors);
  }), t;
}
function wa() {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  var n = /* @__PURE__ */Object.create(null);
  return e.forEach(function (r) {
    r && Object.keys(r).forEach(function (a) {
      var i = r[a];
      i !== void 0 && (n[a] = i);
    });
  }), n;
}
var Rd = /* @__PURE__ */new Map();
function gu(e) {
  var t = Rd.get(e) || 1;
  return Rd.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function L0(e) {
  var t = gu("stringifyForDisplay");
  return JSON.stringify(e, function (n, r) {
    return r === void 0 ? t : r;
  }).split(JSON.stringify(t)).join("<undefined>");
}
function Jr(e, t) {
  return wa(e, t, t.variables && {
    variables: _P2(_P2({}, e && e.variables), t.variables)
  });
}
function Nd(e) {
  return new Ye(function (t) {
    t.error(e);
  });
}
var bu = function bu(e, t, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = e, r.statusCode = e.status, r.result = t, r;
};
function j0(e) {
  for (var t = ["query", "operationName", "variables", "extensions", "context"], n = 0, r = Object.keys(e); n < r.length; n++) {
    var a = r[n];
    if (t.indexOf(a) < 0) throw __DEV__ ? new Ne("illegal argument: ".concat(a)) : new Ne(26);
  }
  return e;
}
function B0(e, t) {
  var n = _P2({}, e),
    r = function r(i) {
      typeof i == "function" ? n = _P2(_P2({}, n), i(n)) : n = _P2(_P2({}, n), i);
    },
    a = function a() {
      return _P2({}, n);
    };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: a
  }), t;
}
function V0(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? hu(t.query) || void 0 : ""), t;
}
function Ad(e, t) {
  return t ? t(e) : Ye.of();
}
function Br(e) {
  return typeof e == "function" ? new Oa(e) : e;
}
function ja(e) {
  return e.request.length <= 1;
}
var q0 = function (e) {
    et(t, e);
    function t(n, r) {
      var a = e.call(this, n) || this;
      return a.link = r, a;
    }
    return t;
  }(Error),
  Oa = function () {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function () {
      return new e(function () {
        return Ye.of();
      });
    }, e.from = function (t) {
      return t.length === 0 ? e.empty() : t.map(Br).reduce(function (n, r) {
        return n.concat(r);
      });
    }, e.split = function (t, n, r) {
      var a = Br(n),
        i = Br(r || new e(Ad));
      return ja(a) && ja(i) ? new e(function (o) {
        return t(o) ? a.request(o) || Ye.of() : i.request(o) || Ye.of();
      }) : new e(function (o, s) {
        return t(o) ? a.request(o, s) || Ye.of() : i.request(o, s) || Ye.of();
      });
    }, e.execute = function (t, n) {
      return t.request(B0(n.context, V0(j0(n)))) || Ye.of();
    }, e.concat = function (t, n) {
      var r = Br(t);
      if (ja(r)) return __DEV__ && te.warn(new q0("You are calling concat on a terminating link, which will have no effect", r)), r;
      var a = Br(n);
      return ja(a) ? new e(function (i) {
        return r.request(i, function (o) {
          return a.request(o) || Ye.of();
        }) || Ye.of();
      }) : new e(function (i, o) {
        return r.request(i, function (s) {
          return a.request(s, o) || Ye.of();
        }) || Ye.of();
      });
    }, e.prototype.split = function (t, n, r) {
      return this.concat(e.split(t, n, r || new e(Ad)));
    }, e.prototype.concat = function (t) {
      return e.concat(this, t);
    }, e.prototype.request = function (t, n) {
      throw __DEV__ ? new Ne("request is not implemented") : new Ne(21);
    }, e.prototype.onError = function (t, n) {
      if (n && n.error) return n.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function (t) {
      return this.onError = t, this;
    }, e;
  }(),
  _u = Oa.execute,
  U0 = "3.7.5";
function z0(e) {
  return !!e.body;
}
function H0(e) {
  return !!e.getReader;
}
function W0(e) {
  return !!(Go && e[Symbol.asyncIterator]);
}
function G0(e) {
  return !!e.stream;
}
function Y0(e) {
  return !!e.arrayBuffer;
}
function Q0(e) {
  return !!e.pipe;
}
function K0(e) {
  var t,
    n = e[Symbol.asyncIterator]();
  return t = {
    next: function next() {
      return n.next();
    }
  }, t[Symbol.asyncIterator] = function () {
    return this;
  }, t;
}
function J0(e) {
  var _t2 = null,
    n = null,
    r = !1,
    a = [],
    i = [];
  function o(f) {
    if (!n) {
      if (i.length) {
        var h = i.shift();
        if (Array.isArray(h) && h[0]) return h[0]({
          value: f,
          done: !1
        });
      }
      a.push(f);
    }
  }
  function s(f) {
    n = f;
    var h = i.slice();
    h.forEach(function (p) {
      p[1](f);
    }), !_t2 || _t2();
  }
  function u() {
    r = !0;
    var f = i.slice();
    f.forEach(function (h) {
      h[0]({
        value: void 0,
        done: !0
      });
    }), !_t2 || _t2();
  }
  _t2 = function t() {
    _t2 = null, e.removeListener("data", o), e.removeListener("error", s), e.removeListener("end", u), e.removeListener("finish", u), e.removeListener("close", u);
  }, e.on("data", o), e.on("error", s), e.on("end", u), e.on("finish", u), e.on("close", u);
  function l() {
    return new Promise(function (f, h) {
      if (n) return h(n);
      if (a.length) return f({
        value: a.shift(),
        done: !1
      });
      if (r) return f({
        value: void 0,
        done: !0
      });
      i.push([f, h]);
    });
  }
  var c = {
    next: function next() {
      return l();
    }
  };
  return Go && (c[Symbol.asyncIterator] = function () {
    return this;
  }), c;
}
function X0(e) {
  var t = !1,
    n = {
      next: function next() {
        return t ? Promise.resolve({
          value: void 0,
          done: !0
        }) : (t = !0, new Promise(function (r, a) {
          e.then(function (i) {
            r({
              value: i,
              done: !1
            });
          }).catch(a);
        }));
      }
    };
  return Go && (n[Symbol.asyncIterator] = function () {
    return this;
  }), n;
}
function Id(e) {
  var t = {
    next: function next() {
      return e.read();
    }
  };
  return Go && (t[Symbol.asyncIterator] = function () {
    return this;
  }), t;
}
function Z0(e) {
  var t = e;
  if (z0(e) && (t = e.body), W0(t)) return K0(t);
  if (H0(t)) return Id(t.getReader());
  if (G0(t)) return Id(t.stream().getReader());
  if (Y0(t)) return X0(t.arrayBuffer());
  if (Q0(t)) return J0(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Md = Object.prototype.hasOwnProperty;
function eO(e, t) {
  var n, r, a;
  return mn(this, void 0, void 0, function () {
    var i, o, s, u, l, c, f, h, p, v, m, g, b, y, E, w, _, C, D, U;
    return vn(this, function (Z) {
      switch (Z.label) {
        case 0:
          if (TextDecoder === void 0) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          i = new TextDecoder("utf-8"), o = (n = e.headers) === null || n === void 0 ? void 0 : n.get("content-type"), s = "boundary=", u = o != null && o.includes(s) ? o == null ? void 0 : o.substring((o == null ? void 0 : o.indexOf(s)) + s.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", l = "--".concat(u), c = "", f = Z0(e), h = !0, Z.label = 1;
        case 1:
          return h ? [4, f.next()] : [3, 3];
        case 2:
          for (p = Z.sent(), v = p.value, m = p.done, g = typeof v == "string" ? v : i.decode(v), h = !m, c += g, b = c.indexOf(l); b > -1;) {
            if (y = void 0, U = [c.slice(0, b), c.slice(b + l.length)], y = U[0], c = U[1], y.trim()) {
              if (E = y.indexOf("\r\n\r\n"), w = tO(y.slice(0, E)), _ = w["content-type"], _ && _.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
              C = y.slice(E);
              try {
                D = Gv(e, C.replace("\r\n", "")), (Object.keys(D).length > 1 || "data" in D || "incremental" in D || "errors" in D) && ((r = t.next) === null || r === void 0 || r.call(t, D));
              } catch (me) {
                Zc(me, t);
              }
            }
            b = c.indexOf(l);
          }
          return [3, 1];
        case 3:
          return (a = t.complete) === null || a === void 0 || a.call(t), [2];
      }
    });
  });
}
function tO(e) {
  var t = {};
  return e.split("\n").forEach(function (n) {
    var r = n.indexOf(":");
    if (r > -1) {
      var a = n.slice(0, r).trim().toLowerCase(),
        i = n.slice(r + 1).trim();
      t[a] = i;
    }
  }), t;
}
function Gv(e, t) {
  if (e.status >= 300) {
    var n = function n() {
      try {
        return JSON.parse(t);
      } catch (_unused6) {
        return t;
      }
    };
    bu(e, n(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (a) {
    var r = a;
    throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, r;
  }
}
function Zc(e, t) {
  var n, r;
  e.name !== "AbortError" && (e.result && e.result.errors && e.result.data && ((n = t.next) === null || n === void 0 || n.call(t, e.result)), (r = t.error) === null || r === void 0 || r.call(t, e));
}
function nO(e, t, n) {
  rO(t)(e).then(function (r) {
    var a, i;
    (a = n.next) === null || a === void 0 || a.call(n, r), (i = n.complete) === null || i === void 0 || i.call(n);
  }).catch(function (r) {
    return Zc(r, n);
  });
}
function rO(e) {
  return function (t) {
    return t.text().then(function (n) {
      return Gv(t, n);
    }).then(function (n) {
      return t.status >= 300 && bu(t, n, "Response not successful: Received status code ".concat(t.status)), !Array.isArray(n) && !Md.call(n, "data") && !Md.call(n, "errors") && bu(t, n, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function (r) {
        return r.operationName;
      }) : e.operationName, "'.")), n;
    });
  };
}
var wu = function wu(e, t) {
    var n;
    try {
      n = JSON.stringify(e);
    } catch (a) {
      var r = __DEV__ ? new Ne("Network request failed. ".concat(t, " is not serializable: ").concat(a.message)) : new Ne(23);
      throw r.parseError = a, r;
    }
    return n;
  },
  aO = {
    includeQuery: !0,
    includeExtensions: !1,
    preserveHeaderCase: !1
  },
  iO = {
    accept: "*/*",
    "content-type": "application/json"
  },
  oO = {
    method: "POST"
  },
  sO = {
    http: aO,
    headers: iO,
    options: oO
  },
  uO = function uO(e, t) {
    return t(e);
  };
function lO(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = {},
    i = {};
  n.forEach(function (f) {
    a = _P2(_P2(_P2({}, a), f.options), {
      headers: _P2(_P2({}, a.headers), f.headers)
    }), f.credentials && (a.credentials = f.credentials), i = _P2(_P2({}, i), f.http);
  }), a.headers && (a.headers = cO(a.headers, i.preserveHeaderCase));
  var o = e.operationName,
    s = e.extensions,
    u = e.variables,
    l = e.query,
    c = {
      operationName: o,
      variables: u
    };
  return i.includeExtensions && (c.extensions = s), i.includeQuery && (c.query = t(l, Uw)), {
    options: a,
    body: c
  };
}
function cO(e, t) {
  if (!t) {
    var n = /* @__PURE__ */Object.create(null);
    return Object.keys(Object(e)).forEach(function (i) {
      n[i.toLowerCase()] = e[i];
    }), n;
  }
  var r = /* @__PURE__ */Object.create(null);
  Object.keys(Object(e)).forEach(function (i) {
    r[i.toLowerCase()] = {
      originalName: i,
      value: e[i]
    };
  });
  var a = /* @__PURE__ */Object.create(null);
  return Object.keys(r).forEach(function (i) {
    a[r[i].originalName] = r[i].value;
  }), a;
}
var fO = function fO(e) {
    if (!e && typeof fetch > "u") throw __DEV__ ? new Ne("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new Ne(22);
  },
  dO = function dO() {
    if (typeof AbortController > "u") return {
      controller: !1,
      signal: !1
    };
    var e = new AbortController(),
      t = e.signal;
    return {
      controller: e,
      signal: t
    };
  },
  hO = function hO(e, t) {
    var n = e.getContext(),
      r = n.uri;
    return r || (typeof t == "function" ? t(e) : t || "/graphql");
  };
function pO(e, t) {
  var n = [],
    r = function r(f, h) {
      n.push("".concat(f, "=").concat(encodeURIComponent(h)));
    };
  if ("query" in t && r("query", t.query), t.operationName && r("operationName", t.operationName), t.variables) {
    var a = void 0;
    try {
      a = wu(t.variables, "Variables map");
    } catch (f) {
      return {
        parseError: f
      };
    }
    r("variables", a);
  }
  if (t.extensions) {
    var i = void 0;
    try {
      i = wu(t.extensions, "Extensions map");
    } catch (f) {
      return {
        parseError: f
      };
    }
    r("extensions", i);
  }
  var o = "",
    s = e,
    u = e.indexOf("#");
  u !== -1 && (o = e.substr(u), s = e.substr(0, u));
  var l = s.indexOf("?") === -1 ? "?" : "&",
    c = s + l + n.join("&") + o;
  return {
    newURI: c
  };
}
var Fd = Lt(function () {
    return fetch;
  }),
  mO = function mO(e) {
    e === void 0 && (e = {});
    var t = e.uri,
      n = t === void 0 ? "/graphql" : t,
      r = e.fetch,
      a = e.print,
      i = a === void 0 ? uO : a,
      o = e.includeExtensions,
      s = e.preserveHeaderCase,
      u = e.useGETForQueries,
      l = e.includeUnusedVariables,
      c = l === void 0 ? !1 : l,
      f = Mt(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    __DEV__ && fO(r || Fd);
    var h = {
      http: {
        includeExtensions: o,
        preserveHeaderCase: s
      },
      options: f.fetchOptions,
      credentials: f.credentials,
      headers: f.headers
    };
    return new Oa(function (p) {
      var v = hO(p, n),
        m = p.getContext(),
        g = {};
      if (m.clientAwareness) {
        var b = m.clientAwareness,
          y = b.name,
          E = b.version;
        y && (g["apollographql-client-name"] = y), E && (g["apollographql-client-version"] = E);
      }
      var w = _P2(_P2({}, g), m.headers),
        _ = {
          http: m.http,
          options: m.fetchOptions,
          credentials: m.credentials,
          headers: w
        },
        C = lO(p, i, sO, h, _),
        D = C.options,
        U = C.body;
      if (U.variables && !c) {
        var Z = new Set(Object.keys(U.variables));
        tn(p.query, {
          Variable: function Variable(ce, H, O) {
            O && O.kind !== "VariableDefinition" && Z.delete(ce.name.value);
          }
        }), Z.size && (U.variables = _P2({}, U.variables), Z.forEach(function (ce) {
          delete U.variables[ce];
        }));
      }
      var me;
      if (!D.signal) {
        var ye = dO(),
          Y = ye.controller,
          K = ye.signal;
        me = Y, me && (D.signal = K);
      }
      var ee = function ee(ce) {
        return ce.kind === "OperationDefinition" && ce.operation === "mutation";
      };
      if (u && !p.query.definitions.some(ee) && (D.method = "GET"), Lc(["defer"], p.query) && (D.headers = D.headers || {}, D.headers.accept = "multipart/mixed; deferSpec=20220824, application/json"), D.method === "GET") {
        var ne = pO(v, U),
          ie = ne.newURI,
          fe = ne.parseError;
        if (fe) return Nd(fe);
        v = ie;
      } else try {
        D.body = wu(U, "Payload");
      } catch (ce) {
        return Nd(ce);
      }
      return new Ye(function (ce) {
        var H = r || Lt(function () {
          return fetch;
        }) || Fd;
        return H(v, D).then(function (O) {
          var I;
          p.setContext({
            response: O
          });
          var B = (I = O.headers) === null || I === void 0 ? void 0 : I.get("content-type");
          return B !== null && /^multipart\/mixed/i.test(B) ? eO(O, ce) : nO(O, p, ce);
        }).catch(function (O) {
          return Zc(O, ce);
        }), function () {
          me && me.abort();
        };
      });
    });
  },
  vO = function (e) {
    et(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, mO(n).request) || this;
      return r.options = n, r;
    }
    return t;
  }(Oa),
  Yv = Object.prototype,
  Ld = Yv.toString,
  yO = Yv.hasOwnProperty,
  jd = Function.prototype.toString,
  Ou = /* @__PURE__ */new Map();
function Qe(e, t) {
  try {
    return Su(e, t);
  } finally {
    Ou.clear();
  }
}
function Su(e, t) {
  if (e === t) return !0;
  var n = Ld.call(e),
    r = Ld.call(t);
  if (n !== r) return !1;
  switch (n) {
    case "[object Array]":
      if (e.length !== t.length) return !1;
    case "[object Object]":
      {
        if (Vd(e, t)) return !0;
        var a = Bd(e),
          i = Bd(t),
          o = a.length;
        if (o !== i.length) return !1;
        for (var s = 0; s < o; ++s) if (!yO.call(t, a[s])) return !1;
        for (var s = 0; s < o; ++s) {
          var u = a[s];
          if (!Su(e[u], t[u])) return !1;
        }
        return !0;
      }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e) return t !== t;
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == "".concat(t);
    case "[object Map]":
    case "[object Set]":
      {
        if (e.size !== t.size) return !1;
        if (Vd(e, t)) return !0;
        for (var l = e.entries(), c = n === "[object Map]";;) {
          var f = l.next();
          if (f.done) break;
          var h = f.value,
            p = h[0],
            v = h[1];
          if (!t.has(p) || c && !Su(v, t.get(p))) return !1;
        }
        return !0;
      }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    case "[object DataView]":
      {
        var m = e.byteLength;
        if (m === t.byteLength) for (; m-- && e[m] === t[m];);
        return m === -1;
      }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]":
      {
        var g = jd.call(e);
        return g !== jd.call(t) ? !1 : !_O(g, bO);
      }
  }
  return !1;
}
function Bd(e) {
  return Object.keys(e).filter(gO, e);
}
function gO(e) {
  return this[e] !== void 0;
}
var bO = "{ [native code] }";
function _O(e, t) {
  var n = e.length - t.length;
  return n >= 0 && e.indexOf(t, n) === n;
}
function Vd(e, t) {
  var n = Ou.get(e);
  if (n) {
    if (n.has(t)) return !0;
  } else Ou.set(e, n = /* @__PURE__ */new Set());
  return n.add(t), !1;
}
var wO = function wO() {
    return /* @__PURE__ */Object.create(null);
  },
  Qv = Array.prototype,
  OO = Qv.forEach,
  SO = Qv.slice,
  Sa = /** @class */
  function () {
    function e(t, n) {
      t === void 0 && (t = !0), n === void 0 && (n = wO), this.weakness = t, this.makeData = n;
    }
    return e.prototype.lookup = function () {
      for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
      return this.lookupArray(t);
    }, e.prototype.lookupArray = function (t) {
      var n = this;
      return OO.call(t, function (r) {
        return n = n.getChildTrie(r);
      }), n.data || (n.data = this.makeData(SO.call(t)));
    }, e.prototype.getChildTrie = function (t) {
      var n = this.weakness && EO(t) ? this.weak || (this.weak = /* @__PURE__ */new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */new Map()),
        r = n.get(t);
      return r || n.set(t, r = new e(this.weakness, this.makeData)), r;
    }, e;
  }();
function EO(e) {
  switch (typeof e) {
    case "object":
      if (e === null) break;
    case "function":
      return !0;
  }
  return !1;
}
var yt = null,
  qd = {},
  PO = 1,
  TO = function TO() {
    return (/** @class */
      function () {
        function e() {
          this.id = ["slot", PO++, Date.now(), Math.random().toString(36).slice(2)].join(":");
        }
        return e.prototype.hasValue = function () {
          for (var t = yt; t; t = t.parent) if (this.id in t.slots) {
            var n = t.slots[this.id];
            if (n === qd) break;
            return t !== yt && (yt.slots[this.id] = n), !0;
          }
          return yt && (yt.slots[this.id] = qd), !1;
        }, e.prototype.getValue = function () {
          if (this.hasValue()) return yt.slots[this.id];
        }, e.prototype.withValue = function (t, n, r, a) {
          var i,
            o = (i = {
              __proto__: null
            }, i[this.id] = t, i),
            s = yt;
          yt = {
            parent: s,
            slots: o
          };
          try {
            return n.apply(a, r);
          } finally {
            yt = s;
          }
        }, e.bind = function (t) {
          var n = yt;
          return function () {
            var r = yt;
            try {
              return yt = n, t.apply(this, arguments);
            } finally {
              yt = r;
            }
          };
        }, e.noContext = function (t, n, r) {
          if (yt) {
            var a = yt;
            try {
              return yt = null, t.apply(r, n);
            } finally {
              yt = a;
            }
          } else return t.apply(r, n);
        }, e;
      }()
    );
  },
  Ss = "@wry/context:Slot",
  Es = Array,
  ef = Es[Ss] || function () {
    var e = TO();
    try {
      Object.defineProperty(Es, Ss, {
        value: Es[Ss] = e,
        enumerable: !1,
        writable: !1,
        configurable: !1
      });
    } finally {
      return e;
    }
  }();
ef.bind;
ef.noContext;
function kO() {}
var DO = /** @class */
  function () {
    function e(t, n) {
      t === void 0 && (t = 1 / 0), n === void 0 && (n = kO), this.max = t, this.dispose = n, this.map = /* @__PURE__ */new Map(), this.newest = null, this.oldest = null;
    }
    return e.prototype.has = function (t) {
      return this.map.has(t);
    }, e.prototype.get = function (t) {
      var n = this.getNode(t);
      return n && n.value;
    }, e.prototype.getNode = function (t) {
      var n = this.map.get(t);
      if (n && n !== this.newest) {
        var r = n.older,
          a = n.newer;
        a && (a.older = r), r && (r.newer = a), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = a);
      }
      return n;
    }, e.prototype.set = function (t, n) {
      var r = this.getNode(t);
      return r ? r.value = n : (r = {
        key: t,
        value: n,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(t, r), r.value);
    }, e.prototype.clean = function () {
      for (; this.oldest && this.map.size > this.max;) this.delete(this.oldest.key);
    }, e.prototype.delete = function (t) {
      var n = this.map.get(t);
      return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(t), this.dispose(n.value, t), !0) : !1;
    }, e;
  }(),
  Yo = new ef(),
  Ps,
  xO = Object.prototype.hasOwnProperty,
  tf = (Ps = Array.from, Ps === void 0 ? function (e) {
    var t = [];
    return e.forEach(function (n) {
      return t.push(n);
    }), t;
  } : Ps);
function Wi(e) {
  var t = e.unsubscribe;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
var oa = [],
  $O = 100;
function wr(e, t) {
  if (!e) throw new Error(t || "assertion failure");
}
function CO(e, t) {
  var n = e.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 &&
    // Both values must be ordinary (or both exceptional) to be equal.
    n === t.length &&
    // The underlying value or exception must be the same.
    e[n - 1] === t[n - 1]
  );
}
function Kv(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function RO(e) {
  return e.slice(0);
}
var NO = /** @class */
function () {
  function e(t) {
    this.fn = t, this.parents = /* @__PURE__ */new Set(), this.childValues = /* @__PURE__ */new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++e.count;
  }
  return e.prototype.peek = function () {
    if (this.value.length === 1 && !On(this)) return Ud(this), this.value[0];
  }, e.prototype.recompute = function (t) {
    return wr(!this.recomputing, "already recomputing"), Ud(this), On(this) ? AO(this, t) : Kv(this.value);
  }, e.prototype.setDirty = function () {
    this.dirty || (this.dirty = !0, this.value.length = 0, Jv(this), Wi(this));
  }, e.prototype.dispose = function () {
    var t = this;
    this.setDirty(), ny(this), nf(this, function (n, r) {
      n.setDirty(), ry(n, t);
    });
  }, e.prototype.forget = function () {
    this.dispose();
  }, e.prototype.dependOn = function (t) {
    t.add(this), this.deps || (this.deps = oa.pop() || /* @__PURE__ */new Set()), this.deps.add(t);
  }, e.prototype.forgetDeps = function () {
    var t = this;
    this.deps && (tf(this.deps).forEach(function (n) {
      return n.delete(t);
    }), this.deps.clear(), oa.push(this.deps), this.deps = null);
  }, e.count = 0, e;
}();
function Ud(e) {
  var t = Yo.getValue();
  if (t) return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), On(e) ? Zv(t, e) : ey(t, e), t;
}
function AO(e, t) {
  return ny(e), Yo.withValue(e, IO, [e, t]), FO(e, t) && MO(e), Kv(e.value);
}
function IO(e, t) {
  e.recomputing = !0, e.value.length = 0;
  try {
    e.value[0] = e.fn.apply(null, t);
  } catch (n) {
    e.value[1] = n;
  }
  e.recomputing = !1;
}
function On(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function MO(e) {
  e.dirty = !1, !On(e) && Xv(e);
}
function Jv(e) {
  nf(e, Zv);
}
function Xv(e) {
  nf(e, ey);
}
function nf(e, t) {
  var n = e.parents.size;
  if (n) for (var r = tf(e.parents), a = 0; a < n; ++a) t(r[a], e);
}
function Zv(e, t) {
  wr(e.childValues.has(t)), wr(On(t));
  var n = !On(e);
  if (!e.dirtyChildren) e.dirtyChildren = oa.pop() || /* @__PURE__ */new Set();else if (e.dirtyChildren.has(t)) return;
  e.dirtyChildren.add(t), n && Jv(e);
}
function ey(e, t) {
  wr(e.childValues.has(t)), wr(!On(t));
  var n = e.childValues.get(t);
  n.length === 0 ? e.childValues.set(t, RO(t.value)) : CO(n, t.value) || e.setDirty(), ty(e, t), !On(e) && Xv(e);
}
function ty(e, t) {
  var n = e.dirtyChildren;
  n && (n.delete(t), n.size === 0 && (oa.length < $O && oa.push(n), e.dirtyChildren = null));
}
function ny(e) {
  e.childValues.size > 0 && e.childValues.forEach(function (t, n) {
    ry(e, n);
  }), e.forgetDeps(), wr(e.dirtyChildren === null);
}
function ry(e, t) {
  t.parents.delete(e), e.childValues.delete(t), ty(e, t);
}
function FO(e, t) {
  if (typeof e.subscribe == "function") try {
    Wi(e), e.unsubscribe = e.subscribe.apply(null, t);
  } catch (_unused7) {
    return e.setDirty(), !1;
  }
  return !0;
}
var LO = {
  setDirty: !0,
  dispose: !0,
  forget: !0
};
function ay(e) {
  var t = /* @__PURE__ */new Map(),
    n = e && e.subscribe;
  function r(a) {
    var i = Yo.getValue();
    if (i) {
      var o = t.get(a);
      o || t.set(a, o = /* @__PURE__ */new Set()), i.dependOn(o), typeof n == "function" && (Wi(o), o.unsubscribe = n(a));
    }
  }
  return r.dirty = function (i, o) {
    var s = t.get(i);
    if (s) {
      var u = o && xO.call(LO, o) ? o : "setDirty";
      tf(s).forEach(function (l) {
        return l[u]();
      }), t.delete(i), Wi(s);
    }
  }, r;
}
function iy() {
  var e = new Sa(typeof WeakMap == "function");
  return function () {
    return e.lookupArray(arguments);
  };
}
iy();
var Ts = /* @__PURE__ */new Set();
function Gi(e, t) {
  t === void 0 && (t = /* @__PURE__ */Object.create(null));
  var n = new DO(t.max || Math.pow(2, 16), function (l) {
      return l.dispose();
    }),
    r = t.keyArgs,
    a = t.makeCacheKey || iy(),
    i = function i() {
      var l = a.apply(null, r ? r.apply(null, arguments) : arguments);
      if (l === void 0) return e.apply(null, arguments);
      var c = n.get(l);
      c || (n.set(l, c = new NO(e)), c.subscribe = t.subscribe, c.forget = function () {
        return n.delete(l);
      });
      var f = c.recompute(Array.prototype.slice.call(arguments));
      return n.set(l, c), Ts.add(n), Yo.hasValue() || (Ts.forEach(function (h) {
        return h.clean();
      }), Ts.clear()), f;
    };
  Object.defineProperty(i, "size", {
    get: function get() {
      return n.map.size;
    },
    configurable: !1,
    enumerable: !1
  });
  function o(l) {
    var c = n.get(l);
    c && c.setDirty();
  }
  i.dirtyKey = o, i.dirty = function () {
    o(a.apply(null, arguments));
  };
  function s(l) {
    var c = n.get(l);
    if (c) return c.peek();
  }
  i.peekKey = s, i.peek = function () {
    return s(a.apply(null, arguments));
  };
  function u(l) {
    return n.delete(l);
  }
  return i.forgetKey = u, i.forget = function () {
    return u(a.apply(null, arguments));
  }, i.makeCacheKey = a, i.getKey = r ? function () {
    return a.apply(null, r.apply(null, arguments));
  } : a, Object.freeze(i);
}
var jO = function () {
    function e() {
      this.getFragmentDoc = Gi(Xw);
    }
    return e.prototype.batch = function (t) {
      var n = this,
        r = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0,
        a;
      return this.performTransaction(function () {
        return a = t.update(n);
      }, r), a;
    }, e.prototype.recordOptimisticTransaction = function (t, n) {
      this.performTransaction(t, n);
    }, e.prototype.transformDocument = function (t) {
      return t;
    }, e.prototype.transformForLink = function (t) {
      return t;
    }, e.prototype.identify = function (t) {}, e.prototype.gc = function () {
      return [];
    }, e.prototype.modify = function (t) {
      return !1;
    }, e.prototype.readQuery = function (t, n) {
      return n === void 0 && (n = !!t.optimistic), this.read(_P2(_P2({}, t), {
        rootId: t.id || "ROOT_QUERY",
        optimistic: n
      }));
    }, e.prototype.readFragment = function (t, n) {
      return n === void 0 && (n = !!t.optimistic), this.read(_P2(_P2({}, t), {
        query: this.getFragmentDoc(t.fragment, t.fragmentName),
        rootId: t.id,
        optimistic: n
      }));
    }, e.prototype.writeQuery = function (t) {
      var n = t.id,
        r = t.data,
        a = Mt(t, ["id", "data"]);
      return this.write(Object.assign(a, {
        dataId: n || "ROOT_QUERY",
        result: r
      }));
    }, e.prototype.writeFragment = function (t) {
      var n = t.id,
        r = t.data,
        a = t.fragment,
        i = t.fragmentName,
        o = Mt(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(o, {
        query: this.getFragmentDoc(a, i),
        dataId: n,
        result: r
      }));
    }, e.prototype.updateQuery = function (t, n) {
      return this.batch({
        update: function update(r) {
          var a = r.readQuery(t),
            i = n(a);
          return i == null ? a : (r.writeQuery(_P2(_P2({}, t), {
            data: i
          })), i);
        }
      });
    }, e.prototype.updateFragment = function (t, n) {
      return this.batch({
        update: function update(r) {
          var a = r.readFragment(t),
            i = n(a);
          return i == null ? a : (r.writeFragment(_P2(_P2({}, t), {
            data: i
          })), i);
        }
      });
    }, e;
  }(),
  oy = function (e) {
    et(t, e);
    function t(n, r, a, i) {
      var o,
        s = e.call(this, n) || this;
      if (s.message = n, s.path = r, s.query = a, s.variables = i, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var u = s.path.length - 1; u >= 0; --u) s.missing = (o = {}, o[s.path[u]] = s.missing, o);
      } else s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  }(Error),
  mt = Object.prototype.hasOwnProperty;
function Vr(e) {
  return e == null;
}
var lt = Array.isArray;
function sy(e, t) {
  var n = e.__typename,
    r = e.id,
    a = e._id;
  if (typeof n == "string" && (t && (t.keyObject = Vr(r) ? Vr(a) ? void 0 : {
    _id: a
  } : {
    id: r
  }), Vr(r) && !Vr(a) && (r = a), !Vr(r))) return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var uy = {
  dataIdFromObject: sy,
  addTypename: !0,
  resultCaching: !0,
  canonizeResults: !1
};
function BO(e) {
  return wa(uy, e);
}
function ly(e) {
  var t = e.canonizeResults;
  return t === void 0 ? uy.canonizeResults : t;
}
function VO(e, t) {
  return Ve(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var cy = /^[_a-z][_0-9a-z]*/i;
function Sn(e) {
  var t = e.match(cy);
  return t ? t[0] : e;
}
function Eu(e, t, n) {
  return it(t) ? lt(t) ? t.every(function (r) {
    return Eu(e, r, n);
  }) : e.selections.every(function (r) {
    if (sn(r) && zo(r, n)) {
      var a = Un(r);
      return mt.call(t, a) && (!r.selectionSet || Eu(r.selectionSet, t[a], n));
    }
    return !0;
  }) : !1;
}
function lr(e) {
  return it(e) && !Ve(e) && !lt(e);
}
function qO() {
  return new wn();
}
function fy(e, t) {
  var n = jc(qc(e));
  return {
    fragmentMap: n,
    lookupFragment: function lookupFragment(r) {
      var a = n[r];
      return !a && t && (a = t.lookup(r)), a || null;
    }
  };
}
var ri = /* @__PURE__ */Object.create(null),
  ks = function ks() {
    return ri;
  },
  zd = /* @__PURE__ */Object.create(null),
  sa = function () {
    function e(t, n) {
      var r = this;
      this.policies = t, this.group = n, this.data = /* @__PURE__ */Object.create(null), this.rootIds = /* @__PURE__ */Object.create(null), this.refs = /* @__PURE__ */Object.create(null), this.getFieldValue = function (a, i) {
        return ia(Ve(a) ? r.get(a.__ref, i) : a && a[i]);
      }, this.canRead = function (a) {
        return Ve(a) ? r.has(a.__ref) : typeof a == "object";
      }, this.toReference = function (a, i) {
        if (typeof a == "string") return pr(a);
        if (Ve(a)) return a;
        var o = r.policies.identify(a)[0];
        if (o) {
          var s = pr(o);
          return i && r.merge(o, a), s;
        }
      };
    }
    return e.prototype.toObject = function () {
      return _P2({}, this.data);
    }, e.prototype.has = function (t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function (t, n) {
      if (this.group.depend(t, n), mt.call(this.data, t)) {
        var r = this.data[t];
        if (r && mt.call(r, n)) return r[n];
      }
      if (n === "__typename" && mt.call(this.policies.rootTypenamesById, t)) return this.policies.rootTypenamesById[t];
      if (this instanceof pn) return this.parent.get(t, n);
    }, e.prototype.lookup = function (t, n) {
      if (n && this.group.depend(t, "__exists"), mt.call(this.data, t)) return this.data[t];
      if (this instanceof pn) return this.parent.lookup(t, n);
      if (this.policies.rootTypenamesById[t]) return /* @__PURE__ */Object.create(null);
    }, e.prototype.merge = function (t, n) {
      var r = this,
        a;
      Ve(t) && (t = t.__ref), Ve(n) && (n = n.__ref);
      var i = typeof t == "string" ? this.lookup(a = t) : t,
        o = typeof n == "string" ? this.lookup(a = n) : n;
      if (o) {
        __DEV__ ? te(typeof a == "string", "store.merge expects a string ID") : te(typeof a == "string", 1);
        var s = new wn(zO).merge(i, o);
        if (this.data[a] = s, s !== i && (delete this.refs[a], this.group.caching)) {
          var u = /* @__PURE__ */Object.create(null);
          i || (u.__exists = 1), Object.keys(o).forEach(function (l) {
            if (!i || i[l] !== s[l]) {
              u[l] = 1;
              var c = Sn(l);
              c !== l && !r.policies.hasKeyArgs(s.__typename, c) && (u[c] = 1), s[l] === void 0 && !(r instanceof pn) && delete s[l];
            }
          }), u.__typename && !(i && i.__typename) && this.policies.rootTypenamesById[a] === s.__typename && delete u.__typename, Object.keys(u).forEach(function (l) {
            return r.group.dirty(a, l);
          });
        }
      }
    }, e.prototype.modify = function (t, n) {
      var r = this,
        a = this.lookup(t);
      if (a) {
        var i = /* @__PURE__ */Object.create(null),
          o = !1,
          s = !0,
          u = {
            DELETE: ri,
            INVALIDATE: zd,
            isReference: Ve,
            toReference: this.toReference,
            canRead: this.canRead,
            readField: function readField(l, c) {
              return r.policies.readField(typeof l == "string" ? {
                fieldName: l,
                from: c || pr(t)
              } : l, {
                store: r
              });
            }
          };
        if (Object.keys(a).forEach(function (l) {
          var c = Sn(l),
            f = a[l];
          if (f !== void 0) {
            var h = typeof n == "function" ? n : n[l] || n[c];
            if (h) {
              var p = h === ks ? ri : h(ia(f), _P2(_P2({}, u), {
                fieldName: c,
                storeFieldName: l,
                storage: r.getStorage(t, l)
              }));
              p === zd ? r.group.dirty(t, l) : (p === ri && (p = void 0), p !== f && (i[l] = p, o = !0, f = p));
            }
            f !== void 0 && (s = !1);
          }
        }), o) return this.merge(t, i), s && (this instanceof pn ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function (t, n, r) {
      var a,
        i = this.lookup(t);
      if (i) {
        var o = this.getFieldValue(i, "__typename"),
          s = n && r ? this.policies.getStoreFieldName({
            typename: o,
            fieldName: n,
            args: r
          }) : n;
        return this.modify(t, s ? (a = {}, a[s] = ks, a) : ks);
      }
      return !1;
    }, e.prototype.evict = function (t, n) {
      var r = !1;
      return t.id && (mt.call(this.data, t.id) && (r = this.delete(t.id, t.fieldName, t.args)), this instanceof pn && this !== n && (r = this.parent.evict(t, n) || r), (t.fieldName || r) && this.group.dirty(t.id, t.fieldName || "__exists")), r;
    }, e.prototype.clear = function () {
      this.replace(null);
    }, e.prototype.extract = function () {
      var t = this,
        n = this.toObject(),
        r = [];
      return this.getRootIdSet().forEach(function (a) {
        mt.call(t.policies.rootTypenamesById, a) || r.push(a);
      }), r.length && (n.__META = {
        extraRootIds: r.sort()
      }), n;
    }, e.prototype.replace = function (t) {
      var n = this;
      if (Object.keys(this.data).forEach(function (i) {
        t && mt.call(t, i) || n.delete(i);
      }), t) {
        var r = t.__META,
          a = Mt(t, ["__META"]);
        Object.keys(a).forEach(function (i) {
          n.merge(i, a[i]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function (t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function (t) {
      if (this.rootIds[t] > 0) {
        var n = --this.rootIds[t];
        return n || delete this.rootIds[t], n;
      }
      return 0;
    }, e.prototype.getRootIdSet = function (t) {
      return t === void 0 && (t = /* @__PURE__ */new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof pn ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function () {
      var t = this,
        n = this.getRootIdSet(),
        r = this.toObject();
      n.forEach(function (o) {
        mt.call(r, o) && (Object.keys(t.findChildRefIds(o)).forEach(n.add, n), delete r[o]);
      });
      var a = Object.keys(r);
      if (a.length) {
        for (var i = this; i instanceof pn;) i = i.parent;
        a.forEach(function (o) {
          return i.delete(o);
        });
      }
      return a;
    }, e.prototype.findChildRefIds = function (t) {
      if (!mt.call(this.refs, t)) {
        var n = this.refs[t] = /* @__PURE__ */Object.create(null),
          r = this.data[t];
        if (!r) return n;
        var a = /* @__PURE__ */new Set([r]);
        a.forEach(function (i) {
          Ve(i) && (n[i.__ref] = !0), it(i) && Object.keys(i).forEach(function (o) {
            var s = i[o];
            it(s) && a.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function () {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  }(),
  dy = function () {
    function e(t, n) {
      n === void 0 && (n = null), this.caching = t, this.parent = n, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function () {
      this.d = this.caching ? ay() : null, this.keyMaker = new Sa(xn);
    }, e.prototype.depend = function (t, n) {
      if (this.d) {
        this.d(Ds(t, n));
        var r = Sn(n);
        r !== n && this.d(Ds(t, r)), this.parent && this.parent.depend(t, n);
      }
    }, e.prototype.dirty = function (t, n) {
      this.d && this.d.dirty(Ds(t, n), n === "__exists" ? "forget" : "setDirty");
    }, e;
  }();
function Ds(e, t) {
  return t + "#" + e;
}
function Hd(e, t) {
  Xr(e) && e.group.depend(t, "__exists");
}
(function (e) {
  var t = function (n) {
    et(r, n);
    function r(a) {
      var i = a.policies,
        o = a.resultCaching,
        s = o === void 0 ? !0 : o,
        u = a.seed,
        l = n.call(this, i, new dy(s)) || this;
      return l.stump = new UO(l), l.storageTrie = new Sa(xn), u && l.replace(u), l;
    }
    return r.prototype.addLayer = function (a, i) {
      return this.stump.addLayer(a, i);
    }, r.prototype.removeLayer = function () {
      return this;
    }, r.prototype.getStorage = function () {
      return this.storageTrie.lookupArray(arguments);
    }, r;
  }(e);
  e.Root = t;
})(sa || (sa = {}));
var pn = function (e) {
    et(t, e);
    function t(n, r, a, i) {
      var o = e.call(this, r.policies, i) || this;
      return o.id = n, o.parent = r, o.replay = a, o.group = i, a(o), o;
    }
    return t.prototype.addLayer = function (n, r) {
      return new t(n, this, r, this.group);
    }, t.prototype.removeLayer = function (n) {
      var r = this,
        a = this.parent.removeLayer(n);
      return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function (i) {
        var o = r.data[i],
          s = a.lookup(i);
        s ? o ? o !== s && Object.keys(o).forEach(function (u) {
          Qe(o[u], s[u]) || r.group.dirty(i, u);
        }) : (r.group.dirty(i, "__exists"), Object.keys(s).forEach(function (u) {
          r.group.dirty(i, u);
        })) : r.delete(i);
      }), a) : a === this.parent ? this : a.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function () {
      return _P2(_P2({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function (n) {
      var r = this.parent.findChildRefIds(n);
      return mt.call(this.data, n) ? _P2(_P2({}, r), e.prototype.findChildRefIds.call(this, n)) : r;
    }, t.prototype.getStorage = function () {
      for (var n = this.parent; n.parent;) n = n.parent;
      return n.getStorage.apply(n, arguments);
    }, t;
  }(sa),
  UO = function (e) {
    et(t, e);
    function t(n) {
      return e.call(this, "EntityStore.Stump", n, function () {}, new dy(n.group.caching, n.group)) || this;
    }
    return t.prototype.removeLayer = function () {
      return this;
    }, t.prototype.merge = function () {
      return this.parent.merge.apply(this.parent, arguments);
    }, t;
  }(pn);
function zO(e, t, n) {
  var r = e[n],
    a = t[n];
  return Qe(r, a) ? r : a;
}
function Xr(e) {
  return !!(e instanceof sa && e.group.caching);
}
function HO(e) {
  return it(e) ? lt(e) ? e.slice(0) : _P2({
    __proto__: Object.getPrototypeOf(e)
  }, e) : e;
}
var Pu = function () {
    function e() {
      this.known = new (zv ? WeakSet : Set)(), this.pool = new Sa(xn), this.passes = /* @__PURE__ */new WeakMap(), this.keysByJSON = /* @__PURE__ */new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function (t) {
      return it(t) && this.known.has(t);
    }, e.prototype.pass = function (t) {
      if (it(t)) {
        var n = HO(t);
        return this.passes.set(n, t), n;
      }
      return t;
    }, e.prototype.admit = function (t) {
      var n = this;
      if (it(t)) {
        var r = this.passes.get(t);
        if (r) return r;
        var a = Object.getPrototypeOf(t);
        switch (a) {
          case Array.prototype:
            {
              if (this.known.has(t)) return t;
              var i = t.map(this.admit, this),
                o = this.pool.lookupArray(i);
              return o.array || (this.known.add(o.array = i), __DEV__ && Object.freeze(i)), o.array;
            }
          case null:
          case Object.prototype:
            {
              if (this.known.has(t)) return t;
              var s = Object.getPrototypeOf(t),
                u = [s],
                l = this.sortedKeys(t);
              u.push(l.json);
              var c = u.length;
              l.sorted.forEach(function (p) {
                u.push(n.admit(t[p]));
              });
              var o = this.pool.lookupArray(u);
              if (!o.object) {
                var f = o.object = Object.create(s);
                this.known.add(f), l.sorted.forEach(function (p, v) {
                  f[p] = u[c + v];
                }), __DEV__ && Object.freeze(f);
              }
              return o.object;
            }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function (t) {
      var n = Object.keys(t),
        r = this.pool.lookupArray(n);
      if (!r.keys) {
        n.sort();
        var a = JSON.stringify(n);
        (r.keys = this.keysByJSON.get(a)) || this.keysByJSON.set(a, r.keys = {
          sorted: n,
          json: a
        });
      }
      return r.keys;
    }, e;
  }(),
  jn = Object.assign(function (e) {
    if (it(e)) {
      Tu === void 0 && Wd();
      var t = Tu.admit(e),
        n = ku.get(t);
      return n === void 0 && ku.set(t, n = JSON.stringify(t)), n;
    }
    return JSON.stringify(e);
  }, {
    reset: Wd
  }),
  Tu,
  ku;
function Wd() {
  Tu = new Pu(), ku = new (xn ? WeakMap : Map)();
}
function Gd(e) {
  return [e.selectionSet, e.objectOrReference, e.context, e.context.canonizeResults];
}
var WO = function () {
  function e(t) {
    var n = this;
    this.knownResults = new (xn ? WeakMap : Map)(), this.config = wa(t, {
      addTypename: t.addTypename !== !1,
      canonizeResults: ly(t)
    }), this.canon = t.canon || new Pu(), this.executeSelectionSet = Gi(function (r) {
      var a,
        i = r.context.canonizeResults,
        o = Gd(r);
      o[3] = !i;
      var s = (a = n.executeSelectionSet).peek.apply(a, o);
      return s ? i ? _P2(_P2({}, s), {
        result: n.canon.admit(s.result)
      }) : s : (Hd(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: Gd,
      makeCacheKey: function makeCacheKey(r, a, i, o) {
        if (Xr(i.store)) return i.store.makeCacheKey(r, Ve(a) ? a.__ref : a, i.varString, o);
      }
    }), this.executeSubSelectedArray = Gi(function (r) {
      return Hd(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function makeCacheKey(r) {
        var a = r.field,
          i = r.array,
          o = r.context;
        if (Xr(o.store)) return o.store.makeCacheKey(a, i, o.varString);
      }
    });
  }
  return e.prototype.resetCanon = function () {
    this.canon = new Pu();
  }, e.prototype.diffQueryAgainstStore = function (t) {
    var n = t.store,
      r = t.query,
      a = t.rootId,
      i = a === void 0 ? "ROOT_QUERY" : a,
      o = t.variables,
      s = t.returnPartialData,
      u = s === void 0 ? !0 : s,
      l = t.canonizeResults,
      c = l === void 0 ? this.config.canonizeResults : l,
      f = this.config.cache.policies;
    o = _P2(_P2({}, zc(Mv(r))), o);
    var h = pr(i),
      p = this.executeSelectionSet({
        selectionSet: Uc(r).selectionSet,
        objectOrReference: h,
        enclosingRef: h,
        context: _P2({
          store: n,
          query: r,
          policies: f,
          variables: o,
          varString: jn(o),
          canonizeResults: c
        }, fy(r, this.config.fragments))
      }),
      v;
    if (p.missing && (v = [new oy(GO(p.missing), p.missing, r, o)], !u)) throw v[0];
    return {
      result: p.result,
      complete: !v,
      missing: v
    };
  }, e.prototype.isFresh = function (t, n, r, a) {
    if (Xr(a.store) && this.knownResults.get(t) === r) {
      var i = this.executeSelectionSet.peek(r, n, a, this.canon.isKnown(t));
      if (i && t === i.result) return !0;
    }
    return !1;
  }, e.prototype.execSelectionSetImpl = function (t) {
    var n = this,
      r = t.selectionSet,
      a = t.objectOrReference,
      i = t.enclosingRef,
      o = t.context;
    if (Ve(a) && !o.policies.rootTypenamesById[a.__ref] && !o.store.has(a.__ref)) return {
      result: this.canon.empty,
      missing: "Dangling reference to missing ".concat(a.__ref, " object")
    };
    var s = o.variables,
      u = o.policies,
      l = o.store,
      c = l.getFieldValue(a, "__typename"),
      f = [],
      h,
      p = new wn();
    this.config.addTypename && typeof c == "string" && !u.rootIdsByTypename[c] && f.push({
      __typename: c
    });
    function v(E, w) {
      var _;
      return E.missing && (h = p.merge(h, (_ = {}, _[w] = E.missing, _))), E.result;
    }
    var m = new Set(r.selections);
    m.forEach(function (E) {
      var w, _;
      if (zo(E, s)) if (sn(E)) {
        var C = u.readField({
            fieldName: E.name.value,
            field: E,
            variables: o.variables,
            from: a
          }, o),
          D = Un(E);
        C === void 0 ? Wc.added(E) || (h = p.merge(h, (w = {}, w[D] = "Can't find field '".concat(E.name.value, "' on ").concat(Ve(a) ? a.__ref + " object" : "object " + JSON.stringify(a, null, 2)), w))) : lt(C) ? C = v(n.executeSubSelectedArray({
          field: E,
          array: C,
          enclosingRef: i,
          context: o
        }), D) : E.selectionSet ? C != null && (C = v(n.executeSelectionSet({
          selectionSet: E.selectionSet,
          objectOrReference: C,
          enclosingRef: Ve(C) ? C : i,
          context: o
        }), D)) : o.canonizeResults && (C = n.canon.pass(C)), C !== void 0 && f.push((_ = {}, _[D] = C, _));
      } else {
        var U = Bc(E, o.lookupFragment);
        if (!U && E.kind === we.FRAGMENT_SPREAD) throw __DEV__ ? new Ne("No fragment named ".concat(E.name.value)) : new Ne(5);
        U && u.fragmentMatches(U, c) && U.selectionSet.selections.forEach(m.add, m);
      }
    });
    var g = Gc(f),
      b = {
        result: g,
        missing: h
      },
      y = o.canonizeResults ? this.canon.admit(b) : ia(b);
    return y.result && this.knownResults.set(y.result, r), y;
  }, e.prototype.execSubSelectedArrayImpl = function (t) {
    var n = this,
      r = t.field,
      a = t.array,
      i = t.enclosingRef,
      o = t.context,
      s,
      u = new wn();
    function l(c, f) {
      var h;
      return c.missing && (s = u.merge(s, (h = {}, h[f] = c.missing, h))), c.result;
    }
    return r.selectionSet && (a = a.filter(o.store.canRead)), a = a.map(function (c, f) {
      return c === null ? null : lt(c) ? l(n.executeSubSelectedArray({
        field: r,
        array: c,
        enclosingRef: i,
        context: o
      }), f) : r.selectionSet ? l(n.executeSelectionSet({
        selectionSet: r.selectionSet,
        objectOrReference: c,
        enclosingRef: Ve(c) ? c : i,
        context: o
      }), f) : (__DEV__ && YO(o.store, r, c), c);
    }), {
      result: o.canonizeResults ? this.canon.admit(a) : a,
      missing: s
    };
  }, e;
}();
function GO(e) {
  try {
    JSON.stringify(e, function (t, n) {
      if (typeof n == "string") throw n;
      return n;
    });
  } catch (t) {
    return t;
  }
}
function YO(e, t, n) {
  if (!t.selectionSet) {
    var r = /* @__PURE__ */new Set([n]);
    r.forEach(function (a) {
      it(a) && (__DEV__ ? te(!Ve(a), "Missing selection set for object of type ".concat(VO(e, a), " returned for query field ").concat(t.name.value)) : te(!Ve(a), 6), Object.values(a).forEach(r.add, r));
    });
  }
}
var gt = null,
  Yd = {},
  QO = 1,
  KO = function KO() {
    return (/** @class */
      function () {
        function e() {
          this.id = ["slot", QO++, Date.now(), Math.random().toString(36).slice(2)].join(":");
        }
        return e.prototype.hasValue = function () {
          for (var t = gt; t; t = t.parent) if (this.id in t.slots) {
            var n = t.slots[this.id];
            if (n === Yd) break;
            return t !== gt && (gt.slots[this.id] = n), !0;
          }
          return gt && (gt.slots[this.id] = Yd), !1;
        }, e.prototype.getValue = function () {
          if (this.hasValue()) return gt.slots[this.id];
        }, e.prototype.withValue = function (t, n, r, a) {
          var i,
            o = (i = {
              __proto__: null
            }, i[this.id] = t, i),
            s = gt;
          gt = {
            parent: s,
            slots: o
          };
          try {
            return n.apply(a, r);
          } finally {
            gt = s;
          }
        }, e.bind = function (t) {
          var n = gt;
          return function () {
            var r = gt;
            try {
              return gt = n, t.apply(this, arguments);
            } finally {
              gt = r;
            }
          };
        }, e.noContext = function (t, n, r) {
          if (gt) {
            var a = gt;
            try {
              return gt = null, t.apply(r, n);
            } finally {
              gt = a;
            }
          } else return t.apply(r, n);
        }, e;
      }()
    );
  };
function Qd(e) {
  try {
    return e();
  } catch (_unused8) {}
}
var xs = "@wry/context:Slot",
  JO =
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  Qd(function () {
    return globalThis;
  }) ||
  // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  Qd(function () {
    return global;
  }) ||
  // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */
  Object.create(null),
  Kd = JO,
  rf = Kd[xs] ||
  // Earlier versions of this package stored the globalKey property on the Array
  // constructor, so we check there as well, to prevent Slot class duplication.
  Array[xs] || function (e) {
    try {
      Object.defineProperty(Kd, xs, {
        value: e,
        enumerable: !1,
        writable: !1,
        // When it was possible for globalHost to be the Array constructor (a
        // legacy Slot dedup strategy), it was important for the property to be
        // configurable:true so it could be deleted. That does not seem to be as
        // important when globalHost is the global object, but I don't want to
        // cause similar problems again, and configurable:true seems safest.
        // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
        configurable: !0
      });
    } finally {
      return e;
    }
  }(KO());
rf.bind;
rf.noContext;
var af = new rf(),
  Jd = /* @__PURE__ */new WeakMap();
function Zr(e) {
  var t = Jd.get(e);
  return t || Jd.set(e, t = {
    vars: /* @__PURE__ */new Set(),
    dep: ay()
  }), t;
}
function Xd(e) {
  Zr(e).vars.forEach(function (t) {
    return t.forgetCache(e);
  });
}
function XO(e) {
  Zr(e).vars.forEach(function (t) {
    return t.attachCache(e);
  });
}
function ZO(e) {
  var t = /* @__PURE__ */new Set(),
    n = /* @__PURE__ */new Set(),
    r = function r(i) {
      if (arguments.length > 0) {
        if (e !== i) {
          e = i, t.forEach(function (u) {
            Zr(u).dep.dirty(r), eS(u);
          });
          var o = Array.from(n);
          n.clear(), o.forEach(function (u) {
            return u(e);
          });
        }
      } else {
        var s = af.getValue();
        s && (a(s), Zr(s).dep(r));
      }
      return e;
    };
  r.onNextChange = function (i) {
    return n.add(i), function () {
      n.delete(i);
    };
  };
  var a = r.attachCache = function (i) {
    return t.add(i), Zr(i).vars.add(r), r;
  };
  return r.forgetCache = function (i) {
    return t.delete(i);
  }, r;
}
function eS(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var Zd = /* @__PURE__ */Object.create(null);
function of(e) {
  var t = JSON.stringify(e);
  return Zd[t] || (Zd[t] = /* @__PURE__ */Object.create(null));
}
function eh(e) {
  var t = of(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function (n, r) {
    var a = function a(o, s) {
        return r.readField(s, o);
      },
      i = r.keyObject = sf(e, function (o) {
        var s = vr(r.storeObject, o, a);
        return s === void 0 && n !== r.storeObject && mt.call(n, o[0]) && (s = vr(n, o, py)), __DEV__ ? te(s !== void 0, "Missing field '".concat(o.join("."), "' while extracting keyFields from ").concat(JSON.stringify(n))) : te(s !== void 0, 2), s;
      });
    return "".concat(r.typename, ":").concat(JSON.stringify(i));
  });
}
function th(e) {
  var t = of(e);
  return t.keyArgsFn || (t.keyArgsFn = function (n, r) {
    var a = r.field,
      i = r.variables,
      o = r.fieldName,
      s = sf(e, function (l) {
        var c = l[0],
          f = c.charAt(0);
        if (f === "@") {
          if (a && Ct(a.directives)) {
            var h = c.slice(1),
              p = a.directives.find(function (b) {
                return b.name.value === h;
              }),
              v = p && Ho(p, i);
            return v && vr(v, l.slice(1));
          }
          return;
        }
        if (f === "$") {
          var m = c.slice(1);
          if (i && mt.call(i, m)) {
            var g = l.slice(0);
            return g[0] = m, vr(i, g);
          }
          return;
        }
        if (n) return vr(n, l);
      }),
      u = JSON.stringify(s);
    return (n || u !== "{}") && (o += ":" + u), o;
  });
}
function sf(e, t) {
  var n = new wn();
  return hy(e).reduce(function (r, a) {
    var i,
      o = t(a);
    if (o !== void 0) {
      for (var s = a.length - 1; s >= 0; --s) o = (i = {}, i[a[s]] = o, i);
      r = n.merge(r, o);
    }
    return r;
  }, /* @__PURE__ */Object.create(null));
}
function hy(e) {
  var t = of(e);
  if (!t.paths) {
    var n = t.paths = [],
      r = [];
    e.forEach(function (a, i) {
      lt(a) ? (hy(a).forEach(function (o) {
        return n.push(r.concat(o));
      }), r.length = 0) : (r.push(a), lt(e[i + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return t.paths;
}
function py(e, t) {
  return e[t];
}
function vr(e, t, n) {
  return n = n || py, my(t.reduce(function r(a, i) {
    return lt(a) ? a.map(function (o) {
      return r(o, i);
    }) : a && n(a, i);
  }, e));
}
function my(e) {
  return it(e) ? lt(e) ? e.map(my) : sf(Object.keys(e).sort(), function (t) {
    return vr(e, t);
  }) : e;
}
Vc.setStringify(jn);
function Du(e) {
  return e.args !== void 0 ? e.args : e.field ? Ho(e.field, e.variables) : null;
}
var tS = function tS() {},
  nh = function nh(e, t) {
    return t.fieldName;
  },
  rh = function rh(e, t, n) {
    var r = n.mergeObjects;
    return r(e, t);
  },
  ah = function ah(e, t) {
    return t;
  },
  nS = function () {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */Object.create(null), this.toBeAdded = /* @__PURE__ */Object.create(null), this.supertypeMap = /* @__PURE__ */new Map(), this.fuzzySubtypes = /* @__PURE__ */new Map(), this.rootIdsByTypename = /* @__PURE__ */Object.create(null), this.rootTypenamesById = /* @__PURE__ */Object.create(null), this.usingPossibleTypes = !1, this.config = _P2({
        dataIdFromObject: sy
      }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function (t, n) {
      var r,
        a = this,
        i = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || t.__typename;
      if (i === this.rootTypenamesById.ROOT_QUERY) return ["ROOT_QUERY"];
      for (var o = n && n.storeObject || t, s = _P2(_P2({}, n), {
          typename: i,
          storeObject: o,
          readField: n && n.readField || function () {
            var h = uf(arguments, o);
            return a.readField(h, {
              store: a.cache.data,
              variables: h.variables
            });
          }
        }), u, l = i && this.getTypePolicy(i), c = l && l.keyFn || this.config.dataIdFromObject; c;) {
        var f = c(t, s);
        if (lt(f)) c = eh(f);else {
          u = f;
          break;
        }
      }
      return u = u ? String(u) : void 0, s.keyObject ? [u, s.keyObject] : [u];
    }, e.prototype.addTypePolicies = function (t) {
      var n = this;
      Object.keys(t).forEach(function (r) {
        var a = t[r],
          i = a.queryType,
          o = a.mutationType,
          s = a.subscriptionType,
          u = Mt(a, ["queryType", "mutationType", "subscriptionType"]);
        i && n.setRootTypename("Query", r), o && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), mt.call(n.toBeAdded, r) ? n.toBeAdded[r].push(u) : n.toBeAdded[r] = [u];
      });
    }, e.prototype.updateTypePolicy = function (t, n) {
      var r = this,
        a = this.getTypePolicy(t),
        i = n.keyFields,
        o = n.fields;
      function s(u, l) {
        u.merge = typeof l == "function" ? l : l === !0 ? rh : l === !1 ? ah : u.merge;
      }
      s(a, n.merge), a.keyFn = i === !1 ? tS : lt(i) ? eh(i) : typeof i == "function" ? i : a.keyFn, o && Object.keys(o).forEach(function (u) {
        var l = r.getFieldPolicy(t, u, !0),
          c = o[u];
        if (typeof c == "function") l.read = c;else {
          var f = c.keyArgs,
            h = c.read,
            p = c.merge;
          l.keyFn = f === !1 ? nh : lt(f) ? th(f) : typeof f == "function" ? f : l.keyFn, typeof h == "function" && (l.read = h), s(l, p);
        }
        l.read && l.merge && (l.keyFn = l.keyFn || nh);
      });
    }, e.prototype.setRootTypename = function (t, n) {
      n === void 0 && (n = t);
      var r = "ROOT_" + t.toUpperCase(),
        a = this.rootTypenamesById[r];
      n !== a && (__DEV__ ? te(!a || a === t, "Cannot change root ".concat(t, " __typename more than once")) : te(!a || a === t, 3), a && delete this.rootIdsByTypename[a], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
    }, e.prototype.addPossibleTypes = function (t) {
      var n = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function (r) {
        n.getSupertypeSet(r, !0), t[r].forEach(function (a) {
          n.getSupertypeSet(a, !0).add(r);
          var i = a.match(cy);
          (!i || i[0] !== a) && n.fuzzySubtypes.set(a, new RegExp(a));
        });
      });
    }, e.prototype.getTypePolicy = function (t) {
      var n = this;
      if (!mt.call(this.typePolicies, t)) {
        var r = this.typePolicies[t] = /* @__PURE__ */Object.create(null);
        r.fields = /* @__PURE__ */Object.create(null);
        var a = this.supertypeMap.get(t);
        a && a.size && a.forEach(function (o) {
          var s = n.getTypePolicy(o),
            u = s.fields,
            l = Mt(s, ["fields"]);
          Object.assign(r, l), Object.assign(r.fields, u);
        });
      }
      var i = this.toBeAdded[t];
      return i && i.length && i.splice(0).forEach(function (o) {
        n.updateTypePolicy(t, o);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function (t, n, r) {
      if (t) {
        var a = this.getTypePolicy(t).fields;
        return a[n] || r && (a[n] = /* @__PURE__ */Object.create(null));
      }
    }, e.prototype.getSupertypeSet = function (t, n) {
      var r = this.supertypeMap.get(t);
      return !r && n && this.supertypeMap.set(t, r = /* @__PURE__ */new Set()), r;
    }, e.prototype.fragmentMatches = function (t, n, r, a) {
      var i = this;
      if (!t.typeCondition) return !0;
      if (!n) return !1;
      var o = t.typeCondition.name.value;
      if (n === o) return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(o)) for (var s = this.getSupertypeSet(n, !0), u = [s], l = function l(v) {
          var m = i.getSupertypeSet(v, !1);
          m && m.size && u.indexOf(m) < 0 && u.push(m);
        }, c = !!(r && this.fuzzySubtypes.size), f = !1, h = 0; h < u.length; ++h) {
        var p = u[h];
        if (p.has(o)) return s.has(o) || (f && __DEV__ && te.warn("Inferring subtype ".concat(n, " of supertype ").concat(o)), s.add(o)), !0;
        p.forEach(l), c && h === u.length - 1 && Eu(t.selectionSet, r, a) && (c = !1, f = !0, this.fuzzySubtypes.forEach(function (v, m) {
          var g = n.match(v);
          g && g[0] === n && l(m);
        }));
      }
      return !1;
    }, e.prototype.hasKeyArgs = function (t, n) {
      var r = this.getFieldPolicy(t, n, !1);
      return !!(r && r.keyFn);
    }, e.prototype.getStoreFieldName = function (t) {
      var n = t.typename,
        r = t.fieldName,
        a = this.getFieldPolicy(n, r, !1),
        i,
        o = a && a.keyFn;
      if (o && n) for (var s = {
          typename: n,
          fieldName: r,
          field: t.field || null,
          variables: t.variables
        }, u = Du(t); o;) {
        var l = o(u, s);
        if (lt(l)) o = th(l);else {
          i = l || r;
          break;
        }
      }
      return i === void 0 && (i = t.field ? l0(t.field, t.variables) : Vc(r, Du(t))), i === !1 ? r : r === Sn(i) ? i : r + ":" + i;
    }, e.prototype.readField = function (t, n) {
      var r = t.from;
      if (r) {
        var a = t.field || t.fieldName;
        if (a) {
          if (t.typename === void 0) {
            var i = n.store.getFieldValue(r, "__typename");
            i && (t.typename = i);
          }
          var o = this.getStoreFieldName(t),
            s = Sn(o),
            u = n.store.getFieldValue(r, o),
            l = this.getFieldPolicy(t.typename, s, !1),
            c = l && l.read;
          if (c) {
            var f = ih(this, r, t, n, n.store.getStorage(Ve(r) ? r.__ref : r, o));
            return af.withValue(this.cache, c, [u, f]);
          }
          return u;
        }
      }
    }, e.prototype.getReadFunction = function (t, n) {
      var r = this.getFieldPolicy(t, n, !1);
      return r && r.read;
    }, e.prototype.getMergeFunction = function (t, n, r) {
      var a = this.getFieldPolicy(t, n, !1),
        i = a && a.merge;
      return !i && r && (a = this.getTypePolicy(r), i = a && a.merge), i;
    }, e.prototype.runMergeFunction = function (t, n, r, a, i) {
      var o = r.field,
        s = r.typename,
        u = r.merge;
      return u === rh ? vy(a.store)(t, n) : u === ah ? n : (a.overwrite && (t = void 0), u(t, n, ih(this, void 0, {
        typename: s,
        fieldName: o.name.value,
        field: o,
        variables: a.variables
      }, a, i || /* @__PURE__ */Object.create(null))));
    }, e;
  }();
function ih(e, t, n, r, a) {
  var i = e.getStoreFieldName(n),
    o = Sn(i),
    s = n.variables || r.variables,
    u = r.store,
    l = u.toReference,
    c = u.canRead;
  return {
    args: Du(n),
    field: n.field || null,
    fieldName: o,
    storeFieldName: i,
    variables: s,
    isReference: Ve,
    toReference: l,
    storage: a,
    cache: e.cache,
    canRead: c,
    readField: function readField() {
      return e.readField(uf(arguments, t, s), r);
    },
    mergeObjects: vy(r.store)
  };
}
function uf(e, t, n) {
  var r = e[0],
    a = e[1],
    i = e.length,
    o;
  return typeof r == "string" ? o = {
    fieldName: r,
    from: i > 1 ? a : t
  } : (o = _P2({}, r), mt.call(o, "from") || (o.from = t)), __DEV__ && o.from === void 0 && __DEV__ && te.warn("Undefined 'from' passed to readField with arguments ".concat(L0(Array.from(e)))), o.variables === void 0 && (o.variables = n), o;
}
function vy(e) {
  return function (n, r) {
    if (lt(n) || lt(r)) throw __DEV__ ? new Ne("Cannot automatically merge arrays") : new Ne(4);
    if (it(n) && it(r)) {
      var a = e.getFieldValue(n, "__typename"),
        i = e.getFieldValue(r, "__typename"),
        o = a && i && a !== i;
      if (o) return r;
      if (Ve(n) && lr(r)) return e.merge(n.__ref, r), n;
      if (lr(n) && Ve(r)) return e.merge(n, r.__ref), r;
      if (lr(n) && lr(r)) return _P2(_P2({}, n), r);
    }
    return r;
  };
}
function $s(e, t, n) {
  var r = "".concat(t).concat(n),
    a = e.flavors.get(r);
  return a || e.flavors.set(r, a = e.clientOnly === t && e.deferred === n ? e : _P2(_P2({}, e), {
    clientOnly: t,
    deferred: n
  })), a;
}
var rS = function () {
    function e(t, n, r) {
      this.cache = t, this.reader = n, this.fragments = r;
    }
    return e.prototype.writeToStore = function (t, n) {
      var r = this,
        a = n.query,
        i = n.result,
        o = n.dataId,
        s = n.variables,
        u = n.overwrite,
        l = _a(a),
        c = qO();
      s = _P2(_P2({}, zc(l)), s);
      var f = _P2(_P2({
          store: t,
          written: /* @__PURE__ */Object.create(null),
          merge: function merge(p, v) {
            return c.merge(p, v);
          },
          variables: s,
          varString: jn(s)
        }, fy(a, this.fragments)), {
          overwrite: !!u,
          incomingById: /* @__PURE__ */new Map(),
          clientOnly: !1,
          deferred: !1,
          flavors: /* @__PURE__ */new Map()
        }),
        h = this.processSelectionSet({
          result: i || /* @__PURE__ */Object.create(null),
          dataId: o,
          selectionSet: l.selectionSet,
          mergeTree: {
            map: /* @__PURE__ */new Map()
          },
          context: f
        });
      if (!Ve(h)) throw __DEV__ ? new Ne("Could not identify object ".concat(JSON.stringify(i))) : new Ne(7);
      return f.incomingById.forEach(function (p, v) {
        var m = p.storeObject,
          g = p.mergeTree,
          b = p.fieldNodeSet,
          y = pr(v);
        if (g && g.map.size) {
          var E = r.applyMerges(g, y, m, f);
          if (Ve(E)) return;
          m = E;
        }
        if (__DEV__ && !f.overwrite) {
          var w = /* @__PURE__ */Object.create(null);
          b.forEach(function (D) {
            D.selectionSet && (w[D.name.value] = !0);
          });
          var _ = function _(D) {
              return w[Sn(D)] === !0;
            },
            C = function C(D) {
              var U = g && g.map.get(D);
              return Boolean(U && U.info && U.info.merge);
            };
          Object.keys(m).forEach(function (D) {
            _(D) && !C(D) && aS(y, m, D, f.store);
          });
        }
        t.merge(v, m);
      }), t.retain(h.__ref), h;
    }, e.prototype.processSelectionSet = function (t) {
      var n = this,
        r = t.dataId,
        a = t.result,
        i = t.selectionSet,
        o = t.context,
        s = t.mergeTree,
        u = this.cache.policies,
        l = /* @__PURE__ */Object.create(null),
        c = r && u.rootTypenamesById[r] || du(a, i, o.fragmentMap) || r && o.store.get(r, "__typename");
      typeof c == "string" && (l.__typename = c);
      var f = function f() {
          var E = uf(arguments, l, o.variables);
          if (Ve(E.from)) {
            var w = o.incomingById.get(E.from.__ref);
            if (w) {
              var _ = u.readField(_P2(_P2({}, E), {
                from: w.storeObject
              }), o);
              if (_ !== void 0) return _;
            }
          }
          return u.readField(E, o);
        },
        h = /* @__PURE__ */new Set();
      this.flattenFields(i, a, o, c).forEach(function (E, w) {
        var _,
          C = Un(w),
          D = a[C];
        if (h.add(w), D !== void 0) {
          var U = u.getStoreFieldName({
              typename: c,
              fieldName: w.name.value,
              field: w,
              variables: E.variables
            }),
            Z = oh(s, U),
            me = n.processFieldValue(D, w, w.selectionSet ? $s(E, !1, !1) : E, Z),
            ye = void 0;
          w.selectionSet && (Ve(me) || lr(me)) && (ye = f("__typename", me));
          var Y = u.getMergeFunction(c, w.name.value, ye);
          Y ? Z.info = {
            field: w,
            typename: c,
            merge: Y
          } : sh(s, U), l = E.merge(l, (_ = {}, _[U] = me, _));
        } else __DEV__ && !E.clientOnly && !E.deferred && !Wc.added(w) && !u.getReadFunction(c, w.name.value) && __DEV__ && te.error("Missing field '".concat(Un(w), "' while writing result ").concat(JSON.stringify(a, null, 2)).substring(0, 1e3));
      });
      try {
        var p = u.identify(a, {
            typename: c,
            selectionSet: i,
            fragmentMap: o.fragmentMap,
            storeObject: l,
            readField: f
          }),
          v = p[0],
          m = p[1];
        r = r || v, m && (l = o.merge(l, m));
      } catch (E) {
        if (!r) throw E;
      }
      if (typeof r == "string") {
        var g = pr(r),
          b = o.written[r] || (o.written[r] = []);
        if (b.indexOf(i) >= 0 || (b.push(i), this.reader && this.reader.isFresh(a, g, i, o))) return g;
        var y = o.incomingById.get(r);
        return y ? (y.storeObject = o.merge(y.storeObject, l), y.mergeTree = xu(y.mergeTree, s), h.forEach(function (E) {
          return y.fieldNodeSet.add(E);
        })) : o.incomingById.set(r, {
          storeObject: l,
          mergeTree: Yi(s) ? void 0 : s,
          fieldNodeSet: h
        }), g;
      }
      return l;
    }, e.prototype.processFieldValue = function (t, n, r, a) {
      var i = this;
      return !n.selectionSet || t === null ? __DEV__ ? Uv(t) : t : lt(t) ? t.map(function (o, s) {
        var u = i.processFieldValue(o, n, r, oh(a, s));
        return sh(a, s), u;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: n.selectionSet,
        context: r,
        mergeTree: a
      });
    }, e.prototype.flattenFields = function (t, n, r, a) {
      a === void 0 && (a = du(n, t, r.fragmentMap));
      var i = /* @__PURE__ */new Map(),
        o = this.cache.policies,
        s = new Sa(!1);
      return function u(l, c) {
        var f = s.lookup(l, c.clientOnly, c.deferred);
        f.visited || (f.visited = !0, l.selections.forEach(function (h) {
          if (zo(h, r.variables)) {
            var p = c.clientOnly,
              v = c.deferred;
            if (!(p && v) && Ct(h.directives) && h.directives.forEach(function (b) {
              var y = b.name.value;
              if (y === "client" && (p = !0), y === "defer") {
                var E = Ho(b, r.variables);
                (!E || E.if !== !1) && (v = !0);
              }
            }), sn(h)) {
              var m = i.get(h);
              m && (p = p && m.clientOnly, v = v && m.deferred), i.set(h, $s(r, p, v));
            } else {
              var g = Bc(h, r.lookupFragment);
              if (!g && h.kind === we.FRAGMENT_SPREAD) throw __DEV__ ? new Ne("No fragment named ".concat(h.name.value)) : new Ne(8);
              g && o.fragmentMatches(g, a, n, r.variables) && u(g.selectionSet, $s(r, p, v));
            }
          }
        }));
      }(t, r), i;
    }, e.prototype.applyMerges = function (t, n, r, a, i) {
      var o,
        s = this;
      if (t.map.size && !Ve(r)) {
        var u = !lt(r) && (Ve(n) || lr(n)) ? n : void 0,
          l = r;
        u && !i && (i = [Ve(u) ? u.__ref : u]);
        var c,
          f = function f(h, p) {
            return lt(h) ? typeof p == "number" ? h[p] : void 0 : a.store.getFieldValue(h, String(p));
          };
        t.map.forEach(function (h, p) {
          var v = f(u, p),
            m = f(l, p);
          if (m !== void 0) {
            i && i.push(p);
            var g = s.applyMerges(h, v, m, a, i);
            g !== m && (c = c || /* @__PURE__ */new Map(), c.set(p, g)), i && te(i.pop() === p);
          }
        }), c && (r = lt(l) ? l.slice(0) : _P2({}, l), c.forEach(function (h, p) {
          r[p] = h;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(n, r, t.info, a, i && (o = a.store).getStorage.apply(o, i)) : r;
    }, e;
  }(),
  yy = [];
function oh(e, t) {
  var n = e.map;
  return n.has(t) || n.set(t, yy.pop() || {
    map: /* @__PURE__ */new Map()
  }), n.get(t);
}
function xu(e, t) {
  if (e === t || !t || Yi(t)) return e;
  if (!e || Yi(e)) return t;
  var n = e.info && t.info ? _P2(_P2({}, e.info), t.info) : e.info || t.info,
    r = e.map.size && t.map.size,
    a = r ? /* @__PURE__ */new Map() : e.map.size ? e.map : t.map,
    i = {
      info: n,
      map: a
    };
  if (r) {
    var o = new Set(t.map.keys());
    e.map.forEach(function (s, u) {
      i.map.set(u, xu(s, t.map.get(u))), o.delete(u);
    }), o.forEach(function (s) {
      i.map.set(s, xu(t.map.get(s), e.map.get(s)));
    });
  }
  return i;
}
function Yi(e) {
  return !e || !(e.info || e.map.size);
}
function sh(e, t) {
  var n = e.map,
    r = n.get(t);
  r && Yi(r) && (yy.push(r), n.delete(t));
}
var uh = /* @__PURE__ */new Set();
function aS(e, t, n, r) {
  var a = function a(f) {
      var h = r.getFieldValue(f, n);
      return typeof h == "object" && h;
    },
    i = a(e);
  if (i) {
    var o = a(t);
    if (o && !Ve(i) && !Qe(i, o) && !Object.keys(i).every(function (f) {
      return r.getFieldValue(o, f) !== void 0;
    })) {
      var s = r.getFieldValue(e, "__typename") || r.getFieldValue(t, "__typename"),
        u = Sn(n),
        l = "".concat(s, ".").concat(u);
      if (!uh.has(l)) {
        uh.add(l);
        var c = [];
        !lt(i) && !lt(o) && [i, o].forEach(function (f) {
          var h = r.getFieldValue(f, "__typename");
          typeof h == "string" && !c.includes(h) && c.push(h);
        }), __DEV__ && te.warn("Cache data may be lost when replacing the ".concat(u, " field of a ").concat(s, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(l, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(i).slice(0, 1e3), "\n  incoming: ").concat(JSON.stringify(o).slice(0, 1e3), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
      }
    }
  }
}
var iS = function (e) {
  et(t, e);
  function t(n) {
    n === void 0 && (n = {});
    var r = e.call(this) || this;
    return r.watches = /* @__PURE__ */new Set(), r.typenameDocumentCache = /* @__PURE__ */new Map(), r.makeVar = ZO, r.txCount = 0, r.config = BO(n), r.addTypename = !!r.config.addTypename, r.policies = new nS({
      cache: r,
      dataIdFromObject: r.config.dataIdFromObject,
      possibleTypes: r.config.possibleTypes,
      typePolicies: r.config.typePolicies
    }), r.init(), r;
  }
  return t.prototype.init = function () {
    var n = this.data = new sa.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = n.stump, this.resetResultCache();
  }, t.prototype.resetResultCache = function (n) {
    var r = this,
      a = this.storeReader,
      i = this.config.fragments;
    this.storeWriter = new rS(this, this.storeReader = new WO({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: ly(this.config),
      canon: n ? void 0 : a && a.canon,
      fragments: i
    }), i), this.maybeBroadcastWatch = Gi(function (o, s) {
      return r.broadcastWatch(o, s);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function makeCacheKey(o) {
        var s = o.optimistic ? r.optimisticData : r.data;
        if (Xr(s)) {
          var u = o.optimistic,
            l = o.id,
            c = o.variables;
          return s.makeCacheKey(o.query, o.callback, jn({
            optimistic: u,
            id: l,
            variables: c
          }));
        }
      }
    }), /* @__PURE__ */new Set([this.data.group, this.optimisticData.group]).forEach(function (o) {
      return o.resetCaching();
    });
  }, t.prototype.restore = function (n) {
    return this.init(), n && this.data.replace(n), this;
  }, t.prototype.extract = function (n) {
    return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
  }, t.prototype.read = function (n) {
    var r = n.returnPartialData,
      a = r === void 0 ? !1 : r;
    try {
      return this.storeReader.diffQueryAgainstStore(_P2(_P2({}, n), {
        store: n.optimistic ? this.optimisticData : this.data,
        config: this.config,
        returnPartialData: a
      })).result || null;
    } catch (i) {
      if (i instanceof oy) return null;
      throw i;
    }
  }, t.prototype.write = function (n) {
    try {
      return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
    } finally {
      ! --this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.modify = function (n) {
    if (mt.call(n, "id") && !n.id) return !1;
    var r = n.optimistic ? this.optimisticData : this.data;
    try {
      return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
    } finally {
      ! --this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.diff = function (n) {
    return this.storeReader.diffQueryAgainstStore(_P2(_P2({}, n), {
      store: n.optimistic ? this.optimisticData : this.data,
      rootId: n.id || "ROOT_QUERY",
      config: this.config
    }));
  }, t.prototype.watch = function (n) {
    var r = this;
    return this.watches.size || XO(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function () {
      r.watches.delete(n) && !r.watches.size && Xd(r), r.maybeBroadcastWatch.forget(n);
    };
  }, t.prototype.gc = function (n) {
    jn.reset();
    var r = this.optimisticData.gc();
    return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
  }, t.prototype.retain = function (n, r) {
    return (r ? this.optimisticData : this.data).retain(n);
  }, t.prototype.release = function (n, r) {
    return (r ? this.optimisticData : this.data).release(n);
  }, t.prototype.identify = function (n) {
    if (Ve(n)) return n.__ref;
    try {
      return this.policies.identify(n)[0];
    } catch (r) {
      __DEV__ && te.warn(r);
    }
  }, t.prototype.evict = function (n) {
    if (!n.id) {
      if (mt.call(n, "id")) return !1;
      n = _P2(_P2({}, n), {
        id: "ROOT_QUERY"
      });
    }
    try {
      return ++this.txCount, this.optimisticData.evict(n, this.data);
    } finally {
      ! --this.txCount && n.broadcast !== !1 && this.broadcastWatches();
    }
  }, t.prototype.reset = function (n) {
    var r = this;
    return this.init(), jn.reset(), n && n.discardWatches ? (this.watches.forEach(function (a) {
      return r.maybeBroadcastWatch.forget(a);
    }), this.watches.clear(), Xd(this)) : this.broadcastWatches(), Promise.resolve();
  }, t.prototype.removeOptimistic = function (n) {
    var r = this.optimisticData.removeLayer(n);
    r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
  }, t.prototype.batch = function (n) {
    var r = this,
      a = n.update,
      i = n.optimistic,
      o = i === void 0 ? !0 : i,
      s = n.removeOptimistic,
      u = n.onWatchUpdated,
      l,
      c = function c(h) {
        var p = r,
          v = p.data,
          m = p.optimisticData;
        ++r.txCount, h && (r.data = r.optimisticData = h);
        try {
          return l = a(r);
        } finally {
          --r.txCount, r.data = v, r.optimisticData = m;
        }
      },
      f = /* @__PURE__ */new Set();
    return u && !this.txCount && this.broadcastWatches(_P2(_P2({}, n), {
      onWatchUpdated: function onWatchUpdated(h) {
        return f.add(h), !1;
      }
    })), typeof o == "string" ? this.optimisticData = this.optimisticData.addLayer(o, c) : o === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), u && f.size ? (this.broadcastWatches(_P2(_P2({}, n), {
      onWatchUpdated: function onWatchUpdated(h, p) {
        var v = u.call(this, h, p);
        return v !== !1 && f.delete(h), v;
      }
    })), f.size && f.forEach(function (h) {
      return r.maybeBroadcastWatch.dirty(h);
    })) : this.broadcastWatches(n), l;
  }, t.prototype.performTransaction = function (n, r) {
    return this.batch({
      update: n,
      optimistic: r || r !== null
    });
  }, t.prototype.transformDocument = function (n) {
    if (this.addTypename) {
      var r = this.typenameDocumentCache.get(n);
      return r || (r = Wc(n), this.typenameDocumentCache.set(n, r), this.typenameDocumentCache.set(r, r)), r;
    }
    return n;
  }, t.prototype.transformForLink = function (n) {
    var r = this.config.fragments;
    return r ? r.transform(n) : n;
  }, t.prototype.broadcastWatches = function (n) {
    var r = this;
    this.txCount || this.watches.forEach(function (a) {
      return r.maybeBroadcastWatch(a, n);
    });
  }, t.prototype.broadcastWatch = function (n, r) {
    var a = n.lastDiff,
      i = this.diff(n);
    r && (n.optimistic && typeof r.optimistic == "string" && (i.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, i, a) === !1) || (!a || !Qe(a.result, i.result)) && n.callback(n.lastDiff = i, a);
  }, t;
}(jO);
function oS(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var sS = function sS(e) {
    var t = "";
    if (Ct(e.graphQLErrors) || Ct(e.clientErrors)) {
      var n = (e.graphQLErrors || []).concat(e.clientErrors || []);
      n.forEach(function (r) {
        var a = r ? r.message : "Error message not found.";
        t += "".concat(a, "\n");
      });
    }
    return e.networkError && (t += "".concat(e.networkError.message, "\n")), t = t.replace(/\n$/, ""), t;
  },
  an = function (e) {
    et(t, e);
    function t(n) {
      var r = n.graphQLErrors,
        a = n.clientErrors,
        i = n.networkError,
        o = n.errorMessage,
        s = n.extraInfo,
        u = e.call(this, o) || this;
      return u.name = "ApolloError", u.graphQLErrors = r || [], u.clientErrors = a || [], u.networkError = i || null, u.message = o || sS(u), u.extraInfo = s, u.__proto__ = t.prototype, u;
    }
    return t;
  }(Error),
  Re;
(function (e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(Re || (Re = {}));
function ua(e) {
  return e ? e < 7 : !1;
}
var uS = Object.assign,
  lS = Object.hasOwnProperty,
  $u = function (e) {
    et(t, e);
    function t(n) {
      var r = n.queryManager,
        a = n.queryInfo,
        i = n.options,
        o = e.call(this, function (g) {
          try {
            var b = g._subscription._observer;
            b && !b.error && (b.error = cS);
          } catch (_unused9) {}
          var y = !o.observers.size;
          o.observers.add(g);
          var E = o.last;
          return E && E.error ? g.error && g.error(E.error) : E && E.result && g.next && g.next(E.result), y && o.reobserve().catch(function () {}), function () {
            o.observers.delete(g) && !o.observers.size && o.tearDownQuery();
          };
        }) || this;
      o.observers = /* @__PURE__ */new Set(), o.subscriptions = /* @__PURE__ */new Set(), o.queryInfo = a, o.queryManager = r, o.isTornDown = !1;
      var s = r.defaultOptions.watchQuery,
        u = s === void 0 ? {} : s,
        l = u.fetchPolicy,
        c = l === void 0 ? "cache-first" : l,
        f = i.fetchPolicy,
        h = f === void 0 ? c : f,
        p = i.initialFetchPolicy,
        v = p === void 0 ? h === "standby" ? c : h : p;
      o.options = _P2(_P2({}, i), {
        initialFetchPolicy: v,
        fetchPolicy: h
      }), o.queryId = a.queryId || r.generateQueryId();
      var m = _a(o.query);
      return o.queryName = m && m.name && m.name.value, o;
    }
    return Object.defineProperty(t.prototype, "query", {
      get: function get() {
        return this.queryManager.transform(this.options.query).document;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      get: function get() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function () {
      var n = this;
      return new Promise(function (r, a) {
        var i = {
            next: function next(s) {
              r(s), n.observers.delete(i), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function () {
                o.unsubscribe();
              }, 0);
            },
            error: a
          },
          o = n.subscribe(i);
      });
    }, t.prototype.getCurrentResult = function (n) {
      n === void 0 && (n = !0);
      var r = this.getLastResult(!0),
        a = this.queryInfo.networkStatus || r && r.networkStatus || Re.ready,
        i = _P2(_P2({}, r), {
          loading: ua(a),
          networkStatus: a
        }),
        o = this.options.fetchPolicy,
        s = o === void 0 ? "cache-first" : o;
      if (!(s === "network-only" || s === "no-cache" || s === "standby" || this.queryManager.transform(this.options.query).hasForcedResolvers)) {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (i.data = u.result), Qe(i.data, {}) && (i.data = void 0), u.complete ? (delete i.partial, u.complete && i.networkStatus === Re.loading && (s === "cache-first" || s === "cache-only") && (i.networkStatus = Re.ready, i.loading = !1)) : i.partial = !0, __DEV__ && !u.complete && !this.options.partialRefetch && !i.loading && !i.data && !i.error && by(u.missing);
      }
      return n && this.updateLastResult(i), i;
    }, t.prototype.isDifferentFromLastResult = function (n, r) {
      return !this.last || !Qe(this.last.result, n) || r && !Qe(this.last.variables, r);
    }, t.prototype.getLast = function (n, r) {
      var a = this.last;
      if (a && a[n] && (!r || Qe(a.variables, this.variables))) return a[n];
    }, t.prototype.getLastResult = function (n) {
      return this.getLast("result", n);
    }, t.prototype.getLastError = function (n) {
      return this.getLast("error", n);
    }, t.prototype.resetLastResults = function () {
      delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function () {
      this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function (n) {
      var r,
        a = {
          pollInterval: 0
        },
        i = this.options.fetchPolicy;
      if (i === "cache-and-network" ? a.fetchPolicy = i : i === "no-cache" ? a.fetchPolicy = "no-cache" : a.fetchPolicy = "network-only", __DEV__ && n && lS.call(n, "variables")) {
        var o = Mv(this.query),
          s = o.variableDefinitions;
        (!s || !s.some(function (u) {
          return u.variable.name.value === "variables";
        })) && __DEV__ && te.warn("Called refetch(".concat(JSON.stringify(n), ") for query ").concat(((r = o.name) === null || r === void 0 ? void 0 : r.value) || JSON.stringify(o), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
      }
      return n && !Qe(this.options.variables, n) && (a.variables = this.options.variables = _P2(_P2({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(a, Re.refetch);
    }, t.prototype.fetchMore = function (n) {
      var r = this,
        a = _P2(_P2({}, n.query ? n : _P2(_P2(_P2(_P2({}, this.options), {
          query: this.query
        }), n), {
          variables: _P2(_P2({}, this.options.variables), n.variables)
        })), {
          fetchPolicy: "no-cache"
        }),
        i = this.queryManager.generateQueryId(),
        o = this.queryInfo,
        s = o.networkStatus;
      o.networkStatus = Re.fetchMore, a.notifyOnNetworkStatusChange && this.observe();
      var u = /* @__PURE__ */new Set();
      return this.queryManager.fetchQuery(i, a, Re.fetchMore).then(function (l) {
        return r.queryManager.removeQuery(i), o.networkStatus === Re.fetchMore && (o.networkStatus = s), r.queryManager.cache.batch({
          update: function update(c) {
            var f = n.updateQuery;
            f ? c.updateQuery({
              query: r.query,
              variables: r.variables,
              returnPartialData: !0,
              optimistic: !1
            }, function (h) {
              return f(h, {
                fetchMoreResult: l.data,
                variables: a.variables
              });
            }) : c.writeQuery({
              query: a.query,
              variables: a.variables,
              data: l.data
            });
          },
          onWatchUpdated: function onWatchUpdated(c) {
            u.add(c.query);
          }
        }), l;
      }).finally(function () {
        u.has(r.query) || gy(r);
      });
    }, t.prototype.subscribeToMore = function (n) {
      var r = this,
        a = this.queryManager.startGraphQLSubscription({
          query: n.document,
          variables: n.variables,
          context: n.context
        }).subscribe({
          next: function next(i) {
            var o = n.updateQuery;
            o && r.updateQuery(function (s, u) {
              var l = u.variables;
              return o(s, {
                subscriptionData: i,
                variables: l
              });
            });
          },
          error: function error(i) {
            if (n.onError) {
              n.onError(i);
              return;
            }
            __DEV__ && te.error("Unhandled GraphQL subscription error", i);
          }
        });
      return this.subscriptions.add(a), function () {
        r.subscriptions.delete(a) && a.unsubscribe();
      };
    }, t.prototype.setOptions = function (n) {
      return this.reobserve(n);
    }, t.prototype.setVariables = function (n) {
      return Qe(this.variables, n) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
        fetchPolicy: this.options.initialFetchPolicy,
        variables: n
      }, Re.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function (n) {
      var r = this.queryManager,
        a = r.cache.diff({
          query: this.options.query,
          variables: this.variables,
          returnPartialData: !0,
          optimistic: !1
        }).result,
        i = n(a, {
          variables: this.variables
        });
      i && (r.cache.writeQuery({
        query: this.options.query,
        data: i,
        variables: this.variables
      }), r.broadcastQueries());
    }, t.prototype.startPolling = function (n) {
      this.options.pollInterval = n, this.updatePolling();
    }, t.prototype.stopPolling = function () {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function (n, r) {
      if (r.nextFetchPolicy) {
        var a = r.fetchPolicy,
          i = a === void 0 ? "cache-first" : a,
          o = r.initialFetchPolicy,
          s = o === void 0 ? i : o;
        i === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(i, {
          reason: n,
          options: r,
          observable: this,
          initialFetchPolicy: s
        }) : n === "variables-changed" ? r.fetchPolicy = s : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, t.prototype.fetch = function (n, r) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchQueryObservable(this.queryId, n, r);
    }, t.prototype.updatePolling = function () {
      var n = this;
      if (!this.queryManager.ssrMode) {
        var r = this,
          a = r.pollingInfo,
          i = r.options.pollInterval;
        if (!i) {
          a && (clearTimeout(a.timeout), delete this.pollingInfo);
          return;
        }
        if (!(a && a.interval === i)) {
          __DEV__ ? te(i, "Attempted to start a polling query without a polling interval.") : te(i, 12);
          var o = a || (this.pollingInfo = {});
          o.interval = i;
          var s = function s() {
              n.pollingInfo && (ua(n.queryInfo.networkStatus) ? u() : n.reobserve({
                fetchPolicy: n.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
              }, Re.poll).then(u, u));
            },
            u = function u() {
              var l = n.pollingInfo;
              l && (clearTimeout(l.timeout), l.timeout = setTimeout(s, l.interval));
            };
          u();
        }
      }
    }, t.prototype.updateLastResult = function (n, r) {
      return r === void 0 && (r = this.variables), this.last = _P2(_P2({}, this.last), {
        result: this.queryManager.assumeImmutableResults ? n : Uv(n),
        variables: r
      }), Ct(n.errors) || delete this.last.error, this.last;
    }, t.prototype.reobserve = function (n, r) {
      var a = this;
      this.isTornDown = !1;
      var i = r === Re.refetch || r === Re.fetchMore || r === Re.poll,
        o = this.options.variables,
        s = this.options.fetchPolicy,
        u = wa(this.options, n || {}),
        l = i ? u : uS(this.options, u);
      i || (this.updatePolling(), n && n.variables && !Qe(n.variables, o) && l.fetchPolicy !== "standby" && l.fetchPolicy === s && (this.applyNextFetchPolicy("variables-changed", l), r === void 0 && (r = Re.setVariables)));
      var c = l.variables && _P2({}, l.variables),
        f = this.fetch(l, r),
        h = {
          next: function next(p) {
            a.reportResult(p, c);
          },
          error: function error(p) {
            a.reportError(p, c);
          }
        };
      return i || (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = f, this.observer = h), f.addObserver(h), f.promise;
    }, t.prototype.observe = function () {
      this.reportResult(this.getCurrentResult(!1), this.variables);
    }, t.prototype.reportResult = function (n, r) {
      var a = this.getLastError();
      (a || this.isDifferentFromLastResult(n, r)) && ((a || !n.partial || this.options.returnPartialData) && this.updateLastResult(n, r), Kr(this.observers, "next", n));
    }, t.prototype.reportError = function (n, r) {
      var a = _P2(_P2({}, this.getLastResult()), {
        error: n,
        errors: n.graphQLErrors,
        networkStatus: Re.error,
        loading: !1
      });
      this.updateLastResult(a, r), Kr(this.observers, "error", this.last.error = n);
    }, t.prototype.hasObservers = function () {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function () {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function (n) {
        return n.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t;
  }(Ye);
Hv($u);
function gy(e) {
  var t = e.options,
    n = t.fetchPolicy,
    r = t.nextFetchPolicy;
  return n === "cache-and-network" || n === "network-only" ? e.reobserve({
    fetchPolicy: "cache-first",
    nextFetchPolicy: function nextFetchPolicy() {
      return this.nextFetchPolicy = r, typeof r == "function" ? r.apply(this, arguments) : n;
    }
  }) : e.reobserve();
}
function cS(e) {
  __DEV__ && te.error("Unhandled error", e.message, e.stack);
}
function by(e) {
  __DEV__ && e && __DEV__ && te.debug("Missing cache result fields: ".concat(JSON.stringify(e)), e);
}
var _y = function () {
    function e(t) {
      var n = t.cache,
        r = t.client,
        a = t.resolvers,
        i = t.fragmentMatcher;
      this.cache = n, r && (this.client = r), a && this.addResolvers(a), i && this.setFragmentMatcher(i);
    }
    return e.prototype.addResolvers = function (t) {
      var n = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function (r) {
        n.resolvers = Td(n.resolvers, r);
      }) : this.resolvers = Td(this.resolvers, t);
    }, e.prototype.setResolvers = function (t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function () {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function (t) {
      var n = t.document,
        r = t.remoteResult,
        a = t.context,
        i = t.variables,
        o = t.onlyRunForcedResolvers,
        s = o === void 0 ? !1 : o;
      return mn(this, void 0, void 0, function () {
        return vn(this, function (u) {
          return n ? [2, this.resolveDocument(n, r.data, a, i, this.fragmentMatcher, s).then(function (l) {
            return _P2(_P2({}, r), {
              data: l.result
            });
          })] : [2, r];
        });
      });
    }, e.prototype.setFragmentMatcher = function (t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function () {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function (t) {
      return Lc(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function (t) {
      return b0(t);
    }, e.prototype.prepareContext = function (t) {
      var n = this.cache;
      return _P2(_P2({}, t), {
        cache: n,
        getCacheKey: function getCacheKey(r) {
          return n.identify(r);
        }
      });
    }, e.prototype.addExportedVariables = function (t, n, r) {
      return n === void 0 && (n = {}), r === void 0 && (r = {}), mn(this, void 0, void 0, function () {
        return vn(this, function (a) {
          return t ? [2, this.resolveDocument(t, this.buildRootValueFromCache(t, n) || {}, this.prepareContext(r), n).then(function (i) {
            return _P2(_P2({}, n), i.exportedVariables);
          })] : [2, _P2({}, n)];
        });
      });
    }, e.prototype.shouldForceResolvers = function (t) {
      var n = !1;
      return tn(t, {
        Directive: {
          enter: function enter(r) {
            if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function (a) {
              return a.name.value === "always" && a.value.kind === "BooleanValue" && a.value.value === !0;
            }), n)) return Fc;
          }
        }
      }), n;
    }, e.prototype.buildRootValueFromCache = function (t, n) {
      return this.cache.diff({
        query: g0(t),
        variables: n,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function (t, n, r, a, i, o) {
      return r === void 0 && (r = {}), a === void 0 && (a = {}), i === void 0 && (i = function i() {
        return !0;
      }), o === void 0 && (o = !1), mn(this, void 0, void 0, function () {
        var s, u, l, c, f, h, p, v, m;
        return vn(this, function (g) {
          return s = Uc(t), u = qc(t), l = jc(u), c = s.operation, f = c ? c.charAt(0).toUpperCase() + c.slice(1) : "Query", h = this, p = h.cache, v = h.client, m = {
            fragmentMap: l,
            context: _P2(_P2({}, r), {
              cache: p,
              client: v
            }),
            variables: a,
            fragmentMatcher: i,
            defaultOperationType: f,
            exportedVariables: {},
            onlyRunForcedResolvers: o
          }, [2, this.resolveSelectionSet(s.selectionSet, n, m).then(function (b) {
            return {
              result: b,
              exportedVariables: m.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function (t, n, r) {
      return mn(this, void 0, void 0, function () {
        var a,
          i,
          o,
          s,
          u,
          l = this;
        return vn(this, function (c) {
          return a = r.fragmentMap, i = r.context, o = r.variables, s = [n], u = function u(f) {
            return mn(l, void 0, void 0, function () {
              var h, p;
              return vn(this, function (v) {
                return zo(f, o) ? sn(f) ? [2, this.resolveField(f, n, r).then(function (m) {
                  var g;
                  typeof m < "u" && s.push((g = {}, g[Un(f)] = m, g));
                })] : (Iv(f) ? h = f : (h = a[f.name.value], __DEV__ ? te(h, "No fragment named ".concat(f.name.value)) : te(h, 11)), h && h.typeCondition && (p = h.typeCondition.name.value, r.fragmentMatcher(n, p, i)) ? [2, this.resolveSelectionSet(h.selectionSet, n, r).then(function (m) {
                  s.push(m);
                })] : [2]) : [2];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function () {
            return Gc(s);
          })];
        });
      });
    }, e.prototype.resolveField = function (t, n, r) {
      return mn(this, void 0, void 0, function () {
        var a,
          i,
          o,
          s,
          u,
          l,
          c,
          f,
          h,
          p = this;
        return vn(this, function (v) {
          return a = r.variables, i = t.name.value, o = Un(t), s = i !== o, u = n[o] || n[i], l = Promise.resolve(u), (!r.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (c = n.__typename || r.defaultOperationType, f = this.resolvers && this.resolvers[c], f && (h = f[s ? i : o], h && (l = Promise.resolve(af.withValue(this.cache, h, [n, Ho(t, a), r.context, {
            field: t,
            fragmentMap: r.fragmentMap
          }]))))), [2, l.then(function (m) {
            if (m === void 0 && (m = u), t.directives && t.directives.forEach(function (g) {
              g.name.value === "export" && g.arguments && g.arguments.forEach(function (b) {
                b.name.value === "as" && b.value.kind === "StringValue" && (r.exportedVariables[b.value.value] = m);
              });
            }), !t.selectionSet || m == null) return m;
            if (Array.isArray(m)) return p.resolveSubSelectedArray(t, m, r);
            if (t.selectionSet) return p.resolveSelectionSet(t.selectionSet, m, r);
          })];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function (t, n, r) {
      var a = this;
      return Promise.all(n.map(function (i) {
        if (i === null) return null;
        if (Array.isArray(i)) return a.resolveSubSelectedArray(t, i, r);
        if (t.selectionSet) return a.resolveSelectionSet(t.selectionSet, i, r);
      }));
    }, e;
  }(),
  cr = new (xn ? WeakMap : Map)();
function Cs(e, t) {
  var n = e[t];
  typeof n == "function" && (e[t] = function () {
    return cr.set(e, (cr.get(e) + 1) % 1e15), n.apply(this, arguments);
  });
}
function lh(e) {
  e.notifyTimeout && (clearTimeout(e.notifyTimeout), e.notifyTimeout = void 0);
}
var Rs = function () {
  function e(t, n) {
    n === void 0 && (n = t.generateQueryId()), this.queryId = n, this.listeners = /* @__PURE__ */new Set(), this.document = null, this.lastRequestId = 1, this.subscriptions = /* @__PURE__ */new Set(), this.stopped = !1, this.dirty = !1, this.observableQuery = null;
    var r = this.cache = t.cache;
    cr.has(r) || (cr.set(r, 0), Cs(r, "evict"), Cs(r, "modify"), Cs(r, "reset"));
  }
  return e.prototype.init = function (t) {
    var n = t.networkStatus || Re.loading;
    return this.variables && this.networkStatus !== Re.loading && !Qe(this.variables, t.variables) && (n = Re.setVariables), Qe(t.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
      document: t.document,
      variables: t.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: n
    }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
  }, e.prototype.reset = function () {
    lh(this), this.dirty = !1;
  }, e.prototype.getDiff = function (t) {
    t === void 0 && (t = this.variables);
    var n = this.getDiffOptions(t);
    if (this.lastDiff && Qe(n, this.lastDiff.options)) return this.lastDiff.diff;
    this.updateWatch(this.variables = t);
    var r = this.observableQuery;
    if (r && r.options.fetchPolicy === "no-cache") return {
      complete: !1
    };
    var a = this.cache.diff(n);
    return this.updateLastDiff(a, n), a;
  }, e.prototype.updateLastDiff = function (t, n) {
    this.lastDiff = t ? {
      diff: t,
      options: n || this.getDiffOptions()
    } : void 0;
  }, e.prototype.getDiffOptions = function (t) {
    var n;
    return t === void 0 && (t = this.variables), {
      query: this.document,
      variables: t,
      returnPartialData: !0,
      optimistic: !0,
      canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
    };
  }, e.prototype.setDiff = function (t) {
    var n = this,
      r = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(t), !this.dirty && !Qe(r && r.result, t && t.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function () {
      return n.notify();
    }, 0)));
  }, e.prototype.setObservableQuery = function (t) {
    var n = this;
    t !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = t, t ? (t.queryInfo = this, this.listeners.add(this.oqListener = function () {
      var r = n.getDiff();
      r.fromOptimisticTransaction ? t.observe() : gy(t);
    })) : delete this.oqListener);
  }, e.prototype.notify = function () {
    var t = this;
    lh(this), this.shouldNotify() && this.listeners.forEach(function (n) {
      return n(t);
    }), this.dirty = !1;
  }, e.prototype.shouldNotify = function () {
    if (!this.dirty || !this.listeners.size) return !1;
    if (ua(this.networkStatus) && this.observableQuery) {
      var t = this.observableQuery.options.fetchPolicy;
      if (t !== "cache-only" && t !== "cache-and-network") return !1;
    }
    return !0;
  }, e.prototype.stop = function () {
    if (!this.stopped) {
      this.stopped = !0, this.reset(), this.cancel(), this.cancel = e.prototype.cancel, this.subscriptions.forEach(function (n) {
        return n.unsubscribe();
      });
      var t = this.observableQuery;
      t && t.stopPolling();
    }
  }, e.prototype.cancel = function () {}, e.prototype.updateWatch = function (t) {
    var n = this;
    t === void 0 && (t = this.variables);
    var r = this.observableQuery;
    if (!(r && r.options.fetchPolicy === "no-cache")) {
      var a = _P2(_P2({}, this.getDiffOptions(t)), {
        watcher: this,
        callback: function callback(i) {
          return n.setDiff(i);
        }
      });
      (!this.lastWatch || !Qe(a, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = a));
    }
  }, e.prototype.resetLastWrite = function () {
    this.lastWrite = void 0;
  }, e.prototype.shouldWrite = function (t, n) {
    var r = this.lastWrite;
    return !(r && r.dmCount === cr.get(this.cache) && Qe(n, r.variables) && Qe(t.data, r.result.data));
  }, e.prototype.markResult = function (t, n, r, a) {
    var i = this,
      o = new wn(),
      s = Ct(t.errors) ? t.errors.slice(0) : [];
    if (this.reset(), "incremental" in t && Ct(t.incremental)) {
      var u = Wv(this.getDiff().result, t);
      t.data = u;
    } else if ("hasNext" in t && t.hasNext) {
      var l = this.getDiff();
      t.data = o.merge(l.result, t.data);
    }
    this.graphQLErrors = s, r.fetchPolicy === "no-cache" ? this.updateLastDiff({
      result: t.data,
      complete: !0
    }, this.getDiffOptions(r.variables)) : a !== 0 && (Cu(t, r.errorPolicy) ? this.cache.performTransaction(function (c) {
      if (i.shouldWrite(t, r.variables)) c.writeQuery({
        query: n,
        data: t.data,
        variables: r.variables,
        overwrite: a === 1
      }), i.lastWrite = {
        result: t,
        variables: r.variables,
        dmCount: cr.get(i.cache)
      };else if (i.lastDiff && i.lastDiff.diff.complete) {
        t.data = i.lastDiff.diff.result;
        return;
      }
      var f = i.getDiffOptions(r.variables),
        h = c.diff(f);
      i.stopped || i.updateWatch(r.variables), i.updateLastDiff(h, f), h.complete && (t.data = h.result);
    }) : this.lastWrite = void 0);
  }, e.prototype.markReady = function () {
    return this.networkError = null, this.networkStatus = Re.ready;
  }, e.prototype.markError = function (t) {
    return this.networkStatus = Re.error, this.lastWrite = void 0, this.reset(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
  }, e;
}();
function Cu(e, t) {
  t === void 0 && (t = "none");
  var n = t === "ignore" || t === "all",
    r = !ni(e);
  return !r && n && e.data && (r = !0), r;
}
var fS = Object.prototype.hasOwnProperty,
  dS = function () {
    function e(t) {
      var n = t.cache,
        r = t.link,
        a = t.defaultOptions,
        i = t.queryDeduplication,
        o = i === void 0 ? !1 : i,
        s = t.onBroadcast,
        u = t.ssrMode,
        l = u === void 0 ? !1 : u,
        c = t.clientAwareness,
        f = c === void 0 ? {} : c,
        h = t.localState,
        p = t.assumeImmutableResults;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */new Map(), this.fetchCancelFns = /* @__PURE__ */new Map(), this.transformCache = new (xn ? WeakMap : Map)(), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = /* @__PURE__ */new Map(), this.cache = n, this.link = r, this.defaultOptions = a || /* @__PURE__ */Object.create(null), this.queryDeduplication = o, this.clientAwareness = f, this.localState = h || new _y({
        cache: n
      }), this.ssrMode = l, this.assumeImmutableResults = !!p, (this.onBroadcast = s) && (this.mutationStore = /* @__PURE__ */Object.create(null));
    }
    return e.prototype.stop = function () {
      var t = this;
      this.queries.forEach(function (n, r) {
        t.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(__DEV__ ? new Ne("QueryManager stopped while query was in flight") : new Ne(13));
    }, e.prototype.cancelPendingFetches = function (t) {
      this.fetchCancelFns.forEach(function (n) {
        return n(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function (t) {
      var n,
        r,
        a = t.mutation,
        i = t.variables,
        o = t.optimisticResponse,
        s = t.updateQueries,
        u = t.refetchQueries,
        l = u === void 0 ? [] : u,
        c = t.awaitRefetchQueries,
        f = c === void 0 ? !1 : c,
        h = t.update,
        p = t.onQueryUpdated,
        v = t.fetchPolicy,
        m = v === void 0 ? ((n = this.defaultOptions.mutate) === null || n === void 0 ? void 0 : n.fetchPolicy) || "network-only" : v,
        g = t.errorPolicy,
        b = g === void 0 ? ((r = this.defaultOptions.mutate) === null || r === void 0 ? void 0 : r.errorPolicy) || "none" : g,
        y = t.keepRootFields,
        E = t.context;
      return mn(this, void 0, void 0, function () {
        var w, _, C, D, U, Z;
        return vn(this, function (me) {
          switch (me.label) {
            case 0:
              return __DEV__ ? te(a, "mutation option is required. You must specify your GraphQL document in the mutation option.") : te(a, 14), __DEV__ ? te(m === "network-only" || m === "no-cache", "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : te(m === "network-only" || m === "no-cache", 15), w = this.generateMutationId(), _ = this.transform(a), C = _.document, D = _.hasClientExports, a = this.cache.transformForLink(C), i = this.getVariables(a, i), D ? [4, this.localState.addExportedVariables(a, i, E)] : [3, 2];
            case 1:
              i = me.sent(), me.label = 2;
            case 2:
              return U = this.mutationStore && (this.mutationStore[w] = {
                mutation: a,
                variables: i,
                loading: !0,
                error: null
              }), o && this.markMutationOptimistic(o, {
                mutationId: w,
                document: a,
                variables: i,
                fetchPolicy: m,
                errorPolicy: b,
                context: E,
                updateQueries: s,
                update: h,
                keepRootFields: y
              }), this.broadcastQueries(), Z = this, [2, new Promise(function (ye, Y) {
                return Os(Z.getObservableFromLink(a, _P2(_P2({}, E), {
                  optimisticResponse: o
                }), i, !1), function (K) {
                  if (ni(K) && b === "none") throw new an({
                    graphQLErrors: yu(K)
                  });
                  U && (U.loading = !1, U.error = null);
                  var ee = _P2({}, K);
                  return typeof l == "function" && (l = l(ee)), b === "ignore" && ni(ee) && delete ee.errors, Z.markMutationResult({
                    mutationId: w,
                    result: ee,
                    document: a,
                    variables: i,
                    fetchPolicy: m,
                    errorPolicy: b,
                    context: E,
                    update: h,
                    updateQueries: s,
                    awaitRefetchQueries: f,
                    refetchQueries: l,
                    removeOptimistic: o ? w : void 0,
                    onQueryUpdated: p,
                    keepRootFields: y
                  });
                }).subscribe({
                  next: function next(K) {
                    Z.broadcastQueries(), (!("hasNext" in K) || K.hasNext === !1) && ye(K);
                  },
                  error: function error(K) {
                    U && (U.loading = !1, U.error = K), o && Z.cache.removeOptimistic(w), Z.broadcastQueries(), Y(K instanceof an ? K : new an({
                      networkError: K
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function (t, n) {
      var r = this;
      n === void 0 && (n = this.cache);
      var a = t.result,
        i = [],
        o = t.fetchPolicy === "no-cache";
      if (!o && Cu(a, t.errorPolicy)) {
        if (mr(a) || i.push({
          result: a.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), mr(a) && Ct(a.incremental)) {
          var s = n.diff({
              id: "ROOT_MUTATION",
              query: this.transform(t.document).asQuery,
              variables: t.variables,
              optimistic: !1,
              returnPartialData: !0
            }),
            u = Wv(s.result, a);
          typeof u < "u" && (a.data = u, i.push({
            result: u,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var l = t.updateQueries;
        l && this.queries.forEach(function (f, h) {
          var p = f.observableQuery,
            v = p && p.queryName;
          if (!(!v || !fS.call(l, v))) {
            var m = l[v],
              g = r.queries.get(h),
              b = g.document,
              y = g.variables,
              E = n.diff({
                query: b,
                variables: y,
                returnPartialData: !0,
                optimistic: !1
              }),
              w = E.result,
              _ = E.complete;
            if (_ && w) {
              var C = m(w, {
                mutationResult: a,
                queryName: b && hu(b) || void 0,
                queryVariables: y
              });
              C && i.push({
                result: C,
                dataId: "ROOT_QUERY",
                query: b,
                variables: y
              });
            }
          }
        });
      }
      if (i.length > 0 || t.refetchQueries || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function updateCache(f) {
            o || i.forEach(function (m) {
              return f.write(m);
            });
            var h = t.update,
              p = !F0(a) || mr(a) && !a.hasNext;
            if (h) {
              if (!o) {
                var v = f.diff({
                  id: "ROOT_MUTATION",
                  query: r.transform(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                v.complete && (a = _P2(_P2({}, a), {
                  data: v.result
                }), "incremental" in a && delete a.incremental, "hasNext" in a && delete a.hasNext);
              }
              p && h(f, a, {
                context: t.context,
                variables: t.variables
              });
            }
            !o && !t.keepRootFields && p && f.modify({
              id: "ROOT_MUTATION",
              fields: function fields(m, g) {
                var b = g.fieldName,
                  y = g.DELETE;
                return b === "__typename" ? m : y;
              }
            });
          },
          include: t.refetchQueries,
          optimistic: !1,
          removeOptimistic: t.removeOptimistic,
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function (f) {
          return c.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated) return Promise.all(c).then(function () {
          return a;
        });
      }
      return Promise.resolve(a);
    }, e.prototype.markMutationOptimistic = function (t, n) {
      var r = this,
        a = typeof t == "function" ? t(n.variables) : t;
      return this.cache.recordOptimisticTransaction(function (i) {
        try {
          r.markMutationResult(_P2(_P2({}, n), {
            result: {
              data: a
            }
          }), i);
        } catch (o) {
          __DEV__ && te.error(o);
        }
      }, n.mutationId);
    }, e.prototype.fetchQuery = function (t, n, r) {
      return this.fetchQueryObservable(t, n, r).promise;
    }, e.prototype.getQueryStore = function () {
      var t = /* @__PURE__ */Object.create(null);
      return this.queries.forEach(function (n, r) {
        t[r] = {
          variables: n.variables,
          networkStatus: n.networkStatus,
          networkError: n.networkError,
          graphQLErrors: n.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function (t) {
      var n = this.queries.get(t);
      n && (n.networkError = void 0, n.graphQLErrors = []);
    }, e.prototype.transform = function (t) {
      var n = this.transformCache;
      if (!n.has(t)) {
        var r = this.cache.transformDocument(t),
          a = p0(r),
          i = this.localState.clientQuery(r),
          o = a && this.localState.serverQuery(a),
          s = {
            document: r,
            hasClientExports: Qw(r),
            hasForcedResolvers: this.localState.shouldForceResolvers(r),
            clientQuery: i,
            serverQuery: o,
            defaultVars: zc(_a(r)),
            asQuery: _P2(_P2({}, r), {
              definitions: r.definitions.map(function (l) {
                return l.kind === "OperationDefinition" && l.operation !== "query" ? _P2(_P2({}, l), {
                  operation: "query"
                }) : l;
              })
            })
          },
          u = function u(l) {
            l && !n.has(l) && n.set(l, s);
          };
        u(t), u(r), u(i), u(o);
      }
      return n.get(t);
    }, e.prototype.getVariables = function (t, n) {
      return _P2(_P2({}, this.transform(t).defaultVars), n);
    }, e.prototype.watchQuery = function (t) {
      t = _P2(_P2({}, t), {
        variables: this.getVariables(t.query, t.variables)
      }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var n = new Rs(this),
        r = new $u({
          queryManager: this,
          queryInfo: n,
          options: t
        });
      return this.queries.set(r.queryId, n), n.init({
        document: r.query,
        observableQuery: r,
        variables: r.variables
      }), r;
    }, e.prototype.query = function (t, n) {
      var r = this;
      return n === void 0 && (n = this.generateQueryId()), __DEV__ ? te(t.query, "query option is required. You must specify your GraphQL document in the query option.") : te(t.query, 16), __DEV__ ? te(t.query.kind === "Document", 'You must wrap the query string in a "gql" tag.') : te(t.query.kind === "Document", 17), __DEV__ ? te(!t.returnPartialData, "returnPartialData option only supported on watchQuery.") : te(!t.returnPartialData, 18), __DEV__ ? te(!t.pollInterval, "pollInterval option only supported on watchQuery.") : te(!t.pollInterval, 19), this.fetchQuery(n, t).finally(function () {
        return r.stopQuery(n);
      });
    }, e.prototype.generateQueryId = function () {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function () {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function () {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function (t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function (t) {
      var n = this.queries.get(t);
      n && n.stop();
    }, e.prototype.clearStore = function (t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(__DEV__ ? new Ne("Store reset while query was in flight (not completed in link chain)") : new Ne(20)), this.queries.forEach(function (n) {
        n.observableQuery ? n.networkStatus = Re.loading : n.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function (t) {
      var n = this;
      t === void 0 && (t = "active");
      var r = /* @__PURE__ */new Map(),
        a = /* @__PURE__ */new Map(),
        i = /* @__PURE__ */new Set();
      return Array.isArray(t) && t.forEach(function (o) {
        typeof o == "string" ? a.set(o, !1) : Zw(o) ? a.set(n.transform(o).document, !1) : it(o) && o.query && i.add(o);
      }), this.queries.forEach(function (o, s) {
        var u = o.observableQuery,
          l = o.document;
        if (u) {
          if (t === "all") {
            r.set(s, u);
            return;
          }
          var c = u.queryName,
            f = u.options.fetchPolicy;
          if (f === "standby" || t === "active" && !u.hasObservers()) return;
          (t === "active" || c && a.has(c) || l && a.has(l)) && (r.set(s, u), c && a.set(c, !0), l && a.set(l, !0));
        }
      }), i.size && i.forEach(function (o) {
        var s = gu("legacyOneTimeQuery"),
          u = n.getQuery(s).init({
            document: o.query,
            variables: o.variables
          }),
          l = new $u({
            queryManager: n,
            queryInfo: u,
            options: _P2(_P2({}, o), {
              fetchPolicy: "network-only"
            })
          });
        te(l.queryId === s), u.setObservableQuery(l), r.set(s, l);
      }), __DEV__ && a.size && a.forEach(function (o, s) {
        o || __DEV__ && te.warn("Unknown query ".concat(typeof s == "string" ? "named " : "").concat(JSON.stringify(s, null, 2), " requested in refetchQueries options.include array"));
      }), r;
    }, e.prototype.reFetchObservableQueries = function (t) {
      var n = this;
      t === void 0 && (t = !1);
      var r = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function (a, i) {
        var o = a.options.fetchPolicy;
        a.resetLastResults(), (t || o !== "standby" && o !== "cache-only") && r.push(a.refetch()), n.getQuery(i).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, e.prototype.setObservableQuery = function (t) {
      this.getQuery(t.queryId).setObservableQuery(t);
    }, e.prototype.startGraphQLSubscription = function (t) {
      var n = this,
        r = t.query,
        a = t.fetchPolicy,
        i = t.errorPolicy,
        o = t.variables,
        s = t.context,
        u = s === void 0 ? {} : s;
      r = this.transform(r).document, o = this.getVariables(r, o);
      var l = function l(f) {
        return n.getObservableFromLink(r, u, f).map(function (h) {
          if (a !== "no-cache" && (Cu(h, i) && n.cache.write({
            query: r,
            result: h.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: f
          }), n.broadcastQueries()), ni(h)) throw new an({
            graphQLErrors: h.errors
          });
          return h;
        });
      };
      if (this.transform(r).hasClientExports) {
        var c = this.localState.addExportedVariables(r, o, u).then(l);
        return new Ye(function (f) {
          var h = null;
          return c.then(function (p) {
            return h = p.subscribe(f);
          }, f.error), function () {
            return h && h.unsubscribe();
          };
        });
      }
      return l(o);
    }, e.prototype.stopQuery = function (t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function (t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function (t) {
      this.fetchCancelFns.delete(t), this.queries.has(t) && (this.getQuery(t).stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function () {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function (t) {
        return t.notify();
      });
    }, e.prototype.getLocalState = function () {
      return this.localState;
    }, e.prototype.getObservableFromLink = function (t, n, r, a) {
      var i = this,
        o;
      a === void 0 && (a = (o = n == null ? void 0 : n.queryDeduplication) !== null && o !== void 0 ? o : this.queryDeduplication);
      var s,
        u = this.transform(t).serverQuery;
      if (u) {
        var l = this,
          c = l.inFlightLinkObservables,
          f = l.link,
          h = {
            query: u,
            variables: r,
            operationName: hu(u) || void 0,
            context: this.prepareContext(_P2(_P2({}, n), {
              forceFetch: !a
            }))
          };
        if (n = h.context, a) {
          var p = c.get(u) || /* @__PURE__ */new Map();
          c.set(u, p);
          var v = jn(r);
          if (s = p.get(v), !s) {
            var m = new Gr([_u(f, h)]);
            p.set(v, s = m), m.beforeNext(function () {
              p.delete(v) && p.size < 1 && c.delete(u);
            });
          }
        } else s = new Gr([_u(f, h)]);
      } else s = new Gr([Ye.of({
        data: {}
      })]), n = this.prepareContext(n);
      var g = this.transform(t).clientQuery;
      return g && (s = Os(s, function (b) {
        return i.localState.runResolvers({
          document: g,
          remoteResult: b,
          context: n,
          variables: r
        });
      })), s;
    }, e.prototype.getResultsFromLink = function (t, n, r) {
      var a = t.lastRequestId = this.generateRequestId(),
        i = this.cache.transformForLink(this.transform(t.document).document);
      return Os(this.getObservableFromLink(i, r.context, r.variables), function (o) {
        var s = yu(o),
          u = s.length > 0;
        if (a >= t.lastRequestId) {
          if (u && r.errorPolicy === "none") throw t.markError(new an({
            graphQLErrors: s
          }));
          t.markResult(o, i, r, n), t.markReady();
        }
        var l = {
          data: o.data,
          loading: !1,
          networkStatus: Re.ready
        };
        return u && r.errorPolicy !== "ignore" && (l.errors = s, l.networkStatus = Re.error), l;
      }, function (o) {
        var s = oS(o) ? o : new an({
          networkError: o
        });
        throw a >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchQueryObservable = function (t, n, r) {
      var a = this;
      r === void 0 && (r = Re.loading);
      var i = this.transform(n.query).document,
        o = this.getVariables(i, n.variables),
        s = this.getQuery(t),
        u = this.defaultOptions.watchQuery,
        l = n.fetchPolicy,
        c = l === void 0 ? u && u.fetchPolicy || "cache-first" : l,
        f = n.errorPolicy,
        h = f === void 0 ? u && u.errorPolicy || "none" : f,
        p = n.returnPartialData,
        v = p === void 0 ? !1 : p,
        m = n.notifyOnNetworkStatusChange,
        g = m === void 0 ? !1 : m,
        b = n.context,
        y = b === void 0 ? {} : b,
        E = Object.assign({}, n, {
          query: i,
          variables: o,
          fetchPolicy: c,
          errorPolicy: h,
          returnPartialData: v,
          notifyOnNetworkStatusChange: g,
          context: y
        }),
        w = function w(D) {
          E.variables = D;
          var U = a.fetchQueryByPolicy(s, E, r);
          return E.fetchPolicy !== "standby" && U.length > 0 && s.observableQuery && s.observableQuery.applyNextFetchPolicy("after-fetch", n), U;
        },
        _ = function _() {
          return a.fetchCancelFns.delete(t);
        };
      this.fetchCancelFns.set(t, function (D) {
        _(), setTimeout(function () {
          return C.cancel(D);
        });
      });
      var C = new Gr(this.transform(E.query).hasClientExports ? this.localState.addExportedVariables(E.query, E.variables, E.context).then(w) : w(E.variables));
      return C.promise.then(_, _), C;
    }, e.prototype.refetchQueries = function (t) {
      var n = this,
        r = t.updateCache,
        a = t.include,
        i = t.optimistic,
        o = i === void 0 ? !1 : i,
        s = t.removeOptimistic,
        u = s === void 0 ? o ? gu("refetchQueries") : void 0 : s,
        l = t.onQueryUpdated,
        c = /* @__PURE__ */new Map();
      a && this.getObservableQueries(a).forEach(function (h, p) {
        c.set(p, {
          oq: h,
          lastDiff: n.getQuery(p).getDiff()
        });
      });
      var f = /* @__PURE__ */new Map();
      return r && this.cache.batch({
        update: r,
        optimistic: o && u || !1,
        removeOptimistic: u,
        onWatchUpdated: function onWatchUpdated(h, p, v) {
          var m = h.watcher instanceof Rs && h.watcher.observableQuery;
          if (m) {
            if (l) {
              c.delete(m.queryId);
              var g = l(m, p, v);
              return g === !0 && (g = m.refetch()), g !== !1 && f.set(m, g), g;
            }
            l !== null && c.set(m.queryId, {
              oq: m,
              lastDiff: v,
              diff: p
            });
          }
        }
      }), c.size && c.forEach(function (h, p) {
        var v = h.oq,
          m = h.lastDiff,
          g = h.diff,
          b;
        if (l) {
          if (!g) {
            var y = v.queryInfo;
            y.reset(), g = y.getDiff();
          }
          b = l(v, g, m);
        }
        (!l || b === !0) && (b = v.refetch()), b !== !1 && f.set(v, b), p.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(p);
      }), u && this.cache.removeOptimistic(u), f;
    }, e.prototype.fetchQueryByPolicy = function (t, n, r) {
      var a = this,
        i = n.query,
        o = n.variables,
        s = n.fetchPolicy,
        u = n.refetchWritePolicy,
        l = n.errorPolicy,
        c = n.returnPartialData,
        f = n.context,
        h = n.notifyOnNetworkStatusChange,
        p = t.networkStatus;
      t.init({
        document: this.transform(i).document,
        variables: o,
        networkStatus: r
      });
      var v = function v() {
          return t.getDiff(o);
        },
        m = function m(w, _) {
          _ === void 0 && (_ = t.networkStatus || Re.loading);
          var C = w.result;
          __DEV__ && !c && !Qe(C, {}) && by(w.missing);
          var D = function D(U) {
            return Ye.of(_P2({
              data: U,
              loading: ua(_),
              networkStatus: _
            }, w.complete ? null : {
              partial: !0
            }));
          };
          return C && a.transform(i).hasForcedResolvers ? a.localState.runResolvers({
            document: i,
            remoteResult: {
              data: C
            },
            context: f,
            variables: o,
            onlyRunForcedResolvers: !0
          }).then(function (U) {
            return D(U.data || void 0);
          }) : l === "none" && _ === Re.refetch && Array.isArray(w.missing) ? D(void 0) : D(C);
        },
        g = s === "no-cache" ? 0 : r === Re.refetch && u !== "merge" ? 1 : 2,
        b = function b() {
          return a.getResultsFromLink(t, g, {
            variables: o,
            context: f,
            fetchPolicy: s,
            errorPolicy: l
          });
        },
        y = h && typeof p == "number" && p !== r && ua(r);
      switch (s) {
        default:
        case "cache-first":
          {
            var E = v();
            return E.complete ? [m(E, t.markReady())] : c || y ? [m(E), b()] : [b()];
          }
        case "cache-and-network":
          {
            var E = v();
            return E.complete || c || y ? [m(E), b()] : [b()];
          }
        case "cache-only":
          return [m(v(), t.markReady())];
        case "network-only":
          return y ? [m(v()), b()] : [b()];
        case "no-cache":
          return y ? [m(t.getDiff()), b()] : [b()];
        case "standby":
          return [];
      }
    }, e.prototype.getQuery = function (t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Rs(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function (t) {
      t === void 0 && (t = {});
      var n = this.localState.prepareContext(t);
      return _P2(_P2({}, n), {
        clientAwareness: this.clientAwareness
      });
    }, e;
  }(),
  ch = !1,
  hS = function () {
    function e(t) {
      var n = this;
      this.resetStoreCallbacks = [], this.clearStoreCallbacks = [];
      var r = t.uri,
        a = t.credentials,
        i = t.headers,
        o = t.cache,
        s = t.ssrMode,
        u = s === void 0 ? !1 : s,
        l = t.ssrForceFetchDelay,
        c = l === void 0 ? 0 : l,
        f = t.connectToDevTools,
        h = f === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && __DEV__ : f,
        p = t.queryDeduplication,
        v = p === void 0 ? !0 : p,
        m = t.defaultOptions,
        g = t.assumeImmutableResults,
        b = g === void 0 ? !1 : g,
        y = t.resolvers,
        E = t.typeDefs,
        w = t.fragmentMatcher,
        _ = t.name,
        C = t.version,
        D = t.link;
      if (D || (D = r ? new vO({
        uri: r,
        credentials: a,
        headers: i
      }) : Oa.empty()), !o) throw __DEV__ ? new Ne("To initialize Apollo Client, you must specify a 'cache' property in the options object. \nFor more information, please visit: https://go.apollo.dev/c/docs") : new Ne(9);
      if (this.link = D, this.cache = o, this.disableNetworkFetches = u || c > 0, this.queryDeduplication = v, this.defaultOptions = m || /* @__PURE__ */Object.create(null), this.typeDefs = E, c && setTimeout(function () {
        return n.disableNetworkFetches = !1;
      }, c), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), h && typeof window == "object" && (window.__APOLLO_CLIENT__ = this), !ch && h && __DEV__ && (ch = !0, typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__)) {
        var U = window.navigator,
          Z = U && U.userAgent,
          me = void 0;
        typeof Z == "string" && (Z.indexOf("Chrome/") > -1 ? me = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : Z.indexOf("Firefox/") > -1 && (me = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), me && __DEV__ && te.log("Download the Apollo DevTools for a better development experience: " + me);
      }
      this.version = U0, this.localState = new _y({
        cache: o,
        client: this,
        resolvers: y,
        fragmentMatcher: w
      }), this.queryManager = new dS({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        queryDeduplication: v,
        ssrMode: u,
        clientAwareness: {
          name: _,
          version: C
        },
        localState: this.localState,
        assumeImmutableResults: b,
        onBroadcast: h ? function () {
          n.devToolsHookCb && n.devToolsHookCb({
            action: {},
            state: {
              queries: n.queryManager.getQueryStore(),
              mutations: n.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: n.cache.extract(!0)
          });
        } : void 0
      });
    }
    return e.prototype.stop = function () {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function (t) {
      return this.defaultOptions.watchQuery && (t = Jr(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = _P2(_P2({}, t), {
        fetchPolicy: "cache-first"
      })), this.queryManager.watchQuery(t);
    }, e.prototype.query = function (t) {
      return this.defaultOptions.query && (t = Jr(this.defaultOptions.query, t)), __DEV__ ? te(t.fetchPolicy !== "cache-and-network", "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only.") : te(t.fetchPolicy !== "cache-and-network", 10), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = _P2(_P2({}, t), {
        fetchPolicy: "cache-first"
      })), this.queryManager.query(t);
    }, e.prototype.mutate = function (t) {
      return this.defaultOptions.mutate && (t = Jr(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function (t) {
      return this.queryManager.startGraphQLSubscription(t);
    }, e.prototype.readQuery = function (t, n) {
      return n === void 0 && (n = !1), this.cache.readQuery(t, n);
    }, e.prototype.readFragment = function (t, n) {
      return n === void 0 && (n = !1), this.cache.readFragment(t, n);
    }, e.prototype.writeQuery = function (t) {
      this.cache.writeQuery(t), this.queryManager.broadcastQueries();
    }, e.prototype.writeFragment = function (t) {
      this.cache.writeFragment(t), this.queryManager.broadcastQueries();
    }, e.prototype.__actionHookForDevTools = function (t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function (t) {
      return _u(this.link, t);
    }, e.prototype.resetStore = function () {
      var t = this;
      return Promise.resolve().then(function () {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function () {
        return Promise.all(t.resetStoreCallbacks.map(function (n) {
          return n();
        }));
      }).then(function () {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function () {
      var t = this;
      return Promise.resolve().then(function () {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function () {
        return Promise.all(t.clearStoreCallbacks.map(function (n) {
          return n();
        }));
      });
    }, e.prototype.onResetStore = function (t) {
      var n = this;
      return this.resetStoreCallbacks.push(t), function () {
        n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function (r) {
          return r !== t;
        });
      };
    }, e.prototype.onClearStore = function (t) {
      var n = this;
      return this.clearStoreCallbacks.push(t), function () {
        n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function (r) {
          return r !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function (t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function (t) {
      var n = this.queryManager.refetchQueries(t),
        r = [],
        a = [];
      n.forEach(function (o, s) {
        r.push(s), a.push(o);
      });
      var i = Promise.all(a);
      return i.queries = r, i.results = a, i.catch(function (o) {
        __DEV__ && te.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(o));
      }), i;
    }, e.prototype.getObservableQueries = function (t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function (t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function (t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function (t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function (t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function () {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function (t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function (t) {
      this.link = this.queryManager.link = t;
    }, e;
  }(),
  ai = /* @__PURE__ */new Map(),
  Ru = /* @__PURE__ */new Map(),
  wy = !0,
  Qi = !1;
function Oy(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function pS(e) {
  return Oy(e.source.body.substring(e.start, e.end));
}
function mS(e) {
  var t = /* @__PURE__ */new Set(),
    n = [];
  return e.definitions.forEach(function (r) {
    if (r.kind === "FragmentDefinition") {
      var a = r.name.value,
        i = pS(r.loc),
        o = Ru.get(a);
      o && !o.has(i) ? wy && console.warn("Warning: fragment with name " + a + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names") : o || Ru.set(a, o = /* @__PURE__ */new Set()), o.add(i), t.has(i) || (t.add(i), n.push(r));
    } else n.push(r);
  }), _P2(_P2({}, e), {
    definitions: n
  });
}
function vS(e) {
  var t = new Set(e.definitions);
  t.forEach(function (r) {
    r.loc && delete r.loc, Object.keys(r).forEach(function (a) {
      var i = r[a];
      i && typeof i == "object" && t.add(i);
    });
  });
  var n = e.loc;
  return n && (delete n.startToken, delete n.endToken), e;
}
function yS(e) {
  var t = Oy(e);
  if (!ai.has(t)) {
    var n = jw(e, {
      experimentalFragmentVariables: Qi,
      allowLegacyFragmentVariables: Qi
    });
    if (!n || n.kind !== "Document") throw new Error("Not a valid GraphQL document.");
    ai.set(t, vS(mS(n)));
  }
  return ai.get(t);
}
function wt(e) {
  for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
  typeof e == "string" && (e = [e]);
  var r = e[0];
  return t.forEach(function (a, i) {
    a && a.kind === "Document" ? r += a.loc.source.body : r += a, r += e[i + 1];
  }), yS(r);
}
function gS() {
  ai.clear(), Ru.clear();
}
function bS() {
  wy = !1;
}
function _S() {
  Qi = !0;
}
function wS() {
  Qi = !1;
}
var qr = {
  gql: wt,
  resetCaches: gS,
  disableFragmentWarnings: bS,
  enableExperimentalFragmentVariables: _S,
  disableExperimentalFragmentVariables: wS
};
(function (e) {
  e.gql = qr.gql, e.resetCaches = qr.resetCaches, e.disableFragmentWarnings = qr.disableFragmentWarnings, e.enableExperimentalFragmentVariables = qr.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = qr.disableExperimentalFragmentVariables;
})(wt || (wt = {}));
wt.default = wt;
var fh = Xc ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function lf() {
  var e = React__namespace.createContext[fh];
  return e || (Object.defineProperty(React__namespace.createContext, fh, {
    value: e = React__namespace.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), e.displayName = "ApolloContext"), e;
}
var OS = function OS(e) {
  var t = e.client,
    n = e.children,
    r = lf();
  return React__namespace.createElement(r.Consumer, null, function (a) {
    return a === void 0 && (a = {}), t && a.client !== t && (a = Object.assign({}, a, {
      client: t
    })), __DEV__ ? te(a.client, 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.') : te(a.client, 28), React__namespace.createElement(r.Provider, {
      value: a
    }, n);
  });
};
function Sy(e) {
  var t = React.useContext(lf()),
    n = e || t.client;
  return __DEV__ ? te(!!n, 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.') : te(!!n, 31), n;
}
var dh = !1,
  SS = "useSyncExternalStore",
  ES = React__namespace[SS],
  PS = ES || function (e, t, n) {
    var r = t();
    __DEV__ && !dh && r !== t() && (dh = !0, __DEV__ && te.error("The result of getSnapshot should be cached to avoid an infinite loop"));
    var a = React__namespace.useState({
        inst: {
          value: r,
          getSnapshot: t
        }
      }),
      i = a[0].inst,
      o = a[1];
    return I0 ? React__namespace.useLayoutEffect(function () {
      Object.assign(i, {
        value: r,
        getSnapshot: t
      }), Ns(i) && o({
        inst: i
      });
    }, [e, r, t]) : Object.assign(i, {
      value: r,
      getSnapshot: t
    }), React__namespace.useEffect(function () {
      return Ns(i) && o({
        inst: i
      }), e(function () {
        Ns(i) && o({
          inst: i
        });
      });
    }, [e]), r;
  };
function Ns(e) {
  var t = e.value,
    n = e.getSnapshot;
  try {
    return t !== n();
  } catch (_unused10) {
    return !0;
  }
}
var Jt;
(function (e) {
  e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
})(Jt || (Jt = {}));
var hh = /* @__PURE__ */new Map();
function ph(e) {
  var t;
  switch (e) {
    case Jt.Query:
      t = "Query";
      break;
    case Jt.Mutation:
      t = "Mutation";
      break;
    case Jt.Subscription:
      t = "Subscription";
      break;
  }
  return t;
}
function TS(e) {
  var t = hh.get(e);
  if (t) return t;
  var n, r, a;
  __DEV__ ? te(!!e && !!e.kind, "Argument of ".concat(e, " passed to parser was not a valid GraphQL ") + "DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document") : te(!!e && !!e.kind, 32);
  for (var i = [], o = [], s = [], u = [], l = 0, c = e.definitions; l < c.length; l++) {
    var f = c[l];
    if (f.kind === "FragmentDefinition") {
      i.push(f);
      continue;
    }
    if (f.kind === "OperationDefinition") switch (f.operation) {
      case "query":
        o.push(f);
        break;
      case "mutation":
        s.push(f);
        break;
      case "subscription":
        u.push(f);
        break;
    }
  }
  __DEV__ ? te(!i.length || o.length || s.length || u.length, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well") : te(!i.length || o.length || s.length || u.length, 33), __DEV__ ? te(o.length + s.length + u.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + "".concat(e, " had ").concat(o.length, " queries, ").concat(u.length, " ") + "subscriptions and ".concat(s.length, " mutations. ") + "You can use 'compose' to join multiple operation types to a component") : te(o.length + s.length + u.length <= 1, 34), r = o.length ? Jt.Query : Jt.Mutation, !o.length && !s.length && (r = Jt.Subscription);
  var h = o.length ? o : s.length ? s : u;
  __DEV__ ? te(h.length === 1, "react-apollo only supports one definition per HOC. ".concat(e, " had ") + "".concat(h.length, " definitions. ") + "You can use 'compose' to join multiple operation types to a component") : te(h.length === 1, 35);
  var p = h[0];
  n = p.variableDefinitions || [], p.name && p.name.kind === "Name" ? a = p.name.value : a = "data";
  var v = {
    name: a,
    type: r,
    variables: n
  };
  return hh.set(e, v), v;
}
function Ey(e, t) {
  var n = TS(e),
    r = ph(t),
    a = ph(n.type);
  __DEV__ ? te(n.type === t, "Running a ".concat(r, " requires a graphql ") + "".concat(r, ", but a ").concat(a, " was used instead.")) : te(n.type === t, 36);
}
var kS = Object.prototype.hasOwnProperty;
function ln(e, t) {
  return t === void 0 && (t = /* @__PURE__ */Object.create(null)), DS(Sy(t.client), e).useQuery(t);
}
function DS(e, t) {
  var n = React.useRef();
  (!n.current || e !== n.current.client || t !== n.current.query) && (n.current = new xS(e, t, n.current));
  var r = n.current,
    a = React.useState(0);
  a[0];
  var i = a[1];
  return r.forceUpdate = function () {
    i(function (o) {
      return o + 1;
    });
  }, r;
}
var xS = function () {
  function e(t, n, r) {
    this.client = t, this.query = n, this.asyncResolveFns = /* @__PURE__ */new Set(), this.optionsToIgnoreOnce = new (zv ? WeakSet : Set)(), this.ssrDisabledResult = ia({
      loading: !0,
      data: void 0,
      error: void 0,
      networkStatus: Re.loading
    }), this.skipStandbyResult = ia({
      loading: !1,
      data: void 0,
      error: void 0,
      networkStatus: Re.ready
    }), this.toQueryResultCache = new (xn ? WeakMap : Map)(), Ey(n, Jt.Query);
    var a = r && r.result,
      i = a && a.data;
    i && (this.previousData = i);
  }
  return e.prototype.forceUpdate = function () {
    __DEV__ && te.warn("Calling default no-op implementation of InternalState#forceUpdate");
  }, e.prototype.asyncUpdate = function (t) {
    var n = this;
    return new Promise(function (r, a) {
      var i = n.watchQueryOptions,
        o = function o() {
          n.asyncResolveFns.delete(r), n.optionsToIgnoreOnce.delete(i), t.removeEventListener("abort", o), a(t.reason);
        };
      n.asyncResolveFns.add(r), n.optionsToIgnoreOnce.add(i), t.addEventListener("abort", o), n.forceUpdate();
    });
  }, e.prototype.useQuery = function (t) {
    var n = this;
    this.renderPromises = React.useContext(lf()).renderPromises, this.useOptions(t);
    var r = this.useObservableQuery(),
      a = PS(React.useCallback(function () {
        if (n.renderPromises) return function () {};
        var o = function o() {
            var l = n.result,
              c = r.getCurrentResult();
            l && l.loading === c.loading && l.networkStatus === c.networkStatus && Qe(l.data, c.data) || n.setResult(c);
          },
          s = function s(l) {
            var c = r.last;
            u.unsubscribe();
            try {
              r.resetLastResults(), u = r.subscribe(o, s);
            } finally {
              r.last = c;
            }
            if (!kS.call(l, "graphQLErrors")) throw l;
            var f = n.result;
            (!f || f && f.loading || !Qe(l, f.error)) && n.setResult({
              data: f && f.data,
              error: l,
              loading: !1,
              networkStatus: Re.error
            });
          },
          u = r.subscribe(o, s);
        return function () {
          return u.unsubscribe();
        };
      }, [r, this.renderPromises, this.client.disableNetworkFetches]), function () {
        return n.getCurrentResult();
      }, function () {
        return n.getCurrentResult();
      });
    this.unsafeHandlePartialRefetch(a);
    var i = this.toQueryResult(a);
    return !i.loading && this.asyncResolveFns.size && (this.asyncResolveFns.forEach(function (o) {
      return o(i);
    }), this.asyncResolveFns.clear()), i;
  }, e.prototype.useOptions = function (t) {
    var n,
      r = this.createWatchQueryOptions(this.queryHookOptions = t),
      a = this.watchQueryOptions;
    (this.optionsToIgnoreOnce.has(a) || !Qe(r, a)) && (this.watchQueryOptions = r, a && this.observable && (this.optionsToIgnoreOnce.delete(a), this.observable.reobserve(this.getObsQueryOptions()), this.previousData = ((n = this.result) === null || n === void 0 ? void 0 : n.data) || this.previousData, this.result = void 0)), this.onCompleted = t.onCompleted || e.prototype.onCompleted, this.onError = t.onError || e.prototype.onError, (this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === !1 && !this.queryHookOptions.skip ? this.result = this.ssrDisabledResult : this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby" ? this.result = this.skipStandbyResult : (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) && (this.result = void 0);
  }, e.prototype.getObsQueryOptions = function () {
    var t = [],
      n = this.client.defaultOptions.watchQuery;
    return n && t.push(n), this.queryHookOptions.defaultOptions && t.push(this.queryHookOptions.defaultOptions), t.push(wa(this.observable && this.observable.options, this.watchQueryOptions)), t.reduce(Jr);
  }, e.prototype.createWatchQueryOptions = function (t) {
    var n;
    t === void 0 && (t = {});
    var r = t.skip;
    t.ssr, t.onCompleted, t.onError, t.defaultOptions;
    var a = Mt(t, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]),
      i = Object.assign(a, {
        query: this.query
      });
    if (this.renderPromises && (i.fetchPolicy === "network-only" || i.fetchPolicy === "cache-and-network") && (i.fetchPolicy = "cache-first"), i.variables || (i.variables = {}), r) {
      var o = i.fetchPolicy,
        s = o === void 0 ? this.getDefaultFetchPolicy() : o,
        u = i.initialFetchPolicy,
        l = u === void 0 ? s : u;
      Object.assign(i, {
        initialFetchPolicy: l,
        fetchPolicy: "standby"
      });
    } else i.fetchPolicy || (i.fetchPolicy = ((n = this.observable) === null || n === void 0 ? void 0 : n.options.initialFetchPolicy) || this.getDefaultFetchPolicy());
    return i;
  }, e.prototype.getDefaultFetchPolicy = function () {
    var t, n;
    return ((t = this.queryHookOptions.defaultOptions) === null || t === void 0 ? void 0 : t.fetchPolicy) || ((n = this.client.defaultOptions.watchQuery) === null || n === void 0 ? void 0 : n.fetchPolicy) || "cache-first";
  }, e.prototype.onCompleted = function (t) {}, e.prototype.onError = function (t) {}, e.prototype.useObservableQuery = function () {
    var t = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
    this.obsQueryFields = React.useMemo(function () {
      return {
        refetch: t.refetch.bind(t),
        reobserve: t.reobserve.bind(t),
        fetchMore: t.fetchMore.bind(t),
        updateQuery: t.updateQuery.bind(t),
        startPolling: t.startPolling.bind(t),
        stopPolling: t.stopPolling.bind(t),
        subscribeToMore: t.subscribeToMore.bind(t)
      };
    }, [t]);
    var n = !(this.queryHookOptions.ssr === !1 || this.queryHookOptions.skip);
    return this.renderPromises && n && (this.renderPromises.registerSSRObservable(t), t.getCurrentResult().loading && this.renderPromises.addObservableQueryPromise(t)), t;
  }, e.prototype.setResult = function (t) {
    var n = this.result;
    n && n.data && (this.previousData = n.data), this.result = t, this.forceUpdate(), this.handleErrorOrCompleted(t);
  }, e.prototype.handleErrorOrCompleted = function (t) {
    var n = this;
    if (!t.loading) {
      var r = this.toApolloError(t);
      Promise.resolve().then(function () {
        r ? n.onError(r) : t.data && n.onCompleted(t.data);
      }).catch(function (a) {
        __DEV__ && te.warn(a);
      });
    }
  }, e.prototype.toApolloError = function (t) {
    return Ct(t.errors) ? new an({
      graphQLErrors: t.errors
    }) : t.error;
  }, e.prototype.getCurrentResult = function () {
    return this.result || this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult()), this.result;
  }, e.prototype.toQueryResult = function (t) {
    var n = this.toQueryResultCache.get(t);
    if (n) return n;
    var r = t.data;
    t.partial;
    var a = Mt(t, ["data", "partial"]);
    return this.toQueryResultCache.set(t, n = _P2(_P2(_P2({
      data: r
    }, a), this.obsQueryFields), {
      client: this.client,
      observable: this.observable,
      variables: this.observable.variables,
      called: !this.queryHookOptions.skip,
      previousData: this.previousData
    })), !n.error && Ct(t.errors) && (n.error = new an({
      graphQLErrors: t.errors
    })), n;
  }, e.prototype.unsafeHandlePartialRefetch = function (t) {
    t.partial && this.queryHookOptions.partialRefetch && !t.loading && (!t.data || Object.keys(t.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only" && (Object.assign(t, {
      loading: !0,
      networkStatus: Re.refetch
    }), this.observable.refetch());
  }, e;
}();
function Py(e, t) {
  var n = Sy(t == null ? void 0 : t.client);
  Ey(e, Jt.Mutation);
  var r = React.useState({
      called: !1,
      loading: !1,
      client: n
    }),
    a = r[0],
    i = r[1],
    o = React.useRef({
      result: a,
      mutationId: 0,
      isMounted: !0,
      client: n,
      mutation: e,
      options: t
    });
  Object.assign(o.current, {
    client: n,
    options: t,
    mutation: e
  });
  var s = React.useCallback(function (l) {
      l === void 0 && (l = {});
      var c = o.current,
        f = c.client,
        h = c.options,
        p = c.mutation,
        v = _P2(_P2({}, h), {
          mutation: p
        });
      !o.current.result.loading && !v.ignoreResults && o.current.isMounted && i(o.current.result = {
        loading: !0,
        error: void 0,
        data: void 0,
        called: !0,
        client: f
      });
      var m = ++o.current.mutationId,
        g = Jr(v, l);
      return f.mutate(g).then(function (b) {
        var y,
          E = b.data,
          w = b.errors,
          _ = w && w.length > 0 ? new an({
            graphQLErrors: w
          }) : void 0;
        if (m === o.current.mutationId && !g.ignoreResults) {
          var C = {
            called: !0,
            loading: !1,
            data: E,
            error: _,
            client: f
          };
          o.current.isMounted && !Qe(o.current.result, C) && i(o.current.result = C);
        }
        var D = l.onCompleted || ((y = o.current.options) === null || y === void 0 ? void 0 : y.onCompleted);
        return D == null || D(b.data, g), b;
      }).catch(function (b) {
        var y;
        if (m === o.current.mutationId && o.current.isMounted) {
          var E = {
            loading: !1,
            error: b,
            data: void 0,
            called: !0,
            client: f
          };
          Qe(o.current.result, E) || i(o.current.result = E);
        }
        var w = l.onError || ((y = o.current.options) === null || y === void 0 ? void 0 : y.onError);
        if (w) return w(b, g), {
          data: void 0,
          errors: b
        };
        throw b;
      });
    }, []),
    u = React.useCallback(function () {
      o.current.isMounted && i({
        called: !1,
        loading: !1,
        client: n
      });
    }, []);
  return React.useEffect(function () {
    return o.current.isMounted = !0, function () {
      o.current.isMounted = !1;
    };
  }, []), [s, _P2({
    reset: u
  }, a)];
}
var $S = wt(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral2(["\n  query PortalSiteQuery($id: ID!) {\n    PortalSite(id: $id) {\n      id\n      portal_code\n      options\n      countries {\n        id\n        name\n      }\n      regions {\n        id\n        name\n        country_id\n      }\n      cities {\n        id\n        name\n        region\n        country_id\n      }\n      extra_search\n      max_bathrooms\n      max_bedrooms\n      max_nights\n      max_persons\n      max_weekprice\n      country_placeholder\n      categories\n      countries_label\n      country_placeholder\n      regions_label\n      cities_label\n      arrival_date_label\n      departure_date_label\n      max_weekprice_label\n      persons_min_label\n      persons_max_label\n      bedrooms_min_label\n      bathrooms_min_label\n      weekprice_max_label\n      no_nights_label\n      extra_search_label\n      properties_label\n    }\n  }\n"]))),
  CS = wt(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral2(["\n  query PortalSiteHousesQuery(\n    $id: ID!\n    $house_id: String!\n    $starts_at: Date!\n    $ends_at: Date!\n  ) {\n    PortalSite(id: $id) {\n      id\n      houses(house_code: $house_id) {\n        id\n        name\n        last_minute_days\n        availabilities(starts_at: $starts_at, ends_at: $ends_at) {\n          arrival\n          arrival_time_from\n          arrival_time_to\n          date\n          departure\n          departure_time\n          max_nights\n          min_nights\n          special_offer\n        }\n      }\n    }\n    Discounts(\n      house_code: $house_id\n      discount_starts_at: $ends_at\n      discount_ends_at: $starts_at\n      active_today: true\n    ) {\n      name\n      discount_starts_at\n      discount_ends_at\n    }\n  }\n"]))),
  RS = wt(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral2(["\n  query BookingFormQuery(\n    $portalCode: ID!\n    $objectCode: String!\n    $starts_at: Date!\n    $ends_at: Date!\n  ) {\n    PortalSite(id: $portalCode) {\n      id\n      options\n      first_name_label\n      preposition_label\n      last_name_label\n      email_label\n      zipcode_label\n      city_label\n      address_label\n      house_number_label\n      phone_label\n      phone_mobile_label\n      country_label\n      iban_label\n      holder_label\n      bic_label\n      comment_label\n      company_name_label\n      extra_fields_drivers_license_label\n      extra_fields_destination_label\n      booking_fields {\n        id\n        label\n        field_type\n        options\n        placeholder\n      }\n      houses(house_code: $objectCode) {\n        id\n        name\n        code\n        allow_option\n        persons\n        image_url\n        discounts\n        discounts_info\n        house_type\n        rental_terms\n        cancel_insurance\n        damage_insurance\n        damage_insurance_required\n        travel_insurance\n        babies_extra\n        booking_price(starts_at: $starts_at, ends_at: $ends_at)\n      }\n    }\n  }\n"]))),
  NS = wt(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral2(["\n  mutation CreateBooking(\n    $first_name: String!\n    $preposition: String\n    $last_name: String!\n    $company_name: String\n    $is_option: Boolean!\n    $address: String\n    $house_number: String\n    $zipcode: String\n    $city: String\n    $phone: String\n    $phone_mobile: String\n    $iban: String\n    $bic: String\n    $holder: String\n    $email: String!\n    $house_code: String!\n    $portal_code: String\n    $language: String\n    $country: String!\n    $adults: Int!\n    $children: Int\n    $babies: Int\n    $discount: Int\n    $damage_insurance: Int\n    $cancel_insurance: Int\n    $travel_insurance: Int\n    $discount_reason: String\n    $discount_code: String\n    $comment: String\n    $arrival_date: String!\n    $departure_date: String!\n    $costs: Json\n    $extra_fields: String\n  ) {\n    createBooking(\n      first_name: $first_name\n      preposition: $preposition\n      company_name: $company_name\n      last_name: $last_name\n      is_option: $is_option\n      address: $address\n      house_number: $house_number\n      zipcode: $zipcode\n      city: $city\n      phone: $phone\n      phone_mobile: $phone_mobile\n      iban: $iban\n      bic: $bic\n      holder: $holder\n      email: $email\n      house_code: $house_code\n      portal_code: $portal_code\n      language: $language\n      country: $country\n      adults: $adults\n      children: $children\n      babies: $babies\n      discount: $discount\n      discount_code: $discount_code\n      damage_insurance: $damage_insurance\n      cancel_insurance: $cancel_insurance\n      travel_insurance: $travel_insurance\n      discount_reason: $discount_reason\n      arrival_date: $arrival_date\n      departure_date: $departure_date\n      comment: $comment\n      costs: $costs\n      extra_fields: $extra_fields\n    ) {\n      booking_nr\n    }\n  }\n"]))),
  AS = wt(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral2(["\n  query PortalSiteSingleHouseQuery($portalCode: ID!, $objectCode: String!) {\n    PortalSite(id: $portalCode) {\n      id\n      houses(house_code: $objectCode) {\n        id\n        code\n        name\n        max_nights\n        last_minute_days\n        discounts\n        discounts_info\n        house_type\n        persons\n      }\n    }\n  }\n"])));
function IS(_ref36) {
  var e = _ref36.filters,
    t = _ref36.field,
    n = _ref36.options,
    r = _ref36.onChange,
    a = _ref36.value;
  var i = e.countries,
    o = function o(u) {
      a === u.target.value ? s(null) : s(u.target.value);
    },
    s = function s(u) {
      r(t.id, u);
    };
  return ["cities", "regions"].includes(t.id) ? /* @__PURE__ */d("ul", {
    className: "radioList",
    children: n.map(function (u) {
      return /* @__PURE__ */F("li", {
        className: "bu-list-item ".concat(i && !i.includes(u.country_id) ? "bu-disabled" : "bu-open"),
        children: [/* @__PURE__ */d("input", {
          name: t.id,
          type: "checkbox",
          id: u.id,
          value: u.id,
          disabled: i ? !i.includes(u.country_id) : !1,
          checked: a === u.id,
          onBlur: s,
          onChange: s
        }), /* @__PURE__ */d("label", {
          htmlFor: u.id,
          children: u.name
        })]
      }, u.id);
    })
  }) : /* @__PURE__ */d("ul", {
    className: "radioList",
    children: n.map(function (u) {
      return /* @__PURE__ */F("li", {
        className: "bu-list-item bu-open",
        children: [/* @__PURE__ */d("input", {
          name: t.id,
          type: "checkbox",
          id: u.id,
          value: u.id,
          checked: a === u.id,
          onBlur: s,
          onChange: o
        }), /* @__PURE__ */d("label", {
          htmlFor: u.id,
          children: u.name
        })]
      }, u.id);
    })
  });
}
function Ba(e) {
  return Array.from({
    length: e + 1
  }, function (t, n) {
    return n;
  });
}
function MS(e) {
  var t = Math.ceil(e / 100);
  return Array.from({
    length: t + 1
  }, function (n, r) {
    return r * 100;
  });
}
var FS = [{
  label: "Land",
  id: "countries",
  type: "select",
  required: !1,
  mandatory: !0,
  options: ["select", "list", "radio", "text"]
}];
function LS(_ref37) {
  var e = _ref37.options,
    t = _ref37.field,
    n = _ref37.filters,
    r = _ref37.value,
    a = _ref37.onChange;
  var i = function i(u) {
      a(t.id, u.currentTarget.value);
    },
    o = n.countries,
    s = Array.isArray(n.regions) ? n.regions : [n.regions].filter(function (u) {
      return String(u).trim();
    });
  return e && ["countries", "cities", "regions"].includes(t.id) ? /* @__PURE__ */F("select", {
    name: t.id,
    onBlur: i,
    onChange: i,
    value: r,
    children: [/* @__PURE__ */d("option", {
      value: ""
    }), e.map(function (u) {
      var l = !1;
      return ["cities", "regions"].includes(t.id) && (o && !o.includes(u.country_id) && (l = !0), t.id === "cities" && s.length && !s.includes(u.region) && (l = !0)), /* @__PURE__ */d("option", {
        value: u.id,
        id: u.region,
        disabled: l,
        hidden: l,
        children: u.name
      }, u.id);
    })]
  }) : /* @__PURE__ */F("select", {
    name: t.id,
    onBlur: i,
    onChange: i,
    value: r,
    children: [/* @__PURE__ */d("option", {
      value: ""
    }), e.map(function (u) {
      var l = !1;
      return /* @__PURE__ */d("option", {
        value: u,
        disabled: l,
        hidden: l,
        children: u
      }, u);
    })]
  });
}
function jS(_ref38) {
  var e = _ref38.PortalSite,
    t = _ref38.filters,
    n = _ref38.onChange;
  var r = t.properties || [];
  var a = e.options.filtersForm.categories,
    i = [];
  var o = function o(s) {
    var u = Number(s.currentTarget.value);
    if (r.includes(u)) {
      var _l2 = r.indexOf(u);
      r.splice(_l2, 1);
    } else r.push(u);
    n("properties", r);
  };
  return e.categories.map(function (s) {
    a.includes(s.id) && i.push( /* @__PURE__ */F("div", {
      className: "bu-properties",
      children: [/* @__PURE__ */d("strong", {
        children: s.name
      }), /* @__PURE__ */d("ul", {
        children: s.properties.map(function (u) {
          return /* @__PURE__ */d("li", {
            children: /* @__PURE__ */F("label", {
              htmlFor: u.id.toString(),
              children: [/* @__PURE__ */d("input", {
                type: "checkbox",
                id: u.id.toString(),
                value: u.id,
                checked: r.includes(u.id),
                onChange: o
              }), u.name]
            })
          }, u.id);
        })
      })]
    }, s.id));
  }), i;
}
function BS(_ref39) {
  var e = _ref39.options,
    t = _ref39.filters,
    n = _ref39.onChange,
    r = _ref39.field;
  var a = t.countries,
    i = function i(o) {
      n(r.id, o.currentTarget.value);
    };
  return /* @__PURE__ */d("ul", {
    className: "radioList",
    children: e.map(function (o) {
      return /* @__PURE__ */F("li", {
        className: "bu-list-item ".concat(a && !a.includes(o.country_id) ? "bu-disabled" : ""),
        children: [/* @__PURE__ */d("input", {
          name: r.id,
          type: "radio",
          id: o.id || o,
          value: o.id || o,
          disabled: a ? !a.includes(o.country_id) : !1,
          onBlur: i,
          onChange: i
        }), /* @__PURE__ */d("label", {
          htmlFor: o.id || o,
          children: o.name || o
        })]
      }, o.id || o);
    })
  });
}
function ot(e) {
  if (e === null || e === !0 || e === !1) return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function De(e, t) {
  if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ii(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ii = function ii(n) {
    return typeof n;
  } : ii = function ii(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ii(e);
}
function qe(e) {
  De(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || ii(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
}
function Qo(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = ot(t);
  return isNaN(r) ? new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Ea(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = ot(t);
  if (isNaN(r)) return new Date(NaN);
  if (!r) return n;
  var a = n.getDate(),
    i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var o = i.getDate();
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
function VS(e, t) {
  De(2, arguments);
  var n = qe(e).getTime(),
    r = ot(t);
  return new Date(n + r);
}
var qS = {};
function $n() {
  return qS;
}
function cf(e, t) {
  var n, r, a, i, o, s, u, l;
  De(1, arguments);
  var c = $n(),
    f = ot((n = (r = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = qe(e),
    p = h.getDay(),
    v = (p < f ? 7 : 0) + p - f;
  return h.setDate(h.getDate() - v), h.setHours(0, 0, 0, 0), h;
}
function Ki(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Ji(e) {
  De(1, arguments);
  var t = qe(e);
  return t.setHours(0, 0, 0, 0), t;
}
var US = 864e5;
function _n(e, t) {
  De(2, arguments);
  var n = Ji(e),
    r = Ji(t),
    a = n.getTime() - Ki(n),
    i = r.getTime() - Ki(r);
  return Math.round((a - i) / US);
}
function zS(e, t) {
  De(2, arguments);
  var n = ot(t);
  return Ea(e, n * 12);
}
var HS = 6e4,
  WS = 36e5,
  GS = 1e3;
function mh(e, t) {
  De(2, arguments);
  var n = Ji(e),
    r = Ji(t);
  return n.getTime() === r.getTime();
}
function oi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? oi = function oi(n) {
    return typeof n;
  } : oi = function oi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, oi(e);
}
function YS(e) {
  return De(1, arguments), e instanceof Date || oi(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function QS(e) {
  if (De(1, arguments), !YS(e) && typeof e != "number") return !1;
  var t = qe(e);
  return !isNaN(Number(t));
}
function Ty(e) {
  De(1, arguments);
  var t = qe(e),
    n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function ky(e) {
  De(1, arguments);
  var t = qe(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Dy(e, t) {
  var n, r, a, i, o, s, u, l;
  De(1, arguments);
  var c = $n(),
    f = ot((n = (r = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = qe(e),
    p = h.getDay(),
    v = (p < f ? -7 : 0) + 6 - (p - f);
  return h.setDate(h.getDate() + v), h.setHours(23, 59, 59, 999), h;
}
function xy(e, t) {
  De(2, arguments);
  var n = ot(t);
  return VS(e, -n);
}
var KS = 864e5;
function JS(e) {
  De(1, arguments);
  var t = qe(e),
    n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(),
    a = n - r;
  return Math.floor(a / KS) + 1;
}
function Or(e) {
  De(1, arguments);
  var t = 1,
    n = qe(e),
    r = n.getUTCDay(),
    a = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $y(e) {
  De(1, arguments);
  var t = qe(e),
    n = t.getUTCFullYear(),
    r = new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var a = Or(r),
    i = new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = Or(i);
  return t.getTime() >= a.getTime() ? n + 1 : t.getTime() >= o.getTime() ? n : n - 1;
}
function XS(e) {
  De(1, arguments);
  var t = $y(e),
    n = new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Or(n);
  return r;
}
var ZS = 6048e5;
function Cy(e) {
  De(1, arguments);
  var t = qe(e),
    n = Or(t).getTime() - XS(t).getTime();
  return Math.round(n / ZS) + 1;
}
function un(e, t) {
  var n, r, a, i, o, s, u, l;
  De(1, arguments);
  var c = $n(),
    f = ot((n = (r = (a = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : c.weekStartsOn) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = qe(e),
    p = h.getUTCDay(),
    v = (p < f ? 7 : 0) + p - f;
  return h.setUTCDate(h.getUTCDate() - v), h.setUTCHours(0, 0, 0, 0), h;
}
function ff(e, t) {
  var n, r, a, i, o, s, u, l;
  De(1, arguments);
  var c = qe(e),
    f = c.getUTCFullYear(),
    h = $n(),
    p = ot((n = (r = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : h.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = h.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(p >= 1 && p <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = new Date(0);
  v.setUTCFullYear(f + 1, 0, p), v.setUTCHours(0, 0, 0, 0);
  var m = un(v, t),
    g = new Date(0);
  g.setUTCFullYear(f, 0, p), g.setUTCHours(0, 0, 0, 0);
  var b = un(g, t);
  return c.getTime() >= m.getTime() ? f + 1 : c.getTime() >= b.getTime() ? f : f - 1;
}
function e2(e, t) {
  var n, r, a, i, o, s, u, l;
  De(1, arguments);
  var c = $n(),
    f = ot((n = (r = (a = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (s = o.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : c.firstWeekContainsDate) !== null && r !== void 0 ? r : (u = c.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && n !== void 0 ? n : 1),
    h = ff(e, t),
    p = new Date(0);
  p.setUTCFullYear(h, 0, f), p.setUTCHours(0, 0, 0, 0);
  var v = un(p, t);
  return v;
}
var t2 = 6048e5;
function Ry(e, t) {
  De(1, arguments);
  var n = qe(e),
    r = un(n, t).getTime() - e2(n, t).getTime();
  return Math.round(r / t2) + 1;
}
function Be(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
  return n + r;
}
var n2 = {
  // Year
  y: function y(t, n) {
    var r = t.getUTCFullYear(),
      a = r > 0 ? r : 1 - r;
    return Be(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M: function M(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Be(r + 1, 2);
  },
  // Day of the month
  d: function d(t, n) {
    return Be(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function a(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h(t, n) {
    return Be(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function H(t, n) {
    return Be(t.getUTCHours(), n.length);
  },
  // Minute
  m: function m(t, n) {
    return Be(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function s(t, n) {
    return Be(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function S(t, n) {
    var r = n.length,
      a = t.getUTCMilliseconds(),
      i = Math.floor(a * Math.pow(10, r - 3));
    return Be(i, n.length);
  }
};
var hn = n2;
var sr = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  r2 = {
    // Era
    G: function G(t, n, r) {
      var a = t.getUTCFullYear() > 0 ? 1 : 0;
      switch (n) {
        case "G":
        case "GG":
        case "GGG":
          return r.era(a, {
            width: "abbreviated"
          });
        case "GGGGG":
          return r.era(a, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return r.era(a, {
            width: "wide"
          });
      }
    },
    // Year
    y: function y(t, n, r) {
      if (n === "yo") {
        var a = t.getUTCFullYear(),
          i = a > 0 ? a : 1 - a;
        return r.ordinalNumber(i, {
          unit: "year"
        });
      }
      return hn.y(t, n);
    },
    // Local week-numbering year
    Y: function Y(t, n, r, a) {
      var i = ff(t, a),
        o = i > 0 ? i : 1 - i;
      if (n === "YY") {
        var s = o % 100;
        return Be(s, 2);
      }
      return n === "Yo" ? r.ordinalNumber(o, {
        unit: "year"
      }) : Be(o, n.length);
    },
    // ISO week-numbering year
    R: function R(t, n) {
      var r = $y(t);
      return Be(r, n.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(t, n) {
      var r = t.getUTCFullYear();
      return Be(r, n.length);
    },
    // Quarter
    Q: function Q(t, n, r) {
      var a = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (n) {
        case "Q":
          return String(a);
        case "QQ":
          return Be(a, 2);
        case "Qo":
          return r.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return r.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return r.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return r.quarter(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function q(t, n, r) {
      var a = Math.ceil((t.getUTCMonth() + 1) / 3);
      switch (n) {
        case "q":
          return String(a);
        case "qq":
          return Be(a, 2);
        case "qo":
          return r.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return r.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return r.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return r.quarter(a, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function M(t, n, r) {
      var a = t.getUTCMonth();
      switch (n) {
        case "M":
        case "MM":
          return hn.M(t, n);
        case "Mo":
          return r.ordinalNumber(a + 1, {
            unit: "month"
          });
        case "MMM":
          return r.month(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return r.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return r.month(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone month
    L: function L(t, n, r) {
      var a = t.getUTCMonth();
      switch (n) {
        case "L":
          return String(a + 1);
        case "LL":
          return Be(a + 1, 2);
        case "Lo":
          return r.ordinalNumber(a + 1, {
            unit: "month"
          });
        case "LLL":
          return r.month(a, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return r.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return r.month(a, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Local week of year
    w: function w(t, n, r, a) {
      var i = Ry(t, a);
      return n === "wo" ? r.ordinalNumber(i, {
        unit: "week"
      }) : Be(i, n.length);
    },
    // ISO week of year
    I: function I(t, n, r) {
      var a = Cy(t);
      return n === "Io" ? r.ordinalNumber(a, {
        unit: "week"
      }) : Be(a, n.length);
    },
    // Day of the month
    d: function d(t, n, r) {
      return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
        unit: "date"
      }) : hn.d(t, n);
    },
    // Day of year
    D: function D(t, n, r) {
      var a = JS(t);
      return n === "Do" ? r.ordinalNumber(a, {
        unit: "dayOfYear"
      }) : Be(a, n.length);
    },
    // Day of week
    E: function E(t, n, r) {
      var a = t.getUTCDay();
      switch (n) {
        case "E":
        case "EE":
        case "EEE":
          return r.day(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return r.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return r.day(a, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return r.day(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function e(t, n, r, a) {
      var i = t.getUTCDay(),
        o = (i - a.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "e":
          return String(o);
        case "ee":
          return Be(o, 2);
        case "eo":
          return r.ordinalNumber(o, {
            unit: "day"
          });
        case "eee":
          return r.day(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return r.day(i, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return r.day(i, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return r.day(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function c(t, n, r, a) {
      var i = t.getUTCDay(),
        o = (i - a.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "c":
          return String(o);
        case "cc":
          return Be(o, n.length);
        case "co":
          return r.ordinalNumber(o, {
            unit: "day"
          });
        case "ccc":
          return r.day(i, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return r.day(i, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return r.day(i, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return r.day(i, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function i(t, n, r) {
      var a = t.getUTCDay(),
        i = a === 0 ? 7 : a;
      switch (n) {
        case "i":
          return String(i);
        case "ii":
          return Be(i, n.length);
        case "io":
          return r.ordinalNumber(i, {
            unit: "day"
          });
        case "iii":
          return r.day(a, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return r.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return r.day(a, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return r.day(a, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function a(t, n, r) {
      var a = t.getUTCHours(),
        i = a / 12 >= 1 ? "pm" : "am";
      switch (n) {
        case "a":
        case "aa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(t, n, r) {
      var a = t.getUTCHours(),
        i;
      switch (a === 12 ? i = sr.noon : a === 0 ? i = sr.midnight : i = a / 12 >= 1 ? "pm" : "am", n) {
        case "b":
        case "bb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(t, n, r) {
      var a = t.getUTCHours(),
        i;
      switch (a >= 17 ? i = sr.evening : a >= 12 ? i = sr.afternoon : a >= 4 ? i = sr.morning : i = sr.night, n) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function h(t, n, r) {
      if (n === "ho") {
        var a = t.getUTCHours() % 12;
        return a === 0 && (a = 12), r.ordinalNumber(a, {
          unit: "hour"
        });
      }
      return hn.h(t, n);
    },
    // Hour [0-23]
    H: function H(t, n, r) {
      return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
        unit: "hour"
      }) : hn.H(t, n);
    },
    // Hour [0-11]
    K: function K(t, n, r) {
      var a = t.getUTCHours() % 12;
      return n === "Ko" ? r.ordinalNumber(a, {
        unit: "hour"
      }) : Be(a, n.length);
    },
    // Hour [1-24]
    k: function k(t, n, r) {
      var a = t.getUTCHours();
      return a === 0 && (a = 24), n === "ko" ? r.ordinalNumber(a, {
        unit: "hour"
      }) : Be(a, n.length);
    },
    // Minute
    m: function m(t, n, r) {
      return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
        unit: "minute"
      }) : hn.m(t, n);
    },
    // Second
    s: function s(t, n, r) {
      return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
        unit: "second"
      }) : hn.s(t, n);
    },
    // Fraction of second
    S: function S(t, n) {
      return hn.S(t, n);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(t, n, r, a) {
      var i = a._originalDate || t,
        o = i.getTimezoneOffset();
      if (o === 0) return "Z";
      switch (n) {
        case "X":
          return yh(o);
        case "XXXX":
        case "XX":
          return Mn(o);
        case "XXXXX":
        case "XXX":
        default:
          return Mn(o, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(t, n, r, a) {
      var i = a._originalDate || t,
        o = i.getTimezoneOffset();
      switch (n) {
        case "x":
          return yh(o);
        case "xxxx":
        case "xx":
          return Mn(o);
        case "xxxxx":
        case "xxx":
        default:
          return Mn(o, ":");
      }
    },
    // Timezone (GMT)
    O: function O(t, n, r, a) {
      var i = a._originalDate || t,
        o = i.getTimezoneOffset();
      switch (n) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + vh(o, ":");
        case "OOOO":
        default:
          return "GMT" + Mn(o, ":");
      }
    },
    // Timezone (specific non-location)
    z: function z(t, n, r, a) {
      var i = a._originalDate || t,
        o = i.getTimezoneOffset();
      switch (n) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + vh(o, ":");
        case "zzzz":
        default:
          return "GMT" + Mn(o, ":");
      }
    },
    // Seconds timestamp
    t: function t(_t3, n, r, a) {
      var i = a._originalDate || _t3,
        o = Math.floor(i.getTime() / 1e3);
      return Be(o, n.length);
    },
    // Milliseconds timestamp
    T: function T(t, n, r, a) {
      var i = a._originalDate || t,
        o = i.getTime();
      return Be(o, n.length);
    }
  };
function vh(e, t) {
  var n = e > 0 ? "-" : "+",
    r = Math.abs(e),
    a = Math.floor(r / 60),
    i = r % 60;
  if (i === 0) return n + String(a);
  var o = t || "";
  return n + String(a) + o + Be(i, 2);
}
function yh(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Be(Math.abs(e) / 60, 2);
  }
  return Mn(e, t);
}
function Mn(e, t) {
  var n = t || "",
    r = e > 0 ? "-" : "+",
    a = Math.abs(e),
    i = Be(Math.floor(a / 60), 2),
    o = Be(a % 60, 2);
  return r + i + n + o;
}
var a2 = r2;
var gh = function gh(t, n) {
    switch (t) {
      case "P":
        return n.date({
          width: "short"
        });
      case "PP":
        return n.date({
          width: "medium"
        });
      case "PPP":
        return n.date({
          width: "long"
        });
      case "PPPP":
      default:
        return n.date({
          width: "full"
        });
    }
  },
  Ny = function Ny(t, n) {
    switch (t) {
      case "p":
        return n.time({
          width: "short"
        });
      case "pp":
        return n.time({
          width: "medium"
        });
      case "ppp":
        return n.time({
          width: "long"
        });
      case "pppp":
      default:
        return n.time({
          width: "full"
        });
    }
  },
  i2 = function i2(t, n) {
    var r = t.match(/(P+)(p+)?/) || [],
      a = r[1],
      i = r[2];
    if (!i) return gh(t, n);
    var o;
    switch (a) {
      case "P":
        o = n.dateTime({
          width: "short"
        });
        break;
      case "PP":
        o = n.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        o = n.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        o = n.dateTime({
          width: "full"
        });
        break;
    }
    return o.replace("{{date}}", gh(a, n)).replace("{{time}}", Ny(i, n));
  },
  o2 = {
    p: Ny,
    P: i2
  };
var Nu = o2;
var s2 = ["D", "DD"],
  u2 = ["YY", "YYYY"];
function Ay(e) {
  return s2.indexOf(e) !== -1;
}
function Iy(e) {
  return u2.indexOf(e) !== -1;
}
function Xi(e, t, n) {
  if (e === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var l2 = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  },
  c2 = function c2(t, n, r) {
    var a,
      i = l2[t];
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : a + " ago" : a;
  };
var My = c2;
function dt(e) {
  return function () {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      n = t.width ? String(t.width) : e.defaultWidth,
      r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var f2 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  },
  d2 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  },
  h2 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  p2 = {
    date: dt({
      formats: f2,
      defaultWidth: "full"
    }),
    time: dt({
      formats: d2,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: h2,
      defaultWidth: "full"
    })
  };
var m2 = p2;
var v2 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  },
  y2 = function y2(t, n, r, a) {
    return v2[t];
  };
var Fy = y2;
function Fe(e) {
  return function (t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone",
      a;
    if (r === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth,
        o = n != null && n.width ? String(n.width) : i;
      a = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var s = e.defaultWidth,
        u = n != null && n.width ? String(n.width) : e.defaultWidth;
      a = e.values[u] || e.values[s];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return a[l];
  };
}
var g2 = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  },
  b2 = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  },
  _2 = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  },
  w2 = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  },
  O2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  },
  S2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  },
  E2 = function E2(t, n) {
    var r = Number(t),
      a = r % 100;
    if (a > 20 || a < 10) switch (a % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
    return r + "th";
  },
  P2 = {
    ordinalNumber: E2,
    era: Fe({
      values: g2,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: b2,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Fe({
      values: _2,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: w2,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: O2,
      defaultWidth: "wide",
      formattingValues: S2,
      defaultFormattingWidth: "wide"
    })
  };
var Ly = P2;
function Le(e) {
  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      r = n.width,
      a = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth],
      i = t.match(a);
    if (!i) return null;
    var o = i[0],
      s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth],
      u = Array.isArray(s) ? k2(s, function (f) {
        return f.test(o);
      }) : T2(s, function (f) {
        return f.test(o);
      }),
      l;
    l = e.valueCallback ? e.valueCallback(u) : u, l = n.valueCallback ? n.valueCallback(l) : l;
    var c = t.slice(o.length);
    return {
      value: l,
      rest: c
    };
  };
}
function T2(e, t) {
  for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
}
function k2(e, t) {
  for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
}
function Dr(e) {
  return function (t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      r = t.match(e.matchPattern);
    if (!r) return null;
    var a = r[0],
      i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    var s = t.slice(a.length);
    return {
      value: o,
      rest: s
    };
  };
}
var D2 = /^(\d+)(th|st|nd|rd)?/i,
  x2 = /\d+/i,
  $2 = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  },
  C2 = {
    any: [/^b/i, /^(a|c)/i]
  },
  R2 = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  },
  N2 = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  A2 = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  },
  I2 = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  M2 = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  },
  F2 = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  },
  L2 = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  },
  j2 = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  },
  B2 = {
    ordinalNumber: Dr({
      matchPattern: D2,
      parsePattern: x2,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }),
    era: Le({
      matchPatterns: $2,
      defaultMatchWidth: "wide",
      parsePatterns: C2,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: R2,
      defaultMatchWidth: "wide",
      parsePatterns: N2,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: A2,
      defaultMatchWidth: "wide",
      parsePatterns: I2,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: M2,
      defaultMatchWidth: "wide",
      parsePatterns: F2,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: L2,
      defaultMatchWidth: "any",
      parsePatterns: j2,
      defaultParseWidth: "any"
    })
  };
var jy = B2;
var V2 = {
  code: "en-US",
  formatDistance: My,
  formatLong: m2,
  formatRelative: Fy,
  localize: Ly,
  match: jy,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var By = V2;
var q2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  U2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  z2 = /^'([^]*?)'?$/,
  H2 = /''/g,
  W2 = /[a-zA-Z]/;
function la(e, t, n) {
  var r, a, i, o, s, u, l, c, f, h, p, v, m, g, b, y, E, w;
  De(2, arguments);
  var _ = String(t),
    C = $n(),
    D = (r = (a = n == null ? void 0 : n.locale) !== null && a !== void 0 ? a : C.locale) !== null && r !== void 0 ? r : By,
    U = ot((i = (o = (s = (u = n == null ? void 0 : n.firstWeekContainsDate) !== null && u !== void 0 ? u : n == null || (l = n.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && s !== void 0 ? s : C.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = C.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(U >= 1 && U <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Z = ot((p = (v = (m = (g = n == null ? void 0 : n.weekStartsOn) !== null && g !== void 0 ? g : n == null || (b = n.locale) === null || b === void 0 || (y = b.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && m !== void 0 ? m : C.weekStartsOn) !== null && v !== void 0 ? v : (E = C.locale) === null || E === void 0 || (w = E.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(Z >= 0 && Z <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!D.localize) throw new RangeError("locale must contain localize property");
  if (!D.formatLong) throw new RangeError("locale must contain formatLong property");
  var me = qe(e);
  if (!QS(me)) throw new RangeError("Invalid time value");
  var ye = Ki(me),
    Y = xy(me, ye),
    K = {
      firstWeekContainsDate: U,
      weekStartsOn: Z,
      locale: D,
      _originalDate: me
    },
    ee = _.match(U2).map(function (ne) {
      var ie = ne[0];
      if (ie === "p" || ie === "P") {
        var fe = Nu[ie];
        return fe(ne, D.formatLong);
      }
      return ne;
    }).join("").match(q2).map(function (ne) {
      if (ne === "''") return "'";
      var ie = ne[0];
      if (ie === "'") return G2(ne);
      var fe = a2[ie];
      if (fe) return !(n != null && n.useAdditionalWeekYearTokens) && Iy(ne) && Xi(ne, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Ay(ne) && Xi(ne, t, String(e)), fe(Y, ne, D.localize, K);
      if (ie.match(W2)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + ie + "`");
      return ne;
    }).join("");
  return ee;
}
function G2(e) {
  var t = e.match(z2);
  return t ? t[1].replace(H2, "'") : e;
}
function Y2(e, t) {
  if (e == null) throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function fr(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = qe(t);
  return n.getTime() > r.getTime();
}
function bh(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = qe(t);
  return n.getTime() < r.getTime();
}
function si(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? si = function si(n) {
    return typeof n;
  } : si = function si(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, si(e);
}
function Vy(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Au(e, t);
}
function Au(e, t) {
  return Au = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Au(e, t);
}
function qy(e) {
  var t = K2();
  return function () {
    var r = Zi(e),
      a;
    if (t) {
      var i = Zi(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Q2(this, a);
  };
}
function Q2(e, t) {
  return t && (si(t) === "object" || typeof t == "function") ? t : Iu(e);
}
function Iu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function K2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused11) {
    return !1;
  }
}
function Zi(e) {
  return Zi = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Zi(e);
}
function df(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _h(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hf(e, t, n) {
  return t && _h(e.prototype, t), n && _h(e, n), e;
}
function Mu(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var J2 = 10,
  Uy = /* @__PURE__ */function () {
    function e() {
      df(this, e), Mu(this, "subPriority", 0);
    }
    return hf(e, [{
      key: "validate",
      value: function value(n, r) {
        return !0;
      }
    }]), e;
  }(),
  X2 = /* @__PURE__ */function (e) {
    Vy(n, e);
    var t = qy(n);
    function n(r, a, i, o, s) {
      var u;
      return df(this, n), u = t.call(this), u.value = r, u.validateValue = a, u.setValue = i, u.priority = o, s && (u.subPriority = s), u;
    }
    return hf(n, [{
      key: "validate",
      value: function value(a, i) {
        return this.validateValue(a, this.value, i);
      }
    }, {
      key: "set",
      value: function value(a, i, o) {
        return this.setValue(a, i, this.value, o);
      }
    }]), n;
  }(Uy),
  Z2 = /* @__PURE__ */function (e) {
    Vy(n, e);
    var t = qy(n);
    function n() {
      var r;
      df(this, n);
      for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return r = t.call.apply(t, [this].concat(i)), Mu(Iu(r), "priority", J2), Mu(Iu(r), "subPriority", -1), r;
    }
    return hf(n, [{
      key: "set",
      value: function value(a, i) {
        if (i.timestampIsSet) return a;
        var o = new Date(0);
        return o.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), o.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), o;
      }
    }]), n;
  }(Uy);
function eE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function wh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function tE(e, t, n) {
  return t && wh(e.prototype, t), n && wh(e, n), e;
}
var Ae = /* @__PURE__ */function () {
  function e() {
    eE(this, e);
  }
  return tE(e, [{
    key: "run",
    value: function value(n, r, a, i) {
      var o = this.parse(n, r, a, i);
      return o ? {
        setter: new X2(o.value, this.validate, this.set, this.priority, this.subPriority),
        rest: o.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function value(n, r, a) {
      return !0;
    }
  }]), e;
}();
function ui(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ui = function ui(n) {
    return typeof n;
  } : ui = function ui(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ui(e);
}
function nE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Oh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function rE(e, t, n) {
  return t && Oh(e.prototype, t), n && Oh(e, n), e;
}
function aE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Fu(e, t);
}
function Fu(e, t) {
  return Fu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Fu(e, t);
}
function iE(e) {
  var t = sE();
  return function () {
    var r = eo(e),
      a;
    if (t) {
      var i = eo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return oE(this, a);
  };
}
function oE(e, t) {
  return t && (ui(t) === "object" || typeof t == "function") ? t : Lu(e);
}
function Lu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function sE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused12) {
    return !1;
  }
}
function eo(e) {
  return eo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, eo(e);
}
function Sh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var uE = /* @__PURE__ */function (e) {
    aE(n, e);
    var t = iE(n);
    function n() {
      var r;
      nE(this, n);
      for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return r = t.call.apply(t, [this].concat(i)), Sh(Lu(r), "priority", 140), Sh(Lu(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
    }
    return rE(n, [{
      key: "parse",
      value: function value(a, i, o) {
        switch (i) {
          case "G":
          case "GG":
          case "GGG":
            return o.era(a, {
              width: "abbreviated"
            }) || o.era(a, {
              width: "narrow"
            });
          case "GGGGG":
            return o.era(a, {
              width: "narrow"
            });
          case "GGGG":
          default:
            return o.era(a, {
              width: "wide"
            }) || o.era(a, {
              width: "abbreviated"
            }) || o.era(a, {
              width: "narrow"
            });
        }
      }
    }, {
      key: "set",
      value: function value(a, i, o) {
        return i.era = o, a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
    }]), n;
  }(Ae),
  ct = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
    // 0 to 9999, -0 to -9999
  },
  Yt = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };
function ft(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ze(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Qt(e, t) {
  var n = t.match(e);
  if (!n) return null;
  if (n[0] === "Z") return {
    value: 0,
    rest: t.slice(1)
  };
  var r = n[1] === "+" ? 1 : -1,
    a = n[2] ? parseInt(n[2], 10) : 0,
    i = n[3] ? parseInt(n[3], 10) : 0,
    o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (a * WS + i * HS + o * GS),
    rest: t.slice(n[0].length)
  };
}
function zy(e) {
  return Ze(ct.anyDigitsSigned, e);
}
function st(e, t) {
  switch (e) {
    case 1:
      return Ze(ct.singleDigit, t);
    case 2:
      return Ze(ct.twoDigits, t);
    case 3:
      return Ze(ct.threeDigits, t);
    case 4:
      return Ze(ct.fourDigits, t);
    default:
      return Ze(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function to(e, t) {
  switch (e) {
    case 1:
      return Ze(ct.singleDigitSigned, t);
    case 2:
      return Ze(ct.twoDigitsSigned, t);
    case 3:
      return Ze(ct.threeDigitsSigned, t);
    case 4:
      return Ze(ct.fourDigitsSigned, t);
    default:
      return Ze(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function pf(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Hy(e, t) {
  var n = t > 0,
    r = n ? t : 1 - t,
    a;
  if (r <= 50) a = e || 100;else {
    var i = r + 50,
      o = Math.floor(i / 100) * 100,
      s = e >= i % 100;
    a = e + o - (s ? 100 : 0);
  }
  return n ? a : 1 - a;
}
function Wy(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function li(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? li = function li(n) {
    return typeof n;
  } : li = function li(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, li(e);
}
function lE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Eh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function cE(e, t, n) {
  return t && Eh(e.prototype, t), n && Eh(e, n), e;
}
function fE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && ju(e, t);
}
function ju(e, t) {
  return ju = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, ju(e, t);
}
function dE(e) {
  var t = pE();
  return function () {
    var r = no(e),
      a;
    if (t) {
      var i = no(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return hE(this, a);
  };
}
function hE(e, t) {
  return t && (li(t) === "object" || typeof t == "function") ? t : Bu(e);
}
function Bu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused13) {
    return !1;
  }
}
function no(e) {
  return no = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, no(e);
}
function Ph(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var mE = /* @__PURE__ */function (e) {
  fE(n, e);
  var t = dE(n);
  function n() {
    var r;
    lE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Ph(Bu(r), "priority", 130), Ph(Bu(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return cE(n, [{
    key: "parse",
    value: function value(a, i, o) {
      var s = function s(l) {
        return {
          year: l,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return ft(st(4, a), s);
        case "yo":
          return ft(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return ft(st(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      var s = a.getUTCFullYear();
      if (o.isTwoDigitYear) {
        var u = Hy(o.year, s);
        return a.setUTCFullYear(u, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
      }
      var l = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(l, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function ci(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ci = function ci(n) {
    return typeof n;
  } : ci = function ci(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ci(e);
}
function vE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Th(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function yE(e, t, n) {
  return t && Th(e.prototype, t), n && Th(e, n), e;
}
function gE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Vu(e, t);
}
function Vu(e, t) {
  return Vu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Vu(e, t);
}
function bE(e) {
  var t = wE();
  return function () {
    var r = ro(e),
      a;
    if (t) {
      var i = ro(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return _E(this, a);
  };
}
function _E(e, t) {
  return t && (ci(t) === "object" || typeof t == "function") ? t : qu(e);
}
function qu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function wE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused14) {
    return !1;
  }
}
function ro(e) {
  return ro = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ro(e);
}
function kh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var OE = /* @__PURE__ */function (e) {
  gE(n, e);
  var t = bE(n);
  function n() {
    var r;
    vE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), kh(qu(r), "priority", 130), kh(qu(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return yE(n, [{
    key: "parse",
    value: function value(a, i, o) {
      var s = function s(l) {
        return {
          year: l,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return ft(st(4, a), s);
        case "Yo":
          return ft(o.ordinalNumber(a, {
            unit: "year"
          }), s);
        default:
          return ft(st(i.length, a), s);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function value(a, i, o, s) {
      var u = ff(a, s);
      if (o.isTwoDigitYear) {
        var l = Hy(o.year, u);
        return a.setUTCFullYear(l, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), un(a, s);
      }
      var c = !("era" in i) || i.era === 1 ? o.year : 1 - o.year;
      return a.setUTCFullYear(c, 0, s.firstWeekContainsDate), a.setUTCHours(0, 0, 0, 0), un(a, s);
    }
  }]), n;
}(Ae);
function fi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fi = function fi(n) {
    return typeof n;
  } : fi = function fi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, fi(e);
}
function SE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Dh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function EE(e, t, n) {
  return t && Dh(e.prototype, t), n && Dh(e, n), e;
}
function PE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Uu(e, t);
}
function Uu(e, t) {
  return Uu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Uu(e, t);
}
function TE(e) {
  var t = DE();
  return function () {
    var r = ao(e),
      a;
    if (t) {
      var i = ao(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return kE(this, a);
  };
}
function kE(e, t) {
  return t && (fi(t) === "object" || typeof t == "function") ? t : zu(e);
}
function zu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused15) {
    return !1;
  }
}
function ao(e) {
  return ao = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ao(e);
}
function xh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var xE = /* @__PURE__ */function (e) {
  PE(n, e);
  var t = TE(n);
  function n() {
    var r;
    SE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), xh(zu(r), "priority", 130), xh(zu(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return EE(n, [{
    key: "parse",
    value: function value(a, i) {
      return to(i === "R" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      var s = new Date(0);
      return s.setUTCFullYear(o, 0, 4), s.setUTCHours(0, 0, 0, 0), Or(s);
    }
  }]), n;
}(Ae);
function di(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? di = function di(n) {
    return typeof n;
  } : di = function di(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, di(e);
}
function $E(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $h(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function CE(e, t, n) {
  return t && $h(e.prototype, t), n && $h(e, n), e;
}
function RE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Hu(e, t);
}
function Hu(e, t) {
  return Hu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Hu(e, t);
}
function NE(e) {
  var t = IE();
  return function () {
    var r = io(e),
      a;
    if (t) {
      var i = io(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return AE(this, a);
  };
}
function AE(e, t) {
  return t && (di(t) === "object" || typeof t == "function") ? t : Wu(e);
}
function Wu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function IE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused16) {
    return !1;
  }
}
function io(e) {
  return io = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, io(e);
}
function Ch(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var ME = /* @__PURE__ */function (e) {
  RE(n, e);
  var t = NE(n);
  function n() {
    var r;
    $E(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Ch(Wu(r), "priority", 130), Ch(Wu(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return CE(n, [{
    key: "parse",
    value: function value(a, i) {
      return to(i === "u" ? 4 : i.length, a);
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCFullYear(o, 0, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function hi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hi = function hi(n) {
    return typeof n;
  } : hi = function hi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, hi(e);
}
function FE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Rh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function LE(e, t, n) {
  return t && Rh(e.prototype, t), n && Rh(e, n), e;
}
function jE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Gu(e, t);
}
function Gu(e, t) {
  return Gu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Gu(e, t);
}
function BE(e) {
  var t = qE();
  return function () {
    var r = oo(e),
      a;
    if (t) {
      var i = oo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return VE(this, a);
  };
}
function VE(e, t) {
  return t && (hi(t) === "object" || typeof t == "function") ? t : Yu(e);
}
function Yu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused17) {
    return !1;
  }
}
function oo(e) {
  return oo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, oo(e);
}
function Nh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var UE = /* @__PURE__ */function (e) {
  jE(n, e);
  var t = BE(n);
  function n() {
    var r;
    FE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Nh(Yu(r), "priority", 120), Nh(Yu(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return LE(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "Q":
        case "QQ":
          return st(i.length, a);
        case "Qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "QQQ":
          return o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "formatting"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.quarter(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function pi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pi = function pi(n) {
    return typeof n;
  } : pi = function pi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, pi(e);
}
function zE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ah(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function HE(e, t, n) {
  return t && Ah(e.prototype, t), n && Ah(e, n), e;
}
function WE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Qu(e, t);
}
function Qu(e, t) {
  return Qu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Qu(e, t);
}
function GE(e) {
  var t = QE();
  return function () {
    var r = so(e),
      a;
    if (t) {
      var i = so(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return YE(this, a);
  };
}
function YE(e, t) {
  return t && (pi(t) === "object" || typeof t == "function") ? t : Ku(e);
}
function Ku(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function QE() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused18) {
    return !1;
  }
}
function so(e) {
  return so = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, so(e);
}
function Ih(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var KE = /* @__PURE__ */function (e) {
  WE(n, e);
  var t = GE(n);
  function n() {
    var r;
    zE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Ih(Ku(r), "priority", 120), Ih(Ku(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return HE(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "q":
        case "qq":
          return st(i.length, a);
        case "qo":
          return o.ordinalNumber(a, {
            unit: "quarter"
          });
        case "qqq":
          return o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return o.quarter(a, {
            width: "wide",
            context: "standalone"
          }) || o.quarter(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.quarter(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMonth((o - 1) * 3, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function mi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mi = function mi(n) {
    return typeof n;
  } : mi = function mi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, mi(e);
}
function JE(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Mh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function XE(e, t, n) {
  return t && Mh(e.prototype, t), n && Mh(e, n), e;
}
function ZE(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Ju(e, t);
}
function Ju(e, t) {
  return Ju = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Ju(e, t);
}
function eP(e) {
  var t = nP();
  return function () {
    var r = uo(e),
      a;
    if (t) {
      var i = uo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return tP(this, a);
  };
}
function tP(e, t) {
  return t && (mi(t) === "object" || typeof t == "function") ? t : Xu(e);
}
function Xu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused19) {
    return !1;
  }
}
function uo(e) {
  return uo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, uo(e);
}
function Fh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var rP = /* @__PURE__ */function (e) {
  ZE(n, e);
  var t = eP(n);
  function n() {
    var r;
    JE(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Fh(Xu(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), Fh(Xu(r), "priority", 110), r;
  }
  return XE(n, [{
    key: "parse",
    value: function value(a, i, o) {
      var s = function s(l) {
        return l - 1;
      };
      switch (i) {
        case "M":
          return ft(Ze(ct.month, a), s);
        case "MM":
          return ft(st(2, a), s);
        case "Mo":
          return ft(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "MMM":
          return o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return o.month(a, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return o.month(a, {
            width: "wide",
            context: "formatting"
          }) || o.month(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.month(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function vi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? vi = function vi(n) {
    return typeof n;
  } : vi = function vi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, vi(e);
}
function aP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Lh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function iP(e, t, n) {
  return t && Lh(e.prototype, t), n && Lh(e, n), e;
}
function oP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Zu(e, t);
}
function Zu(e, t) {
  return Zu = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Zu(e, t);
}
function sP(e) {
  var t = lP();
  return function () {
    var r = lo(e),
      a;
    if (t) {
      var i = lo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return uP(this, a);
  };
}
function uP(e, t) {
  return t && (vi(t) === "object" || typeof t == "function") ? t : el(e);
}
function el(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function lP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused20) {
    return !1;
  }
}
function lo(e) {
  return lo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, lo(e);
}
function jh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var cP = /* @__PURE__ */function (e) {
  oP(n, e);
  var t = sP(n);
  function n() {
    var r;
    aP(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), jh(el(r), "priority", 110), jh(el(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return iP(n, [{
    key: "parse",
    value: function value(a, i, o) {
      var s = function s(l) {
        return l - 1;
      };
      switch (i) {
        case "L":
          return ft(Ze(ct.month, a), s);
        case "LL":
          return ft(st(2, a), s);
        case "Lo":
          return ft(o.ordinalNumber(a, {
            unit: "month"
          }), s);
        case "LLL":
          return o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return o.month(a, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return o.month(a, {
            width: "wide",
            context: "standalone"
          }) || o.month(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.month(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMonth(o, 1), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function fP(e, t, n) {
  De(2, arguments);
  var r = qe(e),
    a = ot(t),
    i = Ry(r, n) - a;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
function yi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yi = function yi(n) {
    return typeof n;
  } : yi = function yi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, yi(e);
}
function dP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Bh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hP(e, t, n) {
  return t && Bh(e.prototype, t), n && Bh(e, n), e;
}
function pP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && tl(e, t);
}
function tl(e, t) {
  return tl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, tl(e, t);
}
function mP(e) {
  var t = yP();
  return function () {
    var r = co(e),
      a;
    if (t) {
      var i = co(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return vP(this, a);
  };
}
function vP(e, t) {
  return t && (yi(t) === "object" || typeof t == "function") ? t : nl(e);
}
function nl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function yP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused21) {
    return !1;
  }
}
function co(e) {
  return co = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, co(e);
}
function Vh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var gP = /* @__PURE__ */function (e) {
  pP(n, e);
  var t = mP(n);
  function n() {
    var r;
    dP(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Vh(nl(r), "priority", 100), Vh(nl(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return hP(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "w":
          return Ze(ct.week, a);
        case "wo":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function value(a, i, o, s) {
      return un(fP(a, o, s), s);
    }
  }]), n;
}(Ae);
function bP(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = ot(t),
    a = Cy(n) - r;
  return n.setUTCDate(n.getUTCDate() - a * 7), n;
}
function gi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? gi = function gi(n) {
    return typeof n;
  } : gi = function gi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, gi(e);
}
function _P(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function qh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function wP(e, t, n) {
  return t && qh(e.prototype, t), n && qh(e, n), e;
}
function OP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && rl(e, t);
}
function rl(e, t) {
  return rl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, rl(e, t);
}
function SP(e) {
  var t = PP();
  return function () {
    var r = fo(e),
      a;
    if (t) {
      var i = fo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return EP(this, a);
  };
}
function EP(e, t) {
  return t && (gi(t) === "object" || typeof t == "function") ? t : al(e);
}
function al(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function PP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused22) {
    return !1;
  }
}
function fo(e) {
  return fo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, fo(e);
}
function Uh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var TP = /* @__PURE__ */function (e) {
  OP(n, e);
  var t = SP(n);
  function n() {
    var r;
    _P(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Uh(al(r), "priority", 100), Uh(al(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return wP(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "I":
          return Ze(ct.week, a);
        case "Io":
          return o.ordinalNumber(a, {
            unit: "week"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return Or(bP(a, o));
    }
  }]), n;
}(Ae);
function bi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? bi = function bi(n) {
    return typeof n;
  } : bi = function bi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, bi(e);
}
function kP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function zh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function DP(e, t, n) {
  return t && zh(e.prototype, t), n && zh(e, n), e;
}
function xP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && il(e, t);
}
function il(e, t) {
  return il = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, il(e, t);
}
function $P(e) {
  var t = RP();
  return function () {
    var r = ho(e),
      a;
    if (t) {
      var i = ho(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return CP(this, a);
  };
}
function CP(e, t) {
  return t && (bi(t) === "object" || typeof t == "function") ? t : _i(e);
}
function _i(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function RP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused23) {
    return !1;
  }
}
function ho(e) {
  return ho = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ho(e);
}
function As(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var NP = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  AP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  IP = /* @__PURE__ */function (e) {
    xP(n, e);
    var t = $P(n);
    function n() {
      var r;
      kP(this, n);
      for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return r = t.call.apply(t, [this].concat(i)), As(_i(r), "priority", 90), As(_i(r), "subPriority", 1), As(_i(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
    }
    return DP(n, [{
      key: "parse",
      value: function value(a, i, o) {
        switch (i) {
          case "d":
            return Ze(ct.date, a);
          case "do":
            return o.ordinalNumber(a, {
              unit: "date"
            });
          default:
            return st(i.length, a);
        }
      }
    }, {
      key: "validate",
      value: function value(a, i) {
        var o = a.getUTCFullYear(),
          s = Wy(o),
          u = a.getUTCMonth();
        return s ? i >= 1 && i <= AP[u] : i >= 1 && i <= NP[u];
      }
    }, {
      key: "set",
      value: function value(a, i, o) {
        return a.setUTCDate(o), a.setUTCHours(0, 0, 0, 0), a;
      }
    }]), n;
  }(Ae);
function wi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? wi = function wi(n) {
    return typeof n;
  } : wi = function wi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, wi(e);
}
function MP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Hh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function FP(e, t, n) {
  return t && Hh(e.prototype, t), n && Hh(e, n), e;
}
function LP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && ol(e, t);
}
function ol(e, t) {
  return ol = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, ol(e, t);
}
function jP(e) {
  var t = VP();
  return function () {
    var r = po(e),
      a;
    if (t) {
      var i = po(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return BP(this, a);
  };
}
function BP(e, t) {
  return t && (wi(t) === "object" || typeof t == "function") ? t : Oi(e);
}
function Oi(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused24) {
    return !1;
  }
}
function po(e) {
  return po = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, po(e);
}
function Is(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var qP = /* @__PURE__ */function (e) {
  LP(n, e);
  var t = jP(n);
  function n() {
    var r;
    MP(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Is(Oi(r), "priority", 90), Is(Oi(r), "subpriority", 1), Is(Oi(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return FP(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "D":
        case "DD":
          return Ze(ct.dayOfYear, a);
        case "Do":
          return o.ordinalNumber(a, {
            unit: "date"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      var o = a.getUTCFullYear(),
        s = Wy(o);
      return s ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMonth(0, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function mf(e, t, n) {
  var r, a, i, o, s, u, l, c;
  De(2, arguments);
  var f = $n(),
    h = ot((r = (a = (i = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (s = n.locale) === null || s === void 0 || (u = s.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && a !== void 0 ? a : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(h >= 0 && h <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = qe(e),
    v = ot(t),
    m = p.getUTCDay(),
    g = v % 7,
    b = (g + 7) % 7,
    y = (b < h ? 7 : 0) + v - m;
  return p.setUTCDate(p.getUTCDate() + y), p;
}
function Si(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Si = function Si(n) {
    return typeof n;
  } : Si = function Si(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Si(e);
}
function UP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Wh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function zP(e, t, n) {
  return t && Wh(e.prototype, t), n && Wh(e, n), e;
}
function HP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && sl(e, t);
}
function sl(e, t) {
  return sl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, sl(e, t);
}
function WP(e) {
  var t = YP();
  return function () {
    var r = mo(e),
      a;
    if (t) {
      var i = mo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return GP(this, a);
  };
}
function GP(e, t) {
  return t && (Si(t) === "object" || typeof t == "function") ? t : ul(e);
}
function ul(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function YP() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused25) {
    return !1;
  }
}
function mo(e) {
  return mo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, mo(e);
}
function Gh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var QP = /* @__PURE__ */function (e) {
  HP(n, e);
  var t = WP(n);
  function n() {
    var r;
    UP(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Gh(ul(r), "priority", 90), Gh(ul(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return zP(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function value(a, i, o, s) {
      return a = mf(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ei(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ei = function Ei(n) {
    return typeof n;
  } : Ei = function Ei(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ei(e);
}
function KP(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Yh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function JP(e, t, n) {
  return t && Yh(e.prototype, t), n && Yh(e, n), e;
}
function XP(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && ll(e, t);
}
function ll(e, t) {
  return ll = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, ll(e, t);
}
function ZP(e) {
  var t = tT();
  return function () {
    var r = vo(e),
      a;
    if (t) {
      var i = vo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return eT(this, a);
  };
}
function eT(e, t) {
  return t && (Ei(t) === "object" || typeof t == "function") ? t : cl(e);
}
function cl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused26) {
    return !1;
  }
}
function vo(e) {
  return vo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, vo(e);
}
function Qh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var nT = /* @__PURE__ */function (e) {
  XP(n, e);
  var t = ZP(n);
  function n() {
    var r;
    KP(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Qh(cl(r), "priority", 90), Qh(cl(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return JP(n, [{
    key: "parse",
    value: function value(a, i, o, s) {
      var u = function u(c) {
        var f = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "e":
        case "ee":
          return ft(st(i.length, a), u);
        case "eo":
          return ft(o.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "eee":
          return o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function value(a, i, o, s) {
      return a = mf(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Pi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Pi = function Pi(n) {
    return typeof n;
  } : Pi = function Pi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Pi(e);
}
function rT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Kh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function aT(e, t, n) {
  return t && Kh(e.prototype, t), n && Kh(e, n), e;
}
function iT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && fl(e, t);
}
function fl(e, t) {
  return fl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, fl(e, t);
}
function oT(e) {
  var t = uT();
  return function () {
    var r = yo(e),
      a;
    if (t) {
      var i = yo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return sT(this, a);
  };
}
function sT(e, t) {
  return t && (Pi(t) === "object" || typeof t == "function") ? t : dl(e);
}
function dl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused27) {
    return !1;
  }
}
function yo(e) {
  return yo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, yo(e);
}
function Jh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var lT = /* @__PURE__ */function (e) {
  iT(n, e);
  var t = oT(n);
  function n() {
    var r;
    rT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Jh(dl(r), "priority", 90), Jh(dl(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return aT(n, [{
    key: "parse",
    value: function value(a, i, o, s) {
      var u = function u(c) {
        var f = Math.floor((c - 1) / 7) * 7;
        return (c + s.weekStartsOn + 6) % 7 + f;
      };
      switch (i) {
        case "c":
        case "cc":
          return ft(st(i.length, a), u);
        case "co":
          return ft(o.ordinalNumber(a, {
            unit: "day"
          }), u);
        case "ccc":
          return o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return o.day(a, {
            width: "wide",
            context: "standalone"
          }) || o.day(a, {
            width: "abbreviated",
            context: "standalone"
          }) || o.day(a, {
            width: "short",
            context: "standalone"
          }) || o.day(a, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function value(a, i, o, s) {
      return a = mf(a, o, s), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function cT(e, t) {
  De(2, arguments);
  var n = ot(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1,
    a = qe(e),
    i = a.getUTCDay(),
    o = n % 7,
    s = (o + 7) % 7,
    u = (s < r ? 7 : 0) + n - i;
  return a.setUTCDate(a.getUTCDate() + u), a;
}
function Ti(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ti = function Ti(n) {
    return typeof n;
  } : Ti = function Ti(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ti(e);
}
function fT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Xh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function dT(e, t, n) {
  return t && Xh(e.prototype, t), n && Xh(e, n), e;
}
function hT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && hl(e, t);
}
function hl(e, t) {
  return hl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, hl(e, t);
}
function pT(e) {
  var t = vT();
  return function () {
    var r = go(e),
      a;
    if (t) {
      var i = go(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return mT(this, a);
  };
}
function mT(e, t) {
  return t && (Ti(t) === "object" || typeof t == "function") ? t : pl(e);
}
function pl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused28) {
    return !1;
  }
}
function go(e) {
  return go = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, go(e);
}
function Zh(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var yT = /* @__PURE__ */function (e) {
  hT(n, e);
  var t = pT(n);
  function n() {
    var r;
    fT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Zh(pl(r), "priority", 90), Zh(pl(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return dT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      var s = function s(l) {
        return l === 0 ? 7 : l;
      };
      switch (i) {
        case "i":
        case "ii":
          return st(i.length, a);
        case "io":
          return o.ordinalNumber(a, {
            unit: "day"
          });
        case "iii":
          return ft(o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiii":
          return ft(o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiiiii":
          return ft(o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
        case "iiii":
        default:
          return ft(o.day(a, {
            width: "wide",
            context: "formatting"
          }) || o.day(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(a, {
            width: "short",
            context: "formatting"
          }) || o.day(a, {
            width: "narrow",
            context: "formatting"
          }), s);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a = cT(a, o), a.setUTCHours(0, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function ki(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ki = function ki(n) {
    return typeof n;
  } : ki = function ki(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ki(e);
}
function gT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ep(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function bT(e, t, n) {
  return t && ep(e.prototype, t), n && ep(e, n), e;
}
function _T(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && ml(e, t);
}
function ml(e, t) {
  return ml = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, ml(e, t);
}
function wT(e) {
  var t = ST();
  return function () {
    var r = bo(e),
      a;
    if (t) {
      var i = bo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return OT(this, a);
  };
}
function OT(e, t) {
  return t && (ki(t) === "object" || typeof t == "function") ? t : vl(e);
}
function vl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ST() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused29) {
    return !1;
  }
}
function bo(e) {
  return bo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, bo(e);
}
function tp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var ET = /* @__PURE__ */function (e) {
  _T(n, e);
  var t = wT(n);
  function n() {
    var r;
    gT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), tp(vl(r), "priority", 80), tp(vl(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return bT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCHours(pf(o), 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Di(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Di = function Di(n) {
    return typeof n;
  } : Di = function Di(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Di(e);
}
function PT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function np(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function TT(e, t, n) {
  return t && np(e.prototype, t), n && np(e, n), e;
}
function kT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && yl(e, t);
}
function yl(e, t) {
  return yl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, yl(e, t);
}
function DT(e) {
  var t = $T();
  return function () {
    var r = _o(e),
      a;
    if (t) {
      var i = _o(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return xT(this, a);
  };
}
function xT(e, t) {
  return t && (Di(t) === "object" || typeof t == "function") ? t : gl(e);
}
function gl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function $T() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused30) {
    return !1;
  }
}
function _o(e) {
  return _o = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _o(e);
}
function rp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var CT = /* @__PURE__ */function (e) {
  kT(n, e);
  var t = DT(n);
  function n() {
    var r;
    PT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), rp(gl(r), "priority", 80), rp(gl(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return TT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCHours(pf(o), 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function xi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? xi = function xi(n) {
    return typeof n;
  } : xi = function xi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, xi(e);
}
function RT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ap(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function NT(e, t, n) {
  return t && ap(e.prototype, t), n && ap(e, n), e;
}
function AT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && bl(e, t);
}
function bl(e, t) {
  return bl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, bl(e, t);
}
function IT(e) {
  var t = FT();
  return function () {
    var r = wo(e),
      a;
    if (t) {
      var i = wo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return MT(this, a);
  };
}
function MT(e, t) {
  return t && (xi(t) === "object" || typeof t == "function") ? t : _l(e);
}
function _l(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused31) {
    return !1;
  }
}
function wo(e) {
  return wo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, wo(e);
}
function ip(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var LT = /* @__PURE__ */function (e) {
  AT(n, e);
  var t = IT(n);
  function n() {
    var r;
    RT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), ip(_l(r), "priority", 80), ip(_l(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return NT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return o.dayPeriod(a, {
            width: "wide",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting"
          }) || o.dayPeriod(a, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCHours(pf(o), 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function $i(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $i = function $i(n) {
    return typeof n;
  } : $i = function $i(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, $i(e);
}
function jT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function op(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function BT(e, t, n) {
  return t && op(e.prototype, t), n && op(e, n), e;
}
function VT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && wl(e, t);
}
function wl(e, t) {
  return wl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, wl(e, t);
}
function qT(e) {
  var t = zT();
  return function () {
    var r = Oo(e),
      a;
    if (t) {
      var i = Oo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return UT(this, a);
  };
}
function UT(e, t) {
  return t && ($i(t) === "object" || typeof t == "function") ? t : Ol(e);
}
function Ol(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused32) {
    return !1;
  }
}
function Oo(e) {
  return Oo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Oo(e);
}
function sp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var HT = /* @__PURE__ */function (e) {
  VT(n, e);
  var t = qT(n);
  function n() {
    var r;
    jT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), sp(Ol(r), "priority", 70), sp(Ol(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return BT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "h":
          return Ze(ct.hour12h, a);
        case "ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : !s && o === 12 ? a.setUTCHours(0, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ci(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ci = function Ci(n) {
    return typeof n;
  } : Ci = function Ci(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ci(e);
}
function WT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function up(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function GT(e, t, n) {
  return t && up(e.prototype, t), n && up(e, n), e;
}
function YT(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Sl(e, t);
}
function Sl(e, t) {
  return Sl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Sl(e, t);
}
function QT(e) {
  var t = JT();
  return function () {
    var r = So(e),
      a;
    if (t) {
      var i = So(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return KT(this, a);
  };
}
function KT(e, t) {
  return t && (Ci(t) === "object" || typeof t == "function") ? t : El(e);
}
function El(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JT() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused33) {
    return !1;
  }
}
function So(e) {
  return So = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, So(e);
}
function lp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var XT = /* @__PURE__ */function (e) {
  YT(n, e);
  var t = QT(n);
  function n() {
    var r;
    WT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), lp(El(r), "priority", 70), lp(El(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return GT(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "H":
          return Ze(ct.hour23h, a);
        case "Ho":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ri(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ri = function Ri(n) {
    return typeof n;
  } : Ri = function Ri(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ri(e);
}
function ZT(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function cp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ek(e, t, n) {
  return t && cp(e.prototype, t), n && cp(e, n), e;
}
function tk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Pl(e, t);
}
function Pl(e, t) {
  return Pl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Pl(e, t);
}
function nk(e) {
  var t = ak();
  return function () {
    var r = Eo(e),
      a;
    if (t) {
      var i = Eo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return rk(this, a);
  };
}
function rk(e, t) {
  return t && (Ri(t) === "object" || typeof t == "function") ? t : Tl(e);
}
function Tl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ak() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused34) {
    return !1;
  }
}
function Eo(e) {
  return Eo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Eo(e);
}
function fp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var ik = /* @__PURE__ */function (e) {
  tk(n, e);
  var t = nk(n);
  function n() {
    var r;
    ZT(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), fp(Tl(r), "priority", 70), fp(Tl(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return ek(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "K":
          return Ze(ct.hour11h, a);
        case "Ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      var s = a.getUTCHours() >= 12;
      return s && o < 12 ? a.setUTCHours(o + 12, 0, 0, 0) : a.setUTCHours(o, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ni(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ni = function Ni(n) {
    return typeof n;
  } : Ni = function Ni(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ni(e);
}
function ok(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function dp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function sk(e, t, n) {
  return t && dp(e.prototype, t), n && dp(e, n), e;
}
function uk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && kl(e, t);
}
function kl(e, t) {
  return kl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, kl(e, t);
}
function lk(e) {
  var t = fk();
  return function () {
    var r = Po(e),
      a;
    if (t) {
      var i = Po(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return ck(this, a);
  };
}
function ck(e, t) {
  return t && (Ni(t) === "object" || typeof t == "function") ? t : Dl(e);
}
function Dl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused35) {
    return !1;
  }
}
function Po(e) {
  return Po = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Po(e);
}
function hp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var dk = /* @__PURE__ */function (e) {
  uk(n, e);
  var t = lk(n);
  function n() {
    var r;
    ok(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), hp(Dl(r), "priority", 70), hp(Dl(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return sk(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "k":
          return Ze(ct.hour24h, a);
        case "ko":
          return o.ordinalNumber(a, {
            unit: "hour"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      var s = o <= 24 ? o % 24 : o;
      return a.setUTCHours(s, 0, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ai(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ai = function Ai(n) {
    return typeof n;
  } : Ai = function Ai(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ai(e);
}
function hk(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function pp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function pk(e, t, n) {
  return t && pp(e.prototype, t), n && pp(e, n), e;
}
function mk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && xl(e, t);
}
function xl(e, t) {
  return xl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, xl(e, t);
}
function vk(e) {
  var t = gk();
  return function () {
    var r = To(e),
      a;
    if (t) {
      var i = To(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return yk(this, a);
  };
}
function yk(e, t) {
  return t && (Ai(t) === "object" || typeof t == "function") ? t : $l(e);
}
function $l(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function gk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused36) {
    return !1;
  }
}
function To(e) {
  return To = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, To(e);
}
function mp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var bk = /* @__PURE__ */function (e) {
  mk(n, e);
  var t = vk(n);
  function n() {
    var r;
    hk(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), mp($l(r), "priority", 60), mp($l(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return pk(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "m":
          return Ze(ct.minute, a);
        case "mo":
          return o.ordinalNumber(a, {
            unit: "minute"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMinutes(o, 0, 0), a;
    }
  }]), n;
}(Ae);
function Ii(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ii = function Ii(n) {
    return typeof n;
  } : Ii = function Ii(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Ii(e);
}
function _k(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function vp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function wk(e, t, n) {
  return t && vp(e.prototype, t), n && vp(e, n), e;
}
function Ok(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Cl(e, t);
}
function Cl(e, t) {
  return Cl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Cl(e, t);
}
function Sk(e) {
  var t = Pk();
  return function () {
    var r = ko(e),
      a;
    if (t) {
      var i = ko(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Ek(this, a);
  };
}
function Ek(e, t) {
  return t && (Ii(t) === "object" || typeof t == "function") ? t : Rl(e);
}
function Rl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Pk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused37) {
    return !1;
  }
}
function ko(e) {
  return ko = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ko(e);
}
function yp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Tk = /* @__PURE__ */function (e) {
  Ok(n, e);
  var t = Sk(n);
  function n() {
    var r;
    _k(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), yp(Rl(r), "priority", 50), yp(Rl(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return wk(n, [{
    key: "parse",
    value: function value(a, i, o) {
      switch (i) {
        case "s":
          return Ze(ct.second, a);
        case "so":
          return o.ordinalNumber(a, {
            unit: "second"
          });
        default:
          return st(i.length, a);
      }
    }
  }, {
    key: "validate",
    value: function value(a, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCSeconds(o, 0), a;
    }
  }]), n;
}(Ae);
function Mi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Mi = function Mi(n) {
    return typeof n;
  } : Mi = function Mi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Mi(e);
}
function kk(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function gp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Dk(e, t, n) {
  return t && gp(e.prototype, t), n && gp(e, n), e;
}
function xk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Nl(e, t);
}
function Nl(e, t) {
  return Nl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Nl(e, t);
}
function $k(e) {
  var t = Rk();
  return function () {
    var r = Do(e),
      a;
    if (t) {
      var i = Do(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Ck(this, a);
  };
}
function Ck(e, t) {
  return t && (Mi(t) === "object" || typeof t == "function") ? t : Al(e);
}
function Al(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused38) {
    return !1;
  }
}
function Do(e) {
  return Do = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Do(e);
}
function bp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Nk = /* @__PURE__ */function (e) {
  xk(n, e);
  var t = $k(n);
  function n() {
    var r;
    kk(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), bp(Al(r), "priority", 30), bp(Al(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Dk(n, [{
    key: "parse",
    value: function value(a, i) {
      var o = function o(u) {
        return Math.floor(u * Math.pow(10, -i.length + 3));
      };
      return ft(st(i.length, a), o);
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return a.setUTCMilliseconds(o), a;
    }
  }]), n;
}(Ae);
function Fi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Fi = function Fi(n) {
    return typeof n;
  } : Fi = function Fi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Fi(e);
}
function Ak(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _p(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ik(e, t, n) {
  return t && _p(e.prototype, t), n && _p(e, n), e;
}
function Mk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Il(e, t);
}
function Il(e, t) {
  return Il = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Il(e, t);
}
function Fk(e) {
  var t = jk();
  return function () {
    var r = xo(e),
      a;
    if (t) {
      var i = xo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Lk(this, a);
  };
}
function Lk(e, t) {
  return t && (Fi(t) === "object" || typeof t == "function") ? t : Ml(e);
}
function Ml(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused39) {
    return !1;
  }
}
function xo(e) {
  return xo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, xo(e);
}
function wp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Bk = /* @__PURE__ */function (e) {
  Mk(n, e);
  var t = Fk(n);
  function n() {
    var r;
    Ak(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), wp(Ml(r), "priority", 10), wp(Ml(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Ik(n, [{
    key: "parse",
    value: function value(a, i) {
      switch (i) {
        case "X":
          return Qt(Yt.basicOptionalMinutes, a);
        case "XX":
          return Qt(Yt.basic, a);
        case "XXXX":
          return Qt(Yt.basicOptionalSeconds, a);
        case "XXXXX":
          return Qt(Yt.extendedOptionalSeconds, a);
        case "XXX":
        default:
          return Qt(Yt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(Ae);
function Li(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Li = function Li(n) {
    return typeof n;
  } : Li = function Li(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Li(e);
}
function Vk(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Op(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function qk(e, t, n) {
  return t && Op(e.prototype, t), n && Op(e, n), e;
}
function Uk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Fl(e, t);
}
function Fl(e, t) {
  return Fl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Fl(e, t);
}
function zk(e) {
  var t = Wk();
  return function () {
    var r = $o(e),
      a;
    if (t) {
      var i = $o(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Hk(this, a);
  };
}
function Hk(e, t) {
  return t && (Li(t) === "object" || typeof t == "function") ? t : Ll(e);
}
function Ll(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Wk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused40) {
    return !1;
  }
}
function $o(e) {
  return $o = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $o(e);
}
function Sp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Gk = /* @__PURE__ */function (e) {
  Uk(n, e);
  var t = zk(n);
  function n() {
    var r;
    Vk(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Sp(Ll(r), "priority", 10), Sp(Ll(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return qk(n, [{
    key: "parse",
    value: function value(a, i) {
      switch (i) {
        case "x":
          return Qt(Yt.basicOptionalMinutes, a);
        case "xx":
          return Qt(Yt.basic, a);
        case "xxxx":
          return Qt(Yt.basicOptionalSeconds, a);
        case "xxxxx":
          return Qt(Yt.extendedOptionalSeconds, a);
        case "xxx":
        default:
          return Qt(Yt.extended, a);
      }
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return i.timestampIsSet ? a : new Date(a.getTime() - o);
    }
  }]), n;
}(Ae);
function ji(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ji = function ji(n) {
    return typeof n;
  } : ji = function ji(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, ji(e);
}
function Yk(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Ep(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Qk(e, t, n) {
  return t && Ep(e.prototype, t), n && Ep(e, n), e;
}
function Kk(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && jl(e, t);
}
function jl(e, t) {
  return jl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, jl(e, t);
}
function Jk(e) {
  var t = Zk();
  return function () {
    var r = Co(e),
      a;
    if (t) {
      var i = Co(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return Xk(this, a);
  };
}
function Xk(e, t) {
  return t && (ji(t) === "object" || typeof t == "function") ? t : Bl(e);
}
function Bl(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Zk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused41) {
    return !1;
  }
}
function Co(e) {
  return Co = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Co(e);
}
function Pp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var eD = /* @__PURE__ */function (e) {
  Kk(n, e);
  var t = Jk(n);
  function n() {
    var r;
    Yk(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Pp(Bl(r), "priority", 40), Pp(Bl(r), "incompatibleTokens", "*"), r;
  }
  return Qk(n, [{
    key: "parse",
    value: function value(a) {
      return zy(a);
    }
  }, {
    key: "set",
    value: function value(a, i, o) {
      return [new Date(o * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Ae);
function Bi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Bi = function Bi(n) {
    return typeof n;
  } : Bi = function Bi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Bi(e);
}
function tD(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Tp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function nD(e, t, n) {
  return t && Tp(e.prototype, t), n && Tp(e, n), e;
}
function rD(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && Vl(e, t);
}
function Vl(e, t) {
  return Vl = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Vl(e, t);
}
function aD(e) {
  var t = oD();
  return function () {
    var r = Ro(e),
      a;
    if (t) {
      var i = Ro(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return iD(this, a);
  };
}
function iD(e, t) {
  return t && (Bi(t) === "object" || typeof t == "function") ? t : ql(e);
}
function ql(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function oD() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused42) {
    return !1;
  }
}
function Ro(e) {
  return Ro = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ro(e);
}
function kp(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var sD = /* @__PURE__ */function (e) {
    rD(n, e);
    var t = aD(n);
    function n() {
      var r;
      tD(this, n);
      for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return r = t.call.apply(t, [this].concat(i)), kp(ql(r), "priority", 20), kp(ql(r), "incompatibleTokens", "*"), r;
    }
    return nD(n, [{
      key: "parse",
      value: function value(a) {
        return zy(a);
      }
    }, {
      key: "set",
      value: function value(a, i, o) {
        return [new Date(o), {
          timestampIsSet: !0
        }];
      }
    }]), n;
  }(Ae),
  uD = {
    G: new uE(),
    y: new mE(),
    Y: new OE(),
    R: new xE(),
    u: new ME(),
    Q: new UE(),
    q: new KE(),
    M: new rP(),
    L: new cP(),
    w: new gP(),
    I: new TP(),
    d: new IP(),
    D: new qP(),
    E: new QP(),
    e: new nT(),
    c: new lT(),
    i: new yT(),
    a: new ET(),
    b: new CT(),
    B: new LT(),
    h: new HT(),
    H: new XT(),
    K: new ik(),
    k: new dk(),
    m: new bk(),
    s: new Tk(),
    S: new Nk(),
    X: new Bk(),
    x: new Gk(),
    t: new eD(),
    T: new sD()
  };
function Vi(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Vi = function Vi(n) {
    return typeof n;
  } : Vi = function Vi(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Vi(e);
}
function Dp(e, t) {
  var _n2;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (_n2 = lD(e)) || t && e && typeof e.length == "number") {
      _n2 && (e = _n2);
      var r = 0,
        a = function a() {};
      return {
        s: a,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(l) {
          throw l;
        },
        f: a
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var i = !0,
    o = !1,
    s;
  return {
    s: function s() {
      _n2 = e[Symbol.iterator]();
    },
    n: function n() {
      var l = _n2.next();
      return i = l.done, l;
    },
    e: function e(l) {
      o = !0, s = l;
    },
    f: function f() {
      try {
        !i && _n2.return != null && _n2.return();
      } finally {
        if (o) throw s;
      }
    }
  };
}
function lD(e, t) {
  if (e) {
    if (typeof e == "string") return xp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xp(e, t);
  }
}
function xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var cD = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  fD = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  dD = /^'([^]*?)'?$/,
  hD = /''/g,
  pD = /\S/,
  mD = /[a-zA-Z]/;
function vD(e, t, n, r) {
  var a, i, o, s, u, l, c, f, h, p, v, m, g, b, y, E, w, _;
  De(3, arguments);
  var C = String(e),
    D = String(t),
    U = $n(),
    Z = (a = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : U.locale) !== null && a !== void 0 ? a : By;
  if (!Z.match) throw new RangeError("locale must contain match property");
  var me = ot((o = (s = (u = (l = r == null ? void 0 : r.firstWeekContainsDate) !== null && l !== void 0 ? l : r == null || (c = r.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && u !== void 0 ? u : U.firstWeekContainsDate) !== null && s !== void 0 ? s : (h = U.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(me >= 1 && me <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ye = ot((v = (m = (g = (b = r == null ? void 0 : r.weekStartsOn) !== null && b !== void 0 ? b : r == null || (y = r.locale) === null || y === void 0 || (E = y.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && g !== void 0 ? g : U.weekStartsOn) !== null && m !== void 0 ? m : (w = U.locale) === null || w === void 0 || (_ = w.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(ye >= 0 && ye <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (D === "") return C === "" ? qe(n) : new Date(NaN);
  var Y = {
      firstWeekContainsDate: me,
      weekStartsOn: ye,
      locale: Z
    },
    K = [new Z2()],
    ee = D.match(fD).map(function (A) {
      var M = A[0];
      if (M in Nu) {
        var N = Nu[M];
        return N(A, Z.formatLong);
      }
      return A;
    }).join("").match(cD),
    ne = [],
    ie = Dp(ee),
    fe;
  try {
    var ce = function ce() {
      var M = fe.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Iy(M) && Xi(M, D, e), !(r != null && r.useAdditionalDayOfYearTokens) && Ay(M) && Xi(M, D, e);
      var N = M[0],
        Q = uD[N];
      if (Q) {
        var L = Q.incompatibleTokens;
        if (Array.isArray(L)) {
          var ve = ne.find(function (_e) {
            return L.includes(_e.token) || _e.token === N;
          });
          if (ve) throw new RangeError("The format string mustn't contain `".concat(ve.fullToken, "` and `").concat(M, "` at the same time"));
        } else if (Q.incompatibleTokens === "*" && ne.length > 0) throw new RangeError("The format string mustn't contain `".concat(M, "` and any other token at the same time"));
        ne.push({
          token: N,
          fullToken: M
        });
        var re = Q.run(C, M, Z.match, Y);
        if (!re) return {
          v: new Date(NaN)
        };
        K.push(re.setter), C = re.rest;
      } else {
        if (N.match(mD)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + N + "`");
        if (M === "''" ? M = "'" : N === "'" && (M = yD(M)), C.indexOf(M) === 0) C = C.slice(M.length);else return {
          v: new Date(NaN)
        };
      }
    };
    for (ie.s(); !(fe = ie.n()).done;) {
      var H = ce();
      if (Vi(H) === "object") return H.v;
    }
  } catch (A) {
    ie.e(A);
  } finally {
    ie.f();
  }
  if (C.length > 0 && pD.test(C)) return new Date(NaN);
  var O = K.map(function (A) {
      return A.priority;
    }).sort(function (A, M) {
      return M - A;
    }).filter(function (A, M, N) {
      return N.indexOf(A) === M;
    }).map(function (A) {
      return K.filter(function (M) {
        return M.priority === A;
      }).sort(function (M, N) {
        return N.subPriority - M.subPriority;
      });
    }).map(function (A) {
      return A[0];
    }),
    I = qe(n);
  if (isNaN(I.getTime())) return new Date(NaN);
  var B = xy(I, Ki(I)),
    W = {},
    G = Dp(O),
    ue;
  try {
    for (G.s(); !(ue = G.n()).done;) {
      var se = ue.value;
      if (!se.validate(B, Y)) return new Date(NaN);
      var x = se.set(B, W, Y);
      Array.isArray(x) ? (B = x[0], Y2(W, x[1])) : B = x;
    }
  } catch (A) {
    G.e(A);
  } finally {
    G.f();
  }
  return B;
}
function yD(e) {
  return e.match(dD)[1].replace(hD, "'");
}
function gD(e, t) {
  De(2, arguments);
  var n = qe(e),
    r = qe(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function Gy(e, t) {
  De(2, arguments);
  var n = ot(t);
  return Qo(e, -n);
}
function bD(e, t) {
  De(2, arguments);
  var n = ot(t);
  return Ea(e, -n);
}
function _D(e, t) {
  De(2, arguments);
  var n = ot(t);
  return zS(e, -n);
}
var Yy = {},
  Qy = {},
  k = {},
  $p = {
    get exports() {
      return k;
    },
    set exports(e) {
      k = e;
    }
  },
  ca = {},
  wD = {
    get exports() {
      return ca;
    },
    set exports(e) {
      ca = e;
    }
  },
  Ie = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cp;
function OD() {
  if (Cp) return Ie;
  Cp = 1;
  var e = typeof Symbol == "function" && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    a = e ? Symbol.for("react.strict_mode") : 60108,
    i = e ? Symbol.for("react.profiler") : 60114,
    o = e ? Symbol.for("react.provider") : 60109,
    s = e ? Symbol.for("react.context") : 60110,
    u = e ? Symbol.for("react.async_mode") : 60111,
    l = e ? Symbol.for("react.concurrent_mode") : 60111,
    c = e ? Symbol.for("react.forward_ref") : 60112,
    f = e ? Symbol.for("react.suspense") : 60113,
    h = e ? Symbol.for("react.suspense_list") : 60120,
    p = e ? Symbol.for("react.memo") : 60115,
    v = e ? Symbol.for("react.lazy") : 60116,
    m = e ? Symbol.for("react.block") : 60121,
    g = e ? Symbol.for("react.fundamental") : 60117,
    b = e ? Symbol.for("react.responder") : 60118,
    y = e ? Symbol.for("react.scope") : 60119;
  function E(_) {
    if (typeof _ == "object" && _ !== null) {
      var C = _.$$typeof;
      switch (C) {
        case t:
          switch (_ = _.type, _) {
            case u:
            case l:
            case r:
            case i:
            case a:
            case f:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case c:
                case v:
                case p:
                case o:
                  return _;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function w(_) {
    return E(_) === l;
  }
  return Ie.AsyncMode = u, Ie.ConcurrentMode = l, Ie.ContextConsumer = s, Ie.ContextProvider = o, Ie.Element = t, Ie.ForwardRef = c, Ie.Fragment = r, Ie.Lazy = v, Ie.Memo = p, Ie.Portal = n, Ie.Profiler = i, Ie.StrictMode = a, Ie.Suspense = f, Ie.isAsyncMode = function (_) {
    return w(_) || E(_) === u;
  }, Ie.isConcurrentMode = w, Ie.isContextConsumer = function (_) {
    return E(_) === s;
  }, Ie.isContextProvider = function (_) {
    return E(_) === o;
  }, Ie.isElement = function (_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === t;
  }, Ie.isForwardRef = function (_) {
    return E(_) === c;
  }, Ie.isFragment = function (_) {
    return E(_) === r;
  }, Ie.isLazy = function (_) {
    return E(_) === v;
  }, Ie.isMemo = function (_) {
    return E(_) === p;
  }, Ie.isPortal = function (_) {
    return E(_) === n;
  }, Ie.isProfiler = function (_) {
    return E(_) === i;
  }, Ie.isStrictMode = function (_) {
    return E(_) === a;
  }, Ie.isSuspense = function (_) {
    return E(_) === f;
  }, Ie.isValidElementType = function (_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === l || _ === i || _ === a || _ === f || _ === h || typeof _ == "object" && _ !== null && (_.$$typeof === v || _.$$typeof === p || _.$$typeof === o || _.$$typeof === s || _.$$typeof === c || _.$$typeof === g || _.$$typeof === b || _.$$typeof === y || _.$$typeof === m);
  }, Ie.typeOf = E, Ie;
}
var Me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rp;
function SD() {
  return Rp || (Rp = 1, process.env.NODE_ENV !== "production" && function () {
    var e = typeof Symbol == "function" && Symbol.for,
      t = e ? Symbol.for("react.element") : 60103,
      n = e ? Symbol.for("react.portal") : 60106,
      r = e ? Symbol.for("react.fragment") : 60107,
      a = e ? Symbol.for("react.strict_mode") : 60108,
      i = e ? Symbol.for("react.profiler") : 60114,
      o = e ? Symbol.for("react.provider") : 60109,
      s = e ? Symbol.for("react.context") : 60110,
      u = e ? Symbol.for("react.async_mode") : 60111,
      l = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      f = e ? Symbol.for("react.suspense") : 60113,
      h = e ? Symbol.for("react.suspense_list") : 60120,
      p = e ? Symbol.for("react.memo") : 60115,
      v = e ? Symbol.for("react.lazy") : 60116,
      m = e ? Symbol.for("react.block") : 60121,
      g = e ? Symbol.for("react.fundamental") : 60117,
      b = e ? Symbol.for("react.responder") : 60118,
      y = e ? Symbol.for("react.scope") : 60119;
    function E(L) {
      return typeof L == "string" || typeof L == "function" ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === l || L === i || L === a || L === f || L === h || typeof L == "object" && L !== null && (L.$$typeof === v || L.$$typeof === p || L.$$typeof === o || L.$$typeof === s || L.$$typeof === c || L.$$typeof === g || L.$$typeof === b || L.$$typeof === y || L.$$typeof === m);
    }
    function w(L) {
      if (typeof L == "object" && L !== null) {
        var ve = L.$$typeof;
        switch (ve) {
          case t:
            var re = L.type;
            switch (re) {
              case u:
              case l:
              case r:
              case i:
              case a:
              case f:
                return re;
              default:
                var _e = re && re.$$typeof;
                switch (_e) {
                  case s:
                  case c:
                  case v:
                  case p:
                  case o:
                    return _e;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var _ = u,
      C = l,
      D = s,
      U = o,
      Z = t,
      me = c,
      ye = r,
      Y = v,
      K = p,
      ee = n,
      ne = i,
      ie = a,
      fe = f,
      ce = !1;
    function H(L) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(L) || w(L) === u;
    }
    function O(L) {
      return w(L) === l;
    }
    function I(L) {
      return w(L) === s;
    }
    function B(L) {
      return w(L) === o;
    }
    function W(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function G(L) {
      return w(L) === c;
    }
    function ue(L) {
      return w(L) === r;
    }
    function se(L) {
      return w(L) === v;
    }
    function x(L) {
      return w(L) === p;
    }
    function A(L) {
      return w(L) === n;
    }
    function M(L) {
      return w(L) === i;
    }
    function N(L) {
      return w(L) === a;
    }
    function Q(L) {
      return w(L) === f;
    }
    Me.AsyncMode = _, Me.ConcurrentMode = C, Me.ContextConsumer = D, Me.ContextProvider = U, Me.Element = Z, Me.ForwardRef = me, Me.Fragment = ye, Me.Lazy = Y, Me.Memo = K, Me.Portal = ee, Me.Profiler = ne, Me.StrictMode = ie, Me.Suspense = fe, Me.isAsyncMode = H, Me.isConcurrentMode = O, Me.isContextConsumer = I, Me.isContextProvider = B, Me.isElement = W, Me.isForwardRef = G, Me.isFragment = ue, Me.isLazy = se, Me.isMemo = x, Me.isPortal = A, Me.isProfiler = M, Me.isStrictMode = N, Me.isSuspense = Q, Me.isValidElementType = E, Me.typeOf = w;
  }()), Me;
}
(function (e) {
  process.env.NODE_ENV === "production" ? e.exports = OD() : e.exports = SD();
})(wD);
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ms, Np;
function ED() {
  if (Np) return Ms;
  Np = 1;
  var e = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign) return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5") return !1;
      for (var o = {}, s = 0; s < 10; s++) o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function (c) {
        return o[c];
      });
      if (u.join("") !== "0123456789") return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (c) {
        l[c] = c;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch (_unused43) {
      return !1;
    }
  }
  return Ms = a() ? Object.assign : function (i, o) {
    for (var s, u = r(i), l, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s) t.call(s, f) && (u[f] = s[f]);
      if (e) {
        l = e(s);
        for (var h = 0; h < l.length; h++) n.call(s, l[h]) && (u[l[h]] = s[l[h]]);
      }
    }
    return u;
  }, Ms;
}
var Fs, Ap;
function vf() {
  if (Ap) return Fs;
  Ap = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Fs = e, Fs;
}
var Ls, Ip;
function Ky() {
  return Ip || (Ip = 1, Ls = Function.call.bind(Object.prototype.hasOwnProperty)), Ls;
}
var js, Mp;
function PD() {
  if (Mp) return js;
  Mp = 1;
  var e = function e() {};
  if (process.env.NODE_ENV !== "production") {
    var t = vf(),
      n = {},
      r = Ky();
    e = function e(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch (_unused44) {}
    };
  }
  function a(i, o, s, u, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i) if (r(i, c)) {
        var f;
        try {
          if (typeof i[c] != "function") {
            var h = Error((u || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
            throw h.name = "Invariant Violation", h;
          }
          f = i[c](o, c, u, s, null, t);
        } catch (v) {
          f = v;
        }
        if (f && !(f instanceof Error) && e((u || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), f instanceof Error && !(f.message in n)) {
          var _p4;
          n[f.message] = !0;
          var p = l ? l() : "";
          e("Failed " + s + " type: " + f.message + ((_p4 = p) !== null && _p4 !== void 0 ? _p4 : ""));
        }
      }
    }
  }
  return a.resetWarningCache = function () {
    process.env.NODE_ENV !== "production" && (n = {});
  }, js = a, js;
}
var Bs, Fp;
function TD() {
  if (Fp) return Bs;
  Fp = 1;
  var e = ca,
    t = ED(),
    n = vf(),
    r = Ky(),
    a = PD(),
    i = function i() {};
  process.env.NODE_ENV !== "production" && (i = function i(s) {
    var u = "Warning: " + s;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch (_unused45) {}
  });
  function o() {
    return null;
  }
  return Bs = function Bs(s, u) {
    var l = typeof Symbol == "function" && Symbol.iterator,
      c = "@@iterator";
    function f(O) {
      var I = O && (l && O[l] || O[c]);
      if (typeof I == "function") return I;
    }
    var h = "<<anonymous>>",
      p = {
        array: b("array"),
        bigint: b("bigint"),
        bool: b("boolean"),
        func: b("function"),
        number: b("number"),
        object: b("object"),
        string: b("string"),
        symbol: b("symbol"),
        any: y(),
        arrayOf: E,
        element: w(),
        elementType: _(),
        instanceOf: C,
        node: me(),
        objectOf: U,
        oneOf: D,
        oneOfType: Z,
        shape: Y,
        exact: K
      };
    function v(O, I) {
      return O === I ? O !== 0 || 1 / O === 1 / I : O !== O && I !== I;
    }
    function m(O, I) {
      this.message = O, this.data = I && typeof I == "object" ? I : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g(O) {
      if (process.env.NODE_ENV !== "production") var I = {},
        B = 0;
      function W(ue, se, x, A, M, N, Q) {
        if (A = A || h, N = N || x, Q !== n) {
          if (u) {
            var L = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ve = A + ":" + x;
            !I[ve] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            B < 3 && (i("You are manually calling a React.PropTypes validation function for the `" + N + "` prop on `" + A + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), I[ve] = !0, B++);
          }
        }
        return se[x] == null ? ue ? se[x] === null ? new m("The " + M + " `" + N + "` is marked as required " + ("in `" + A + "`, but its value is `null`.")) : new m("The " + M + " `" + N + "` is marked as required in " + ("`" + A + "`, but its value is `undefined`.")) : null : O(se, x, A, M, N);
      }
      var G = W.bind(null, !1);
      return G.isRequired = W.bind(null, !0), G;
    }
    function b(O) {
      function I(B, W, G, ue, se, x) {
        var A = B[W],
          M = ie(A);
        if (M !== O) {
          var N = fe(A);
          return new m("Invalid " + ue + " `" + se + "` of type " + ("`" + N + "` supplied to `" + G + "`, expected ") + ("`" + O + "`."), {
            expectedType: O
          });
        }
        return null;
      }
      return g(I);
    }
    function y() {
      return g(o);
    }
    function E(O) {
      function I(B, W, G, ue, se) {
        if (typeof O != "function") return new m("Property `" + se + "` of component `" + G + "` has invalid PropType notation inside arrayOf.");
        var x = B[W];
        if (!Array.isArray(x)) {
          var A = ie(x);
          return new m("Invalid " + ue + " `" + se + "` of type " + ("`" + A + "` supplied to `" + G + "`, expected an array."));
        }
        for (var M = 0; M < x.length; M++) {
          var N = O(x, M, G, ue, se + "[" + M + "]", n);
          if (N instanceof Error) return N;
        }
        return null;
      }
      return g(I);
    }
    function w() {
      function O(I, B, W, G, ue) {
        var se = I[B];
        if (!s(se)) {
          var x = ie(se);
          return new m("Invalid " + G + " `" + ue + "` of type " + ("`" + x + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(O);
    }
    function _() {
      function O(I, B, W, G, ue) {
        var se = I[B];
        if (!e.isValidElementType(se)) {
          var x = ie(se);
          return new m("Invalid " + G + " `" + ue + "` of type " + ("`" + x + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(O);
    }
    function C(O) {
      function I(B, W, G, ue, se) {
        if (!(B[W] instanceof O)) {
          var x = O.name || h,
            A = H(B[W]);
          return new m("Invalid " + ue + " `" + se + "` of type " + ("`" + A + "` supplied to `" + G + "`, expected ") + ("instance of `" + x + "`."));
        }
        return null;
      }
      return g(I);
    }
    function D(O) {
      if (!Array.isArray(O)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function I(B, W, G, ue, se) {
        for (var x = B[W], A = 0; A < O.length; A++) if (v(x, O[A])) return null;
        var M = JSON.stringify(O, function (Q, L) {
          var ve = fe(L);
          return ve === "symbol" ? String(L) : L;
        });
        return new m("Invalid " + ue + " `" + se + "` of value `" + String(x) + "` " + ("supplied to `" + G + "`, expected one of " + M + "."));
      }
      return g(I);
    }
    function U(O) {
      function I(B, W, G, ue, se) {
        if (typeof O != "function") return new m("Property `" + se + "` of component `" + G + "` has invalid PropType notation inside objectOf.");
        var x = B[W],
          A = ie(x);
        if (A !== "object") return new m("Invalid " + ue + " `" + se + "` of type " + ("`" + A + "` supplied to `" + G + "`, expected an object."));
        for (var M in x) if (r(x, M)) {
          var N = O(x, M, G, ue, se + "." + M, n);
          if (N instanceof Error) return N;
        }
        return null;
      }
      return g(I);
    }
    function Z(O) {
      if (!Array.isArray(O)) return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var I = 0; I < O.length; I++) {
        var B = O[I];
        if (typeof B != "function") return i("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(B) + " at index " + I + "."), o;
      }
      function W(G, ue, se, x, A) {
        for (var M = [], N = 0; N < O.length; N++) {
          var Q = O[N],
            L = Q(G, ue, se, x, A, n);
          if (L == null) return null;
          L.data && r(L.data, "expectedType") && M.push(L.data.expectedType);
        }
        var ve = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new m("Invalid " + x + " `" + A + "` supplied to " + ("`" + se + "`" + ve + "."));
      }
      return g(W);
    }
    function me() {
      function O(I, B, W, G, ue) {
        return ee(I[B]) ? null : new m("Invalid " + G + " `" + ue + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return g(O);
    }
    function ye(O, I, B, W, G) {
      return new m((O || "React class") + ": " + I + " type `" + B + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + G + "`.");
    }
    function Y(O) {
      function I(B, W, G, ue, se) {
        var x = B[W],
          A = ie(x);
        if (A !== "object") return new m("Invalid " + ue + " `" + se + "` of type `" + A + "` " + ("supplied to `" + G + "`, expected `object`."));
        for (var M in O) {
          var N = O[M];
          if (typeof N != "function") return ye(G, ue, se, M, fe(N));
          var Q = N(x, M, G, ue, se + "." + M, n);
          if (Q) return Q;
        }
        return null;
      }
      return g(I);
    }
    function K(O) {
      function I(B, W, G, ue, se) {
        var x = B[W],
          A = ie(x);
        if (A !== "object") return new m("Invalid " + ue + " `" + se + "` of type `" + A + "` " + ("supplied to `" + G + "`, expected `object`."));
        var M = t({}, B[W], O);
        for (var N in M) {
          var Q = O[N];
          if (r(O, N) && typeof Q != "function") return ye(G, ue, se, N, fe(Q));
          if (!Q) return new m("Invalid " + ue + " `" + se + "` key `" + N + "` supplied to `" + G + "`.\nBad object: " + JSON.stringify(B[W], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(O), null, "  "));
          var L = Q(x, N, G, ue, se + "." + N, n);
          if (L) return L;
        }
        return null;
      }
      return g(I);
    }
    function ee(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O)) return O.every(ee);
          if (O === null || s(O)) return !0;
          var I = f(O);
          if (I) {
            var B = I.call(O),
              W;
            if (I !== O.entries) {
              for (; !(W = B.next()).done;) if (!ee(W.value)) return !1;
            } else for (; !(W = B.next()).done;) {
              var G = W.value;
              if (G && !ee(G[1])) return !1;
            }
          } else return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ne(O, I) {
      return O === "symbol" ? !0 : I ? I["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && I instanceof Symbol : !1;
    }
    function ie(O) {
      var I = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : ne(I, O) ? "symbol" : I;
    }
    function fe(O) {
      if (typeof O > "u" || O === null) return "" + O;
      var I = ie(O);
      if (I === "object") {
        if (O instanceof Date) return "date";
        if (O instanceof RegExp) return "regexp";
      }
      return I;
    }
    function ce(O) {
      var I = fe(O);
      switch (I) {
        case "array":
        case "object":
          return "an " + I;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + I;
        default:
          return I;
      }
    }
    function H(O) {
      return !O.constructor || !O.constructor.name ? h : O.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, Bs;
}
var Vs, Lp;
function kD() {
  if (Lp) return Vs;
  Lp = 1;
  var e = vf();
  function t() {}
  function n() {}
  return n.resetWarningCache = t, Vs = function Vs() {
    function r(o, s, u, l, c, f) {
      if (f !== e) {
        var h = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Vs;
}
if (process.env.NODE_ENV !== "production") {
  var DD = ca,
    xD = !0;
  $p.exports = TD()(DD.isElement, xD);
} else $p.exports = kD()();
var Jy = ["onCopy", "onCut", "onPaste"],
  Xy = ["onCompositionEnd", "onCompositionStart", "onCompositionUpdate"],
  Zy = ["onKeyDown", "onKeyPress", "onKeyUp"],
  eg = ["onFocus", "onBlur"],
  tg = ["onChange", "onInput", "onInvalid", "onReset", "onSubmit"],
  ng = ["onError", "onLoad"],
  rg = ["onClick", "onContextMenu", "onDoubleClick", "onDrag", "onDragEnd", "onDragEnter", "onDragExit", "onDragLeave", "onDragOver", "onDragStart", "onDrop", "onMouseDown", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseOut", "onMouseOver", "onMouseUp"],
  ag = ["onPointerDown", "onPointerMove", "onPointerUp", "onPointerCancel", "onGotPointerCapture", "onLostPointerCapture", "onPointerEnter", "onPointerLeave", "onPointerOver", "onPointerOut"],
  ig = ["onSelect"],
  og = ["onTouchCancel", "onTouchEnd", "onTouchMove", "onTouchStart"],
  sg = ["onScroll"],
  ug = ["onWheel"],
  lg = ["onAbort", "onCanPlay", "onCanPlayThrough", "onDurationChange", "onEmptied", "onEncrypted", "onEnded", "onError", "onLoadedData", "onLoadedMetadata", "onLoadStart", "onPause", "onPlay", "onPlaying", "onProgress", "onRateChange", "onSeeked", "onSeeking", "onStalled", "onSuspend", "onTimeUpdate", "onVolumeChange", "onWaiting"],
  cg = ["onLoad", "onError"],
  fg = ["onAnimationStart", "onAnimationEnd", "onAnimationIteration"],
  dg = ["onTransitionEnd"],
  hg = ["onToggle"],
  pg = [].concat(Jy, Xy, Zy, eg, tg, ng, rg, ag, ig, og, sg, ug, lg, cg, fg, dg, hg),
  $D = function $D(t, n) {
    var r = {};
    return pg.forEach(function (a) {
      if (a in t) {
        if (!n) {
          r[a] = t[a];
          return;
        }
        r[a] = function (i) {
          return t[a](i, n(a));
        };
      }
    }), r;
  };
var CD = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    allEvents: pg,
    animationEvents: fg,
    clipboardEvents: Jy,
    compositionEvents: Xy,
    default: $D,
    focusEvents: eg,
    formEvents: tg,
    genericEvents: ng,
    imageEvents: cg,
    keyboardEvents: Zy,
    mediaEvents: lg,
    mouseEvents: rg,
    otherEvents: hg,
    pointerEvents: ag,
    selectionEvents: ig,
    touchEvents: og,
    transitionEvents: dg,
    uiEvents: sg,
    wheelEvents: ug
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  RD = /* @__PURE__ */kn(CD);
function Ko() {
  return Array.prototype.slice.call(arguments).reduce(function (e, t) {
    return e.concat(t);
  }, []).filter(function (e) {
    return typeof e == "string";
  }).join(" ");
}
var ND = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: Ko
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  yf = /* @__PURE__ */kn(ND);
var AD = "Expected a function",
  mg = "__lodash_hash_undefined__",
  ID = "[object Function]",
  MD = "[object GeneratorFunction]",
  FD = /[\\^$.*+?()[\]{}|]/g,
  LD = /^\[object .+?Constructor\]$/,
  jD = typeof Hr == "object" && Hr && Hr.Object === Object && Hr,
  BD = typeof self == "object" && self && self.Object === Object && self,
  vg = jD || BD || Function("return this")();
function VD(e, t) {
  return e == null ? void 0 : e[t];
}
function qD(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function") try {
    t = !!(e + "");
  } catch (_unused46) {}
  return t;
}
var UD = Array.prototype,
  zD = Function.prototype,
  yg = Object.prototype,
  qs = vg["__core-js_shared__"],
  jp = function () {
    var e = /[^.]+$/.exec(qs && qs.keys && qs.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(),
  gg = zD.toString,
  gf = yg.hasOwnProperty,
  HD = yg.toString,
  WD = RegExp("^" + gg.call(gf).replace(FD, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
  GD = UD.splice,
  YD = bg(vg, "Map"),
  fa = bg(Object, "create");
function zn(e) {
  var t = -1,
    n = e ? e.length : 0;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function QD() {
  this.__data__ = fa ? fa(null) : {};
}
function KD(e) {
  return this.has(e) && delete this.__data__[e];
}
function JD(e) {
  var t = this.__data__;
  if (fa) {
    var n = t[e];
    return n === mg ? void 0 : n;
  }
  return gf.call(t, e) ? t[e] : void 0;
}
function XD(e) {
  var t = this.__data__;
  return fa ? t[e] !== void 0 : gf.call(t, e);
}
function ZD(e, t) {
  var n = this.__data__;
  return n[e] = fa && t === void 0 ? mg : t, this;
}
zn.prototype.clear = QD;
zn.prototype.delete = KD;
zn.prototype.get = JD;
zn.prototype.has = XD;
zn.prototype.set = ZD;
function xr(e) {
  var t = -1,
    n = e ? e.length : 0;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function ex() {
  this.__data__ = [];
}
function tx(e) {
  var t = this.__data__,
    n = Jo(t, e);
  if (n < 0) return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : GD.call(t, n, 1), !0;
}
function nx(e) {
  var t = this.__data__,
    n = Jo(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function rx(e) {
  return Jo(this.__data__, e) > -1;
}
function ax(e, t) {
  var n = this.__data__,
    r = Jo(n, e);
  return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
}
xr.prototype.clear = ex;
xr.prototype.delete = tx;
xr.prototype.get = nx;
xr.prototype.has = rx;
xr.prototype.set = ax;
function Gn(e) {
  var t = -1,
    n = e ? e.length : 0;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function ix() {
  this.__data__ = {
    hash: new zn(),
    map: new (YD || xr)(),
    string: new zn()
  };
}
function ox(e) {
  return Xo(this, e).delete(e);
}
function sx(e) {
  return Xo(this, e).get(e);
}
function ux(e) {
  return Xo(this, e).has(e);
}
function lx(e, t) {
  return Xo(this, e).set(e, t), this;
}
Gn.prototype.clear = ix;
Gn.prototype.delete = ox;
Gn.prototype.get = sx;
Gn.prototype.has = ux;
Gn.prototype.set = lx;
function Jo(e, t) {
  for (var n = e.length; n--;) if (px(e[n][0], t)) return n;
  return -1;
}
function cx(e) {
  if (!_g(e) || dx(e)) return !1;
  var t = mx(e) || qD(e) ? WD : LD;
  return t.test(hx(e));
}
function Xo(e, t) {
  var n = e.__data__;
  return fx(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function bg(e, t) {
  var n = VD(e, t);
  return cx(n) ? n : void 0;
}
function fx(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function dx(e) {
  return !!jp && jp in e;
}
function hx(e) {
  if (e != null) {
    try {
      return gg.call(e);
    } catch (_unused47) {}
    try {
      return e + "";
    } catch (_unused48) {}
  }
  return "";
}
function bf(e, t) {
  if (typeof e != "function" || t && typeof t != "function") throw new TypeError(AD);
  var n = function n() {
    var r = arguments,
      a = t ? t.apply(this, r) : r[0],
      i = n.cache;
    if (i.has(a)) return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o), o;
  };
  return n.cache = new (bf.Cache || Gn)(), n;
}
bf.Cache = Gn;
function px(e, t) {
  return e === t || e !== e && t !== t;
}
function mx(e) {
  var t = _g(e) ? HD.call(e) : "";
  return t == ID || t == MD;
}
function _g(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
var vx = bf;
var wg = vx;
function Og(e) {
  return JSON.stringify(e);
}
function yx(e) {
  return e.filter(function (t, n) {
    return t && e.indexOf(t) === n;
  });
}
function gx(e) {
  return e.map(function (t) {
    if (!t || t.indexOf("-") === -1 || t.toLowerCase() !== t) return t;
    var n = t.split("-");
    return n[0] + "-" + n[1].toUpperCase();
  });
}
function bx(e) {
  var t = e === void 0 ? {} : e,
    n = t.useFallbackLocale,
    r = n === void 0 ? !0 : n,
    a = t.fallbackLocale,
    i = a === void 0 ? "en-US" : a,
    o = [];
  if (typeof window < "u") {
    var s = window,
      u = s.navigator;
    o = o.concat(u.languages, u.language, u.userLanguage, u.browserLanguage, u.systemLanguage);
  }
  return r && o.push(i), gx(yx(o));
}
var Sg = wg(bx, Og);
function _x(e) {
  return Sg(e)[0] || null;
}
var No = wg(_x, Og);
var wx = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  default: No,
  getUserLocale: No,
  getUserLocales: Sg
}, Symbol.toStringTag, {
  value: "Module"
}));
function Bt(e, t, n) {
  return function (a) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n,
      o = e(a) + i;
    return t(o);
  };
}
function Pa(e) {
  return function (n) {
    return new Date(e(n).getTime() - 1);
  };
}
function Ta(e) {
  return function (n) {
    return e.map(function (r) {
      return r(n);
    });
  };
}
function je(e) {
  if (e instanceof Date) return e.getFullYear();
  if (typeof e == "number") return e;
  var t = parseInt(e, 10);
  if (typeof e == "string" && !isNaN(t)) return t;
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function cn(e) {
  if (e instanceof Date) return e.getMonth();
  throw new Error("Failed to get month from date: ".concat(e, "."));
}
function _f(e) {
  if (e instanceof Date) return e.getMonth() + 1;
  throw new Error("Failed to get human-readable month from date: ".concat(e, "."));
}
function $r(e) {
  if (e instanceof Date) return e.getDate();
  throw new Error("Failed to get year from date: ".concat(e, "."));
}
function wf(e) {
  if (e instanceof Date) return e.getHours();
  if (typeof e == "string") {
    var t = e.split(":");
    if (t.length >= 2) {
      var n = t[0],
        r = parseInt(n, 10);
      if (!isNaN(r)) return r;
    }
  }
  throw new Error("Failed to get hours from date: ".concat(e, "."));
}
function Of(e) {
  if (e instanceof Date) return e.getMinutes();
  if (typeof e == "string") {
    var t = e.split(":");
    if (t.length >= 2) {
      var n = t[1] || 0,
        r = parseInt(n, 10);
      if (!isNaN(r)) return r;
    }
  }
  throw new Error("Failed to get minutes from date: ".concat(e, "."));
}
function Eg(e) {
  if (e instanceof Date) return e.getSeconds();
  if (typeof e == "string") {
    var t = e.split(":");
    if (t.length >= 2) {
      var n = t[2] || 0,
        r = parseInt(n, 10);
      if (!isNaN(r)) return r;
    }
  }
  throw new Error("Failed to get seconds from date: ".concat(e, "."));
}
function Cr(e) {
  var t = je(e),
    n = t + (-t + 1) % 100,
    r = new Date();
  return r.setFullYear(n, 0, 1), r.setHours(0, 0, 0, 0), r;
}
var Pg = Bt(je, Cr, -100),
  Sf = Bt(je, Cr, 100),
  ka = Pa(Sf),
  Tg = Bt(je, ka, -100),
  Ox = Bt(je, ka, 100),
  Ef = Ta([Cr, ka]);
function Cn(e) {
  var t = je(e),
    n = t + (-t + 1) % 10,
    r = new Date();
  return r.setFullYear(n, 0, 1), r.setHours(0, 0, 0, 0), r;
}
var Pf = Bt(je, Cn, -10),
  Zo = Bt(je, Cn, 10),
  Rr = Pa(Zo),
  Tf = Bt(je, Rr, -10),
  Sx = Bt(je, Rr, 10),
  kf = Ta([Cn, Rr]);
function Nr(e) {
  var t = je(e),
    n = new Date();
  return n.setFullYear(t, 0, 1), n.setHours(0, 0, 0, 0), n;
}
var Df = Bt(je, Nr, -1),
  es = Bt(je, Nr, 1),
  Ar = Pa(es),
  xf = Bt(je, Ar, -1),
  Ex = Bt(je, Ar, 1),
  kg = Ta([Nr, Ar]);
function ts(e, t) {
  return function (r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t,
      i = je(r),
      o = cn(r) + a,
      s = new Date();
    return s.setFullYear(i, o, 1), s.setHours(0, 0, 0, 0), e(s);
  };
}
function Yn(e) {
  var t = je(e),
    n = cn(e),
    r = new Date();
  return r.setFullYear(t, n, 1), r.setHours(0, 0, 0, 0), r;
}
var $f = ts(Yn, -1),
  ns = ts(Yn, 1),
  Qn = Pa(ns),
  Cf = ts(Qn, -1),
  Px = ts(Qn, 1),
  Dg = Ta([Yn, Qn]);
function rs(e, t) {
  return function (r) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t,
      i = je(r),
      o = cn(r),
      s = $r(r) + a,
      u = new Date();
    return u.setFullYear(i, o, s), u.setHours(0, 0, 0, 0), e(u);
  };
}
function Ir(e) {
  var t = je(e),
    n = cn(e),
    r = $r(e),
    a = new Date();
  return a.setFullYear(t, n, r), a.setHours(0, 0, 0, 0), a;
}
var Tx = rs(Ir, -1),
  xg = rs(Ir, 1),
  Mr = Pa(xg),
  kx = rs(Mr, -1),
  Dx = rs(Mr, 1),
  $g = Ta([Ir, Mr]);
function Rf(e) {
  return $r(Qn(e));
}
function Xt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2,
    n = "".concat(e);
  return n.length >= t ? e : "0000".concat(n).slice(-t);
}
function xx(e) {
  var t = Xt(wf(e)),
    n = Xt(Of(e));
  return "".concat(t, ":").concat(n);
}
function Cg(e) {
  var t = Xt(wf(e)),
    n = Xt(Of(e)),
    r = Xt(Eg(e));
  return "".concat(t, ":").concat(n, ":").concat(r);
}
function $x(e) {
  var t = Xt(je(e), 4),
    n = Xt(_f(e));
  return "".concat(t, "-").concat(n);
}
function Rg(e) {
  var t = Xt(je(e), 4),
    n = Xt(_f(e)),
    r = Xt($r(e));
  return "".concat(t, "-").concat(n, "-").concat(r);
}
function Cx(e) {
  return "".concat(Rg(e), "T").concat(Cg(e));
}
var Rx = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  getCenturyEnd: ka,
  getCenturyRange: Ef,
  getCenturyStart: Cr,
  getDate: $r,
  getDayEnd: Mr,
  getDayRange: $g,
  getDayStart: Ir,
  getDaysInMonth: Rf,
  getDecadeEnd: Rr,
  getDecadeRange: kf,
  getDecadeStart: Cn,
  getHours: wf,
  getHoursMinutes: xx,
  getHoursMinutesSeconds: Cg,
  getISOLocalDate: Rg,
  getISOLocalDateTime: Cx,
  getISOLocalMonth: $x,
  getMinutes: Of,
  getMonth: cn,
  getMonthEnd: Qn,
  getMonthHuman: _f,
  getMonthRange: Dg,
  getMonthStart: Yn,
  getNextCenturyEnd: Ox,
  getNextCenturyStart: Sf,
  getNextDayEnd: Dx,
  getNextDayStart: xg,
  getNextDecadeEnd: Sx,
  getNextDecadeStart: Zo,
  getNextMonthEnd: Px,
  getNextMonthStart: ns,
  getNextYearEnd: Ex,
  getNextYearStart: es,
  getPreviousCenturyEnd: Tg,
  getPreviousCenturyStart: Pg,
  getPreviousDayEnd: kx,
  getPreviousDayStart: Tx,
  getPreviousDecadeEnd: Tf,
  getPreviousDecadeStart: Pf,
  getPreviousMonthEnd: Cf,
  getPreviousMonthStart: $f,
  getPreviousYearEnd: xf,
  getPreviousYearStart: Df,
  getSeconds: Eg,
  getYear: je,
  getYearEnd: Ar,
  getYearRange: kg,
  getYearStart: Nr
}, Symbol.toStringTag, {
  value: "Module"
}));
var Ur;
function Nx(e) {
  return Fx(e) || Mx(e) || Ix(e) || Ax();
}
function Ax() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Ix(e, t) {
  if (e) {
    if (typeof e == "string") return Ul(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ul(e, t);
  }
}
function Mx(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Fx(e) {
  if (Array.isArray(e)) return Ul(e);
}
function Ul(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Us(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var ut = {
    ARABIC: "Arabic",
    HEBREW: "Hebrew",
    ISO_8601: "ISO 8601",
    US: "US"
  },
  Bp = (Ur = {}, Us(Ur, ut.US, ["en-CA", "en-US", "es-AR", "es-BO", "es-CL", "es-CO", "es-CR", "es-DO", "es-EC", "es-GT", "es-HN", "es-MX", "es-NI", "es-PA", "es-PE", "es-PR", "es-SV", "es-VE", "pt-BR"]), Us(Ur, ut.ARABIC, [
  // ar-LB, ar-MA intentionally missing
  "ar", "ar-AE", "ar-BH", "ar-DZ", "ar-EG", "ar-IQ", "ar-JO", "ar-KW", "ar-LY", "ar-OM", "ar-QA", "ar-SA", "ar-SD", "ar-SY", "ar-YE", "dv", "dv-MV", "ps", "ps-AR"]), Us(Ur, ut.HEBREW, ["he", "he-IL"]), Ur),
  Nf = Nx(Array(7)).map(function (e, t) {
    return t;
  }),
  zs = /* @__PURE__ */new Map();
function Lx(e) {
  return function (t, n) {
    var r = t || No();
    zs.has(r) || zs.set(r, /* @__PURE__ */new Map());
    var a = zs.get(r);
    return a.has(e) || a.set(e, new Intl.DateTimeFormat(r, e).format), a.get(e)(n);
  };
}
function jx(e) {
  var t = new Date(e);
  return new Date(t.setHours(12));
}
function Kn(e) {
  return function (t, n) {
    return Lx(e)(t, jx(n));
  };
}
var Bx = {
    day: "numeric"
  },
  Vx = {
    day: "numeric",
    month: "long",
    year: "numeric"
  },
  qx = {
    month: "long"
  },
  Ux = {
    month: "long",
    year: "numeric"
  },
  zx = {
    weekday: "short"
  },
  Hx = {
    weekday: "long"
  },
  Wx = {
    year: "numeric"
  },
  Gx = Kn(Bx),
  Yx = Kn(Vx),
  Qx = Kn(qx),
  Ng = Kn(Ux),
  Kx = Kn(zx),
  Jx = Kn(Hx),
  as = Kn(Wx),
  Xx = Nf[0],
  Zx = Nf[5],
  Vp = Nf[6];
function da(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ut.ISO_8601,
    n = e.getDay();
  switch (t) {
    case ut.ISO_8601:
      return (n + 6) % 7;
    case ut.ARABIC:
      return (n + 1) % 7;
    case ut.HEBREW:
    case ut.US:
      return n;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function e$(e) {
  var t = Cr(e);
  return je(t);
}
function t$(e) {
  var t = Cn(e);
  return je(t);
}
function zl(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ut.ISO_8601,
    n = je(e),
    r = cn(e),
    a = e.getDate() - da(e, t);
  return new Date(n, r, a);
}
function n$(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ut.ISO_8601,
    n = t === ut.US ? ut.US : ut.ISO_8601,
    r = zl(e, t),
    a = je(e) + 1,
    i,
    o;
  do i = new Date(a, 0, n === ut.ISO_8601 ? 4 : 1), o = zl(i, t), a -= 1; while (e < o);
  return Math.round((r - o) / (864e5 * 7)) + 1;
}
function Bn(e, t) {
  switch (e) {
    case "century":
      return Cr(t);
    case "decade":
      return Cn(t);
    case "year":
      return Nr(t);
    case "month":
      return Yn(t);
    case "day":
      return Ir(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function r$(e, t) {
  switch (e) {
    case "century":
      return Pg(t);
    case "decade":
      return Pf(t);
    case "year":
      return Df(t);
    case "month":
      return $f(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function Ag(e, t) {
  switch (e) {
    case "century":
      return Sf(t);
    case "decade":
      return Zo(t);
    case "year":
      return es(t);
    case "month":
      return ns(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
var a$ = function a$(t, n) {
    switch (t) {
      case "decade":
        return Pf(n, -100);
      case "year":
        return Df(n, -10);
      case "month":
        return $f(n, -12);
      default:
        throw new Error("Invalid rangeType: ".concat(t));
    }
  },
  i$ = function i$(t, n) {
    switch (t) {
      case "decade":
        return Zo(n, 100);
      case "year":
        return es(n, 10);
      case "month":
        return ns(n, 12);
      default:
        throw new Error("Invalid rangeType: ".concat(t));
    }
  };
function Ig(e, t) {
  switch (e) {
    case "century":
      return ka(t);
    case "decade":
      return Rr(t);
    case "year":
      return Ar(t);
    case "month":
      return Qn(t);
    case "day":
      return Mr(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function o$(e, t) {
  switch (e) {
    case "century":
      return Tg(t);
    case "decade":
      return Tf(t);
    case "year":
      return xf(t);
    case "month":
      return Cf(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
var s$ = function s$(t, n) {
  switch (t) {
    case "decade":
      return Tf(n, -100);
    case "year":
      return xf(n, -10);
    case "month":
      return Cf(n, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(t));
  }
};
function qp(e, t) {
  switch (e) {
    case "century":
      return Ef(t);
    case "decade":
      return kf(t);
    case "year":
      return kg(t);
    case "month":
      return Dg(t);
    case "day":
      return $g(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function u$(e, t, n) {
  var r = [t, n].sort(function (a, i) {
    return a - i;
  });
  return [Bn(e, r[0]), Ig(e, r[1])];
}
function Mg(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : as,
    n = arguments.length > 2 ? arguments[2] : void 0;
  return n.map(function (r) {
    return t(e, r);
  }).join(" – ");
}
function l$(e, t, n) {
  return Mg(e, t, Ef(n));
}
function Fg(e, t, n) {
  return Mg(e, t, kf(n));
}
function c$(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ut.ISO_8601,
    n = e.getDay();
  switch (t) {
    case ut.ARABIC:
    case ut.HEBREW:
      return n === Zx || n === Vp;
    case ut.ISO_8601:
    case ut.US:
      return n === Vp || n === Xx;
    default:
      throw new Error("Unsupported calendar type.");
  }
}
function Sr(e) {
  return Sr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sr(e);
}
var f$ = Object.values(ut),
  Lg = ["century", "decade", "year", "month"],
  Da = k.oneOf(f$),
  Ao = k.oneOfType([k.string, k.arrayOf(k.string)]),
  Af = function Af(t, n, r) {
    var a = t[n];
    if (!a) return null;
    if (!(a instanceof Date)) return new Error("Invalid prop `".concat(n, "` of type `").concat(Sr(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
    var i = t.maxDate;
    return i && a > i ? new Error("Invalid prop `".concat(n, "` of type `").concat(Sr(a), "` supplied to `").concat(r, "`, minDate cannot be larger than maxDate.")) : null;
  },
  If = function If(t, n, r) {
    var a = t[n];
    if (!a) return null;
    if (!(a instanceof Date)) return new Error("Invalid prop `".concat(n, "` of type `").concat(Sr(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
    var i = t.minDate;
    return i && a < i ? new Error("Invalid prop `".concat(n, "` of type `").concat(Sr(a), "` supplied to `").concat(r, "`, maxDate cannot be smaller than minDate.")) : null;
  },
  d$ = k.oneOfType([k.func, k.shape({
    current: k.any
  })]),
  jg = k.oneOfType([k.instanceOf(Date), k.arrayOf(k.instanceOf(Date))]),
  h$ = k.arrayOf(k.oneOf(Lg)),
  ha = function ha(t, n, r) {
    var a = t[n],
      i = t.views,
      o = i || Lg;
    return a !== void 0 && o.indexOf(a) === -1 ? new Error("Invalid prop `".concat(n, "` of value `").concat(a, "` supplied to `").concat(r, "`, expected one of [").concat(o.map(function (s) {
      return '"'.concat(s, '"');
    }).join(", "), "].")) : null;
  };
ha.isRequired = function (e, t, n) {
  var r = e[t];
  return r ? ha(e, t, n) : new Error("The prop `".concat(t, "` is marked as required in `").concat(n, "`, but its value is `").concat(r, "`."));
};
var xa = {
    activeStartDate: k.instanceOf(Date).isRequired,
    hover: k.instanceOf(Date),
    locale: k.string,
    maxDate: If,
    minDate: Af,
    onClick: k.func,
    onMouseOver: k.func,
    tileClassName: k.oneOfType([k.func, Ao]),
    tileContent: k.oneOfType([k.func, k.node]),
    value: jg,
    valueType: k.string
  },
  $a = {
    activeStartDate: k.instanceOf(Date).isRequired,
    classes: k.arrayOf(k.string).isRequired,
    date: k.instanceOf(Date).isRequired,
    locale: k.string,
    maxDate: If,
    minDate: Af,
    onClick: k.func,
    onMouseOver: k.func,
    style: k.objectOf(k.oneOfType([k.string, k.number])),
    tileClassName: k.oneOfType([k.func, Ao]),
    tileContent: k.oneOfType([k.func, k.node]),
    tileDisabled: k.func
  },
  zt = "react-calendar__navigation";
function Bg(e) {
  var t = e.activeStartDate,
    n = e.drillUp,
    r = e.formatMonthYear,
    a = r === void 0 ? Ng : r,
    i = e.formatYear,
    o = i === void 0 ? as : i,
    s = e.locale,
    u = e.maxDate,
    l = e.minDate,
    c = e.navigationAriaLabel,
    f = c === void 0 ? "" : c,
    h = e.navigationAriaLive,
    p = e.navigationLabel,
    v = e.next2AriaLabel,
    m = v === void 0 ? "" : v,
    g = e.next2Label,
    b = g === void 0 ? "»" : g,
    y = e.nextAriaLabel,
    E = y === void 0 ? "" : y,
    w = e.nextLabel,
    _ = w === void 0 ? "›" : w,
    C = e.prev2AriaLabel,
    D = C === void 0 ? "" : C,
    U = e.prev2Label,
    Z = U === void 0 ? "«" : U,
    me = e.prevAriaLabel,
    ye = me === void 0 ? "" : me,
    Y = e.prevLabel,
    K = Y === void 0 ? "‹" : Y,
    ee = e.setActiveStartDate,
    ne = e.showDoubleView,
    ie = e.view,
    fe = e.views,
    ce = fe.indexOf(ie) > 0,
    H = ie !== "century",
    O = r$(ie, t),
    I = H && a$(ie, t),
    B = Ag(ie, t),
    W = H && i$(ie, t),
    G = function () {
      if (O.getFullYear() < 0) return !0;
      var re = o$(ie, t);
      return l && l >= re;
    }(),
    ue = H && function () {
      if (I.getFullYear() < 0) return !0;
      var re = s$(ie, t);
      return l && l >= re;
    }(),
    se = u && u < B,
    x = H && u && u < W;
  function A() {
    ee(O, "prev");
  }
  function M() {
    ee(I, "prev2");
  }
  function N() {
    ee(B, "next");
  }
  function Q() {
    ee(W, "next2");
  }
  function L(re) {
    var _e = function () {
      switch (ie) {
        case "century":
          return l$(s, o, re);
        case "decade":
          return Fg(s, o, re);
        case "year":
          return o(s, re);
        case "month":
          return a(s, re);
        default:
          throw new Error("Invalid view: ".concat(ie, "."));
      }
    }();
    return p ? p({
      date: re,
      label: _e,
      locale: s || No(),
      view: ie
    }) : _e;
  }
  function ve() {
    var re = "".concat(zt, "__label");
    return /* @__PURE__ */React__default["default"].createElement("button", {
      "aria-label": f,
      "aria-live": h,
      className: re,
      disabled: !ce,
      onClick: n,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, /* @__PURE__ */React__default["default"].createElement("span", {
      className: "".concat(re, "__labelText ").concat(re, "__labelText--from")
    }, L(t)), ne && /* @__PURE__ */React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */React__default["default"].createElement("span", {
      className: "".concat(re, "__divider")
    }, " – "), /* @__PURE__ */React__default["default"].createElement("span", {
      className: "".concat(re, "__labelText ").concat(re, "__labelText--to")
    }, L(B))));
  }
  return /* @__PURE__ */React__default["default"].createElement("div", {
    className: zt
  }, Z !== null && H && /* @__PURE__ */React__default["default"].createElement("button", {
    "aria-label": D,
    className: "".concat(zt, "__arrow ").concat(zt, "__prev2-button"),
    disabled: ue,
    onClick: M,
    type: "button"
  }, Z), K !== null && /* @__PURE__ */React__default["default"].createElement("button", {
    "aria-label": ye,
    className: "".concat(zt, "__arrow ").concat(zt, "__prev-button"),
    disabled: G,
    onClick: A,
    type: "button"
  }, K), ve(), _ !== null && /* @__PURE__ */React__default["default"].createElement("button", {
    "aria-label": E,
    className: "".concat(zt, "__arrow ").concat(zt, "__next-button"),
    disabled: se,
    onClick: N,
    type: "button"
  }, _), b !== null && H && /* @__PURE__ */React__default["default"].createElement("button", {
    "aria-label": m,
    className: "".concat(zt, "__arrow ").concat(zt, "__next2-button"),
    disabled: x,
    onClick: Q,
    type: "button"
  }, b));
}
Bg.propTypes = {
  activeStartDate: k.instanceOf(Date).isRequired,
  drillUp: k.func.isRequired,
  formatMonthYear: k.func,
  formatYear: k.func,
  locale: k.string,
  maxDate: k.instanceOf(Date),
  minDate: k.instanceOf(Date),
  navigationAriaLabel: k.string,
  navigationAriaLive: k.string,
  navigationLabel: k.func,
  next2AriaLabel: k.string,
  next2Label: k.node,
  nextAriaLabel: k.string,
  nextLabel: k.node,
  prev2AriaLabel: k.string,
  prev2Label: k.node,
  prevAriaLabel: k.string,
  prevLabel: k.node,
  setActiveStartDate: k.func.isRequired,
  showDoubleView: k.bool,
  view: ha.isRequired,
  views: h$.isRequired
};
var p$ = ["children", "className", "direction", "count", "offset", "style", "wrap"];
function Hl() {
  return Hl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hl.apply(this, arguments);
}
function Up(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hs(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Up(Object(n), !0).forEach(function (r) {
      m$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Up(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function m$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function v$(e, t) {
  if (e == null) return {};
  var n = y$(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function y$(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function zp(e) {
  return "".concat(e, "%");
}
function is(e) {
  var t = e.children,
    n = e.className,
    r = e.direction,
    a = e.count,
    i = e.offset,
    o = e.style,
    s = e.wrap,
    u = v$(e, p$);
  return /* @__PURE__ */React__default["default"].createElement("div", Hl({
    className: n,
    style: Hs({
      display: "flex",
      flexDirection: r,
      flexWrap: s ? "wrap" : "no-wrap"
    }, o)
  }, u), React__default["default"].Children.map(t, function (l, c) {
    return /* @__PURE__ */React__default["default"].cloneElement(l, Hs(Hs({}, l.props), {}, {
      style: {
        flexBasis: zp(100 / a),
        flexShrink: 0,
        flexGrow: 0,
        overflow: "hidden",
        marginLeft: i && c === 0 ? zp(100 * i / a) : null
      }
    }));
  }));
}
is.propTypes = {
  children: k.node,
  className: k.string,
  count: k.number.isRequired,
  direction: k.string,
  offset: k.number,
  style: k.objectOf(k.oneOfType([k.string, k.number])),
  wrap: k.bool
};
function Hp(e) {
  return w$(e) || _$(e) || b$(e) || g$();
}
function g$() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function b$(e, t) {
  if (e) {
    if (typeof e == "string") return Wl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Wl(e, t);
  }
}
function _$(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function w$(e) {
  if (Array.isArray(e)) return Wl(e);
}
function Wl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function O$(e, t, n) {
  return t && t > e ? t : n && n < e ? n : e;
}
function pa(e, t) {
  return t[0] <= e && t[1] >= e;
}
function S$(e, t) {
  return e[0] <= t[0] && e[1] >= t[1];
}
function Vg(e, t) {
  return pa(e[0], t) || pa(e[1], t);
}
function Wp(e, t, n) {
  var r = Vg(t, e),
    a = [];
  if (r) {
    a.push(n);
    var i = pa(e[0], t),
      o = pa(e[1], t);
    i && a.push("".concat(n, "Start")), o && a.push("".concat(n, "End")), i && o && a.push("".concat(n, "BothEnds"));
  }
  return a;
}
function E$() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
    t = e.value,
    n = e.valueType,
    r = e.date,
    a = e.dateType,
    i = e.hover,
    o = "react-calendar__tile",
    s = [o];
  if (!r) return s;
  if (!Array.isArray(r) && !a) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  var u = new Date(),
    l = Array.isArray(r) ? r : qp(a, r);
  if (pa(u, l) && s.push("".concat(o, "--now")), !t) return s;
  if (!Array.isArray(t) && !n) throw new Error("getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.");
  var c = Array.isArray(t) ? t : qp(n, t);
  S$(c, l) ? s.push("".concat(o, "--active")) : Vg(c, l) && s.push("".concat(o, "--hasActive"));
  var f = Wp(c, l, "".concat(o, "--range"));
  s.push.apply(s, Hp(f));
  var h = [].concat(t);
  if (i && h.length === 1) {
    var p = i > c[0] ? [c[0], i] : [i, c[0]],
      v = Wp(p, l, "".concat(o, "--hover"));
    s.push.apply(s, Hp(v));
  }
  return s;
}
var P$ = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];
function Gp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gp(Object(n), !0).forEach(function (r) {
      T$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gp(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function T$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Gl() {
  return Gl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gl.apply(this, arguments);
}
function k$(e, t) {
  if (e == null) return {};
  var n = D$(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function D$(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function Ca(e) {
  for (var t = e.className, n = e.count, r = n === void 0 ? 3 : n, a = e.dateTransform, i = e.dateType, o = e.end, s = e.hover, u = e.offset, l = e.start, c = e.step, f = c === void 0 ? 1 : c, h = e.tile, p = e.value, v = e.valueType, m = k$(e, P$), g = [], b = l; b <= o; b += f) {
    var y = a(b);
    g.push( /* @__PURE__ */React__default["default"].createElement(h, Gl({
      key: y.getTime(),
      classes: E$({
        value: p,
        valueType: v,
        date: y,
        dateType: i,
        hover: s
      }),
      date: y,
      point: b
    }, m)));
  }
  return /* @__PURE__ */React__default["default"].createElement(is, {
    className: t,
    count: r,
    offset: u,
    wrap: !0
  }, g);
}
Ca.propTypes = Yp(Yp({}, xa), {}, {
  activeStartDate: k.instanceOf(Date),
  count: k.number,
  dateTransform: k.func.isRequired,
  dateType: k.string,
  offset: k.number,
  step: k.number,
  tile: k.func.isRequired
});
function Yl(e) {
  return Yl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Yl(e);
}
function Qp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qp(Object(n), !0).forEach(function (r) {
      Ug(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qp(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function x$(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function Jp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function $$(e, t, n) {
  return t && Jp(e.prototype, t), n && Jp(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function C$(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ql(e, t);
}
function Ql(e, t) {
  return Ql = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, Ql(e, t);
}
function R$(e) {
  var t = A$();
  return function () {
    var r = Io(e),
      a;
    if (t) {
      var i = Io(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return N$(this, a);
  };
}
function N$(e, t) {
  if (t && (Yl(t) === "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return qg(e);
}
function qg(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function A$() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused49) {
    return !1;
  }
}
function Io(e) {
  return Io = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Io(e);
}
function Ug(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Xp(e, t) {
  return e && !t || !e && t || e && t && e.getTime() !== t.getTime();
}
function Zp(e, t) {
  var n = e.activeStartDate,
    r = e.date,
    a = e.view;
  return typeof t == "function" ? t({
    activeStartDate: n,
    date: r,
    view: a
  }) : t;
}
var Ra = /* @__PURE__ */function (e) {
  C$(n, e);
  var t = R$(n);
  function n() {
    var r;
    x$(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), Ug(qg(r), "state", {}), r;
  }
  return $$(n, [{
    key: "render",
    value: function value() {
      var a = this.props,
        i = a.activeStartDate,
        o = a.children,
        s = a.classes,
        u = a.date,
        l = a.formatAbbr,
        c = a.locale,
        f = a.maxDate,
        h = a.maxDateTransform,
        p = a.minDate,
        v = a.minDateTransform,
        m = a.onClick,
        g = a.onMouseOver,
        b = a.style,
        y = a.tileDisabled,
        E = a.view,
        w = this.state,
        _ = w.tileClassName,
        C = w.tileContent;
      return /* @__PURE__ */React__default["default"].createElement("button", {
        className: Ko(s, _),
        disabled: p && v(p) > u || f && h(f) < u || y && y({
          activeStartDate: i,
          date: u,
          view: E
        }),
        onClick: m && function (D) {
          return m(u, D);
        },
        onFocus: g && function () {
          return g(u);
        },
        onMouseOver: g && function () {
          return g(u);
        },
        style: b,
        type: "button"
      }, l ? /* @__PURE__ */React__default["default"].createElement("abbr", {
        "aria-label": l(c, u)
      }, o) : o, C);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function value(a, i) {
      var o = a.activeStartDate,
        s = a.tileClassName,
        u = a.tileContent,
        l = {};
      return (s !== i.tileClassNameProps || Xp(o, i.activeStartDateProps)) && (l.tileClassName = Zp(a, s), l.tileClassNameProps = s), (u !== i.tileContentProps || Xp(o, i.activeStartDateProps)) && (l.tileContent = Zp(a, u), l.tileContentProps = u), l.activeStartDateProps = o, l;
    }
  }]), n;
}(React.Component);
Ra.propTypes = Kp(Kp({}, $a), {}, {
  children: k.node.isRequired,
  formatAbbr: k.func,
  maxDateTransform: k.func.isRequired,
  minDateTransform: k.func.isRequired
});
var I$ = ["classes", "formatYear"];
function em(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? em(Object(n), !0).forEach(function (r) {
      M$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : em(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function M$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Kl() {
  return Kl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Kl.apply(this, arguments);
}
function F$(e, t) {
  if (e == null) return {};
  var n = L$(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function L$(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var j$ = "react-calendar__century-view__decades__decade";
function zg(e) {
  var t = e.classes,
    n = e.formatYear,
    r = n === void 0 ? as : n,
    a = F$(e, I$),
    i = a.date,
    o = a.locale;
  return /* @__PURE__ */React__default["default"].createElement(Ra, Kl({}, a, {
    classes: [].concat(t, j$),
    maxDateTransform: Rr,
    minDateTransform: Cn,
    view: "century"
  }), Fg(o, r, i));
}
zg.propTypes = tm(tm({}, $a), {}, {
  formatYear: k.func
});
function nm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nm(Object(n), !0).forEach(function (r) {
      V$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function V$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Jl() {
  return Jl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jl.apply(this, arguments);
}
function Hg(e) {
  var t = e.activeStartDate,
    n = e$(t),
    r = n + 99;
  return /* @__PURE__ */React__default["default"].createElement(Ca, Jl({}, e, {
    className: "react-calendar__century-view__decades",
    dateTransform: Cn,
    dateType: "decade",
    end: r,
    start: n,
    step: 10,
    tile: zg
  }));
}
Hg.propTypes = B$({}, xa);
function Wg(e) {
  function t() {
    return /* @__PURE__ */React__default["default"].createElement(Hg, e);
  }
  return /* @__PURE__ */React__default["default"].createElement("div", {
    className: "react-calendar__century-view"
  }, t());
}
var q$ = ["classes", "formatYear"];
function rm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function am(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rm(Object(n), !0).forEach(function (r) {
      U$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function U$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Xl() {
  return Xl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xl.apply(this, arguments);
}
function z$(e, t) {
  if (e == null) return {};
  var n = H$(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function H$(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var W$ = "react-calendar__decade-view__years__year";
function Gg(e) {
  var t = e.classes,
    n = e.formatYear,
    r = n === void 0 ? as : n,
    a = z$(e, q$),
    i = a.date,
    o = a.locale;
  return /* @__PURE__ */React__default["default"].createElement(Ra, Xl({}, a, {
    classes: [].concat(t, W$),
    maxDateTransform: Ar,
    minDateTransform: Nr,
    view: "decade"
  }), r(o, i));
}
Gg.propTypes = am(am({}, $a), {}, {
  formatYear: k.func
});
function im(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function G$(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? im(Object(n), !0).forEach(function (r) {
      Y$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : im(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Y$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Zl() {
  return Zl = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Zl.apply(this, arguments);
}
function Yg(e) {
  var t = e.activeStartDate,
    n = t$(t),
    r = n + 9;
  return /* @__PURE__ */React__default["default"].createElement(Ca, Zl({}, e, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(i) {
      var o = new Date();
      return o.setFullYear(i, 0, 1), o.setHours(0, 0, 0, 0), o;
    },
    dateType: "year",
    end: r,
    start: n,
    tile: Gg
  }));
}
Yg.propTypes = G$({}, xa);
function Qg(e) {
  function t() {
    return /* @__PURE__ */React__default["default"].createElement(Yg, e);
  }
  return /* @__PURE__ */React__default["default"].createElement("div", {
    className: "react-calendar__decade-view"
  }, t());
}
var Q$ = ["classes", "formatMonth", "formatMonthYear"];
function om(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? om(Object(n), !0).forEach(function (r) {
      K$(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : om(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function K$(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ec() {
  return ec = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ec.apply(this, arguments);
}
function J$(e, t) {
  if (e == null) return {};
  var n = X$(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function X$(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Z$ = "react-calendar__year-view__months__month";
function Kg(e) {
  var t = e.classes,
    n = e.formatMonth,
    r = n === void 0 ? Qx : n,
    a = e.formatMonthYear,
    i = a === void 0 ? Ng : a,
    o = J$(e, Q$),
    s = o.date,
    u = o.locale;
  return /* @__PURE__ */React__default["default"].createElement(Ra, ec({}, o, {
    classes: [].concat(t, Z$),
    formatAbbr: i,
    maxDateTransform: Qn,
    minDateTransform: Yn,
    view: "year"
  }), r(u, s));
}
Kg.propTypes = sm(sm({}, $a), {}, {
  formatMonth: k.func,
  formatMonthYear: k.func
});
function um(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function lm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? um(Object(n), !0).forEach(function (r) {
      eC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : um(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function eC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function tc() {
  return tc = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, tc.apply(this, arguments);
}
function Jg(e) {
  var t = e.activeStartDate,
    n = 0,
    r = 11,
    a = je(t);
  return /* @__PURE__ */React__default["default"].createElement(Ca, tc({}, e, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(o) {
      var s = new Date();
      return s.setFullYear(a, o, 1), s.setHours(0, 0, 0, 0), s;
    },
    dateType: "month",
    end: r,
    start: n,
    tile: Kg
  }));
}
Jg.propTypes = lm(lm({}, xa), {}, {
  locale: k.string
});
function Xg(e) {
  function t() {
    return /* @__PURE__ */React__default["default"].createElement(Jg, e);
  }
  return /* @__PURE__ */React__default["default"].createElement("div", {
    className: "react-calendar__year-view"
  }, t());
}
var tC = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];
function cm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cm(Object(n), !0).forEach(function (r) {
      nC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function nc() {
  return nc = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nc.apply(this, arguments);
}
function rC(e, t) {
  if (e == null) return {};
  var n = aC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function aC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Ws = "react-calendar__month-view__days__day";
function Zg(e) {
  var t = e.formatDay,
    n = t === void 0 ? Gx : t,
    r = e.formatLongDate,
    a = r === void 0 ? Yx : r,
    i = e.calendarType,
    o = e.classes,
    s = e.currentMonthIndex,
    u = rC(e, tC),
    l = u.date,
    c = u.locale;
  return /* @__PURE__ */React__default["default"].createElement(Ra, nc({}, u, {
    classes: [].concat(o, Ws, c$(l, i) ? "".concat(Ws, "--weekend") : null, l.getMonth() !== s ? "".concat(Ws, "--neighboringMonth") : null),
    formatAbbr: a,
    maxDateTransform: Mr,
    minDateTransform: Ir,
    view: "month"
  }), n(c, l));
}
Zg.propTypes = fm(fm({}, $a), {}, {
  currentMonthIndex: k.number.isRequired,
  formatDay: k.func,
  formatLongDate: k.func
});
var iC = ["showFixedNumberOfWeeks", "showNeighboringMonth"];
function dm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function oC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dm(Object(n), !0).forEach(function (r) {
      sC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function sC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function rc() {
  return rc = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, rc.apply(this, arguments);
}
function uC(e, t) {
  if (e == null) return {};
  var n = lC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function lC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function eb(e) {
  var t = e.activeStartDate,
    n = e.calendarType,
    r = e.showFixedNumberOfWeeks,
    a = e.showNeighboringMonth,
    i = uC(e, iC),
    o = je(t),
    s = cn(t),
    u = r || a,
    l = da(t, n),
    c = u ? 0 : l,
    f = (u ? -l : 0) + 1,
    h = function () {
      if (r) return f + 6 * 7 - 1;
      var p = Rf(t);
      if (a) {
        var v = new Date();
        v.setFullYear(o, s, p), v.setHours(0, 0, 0, 0);
        var m = 7 - da(v, n) - 1;
        return p + m;
      }
      return p;
    }();
  return /* @__PURE__ */React__default["default"].createElement(Ca, rc({}, i, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: s,
    dateTransform: function dateTransform(v) {
      var m = new Date();
      return m.setFullYear(o, s, v), m.setHours(0, 0, 0, 0), m;
    },
    dateType: "day",
    end: h,
    offset: c,
    start: f,
    tile: Zg
  }));
}
eb.propTypes = oC({
  calendarType: Da.isRequired,
  showFixedNumberOfWeeks: k.bool,
  showNeighboringMonth: k.bool
}, xa);
var hm = "react-calendar__month-view__weekdays";
function tb(e) {
  for (var t = e.calendarType, n = e.formatShortWeekday, r = n === void 0 ? Kx : n, a = e.locale, i = e.onMouseLeave, o = new Date(), s = Yn(o), u = je(s), l = cn(s), c = [], f = 1; f <= 7; f += 1) {
    var h = new Date(u, l, f - da(s, t)),
      p = Jx(a, h);
    c.push( /* @__PURE__ */React__default["default"].createElement("div", {
      key: f,
      className: "".concat(hm, "__weekday")
    }, /* @__PURE__ */React__default["default"].createElement("abbr", {
      "aria-label": p,
      title: p
    }, r(a, h).replace(".", ""))));
  }
  return /* @__PURE__ */React__default["default"].createElement(is, {
    className: hm,
    count: 7,
    onFocus: i,
    onMouseOver: i
  }, c);
}
tb.propTypes = {
  calendarType: Da.isRequired,
  formatShortWeekday: k.func,
  locale: k.string,
  onMouseLeave: k.func
};
var cC = ["date", "onClickWeekNumber", "weekNumber"];
function ac() {
  return ac = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ac.apply(this, arguments);
}
function pm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pm(Object(n), !0).forEach(function (r) {
      dC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function dC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function hC(e, t) {
  if (e == null) return {};
  var n = pC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function pC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var mC = "react-calendar__tile";
function nb(e) {
  var t = e.date,
    n = e.onClickWeekNumber,
    r = e.weekNumber,
    a = hC(e, cC),
    i = fC({
      className: mC
    }, a),
    o = /* @__PURE__ */React__default["default"].createElement("span", null, r);
  return n ? /* @__PURE__ */React__default["default"].createElement("button", ac({}, i, {
    onClick: function onClick(u) {
      return n(r, t, u);
    },
    type: "button"
  }), o) : /* @__PURE__ */React__default["default"].createElement("div", i, o);
}
nb.propTypes = {
  date: k.instanceOf(Date).isRequired,
  onClickWeekNumber: k.func,
  weekNumber: k.node.isRequired
};
function rb(e) {
  var t = e.activeStartDate,
    n = e.calendarType,
    r = e.onClickWeekNumber,
    a = e.onMouseLeave,
    i = e.showFixedNumberOfWeeks,
    o = function () {
      if (i) return 6;
      var l = Rf(t),
        c = da(t, n),
        f = l - (7 - c);
      return 1 + Math.ceil(f / 7);
    }(),
    s = function () {
      for (var l = je(t), c = cn(t), f = $r(t), h = [], p = 0; p < o; p += 1) h.push(zl(new Date(l, c, f + p * 7), n));
      return h;
    }(),
    u = s.map(function (l) {
      return n$(l, n);
    });
  return /* @__PURE__ */React__default["default"].createElement(is, {
    className: "react-calendar__month-view__weekNumbers",
    count: o,
    direction: "column",
    onFocus: a,
    onMouseOver: a,
    style: {
      flexBasis: "calc(100% * (1 / 8)",
      flexShrink: 0
    }
  }, u.map(function (l, c) {
    return /* @__PURE__ */React__default["default"].createElement(nb, {
      key: l,
      date: s[c],
      onClickWeekNumber: r,
      weekNumber: l
    });
  }));
}
rb.propTypes = {
  activeStartDate: k.instanceOf(Date).isRequired,
  calendarType: Da.isRequired,
  onClickWeekNumber: k.func,
  onMouseLeave: k.func,
  showFixedNumberOfWeeks: k.bool
};
var vC = ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"];
function ic() {
  return ic = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ic.apply(this, arguments);
}
function yC(e, t) {
  if (e == null) return {};
  var n = gC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function gC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function bC(e) {
  return Object.keys(Bp).find(function (t) {
    return Bp[t].includes(e);
  }) || ut.ISO_8601;
}
function Mf(e) {
  var t = e.activeStartDate,
    n = e.locale,
    r = e.onMouseLeave,
    a = e.showFixedNumberOfWeeks,
    i = e.calendarType,
    o = i === void 0 ? bC(n) : i,
    s = e.formatShortWeekday,
    u = e.onClickWeekNumber,
    l = e.showWeekNumbers,
    c = yC(e, vC);
  function f() {
    return /* @__PURE__ */React__default["default"].createElement(tb, {
      calendarType: o,
      formatShortWeekday: s,
      locale: n,
      onMouseLeave: r
    });
  }
  function h() {
    return l ? /* @__PURE__ */React__default["default"].createElement(rb, {
      activeStartDate: t,
      calendarType: o,
      onClickWeekNumber: u,
      onMouseLeave: r,
      showFixedNumberOfWeeks: a
    }) : null;
  }
  function p() {
    return /* @__PURE__ */React__default["default"].createElement(eb, ic({
      calendarType: o
    }, c));
  }
  var v = "react-calendar__month-view";
  return /* @__PURE__ */React__default["default"].createElement("div", {
    className: Ko(v, l ? "".concat(v, "--weekNumbers") : "")
  }, /* @__PURE__ */React__default["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "flex-end"
    }
  }, h(), /* @__PURE__ */React__default["default"].createElement("div", {
    style: {
      flexGrow: 1,
      width: "100%"
    }
  }, f(), p())));
}
Mf.propTypes = {
  activeStartDate: k.instanceOf(Date).isRequired,
  calendarType: Da,
  formatShortWeekday: k.func,
  locale: k.string,
  onClickWeekNumber: k.func,
  onMouseLeave: k.func,
  showFixedNumberOfWeeks: k.bool,
  showWeekNumbers: k.bool
};
var _C = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];
function dr() {
  return dr = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dr.apply(this, arguments);
}
function ma(e) {
  return ma = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ma(e);
}
function wC(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function mm(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function OC(e, t, n) {
  return t && mm(e.prototype, t), n && mm(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function SC(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && oc(e, t);
}
function oc(e, t) {
  return oc = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, oc(e, t);
}
function EC(e) {
  var t = TC();
  return function () {
    var r = Mo(e),
      a;
    if (t) {
      var i = Mo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return PC(this, a);
  };
}
function PC(e, t) {
  if (t && (ma(t) === "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return kt(e);
}
function kt(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function TC() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused50) {
    return !1;
  }
}
function Mo(e) {
  return Mo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Mo(e);
}
function vm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vm(Object(n), !0).forEach(function (r) {
      Ht(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ht(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function kC(e, t) {
  if (e == null) return {};
  var n = DC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function DC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function xC(e) {
  return NC(e) || RC(e) || CC(e) || $C();
}
function $C() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CC(e, t) {
  if (e) {
    if (typeof e == "string") return uc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uc(e, t);
  }
}
function RC(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function NC(e) {
  if (Array.isArray(e)) return uc(e);
}
function uc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var Ff = new Date();
Ff.setFullYear(1, 0, 1);
Ff.setHours(0, 0, 0, 0);
var AC = new Date(864e13),
  Va = "react-calendar",
  Vn = ["century", "decade", "year", "month"],
  IC = [].concat(xC(Vn.slice(1)), ["day"]);
function MC(e) {
  return e instanceof Date ? e : new Date(e);
}
function ab(e, t) {
  return Vn.slice(Vn.indexOf(e), Vn.indexOf(t) + 1);
}
function FC(e, t, n) {
  var r = ab(t, n);
  return r.indexOf(e) !== -1;
}
function Lf(e, t, n) {
  return FC(e, t, n) ? e : n;
}
function ib(e) {
  return IC[Vn.indexOf(e)];
}
function LC(e, t) {
  if (!e) return null;
  var n = Array.isArray(e) && e.length === 2 ? e[t] : e;
  if (!n) return null;
  var r = MC(n);
  if (isNaN(r.getTime())) throw new Error("Invalid date: ".concat(e));
  return r;
}
function ob(e, t) {
  var n = e.value,
    r = e.minDate,
    a = e.maxDate,
    i = e.maxDetail,
    o = LC(n, t);
  if (!o) return null;
  var s = ib(i),
    u = [Bn, Ig][t](s, o);
  return O$(u, r, a);
}
var jf = function jf(t) {
    return ob(t, 0);
  },
  sb = function sb(t) {
    return ob(t, 1);
  },
  jC = function jC(t) {
    var n = t.value;
    return Array.isArray(n) ? n : [jf, sb].map(function (r) {
      return r(t);
    });
  };
function ub(e) {
  var t = e.maxDate,
    n = e.maxDetail,
    r = e.minDate,
    a = e.minDetail,
    i = e.value,
    o = e.view,
    s = Lf(o, a, n),
    u = jf({
      value: i,
      minDate: r,
      maxDate: t,
      maxDetail: n
    }) || new Date();
  return Bn(s, u);
}
function BC(e) {
  var t = e.activeStartDate,
    n = e.defaultActiveStartDate,
    r = e.defaultValue,
    a = e.defaultView,
    i = e.maxDetail,
    o = e.minDetail,
    s = e.value,
    u = e.view,
    l = kC(e, _C),
    c = Lf(u, o, i),
    f = t || n;
  return f ? Bn(c, f) : ub(sc({
    maxDetail: i,
    minDetail: o,
    value: s || r,
    view: u || a
  }, l));
}
var Gs = function Gs(t) {
    return t && [].concat(t).length === 1;
  },
  Fo = /* @__PURE__ */function (e) {
    SC(n, e);
    var t = EC(n);
    function n() {
      var r;
      wC(this, n);
      for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
      return r = t.call.apply(t, [this].concat(i)), Ht(kt(r), "state", {
        activeStartDate: r.props.defaultActiveStartDate,
        value: r.props.defaultValue,
        view: r.props.defaultView
      }), Ht(kt(r), "setStateAndCallCallbacks", function (s, u, l) {
        var c = kt(r),
          f = c.activeStartDate,
          h = c.view,
          p = r.props,
          v = p.allowPartialRange,
          m = p.onActiveStartDateChange,
          g = p.onChange,
          b = p.onViewChange,
          y = p.selectRange,
          E = {
            activeStartDate: f,
            view: h
          };
        r.setState(s, function () {
          var w = {
            action: s.action,
            activeStartDate: s.activeStartDate || r.activeStartDate,
            value: s.value || r.value,
            view: s.view || r.view
          };
          function _(D) {
            return (
              // Key must exist, and…
              D in s && (
              // …key changed from undefined to defined or the other way around, or…
              ma(s[D]) !== ma(E[D]) || (
              // …value changed.
              s[D] instanceof Date ? s[D].getTime() !== E[D].getTime() : s[D] !== E[D]))
            );
          }
          if (_("activeStartDate") && m && m(w), _("view") && b && b(w), _("value") && g) if (y) {
            var C = Gs(s.value);
            C ? v && g([s.value], u) : g(s.value, u);
          } else g(s.value, u);
          l && l(w);
        });
      }), Ht(kt(r), "setActiveStartDate", function (s, u) {
        r.setStateAndCallCallbacks({
          action: u,
          activeStartDate: s
        });
      }), Ht(kt(r), "drillDown", function (s, u) {
        if (r.drillDownAvailable) {
          r.onClickTile(s, u);
          var l = kt(r),
            c = l.view,
            f = l.views,
            h = r.props.onDrillDown,
            p = f[f.indexOf(c) + 1];
          r.setStateAndCallCallbacks({
            action: "drillDown",
            activeStartDate: s,
            view: p
          }, void 0, h);
        }
      }), Ht(kt(r), "drillUp", function () {
        if (r.drillUpAvailable) {
          var s = kt(r),
            u = s.activeStartDate,
            l = s.view,
            c = s.views,
            f = r.props.onDrillUp,
            h = c[c.indexOf(l) - 1],
            p = Bn(h, u);
          r.setStateAndCallCallbacks({
            action: "drillUp",
            activeStartDate: p,
            view: h
          }, void 0, f);
        }
      }), Ht(kt(r), "onChange", function (s, u) {
        var l = r.props.selectRange;
        r.onClickTile(s, u);
        var c;
        if (l) {
          var f = kt(r),
            h = f.value,
            p = f.valueType;
          Gs(h) ? c = u$(p, h, s) : c = Bn(p, s);
        } else c = r.getProcessedValue(s);
        var v = ub(sc(sc({}, r.props), {}, {
          value: c
        }));
        u.persist(), r.setStateAndCallCallbacks({
          action: "onChange",
          activeStartDate: v,
          value: c
        }, u);
      }), Ht(kt(r), "onClickTile", function (s, u) {
        var l = kt(r),
          c = l.view,
          f = r.props,
          h = f.onClickDay,
          p = f.onClickDecade,
          v = f.onClickMonth,
          m = f.onClickYear,
          g = function () {
            switch (c) {
              case "century":
                return p;
              case "decade":
                return m;
              case "year":
                return v;
              case "month":
                return h;
              default:
                throw new Error("Invalid view: ".concat(c, "."));
            }
          }();
        g && g(s, u);
      }), Ht(kt(r), "onMouseOver", function (s) {
        r.setState(function (u) {
          return u.hover && u.hover.getTime() === s.getTime() ? null : {
            hover: s
          };
        });
      }), Ht(kt(r), "onMouseLeave", function () {
        r.setState({
          hover: null
        });
      }), r;
    }
    return OC(n, [{
      key: "activeStartDate",
      get: function get() {
        var a = this.props.activeStartDate,
          i = this.state.activeStartDate;
        return a || i || BC(this.props);
      }
    }, {
      key: "value",
      get: function get() {
        var a = this.props,
          i = a.selectRange,
          o = a.value,
          s = this.state.value;
        return i && Gs(s) ? s : o !== void 0 ? o : s;
      }
    }, {
      key: "valueType",
      get: function get() {
        var a = this.props.maxDetail;
        return ib(a);
      }
    }, {
      key: "view",
      get: function get() {
        var a = this.props,
          i = a.minDetail,
          o = a.maxDetail,
          s = a.view,
          u = this.state.view;
        return Lf(s || u, i, o);
      }
    }, {
      key: "views",
      get: function get() {
        var a = this.props,
          i = a.minDetail,
          o = a.maxDetail;
        return ab(i, o);
      }
    }, {
      key: "hover",
      get: function get() {
        var a = this.props.selectRange,
          i = this.state.hover;
        return a ? i : null;
      }
    }, {
      key: "drillDownAvailable",
      get: function get() {
        var a = this.view,
          i = this.views;
        return i.indexOf(a) < i.length - 1;
      }
    }, {
      key: "drillUpAvailable",
      get: function get() {
        var a = this.view,
          i = this.views;
        return i.indexOf(a) > 0;
      }
      /**
       * Gets current value in a desired format.
       */
    }, {
      key: "getProcessedValue",
      value: function value(a) {
        var i = this.props,
          o = i.minDate,
          s = i.maxDate,
          u = i.maxDetail,
          l = i.returnValue,
          c = function () {
            switch (l) {
              case "start":
                return jf;
              case "end":
                return sb;
              case "range":
                return jC;
              default:
                throw new Error("Invalid returnValue.");
            }
          }();
        return c({
          value: a,
          minDate: o,
          maxDate: s,
          maxDetail: u
        });
      }
    }, {
      key: "renderContent",
      value: function value(a) {
        var i = this.activeStartDate,
          o = this.onMouseOver,
          s = this.valueType,
          u = this.value,
          l = this.view,
          c = this.props,
          f = c.calendarType,
          h = c.locale,
          p = c.maxDate,
          v = c.minDate,
          m = c.selectRange,
          g = c.tileClassName,
          b = c.tileContent,
          y = c.tileDisabled,
          E = this.hover,
          w = a ? Ag(l, i) : Bn(l, i),
          _ = this.drillDownAvailable ? this.drillDown : this.onChange,
          C = {
            activeStartDate: w,
            hover: E,
            locale: h,
            maxDate: p,
            minDate: v,
            onClick: _,
            onMouseOver: m ? o : null,
            tileClassName: g,
            tileContent: b,
            tileDisabled: y,
            value: u,
            valueType: s
          };
        switch (l) {
          case "century":
            {
              var D = this.props.formatYear;
              return /* @__PURE__ */React__default["default"].createElement(Wg, dr({
                formatYear: D
              }, C));
            }
          case "decade":
            {
              var U = this.props.formatYear;
              return /* @__PURE__ */React__default["default"].createElement(Qg, dr({
                formatYear: U
              }, C));
            }
          case "year":
            {
              var Z = this.props,
                me = Z.formatMonth,
                ye = Z.formatMonthYear;
              return /* @__PURE__ */React__default["default"].createElement(Xg, dr({
                formatMonth: me,
                formatMonthYear: ye
              }, C));
            }
          case "month":
            {
              var Y = this.props,
                K = Y.formatDay,
                ee = Y.formatLongDate,
                ne = Y.formatShortWeekday,
                ie = Y.onClickWeekNumber,
                fe = Y.showDoubleView,
                ce = Y.showFixedNumberOfWeeks,
                H = Y.showNeighboringMonth,
                O = Y.showWeekNumbers,
                I = this.onMouseLeave;
              return /* @__PURE__ */React__default["default"].createElement(Mf, dr({
                calendarType: f,
                formatDay: K,
                formatLongDate: ee,
                formatShortWeekday: ne,
                onClickWeekNumber: ie,
                onMouseLeave: m ? I : null,
                showFixedNumberOfWeeks: typeof ce < "u" ? ce : fe,
                showNeighboringMonth: H,
                showWeekNumbers: O
              }, C));
            }
          default:
            throw new Error("Invalid view: ".concat(l, "."));
        }
      }
    }, {
      key: "renderNavigation",
      value: function value() {
        var a = this.props.showNavigation;
        if (!a) return null;
        var i = this.activeStartDate,
          o = this.view,
          s = this.views,
          u = this.props,
          l = u.formatMonthYear,
          c = u.formatYear,
          f = u.locale,
          h = u.maxDate,
          p = u.minDate,
          v = u.navigationAriaLabel,
          m = u.navigationAriaLive,
          g = u.navigationLabel,
          b = u.next2AriaLabel,
          y = u.next2Label,
          E = u.nextAriaLabel,
          w = u.nextLabel,
          _ = u.prev2AriaLabel,
          C = u.prev2Label,
          D = u.prevAriaLabel,
          U = u.prevLabel,
          Z = u.showDoubleView;
        return /* @__PURE__ */React__default["default"].createElement(Bg, {
          activeStartDate: i,
          drillUp: this.drillUp,
          formatMonthYear: l,
          formatYear: c,
          locale: f,
          maxDate: h,
          minDate: p,
          navigationAriaLabel: v,
          navigationAriaLive: m,
          navigationLabel: g,
          next2AriaLabel: b,
          next2Label: y,
          nextAriaLabel: E,
          nextLabel: w,
          prev2AriaLabel: _,
          prev2Label: C,
          prevAriaLabel: D,
          prevLabel: U,
          setActiveStartDate: this.setActiveStartDate,
          showDoubleView: Z,
          view: o,
          views: s
        });
      }
    }, {
      key: "render",
      value: function value() {
        var a = this.props,
          i = a.className,
          o = a.inputRef,
          s = a.selectRange,
          u = a.showDoubleView,
          l = this.onMouseLeave,
          c = this.value,
          f = [].concat(c);
        return /* @__PURE__ */React__default["default"].createElement("div", {
          className: Ko(Va, s && f.length === 1 && "".concat(Va, "--selectRange"), u && "".concat(Va, "--doubleView"), i),
          ref: o
        }, this.renderNavigation(), /* @__PURE__ */React__default["default"].createElement("div", {
          className: "".concat(Va, "__viewContainer"),
          onBlur: s ? l : null,
          onMouseLeave: s ? l : null
        }, this.renderContent(), u && this.renderContent(!0)));
      }
    }]), n;
  }(React.Component);
Fo.defaultProps = {
  maxDate: AC,
  maxDetail: "month",
  minDate: Ff,
  minDetail: "century",
  returnValue: "start",
  showNavigation: !0,
  showNeighboringMonth: !0
};
var ym = k.instanceOf(Date),
  gm = k.oneOfType([k.string, jg]);
Fo.propTypes = {
  activeStartDate: ym,
  allowPartialRange: k.bool,
  calendarType: Da,
  className: Ao,
  defaultActiveStartDate: ym,
  defaultValue: gm,
  defaultView: ha,
  formatDay: k.func,
  formatLongDate: k.func,
  formatMonth: k.func,
  formatMonthYear: k.func,
  formatShortWeekday: k.func,
  formatYear: k.func,
  inputRef: d$,
  locale: k.string,
  maxDate: If,
  maxDetail: k.oneOf(Vn),
  minDate: Af,
  minDetail: k.oneOf(Vn),
  navigationAriaLabel: k.string,
  navigationAriaLive: k.oneOf(["off", "polite", "assertive"]),
  navigationLabel: k.func,
  next2AriaLabel: k.string,
  next2Label: k.node,
  nextAriaLabel: k.string,
  nextLabel: k.node,
  onActiveStartDateChange: k.func,
  onChange: k.func,
  onClickDay: k.func,
  onClickDecade: k.func,
  onClickMonth: k.func,
  onClickWeekNumber: k.func,
  onClickYear: k.func,
  onDrillDown: k.func,
  onDrillUp: k.func,
  onViewChange: k.func,
  prev2AriaLabel: k.string,
  prev2Label: k.node,
  prevAriaLabel: k.string,
  prevLabel: k.node,
  returnValue: k.oneOf(["start", "end", "range"]),
  selectRange: k.bool,
  showDoubleView: k.bool,
  showFixedNumberOfWeeks: k.bool,
  showNavigation: k.bool,
  showNeighboringMonth: k.bool,
  showWeekNumbers: k.bool,
  tileClassName: k.oneOfType([k.func, Ao]),
  tileContent: k.oneOfType([k.func, k.node]),
  tileDisabled: k.func,
  value: gm,
  view: ha
};
var VC = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    Calendar: Fo,
    CenturyView: Wg,
    DecadeView: Qg,
    MonthView: Mf,
    YearView: Xg,
    default: Fo
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  qC = /* @__PURE__ */kn(VC);
var St = function St(t) {
    return t.getBoundingClientRect();
  },
  UC = function UC(t, n) {
    return {
      get collidedTop() {
        return St(t).top < St(n).top;
      },
      get collidedBottom() {
        return St(t).bottom > St(n).bottom;
      },
      get collidedLeft() {
        return St(t).left < St(n).left;
      },
      get collidedRight() {
        return St(t).right > St(n).right;
      },
      get overflowTop() {
        return St(n).top - St(t).top;
      },
      get overflowBottom() {
        return St(t).bottom - St(n).bottom;
      },
      get overflowLeft() {
        return St(n).left - St(t).left;
      },
      get overflowRight() {
        return St(t).right - St(n).right;
      }
    };
  };
var bm = UC;
var zC = process.env.NODE_ENV === "production";
function pt(e, t) {
  if (!zC) {
    if (e) return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch (_unused51) {}
  }
}
var HC = ["invertAxis", "invertSecondaryAxis"];
function WC(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _m(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function GC(e, t, n) {
  return t && _m(e.prototype, t), n && _m(e, n), e;
}
function YC(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && lc(e, t);
}
function lc(e, t) {
  return lc = Object.setPrototypeOf || function (r, a) {
    return r.__proto__ = a, r;
  }, lc(e, t);
}
function QC(e) {
  var t = JC();
  return function () {
    var r = Lo(e),
      a;
    if (t) {
      var i = Lo(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else a = r.apply(this, arguments);
    return KC(this, a);
  };
}
function KC(e, t) {
  if (t && (yr(t) === "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return Yr(e);
}
function Yr(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JC() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (_unused52) {
    return !1;
  }
}
function Lo(e) {
  return Lo = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Lo(e);
}
function XC(e, t) {
  if (e == null) return {};
  var n = ZC(e, t),
    r,
    a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++) r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function ZC(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function wm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wm(Object(n), !0).forEach(function (r) {
      qi(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wm(Object(n)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qi(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function yr(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yr = function yr(n) {
    return typeof n;
  } : yr = function yr(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, yr(e);
}
var lb = typeof window < "u",
  Om = lb && "CSS" in window && "supports" in window.CSS && CSS.supports("display", "contents"),
  Sm = lb && "MutationObserver" in window;
function qa(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function Em(e) {
  if (e) {
    for (var t = e.parentElement; t;) {
      var n = window.getComputedStyle(t),
        r = n.overflow;
      if (r.split(" ").every(function (a) {
        return a === "auto" || a === "scroll";
      })) return t;
      t = t.parentElement;
    }
    return document.documentElement;
  }
}
function cb(e) {
  var t = e.axis,
    n = e.container,
    r = e.element,
    a = e.invertAxis,
    i = e.secondary,
    o = e.scrollContainer,
    s = e.spacing,
    u = window.getComputedStyle(r),
    l = n.parentElement,
    c = bm(l, o),
    f = bm(l, document.documentElement),
    h = t === "x",
    p = h ? "left" : "top",
    v = h ? "right" : "bottom",
    m = h ? "width" : "height",
    g = "overflow".concat(qa(p)),
    b = "overflow".concat(qa(v)),
    y = "scroll".concat(qa(p)),
    E = qa(m),
    w = "offset".concat(E),
    _ = "client".concat(E),
    C = "min-".concat(m),
    D = o[w] - o[_],
    U = yr(s) === "object" ? s[p] : s,
    Z = -Math.max(c[g], f[g] + document.documentElement[y]) - U,
    me = yr(s) === "object" ? s[v] : s,
    ye = -Math.max(c[b], f[b] - document.documentElement[y]) - me - D;
  i && (Z += l[_], ye += l[_]);
  var Y = r[w];
  function K() {
    r.style[p] = "auto", r.style[v] = i ? "0" : "100%";
  }
  function ee() {
    r.style[p] = i ? "0" : "100%", r.style[v] = "auto";
  }
  function ne(O, I) {
    var B = Y <= O;
    return B && I(), B;
  }
  function ie() {
    return ne(Z, K);
  }
  function fe() {
    return ne(ye, ee);
  }
  function ce() {
    var O = Z > ye,
      I = u[C] && parseInt(u[C], 10);
    function B(W) {
      pt(!I || W >= I, "<Fit />'s child will not fit anywhere with its current ".concat(C, " of ").concat(I, "px."));
      var G = Math.max(W, I || 0);
      pt(!1, "<Fit />'s child needed to have its ".concat(m, " decreased to ").concat(G, "px.")), r.style[m] = "".concat(G, "px");
    }
    O ? (B(Z), K()) : (B(ye), ee());
  }
  var H;
  a ? H = ie() || fe() : H = fe() || ie(), H || ce();
}
function eR(e) {
  cb(e);
}
function tR(e) {
  cb(hr(hr({}, e), {}, {
    axis: e.axis === "x" ? "y" : "x",
    secondary: !0
  }));
}
function nR(e) {
  var t = e.invertAxis,
    n = e.invertSecondaryAxis,
    r = XC(e, HC);
  eR(hr(hr({}, r), {}, {
    invertAxis: t
  })), tR(hr(hr({}, r), {}, {
    invertAxis: n
  }));
}
var Bf = /* @__PURE__ */function (e) {
  YC(n, e);
  var t = QC(n);
  function n() {
    var r;
    WC(this, n);
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
    return r = t.call.apply(t, [this].concat(i)), qi(Yr(r), "onMutation", function () {
      r.fit();
    }), qi(Yr(r), "mutationObserver", Sm && new MutationObserver(r.onMutation)), qi(Yr(r), "fit", function () {
      var s = Yr(r),
        u = s.scrollContainer,
        l = s.container,
        c = s.element;
      if (c) {
        var f = c.clientWidth,
          h = c.clientHeight;
        if (!(r.elementWidth === f && r.elementHeight === h)) {
          r.elementWidth = f, r.elementHeight = h;
          var p = l.parentElement;
          if (p) {
            var v = window.getComputedStyle(c),
              m = v.position;
            m !== "absolute" && (pt(!1, "<Fit />'s child does not have absolute position. You should apply `position: absolute` to it."), c.style.position = "absolute");
            var g = window.getComputedStyle(p),
              b = g.position;
            b !== "relative" && b !== "absolute" && (pt(!1, "<Fit />'s parent does not have relative position. You should apply `position: relative` to it."), p.style.position = "relative");
            var y = r.props,
              E = y.invertAxis,
              w = y.invertSecondaryAxis,
              _ = y.mainAxis,
              C = y.spacing;
            nR({
              container: l,
              element: c,
              invertAxis: E,
              invertSecondaryAxis: w,
              axis: _,
              scrollContainer: u,
              spacing: C
            });
          }
        }
      }
    }), r;
  }
  return GC(n, [{
    key: "componentDidMount",
    value: function value() {
      if (!Om) {
        var a = ReactDOM.findDOMNode(this);
        this.container = a, this.element = a, this.scrollContainer = Em(a);
      }
      this.fit(), Sm && this.mutationObserver.observe(this.element, {
        attributes: !0,
        attributeFilter: ["class", "style"]
      });
    }
  }, {
    key: "render",
    value: function value() {
      var a = this,
        i = this.props.children,
        o = React__default["default"].Children.only(i);
      return Om ? /* @__PURE__ */React__default["default"].createElement("span", {
        ref: function ref(u) {
          a.container = u;
          var l = u && u.firstChild;
          a.element = l, a.scrollContainer = Em(l);
        },
        style: {
          display: "contents"
        }
      }, o) : o;
    }
  }]), n;
}(React.Component);
Bf.propTypes = {
  children: k.node,
  invertAxis: k.bool,
  invertSecondaryAxis: k.bool,
  mainAxis: k.oneOf(["x", "y"]),
  spacing: k.oneOfType([k.number, k.shape({
    bottom: k.number.isRequired,
    left: k.number.isRequired,
    right: k.number.isRequired,
    top: k.number.isRequired
  })])
};
Bf.defaultProps = {
  mainAxis: "y",
  spacing: 8
};
var rR = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: Bf
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  aR = /* @__PURE__ */kn(rR);
var fb = {};
var Jn = /* @__PURE__ */kn(Rx);
var db = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = a;
  var t = r(React__default["default"]),
    n = r(k);
  function r(i) {
    return i && i.__esModule ? i : {
      default: i
    };
  }
  function a(i) {
    var o = i.children;
    return /* @__PURE__ */t.default.createElement("span", {
      className: "react-date-picker__inputGroup__divider"
    }, o);
  }
  a.propTypes = {
    children: n.default.node
  };
})(db);
var hb = {},
  os = {};
function iR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  var r = t.filter(Boolean);
  return r.length <= 1 ? r[0] : function (i) {
    r.forEach(function (o) {
      typeof o == "function" ? o(i) : o.current = i;
    });
  };
}
var oR = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: iR
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  sR = /* @__PURE__ */kn(oR);
var uR = ["normal", "small-caps"];
function pb(e) {
  if (!e) return "";
  var t = window.getComputedStyle(e);
  if (t.font) return t.font;
  var n = t["font-family"] !== "";
  if (!n) return "";
  var r = uR.includes(t["font-variant"]) ? t["font-variant"] : "normal";
  return "".concat(t["font-style"], " ").concat(r, " ").concat(t["font-weight"], " ").concat(t["font-size"], " / ").concat(t["line-height"], " ").concat(t["font-family"]);
}
function jo(e, t) {
  var n = jo.canvas || (jo.canvas = document.createElement("canvas")),
    r = n.getContext("2d");
  if (!r) return null;
  r.font = t;
  var a = r.measureText(e),
    i = a.width;
  return Math.ceil(i);
}
function Pm(e) {
  if (typeof window > "u" || !e) return null;
  var t = pb(e),
    n = e.value || e.placeholder,
    r = jo(n, t);
  return r === null ? null : (e.style.width = "".concat(r, "px"), r);
}
var lR = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
    __proto__: null,
    default: Pm,
    getFontShorthand: pb,
    measureText: jo,
    updateInputWidth: Pm
  }, Symbol.toStringTag, {
    value: "Module"
  })),
  cR = /* @__PURE__ */kn(lR);
var _t = {};
Object.defineProperty(_t, "__esModule", {
  value: !0
});
_t.isValueType = _t.isRef = _t.isMinDate = _t.isMaxDate = void 0;
var Qr = fR(k);
function fR(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function Er(e) {
  return Er = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Er(e);
}
function dR(e) {
  return vR(e) || mR(e) || pR(e) || hR();
}
function hR() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pR(e, t) {
  if (e) {
    if (typeof e == "string") return cc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cc(e, t);
  }
}
function mR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function vR(e) {
  if (Array.isArray(e)) return cc(e);
}
function cc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var yR = ["century", "decade", "year", "month"],
  gR = [].concat(dR(yR.slice(1)), ["day"]),
  bR = Qr.default.oneOf(gR);
_t.isValueType = bR;
var _R = function _R(t, n, r) {
  var a = t[n];
  if (!a) return null;
  if (!(a instanceof Date)) return new Error("Invalid prop `".concat(n, "` of type `").concat(Er(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
  var i = t.maxDate;
  return i && a > i ? new Error("Invalid prop `".concat(n, "` of type `").concat(Er(a), "` supplied to `").concat(r, "`, minDate cannot be larger than maxDate.")) : null;
};
_t.isMinDate = _R;
var wR = function wR(t, n, r) {
  var a = t[n];
  if (!a) return null;
  if (!(a instanceof Date)) return new Error("Invalid prop `".concat(n, "` of type `").concat(Er(a), "` supplied to `").concat(r, "`, expected instance of `Date`."));
  var i = t.minDate;
  return i && a < i ? new Error("Invalid prop `".concat(n, "` of type `").concat(Er(a), "` supplied to `").concat(r, "`, maxDate cannot be smaller than minDate.")) : null;
};
_t.isMaxDate = wR;
var OR = Qr.default.oneOfType([Qr.default.func, Qr.default.shape({
  current: Qr.default.any
})]);
_t.isRef = OR;
(function (e) {
  function t(y) {
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (E) {
      return typeof E;
    } : function (E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, t(y);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = b;
  var n = c(React__default["default"]),
    r = c(k),
    a = c(yf),
    i = c(sR),
    o = l(cR),
    s = _t;
  function u(y) {
    if (typeof WeakMap != "function") return null;
    var E = /* @__PURE__ */new WeakMap(),
      w = /* @__PURE__ */new WeakMap();
    return (u = function u(C) {
      return C ? w : E;
    })(y);
  }
  function l(y, E) {
    if (!E && y && y.__esModule) return y;
    if (y === null || t(y) !== "object" && typeof y != "function") return {
      default: y
    };
    var w = u(E);
    if (w && w.has(y)) return w.get(y);
    var _ = {},
      C = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var D in y) if (D !== "default" && Object.prototype.hasOwnProperty.call(y, D)) {
      var U = C ? Object.getOwnPropertyDescriptor(y, D) : null;
      U && (U.get || U.set) ? Object.defineProperty(_, D, U) : _[D] = y[D];
    }
    return _.default = y, w && w.set(y, _), _;
  }
  function c(y) {
    return y && y.__esModule ? y : {
      default: y
    };
  }
  var f = typeof window < "u" && /(MSIE|Trident\/|Edge\/)/.test(window.navigator.userAgent),
    h = typeof window < "u" && /Firefox/.test(window.navigator.userAgent);
  function p(y) {
    var E = y.target;
    f ? requestAnimationFrame(function () {
      return E.select();
    }) : E.select();
  }
  function v(y) {
    if (!document.fonts) return;
    var E = (0, o.getFontShorthand)(y);
    if (!E) return;
    var w = document.fonts.check(E);
    if (w) return;
    function _() {
      (0, o.default)(y);
    }
    document.fonts.addEventListener("loadingdone", _);
  }
  function m(y) {
    return y && "selectionStart" in y && y.selectionStart !== null ? y.value.slice(y.selectionStart, y.selectionEnd) : "getSelection" in window ? window.getSelection().toString() : null;
  }
  function g(y) {
    return function (w) {
      if (!h) {
        var _ = w.key,
          C = w.target,
          D = C.value,
          U = _.length === 1 && /\d/.test(_),
          Z = m(C);
        (!U || !(Z || D.length < y)) && w.preventDefault();
      }
    };
  }
  function b(y) {
    var E = y.ariaLabel,
      w = y.autoFocus,
      _ = y.className,
      C = y.disabled,
      D = y.inputRef,
      U = y.max,
      Z = y.min,
      me = y.name,
      ye = y.nameForClass,
      Y = y.onChange,
      K = y.onKeyDown,
      ee = y.onKeyUp,
      ne = y.placeholder,
      ie = ne === void 0 ? "--" : ne,
      fe = y.required,
      ce = y.showLeadingZeros,
      H = y.step,
      O = y.value,
      I = ce && O && O < 10 && (O === "0" || !O.toString().startsWith("0")),
      B = U ? U.toString().length : null;
    return [I && /* @__PURE__ */n.default.createElement("span", {
      key: "leadingZero",
      className: "".concat(_, "__leadingZero")
    }, "0"), /* @__PURE__ */n.default.createElement("input", {
      key: "input",
      "aria-label": E,
      autoComplete: "off",
      autoFocus: w,
      className: (0, a.default)("".concat(_, "__input"), "".concat(_, "__").concat(ye || me), I && "".concat(_, "__input--hasLeadingZero")),
      "data-input": "true",
      disabled: C,
      inputMode: "numeric",
      max: U,
      min: Z,
      name: me,
      onChange: Y,
      onFocus: p,
      onKeyDown: K,
      onKeyPress: g(B),
      onKeyUp: function onKeyUp(G) {
        (0, o.default)(G.target), ee && ee(G);
      },
      placeholder: ie,
      ref: (0, i.default)(o.default, v, D),
      required: fe,
      step: H,
      type: "number",
      value: O !== null ? O : ""
    })];
  }
  b.propTypes = {
    ariaLabel: r.default.string,
    autoFocus: r.default.bool,
    className: r.default.string.isRequired,
    disabled: r.default.bool,
    inputRef: s.isRef,
    max: r.default.number,
    min: r.default.number,
    name: r.default.string,
    nameForClass: r.default.string,
    onChange: r.default.func,
    onKeyDown: r.default.func,
    onKeyUp: r.default.func,
    placeholder: r.default.string,
    required: r.default.bool,
    showLeadingZeros: r.default.bool,
    step: r.default.number,
    value: r.default.string
  };
})(os);
var fn = {};
Object.defineProperty(fn, "__esModule", {
  value: !0
});
fn.between = kR;
fn.safeMax = xR;
fn.safeMin = DR;
function mb(e) {
  return TR(e) || PR(e) || ER(e) || SR();
}
function SR() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ER(e, t) {
  if (e) {
    if (typeof e == "string") return fc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return fc(e, t);
  }
}
function PR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function TR(e) {
  if (Array.isArray(e)) return fc(e);
}
function fc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function kR(e, t, n) {
  return t && t > e ? t : n && n < e ? n : e;
}
function vb(e) {
  return e !== null && e !== !1 && !Number.isNaN(Number(e));
}
function DR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return Math.min.apply(Math, mb(t.filter(vb)));
}
function xR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return Math.max.apply(Math, mb(t.filter(vb)));
}
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var t = u(React__default["default"]),
    n = u(k),
    r = Jn,
    a = u(os),
    i = _t,
    o = fn,
    s = ["maxDate", "minDate", "month", "year"];
  function u(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  function l() {
    return l = Object.assign || function (p) {
      for (var v = 1; v < arguments.length; v++) {
        var m = arguments[v];
        for (var g in m) Object.prototype.hasOwnProperty.call(m, g) && (p[g] = m[g]);
      }
      return p;
    }, l.apply(this, arguments);
  }
  function c(p, v) {
    if (p == null) return {};
    var m = f(p, v),
      g,
      b;
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(p);
      for (b = 0; b < y.length; b++) g = y[b], !(v.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(p, g) && (m[g] = p[g]);
    }
    return m;
  }
  function f(p, v) {
    if (p == null) return {};
    var m = {},
      g = Object.keys(p),
      b,
      y;
    for (y = 0; y < g.length; y++) b = g[y], !(v.indexOf(b) >= 0) && (m[b] = p[b]);
    return m;
  }
  function h(p) {
    var v = p.maxDate,
      m = p.minDate,
      g = p.month,
      b = p.year,
      y = c(p, s),
      E = function () {
        return g ? (0, r.getDaysInMonth)(new Date(b, g - 1, 1)) : 31;
      }();
    function w(D) {
      return D && b === (0, r.getYear)(D).toString() && g === (0, r.getMonthHuman)(D).toString();
    }
    var _ = (0, o.safeMin)(E, w(v) && (0, r.getDate)(v)),
      C = (0, o.safeMax)(1, w(m) && (0, r.getDate)(m));
    return /* @__PURE__ */t.default.createElement(a.default, l({
      max: _,
      min: C,
      name: "day"
    }, y));
  }
  h.propTypes = {
    ariaLabel: n.default.string,
    className: n.default.string.isRequired,
    disabled: n.default.bool,
    inputRef: i.isRef,
    maxDate: i.isMaxDate,
    minDate: i.isMinDate,
    month: n.default.string,
    onChange: n.default.func,
    onKeyDown: n.default.func,
    onKeyUp: n.default.func,
    placeholder: n.default.string,
    required: n.default.bool,
    showLeadingZeros: n.default.bool,
    value: n.default.string,
    year: n.default.string
  };
})(hb);
var yb = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var t = u(React__default["default"]),
    n = u(k),
    r = Jn,
    a = u(os),
    i = _t,
    o = fn,
    s = ["maxDate", "minDate", "year"];
  function u(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  function l() {
    return l = Object.assign || function (p) {
      for (var v = 1; v < arguments.length; v++) {
        var m = arguments[v];
        for (var g in m) Object.prototype.hasOwnProperty.call(m, g) && (p[g] = m[g]);
      }
      return p;
    }, l.apply(this, arguments);
  }
  function c(p, v) {
    if (p == null) return {};
    var m = f(p, v),
      g,
      b;
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(p);
      for (b = 0; b < y.length; b++) g = y[b], !(v.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(p, g) && (m[g] = p[g]);
    }
    return m;
  }
  function f(p, v) {
    if (p == null) return {};
    var m = {},
      g = Object.keys(p),
      b,
      y;
    for (y = 0; y < g.length; y++) b = g[y], !(v.indexOf(b) >= 0) && (m[b] = p[b]);
    return m;
  }
  function h(p) {
    var v = p.maxDate,
      m = p.minDate,
      g = p.year,
      b = c(p, s);
    function y(_) {
      return _ && g === (0, r.getYear)(_).toString();
    }
    var E = (0, o.safeMin)(12, y(v) && (0, r.getMonthHuman)(v)),
      w = (0, o.safeMax)(1, y(m) && (0, r.getMonthHuman)(m));
    return /* @__PURE__ */t.default.createElement(a.default, l({
      max: E,
      min: w,
      name: "month"
    }, b));
  }
  h.propTypes = {
    ariaLabel: n.default.string,
    className: n.default.string.isRequired,
    disabled: n.default.bool,
    inputRef: i.isRef,
    maxDate: i.isMaxDate,
    minDate: i.isMinDate,
    onChange: n.default.func,
    onKeyDown: n.default.func,
    onKeyUp: n.default.func,
    placeholder: n.default.string,
    required: n.default.bool,
    showLeadingZeros: n.default.bool,
    value: n.default.string,
    year: n.default.string
  };
})(yb);
var gb = {},
  En = {};
var $R = /* @__PURE__ */kn(wx);
Object.defineProperty(En, "__esModule", {
  value: !0
});
En.formatShortMonth = En.formatMonth = void 0;
En.getFormatter = bb;
var CR = RR($R);
function RR(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var Ys = /* @__PURE__ */new Map();
function bb(e) {
  return function (t, n) {
    var r = t || (0, CR.default)();
    Ys.has(r) || Ys.set(r, /* @__PURE__ */new Map());
    var a = Ys.get(r);
    return a.has(e) || a.set(e, new Intl.DateTimeFormat(r, e).format), a.get(e)(n);
  };
}
function NR(e) {
  var t = new Date(e);
  return new Date(t.setHours(12));
}
function _b(e) {
  return function (t, n) {
    return bb(e)(t, NR(n));
  };
}
var AR = {
    month: "long"
  },
  IR = {
    month: "short"
  },
  MR = _b(AR);
En.formatMonth = MR;
var FR = _b(IR);
En.formatShortMonth = FR;
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = E;
  var t = l(React__default["default"]),
    n = l(k),
    r = l(yf),
    a = Jn,
    i = En,
    o = _t,
    s = fn,
    u = ["ariaLabel", "className", "inputRef", "locale", "maxDate", "minDate", "placeholder", "short", "value", "year"];
  function l(w) {
    return w && w.__esModule ? w : {
      default: w
    };
  }
  function c() {
    return c = Object.assign || function (w) {
      for (var _ = 1; _ < arguments.length; _++) {
        var C = arguments[_];
        for (var D in C) Object.prototype.hasOwnProperty.call(C, D) && (w[D] = C[D]);
      }
      return w;
    }, c.apply(this, arguments);
  }
  function f(w) {
    return m(w) || v(w) || p(w) || h();
  }
  function h() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function p(w, _) {
    if (w) {
      if (typeof w == "string") return g(w, _);
      var C = Object.prototype.toString.call(w).slice(8, -1);
      if (C === "Object" && w.constructor && (C = w.constructor.name), C === "Map" || C === "Set") return Array.from(w);
      if (C === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(C)) return g(w, _);
    }
  }
  function v(w) {
    if (typeof Symbol < "u" && w[Symbol.iterator] != null || w["@@iterator"] != null) return Array.from(w);
  }
  function m(w) {
    if (Array.isArray(w)) return g(w);
  }
  function g(w, _) {
    (_ == null || _ > w.length) && (_ = w.length);
    for (var C = 0, D = new Array(_); C < _; C++) D[C] = w[C];
    return D;
  }
  function b(w, _) {
    if (w == null) return {};
    var C = y(w, _),
      D,
      U;
    if (Object.getOwnPropertySymbols) {
      var Z = Object.getOwnPropertySymbols(w);
      for (U = 0; U < Z.length; U++) D = Z[U], !(_.indexOf(D) >= 0) && Object.prototype.propertyIsEnumerable.call(w, D) && (C[D] = w[D]);
    }
    return C;
  }
  function y(w, _) {
    if (w == null) return {};
    var C = {},
      D = Object.keys(w),
      U,
      Z;
    for (Z = 0; Z < D.length; Z++) U = D[Z], !(_.indexOf(U) >= 0) && (C[U] = w[U]);
    return C;
  }
  function E(w) {
    var _ = w.ariaLabel,
      C = w.className,
      D = w.inputRef,
      U = w.locale,
      Z = w.maxDate,
      me = w.minDate,
      ye = w.placeholder,
      Y = ye === void 0 ? "--" : ye,
      K = w.short,
      ee = w.value,
      ne = w.year,
      ie = b(w, u);
    function fe(W) {
      return W && ne === (0, a.getYear)(W).toString();
    }
    var ce = (0, s.safeMin)(12, fe(Z) && (0, a.getMonthHuman)(Z)),
      H = (0, s.safeMax)(1, fe(me) && (0, a.getMonthHuman)(me)),
      O = f(Array(12)).map(function (W, G) {
        return new Date(2019, G, 1);
      }),
      I = "month",
      B = K ? i.formatShortMonth : i.formatMonth;
    return /* @__PURE__ */t.default.createElement("select", c({
      "aria-label": _,
      className: (0, r.default)("".concat(C, "__input"), "".concat(C, "__").concat(I)),
      "data-input": "true",
      "data-select": "true",
      name: I,
      ref: D,
      value: ee !== null ? ee : ""
    }, ie), !ee && /* @__PURE__ */t.default.createElement("option", {
      value: ""
    }, Y), O.map(function (W) {
      var G = (0, a.getMonthHuman)(W),
        ue = G < H || G > ce;
      return /* @__PURE__ */t.default.createElement("option", {
        key: G,
        disabled: ue,
        value: G
      }, B(U, W));
    }));
  }
  E.propTypes = {
    ariaLabel: n.default.string,
    className: n.default.string.isRequired,
    disabled: n.default.bool,
    inputRef: o.isRef,
    locale: n.default.string,
    maxDate: o.isMaxDate,
    minDate: o.isMinDate,
    onChange: n.default.func,
    onKeyDown: n.default.func,
    onKeyUp: n.default.func,
    placeholder: n.default.string,
    required: n.default.bool,
    short: n.default.bool,
    value: n.default.string,
    year: n.default.string
  };
})(gb);
var wb = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = h;
  var t = u(React__default["default"]),
    n = u(k),
    r = Jn,
    a = u(os),
    i = _t,
    o = fn,
    s = ["maxDate", "minDate", "placeholder", "valueType"];
  function u(p) {
    return p && p.__esModule ? p : {
      default: p
    };
  }
  function l() {
    return l = Object.assign || function (p) {
      for (var v = 1; v < arguments.length; v++) {
        var m = arguments[v];
        for (var g in m) Object.prototype.hasOwnProperty.call(m, g) && (p[g] = m[g]);
      }
      return p;
    }, l.apply(this, arguments);
  }
  function c(p, v) {
    if (p == null) return {};
    var m = f(p, v),
      g,
      b;
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(p);
      for (b = 0; b < y.length; b++) g = y[b], !(v.indexOf(g) >= 0) && Object.prototype.propertyIsEnumerable.call(p, g) && (m[g] = p[g]);
    }
    return m;
  }
  function f(p, v) {
    if (p == null) return {};
    var m = {},
      g = Object.keys(p),
      b,
      y;
    for (y = 0; y < g.length; y++) b = g[y], !(v.indexOf(b) >= 0) && (m[b] = p[b]);
    return m;
  }
  function h(p) {
    var v = p.maxDate,
      m = p.minDate,
      g = p.placeholder,
      b = g === void 0 ? "----" : g,
      y = p.valueType,
      E = c(p, s),
      w = (0, o.safeMin)(275760, v && (0, r.getYear)(v)),
      _ = (0, o.safeMax)(1, m && (0, r.getYear)(m)),
      C = function () {
        return y === "century" ? 10 : 1;
      }();
    return /* @__PURE__ */t.default.createElement(a.default, l({
      max: w,
      min: _,
      name: "year",
      placeholder: b,
      step: C
    }, E));
  }
  h.propTypes = {
    ariaLabel: n.default.string,
    className: n.default.string.isRequired,
    disabled: n.default.bool,
    inputRef: i.isRef,
    maxDate: i.isMaxDate,
    minDate: i.isMinDate,
    onChange: n.default.func,
    onKeyDown: n.default.func,
    onKeyUp: n.default.func,
    placeholder: n.default.string,
    required: n.default.bool,
    value: n.default.string,
    valueType: i.isValueType
  };
})(wb);
var Ob = {};
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = o;
  var t = i(React__default["default"]),
    n = i(k),
    r = Jn,
    a = _t;
  function i(s) {
    return s && s.__esModule ? s : {
      default: s
    };
  }
  function o(s) {
    var u = s.ariaLabel,
      l = s.disabled,
      c = s.maxDate,
      f = s.minDate,
      h = s.name,
      p = s.onChange,
      v = s.required,
      m = s.value,
      g = s.valueType,
      b = function () {
        switch (g) {
          case "decade":
          case "year":
            return "number";
          case "month":
            return "month";
          case "day":
            return "date";
          default:
            throw new Error("Invalid valueType.");
        }
      }(),
      y = function () {
        switch (g) {
          case "century":
          case "decade":
          case "year":
            return r.getYear;
          case "month":
            return r.getISOLocalMonth;
          case "day":
            return r.getISOLocalDate;
          default:
            throw new Error("Invalid valueType.");
        }
      }();
    function E(w) {
      w.stopPropagation();
    }
    return /* @__PURE__ */t.default.createElement("input", {
      "aria-label": u,
      disabled: l,
      max: c ? y(c) : null,
      min: f ? y(f) : null,
      name: h,
      onChange: p,
      onFocus: E,
      required: v,
      style: {
        visibility: "hidden",
        position: "absolute",
        zIndex: "-999"
      },
      type: b,
      value: m ? y(m) : ""
    });
  }
  o.propTypes = {
    ariaLabel: n.default.string,
    disabled: n.default.bool,
    maxDate: a.isMaxDate,
    minDate: a.isMinDate,
    name: n.default.string,
    onChange: n.default.func,
    required: n.default.bool,
    value: n.default.oneOfType([n.default.string, n.default.instanceOf(Date)]),
    valueType: a.isValueType
  };
})(Ob);
var ss = {};
Object.defineProperty(ss, "__esModule", {
  value: !0
});
ss.getBegin = LR;
ss.getEnd = jR;
var Kt = Jn;
function LR(e, t) {
  switch (e) {
    case "century":
      return (0, Kt.getCenturyStart)(t);
    case "decade":
      return (0, Kt.getDecadeStart)(t);
    case "year":
      return (0, Kt.getYearStart)(t);
    case "month":
      return (0, Kt.getMonthStart)(t);
    case "day":
      return (0, Kt.getDayStart)(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
function jR(e, t) {
  switch (e) {
    case "century":
      return (0, Kt.getCenturyEnd)(t);
    case "decade":
      return (0, Kt.getDecadeEnd)(t);
    case "year":
      return (0, Kt.getYearEnd)(t);
    case "month":
      return (0, Kt.getMonthEnd)(t);
    case "day":
      return (0, Kt.getDayEnd)(t);
    default:
      throw new Error("Invalid rangeType: ".concat(e));
  }
}
(function (e) {
  function t(T) {
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (R) {
      return typeof R;
    } : function (R) {
      return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
    }, t(T);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = b(React__default["default"]),
    r = m(k),
    a = Jn,
    i = m(db),
    o = m(hb),
    s = m(yb),
    u = m(gb),
    l = m(wb),
    c = m(Ob),
    f = En,
    h = ss,
    p = _t,
    v = fn;
  function m(T) {
    return T && T.__esModule ? T : {
      default: T
    };
  }
  function g(T) {
    if (typeof WeakMap != "function") return null;
    var R = /* @__PURE__ */new WeakMap(),
      z = /* @__PURE__ */new WeakMap();
    return (g = function g(ae) {
      return ae ? z : R;
    })(T);
  }
  function b(T, R) {
    if (!R && T && T.__esModule) return T;
    if (T === null || t(T) !== "object" && typeof T != "function") return {
      default: T
    };
    var z = g(R);
    if (z && z.has(T)) return z.get(T);
    var j = {},
      ae = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var ge in T) if (ge !== "default" && Object.prototype.hasOwnProperty.call(T, ge)) {
      var Pe = ae ? Object.getOwnPropertyDescriptor(T, ge) : null;
      Pe && (Pe.get || Pe.set) ? Object.defineProperty(j, ge, Pe) : j[ge] = T[ge];
    }
    return j.default = T, z && z.set(T, j), j;
  }
  function y() {
    return y = Object.assign || function (T) {
      for (var R = 1; R < arguments.length; R++) {
        var z = arguments[R];
        for (var j in z) Object.prototype.hasOwnProperty.call(z, j) && (T[j] = z[j]);
      }
      return T;
    }, y.apply(this, arguments);
  }
  function E(T, R) {
    return C(T) || _(T, R) || O(T, R) || w();
  }
  function w() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _(T, R) {
    var z = T == null ? null : typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
    if (z != null) {
      var j = [],
        ae = !0,
        ge = !1,
        Pe,
        de;
      try {
        for (z = z.call(T); !(ae = (Pe = z.next()).done) && (j.push(Pe.value), !(R && j.length === R)); ae = !0);
      } catch (Oe) {
        ge = !0, de = Oe;
      } finally {
        try {
          !ae && z.return != null && z.return();
        } finally {
          if (ge) throw de;
        }
      }
      return j;
    }
  }
  function C(T) {
    if (Array.isArray(T)) return T;
  }
  function D(T, R) {
    if (!(T instanceof R)) throw new TypeError("Cannot call a class as a function");
  }
  function U(T, R) {
    for (var z = 0; z < R.length; z++) {
      var j = R[z];
      j.enumerable = j.enumerable || !1, j.configurable = !0, "value" in j && (j.writable = !0), Object.defineProperty(T, j.key, j);
    }
  }
  function Z(T, R, z) {
    return R && U(T.prototype, R), z && U(T, z), Object.defineProperty(T, "prototype", {
      writable: !1
    }), T;
  }
  function me(T, R) {
    if (typeof R != "function" && R !== null) throw new TypeError("Super expression must either be null or a function");
    T.prototype = Object.create(R && R.prototype, {
      constructor: {
        value: T,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(T, "prototype", {
      writable: !1
    }), R && ye(T, R);
  }
  function ye(T, R) {
    return ye = Object.setPrototypeOf || function (j, ae) {
      return j.__proto__ = ae, j;
    }, ye(T, R);
  }
  function Y(T) {
    var R = ne();
    return function () {
      var j = ie(T),
        ae;
      if (R) {
        var ge = ie(this).constructor;
        ae = Reflect.construct(j, arguments, ge);
      } else ae = j.apply(this, arguments);
      return K(this, ae);
    };
  }
  function K(T, R) {
    if (R && (t(R) === "object" || typeof R == "function")) return R;
    if (R !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return ee(T);
  }
  function ee(T) {
    if (T === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return T;
  }
  function ne() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (_unused53) {
      return !1;
    }
  }
  function ie(T) {
    return ie = Object.setPrototypeOf ? Object.getPrototypeOf : function (z) {
      return z.__proto__ || Object.getPrototypeOf(z);
    }, ie(T);
  }
  function fe(T, R, z) {
    return R in T ? Object.defineProperty(T, R, {
      value: z,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : T[R] = z, T;
  }
  function ce(T) {
    return B(T) || I(T) || O(T) || H();
  }
  function H() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function O(T, R) {
    if (T) {
      if (typeof T == "string") return W(T, R);
      var z = Object.prototype.toString.call(T).slice(8, -1);
      if (z === "Object" && T.constructor && (z = T.constructor.name), z === "Map" || z === "Set") return Array.from(T);
      if (z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(z)) return W(T, R);
    }
  }
  function I(T) {
    if (typeof Symbol < "u" && T[Symbol.iterator] != null || T["@@iterator"] != null) return Array.from(T);
  }
  function B(T) {
    if (Array.isArray(T)) return W(T);
  }
  function W(T, R) {
    (R == null || R > T.length) && (R = T.length);
    for (var z = 0, j = new Array(R); z < R; z++) j[z] = T[z];
    return j;
  }
  var G = new Date();
  G.setFullYear(1, 0, 1), G.setHours(0, 0, 0, 0);
  var ue = new Date(864e13),
    se = ["century", "decade", "year", "month"],
    x = [].concat(ce(se.slice(1)), ["day"]);
  function A(T) {
    return T instanceof Date ? T : new Date(T);
  }
  function M(T, R) {
    return T && !R || !T && R || T && R && T.getTime() !== R.getTime();
  }
  function N(T) {
    return x[se.indexOf(T)];
  }
  function Q(T, R) {
    if (!T) return null;
    var z = Array.isArray(T) && T.length === 2 ? T[R] : T;
    if (!z) return null;
    var j = A(z);
    if (isNaN(j.getTime())) throw new Error("Invalid date: ".concat(T));
    return j;
  }
  function L(T, R) {
    var z = T.value,
      j = T.minDate,
      ae = T.maxDate,
      ge = T.maxDetail,
      Pe = Q(z, R);
    if (!Pe) return null;
    var de = N(ge),
      Oe = [h.getBegin, h.getEnd][R](de, Pe);
    return (0, v.between)(Oe, j, ae);
  }
  var ve = function ve(R) {
      return L(R, 0);
    },
    re = function re(R) {
      return L(R, 1);
    },
    _e = function _e(R) {
      var z = R.value;
      return Array.isArray(z) ? z : [ve, re].map(function (j) {
        return j(R);
      });
    };
  function xe(T) {
    return T.getAttribute("data-input") === "true";
  }
  function Ee(T, R) {
    var z = T;
    do z = z[R]; while (z && !xe(z));
    return z;
  }
  function tt(T) {
    T && T.focus();
  }
  function nt(T, R, z) {
    var j = [],
      ae = new RegExp(Object.keys(R).map(function (Pe) {
        return "".concat(Pe, "+");
      }).join("|"), "g"),
      ge = T.match(ae);
    return T.split(ae).reduce(function (Pe, de, Oe) {
      var S = de &&
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */
        n.default.createElement(i.default, {
          key: "separator_".concat(Oe)
        }, de),
        V = [].concat(ce(Pe), [S]),
        X = ge && ge[Oe];
      if (X) {
        var pe = R[X] || R[Object.keys(R).find(function (Te) {
          return X.match(Te);
        })];
        !z && j.includes(pe) ? V.push(X) : (V.push(pe(X, Oe)), j.push(pe));
      }
      return V;
    }, []);
  }
  var $ = /* @__PURE__ */function (T) {
    me(z, T);
    var R = Y(z);
    function z() {
      var j;
      D(this, z);
      for (var ae = arguments.length, ge = new Array(ae), Pe = 0; Pe < ae; Pe++) ge[Pe] = arguments[Pe];
      return j = R.call.apply(R, [this].concat(ge)), fe(ee(j), "state", {
        year: null,
        month: null,
        day: null
      }), fe(ee(j), "dayInput", /* @__PURE__ */(0, n.createRef)()), fe(ee(j), "monthInput", /* @__PURE__ */(0, n.createRef)()), fe(ee(j), "yearInput", /* @__PURE__ */(0, n.createRef)()), fe(ee(j), "onClick", function (de) {
        if (de.target === de.currentTarget) {
          var Oe = de.target.children[1];
          tt(Oe);
        }
      }), fe(ee(j), "onKeyDown", function (de) {
        switch (de.key) {
          case "ArrowLeft":
          case "ArrowRight":
          case j.divider:
            {
              de.preventDefault();
              var Oe = de.target,
                S = de.key === "ArrowLeft" ? "previousElementSibling" : "nextElementSibling",
                V = Ee(Oe, S);
              tt(V);
              break;
            }
        }
      }), fe(ee(j), "onKeyUp", function (de) {
        var Oe = de.key,
          S = de.target,
          V = !isNaN(parseInt(Oe, 10));
        if (V) {
          var X = S.value,
            pe = S.getAttribute("max");
          if (X * 10 > pe || X.length >= pe.length) {
            var Te = "nextElementSibling",
              ke = Ee(S, Te);
            tt(ke);
          }
        }
      }), fe(ee(j), "onChange", function (de) {
        var Oe = de.target,
          S = Oe.name,
          V = Oe.value;
        j.setState(fe({}, S, V), j.onChangeExternal);
      }), fe(ee(j), "onChangeNative", function (de) {
        var Oe = j.props.onChange,
          S = de.target.value;
        if (Oe) {
          var V = function () {
            if (!S) return null;
            var X = S.split("-"),
              pe = E(X, 3),
              Te = pe[0],
              ke = pe[1],
              be = pe[2],
              Se = parseInt(Te, 10),
              Ue = parseInt(ke, 10) - 1 || 0,
              ht = parseInt(be, 10) || 1,
              Ot = new Date();
            return Ot.setFullYear(Se, Ue, ht), Ot.setHours(0, 0, 0, 0), Ot;
          }();
          Oe(V, !1);
        }
      }), fe(ee(j), "onChangeExternal", function () {
        var de = j.props.onChange;
        if (de) {
          var Oe = [j.dayInput.current, j.monthInput.current, j.yearInput.current].filter(Boolean),
            S = {};
          if (Oe.forEach(function (be) {
            S[be.name] = be.value;
          }), Oe.every(function (be) {
            return !be.value;
          })) de(null, !1);else if (Oe.every(function (be) {
            return be.value && be.validity.valid;
          })) {
            var V = parseInt(S.year, 10) || new Date().getFullYear(),
              X = parseInt(S.month || 1, 10) - 1,
              pe = parseInt(S.day || 1, 10),
              Te = new Date();
            Te.setFullYear(V, X, pe), Te.setHours(0, 0, 0, 0);
            var ke = j.getProcessedValue(Te);
            de(ke, !1);
          }
        }
      }), fe(ee(j), "renderDay", function (de, Oe) {
        var S = j.props,
          V = S.autoFocus,
          X = S.dayAriaLabel,
          pe = S.dayPlaceholder,
          Te = S.showLeadingZeros,
          ke = j.state,
          be = ke.day,
          Se = ke.month,
          Ue = ke.year;
        if (de && de.length > 2) throw new Error("Unsupported token: ".concat(de));
        var ht = de && de.length === 2;
        return /* @__PURE__ */n.default.createElement(o.default, y({
          key: "day"
        }, j.commonInputProps, {
          ariaLabel: X,
          autoFocus: Oe === 0 && V,
          inputRef: j.dayInput,
          month: Se,
          placeholder: pe,
          showLeadingZeros: ht || Te,
          value: be,
          year: Ue
        }));
      }), fe(ee(j), "renderMonth", function (de, Oe) {
        var S = j.props,
          V = S.autoFocus,
          X = S.locale,
          pe = S.monthAriaLabel,
          Te = S.monthPlaceholder,
          ke = S.showLeadingZeros,
          be = j.state,
          Se = be.month,
          Ue = be.year;
        if (de && de.length > 4) throw new Error("Unsupported token: ".concat(de));
        if (de.length > 2) return /* @__PURE__ */n.default.createElement(u.default, y({
          key: "month"
        }, j.commonInputProps, {
          ariaLabel: pe,
          autoFocus: Oe === 0 && V,
          inputRef: j.monthInput,
          locale: X,
          placeholder: Te,
          short: de.length === 3,
          value: Se,
          year: Ue
        }));
        var ht = de && de.length === 2;
        return /* @__PURE__ */n.default.createElement(s.default, y({
          key: "month"
        }, j.commonInputProps, {
          ariaLabel: pe,
          autoFocus: Oe === 0 && V,
          inputRef: j.monthInput,
          placeholder: Te,
          showLeadingZeros: ht || ke,
          value: Se,
          year: Ue
        }));
      }), fe(ee(j), "renderYear", function (de, Oe) {
        var S = j.props,
          V = S.autoFocus,
          X = S.yearAriaLabel,
          pe = S.yearPlaceholder,
          Te = j.state.year;
        return /* @__PURE__ */n.default.createElement(l.default, y({
          key: "year"
        }, j.commonInputProps, {
          ariaLabel: X,
          autoFocus: Oe === 0 && V,
          inputRef: j.yearInput,
          placeholder: pe,
          value: Te,
          valueType: j.valueType
        }));
      }), j;
    }
    return Z(z, [{
      key: "formatDate",
      get: function get() {
        var ae = this.props.maxDetail,
          ge = {
            year: "numeric"
          },
          Pe = se.indexOf(ae);
        return Pe >= 2 && (ge.month = "numeric"), Pe >= 3 && (ge.day = "numeric"), (0, f.getFormatter)(ge);
      }
      /**
       * Gets current value in a desired format.
       */
    }, {
      key: "getProcessedValue",
      value: function value(ae) {
        var ge = this.props,
          Pe = ge.minDate,
          de = ge.maxDate,
          Oe = ge.maxDetail,
          S = ge.returnValue,
          V = function () {
            switch (S) {
              case "start":
                return ve;
              case "end":
                return re;
              case "range":
                return _e;
              default:
                throw new Error("Invalid returnValue.");
            }
          }();
        return V({
          value: ae,
          minDate: Pe,
          maxDate: de,
          maxDetail: Oe
        });
      }
    }, {
      key: "divider",
      get: function get() {
        var ae = this.placeholder.match(/[^0-9a-z]/i);
        return ae ? ae[0] : null;
      }
    }, {
      key: "placeholder",
      get: function get() {
        var ae = this.props,
          ge = ae.format,
          Pe = ae.locale;
        if (ge) return ge;
        var de = 2017,
          Oe = 11,
          S = 11,
          V = new Date(de, Oe, S),
          X = this.formatDate(Pe, V),
          pe = ["year", "month", "day"],
          Te = ["y", "M", "d"];
        function ke(Se, Ue) {
          return (0, f.getFormatter)(fe({
            useGrouping: !1
          }, Se, "numeric"))(Pe, Ue).match(/\d{1,}/);
        }
        var be = X;
        return pe.forEach(function (Se, Ue) {
          var ht = ke(Se, V),
            Ot = Te[Ue];
          be = be.replace(ht, Ot);
        }), be = be.replace("17", "y"), be;
      }
    }, {
      key: "commonInputProps",
      get: function get() {
        var ae = this.props,
          ge = ae.className,
          Pe = ae.disabled,
          de = ae.isCalendarOpen,
          Oe = ae.maxDate,
          S = ae.minDate,
          V = ae.required;
        return {
          className: ge,
          disabled: Pe,
          maxDate: Oe || ue,
          minDate: S || G,
          onChange: this.onChange,
          onKeyDown: this.onKeyDown,
          onKeyUp: this.onKeyUp,
          // This is only for showing validity when editing
          required: V || de
        };
      }
    }, {
      key: "valueType",
      get: function get() {
        var ae = this.props.maxDetail;
        return N(ae);
      }
    }, {
      key: "renderCustomInputs",
      value: function value() {
        var ae = this.placeholder,
          ge = this.props.format,
          Pe = {
            d: this.renderDay,
            M: this.renderMonth,
            y: this.renderYear
          },
          de = typeof ge < "u";
        return nt(ae, Pe, de);
      }
    }, {
      key: "renderNativeInput",
      value: function value() {
        var ae = this.props,
          ge = ae.disabled,
          Pe = ae.maxDate,
          de = ae.minDate,
          Oe = ae.name,
          S = ae.nativeInputAriaLabel,
          V = ae.required,
          X = this.state.value;
        return /* @__PURE__ */n.default.createElement(c.default, {
          key: "date",
          ariaLabel: S,
          disabled: ge,
          maxDate: Pe || ue,
          minDate: de || G,
          name: Oe,
          onChange: this.onChangeNative,
          required: V,
          value: X,
          valueType: this.valueType
        });
      }
    }, {
      key: "render",
      value: function value() {
        var ae = this.props.className;
        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          /* @__PURE__ */
          n.default.createElement("div", {
            className: ae,
            onClick: this.onClick
          }, this.renderNativeInput(), this.renderCustomInputs())
        );
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function value(ae, ge) {
        var Pe = ae.minDate,
          de = ae.maxDate,
          Oe = ae.maxDetail,
          S = {};
        ae.isCalendarOpen !== ge.isCalendarOpen && (S.isCalendarOpen = ae.isCalendarOpen);
        var V = ve({
            value: ae.value,
            minDate: Pe,
            maxDate: de,
            maxDetail: Oe
          }),
          X = [V, ge.value];
        return (
          // Toggling calendar visibility resets values
          (S.isCalendarOpen ||
          // Flag was toggled
          M.apply(void 0, ce(X.map(function (pe) {
            return ve({
              value: pe,
              minDate: Pe,
              maxDate: de,
              maxDetail: Oe
            });
          }))) || M.apply(void 0, ce(X.map(function (pe) {
            return re({
              value: pe,
              minDate: Pe,
              maxDate: de,
              maxDetail: Oe
            });
          })))) && (V ? (S.year = (0, a.getYear)(V).toString(), S.month = (0, a.getMonthHuman)(V).toString(), S.day = (0, a.getDate)(V).toString()) : (S.year = null, S.month = null, S.day = null), S.value = V), S
        );
      }
    }]), z;
  }(n.PureComponent);
  e.default = $, $.defaultProps = {
    maxDetail: "month",
    name: "date",
    returnValue: "start"
  };
  var oe = r.default.oneOfType([r.default.string, r.default.instanceOf(Date)]);
  $.propTypes = {
    autoFocus: r.default.bool,
    className: r.default.string.isRequired,
    dayAriaLabel: r.default.string,
    dayPlaceholder: r.default.string,
    disabled: r.default.bool,
    format: r.default.string,
    isCalendarOpen: r.default.bool,
    locale: r.default.string,
    maxDate: p.isMaxDate,
    maxDetail: r.default.oneOf(se),
    minDate: p.isMinDate,
    monthAriaLabel: r.default.string,
    monthPlaceholder: r.default.string,
    name: r.default.string,
    nativeInputAriaLabel: r.default.string,
    onChange: r.default.func,
    required: r.default.bool,
    returnValue: r.default.oneOf(["start", "end", "range"]),
    showLeadingZeros: r.default.bool,
    value: r.default.oneOfType([oe, r.default.arrayOf(oe)]),
    yearAriaLabel: r.default.string,
    yearPlaceholder: r.default.string
  };
})(fb);
(function (e) {
  function t(x) {
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (A) {
      return typeof A;
    } : function (A) {
      return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
    }, t(x);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = v(React__default["default"]),
    r = h(k),
    a = h(RD),
    i = h(yf),
    o = h(qC),
    s = h(aR),
    u = h(fb),
    l = _t,
    c = ["calendarClassName", "className", "onChange", "value"],
    f = ["onChange"];
  function h(x) {
    return x && x.__esModule ? x : {
      default: x
    };
  }
  function p(x) {
    if (typeof WeakMap != "function") return null;
    var A = /* @__PURE__ */new WeakMap(),
      M = /* @__PURE__ */new WeakMap();
    return (p = function p(Q) {
      return Q ? M : A;
    })(x);
  }
  function v(x, A) {
    if (!A && x && x.__esModule) return x;
    if (x === null || t(x) !== "object" && typeof x != "function") return {
      default: x
    };
    var M = p(A);
    if (M && M.has(x)) return M.get(x);
    var N = {},
      Q = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var L in x) if (L !== "default" && Object.prototype.hasOwnProperty.call(x, L)) {
      var ve = Q ? Object.getOwnPropertyDescriptor(x, L) : null;
      ve && (ve.get || ve.set) ? Object.defineProperty(N, L, ve) : N[L] = x[L];
    }
    return N.default = x, M && M.set(x, N), N;
  }
  function m(x, A) {
    if (x == null) return {};
    var M = g(x, A),
      N,
      Q;
    if (Object.getOwnPropertySymbols) {
      var L = Object.getOwnPropertySymbols(x);
      for (Q = 0; Q < L.length; Q++) N = L[Q], !(A.indexOf(N) >= 0) && Object.prototype.propertyIsEnumerable.call(x, N) && (M[N] = x[N]);
    }
    return M;
  }
  function g(x, A) {
    if (x == null) return {};
    var M = {},
      N = Object.keys(x),
      Q,
      L;
    for (L = 0; L < N.length; L++) Q = N[L], !(A.indexOf(Q) >= 0) && (M[Q] = x[Q]);
    return M;
  }
  function b() {
    return b = Object.assign || function (x) {
      for (var A = 1; A < arguments.length; A++) {
        var M = arguments[A];
        for (var N in M) Object.prototype.hasOwnProperty.call(M, N) && (x[N] = M[N]);
      }
      return x;
    }, b.apply(this, arguments);
  }
  function y(x, A) {
    return D(x) || C(x, A) || w(x, A) || E();
  }
  function E() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function w(x, A) {
    if (x) {
      if (typeof x == "string") return _(x, A);
      var M = Object.prototype.toString.call(x).slice(8, -1);
      if (M === "Object" && x.constructor && (M = x.constructor.name), M === "Map" || M === "Set") return Array.from(x);
      if (M === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(M)) return _(x, A);
    }
  }
  function _(x, A) {
    (A == null || A > x.length) && (A = x.length);
    for (var M = 0, N = new Array(A); M < A; M++) N[M] = x[M];
    return N;
  }
  function C(x, A) {
    var M = x == null ? null : typeof Symbol < "u" && x[Symbol.iterator] || x["@@iterator"];
    if (M != null) {
      var N = [],
        Q = !0,
        L = !1,
        ve,
        re;
      try {
        for (M = M.call(x); !(Q = (ve = M.next()).done) && (N.push(ve.value), !(A && N.length === A)); Q = !0);
      } catch (_e) {
        L = !0, re = _e;
      } finally {
        try {
          !Q && M.return != null && M.return();
        } finally {
          if (L) throw re;
        }
      }
      return N;
    }
  }
  function D(x) {
    if (Array.isArray(x)) return x;
  }
  function U(x, A) {
    if (!(x instanceof A)) throw new TypeError("Cannot call a class as a function");
  }
  function Z(x, A) {
    for (var M = 0; M < A.length; M++) {
      var N = A[M];
      N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(x, N.key, N);
    }
  }
  function me(x, A, M) {
    return A && Z(x.prototype, A), M && Z(x, M), Object.defineProperty(x, "prototype", {
      writable: !1
    }), x;
  }
  function ye(x, A) {
    if (typeof A != "function" && A !== null) throw new TypeError("Super expression must either be null or a function");
    x.prototype = Object.create(A && A.prototype, {
      constructor: {
        value: x,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(x, "prototype", {
      writable: !1
    }), A && Y(x, A);
  }
  function Y(x, A) {
    return Y = Object.setPrototypeOf || function (N, Q) {
      return N.__proto__ = Q, N;
    }, Y(x, A);
  }
  function K(x) {
    var A = ie();
    return function () {
      var N = fe(x),
        Q;
      if (A) {
        var L = fe(this).constructor;
        Q = Reflect.construct(N, arguments, L);
      } else Q = N.apply(this, arguments);
      return ee(this, Q);
    };
  }
  function ee(x, A) {
    if (A && (t(A) === "object" || typeof A == "function")) return A;
    if (A !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return ne(x);
  }
  function ne(x) {
    if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return x;
  }
  function ie() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (_unused54) {
      return !1;
    }
  }
  function fe(x) {
    return fe = Object.setPrototypeOf ? Object.getPrototypeOf : function (M) {
      return M.__proto__ || Object.getPrototypeOf(M);
    }, fe(x);
  }
  function ce(x, A, M) {
    return A in x ? Object.defineProperty(x, A, {
      value: M,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : x[A] = M, x;
  }
  var H = "react-date-picker",
    O = ["mousedown", "focusin", "touchstart"],
    I = ["century", "decade", "year", "month"],
    B = /* @__PURE__ */function (x) {
      ye(M, x);
      var A = K(M);
      function M() {
        var N;
        U(this, M);
        for (var Q = arguments.length, L = new Array(Q), ve = 0; ve < Q; ve++) L[ve] = arguments[ve];
        return N = A.call.apply(A, [this].concat(L)), ce(ne(N), "state", {}), ce(ne(N), "onOutsideAction", function (re) {
          var _e = "composedPath" in re ? re.composedPath()[0] : re.target;
          N.wrapper && !N.wrapper.contains(_e) && N.closeCalendar();
        }), ce(ne(N), "onChange", function (re) {
          var _e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : N.props.closeCalendar,
            xe = N.props.onChange;
          _e && N.closeCalendar(), xe && xe(re);
        }), ce(ne(N), "onFocus", function (re) {
          var _e = N.props,
            xe = _e.disabled,
            Ee = _e.onFocus,
            tt = _e.openCalendarOnFocus;
          if (Ee && Ee(re), !xe && tt) {
            if (re.target.getAttribute("data-select") === "true") return;
            N.openCalendar();
          }
        }), ce(ne(N), "onKeyDown", function (re) {
          re.key === "Escape" && N.closeCalendar();
        }), ce(ne(N), "openCalendar", function () {
          N.setState({
            isOpen: !0
          });
        }), ce(ne(N), "closeCalendar", function () {
          N.setState(function (re) {
            return re.isOpen ? {
              isOpen: !1
            } : null;
          });
        }), ce(ne(N), "toggleCalendar", function () {
          N.setState(function (re) {
            return {
              isOpen: !re.isOpen
            };
          });
        }), ce(ne(N), "stopPropagation", function (re) {
          return re.stopPropagation();
        }), ce(ne(N), "clear", function () {
          return N.onChange(null);
        }), N;
      }
      return me(M, [{
        key: "componentDidMount",
        value: function value() {
          this.handleOutsideActionListeners();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(Q, L) {
          var ve = this.state.isOpen,
            re = this.props,
            _e = re.onCalendarClose,
            xe = re.onCalendarOpen;
          if (ve !== L.isOpen) {
            this.handleOutsideActionListeners();
            var Ee = ve ? xe : _e;
            Ee && Ee();
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.handleOutsideActionListeners(!1);
        }
      }, {
        key: "eventProps",
        get: function get() {
          return (0, a.default)(this.props);
        }
      }, {
        key: "handleOutsideActionListeners",
        value: function value(Q) {
          var L = this,
            ve = this.state.isOpen,
            re = typeof Q < "u" ? Q : ve,
            _e = re ? "addEventListener" : "removeEventListener";
          O.forEach(function (xe) {
            return document[_e](xe, L.onOutsideAction);
          }), document[_e]("keydown", this.onKeyDown);
        }
      }, {
        key: "renderInputs",
        value: function value() {
          var Q = this.props,
            L = Q.autoFocus,
            ve = Q.calendarAriaLabel,
            re = Q.calendarIcon,
            _e = Q.clearAriaLabel,
            xe = Q.clearIcon,
            Ee = Q.dayAriaLabel,
            tt = Q.dayPlaceholder,
            nt = Q.disableCalendar,
            $ = Q.disabled,
            oe = Q.format,
            T = Q.locale,
            R = Q.maxDate,
            z = Q.maxDetail,
            j = Q.minDate,
            ae = Q.monthAriaLabel,
            ge = Q.monthPlaceholder,
            Pe = Q.name,
            de = Q.nativeInputAriaLabel,
            Oe = Q.required,
            S = Q.returnValue,
            V = Q.showLeadingZeros,
            X = Q.value,
            pe = Q.yearAriaLabel,
            Te = Q.yearPlaceholder,
            ke = this.state.isOpen,
            be = [].concat(X),
            Se = y(be, 1),
            Ue = Se[0],
            ht = {
              dayAriaLabel: Ee,
              monthAriaLabel: ae,
              nativeInputAriaLabel: de,
              yearAriaLabel: pe
            },
            Ot = {
              dayPlaceholder: tt,
              monthPlaceholder: ge,
              yearPlaceholder: Te
            };
          return /* @__PURE__ */n.default.createElement("div", {
            className: "".concat(H, "__wrapper")
          }, /* @__PURE__ */n.default.createElement(u.default, b({}, ht, Ot, {
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: L,
            className: "".concat(H, "__inputGroup"),
            disabled: $,
            format: oe,
            isCalendarOpen: ke,
            locale: T,
            maxDate: R,
            maxDetail: z,
            minDate: j,
            name: Pe,
            onChange: this.onChange,
            required: Oe,
            returnValue: S,
            showLeadingZeros: V,
            value: Ue
          })), xe !== null && /* @__PURE__ */n.default.createElement("button", {
            "aria-label": _e,
            className: "".concat(H, "__clear-button ").concat(H, "__button"),
            disabled: $,
            onClick: this.clear,
            onFocus: this.stopPropagation,
            type: "button"
          }, xe), re !== null && !nt && /* @__PURE__ */n.default.createElement("button", {
            "aria-label": ve,
            className: "".concat(H, "__calendar-button ").concat(H, "__button"),
            disabled: $,
            onBlur: this.resetValue,
            onClick: this.toggleCalendar,
            onFocus: this.stopPropagation,
            type: "button"
          }, re));
        }
      }, {
        key: "renderCalendar",
        value: function value() {
          var Q = this.props.disableCalendar,
            L = this.state.isOpen;
          if (L === null || Q) return null;
          var ve = this.props,
            re = ve.calendarClassName;
          ve.className, ve.onChange;
          var _e = ve.value,
            xe = m(ve, c),
            Ee = "".concat(H, "__calendar");
          return /* @__PURE__ */n.default.createElement(s.default, null, /* @__PURE__ */n.default.createElement("div", {
            ref: function ref(nt) {
              nt && !L && nt.removeAttribute("style");
            },
            className: (0, i.default)(Ee, "".concat(Ee, "--").concat(L ? "open" : "closed")),
            style: L ? void 0 : {}
          }, /* @__PURE__ */n.default.createElement(o.default, b({
            className: re,
            onChange: this.onChange,
            value: _e || null
          }, xe))));
        }
      }, {
        key: "render",
        value: function value() {
          var Q = this,
            L = this.eventProps,
            ve = this.props,
            re = ve.className,
            _e = ve.disabled,
            xe = this.state.isOpen;
          L.onChange;
          var Ee = m(L, f);
          return /* @__PURE__ */n.default.createElement("div", b({
            className: (0, i.default)(H, "".concat(H, "--").concat(xe ? "open" : "closed"), "".concat(H, "--").concat(_e ? "disabled" : "enabled"), re)
          }, Ee, {
            onFocus: this.onFocus,
            ref: function ref(nt) {
              nt && (Q.wrapper = nt);
            }
          }), this.renderInputs(), this.renderCalendar());
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function value(Q, L) {
          return Q.isOpen !== L.isOpenProps ? {
            isOpen: Q.isOpen,
            isOpenProps: Q.isOpen
          } : null;
        }
      }]), M;
    }(n.PureComponent);
  e.default = B;
  var W = {
      xmlns: "http://www.w3.org/2000/svg",
      width: 19,
      height: 19,
      viewBox: "0 0 19 19",
      stroke: "black",
      strokeWidth: 2
    },
    G = /* @__PURE__ */n.default.createElement("svg", b({}, W, {
      className: "".concat(H, "__calendar-button__icon ").concat(H, "__button__icon")
    }), /* @__PURE__ */n.default.createElement("rect", {
      fill: "none",
      height: "15",
      width: "15",
      x: "2",
      y: "2"
    }), /* @__PURE__ */n.default.createElement("line", {
      x1: "6",
      x2: "6",
      y1: "0",
      y2: "4"
    }), /* @__PURE__ */n.default.createElement("line", {
      x1: "13",
      x2: "13",
      y1: "0",
      y2: "4"
    })),
    ue = /* @__PURE__ */n.default.createElement("svg", b({}, W, {
      className: "".concat(H, "__clear-button__icon ").concat(H, "__button__icon")
    }), /* @__PURE__ */n.default.createElement("line", {
      x1: "4",
      x2: "15",
      y1: "4",
      y2: "15"
    }), /* @__PURE__ */n.default.createElement("line", {
      x1: "15",
      x2: "4",
      y1: "4",
      y2: "15"
    }));
  B.defaultProps = {
    calendarIcon: G,
    clearIcon: ue,
    closeCalendar: !0,
    isOpen: null,
    openCalendarOnFocus: !0,
    returnValue: "start"
  };
  var se = r.default.oneOfType([r.default.string, r.default.instanceOf(Date)]);
  B.propTypes = {
    autoFocus: r.default.bool,
    calendarAriaLabel: r.default.string,
    calendarClassName: r.default.oneOfType([r.default.string, r.default.arrayOf(r.default.string)]),
    calendarIcon: r.default.node,
    className: r.default.oneOfType([r.default.string, r.default.arrayOf(r.default.string)]),
    clearAriaLabel: r.default.string,
    clearIcon: r.default.node,
    closeCalendar: r.default.bool,
    dayAriaLabel: r.default.string,
    dayPlaceholder: r.default.string,
    disableCalendar: r.default.bool,
    disabled: r.default.bool,
    format: r.default.string,
    isOpen: r.default.bool,
    locale: r.default.string,
    maxDate: l.isMaxDate,
    maxDetail: r.default.oneOf(I),
    minDate: l.isMinDate,
    monthAriaLabel: r.default.string,
    monthPlaceholder: r.default.string,
    name: r.default.string,
    nativeInputAriaLabel: r.default.string,
    onCalendarClose: r.default.func,
    onCalendarOpen: r.default.func,
    onChange: r.default.func,
    onFocus: r.default.func,
    openCalendarOnFocus: r.default.bool,
    required: r.default.bool,
    returnValue: r.default.oneOf(["start", "end", "range"]),
    showLeadingZeros: r.default.bool,
    value: r.default.oneOfType([se, r.default.arrayOf(se)]),
    yearAriaLabel: r.default.string,
    yearPlaceholder: r.default.string
  };
})(Qy);
(function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = n(Qy);
  function n(a) {
    return a && a.__esModule ? a : {
      default: a
    };
  }
  var r = t.default;
  e.default = r;
})(Yy);
var Sb = /* @__PURE__ */Pv(Yy);
function BR(_ref40) {
  var e = _ref40.value,
    t = _ref40.onChange,
    n = _ref40.field;
  var r;
  return e === "" || !e ? r = null : r = new Date(e), /* @__PURE__ */d(Sb, {
    onChange: function onChange(a) {
      a ? t(n.id, la(a, "yyyy-MM-dd")) : t(n.id, "");
    },
    value: r,
    format: "dd-MM-y"
  });
}
function VR(_ref41) {
  var e = _ref41.PortalSite,
    t = _ref41.field,
    n = _ref41.value,
    r = _ref41.onChange;
  var a = function a(i) {
    r(t.id, i.currentTarget.value);
  };
  return /* @__PURE__ */d("input", {
    value: n,
    type: "number",
    min: "0",
    max: t.id === "persons_min" ? e.max_persons : e[t.id],
    onBlur: a
  });
}
function qR(_ref42) {
  var e = _ref42.PortalSite,
    t = _ref42.field,
    n = _ref42.filters,
    r = _ref42.value,
    a = _ref42.onFilterChange;
  var i = [];
  ["countries", "cities", "regions"].includes(t.id) ? i = e[t.id] : t.id === "persons_min" || t.id === "persons_max" ? i = Ba(e.max_persons) : t.id === "bedrooms_min" ? i = Ba(e.max_bedrooms) : t.id === "bathrooms_min" ? i = Ba(e.max_bathrooms) : t.id === "weekprice_max" ? i = MS(e.max_weekprice) : i = Ba(e[t.id]);
  var o = {
    options: i,
    field: t,
    filters: n,
    value: r
  };
  return t.id === "properties" ? /* @__PURE__ */d(jS, {
    PortalSite: e,
    filters: n,
    onChange: a
  }) : t.type === "select" ? /* @__PURE__ */d(LS, _objectSpread2(_objectSpread2({}, o), {}, {
    onChange: a
  })) : t.type === "list" ? /* @__PURE__ */d(IS, _objectSpread2(_objectSpread2({}, o), {}, {
    onChange: a
  })) : t.type === "radio" ? /* @__PURE__ */d(BS, _objectSpread2(_objectSpread2({}, o), {}, {
    onChange: a
  })) : t.type === "number" ? /* @__PURE__ */d(VR, {
    PortalSite: e,
    field: t,
    value: r,
    onChange: a
  }) : t.type === "date" ? /* @__PURE__ */d(BR, {
    field: t,
    value: r,
    onChange: a
  }) : /* @__PURE__ */d("input", {
    value: r,
    onBlur: function onBlur(s) {
      a(t.id, s.target.value);
    }
  });
}
var Eb = function Eb() {
  return /* @__PURE__ */d("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    height: "16px",
    children: /* @__PURE__ */d("path", {
      fill: "#000000",
      stroke: "2",
      d: "M77,53.752c0,0.012,0,0.022,0,0.034c0,14.92-12.019,27.058-26.938,27.058  c-14.92,0-26.948-12.138-26.948-27.058C23.114,38.961,35,26.889,50,26.738v4.942c0,2.84,2.54,2.913,3.947,1.647l10.354-7.714  c0,0,1.128-0.942,1.128-1.979c0-1.089-1.147-1.979-1.147-1.979L53.95,13.941C52.543,12.675,50,12.749,50,15.588v5.149  c-18,0.151-32.826,14.915-32.826,33.048c0,18.229,14.686,33.058,32.914,33.058C68.314,86.844,83,72.015,83,53.786  c0-0.012,0-0.022,0-0.034c0,0,0-3.375-3.037-3.375C77.109,50.376,77,53.752,77,53.752z"
    })
  });
};
var Pb = ca,
  UR = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  },
  zR = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  Tb = {};
Tb[Pb.ForwardRef] = UR;
Tb[Pb.Memo] = zR;
function kb(e, t, n) {
  if (n === void 0 && (n = Error), !e) throw new n(t);
}
var $e;
(function (e) {
  e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
})($e || ($e = {}));
var Ge;
(function (e) {
  e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
})(Ge || (Ge = {}));
var Pr;
(function (e) {
  e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
})(Pr || (Pr = {}));
function Tm(e) {
  return e.type === Ge.literal;
}
function HR(e) {
  return e.type === Ge.argument;
}
function Db(e) {
  return e.type === Ge.number;
}
function xb(e) {
  return e.type === Ge.date;
}
function $b(e) {
  return e.type === Ge.time;
}
function Cb(e) {
  return e.type === Ge.select;
}
function Rb(e) {
  return e.type === Ge.plural;
}
function WR(e) {
  return e.type === Ge.pound;
}
function Nb(e) {
  return e.type === Ge.tag;
}
function Ab(e) {
  return !!(e && typeof e == "object" && e.type === Pr.number);
}
function dc(e) {
  return !!(e && typeof e == "object" && e.type === Pr.dateTime);
}
var Ib = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
  GR = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function YR(e) {
  var t = {};
  return e.replace(GR, function (n) {
    var r = n.length;
    switch (n[0]) {
      case "G":
        t.era = r === 4 ? "long" : r === 5 ? "narrow" : "short";
        break;
      case "y":
        t.year = r === 2 ? "2-digit" : "numeric";
        break;
      case "Y":
      case "u":
      case "U":
      case "r":
        throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
      case "q":
      case "Q":
        throw new RangeError("`q/Q` (quarter) patterns are not supported");
      case "M":
      case "L":
        t.month = ["numeric", "2-digit", "short", "long", "narrow"][r - 1];
        break;
      case "w":
      case "W":
        throw new RangeError("`w/W` (week) patterns are not supported");
      case "d":
        t.day = ["numeric", "2-digit"][r - 1];
        break;
      case "D":
      case "F":
      case "g":
        throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
      case "E":
        t.weekday = r === 4 ? "short" : r === 5 ? "narrow" : "short";
        break;
      case "e":
        if (r < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "c":
        if (r < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
        t.weekday = ["short", "long", "narrow", "short"][r - 4];
        break;
      case "a":
        t.hour12 = !0;
        break;
      case "b":
      case "B":
        throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
      case "h":
        t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "H":
        t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "K":
        t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "k":
        t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][r - 1];
        break;
      case "j":
      case "J":
      case "C":
        throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
      case "m":
        t.minute = ["numeric", "2-digit"][r - 1];
        break;
      case "s":
        t.second = ["numeric", "2-digit"][r - 1];
        break;
      case "S":
      case "A":
        throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
      case "z":
        t.timeZoneName = r < 4 ? "short" : "long";
        break;
      case "Z":
      case "O":
      case "v":
      case "V":
      case "X":
      case "x":
        throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
    }
    return "";
  }), t;
}
var QR = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
function KR(e) {
  if (e.length === 0) throw new Error("Number skeleton cannot be empty");
  for (var t = e.split(QR).filter(function (h) {
      return h.length > 0;
    }), n = [], r = 0, a = t; r < a.length; r++) {
    var i = a[r],
      o = i.split("/");
    if (o.length === 0) throw new Error("Invalid number skeleton");
    for (var s = o[0], u = o.slice(1), l = 0, c = u; l < c.length; l++) {
      var f = c[l];
      if (f.length === 0) throw new Error("Invalid number skeleton");
    }
    n.push({
      stem: s,
      options: u
    });
  }
  return n;
}
function JR(e) {
  return e.replace(/^(.*?)-/, "");
}
var km = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g,
  Mb = /^(@+)?(\+|#+)?[rs]?$/g,
  XR = /(\*)(0+)|(#+)(0+)|(0+)/g,
  Fb = /^(0+)$/;
function Dm(e) {
  var t = {};
  return e[e.length - 1] === "r" ? t.roundingPriority = "morePrecision" : e[e.length - 1] === "s" && (t.roundingPriority = "lessPrecision"), e.replace(Mb, function (n, r, a) {
    return typeof a != "string" ? (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length) : a === "+" ? t.minimumSignificantDigits = r.length : r[0] === "#" ? t.maximumSignificantDigits = r.length : (t.minimumSignificantDigits = r.length, t.maximumSignificantDigits = r.length + (typeof a == "string" ? a.length : 0)), "";
  }), t;
}
function Lb(e) {
  switch (e) {
    case "sign-auto":
      return {
        signDisplay: "auto"
      };
    case "sign-accounting":
    case "()":
      return {
        currencySign: "accounting"
      };
    case "sign-always":
    case "+!":
      return {
        signDisplay: "always"
      };
    case "sign-accounting-always":
    case "()!":
      return {
        signDisplay: "always",
        currencySign: "accounting"
      };
    case "sign-except-zero":
    case "+?":
      return {
        signDisplay: "exceptZero"
      };
    case "sign-accounting-except-zero":
    case "()?":
      return {
        signDisplay: "exceptZero",
        currencySign: "accounting"
      };
    case "sign-never":
    case "+_":
      return {
        signDisplay: "never"
      };
  }
}
function ZR(e) {
  var t;
  if (e[0] === "E" && e[1] === "E" ? (t = {
    notation: "engineering"
  }, e = e.slice(2)) : e[0] === "E" && (t = {
    notation: "scientific"
  }, e = e.slice(1)), t) {
    var n = e.slice(0, 2);
    if (n === "+!" ? (t.signDisplay = "always", e = e.slice(2)) : n === "+?" && (t.signDisplay = "exceptZero", e = e.slice(2)), !Fb.test(e)) throw new Error("Malformed concise eng/scientific notation");
    t.minimumIntegerDigits = e.length;
  }
  return t;
}
function xm(e) {
  var t = {},
    n = Lb(e);
  return n || t;
}
function e1(e) {
  for (var t = {}, n = 0, r = e; n < r.length; n++) {
    var a = r[n];
    switch (a.stem) {
      case "percent":
      case "%":
        t.style = "percent";
        continue;
      case "%x100":
        t.style = "percent", t.scale = 100;
        continue;
      case "currency":
        t.style = "currency", t.currency = a.options[0];
        continue;
      case "group-off":
      case ",_":
        t.useGrouping = !1;
        continue;
      case "precision-integer":
      case ".":
        t.maximumFractionDigits = 0;
        continue;
      case "measure-unit":
      case "unit":
        t.style = "unit", t.unit = JR(a.options[0]);
        continue;
      case "compact-short":
      case "K":
        t.notation = "compact", t.compactDisplay = "short";
        continue;
      case "compact-long":
      case "KK":
        t.notation = "compact", t.compactDisplay = "long";
        continue;
      case "scientific":
        t = _P2(_P2(_P2({}, t), {
          notation: "scientific"
        }), a.options.reduce(function (u, l) {
          return _P2(_P2({}, u), xm(l));
        }, {}));
        continue;
      case "engineering":
        t = _P2(_P2(_P2({}, t), {
          notation: "engineering"
        }), a.options.reduce(function (u, l) {
          return _P2(_P2({}, u), xm(l));
        }, {}));
        continue;
      case "notation-simple":
        t.notation = "standard";
        continue;
      case "unit-width-narrow":
        t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
        continue;
      case "unit-width-short":
        t.currencyDisplay = "code", t.unitDisplay = "short";
        continue;
      case "unit-width-full-name":
        t.currencyDisplay = "name", t.unitDisplay = "long";
        continue;
      case "unit-width-iso-code":
        t.currencyDisplay = "symbol";
        continue;
      case "scale":
        t.scale = parseFloat(a.options[0]);
        continue;
      case "integer-width":
        if (a.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
        a.options[0].replace(XR, function (u, l, c, f, h, p) {
          if (l) t.minimumIntegerDigits = c.length;else {
            if (f && h) throw new Error("We currently do not support maximum integer digits");
            if (p) throw new Error("We currently do not support exact integer digits");
          }
          return "";
        });
        continue;
    }
    if (Fb.test(a.stem)) {
      t.minimumIntegerDigits = a.stem.length;
      continue;
    }
    if (km.test(a.stem)) {
      if (a.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
      a.stem.replace(km, function (u, l, c, f, h, p) {
        return c === "*" ? t.minimumFractionDigits = l.length : f && f[0] === "#" ? t.maximumFractionDigits = f.length : h && p ? (t.minimumFractionDigits = h.length, t.maximumFractionDigits = h.length + p.length) : (t.minimumFractionDigits = l.length, t.maximumFractionDigits = l.length), "";
      });
      var i = a.options[0];
      i === "w" ? t = _P2(_P2({}, t), {
        trailingZeroDisplay: "stripIfInteger"
      }) : i && (t = _P2(_P2({}, t), Dm(i)));
      continue;
    }
    if (Mb.test(a.stem)) {
      t = _P2(_P2({}, t), Dm(a.stem));
      continue;
    }
    var o = Lb(a.stem);
    o && (t = _P2(_P2({}, t), o));
    var s = ZR(a.stem);
    s && (t = _P2(_P2({}, t), s));
  }
  return t;
}
var Ua = {
  AX: ["H"],
  BQ: ["H"],
  CP: ["H"],
  CZ: ["H"],
  DK: ["H"],
  FI: ["H"],
  ID: ["H"],
  IS: ["H"],
  ML: ["H"],
  NE: ["H"],
  RU: ["H"],
  SE: ["H"],
  SJ: ["H"],
  SK: ["H"],
  AS: ["h", "H"],
  BT: ["h", "H"],
  DJ: ["h", "H"],
  ER: ["h", "H"],
  GH: ["h", "H"],
  IN: ["h", "H"],
  LS: ["h", "H"],
  PG: ["h", "H"],
  PW: ["h", "H"],
  SO: ["h", "H"],
  TO: ["h", "H"],
  VU: ["h", "H"],
  WS: ["h", "H"],
  "001": ["H", "h"],
  AL: ["h", "H", "hB"],
  TD: ["h", "H", "hB"],
  "ca-ES": ["H", "h", "hB"],
  CF: ["H", "h", "hB"],
  CM: ["H", "h", "hB"],
  "fr-CA": ["H", "h", "hB"],
  "gl-ES": ["H", "h", "hB"],
  "it-CH": ["H", "h", "hB"],
  "it-IT": ["H", "h", "hB"],
  LU: ["H", "h", "hB"],
  NP: ["H", "h", "hB"],
  PF: ["H", "h", "hB"],
  SC: ["H", "h", "hB"],
  SM: ["H", "h", "hB"],
  SN: ["H", "h", "hB"],
  TF: ["H", "h", "hB"],
  VA: ["H", "h", "hB"],
  CY: ["h", "H", "hb", "hB"],
  GR: ["h", "H", "hb", "hB"],
  CO: ["h", "H", "hB", "hb"],
  DO: ["h", "H", "hB", "hb"],
  KP: ["h", "H", "hB", "hb"],
  KR: ["h", "H", "hB", "hb"],
  NA: ["h", "H", "hB", "hb"],
  PA: ["h", "H", "hB", "hb"],
  PR: ["h", "H", "hB", "hb"],
  VE: ["h", "H", "hB", "hb"],
  AC: ["H", "h", "hb", "hB"],
  AI: ["H", "h", "hb", "hB"],
  BW: ["H", "h", "hb", "hB"],
  BZ: ["H", "h", "hb", "hB"],
  CC: ["H", "h", "hb", "hB"],
  CK: ["H", "h", "hb", "hB"],
  CX: ["H", "h", "hb", "hB"],
  DG: ["H", "h", "hb", "hB"],
  FK: ["H", "h", "hb", "hB"],
  GB: ["H", "h", "hb", "hB"],
  GG: ["H", "h", "hb", "hB"],
  GI: ["H", "h", "hb", "hB"],
  IE: ["H", "h", "hb", "hB"],
  IM: ["H", "h", "hb", "hB"],
  IO: ["H", "h", "hb", "hB"],
  JE: ["H", "h", "hb", "hB"],
  LT: ["H", "h", "hb", "hB"],
  MK: ["H", "h", "hb", "hB"],
  MN: ["H", "h", "hb", "hB"],
  MS: ["H", "h", "hb", "hB"],
  NF: ["H", "h", "hb", "hB"],
  NG: ["H", "h", "hb", "hB"],
  NR: ["H", "h", "hb", "hB"],
  NU: ["H", "h", "hb", "hB"],
  PN: ["H", "h", "hb", "hB"],
  SH: ["H", "h", "hb", "hB"],
  SX: ["H", "h", "hb", "hB"],
  TA: ["H", "h", "hb", "hB"],
  ZA: ["H", "h", "hb", "hB"],
  "af-ZA": ["H", "h", "hB", "hb"],
  AR: ["H", "h", "hB", "hb"],
  CL: ["H", "h", "hB", "hb"],
  CR: ["H", "h", "hB", "hb"],
  CU: ["H", "h", "hB", "hb"],
  EA: ["H", "h", "hB", "hb"],
  "es-BO": ["H", "h", "hB", "hb"],
  "es-BR": ["H", "h", "hB", "hb"],
  "es-EC": ["H", "h", "hB", "hb"],
  "es-ES": ["H", "h", "hB", "hb"],
  "es-GQ": ["H", "h", "hB", "hb"],
  "es-PE": ["H", "h", "hB", "hb"],
  GT: ["H", "h", "hB", "hb"],
  HN: ["H", "h", "hB", "hb"],
  IC: ["H", "h", "hB", "hb"],
  KG: ["H", "h", "hB", "hb"],
  KM: ["H", "h", "hB", "hb"],
  LK: ["H", "h", "hB", "hb"],
  MA: ["H", "h", "hB", "hb"],
  MX: ["H", "h", "hB", "hb"],
  NI: ["H", "h", "hB", "hb"],
  PY: ["H", "h", "hB", "hb"],
  SV: ["H", "h", "hB", "hb"],
  UY: ["H", "h", "hB", "hb"],
  JP: ["H", "h", "K"],
  AD: ["H", "hB"],
  AM: ["H", "hB"],
  AO: ["H", "hB"],
  AT: ["H", "hB"],
  AW: ["H", "hB"],
  BE: ["H", "hB"],
  BF: ["H", "hB"],
  BJ: ["H", "hB"],
  BL: ["H", "hB"],
  BR: ["H", "hB"],
  CG: ["H", "hB"],
  CI: ["H", "hB"],
  CV: ["H", "hB"],
  DE: ["H", "hB"],
  EE: ["H", "hB"],
  FR: ["H", "hB"],
  GA: ["H", "hB"],
  GF: ["H", "hB"],
  GN: ["H", "hB"],
  GP: ["H", "hB"],
  GW: ["H", "hB"],
  HR: ["H", "hB"],
  IL: ["H", "hB"],
  IT: ["H", "hB"],
  KZ: ["H", "hB"],
  MC: ["H", "hB"],
  MD: ["H", "hB"],
  MF: ["H", "hB"],
  MQ: ["H", "hB"],
  MZ: ["H", "hB"],
  NC: ["H", "hB"],
  NL: ["H", "hB"],
  PM: ["H", "hB"],
  PT: ["H", "hB"],
  RE: ["H", "hB"],
  RO: ["H", "hB"],
  SI: ["H", "hB"],
  SR: ["H", "hB"],
  ST: ["H", "hB"],
  TG: ["H", "hB"],
  TR: ["H", "hB"],
  WF: ["H", "hB"],
  YT: ["H", "hB"],
  BD: ["h", "hB", "H"],
  PK: ["h", "hB", "H"],
  AZ: ["H", "hB", "h"],
  BA: ["H", "hB", "h"],
  BG: ["H", "hB", "h"],
  CH: ["H", "hB", "h"],
  GE: ["H", "hB", "h"],
  LI: ["H", "hB", "h"],
  ME: ["H", "hB", "h"],
  RS: ["H", "hB", "h"],
  UA: ["H", "hB", "h"],
  UZ: ["H", "hB", "h"],
  XK: ["H", "hB", "h"],
  AG: ["h", "hb", "H", "hB"],
  AU: ["h", "hb", "H", "hB"],
  BB: ["h", "hb", "H", "hB"],
  BM: ["h", "hb", "H", "hB"],
  BS: ["h", "hb", "H", "hB"],
  CA: ["h", "hb", "H", "hB"],
  DM: ["h", "hb", "H", "hB"],
  "en-001": ["h", "hb", "H", "hB"],
  FJ: ["h", "hb", "H", "hB"],
  FM: ["h", "hb", "H", "hB"],
  GD: ["h", "hb", "H", "hB"],
  GM: ["h", "hb", "H", "hB"],
  GU: ["h", "hb", "H", "hB"],
  GY: ["h", "hb", "H", "hB"],
  JM: ["h", "hb", "H", "hB"],
  KI: ["h", "hb", "H", "hB"],
  KN: ["h", "hb", "H", "hB"],
  KY: ["h", "hb", "H", "hB"],
  LC: ["h", "hb", "H", "hB"],
  LR: ["h", "hb", "H", "hB"],
  MH: ["h", "hb", "H", "hB"],
  MP: ["h", "hb", "H", "hB"],
  MW: ["h", "hb", "H", "hB"],
  NZ: ["h", "hb", "H", "hB"],
  SB: ["h", "hb", "H", "hB"],
  SG: ["h", "hb", "H", "hB"],
  SL: ["h", "hb", "H", "hB"],
  SS: ["h", "hb", "H", "hB"],
  SZ: ["h", "hb", "H", "hB"],
  TC: ["h", "hb", "H", "hB"],
  TT: ["h", "hb", "H", "hB"],
  UM: ["h", "hb", "H", "hB"],
  US: ["h", "hb", "H", "hB"],
  VC: ["h", "hb", "H", "hB"],
  VG: ["h", "hb", "H", "hB"],
  VI: ["h", "hb", "H", "hB"],
  ZM: ["h", "hb", "H", "hB"],
  BO: ["H", "hB", "h", "hb"],
  EC: ["H", "hB", "h", "hb"],
  ES: ["H", "hB", "h", "hb"],
  GQ: ["H", "hB", "h", "hb"],
  PE: ["H", "hB", "h", "hb"],
  AE: ["h", "hB", "hb", "H"],
  "ar-001": ["h", "hB", "hb", "H"],
  BH: ["h", "hB", "hb", "H"],
  DZ: ["h", "hB", "hb", "H"],
  EG: ["h", "hB", "hb", "H"],
  EH: ["h", "hB", "hb", "H"],
  HK: ["h", "hB", "hb", "H"],
  IQ: ["h", "hB", "hb", "H"],
  JO: ["h", "hB", "hb", "H"],
  KW: ["h", "hB", "hb", "H"],
  LB: ["h", "hB", "hb", "H"],
  LY: ["h", "hB", "hb", "H"],
  MO: ["h", "hB", "hb", "H"],
  MR: ["h", "hB", "hb", "H"],
  OM: ["h", "hB", "hb", "H"],
  PH: ["h", "hB", "hb", "H"],
  PS: ["h", "hB", "hb", "H"],
  QA: ["h", "hB", "hb", "H"],
  SA: ["h", "hB", "hb", "H"],
  SD: ["h", "hB", "hb", "H"],
  SY: ["h", "hB", "hb", "H"],
  TN: ["h", "hB", "hb", "H"],
  YE: ["h", "hB", "hb", "H"],
  AF: ["H", "hb", "hB", "h"],
  LA: ["H", "hb", "hB", "h"],
  CN: ["H", "hB", "hb", "h"],
  LV: ["H", "hB", "hb", "h"],
  TL: ["H", "hB", "hb", "h"],
  "zu-ZA": ["H", "hB", "hb", "h"],
  CD: ["hB", "H"],
  IR: ["hB", "H"],
  "hi-IN": ["hB", "h", "H"],
  "kn-IN": ["hB", "h", "H"],
  "ml-IN": ["hB", "h", "H"],
  "te-IN": ["hB", "h", "H"],
  KH: ["hB", "h", "H", "hb"],
  "ta-IN": ["hB", "h", "hb", "H"],
  BN: ["hb", "hB", "h", "H"],
  MY: ["hb", "hB", "h", "H"],
  ET: ["hB", "hb", "h", "H"],
  "gu-IN": ["hB", "hb", "h", "H"],
  "mr-IN": ["hB", "hb", "h", "H"],
  "pa-IN": ["hB", "hb", "h", "H"],
  TW: ["hB", "hb", "h", "H"],
  KE: ["hB", "hb", "H", "h"],
  MM: ["hB", "hb", "H", "h"],
  TZ: ["hB", "hb", "H", "h"],
  UG: ["hB", "hb", "H", "h"]
};
function t1(e, t) {
  for (var n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r);
    if (a === "j") {
      for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === a;) i++, r++;
      var o = 1 + (i & 1),
        s = i < 2 ? 1 : 3 + (i >> 1),
        u = "a",
        l = n1(t);
      for ((l == "H" || l == "k") && (s = 0); s-- > 0;) n += u;
      for (; o-- > 0;) n = l + n;
    } else a === "J" ? n += "H" : n += a;
  }
  return n;
}
function n1(e) {
  var t = e.hourCycle;
  if (t === void 0 &&
  // @ts-ignore hourCycle(s) is not identified yet
  e.hourCycles &&
  // @ts-ignore
  e.hourCycles.length && (t = e.hourCycles[0]), t) switch (t) {
    case "h24":
      return "k";
    case "h23":
      return "H";
    case "h12":
      return "h";
    case "h11":
      return "K";
    default:
      throw new Error("Invalid hourCycle");
  }
  var n = e.language,
    r;
  n !== "root" && (r = e.maximize().region);
  var a = Ua[r || ""] || Ua[n || ""] || Ua["".concat(n, "-001")] || Ua["001"];
  return a[0];
}
var Qs,
  r1 = new RegExp("^".concat(Ib.source, "*")),
  a1 = new RegExp("".concat(Ib.source, "*$"));
function Ce(e, t) {
  return {
    start: e,
    end: t
  };
}
var i1 = !!String.prototype.startsWith,
  o1 = !!String.fromCodePoint,
  s1 = !!Object.fromEntries,
  u1 = !!String.prototype.codePointAt,
  l1 = !!String.prototype.trimStart,
  c1 = !!String.prototype.trimEnd,
  f1 = !!Number.isSafeInteger,
  d1 = f1 ? Number.isSafeInteger : function (e) {
    return typeof e == "number" && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
  },
  hc = !0;
try {
  var h1 = Bb("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  hc = ((Qs = h1.exec("a")) === null || Qs === void 0 ? void 0 : Qs[0]) === "a";
} catch (_unused55) {
  hc = !1;
}
var $m = i1 ?
  // Native
  function (t, n, r) {
    return t.startsWith(n, r);
  } :
  // For IE11
  function (t, n, r) {
    return t.slice(r, r + n.length) === n;
  },
  pc = o1 ? String.fromCodePoint :
  // IE11
  function () {
    for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
    for (var r = "", a = t.length, i = 0, o; a > i;) {
      if (o = t[i++], o > 1114111) throw RangeError(o + " is not a valid code point");
      r += o < 65536 ? String.fromCharCode(o) : String.fromCharCode(((o -= 65536) >> 10) + 55296, o % 1024 + 56320);
    }
    return r;
  },
  Cm =
  // native
  s1 ? Object.fromEntries :
  // Ponyfill
  function (t) {
    for (var n = {}, r = 0, a = t; r < a.length; r++) {
      var i = a[r],
        o = i[0],
        s = i[1];
      n[o] = s;
    }
    return n;
  },
  jb = u1 ?
  // Native
  function (t, n) {
    return t.codePointAt(n);
  } :
  // IE 11
  function (t, n) {
    var r = t.length;
    if (!(n < 0 || n >= r)) {
      var a = t.charCodeAt(n),
        i;
      return a < 55296 || a > 56319 || n + 1 === r || (i = t.charCodeAt(n + 1)) < 56320 || i > 57343 ? a : (a - 55296 << 10) + (i - 56320) + 65536;
    }
  },
  p1 = l1 ?
  // Native
  function (t) {
    return t.trimStart();
  } :
  // Ponyfill
  function (t) {
    return t.replace(r1, "");
  },
  m1 = c1 ?
  // Native
  function (t) {
    return t.trimEnd();
  } :
  // Ponyfill
  function (t) {
    return t.replace(a1, "");
  };
function Bb(e, t) {
  return new RegExp(e, t);
}
var mc;
if (hc) {
  var Rm = Bb("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
  mc = function mc(t, n) {
    var r;
    Rm.lastIndex = n;
    var a = Rm.exec(t);
    return (r = a[1]) !== null && r !== void 0 ? r : "";
  };
} else mc = function mc(t, n) {
  for (var r = [];;) {
    var a = jb(t, n);
    if (a === void 0 || Vb(a) || b1(a)) break;
    r.push(a), n += a >= 65536 ? 2 : 1;
  }
  return pc.apply(void 0, r);
};
var v1 = /** @class */
function () {
  function e(t, n) {
    n === void 0 && (n = {}), this.message = t, this.position = {
      offset: 0,
      line: 1,
      column: 1
    }, this.ignoreTag = !!n.ignoreTag, this.locale = n.locale, this.requiresOtherClause = !!n.requiresOtherClause, this.shouldParseSkeletons = !!n.shouldParseSkeletons;
  }
  return e.prototype.parse = function () {
    if (this.offset() !== 0) throw Error("parser can only be used once");
    return this.parseMessage(0, "", !1);
  }, e.prototype.parseMessage = function (t, n, r) {
    for (var a = []; !this.isEOF();) {
      var i = this.char();
      if (i === 123) {
        var o = this.parseArgument(t, r);
        if (o.err) return o;
        a.push(o.val);
      } else {
        if (i === 125 && t > 0) break;
        if (i === 35 && (n === "plural" || n === "selectordinal")) {
          var s = this.clonePosition();
          this.bump(), a.push({
            type: Ge.pound,
            location: Ce(s, this.clonePosition())
          });
        } else if (i === 60 && !this.ignoreTag && this.peek() === 47) {
          if (r) break;
          return this.error($e.UNMATCHED_CLOSING_TAG, Ce(this.clonePosition(), this.clonePosition()));
        } else if (i === 60 && !this.ignoreTag && vc(this.peek() || 0)) {
          var o = this.parseTag(t, n);
          if (o.err) return o;
          a.push(o.val);
        } else {
          var o = this.parseLiteral(t, n);
          if (o.err) return o;
          a.push(o.val);
        }
      }
    }
    return {
      val: a,
      err: null
    };
  }, e.prototype.parseTag = function (t, n) {
    var r = this.clonePosition();
    this.bump();
    var a = this.parseTagName();
    if (this.bumpSpace(), this.bumpIf("/>")) return {
      val: {
        type: Ge.literal,
        value: "<".concat(a, "/>"),
        location: Ce(r, this.clonePosition())
      },
      err: null
    };
    if (this.bumpIf(">")) {
      var i = this.parseMessage(t + 1, n, !0);
      if (i.err) return i;
      var o = i.val,
        s = this.clonePosition();
      if (this.bumpIf("</")) {
        if (this.isEOF() || !vc(this.char())) return this.error($e.INVALID_TAG, Ce(s, this.clonePosition()));
        var u = this.clonePosition(),
          l = this.parseTagName();
        return a !== l ? this.error($e.UNMATCHED_CLOSING_TAG, Ce(u, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
          val: {
            type: Ge.tag,
            value: a,
            children: o,
            location: Ce(r, this.clonePosition())
          },
          err: null
        } : this.error($e.INVALID_TAG, Ce(s, this.clonePosition())));
      } else return this.error($e.UNCLOSED_TAG, Ce(r, this.clonePosition()));
    } else return this.error($e.INVALID_TAG, Ce(r, this.clonePosition()));
  }, e.prototype.parseTagName = function () {
    var t = this.offset();
    for (this.bump(); !this.isEOF() && g1(this.char());) this.bump();
    return this.message.slice(t, this.offset());
  }, e.prototype.parseLiteral = function (t, n) {
    for (var r = this.clonePosition(), a = "";;) {
      var i = this.tryParseQuote(n);
      if (i) {
        a += i;
        continue;
      }
      var o = this.tryParseUnquoted(t, n);
      if (o) {
        a += o;
        continue;
      }
      var s = this.tryParseLeftAngleBracket();
      if (s) {
        a += s;
        continue;
      }
      break;
    }
    var u = Ce(r, this.clonePosition());
    return {
      val: {
        type: Ge.literal,
        value: a,
        location: u
      },
      err: null
    };
  }, e.prototype.tryParseLeftAngleBracket = function () {
    return !this.isEOF() && this.char() === 60 && (this.ignoreTag ||
    // If at the opening tag or closing tag position, bail.
    !y1(this.peek() || 0)) ? (this.bump(), "<") : null;
  }, e.prototype.tryParseQuote = function (t) {
    if (this.isEOF() || this.char() !== 39) return null;
    switch (this.peek()) {
      case 39:
        return this.bump(), this.bump(), "'";
      case 123:
      case 60:
      case 62:
      case 125:
        break;
      case 35:
        if (t === "plural" || t === "selectordinal") break;
        return null;
      default:
        return null;
    }
    this.bump();
    var n = [this.char()];
    for (this.bump(); !this.isEOF();) {
      var r = this.char();
      if (r === 39) {
        if (this.peek() === 39) n.push(39), this.bump();else {
          this.bump();
          break;
        }
      } else n.push(r);
      this.bump();
    }
    return pc.apply(void 0, n);
  }, e.prototype.tryParseUnquoted = function (t, n) {
    if (this.isEOF()) return null;
    var r = this.char();
    return r === 60 || r === 123 || r === 35 && (n === "plural" || n === "selectordinal") || r === 125 && t > 0 ? null : (this.bump(), pc(r));
  }, e.prototype.parseArgument = function (t, n) {
    var r = this.clonePosition();
    if (this.bump(), this.bumpSpace(), this.isEOF()) return this.error($e.EXPECT_ARGUMENT_CLOSING_BRACE, Ce(r, this.clonePosition()));
    if (this.char() === 125) return this.bump(), this.error($e.EMPTY_ARGUMENT, Ce(r, this.clonePosition()));
    var a = this.parseIdentifierIfPossible().value;
    if (!a) return this.error($e.MALFORMED_ARGUMENT, Ce(r, this.clonePosition()));
    if (this.bumpSpace(), this.isEOF()) return this.error($e.EXPECT_ARGUMENT_CLOSING_BRACE, Ce(r, this.clonePosition()));
    switch (this.char()) {
      case 125:
        return this.bump(), {
          val: {
            type: Ge.argument,
            // value does not include the opening and closing braces.
            value: a,
            location: Ce(r, this.clonePosition())
          },
          err: null
        };
      case 44:
        return this.bump(), this.bumpSpace(), this.isEOF() ? this.error($e.EXPECT_ARGUMENT_CLOSING_BRACE, Ce(r, this.clonePosition())) : this.parseArgumentOptions(t, n, a, r);
      default:
        return this.error($e.MALFORMED_ARGUMENT, Ce(r, this.clonePosition()));
    }
  }, e.prototype.parseIdentifierIfPossible = function () {
    var t = this.clonePosition(),
      n = this.offset(),
      r = mc(this.message, n),
      a = n + r.length;
    this.bumpTo(a);
    var i = this.clonePosition(),
      o = Ce(t, i);
    return {
      value: r,
      location: o
    };
  }, e.prototype.parseArgumentOptions = function (t, n, r, a) {
    var i,
      o = this.clonePosition(),
      s = this.parseIdentifierIfPossible().value,
      u = this.clonePosition();
    switch (s) {
      case "":
        return this.error($e.EXPECT_ARGUMENT_TYPE, Ce(o, u));
      case "number":
      case "date":
      case "time":
        {
          this.bumpSpace();
          var l = null;
          if (this.bumpIf(",")) {
            this.bumpSpace();
            var c = this.clonePosition(),
              f = this.parseSimpleArgStyleIfPossible();
            if (f.err) return f;
            var h = m1(f.val);
            if (h.length === 0) return this.error($e.EXPECT_ARGUMENT_STYLE, Ce(this.clonePosition(), this.clonePosition()));
            var p = Ce(c, this.clonePosition());
            l = {
              style: h,
              styleLocation: p
            };
          }
          var v = this.tryParseArgumentClose(a);
          if (v.err) return v;
          var m = Ce(a, this.clonePosition());
          if (l && $m(l == null ? void 0 : l.style, "::", 0)) {
            var g = p1(l.style.slice(2));
            if (s === "number") {
              var f = this.parseNumberSkeletonFromString(g, l.styleLocation);
              return f.err ? f : {
                val: {
                  type: Ge.number,
                  value: r,
                  location: m,
                  style: f.val
                },
                err: null
              };
            } else {
              if (g.length === 0) return this.error($e.EXPECT_DATE_TIME_SKELETON, m);
              var b = g;
              this.locale && (b = t1(g, this.locale));
              var h = {
                  type: Pr.dateTime,
                  pattern: b,
                  location: l.styleLocation,
                  parsedOptions: this.shouldParseSkeletons ? YR(b) : {}
                },
                y = s === "date" ? Ge.date : Ge.time;
              return {
                val: {
                  type: y,
                  value: r,
                  location: m,
                  style: h
                },
                err: null
              };
            }
          }
          return {
            val: {
              type: s === "number" ? Ge.number : s === "date" ? Ge.date : Ge.time,
              value: r,
              location: m,
              style: (i = l == null ? void 0 : l.style) !== null && i !== void 0 ? i : null
            },
            err: null
          };
        }
      case "plural":
      case "selectordinal":
      case "select":
        {
          var E = this.clonePosition();
          if (this.bumpSpace(), !this.bumpIf(",")) return this.error($e.EXPECT_SELECT_ARGUMENT_OPTIONS, Ce(E, _P2({}, E)));
          this.bumpSpace();
          var w = this.parseIdentifierIfPossible(),
            _ = 0;
          if (s !== "select" && w.value === "offset") {
            if (!this.bumpIf(":")) return this.error($e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, Ce(this.clonePosition(), this.clonePosition()));
            this.bumpSpace();
            var f = this.tryParseDecimalInteger($e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
            if (f.err) return f;
            this.bumpSpace(), w = this.parseIdentifierIfPossible(), _ = f.val;
          }
          var C = this.tryParsePluralOrSelectOptions(t, s, n, w);
          if (C.err) return C;
          var v = this.tryParseArgumentClose(a);
          if (v.err) return v;
          var D = Ce(a, this.clonePosition());
          return s === "select" ? {
            val: {
              type: Ge.select,
              value: r,
              options: Cm(C.val),
              location: D
            },
            err: null
          } : {
            val: {
              type: Ge.plural,
              value: r,
              options: Cm(C.val),
              offset: _,
              pluralType: s === "plural" ? "cardinal" : "ordinal",
              location: D
            },
            err: null
          };
        }
      default:
        return this.error($e.INVALID_ARGUMENT_TYPE, Ce(o, u));
    }
  }, e.prototype.tryParseArgumentClose = function (t) {
    return this.isEOF() || this.char() !== 125 ? this.error($e.EXPECT_ARGUMENT_CLOSING_BRACE, Ce(t, this.clonePosition())) : (this.bump(), {
      val: !0,
      err: null
    });
  }, e.prototype.parseSimpleArgStyleIfPossible = function () {
    for (var t = 0, n = this.clonePosition(); !this.isEOF();) {
      var r = this.char();
      switch (r) {
        case 39:
          {
            this.bump();
            var a = this.clonePosition();
            if (!this.bumpUntil("'")) return this.error($e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, Ce(a, this.clonePosition()));
            this.bump();
            break;
          }
        case 123:
          {
            t += 1, this.bump();
            break;
          }
        case 125:
          {
            if (t > 0) t -= 1;else return {
              val: this.message.slice(n.offset, this.offset()),
              err: null
            };
            break;
          }
        default:
          this.bump();
          break;
      }
    }
    return {
      val: this.message.slice(n.offset, this.offset()),
      err: null
    };
  }, e.prototype.parseNumberSkeletonFromString = function (t, n) {
    var r = [];
    try {
      r = KR(t);
    } catch (_unused56) {
      return this.error($e.INVALID_NUMBER_SKELETON, n);
    }
    return {
      val: {
        type: Pr.number,
        tokens: r,
        location: n,
        parsedOptions: this.shouldParseSkeletons ? e1(r) : {}
      },
      err: null
    };
  }, e.prototype.tryParsePluralOrSelectOptions = function (t, n, r, a) {
    for (var i, o = !1, s = [], u = /* @__PURE__ */new Set(), l = a.value, c = a.location;;) {
      if (l.length === 0) {
        var f = this.clonePosition();
        if (n !== "select" && this.bumpIf("=")) {
          var h = this.tryParseDecimalInteger($e.EXPECT_PLURAL_ARGUMENT_SELECTOR, $e.INVALID_PLURAL_ARGUMENT_SELECTOR);
          if (h.err) return h;
          c = Ce(f, this.clonePosition()), l = this.message.slice(f.offset, this.offset());
        } else break;
      }
      if (u.has(l)) return this.error(n === "select" ? $e.DUPLICATE_SELECT_ARGUMENT_SELECTOR : $e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, c);
      l === "other" && (o = !0), this.bumpSpace();
      var p = this.clonePosition();
      if (!this.bumpIf("{")) return this.error(n === "select" ? $e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : $e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, Ce(this.clonePosition(), this.clonePosition()));
      var v = this.parseMessage(t + 1, n, r);
      if (v.err) return v;
      var m = this.tryParseArgumentClose(p);
      if (m.err) return m;
      s.push([l, {
        value: v.val,
        location: Ce(p, this.clonePosition())
      }]), u.add(l), this.bumpSpace(), i = this.parseIdentifierIfPossible(), l = i.value, c = i.location;
    }
    return s.length === 0 ? this.error(n === "select" ? $e.EXPECT_SELECT_ARGUMENT_SELECTOR : $e.EXPECT_PLURAL_ARGUMENT_SELECTOR, Ce(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !o ? this.error($e.MISSING_OTHER_CLAUSE, Ce(this.clonePosition(), this.clonePosition())) : {
      val: s,
      err: null
    };
  }, e.prototype.tryParseDecimalInteger = function (t, n) {
    var r = 1,
      a = this.clonePosition();
    this.bumpIf("+") || this.bumpIf("-") && (r = -1);
    for (var i = !1, o = 0; !this.isEOF();) {
      var s = this.char();
      if (s >= 48 && s <= 57) i = !0, o = o * 10 + (s - 48), this.bump();else break;
    }
    var u = Ce(a, this.clonePosition());
    return i ? (o *= r, d1(o) ? {
      val: o,
      err: null
    } : this.error(n, u)) : this.error(t, u);
  }, e.prototype.offset = function () {
    return this.position.offset;
  }, e.prototype.isEOF = function () {
    return this.offset() === this.message.length;
  }, e.prototype.clonePosition = function () {
    return {
      offset: this.position.offset,
      line: this.position.line,
      column: this.position.column
    };
  }, e.prototype.char = function () {
    var t = this.position.offset;
    if (t >= this.message.length) throw Error("out of bound");
    var n = jb(this.message, t);
    if (n === void 0) throw Error("Offset ".concat(t, " is at invalid UTF-16 code unit boundary"));
    return n;
  }, e.prototype.error = function (t, n) {
    return {
      val: null,
      err: {
        kind: t,
        message: this.message,
        location: n
      }
    };
  }, e.prototype.bump = function () {
    if (!this.isEOF()) {
      var t = this.char();
      t === 10 ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += t < 65536 ? 1 : 2);
    }
  }, e.prototype.bumpIf = function (t) {
    if ($m(this.message, t, this.offset())) {
      for (var n = 0; n < t.length; n++) this.bump();
      return !0;
    }
    return !1;
  }, e.prototype.bumpUntil = function (t) {
    var n = this.offset(),
      r = this.message.indexOf(t, n);
    return r >= 0 ? (this.bumpTo(r), !0) : (this.bumpTo(this.message.length), !1);
  }, e.prototype.bumpTo = function (t) {
    if (this.offset() > t) throw Error("targetOffset ".concat(t, " must be greater than or equal to the current offset ").concat(this.offset()));
    for (t = Math.min(t, this.message.length);;) {
      var n = this.offset();
      if (n === t) break;
      if (n > t) throw Error("targetOffset ".concat(t, " is at invalid UTF-16 code unit boundary"));
      if (this.bump(), this.isEOF()) break;
    }
  }, e.prototype.bumpSpace = function () {
    for (; !this.isEOF() && Vb(this.char());) this.bump();
  }, e.prototype.peek = function () {
    if (this.isEOF()) return null;
    var t = this.char(),
      n = this.offset(),
      r = this.message.charCodeAt(n + (t >= 65536 ? 2 : 1));
    return r !== null && r !== void 0 ? r : null;
  }, e;
}();
function vc(e) {
  return e >= 97 && e <= 122 || e >= 65 && e <= 90;
}
function y1(e) {
  return vc(e) || e === 47;
}
function g1(e) {
  return e === 45 || e === 46 || e >= 48 && e <= 57 || e === 95 || e >= 97 && e <= 122 || e >= 65 && e <= 90 || e == 183 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
}
function Vb(e) {
  return e >= 9 && e <= 13 || e === 32 || e === 133 || e >= 8206 && e <= 8207 || e === 8232 || e === 8233;
}
function b1(e) {
  return e >= 33 && e <= 35 || e === 36 || e >= 37 && e <= 39 || e === 40 || e === 41 || e === 42 || e === 43 || e === 44 || e === 45 || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || e === 91 || e === 92 || e === 93 || e === 94 || e === 96 || e === 123 || e === 124 || e === 125 || e === 126 || e === 161 || e >= 162 && e <= 165 || e === 166 || e === 167 || e === 169 || e === 171 || e === 172 || e === 174 || e === 176 || e === 177 || e === 182 || e === 187 || e === 191 || e === 215 || e === 247 || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || e === 8216 || e === 8217 || e === 8218 || e >= 8219 && e <= 8220 || e === 8221 || e === 8222 || e === 8223 || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || e === 8249 || e === 8250 || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || e === 8260 || e === 8261 || e === 8262 || e >= 8263 && e <= 8273 || e === 8274 || e === 8275 || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || e === 8608 || e >= 8609 && e <= 8610 || e === 8611 || e >= 8612 && e <= 8613 || e === 8614 || e >= 8615 && e <= 8621 || e === 8622 || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || e === 8658 || e === 8659 || e === 8660 || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || e === 8968 || e === 8969 || e === 8970 || e === 8971 || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || e === 9001 || e === 9002 || e >= 9003 && e <= 9083 || e === 9084 || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || e === 9655 || e >= 9656 && e <= 9664 || e === 9665 || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || e === 9839 || e >= 9840 && e <= 10087 || e === 10088 || e === 10089 || e === 10090 || e === 10091 || e === 10092 || e === 10093 || e === 10094 || e === 10095 || e === 10096 || e === 10097 || e === 10098 || e === 10099 || e === 10100 || e === 10101 || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || e === 10181 || e === 10182 || e >= 10183 && e <= 10213 || e === 10214 || e === 10215 || e === 10216 || e === 10217 || e === 10218 || e === 10219 || e === 10220 || e === 10221 || e === 10222 || e === 10223 || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || e === 10627 || e === 10628 || e === 10629 || e === 10630 || e === 10631 || e === 10632 || e === 10633 || e === 10634 || e === 10635 || e === 10636 || e === 10637 || e === 10638 || e === 10639 || e === 10640 || e === 10641 || e === 10642 || e === 10643 || e === 10644 || e === 10645 || e === 10646 || e === 10647 || e === 10648 || e >= 10649 && e <= 10711 || e === 10712 || e === 10713 || e === 10714 || e === 10715 || e >= 10716 && e <= 10747 || e === 10748 || e === 10749 || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || e === 11158 || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || e === 11778 || e === 11779 || e === 11780 || e === 11781 || e >= 11782 && e <= 11784 || e === 11785 || e === 11786 || e === 11787 || e === 11788 || e === 11789 || e >= 11790 && e <= 11798 || e === 11799 || e >= 11800 && e <= 11801 || e === 11802 || e === 11803 || e === 11804 || e === 11805 || e >= 11806 && e <= 11807 || e === 11808 || e === 11809 || e === 11810 || e === 11811 || e === 11812 || e === 11813 || e === 11814 || e === 11815 || e === 11816 || e === 11817 || e >= 11818 && e <= 11822 || e === 11823 || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || e === 11840 || e === 11841 || e === 11842 || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || e === 11858 || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || e === 12296 || e === 12297 || e === 12298 || e === 12299 || e === 12300 || e === 12301 || e === 12302 || e === 12303 || e === 12304 || e === 12305 || e >= 12306 && e <= 12307 || e === 12308 || e === 12309 || e === 12310 || e === 12311 || e === 12312 || e === 12313 || e === 12314 || e === 12315 || e === 12316 || e === 12317 || e >= 12318 && e <= 12319 || e === 12320 || e === 12336 || e === 64830 || e === 64831 || e >= 65093 && e <= 65094;
}
function yc(e) {
  e.forEach(function (t) {
    if (delete t.location, Cb(t) || Rb(t)) for (var n in t.options) delete t.options[n].location, yc(t.options[n].value);else Db(t) && Ab(t.style) || (xb(t) || $b(t)) && dc(t.style) ? delete t.style.location : Nb(t) && yc(t.children);
  });
}
function _1(e, t) {
  t === void 0 && (t = {}), t = _P2({
    shouldParseSkeletons: !0,
    requiresOtherClause: !0
  }, t);
  var n = new v1(e, t).parse();
  if (n.err) {
    var r = SyntaxError($e[n.err.kind]);
    throw r.location = n.err.location, r.originalMessage = n.err.message, r;
  }
  return t != null && t.captureLocation || yc(n.val), n.val;
}
function Wt(e, t) {
  var n = t && t.cache ? t.cache : T1,
    r = t && t.serializer ? t.serializer : P1,
    a = t && t.strategy ? t.strategy : O1;
  return a(e, {
    cache: n,
    serializer: r
  });
}
function w1(e) {
  return e == null || typeof e == "number" || typeof e == "boolean";
}
function qb(e, t, n, r) {
  var a = w1(r) ? r : n(r),
    i = t.get(a);
  return typeof i > "u" && (i = e.call(this, r), t.set(a, i)), i;
}
function Ub(e, t, n) {
  var r = Array.prototype.slice.call(arguments, 3),
    a = n(r),
    i = t.get(a);
  return typeof i > "u" && (i = e.apply(this, r), t.set(a, i)), i;
}
function Vf(e, t, n, r, a) {
  return n.bind(t, e, r, a);
}
function O1(e, t) {
  var n = e.length === 1 ? qb : Ub;
  return Vf(e, this, n, t.cache.create(), t.serializer);
}
function S1(e, t) {
  return Vf(e, this, Ub, t.cache.create(), t.serializer);
}
function E1(e, t) {
  return Vf(e, this, qb, t.cache.create(), t.serializer);
}
var P1 = function P1() {
  return JSON.stringify(arguments);
};
function qf() {
  this.cache = /* @__PURE__ */Object.create(null);
}
qf.prototype.get = function (e) {
  return this.cache[e];
};
qf.prototype.set = function (e, t) {
  this.cache[e] = t;
};
var T1 = {
    create: function create() {
      return new qf();
    }
  },
  Gt = {
    variadic: S1,
    monadic: E1
  },
  en;
(function (e) {
  e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
})(en || (en = {}));
var Rn = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a) {
      var i = e.call(this, n) || this;
      return i.code = r, i.originalMessage = a, i;
    }
    return t.prototype.toString = function () {
      return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    }, t;
  }(Error),
  Nm = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a, i) {
      return e.call(this, 'Invalid values for "'.concat(n, '": "').concat(r, '". Options are "').concat(Object.keys(a).join('", "'), '"'), en.INVALID_VALUE, i) || this;
    }
    return t;
  }(Rn),
  k1 = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a) {
      return e.call(this, 'Value for "'.concat(n, '" must be of type ').concat(r), en.INVALID_VALUE, a) || this;
    }
    return t;
  }(Rn),
  D1 = /** @class */
  function (e) {
    et(t, e);
    function t(n, r) {
      return e.call(this, 'The intl string context variable "'.concat(n, '" was not provided to the string "').concat(r, '"'), en.MISSING_VALUE, r) || this;
    }
    return t;
  }(Rn),
  Dt;
(function (e) {
  e[e.literal = 0] = "literal", e[e.object = 1] = "object";
})(Dt || (Dt = {}));
function x1(e) {
  return e.length < 2 ? e : e.reduce(function (t, n) {
    var r = t[t.length - 1];
    return !r || r.type !== Dt.literal || n.type !== Dt.literal ? t.push(n) : r.value += n.value, t;
  }, []);
}
function zb(e) {
  return typeof e == "function";
}
function Ui(e, t, n, r, a, i, o) {
  if (e.length === 1 && Tm(e[0])) return [{
    type: Dt.literal,
    value: e[0].value
  }];
  for (var s = [], u = 0, l = e; u < l.length; u++) {
    var c = l[u];
    if (Tm(c)) {
      s.push({
        type: Dt.literal,
        value: c.value
      });
      continue;
    }
    if (WR(c)) {
      typeof i == "number" && s.push({
        type: Dt.literal,
        value: n.getNumberFormat(t).format(i)
      });
      continue;
    }
    var f = c.value;
    if (!(a && f in a)) throw new D1(f, o);
    var h = a[f];
    if (HR(c)) {
      (!h || typeof h == "string" || typeof h == "number") && (h = typeof h == "string" || typeof h == "number" ? String(h) : ""), s.push({
        type: typeof h == "string" ? Dt.literal : Dt.object,
        value: h
      });
      continue;
    }
    if (xb(c)) {
      var p = typeof c.style == "string" ? r.date[c.style] : dc(c.style) ? c.style.parsedOptions : void 0;
      s.push({
        type: Dt.literal,
        value: n.getDateTimeFormat(t, p).format(h)
      });
      continue;
    }
    if ($b(c)) {
      var p = typeof c.style == "string" ? r.time[c.style] : dc(c.style) ? c.style.parsedOptions : r.time.medium;
      s.push({
        type: Dt.literal,
        value: n.getDateTimeFormat(t, p).format(h)
      });
      continue;
    }
    if (Db(c)) {
      var p = typeof c.style == "string" ? r.number[c.style] : Ab(c.style) ? c.style.parsedOptions : void 0;
      p && p.scale && (h = h * (p.scale || 1)), s.push({
        type: Dt.literal,
        value: n.getNumberFormat(t, p).format(h)
      });
      continue;
    }
    if (Nb(c)) {
      var v = c.children,
        m = c.value,
        g = a[m];
      if (!zb(g)) throw new k1(m, "function", o);
      var b = Ui(v, t, n, r, a, i),
        y = g(b.map(function (_) {
          return _.value;
        }));
      Array.isArray(y) || (y = [y]), s.push.apply(s, y.map(function (_) {
        return {
          type: typeof _ == "string" ? Dt.literal : Dt.object,
          value: _
        };
      }));
    }
    if (Cb(c)) {
      var E = c.options[h] || c.options.other;
      if (!E) throw new Nm(c.value, h, Object.keys(c.options), o);
      s.push.apply(s, Ui(E.value, t, n, r, a));
      continue;
    }
    if (Rb(c)) {
      var E = c.options["=".concat(h)];
      if (!E) {
        if (!Intl.PluralRules) throw new Rn("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", en.MISSING_INTL_API, o);
        var w = n.getPluralRules(t, {
          type: c.pluralType
        }).select(h - (c.offset || 0));
        E = c.options[w] || c.options.other;
      }
      if (!E) throw new Nm(c.value, h, Object.keys(c.options), o);
      s.push.apply(s, Ui(E.value, t, n, r, a, h - (c.offset || 0)));
      continue;
    }
  }
  return x1(s);
}
function $1(e, t) {
  return t ? _P2(_P2(_P2({}, e || {}), t || {}), Object.keys(e).reduce(function (n, r) {
    return n[r] = _P2(_P2({}, e[r]), t[r] || {}), n;
  }, {})) : e;
}
function C1(e, t) {
  return t ? Object.keys(e).reduce(function (n, r) {
    return n[r] = $1(e[r], t[r]), n;
  }, _P2({}, e)) : e;
}
function Ks(e) {
  return {
    create: function create() {
      return {
        get: function get(t) {
          return e[t];
        },
        set: function set(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function R1(e) {
  return e === void 0 && (e = {
    number: {},
    dateTime: {},
    pluralRules: {}
  }), {
    getNumberFormat: Wt(function () {
      for (var t, n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
      return new ((t = Intl.NumberFormat).bind.apply(t, xt([void 0], n, !1)))();
    }, {
      cache: Ks(e.number),
      strategy: Gt.variadic
    }),
    getDateTimeFormat: Wt(function () {
      for (var t, n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
      return new ((t = Intl.DateTimeFormat).bind.apply(t, xt([void 0], n, !1)))();
    }, {
      cache: Ks(e.dateTime),
      strategy: Gt.variadic
    }),
    getPluralRules: Wt(function () {
      for (var t, n = [], r = 0; r < arguments.length; r++) n[r] = arguments[r];
      return new ((t = Intl.PluralRules).bind.apply(t, xt([void 0], n, !1)))();
    }, {
      cache: Ks(e.pluralRules),
      strategy: Gt.variadic
    })
  };
}
var Hb = /** @class */
  function () {
    function e(t, n, r, a) {
      n === void 0 && (n = e.defaultLocale);
      var i = this;
      if (this.formatterCache = {
        number: {},
        dateTime: {},
        pluralRules: {}
      }, this.format = function (o) {
        var s = i.formatToParts(o);
        if (s.length === 1) return s[0].value;
        var u = s.reduce(function (l, c) {
          return !l.length || c.type !== Dt.literal || typeof l[l.length - 1] != "string" ? l.push(c.value) : l[l.length - 1] += c.value, l;
        }, []);
        return u.length <= 1 ? u[0] || "" : u;
      }, this.formatToParts = function (o) {
        return Ui(i.ast, i.locales, i.formatters, i.formats, o, void 0, i.message);
      }, this.resolvedOptions = function () {
        var o;
        return {
          locale: ((o = i.resolvedLocale) === null || o === void 0 ? void 0 : o.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
        };
      }, this.getAst = function () {
        return i.ast;
      }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), typeof t == "string") {
        if (this.message = t, !e.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
        this.ast = e.__parse(t, {
          ignoreTag: a == null ? void 0 : a.ignoreTag,
          locale: this.resolvedLocale
        });
      } else this.ast = t;
      if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
      this.formats = C1(e.formats, r), this.formatters = a && a.formatters || R1(this.formatterCache);
    }
    return Object.defineProperty(e, "defaultLocale", {
      get: function get() {
        return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
      },
      enumerable: !1,
      configurable: !0
    }), e.memoizedDefaultLocale = null, e.resolveLocale = function (t) {
      if (!(typeof Intl.Locale > "u")) {
        var n = Intl.NumberFormat.supportedLocalesOf(t);
        return n.length > 0 ? new Intl.Locale(n[0]) : new Intl.Locale(typeof t == "string" ? t : t[0]);
      }
    }, e.__parse = _1, e.formats = {
      number: {
        integer: {
          maximumFractionDigits: 0
        },
        currency: {
          style: "currency"
        },
        percent: {
          style: "percent"
        }
      },
      date: {
        short: {
          month: "numeric",
          day: "numeric",
          year: "2-digit"
        },
        medium: {
          month: "short",
          day: "numeric",
          year: "numeric"
        },
        long: {
          month: "long",
          day: "numeric",
          year: "numeric"
        },
        full: {
          weekday: "long",
          month: "long",
          day: "numeric",
          year: "numeric"
        }
      },
      time: {
        short: {
          hour: "numeric",
          minute: "numeric"
        },
        medium: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric"
        },
        long: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        },
        full: {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZoneName: "short"
        }
      }
    }, e;
  }(),
  Tt;
(function (e) {
  e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
})(Tt || (Tt = {}));
var Rt = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a) {
      var i = this,
        o = a ? a instanceof Error ? a : new Error(String(a)) : void 0;
      return i = e.call(this, "[@formatjs/intl Error ".concat(n, "] ").concat(r, "\n").concat(o ? "\n".concat(o.message, "\n").concat(o.stack) : "")) || this, i.code = n, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(i, t), i;
    }
    return t;
  }(Error),
  N1 = /** @class */
  function (e) {
    et(t, e);
    function t(n, r) {
      return e.call(this, Tt.UNSUPPORTED_FORMATTER, n, r) || this;
    }
    return t;
  }(Rt),
  A1 = /** @class */
  function (e) {
    et(t, e);
    function t(n, r) {
      return e.call(this, Tt.INVALID_CONFIG, n, r) || this;
    }
    return t;
  }(Rt),
  Am = /** @class */
  function (e) {
    et(t, e);
    function t(n, r) {
      return e.call(this, Tt.MISSING_DATA, n, r) || this;
    }
    return t;
  }(Rt),
  Uf = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a) {
      return e.call(this, Tt.FORMAT_ERROR, "".concat(n, "\nLocale: ").concat(r, "\n"), a) || this;
    }
    return t;
  }(Rt),
  Js = /** @class */
  function (e) {
    et(t, e);
    function t(n, r, a, i) {
      var o = e.call(this, "".concat(n, "\nMessageID: ").concat(a == null ? void 0 : a.id, "\nDefault Message: ").concat(a == null ? void 0 : a.defaultMessage, "\nDescription: ").concat(a == null ? void 0 : a.description, "\n"), r, i) || this;
      return o.descriptor = a, o;
    }
    return t;
  }(Uf),
  I1 = /** @class */
  function (e) {
    et(t, e);
    function t(n, r) {
      var a = e.call(this, Tt.MISSING_TRANSLATION, 'Missing message: "'.concat(n.id, '" for locale "').concat(r, '", using ').concat(n.defaultMessage ? "default message (".concat(typeof n.defaultMessage == "string" ? n.defaultMessage : n.defaultMessage.map(function (i) {
        var o;
        return (o = i.value) !== null && o !== void 0 ? o : JSON.stringify(i);
      }).join(), ")") : "id", " as fallback.")) || this;
      return a.descriptor = n, a;
    }
    return t;
  }(Rt);
function Xn(e, t, n) {
  return n === void 0 && (n = {}), t.reduce(function (r, a) {
    return a in e ? r[a] = e[a] : a in n && (r[a] = n[a]), r;
  }, {});
}
var M1 = function M1(e) {
    process.env.NODE_ENV !== "production" && console.error(e);
  },
  F1 = function F1(e) {
    process.env.NODE_ENV !== "production" && console.warn(e);
  },
  Wb = {
    formats: {},
    messages: {},
    timeZone: void 0,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: !0,
    onError: M1,
    onWarn: F1
  };
function Gb() {
  return {
    dateTime: {},
    number: {},
    message: {},
    relativeTime: {},
    pluralRules: {},
    list: {},
    displayNames: {}
  };
}
function An(e) {
  return {
    create: function create() {
      return {
        get: function get(t) {
          return e[t];
        },
        set: function set(t, n) {
          e[t] = n;
        }
      };
    }
  };
}
function L1(e) {
  e === void 0 && (e = Gb());
  var t = Intl.RelativeTimeFormat,
    n = Intl.ListFormat,
    r = Intl.DisplayNames,
    a = Wt(function () {
      for (var s, u = [], l = 0; l < arguments.length; l++) u[l] = arguments[l];
      return new ((s = Intl.DateTimeFormat).bind.apply(s, xt([void 0], u, !1)))();
    }, {
      cache: An(e.dateTime),
      strategy: Gt.variadic
    }),
    i = Wt(function () {
      for (var s, u = [], l = 0; l < arguments.length; l++) u[l] = arguments[l];
      return new ((s = Intl.NumberFormat).bind.apply(s, xt([void 0], u, !1)))();
    }, {
      cache: An(e.number),
      strategy: Gt.variadic
    }),
    o = Wt(function () {
      for (var s, u = [], l = 0; l < arguments.length; l++) u[l] = arguments[l];
      return new ((s = Intl.PluralRules).bind.apply(s, xt([void 0], u, !1)))();
    }, {
      cache: An(e.pluralRules),
      strategy: Gt.variadic
    });
  return {
    getDateTimeFormat: a,
    getNumberFormat: i,
    getMessageFormat: Wt(function (s, u, l, c) {
      return new Hb(s, u, l, _P2({
        formatters: {
          getNumberFormat: i,
          getDateTimeFormat: a,
          getPluralRules: o
        }
      }, c || {}));
    }, {
      cache: An(e.message),
      strategy: Gt.variadic
    }),
    getRelativeTimeFormat: Wt(function () {
      for (var s = [], u = 0; u < arguments.length; u++) s[u] = arguments[u];
      return new (t.bind.apply(t, xt([void 0], s, !1)))();
    }, {
      cache: An(e.relativeTime),
      strategy: Gt.variadic
    }),
    getPluralRules: o,
    getListFormat: Wt(function () {
      for (var s = [], u = 0; u < arguments.length; u++) s[u] = arguments[u];
      return new (n.bind.apply(n, xt([void 0], s, !1)))();
    }, {
      cache: An(e.list),
      strategy: Gt.variadic
    }),
    getDisplayNames: Wt(function () {
      for (var s = [], u = 0; u < arguments.length; u++) s[u] = arguments[u];
      return new (r.bind.apply(r, xt([void 0], s, !1)))();
    }, {
      cache: An(e.displayNames),
      strategy: Gt.variadic
    })
  };
}
function zf(e, t, n, r) {
  var a = e && e[t],
    i;
  if (a && (i = a[n]), i) return i;
  r(new N1("No ".concat(t, " format named: ").concat(n)));
}
function za(e, t) {
  return Object.keys(e).reduce(function (n, r) {
    return n[r] = _P2({
      timeZone: t
    }, e[r]), n;
  }, {});
}
function Im(e, t) {
  var n = Object.keys(_P2(_P2({}, e), t));
  return n.reduce(function (r, a) {
    return r[a] = _P2(_P2({}, e[a] || {}), t[a] || {}), r;
  }, {});
}
function Mm(e, t) {
  if (!t) return e;
  var n = Hb.formats;
  return _P2(_P2(_P2({}, n), e), {
    date: Im(za(n.date, t), za(e.date || {}, t)),
    time: Im(za(n.time, t), za(e.time || {}, t))
  });
}
var gc = function gc(e, t, n, r, a) {
    var i = e.locale,
      o = e.formats,
      s = e.messages,
      u = e.defaultLocale,
      l = e.defaultFormats,
      c = e.fallbackOnEmptyString,
      f = e.onError,
      h = e.timeZone,
      p = e.defaultRichTextElements;
    n === void 0 && (n = {
      id: ""
    });
    var v = n.id,
      m = n.defaultMessage;
    kb(!!v, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var g = String(v),
      b =
      // In case messages is Object.create(null)
      // e.g import('foo.json') from webpack)
      // See https://github.com/formatjs/formatjs/issues/1914
      s && Object.prototype.hasOwnProperty.call(s, g) && s[g];
    if (Array.isArray(b) && b.length === 1 && b[0].type === Ge.literal) return b[0].value;
    if (!r && b && typeof b == "string" && !p) return b.replace(/'\{(.*?)\}'/gi, "{$1}");
    if (r = _P2(_P2({}, p), r || {}), o = Mm(o, h), l = Mm(l, h), !b) {
      if (c === !1 && b === "") return b;
      if ((!m || i && i.toLowerCase() !== u.toLowerCase()) && f(new I1(n, i)), m) try {
        var y = t.getMessageFormat(m, u, l, a);
        return y.format(r);
      } catch (E) {
        return f(new Js('Error formatting default message for: "'.concat(g, '", rendering default message verbatim'), i, n, E)), typeof m == "string" ? m : g;
      }
      return g;
    }
    try {
      var y = t.getMessageFormat(b, i, o, _P2({
        formatters: t
      }, a || {}));
      return y.format(r);
    } catch (E) {
      f(new Js('Error formatting message: "'.concat(g, '", using ').concat(m ? "default message" : "id", " as fallback."), i, n, E));
    }
    if (m) try {
      var y = t.getMessageFormat(m, u, l, a);
      return y.format(r);
    } catch (E) {
      f(new Js('Error formatting the default message for: "'.concat(g, '", rendering message verbatim'), i, n, E));
    }
    return typeof b == "string" ? b : typeof m == "string" ? m : g;
  },
  Yb = ["formatMatcher", "timeZone", "hour12", "weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hourCycle", "dateStyle", "timeStyle", "calendar",
  // 'dayPeriod',
  "numberingSystem", "fractionalSecondDigits"];
function us(e, t, n, r) {
  var a = e.locale,
    i = e.formats,
    o = e.onError,
    s = e.timeZone;
  r === void 0 && (r = {});
  var u = r.format,
    l = _P2(_P2({}, s && {
      timeZone: s
    }), u && zf(i, t, u, o)),
    c = Xn(r, Yb, l);
  return t === "time" && !c.hour && !c.minute && !c.second && !c.timeStyle && !c.dateStyle && (c = _P2(_P2({}, c), {
    hour: "numeric",
    minute: "numeric"
  })), n(a, c);
}
function j1(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = n[0],
    i = n[1],
    o = i === void 0 ? {} : i,
    s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return us(e, "date", t, o).format(s);
  } catch (u) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting date.", u));
  }
  return String(s);
}
function B1(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = n[0],
    i = n[1],
    o = i === void 0 ? {} : i,
    s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return us(e, "time", t, o).format(s);
  } catch (u) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting time.", u));
  }
  return String(s);
}
function V1(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = n[0],
    i = n[1],
    o = n[2],
    s = o === void 0 ? {} : o,
    u = e.timeZone,
    l = e.locale,
    c = e.onError,
    f = Xn(s, Yb, u ? {
      timeZone: u
    } : {});
  try {
    return t(l, f).formatRange(a, i);
  } catch (h) {
    c(new Rt(Tt.FORMAT_ERROR, "Error formatting date time range.", h));
  }
  return String(a);
}
function q1(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = n[0],
    i = n[1],
    o = i === void 0 ? {} : i,
    s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return us(e, "date", t, o).formatToParts(s);
  } catch (u) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting date.", u));
  }
  return [];
}
function U1(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
  var a = n[0],
    i = n[1],
    o = i === void 0 ? {} : i,
    s = typeof a == "string" ? new Date(a || 0) : a;
  try {
    return us(e, "time", t, o).formatToParts(s);
  } catch (u) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting time.", u));
  }
  return [];
}
var z1 = ["style", "type", "fallback", "languageDisplay"];
function H1(e, t, n, r) {
  var a = e.locale,
    i = e.onError,
    o = Intl.DisplayNames;
  o || i(new Rn("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", en.MISSING_INTL_API));
  var s = Xn(r, z1);
  try {
    return t(a, s).of(n);
  } catch (u) {
    i(new Rt(Tt.FORMAT_ERROR, "Error formatting display name.", u));
  }
}
var W1 = ["type", "style"],
  Fm = Date.now();
function G1(e) {
  return "".concat(Fm, "_").concat(e, "_").concat(Fm);
}
function Y1(e, t, n, r) {
  r === void 0 && (r = {});
  var a = Qb(e, t, n, r).reduce(function (i, o) {
    var s = o.value;
    return typeof s != "string" ? i.push(s) : typeof i[i.length - 1] == "string" ? i[i.length - 1] += s : i.push(s), i;
  }, []);
  return a.length === 1 ? a[0] : a.length === 0 ? "" : a;
}
function Qb(e, t, n, r) {
  var a = e.locale,
    i = e.onError;
  r === void 0 && (r = {});
  var o = Intl.ListFormat;
  o || i(new Rn("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", en.MISSING_INTL_API));
  var s = Xn(r, W1);
  try {
    var u = {},
      l = n.map(function (c, f) {
        if (typeof c == "object") {
          var h = G1(f);
          return u[h] = c, h;
        }
        return String(c);
      });
    return t(a, s).formatToParts(l).map(function (c) {
      return c.type === "literal" ? c : _P2(_P2({}, c), {
        value: u[c.value] || c.value
      });
    });
  } catch (c) {
    i(new Rt(Tt.FORMAT_ERROR, "Error formatting list.", c));
  }
  return n;
}
var Q1 = ["type"];
function K1(e, t, n, r) {
  var a = e.locale,
    i = e.onError;
  r === void 0 && (r = {}), Intl.PluralRules || i(new Rn("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", en.MISSING_INTL_API));
  var o = Xn(r, Q1);
  try {
    return t(a, o).select(n);
  } catch (s) {
    i(new Uf("Error formatting plural.", a, s));
  }
  return "other";
}
var J1 = ["numeric", "style"];
function X1(e, t, n) {
  var r = e.locale,
    a = e.formats,
    i = e.onError;
  n === void 0 && (n = {});
  var o = n.format,
    s = !!o && zf(a, "relative", o, i) || {},
    u = Xn(n, J1, s);
  return t(r, u);
}
function Z1(e, t, n, r, a) {
  a === void 0 && (a = {}), r || (r = "second");
  var i = Intl.RelativeTimeFormat;
  i || e.onError(new Rn("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", en.MISSING_INTL_API));
  try {
    return X1(e, t, a).format(n, r);
  } catch (o) {
    e.onError(new Uf("Error formatting relative time.", e.locale, o));
  }
  return String(n);
}
var eN = ["style", "currency", "currencyDisplay", "unit", "unitDisplay", "useGrouping", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits",
// ES2020 NumberFormat
"compactDisplay", "currencyDisplay", "currencySign", "notation", "signDisplay", "unit", "unitDisplay", "numberingSystem"];
function Kb(e, t, n) {
  var r = e.locale,
    a = e.formats,
    i = e.onError;
  n === void 0 && (n = {});
  var o = n.format,
    s = o && zf(a, "number", o, i) || {},
    u = Xn(n, eN, s);
  return t(r, u);
}
function tN(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Kb(e, t, r).format(n);
  } catch (a) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting number.", a));
  }
  return String(n);
}
function nN(e, t, n, r) {
  r === void 0 && (r = {});
  try {
    return Kb(e, t, r).formatToParts(n);
  } catch (a) {
    e.onError(new Rt(Tt.FORMAT_ERROR, "Error formatting number.", a));
  }
  return [];
}
function rN(e) {
  var t = e ? e[Object.keys(e)[0]] : void 0;
  return typeof t == "string";
}
function aN(e) {
  e.onWarn && e.defaultRichTextElements && rN(e.messages || {}) && e.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function iN(e, t) {
  var n = L1(t),
    r = _P2(_P2({}, Wb), e),
    a = r.locale,
    i = r.defaultLocale,
    o = r.onError;
  return a ? !Intl.NumberFormat.supportedLocalesOf(a).length && o ? o(new Am('Missing locale data for locale: "'.concat(a, '" in Intl.NumberFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : !Intl.DateTimeFormat.supportedLocalesOf(a).length && o && o(new Am('Missing locale data for locale: "'.concat(a, '" in Intl.DateTimeFormat. Using default locale: "').concat(i, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details'))) : (o && o(new A1('"locale" was not configured, using "'.concat(i, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details'))), r.locale = r.defaultLocale || "en"), aN(r), _P2(_P2({}, r), {
    formatters: n,
    formatNumber: tN.bind(null, r, n.getNumberFormat),
    formatNumberToParts: nN.bind(null, r, n.getNumberFormat),
    formatRelativeTime: Z1.bind(null, r, n.getRelativeTimeFormat),
    formatDate: j1.bind(null, r, n.getDateTimeFormat),
    formatDateToParts: q1.bind(null, r, n.getDateTimeFormat),
    formatTime: B1.bind(null, r, n.getDateTimeFormat),
    formatDateTimeRange: V1.bind(null, r, n.getDateTimeFormat),
    formatTimeToParts: U1.bind(null, r, n.getDateTimeFormat),
    formatPlural: K1.bind(null, r, n.getPluralRules),
    // @ts-expect-error TODO: will get to this later
    formatMessage: gc.bind(null, r, n),
    // @ts-expect-error TODO: will get to this later
    $t: gc.bind(null, r, n),
    formatList: Y1.bind(null, r, n.getListFormat),
    formatListToParts: Qb.bind(null, r, n.getListFormat),
    formatDisplayName: H1.bind(null, r, n.getDisplayNames)
  });
}
function Jb(e) {
  kb(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var Xb = _P2(_P2({}, Wb), {
  textComponent: React__namespace.Fragment
});
function oN(e) {
  return function (t) {
    return e(React__namespace.Children.toArray(t));
  };
}
function bc(e, t) {
  if (e === t) return !0;
  if (!e || !t) return !1;
  var n = Object.keys(e),
    r = Object.keys(t),
    a = n.length;
  if (r.length !== a) return !1;
  for (var i = 0; i < a; i++) {
    var o = n[i];
    if (e[o] !== t[o] || !Object.prototype.hasOwnProperty.call(t, o)) return !1;
  }
  return !0;
}
var Hf = React__namespace.createContext(null);
Hf.Consumer;
var sN = Hf.Provider,
  uN = sN,
  lN = Hf;
function Wf() {
  var e = React__namespace.useContext(lN);
  return Jb(e), e;
}
var _c;
(function (e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(_c || (_c = {}));
var wc;
(function (e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(wc || (wc = {}));
function Zb(e) {
  var t = function t(n) {
    var r = Wf(),
      a = n.value,
      i = n.children,
      o = Mt(n, ["value", "children"]),
      s = typeof a == "string" ? new Date(a || 0) : a,
      u = e === "formatDate" ? r.formatDateToParts(s, o) : r.formatTimeToParts(s, o);
    return i(u);
  };
  return t.displayName = wc[e], t;
}
function Na(e) {
  var t = function t(n) {
    var r = Wf(),
      a = n.value,
      i = n.children,
      o = Mt(n, ["value", "children"]),
      s = r[e](a, o);
    if (typeof i == "function") return i(s);
    var u = r.textComponent || React__namespace.Fragment;
    return React__namespace.createElement(u, null, s);
  };
  return t.displayName = _c[e], t;
}
function Xs(e) {
  return {
    locale: e.locale,
    timeZone: e.timeZone,
    fallbackOnEmptyString: e.fallbackOnEmptyString,
    formats: e.formats,
    textComponent: e.textComponent,
    messages: e.messages,
    defaultLocale: e.defaultLocale,
    defaultFormats: e.defaultFormats,
    onError: e.onError,
    onWarn: e.onWarn,
    wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
    defaultRichTextElements: e.defaultRichTextElements
  };
}
function e_(e) {
  return e && Object.keys(e).reduce(function (t, n) {
    var r = e[n];
    return t[n] = zb(r) ? oN(r) : r, t;
  }, {});
}
var Lm = function Lm(e, t, n, r) {
    for (var a = [], i = 4; i < arguments.length; i++) a[i - 4] = arguments[i];
    var o = e_(r),
      s = gc.apply(void 0, xt([e, t, n, o], a, !1));
    return Array.isArray(s) ? React__namespace.Children.toArray(s) : s;
  },
  jm = function jm(e, t) {
    var n = e.defaultRichTextElements,
      r = Mt(e, ["defaultRichTextElements"]),
      a = e_(n),
      i = iN(_P2(_P2(_P2({}, Xb), r), {
        defaultRichTextElements: a
      }), t),
      o = {
        locale: i.locale,
        timeZone: i.timeZone,
        fallbackOnEmptyString: i.fallbackOnEmptyString,
        formats: i.formats,
        defaultLocale: i.defaultLocale,
        defaultFormats: i.defaultFormats,
        messages: i.messages,
        onError: i.onError,
        defaultRichTextElements: a
      };
    return _P2(_P2({}, i), {
      // @ts-expect-error fix this
      formatMessage: Lm.bind(null, o, i.formatters),
      // @ts-expect-error fix this
      $t: Lm.bind(null, o, i.formatters)
    });
  },
  cN = /** @class */
  function (e) {
    et(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.cache = Gb(), n.state = {
        cache: n.cache,
        intl: jm(Xs(n.props), n.cache),
        prevConfig: Xs(n.props)
      }, n;
    }
    return t.getDerivedStateFromProps = function (n, r) {
      var a = r.prevConfig,
        i = r.cache,
        o = Xs(n);
      return bc(a, o) ? null : {
        intl: jm(o, i),
        prevConfig: o
      };
    }, t.prototype.render = function () {
      return Jb(this.state.intl), React__namespace.createElement(uN, {
        value: this.state.intl
      }, this.props.children);
    }, t.displayName = "IntlProvider", t.defaultProps = Xb, t;
  }(React__namespace.PureComponent);
var fN = cN;
function dN(e, t) {
  var n = e.values,
    r = Mt(e, ["values"]),
    a = t.values,
    i = Mt(t, ["values"]);
  return bc(a, n) && bc(r, i);
}
function t_(e) {
  var t = Wf(),
    n = t.formatMessage,
    r = t.textComponent,
    a = r === void 0 ? React__namespace.Fragment : r,
    i = e.id,
    o = e.description,
    s = e.defaultMessage,
    u = e.values,
    l = e.children,
    c = e.tagName,
    f = c === void 0 ? a : c,
    h = e.ignoreTag,
    p = {
      id: i,
      description: o,
      defaultMessage: s
    },
    v = n(p, u, {
      ignoreTag: h
    });
  return typeof l == "function" ? l(Array.isArray(v) ? v : [v]) : f ? React__namespace.createElement(f, null, React__namespace.Children.toArray(v)) : React__namespace.createElement(React__namespace.Fragment, null, v);
}
t_.displayName = "FormattedMessage";
var n_ = React__namespace.memo(t_, dN);
n_.displayName = "MemoizedFormattedMessage";
var J = n_;
Na("formatDate");
Na("formatTime");
var Pn = Na("formatNumber");
Na("formatList");
Na("formatDisplayName");
Zb("formatDate");
Zb("formatTime");
function hN(_ref43) {
  var e = _ref43.filters,
    t = _ref43.onFilterChange,
    n = _ref43.PortalSite,
    r = _ref43.options;
  function a(f, h) {
    var p = e;
    p[f] = h, t(p);
  }
  var _React$useState270 = React.useState(!1),
    _React$useState271 = _slicedToArray2(_React$useState270, 2),
    i = _React$useState271[0],
    o = _React$useState271[1],
    s = r.searchFields || FS;
  var u = r.filtersForm && r.filtersForm.fixedMobile ? "fixed-mobile" : null,
    l = r.filtersForm ? r.filtersForm.show ? "filters filters-".concat(r.filtersForm.location) : "filters-hidden" : "filters",
    c = i && "showOnMobile";
  return /* @__PURE__ */F(vt, {
    children: [/* @__PURE__ */d("button", {
      className: "filters-button ".concat(u),
      onClick: function onClick() {
        return o(!i);
      },
      children: /* @__PURE__ */d(J, {
        id: "filters"
      })
    }), /* @__PURE__ */F("div", {
      className: "".concat(l, " ").concat(u, " ").concat(c),
      children: [/* @__PURE__ */d("button", {
        onClick: function onClick() {
          var f = {};
          for (var h in f) f[h] = "";
          t(f);
        },
        className: "filters-reload",
        children: /* @__PURE__ */d(Eb, {})
      }), s.map(function (f) {
        return /* @__PURE__ */F("div", {
          className: "bu-field",
          id: f.id,
          children: [/* @__PURE__ */d("label", {
            style: {
              width: "100%",
              display: "block"
            },
            htmlFor: f.id,
            children: n["".concat(f.id, "_label")]
          }), /* @__PURE__ */d(qR, {
            field: f,
            PortalSite: n,
            filters: e,
            value: e[f.id],
            onFilterChange: a
          })]
        }, f.id);
      })]
    })]
  });
}
function pN(_ref44) {
  var e = _ref44.result,
    t = _ref44.options;
  var n = t || {};
  return /* @__PURE__ */d("a", {
    className: "bukazu-result bu_card",
    href: e.house_url,
    children: /* @__PURE__ */F("div", {
      className: "bukazu-result-inner",
      children: [/* @__PURE__ */d("div", {
        className: "image-holder",
        children: /* @__PURE__ */d("img", {
          src: e.image_url,
          alt: e.name
        })
      }), /* @__PURE__ */F("div", {
        className: "result",
        children: [/* @__PURE__ */d("div", {
          className: "result-title",
          children: e.name
        }), /* @__PURE__ */F("div", {
          className: "result-place",
          children: [n.showCity && /* @__PURE__ */F("span", {
            children: [e.city, ", "]
          }), n.showRegion && /* @__PURE__ */F("span", {
            children: [e.province, ", "]
          }), n.showCountry && /* @__PURE__ */d("span", {
            children: e.country_name
          })]
        }), /* @__PURE__ */d("div", {
          className: "result-description",
          dangerouslySetInnerHTML: {
            __html: e.description
          }
        }), /* @__PURE__ */F("div", {
          className: "result-details",
          children: [n.showPersons && /* @__PURE__ */F("div", {
            children: [e.persons, " ", /* @__PURE__ */d(J, {
              id: "persons"
            })]
          }), n.showBedrooms && /* @__PURE__ */F("div", {
            children: [e.bedrooms, " ", /* @__PURE__ */d(J, {
              id: "bedrooms"
            })]
          }), n.showBathrooms && /* @__PURE__ */F("div", {
            children: [e.bathrooms, " ", /* @__PURE__ */d(J, {
              id: "bathrooms"
            })]
          })]
        }), n.showRating && e.rating && /* @__PURE__ */d("div", {
          className: "result-rating bu_card",
          children: /* @__PURE__ */d("div", {
            className: "result-rating-inner",
            children: e.rating.toFixed(1)
          })
        }), n.showPrice && /* @__PURE__ */d("div", {
          className: "result-price",
          children: e.booking_price ? /* @__PURE__ */F(vt, {
            children: [/* @__PURE__ */d(J, {
              id: "price_from"
            }), /* @__PURE__ */F("span", {
              className: "price",
              children: ["€", " ", /* @__PURE__ */d(Pn, {
                value: e.booking_price.total_price,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })]
            })]
          }) : /* @__PURE__ */F(vt, {
            children: [/* @__PURE__ */d(J, {
              id: "minimum_week_price"
            }), /* @__PURE__ */F("span", {
              className: "price",
              children: ["€", " ", /* @__PURE__ */d(Pn, {
                value: e.minimum_week_price,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })]
            })]
          })
        }), /* @__PURE__ */d("div", {
          className: "result-button",
          children: /* @__PURE__ */d(J, {
            id: "view_details"
          })
        })]
      })]
    })
  });
}
var mN = wt(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral2(["\n  query PortalSiteHousesQuery(\n    $id: ID!\n    $country_id: ID\n    $region_id: String\n    $city_id: String\n    $persons_min: Int\n    $persons_max: Int\n    $bedrooms_min: Int\n    $bathrooms_min: Int\n    $arrival_date: String\n    $no_nights: Int\n    $properties: String\n    $weekprice_max: Int\n    $limit: Int\n    $skip: Int\n  ) {\n    PortalSite(id: $id) {\n      id\n      houses(\n        country_id: $country_id\n        region_id: $region_id\n        city_id: $city_id\n        persons_min: $persons_min\n        persons_max: $persons_max\n        bedrooms_min: $bedrooms_min\n        bathrooms_min: $bathrooms_min\n        arrival_date: $arrival_date\n        weekprice_max: $weekprice_max\n        no_nights_min: $no_nights\n        properties: $properties\n        limit: $limit\n        skip: $skip\n      ) {\n        id\n        name\n        persons\n        bathrooms\n        bedrooms\n        description\n        image_url\n        house_url\n        province\n        city\n        country_name\n        minimum_week_price\n        rating\n        scoreAmount\n      }\n    }\n  }\n"]))),
  vN = wt(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral2(["\n  query PortalSiteHousesQuery(\n    $id: ID!\n    $country_id: ID\n    $region_id: String\n    $city_id: String\n    $persons_min: Int\n    $persons_max: Int\n    $bedrooms_min: Int\n    $bathrooms_min: Int\n    $arrival_date: String\n    $starts_at: Date!\n    $ends_at: Date!\n    $no_nights: Int\n    $properties: String\n    $weekprice_max: Int\n    $limit: Int\n    $skip: Int\n  ) {\n    PortalSite(id: $id) {\n      houses(\n        country_id: $country_id\n        region_id: $region_id\n        city_id: $city_id\n        persons_min: $persons_min\n        persons_max: $persons_max\n        bedrooms_min: $bedrooms_min\n        bathrooms_min: $bathrooms_min\n        arrival_date: $arrival_date\n        weekprice_max: $weekprice_max\n        no_nights_min: $no_nights\n        properties: $properties\n        limit: $limit\n        skip: $skip\n      ) {\n        id\n        name\n        persons\n        bathrooms\n        bedrooms\n        description\n        image_url\n        house_url\n        province\n        city\n        country_name\n        minimum_week_price\n        rating\n        score_amount\n        booking_price(starts_at: $starts_at, ends_at: $ends_at)\n      }\n    }\n  }\n"]))),
  yN = wt(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral2(["\n  query PortalSiteHouseCountQuery(\n    $id: ID!\n    $country_id: ID\n    $region_id: String\n    $city_id: String\n    $persons_min: Int\n    $persons_max: Int\n    $bedrooms_min: Int\n    $bathrooms_min: Int\n    $arrival_date: String\n    $no_nights: Int\n    $properties: String\n    $weekprice_max: Int\n  ) {\n    PortalSite(id: $id) {\n      id\n      houses(\n        country_id: $country_id\n        region_id: $region_id\n        city_id: $city_id\n        persons_min: $persons_min\n        persons_max: $persons_max\n        bedrooms_min: $bedrooms_min\n        bathrooms_min: $bathrooms_min\n        arrival_date: $arrival_date\n        weekprice_max: $weekprice_max\n        no_nights_min: $no_nights\n        properties: $properties\n      ) {\n        id\n      }\n    }\n  }\n"])));
var Oc = {},
  gN = {
    get exports() {
      return Oc;
    },
    set exports(e) {
      Oc = e;
    }
  };
(function (e, t) {
  (function (n, r) {
    e.exports = r(React__default["default"]);
  })(Hr, function (n) {
    return function () {
      var r = {
          703: function _(s, u, l) {
            var c = l(414);
            function f() {}
            function h() {}
            h.resetWarningCache = f, s.exports = function () {
              function p(g, b, y, E, w, _) {
                if (_ !== c) {
                  var C = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                  throw C.name = "Invariant Violation", C;
                }
              }
              function v() {
                return p;
              }
              p.isRequired = p;
              var m = {
                array: p,
                bigint: p,
                bool: p,
                func: p,
                number: p,
                object: p,
                string: p,
                symbol: p,
                any: p,
                arrayOf: v,
                element: p,
                elementType: p,
                instanceOf: v,
                node: p,
                objectOf: v,
                oneOf: v,
                oneOfType: v,
                shape: v,
                exact: v,
                checkPropTypes: h,
                resetWarningCache: f
              };
              return m.PropTypes = m, m;
            };
          },
          697: function _(s, u, l) {
            s.exports = l(703)();
          },
          414: function _(s) {
            s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
          },
          98: function _(s) {
            s.exports = n;
          }
        },
        a = {};
      function i(s) {
        var u = a[s];
        if (u !== void 0) return u.exports;
        var l = a[s] = {
          exports: {}
        };
        return r[s](l, l.exports, i), l.exports;
      }
      i.n = function (s) {
        var u = s && s.__esModule ? function () {
          return s.default;
        } : function () {
          return s;
        };
        return i.d(u, {
          a: u
        }), u;
      }, i.d = function (s, u) {
        for (var l in u) i.o(u, l) && !i.o(s, l) && Object.defineProperty(s, l, {
          enumerable: !0,
          get: u[l]
        });
      }, i.o = function (s, u) {
        return Object.prototype.hasOwnProperty.call(s, u);
      }, i.r = function (s) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(s, "__esModule", {
          value: !0
        });
      };
      var o = {};
      return function () {
        i.r(o), i.d(o, {
          default: function _default() {
            return ye;
          }
        });
        var s = i(98),
          u = i.n(s),
          l = i(697),
          c = i.n(l);
        function f() {
          return f = Object.assign ? Object.assign.bind() : function (Y) {
            for (var K = 1; K < arguments.length; K++) {
              var ee = arguments[K];
              for (var ne in ee) Object.prototype.hasOwnProperty.call(ee, ne) && (Y[ne] = ee[ne]);
            }
            return Y;
          }, f.apply(this, arguments);
        }
        var h = function h(Y) {
          var K = Y.pageClassName,
            ee = Y.pageLinkClassName,
            ne = Y.page,
            ie = Y.selected,
            fe = Y.activeClassName,
            ce = Y.activeLinkClassName,
            H = Y.getEventListener,
            O = Y.pageSelectedHandler,
            I = Y.href,
            B = Y.extraAriaContext,
            W = Y.pageLabelBuilder,
            G = Y.rel,
            ue = Y.ariaLabel || "Page " + ne + (B ? " " + B : ""),
            se = null;
          return ie && (se = "page", ue = Y.ariaLabel || "Page " + ne + " is your current page", K = K !== void 0 ? K + " " + fe : fe, ee !== void 0 ? ce !== void 0 && (ee = ee + " " + ce) : ee = ce), u().createElement("li", {
            className: K
          }, u().createElement("a", f({
            rel: G,
            role: I ? void 0 : "button",
            className: ee,
            href: I,
            tabIndex: ie ? "-1" : "0",
            "aria-label": ue,
            "aria-current": se,
            onKeyPress: O
          }, H(O)), W(ne)));
        };
        h.propTypes = {
          pageSelectedHandler: c().func.isRequired,
          selected: c().bool.isRequired,
          pageClassName: c().string,
          pageLinkClassName: c().string,
          activeClassName: c().string,
          activeLinkClassName: c().string,
          extraAriaContext: c().string,
          href: c().string,
          ariaLabel: c().string,
          page: c().number.isRequired,
          getEventListener: c().func.isRequired,
          pageLabelBuilder: c().func.isRequired,
          rel: c().string
        };
        var p = h;
        function v() {
          return v = Object.assign ? Object.assign.bind() : function (Y) {
            for (var K = 1; K < arguments.length; K++) {
              var ee = arguments[K];
              for (var ne in ee) Object.prototype.hasOwnProperty.call(ee, ne) && (Y[ne] = ee[ne]);
            }
            return Y;
          }, v.apply(this, arguments);
        }
        var m = function m(Y) {
          var K = Y.breakLabel,
            ee = Y.breakClassName,
            ne = Y.breakLinkClassName,
            ie = Y.breakHandler,
            fe = Y.getEventListener,
            ce = ee || "break";
          return u().createElement("li", {
            className: ce
          }, u().createElement("a", v({
            className: ne,
            role: "button",
            tabIndex: "0",
            onKeyPress: ie
          }, fe(ie)), K));
        };
        m.propTypes = {
          breakLabel: c().oneOfType([c().string, c().node]),
          breakClassName: c().string,
          breakLinkClassName: c().string,
          breakHandler: c().func.isRequired,
          getEventListener: c().func.isRequired
        };
        var g = m;
        function b(Y) {
          var K = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
          return Y !== null && Y !== void 0 ? Y : K;
        }
        function y(Y) {
          return y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (K) {
            return typeof K;
          } : function (K) {
            return K && typeof Symbol == "function" && K.constructor === Symbol && K !== Symbol.prototype ? "symbol" : typeof K;
          }, y(Y);
        }
        function E() {
          return E = Object.assign ? Object.assign.bind() : function (Y) {
            for (var K = 1; K < arguments.length; K++) {
              var ee = arguments[K];
              for (var ne in ee) Object.prototype.hasOwnProperty.call(ee, ne) && (Y[ne] = ee[ne]);
            }
            return Y;
          }, E.apply(this, arguments);
        }
        function w(Y, K) {
          for (var ee = 0; ee < K.length; ee++) {
            var ne = K[ee];
            ne.enumerable = ne.enumerable || !1, ne.configurable = !0, "value" in ne && (ne.writable = !0), Object.defineProperty(Y, ne.key, ne);
          }
        }
        function _(Y, K) {
          return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (ee, ne) {
            return ee.__proto__ = ne, ee;
          }, _(Y, K);
        }
        function C(Y, K) {
          if (K && (y(K) === "object" || typeof K == "function")) return K;
          if (K !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
          return D(Y);
        }
        function D(Y) {
          if (Y === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return Y;
        }
        function U(Y) {
          return U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (K) {
            return K.__proto__ || Object.getPrototypeOf(K);
          }, U(Y);
        }
        function Z(Y, K, ee) {
          return K in Y ? Object.defineProperty(Y, K, {
            value: ee,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : Y[K] = ee, Y;
        }
        var me = function (Y) {
          (function (H, O) {
            if (typeof O != "function" && O !== null) throw new TypeError("Super expression must either be null or a function");
            H.prototype = Object.create(O && O.prototype, {
              constructor: {
                value: H,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(H, "prototype", {
              writable: !1
            }), O && _(H, O);
          })(ce, Y);
          var K,
            ee,
            ne,
            ie,
            fe = (ne = ce, ie = function () {
              if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
              if (typeof Proxy == "function") return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (_unused57) {
                return !1;
              }
            }(), function () {
              var H,
                O = U(ne);
              if (ie) {
                var I = U(this).constructor;
                H = Reflect.construct(O, arguments, I);
              } else H = O.apply(this, arguments);
              return C(this, H);
            });
          function ce(H) {
            var O, I;
            return function (B, W) {
              if (!(B instanceof W)) throw new TypeError("Cannot call a class as a function");
            }(this, ce), Z(D(O = fe.call(this, H)), "handlePreviousPage", function (B) {
              var W = O.state.selected;
              O.handleClick(B, null, W > 0 ? W - 1 : void 0, {
                isPrevious: !0
              });
            }), Z(D(O), "handleNextPage", function (B) {
              var W = O.state.selected,
                G = O.props.pageCount;
              O.handleClick(B, null, W < G - 1 ? W + 1 : void 0, {
                isNext: !0
              });
            }), Z(D(O), "handlePageSelected", function (B, W) {
              if (O.state.selected === B) return O.callActiveCallback(B), void O.handleClick(W, null, void 0, {
                isActive: !0
              });
              O.handleClick(W, null, B);
            }), Z(D(O), "handlePageChange", function (B) {
              O.state.selected !== B && (O.setState({
                selected: B
              }), O.callCallback(B));
            }), Z(D(O), "getEventListener", function (B) {
              return Z({}, O.props.eventListener, B);
            }), Z(D(O), "handleClick", function (B, W, G) {
              var ue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {},
                se = ue.isPrevious,
                x = se !== void 0 && se,
                A = ue.isNext,
                M = A !== void 0 && A,
                N = ue.isBreak,
                Q = N !== void 0 && N,
                L = ue.isActive,
                ve = L !== void 0 && L;
              B.preventDefault ? B.preventDefault() : B.returnValue = !1;
              var re = O.state.selected,
                _e = O.props.onClick,
                xe = G;
              if (_e) {
                var Ee = _e({
                  index: W,
                  selected: re,
                  nextSelectedPage: G,
                  event: B,
                  isPrevious: x,
                  isNext: M,
                  isBreak: Q,
                  isActive: ve
                });
                if (Ee === !1) return;
                Number.isInteger(Ee) && (xe = Ee);
              }
              xe !== void 0 && O.handlePageChange(xe);
            }), Z(D(O), "handleBreakClick", function (B, W) {
              var G = O.state.selected;
              O.handleClick(W, B, G < B ? O.getForwardJump() : O.getBackwardJump(), {
                isBreak: !0
              });
            }), Z(D(O), "callCallback", function (B) {
              O.props.onPageChange !== void 0 && typeof O.props.onPageChange == "function" && O.props.onPageChange({
                selected: B
              });
            }), Z(D(O), "callActiveCallback", function (B) {
              O.props.onPageActive !== void 0 && typeof O.props.onPageActive == "function" && O.props.onPageActive({
                selected: B
              });
            }), Z(D(O), "getElementPageRel", function (B) {
              var W = O.state.selected,
                G = O.props,
                ue = G.nextPageRel,
                se = G.prevPageRel,
                x = G.selectedPageRel;
              return W - 1 === B ? se : W === B ? x : W + 1 === B ? ue : void 0;
            }), Z(D(O), "pagination", function () {
              var B = [],
                W = O.props,
                G = W.pageRangeDisplayed,
                ue = W.pageCount,
                se = W.marginPagesDisplayed,
                x = W.breakLabel,
                A = W.breakClassName,
                M = W.breakLinkClassName,
                N = O.state.selected;
              if (ue <= G) for (var Q = 0; Q < ue; Q++) B.push(O.getPageElement(Q));else {
                var L = G / 2,
                  ve = G - L;
                N > ue - G / 2 ? L = G - (ve = ue - N) : N < G / 2 && (ve = G - (L = N));
                var re,
                  _e,
                  xe = function xe(nt) {
                    return O.getPageElement(nt);
                  },
                  Ee = [];
                for (re = 0; re < ue; re++) {
                  var tt = re + 1;
                  tt <= se || tt > ue - se || re >= N - L && re <= N + (N === 0 && G > 1 ? ve - 1 : ve) ? Ee.push({
                    type: "page",
                    index: re,
                    display: xe(re)
                  }) : x && Ee.length > 0 && Ee[Ee.length - 1].display !== _e && (G > 0 || se > 0) && (_e = u().createElement(g, {
                    key: re,
                    breakLabel: x,
                    breakClassName: A,
                    breakLinkClassName: M,
                    breakHandler: O.handleBreakClick.bind(null, re),
                    getEventListener: O.getEventListener
                  }), Ee.push({
                    type: "break",
                    index: re,
                    display: _e
                  }));
                }
                Ee.forEach(function (nt, $) {
                  var oe = nt;
                  nt.type === "break" && Ee[$ - 1] && Ee[$ - 1].type === "page" && Ee[$ + 1] && Ee[$ + 1].type === "page" && Ee[$ + 1].index - Ee[$ - 1].index <= 2 && (oe = {
                    type: "page",
                    index: nt.index,
                    display: xe(nt.index)
                  }), B.push(oe.display);
                });
              }
              return B;
            }), H.initialPage !== void 0 && H.forcePage !== void 0 && console.warn("(react-paginate): Both initialPage (".concat(H.initialPage, ") and forcePage (").concat(H.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), I = H.initialPage ? H.initialPage : H.forcePage ? H.forcePage : 0, O.state = {
              selected: I
            }, O;
          }
          return K = ce, (ee = [{
            key: "componentDidMount",
            value: function value() {
              var H = this.props,
                O = H.initialPage,
                I = H.disableInitialCallback,
                B = H.extraAriaContext,
                W = H.pageCount,
                G = H.forcePage;
              O === void 0 || I || this.callCallback(O), B && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(W) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(W, "). Did you forget a Math.ceil()?")), O !== void 0 && O > W - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(O, " > ").concat(W - 1, ").")), G !== void 0 && G > W - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(G, " > ").concat(W - 1, ")."));
            }
          }, {
            key: "componentDidUpdate",
            value: function value(H) {
              this.props.forcePage !== void 0 && this.props.forcePage !== H.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                selected: this.props.forcePage
              })), Number.isInteger(H.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
            }
          }, {
            key: "getForwardJump",
            value: function value() {
              var H = this.state.selected,
                O = this.props,
                I = O.pageCount,
                B = H + O.pageRangeDisplayed;
              return B >= I ? I - 1 : B;
            }
          }, {
            key: "getBackwardJump",
            value: function value() {
              var H = this.state.selected - this.props.pageRangeDisplayed;
              return H < 0 ? 0 : H;
            }
          }, {
            key: "getElementHref",
            value: function value(H) {
              var O = this.props,
                I = O.hrefBuilder,
                B = O.pageCount,
                W = O.hrefAllControls;
              if (I) return W || H >= 0 && H < B ? I(H + 1, B, this.state.selected) : void 0;
            }
          }, {
            key: "ariaLabelBuilder",
            value: function value(H) {
              var O = H === this.state.selected;
              if (this.props.ariaLabelBuilder && H >= 0 && H < this.props.pageCount) {
                var I = this.props.ariaLabelBuilder(H + 1, O);
                return this.props.extraAriaContext && !O && (I = I + " " + this.props.extraAriaContext), I;
              }
            }
          }, {
            key: "getPageElement",
            value: function value(H) {
              var O = this.state.selected,
                I = this.props,
                B = I.pageClassName,
                W = I.pageLinkClassName,
                G = I.activeClassName,
                ue = I.activeLinkClassName,
                se = I.extraAriaContext,
                x = I.pageLabelBuilder;
              return u().createElement(p, {
                key: H,
                pageSelectedHandler: this.handlePageSelected.bind(null, H),
                selected: O === H,
                rel: this.getElementPageRel(H),
                pageClassName: B,
                pageLinkClassName: W,
                activeClassName: G,
                activeLinkClassName: ue,
                extraAriaContext: se,
                href: this.getElementHref(H),
                ariaLabel: this.ariaLabelBuilder(H),
                page: H + 1,
                pageLabelBuilder: x,
                getEventListener: this.getEventListener
              });
            }
          }, {
            key: "render",
            value: function value() {
              var H = this.props.renderOnZeroPageCount;
              if (this.props.pageCount === 0 && H !== void 0) return H && H(this.props);
              var O = this.props,
                I = O.disabledClassName,
                B = O.disabledLinkClassName,
                W = O.pageCount,
                G = O.className,
                ue = O.containerClassName,
                se = O.previousLabel,
                x = O.previousClassName,
                A = O.previousLinkClassName,
                M = O.previousAriaLabel,
                N = O.prevRel,
                Q = O.nextLabel,
                L = O.nextClassName,
                ve = O.nextLinkClassName,
                re = O.nextAriaLabel,
                _e = O.nextRel,
                xe = this.state.selected,
                Ee = xe === 0,
                tt = xe === W - 1,
                nt = "".concat(b(x)).concat(Ee ? " ".concat(b(I)) : ""),
                $ = "".concat(b(L)).concat(tt ? " ".concat(b(I)) : ""),
                oe = "".concat(b(A)).concat(Ee ? " ".concat(b(B)) : ""),
                T = "".concat(b(ve)).concat(tt ? " ".concat(b(B)) : ""),
                R = Ee ? "true" : "false",
                z = tt ? "true" : "false";
              return u().createElement("ul", {
                className: G || ue,
                role: "navigation",
                "aria-label": "Pagination"
              }, u().createElement("li", {
                className: nt
              }, u().createElement("a", E({
                className: oe,
                href: this.getElementHref(xe - 1),
                tabIndex: Ee ? "-1" : "0",
                role: "button",
                onKeyPress: this.handlePreviousPage,
                "aria-disabled": R,
                "aria-label": M,
                rel: N
              }, this.getEventListener(this.handlePreviousPage)), se)), this.pagination(), u().createElement("li", {
                className: $
              }, u().createElement("a", E({
                className: T,
                href: this.getElementHref(xe + 1),
                tabIndex: tt ? "-1" : "0",
                role: "button",
                onKeyPress: this.handleNextPage,
                "aria-disabled": z,
                "aria-label": re,
                rel: _e
              }, this.getEventListener(this.handleNextPage)), Q)));
            }
          }]) && w(K.prototype, ee), Object.defineProperty(K, "prototype", {
            writable: !1
          }), ce;
        }(s.Component);
        Z(me, "propTypes", {
          pageCount: c().number.isRequired,
          pageRangeDisplayed: c().number,
          marginPagesDisplayed: c().number,
          previousLabel: c().node,
          previousAriaLabel: c().string,
          prevPageRel: c().string,
          prevRel: c().string,
          nextLabel: c().node,
          nextAriaLabel: c().string,
          nextPageRel: c().string,
          nextRel: c().string,
          breakLabel: c().oneOfType([c().string, c().node]),
          hrefBuilder: c().func,
          hrefAllControls: c().bool,
          onPageChange: c().func,
          onPageActive: c().func,
          onClick: c().func,
          initialPage: c().number,
          forcePage: c().number,
          disableInitialCallback: c().bool,
          containerClassName: c().string,
          className: c().string,
          pageClassName: c().string,
          pageLinkClassName: c().string,
          pageLabelBuilder: c().func,
          activeClassName: c().string,
          activeLinkClassName: c().string,
          previousClassName: c().string,
          nextClassName: c().string,
          previousLinkClassName: c().string,
          nextLinkClassName: c().string,
          disabledClassName: c().string,
          disabledLinkClassName: c().string,
          breakClassName: c().string,
          breakLinkClassName: c().string,
          extraAriaContext: c().string,
          ariaLabelBuilder: c().func,
          eventListener: c().string,
          renderOnZeroPageCount: c().func,
          selectedPageRel: c().string
        }), Z(me, "defaultProps", {
          pageRangeDisplayed: 2,
          marginPagesDisplayed: 3,
          activeClassName: "selected",
          previousLabel: "Previous",
          previousClassName: "previous",
          previousAriaLabel: "Previous page",
          prevPageRel: "prev",
          prevRel: "prev",
          nextLabel: "Next",
          nextClassName: "next",
          nextAriaLabel: "Next page",
          nextPageRel: "next",
          nextRel: "next",
          breakLabel: "...",
          disabledClassName: "disabled",
          disableInitialCallback: !1,
          pageLabelBuilder: function pageLabelBuilder(Y) {
            return Y;
          },
          eventListener: "onClick",
          renderOnZeroPageCount: void 0,
          selectedPageRel: "canonical",
          hrefAllControls: !1
        });
        var ye = me;
      }(), o;
    }();
  });
})(gN);
var bN = /* @__PURE__ */Pv(Oc);
function _N(_ref45) {
  var e = _ref45.onPageChange,
    t = _ref45.variables,
    n = _ref45.activePage,
    r = _ref45.limit;
  var _ln = ln(yN, {
      variables: t
    }),
    a = _ln.loading,
    i = _ln.error,
    o = _ln.data;
  if (a) return /* @__PURE__ */d("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    },
    children: /* @__PURE__ */d(Dn, {})
  });
  if (i) return /* @__PURE__ */d("div", {
    children: "Error"
  });
  var s = o.PortalSite.houses,
    u = Math.ceil(s.length / r);
  return /* @__PURE__ */F("div", {
    className: "bu-paginator",
    children: [/* @__PURE__ */F("div", {
      children: [s.length, " ", /* @__PURE__ */d(J, {
        id: "results"
      })]
    }), /* @__PURE__ */d(bN, {
      pageCount: u,
      onPageChange: function onPageChange(_ref46) {
        var l = _ref46.selected;
        e(l);
      },
      forcePage: n,
      pageRangeDisplayed: 5,
      breakLabel: "...",
      className: "bu-pagination",
      nextLabel: ">",
      previousLabel: "<"
    })]
  });
}
function on(_ref47) {
  var e = _ref47.children,
    t = _ref47.buttonText;
  var _React$useState272 = React.useState(!1),
    _React$useState273 = _slicedToArray2(_React$useState272, 2),
    n = _React$useState273[0],
    r = _React$useState273[1];
  return n ? /* @__PURE__ */d("div", {
    className: "bukazu-modal-container",
    children: /* @__PURE__ */F("div", {
      className: "bukazu-modal-container-inner",
      children: [/* @__PURE__ */d("div", {
        className: "bukazu-modal-escape",
        onClick: function onClick() {
          return r(!1);
        }
      }), /* @__PURE__ */F("div", {
        className: "bukazu-modal",
        children: [/* @__PURE__ */d("div", {
          className: "bukazu-modal-content",
          children: e
        }), /* @__PURE__ */d("div", {
          className: "bukazu-modal-footer",
          children: /* @__PURE__ */d("a", {
            onClick: function onClick() {
              return r(!1);
            },
            children: /* @__PURE__ */d(J, {
              id: "close"
            })
          })
        })]
      })]
    })
  }) : /* @__PURE__ */d("a", {
    className: "info-button",
    onClick: function onClick() {
      return r(!0);
    },
    children: t
  });
}
on.defaultProps = {
  show: !1
};
function Zn(e, t) {
  var n = /* @__PURE__ */F("div", {
    className: "bukazu-error-message",
    children: [/* @__PURE__ */d("h2", {
      children: /* @__PURE__ */d(J, {
        id: "something_went_wrong_please_try_again"
      })
    }), /* @__PURE__ */d("ul", {
      children: e.errors.graphQLErrors.map(function (r) {
        return /* @__PURE__ */d("li", {
          children: r.message
        }, r.message);
      })
    })]
  });
  return t == !0 ? /* @__PURE__ */d(on, {
    show: !0,
    children: n
  }) : n;
}
Zn.defaultProps = {
  modal: !1
};
function wN(_ref48) {
  var e = _ref48.portalCode,
    t = _ref48.pageType,
    n = _ref48.locale,
    r = _ref48.filters;
  var a = [];
  if (!e) {
    var i = "No portal code is specified, so portal is not working";
    console.error(i), a.push(i);
  }
  if (t && t !== "reviews") {
    var _i3 = "'".concat(t, "' is not a valid page");
    console.error(_i3), a.push(_i3);
  }
  return n ? ["nl", "de", "en", "fr", "it", "es"].includes(n) || a.push("Invalid locale") : console.warn("No locale is set default to English"), r && !ON(r) && console.error("Filters variable is not an object", r), a.length == 0 ? !1 : /* @__PURE__ */F("div", {
    children: [/* @__PURE__ */d("h2", {
      children: "Something went wrong please try again "
    }), /* @__PURE__ */d("ul", {
      children: a.map(function (i) {
        return /* @__PURE__ */d("li", {
          children: i
        });
      })
    })]
  });
}
var ON = function ON(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
};
function Bm(e, t, n) {
  De(2, arguments);
  var r = un(e, n),
    a = un(t, n);
  return r.getTime() === a.getTime();
}
var Vm = {
    lessThanXSeconds: {
      standalone: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      },
      withPreposition: {
        one: "weniger als 1 Sekunde",
        other: "weniger als {{count}} Sekunden"
      }
    },
    xSeconds: {
      standalone: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      },
      withPreposition: {
        one: "1 Sekunde",
        other: "{{count}} Sekunden"
      }
    },
    halfAMinute: {
      standalone: "halbe Minute",
      withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
      standalone: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      },
      withPreposition: {
        one: "weniger als 1 Minute",
        other: "weniger als {{count}} Minuten"
      }
    },
    xMinutes: {
      standalone: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      },
      withPreposition: {
        one: "1 Minute",
        other: "{{count}} Minuten"
      }
    },
    aboutXHours: {
      standalone: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      },
      withPreposition: {
        one: "etwa 1 Stunde",
        other: "etwa {{count}} Stunden"
      }
    },
    xHours: {
      standalone: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      },
      withPreposition: {
        one: "1 Stunde",
        other: "{{count}} Stunden"
      }
    },
    xDays: {
      standalone: {
        one: "1 Tag",
        other: "{{count}} Tage"
      },
      withPreposition: {
        one: "1 Tag",
        other: "{{count}} Tagen"
      }
    },
    aboutXWeeks: {
      standalone: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      },
      withPreposition: {
        one: "etwa 1 Woche",
        other: "etwa {{count}} Wochen"
      }
    },
    xWeeks: {
      standalone: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      },
      withPreposition: {
        one: "1 Woche",
        other: "{{count}} Wochen"
      }
    },
    aboutXMonths: {
      standalone: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monate"
      },
      withPreposition: {
        one: "etwa 1 Monat",
        other: "etwa {{count}} Monaten"
      }
    },
    xMonths: {
      standalone: {
        one: "1 Monat",
        other: "{{count}} Monate"
      },
      withPreposition: {
        one: "1 Monat",
        other: "{{count}} Monaten"
      }
    },
    aboutXYears: {
      standalone: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahre"
      },
      withPreposition: {
        one: "etwa 1 Jahr",
        other: "etwa {{count}} Jahren"
      }
    },
    xYears: {
      standalone: {
        one: "1 Jahr",
        other: "{{count}} Jahre"
      },
      withPreposition: {
        one: "1 Jahr",
        other: "{{count}} Jahren"
      }
    },
    overXYears: {
      standalone: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahre"
      },
      withPreposition: {
        one: "mehr als 1 Jahr",
        other: "mehr als {{count}} Jahren"
      }
    },
    almostXYears: {
      standalone: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahre"
      },
      withPreposition: {
        one: "fast 1 Jahr",
        other: "fast {{count}} Jahren"
      }
    }
  },
  SN = function SN(t, n, r) {
    var a,
      i = r != null && r.addSuffix ? Vm[t].withPreposition : Vm[t].standalone;
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + a : "vor " + a : a;
  };
var EN = SN;
var PN = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y"
    // 07.01.2018
  },
  TN = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  kN = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  },
  DN = {
    date: dt({
      formats: PN,
      defaultWidth: "full"
    }),
    time: dt({
      formats: TN,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: kN,
      defaultWidth: "full"
    })
  };
var xN = DN;
var $N = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
  },
  CN = function CN(t, n, r, a) {
    return $N[t];
  };
var RN = CN;
var NN = {
    narrow: ["v.Chr.", "n.Chr."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["vor Christus", "nach Christus"]
  },
  AN = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
  },
  Sc = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
  },
  IN = {
    narrow: Sc.narrow,
    abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
    wide: Sc.wide
  },
  MN = {
    narrow: ["S", "M", "D", "M", "D", "F", "S"],
    short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
    wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
  },
  FN = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachm.",
      evening: "Abend",
      night: "Nacht"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "Morgen",
      afternoon: "Nachmittag",
      evening: "Abend",
      night: "Nacht"
    }
  },
  LN = {
    narrow: {
      am: "vm.",
      pm: "nm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachm.",
      evening: "abends",
      night: "nachts"
    },
    abbreviated: {
      am: "vorm.",
      pm: "nachm.",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    },
    wide: {
      am: "vormittags",
      pm: "nachmittags",
      midnight: "Mitternacht",
      noon: "Mittag",
      morning: "morgens",
      afternoon: "nachmittags",
      evening: "abends",
      night: "nachts"
    }
  },
  jN = function jN(t) {
    var n = Number(t);
    return n + ".";
  },
  BN = {
    ordinalNumber: jN,
    era: Fe({
      values: NN,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: AN,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Fe({
      values: Sc,
      formattingValues: IN,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: MN,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: FN,
      defaultWidth: "wide",
      formattingValues: LN,
      defaultFormattingWidth: "wide"
    })
  };
var VN = BN;
var qN = /^(\d+)(\.)?/i,
  UN = /\d+/i,
  zN = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
  },
  HN = {
    any: [/^v/i, /^n/i]
  },
  WN = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
  },
  GN = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  YN = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
  },
  QN = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  KN = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
  },
  JN = {
    any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
  },
  XN = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
  },
  ZN = {
    any: {
      am: /^v/i,
      pm: /^n/i,
      midnight: /^Mitte/i,
      noon: /^Mitta/i,
      morning: /morgens/i,
      afternoon: /nachmittags/i,
      // will never be matched. Afternoon is matched by `pm`
      evening: /abends/i,
      night: /nachts/i
      // will never be matched. Night is matched by `pm`
    }
  },
  eA = {
    ordinalNumber: Dr({
      matchPattern: qN,
      parsePattern: UN,
      valueCallback: function valueCallback(t) {
        return parseInt(t);
      }
    }),
    era: Le({
      matchPatterns: zN,
      defaultMatchWidth: "wide",
      parsePatterns: HN,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: WN,
      defaultMatchWidth: "wide",
      parsePatterns: GN,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: YN,
      defaultMatchWidth: "wide",
      parsePatterns: QN,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: KN,
      defaultMatchWidth: "wide",
      parsePatterns: JN,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: XN,
      defaultMatchWidth: "wide",
      parsePatterns: ZN,
      defaultParseWidth: "any"
    })
  };
var tA = eA;
var nA = {
  code: "de",
  formatDistance: EN,
  formatLong: xN,
  formatRelative: RN,
  localize: VN,
  match: tA,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var rA = nA;
var aA = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
  },
  iA = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  oA = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  sA = {
    date: dt({
      formats: aA,
      defaultWidth: "full"
    }),
    time: dt({
      formats: iA,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: oA,
      defaultWidth: "full"
    })
  };
var uA = sA;
var lA = {
  code: "en-GB",
  formatDistance: My,
  formatLong: uA,
  formatRelative: Fy,
  localize: Ly,
  match: jy,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var cA = lA;
var fA = {
    lessThanXSeconds: {
      one: "menos de un segundo",
      other: "menos de {{count}} segundos"
    },
    xSeconds: {
      one: "1 segundo",
      other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
      one: "menos de un minuto",
      other: "menos de {{count}} minutos"
    },
    xMinutes: {
      one: "1 minuto",
      other: "{{count}} minutos"
    },
    aboutXHours: {
      one: "alrededor de 1 hora",
      other: "alrededor de {{count}} horas"
    },
    xHours: {
      one: "1 hora",
      other: "{{count}} horas"
    },
    xDays: {
      one: "1 día",
      other: "{{count}} días"
    },
    aboutXWeeks: {
      one: "alrededor de 1 semana",
      other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
      one: "1 semana",
      other: "{{count}} semanas"
    },
    aboutXMonths: {
      one: "alrededor de 1 mes",
      other: "alrededor de {{count}} meses"
    },
    xMonths: {
      one: "1 mes",
      other: "{{count}} meses"
    },
    aboutXYears: {
      one: "alrededor de 1 año",
      other: "alrededor de {{count}} años"
    },
    xYears: {
      one: "1 año",
      other: "{{count}} años"
    },
    overXYears: {
      one: "más de 1 año",
      other: "más de {{count}} años"
    },
    almostXYears: {
      one: "casi 1 año",
      other: "casi {{count}} años"
    }
  },
  dA = function dA(t, n, r) {
    var a,
      i = fA[t];
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "en " + a : "hace " + a : a;
  };
var hA = dA;
var pA = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
  },
  mA = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  vA = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  yA = {
    date: dt({
      formats: pA,
      defaultWidth: "full"
    }),
    time: dt({
      formats: mA,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: vA,
      defaultWidth: "full"
    })
  };
var gA = yA;
var bA = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'mañana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
  },
  _A = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'mañana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
  },
  wA = function wA(t, n, r, a) {
    return n.getUTCHours() !== 1 ? _A[t] : bA[t];
  };
var OA = wA;
var SA = {
    narrow: ["AC", "DC"],
    abbreviated: ["AC", "DC"],
    wide: ["antes de cristo", "después de cristo"]
  },
  EA = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  },
  PA = {
    narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
    abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
  },
  TA = {
    narrow: ["d", "l", "m", "m", "j", "v", "s"],
    short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
    abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    wide: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"]
  },
  kA = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "mañana",
      afternoon: "tarde",
      evening: "tarde",
      night: "noche"
    }
  },
  DA = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mn",
      noon: "md",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "medianoche",
      noon: "mediodia",
      morning: "de la mañana",
      afternoon: "de la tarde",
      evening: "de la tarde",
      night: "de la noche"
    }
  },
  xA = function xA(t, n) {
    var r = Number(t);
    return r + "º";
  },
  $A = {
    ordinalNumber: xA,
    era: Fe({
      values: SA,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: EA,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return Number(t) - 1;
      }
    }),
    month: Fe({
      values: PA,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: TA,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: kA,
      defaultWidth: "wide",
      formattingValues: DA,
      defaultFormattingWidth: "wide"
    })
  };
var CA = $A;
var RA = /^(\d+)(º)?/i,
  NA = /\d+/i,
  AA = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
  },
  IA = {
    any: [/^ac/i, /^dc/i],
    wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
  },
  MA = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
  },
  FA = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  LA = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
  },
  jA = {
    narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
  },
  BA = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
  },
  VA = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
  },
  qA = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
  },
  UA = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mn/i,
      noon: /^md/i,
      morning: /mañana/i,
      afternoon: /tarde/i,
      evening: /tarde/i,
      night: /noche/i
    }
  },
  zA = {
    ordinalNumber: Dr({
      matchPattern: RA,
      parsePattern: NA,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }),
    era: Le({
      matchPatterns: AA,
      defaultMatchWidth: "wide",
      parsePatterns: IA,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: MA,
      defaultMatchWidth: "wide",
      parsePatterns: FA,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: LA,
      defaultMatchWidth: "wide",
      parsePatterns: jA,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: BA,
      defaultMatchWidth: "wide",
      parsePatterns: VA,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: qA,
      defaultMatchWidth: "any",
      parsePatterns: UA,
      defaultParseWidth: "any"
    })
  };
var HA = zA;
var WA = {
  code: "es",
  formatDistance: hA,
  formatLong: gA,
  formatRelative: OA,
  localize: CA,
  match: HA,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var GA = WA;
var YA = {
    lessThanXSeconds: {
      one: "moins d’une seconde",
      other: "moins de {{count}} secondes"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
      one: "moins d’une minute",
      other: "moins de {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "environ 1 heure",
      other: "environ {{count}} heures"
    },
    xHours: {
      one: "1 heure",
      other: "{{count}} heures"
    },
    xDays: {
      one: "1 jour",
      other: "{{count}} jours"
    },
    aboutXWeeks: {
      one: "environ 1 semaine",
      other: "environ {{count}} semaines"
    },
    xWeeks: {
      one: "1 semaine",
      other: "{{count}} semaines"
    },
    aboutXMonths: {
      one: "environ 1 mois",
      other: "environ {{count}} mois"
    },
    xMonths: {
      one: "1 mois",
      other: "{{count}} mois"
    },
    aboutXYears: {
      one: "environ 1 an",
      other: "environ {{count}} ans"
    },
    xYears: {
      one: "1 an",
      other: "{{count}} ans"
    },
    overXYears: {
      one: "plus d’un an",
      other: "plus de {{count}} ans"
    },
    almostXYears: {
      one: "presqu’un an",
      other: "presque {{count}} ans"
    }
  },
  QA = function QA(t, n, r) {
    var a,
      i = YA[t];
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + a : "il y a " + a : a;
  };
var KA = QA;
var JA = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  },
  XA = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  ZA = {
    full: "{{date}} 'à' {{time}}",
    long: "{{date}} 'à' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  eI = {
    date: dt({
      formats: JA,
      defaultWidth: "full"
    }),
    time: dt({
      formats: XA,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: ZA,
      defaultWidth: "full"
    })
  };
var tI = eI;
var nI = {
    lastWeek: "eeee 'dernier à' p",
    yesterday: "'hier à' p",
    today: "'aujourd’hui à' p",
    tomorrow: "'demain à' p'",
    nextWeek: "eeee 'prochain à' p",
    other: "P"
  },
  rI = function rI(t, n, r, a) {
    return nI[t];
  };
var aI = rI;
var iI = {
    narrow: ["av. J.-C", "ap. J.-C"],
    abbreviated: ["av. J.-C", "ap. J.-C"],
    wide: ["avant Jésus-Christ", "après Jésus-Christ"]
  },
  oI = {
    narrow: ["T1", "T2", "T3", "T4"],
    abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
    wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
  },
  sI = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
    wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  },
  uI = {
    narrow: ["D", "L", "M", "M", "J", "V", "S"],
    short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
    abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
    wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
  },
  lI = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "mat.",
      afternoon: "ap.m.",
      evening: "soir",
      night: "mat."
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "matin",
      afternoon: "après-midi",
      evening: "soir",
      night: "matin"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "minuit",
      noon: "midi",
      morning: "du matin",
      afternoon: "de l’après-midi",
      evening: "du soir",
      night: "du matin"
    }
  },
  cI = function cI(t, n) {
    var r = Number(t),
      a = n == null ? void 0 : n.unit;
    if (r === 0) return "0";
    var i = ["year", "week", "hour", "minute", "second"],
      o;
    return r === 1 ? o = a && i.includes(a) ? "ère" : "er" : o = "ème", r + o;
  },
  fI = {
    ordinalNumber: cI,
    era: Fe({
      values: iI,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: oI,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Fe({
      values: sI,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: uI,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: lI,
      defaultWidth: "wide"
    })
  };
var dI = fI;
var hI = /^(\d+)(ième|ère|ème|er|e)?/i,
  pI = /\d+/i,
  mI = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
  },
  vI = {
    any: [/^av/i, /^ap/i]
  },
  yI = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
  },
  gI = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  bI = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
  },
  _I = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  wI = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
  },
  OI = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
    any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
  },
  SI = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
  },
  EI = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^min/i,
      noon: /^mid/i,
      morning: /mat/i,
      afternoon: /ap/i,
      evening: /soir/i,
      night: /nuit/i
    }
  },
  PI = {
    ordinalNumber: Dr({
      matchPattern: hI,
      parsePattern: pI,
      valueCallback: function valueCallback(t) {
        return parseInt(t);
      }
    }),
    era: Le({
      matchPatterns: mI,
      defaultMatchWidth: "wide",
      parsePatterns: vI,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: yI,
      defaultMatchWidth: "wide",
      parsePatterns: gI,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: bI,
      defaultMatchWidth: "wide",
      parsePatterns: _I,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: wI,
      defaultMatchWidth: "wide",
      parsePatterns: OI,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: SI,
      defaultMatchWidth: "any",
      parsePatterns: EI,
      defaultParseWidth: "any"
    })
  };
var TI = PI;
var kI = {
  code: "fr",
  formatDistance: KA,
  formatLong: tI,
  formatRelative: aI,
  localize: dI,
  match: TI,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var DI = kI;
var xI = {
    lessThanXSeconds: {
      one: "meno di un secondo",
      other: "meno di {{count}} secondi"
    },
    xSeconds: {
      one: "un secondo",
      other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
      one: "meno di un minuto",
      other: "meno di {{count}} minuti"
    },
    xMinutes: {
      one: "un minuto",
      other: "{{count}} minuti"
    },
    aboutXHours: {
      one: "circa un'ora",
      other: "circa {{count}} ore"
    },
    xHours: {
      one: "un'ora",
      other: "{{count}} ore"
    },
    xDays: {
      one: "un giorno",
      other: "{{count}} giorni"
    },
    aboutXWeeks: {
      one: "circa una settimana",
      other: "circa {{count}} settimane"
    },
    xWeeks: {
      one: "una settimana",
      other: "{{count}} settimane"
    },
    aboutXMonths: {
      one: "circa un mese",
      other: "circa {{count}} mesi"
    },
    xMonths: {
      one: "un mese",
      other: "{{count}} mesi"
    },
    aboutXYears: {
      one: "circa un anno",
      other: "circa {{count}} anni"
    },
    xYears: {
      one: "un anno",
      other: "{{count}} anni"
    },
    overXYears: {
      one: "più di un anno",
      other: "più di {{count}} anni"
    },
    almostXYears: {
      one: "quasi un anno",
      other: "quasi {{count}} anni"
    }
  },
  $I = function $I(t, n, r) {
    var a,
      i = xI[t];
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "tra " + a : a + " fa" : a;
  };
var CI = $I;
var RI = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
  },
  NI = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  AI = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
  },
  II = {
    date: dt({
      formats: RI,
      defaultWidth: "full"
    }),
    time: dt({
      formats: NI,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: AI,
      defaultWidth: "full"
    })
  };
var MI = II;
var Gf = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
function FI(e) {
  switch (e) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + Gf[e] + " scorso alle' p";
  }
}
function qm(e) {
  return "'" + Gf[e] + " alle' p";
}
function LI(e) {
  switch (e) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + Gf[e] + " prossimo alle' p";
  }
}
var jI = {
    lastWeek: function lastWeek(t, n, r) {
      var a = t.getUTCDay();
      return Bm(t, n, r) ? qm(a) : FI(a);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(t, n, r) {
      var a = t.getUTCDay();
      return Bm(t, n, r) ? qm(a) : LI(a);
    },
    other: "P"
  },
  BI = function BI(t, n, r, a) {
    var i = jI[t];
    return typeof i == "function" ? i(n, r, a) : i;
  };
var VI = BI;
var qI = {
    narrow: ["aC", "dC"],
    abbreviated: ["a.C.", "d.C."],
    wide: ["avanti Cristo", "dopo Cristo"]
  },
  UI = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["T1", "T2", "T3", "T4"],
    wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
  },
  zI = {
    narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
    abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
    wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
  },
  HI = {
    narrow: ["D", "L", "M", "M", "G", "V", "S"],
    short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
    wide: ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"]
  },
  WI = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "mattina",
      afternoon: "pomeriggio",
      evening: "sera",
      night: "notte"
    }
  },
  GI = {
    narrow: {
      am: "m.",
      pm: "p.",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "mezzanotte",
      noon: "mezzogiorno",
      morning: "di mattina",
      afternoon: "del pomeriggio",
      evening: "di sera",
      night: "di notte"
    }
  },
  YI = function YI(t, n) {
    var r = Number(t);
    return String(r);
  },
  QI = {
    ordinalNumber: YI,
    era: Fe({
      values: qI,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: UI,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Fe({
      values: zI,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: HI,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: WI,
      defaultWidth: "wide",
      formattingValues: GI,
      defaultFormattingWidth: "wide"
    })
  };
var KI = QI;
var JI = /^(\d+)(º)?/i,
  XI = /\d+/i,
  ZI = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
  },
  eM = {
    any: [/^a/i, /^(d|e)/i]
  },
  tM = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
  },
  nM = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  rM = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
  },
  aM = {
    narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
  },
  iM = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
  },
  oM = {
    narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
    any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
  },
  sM = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
  },
  uM = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mezza/i,
      noon: /^mezzo/i,
      morning: /mattina/i,
      afternoon: /pomeriggio/i,
      evening: /sera/i,
      night: /notte/i
    }
  },
  lM = {
    ordinalNumber: Dr({
      matchPattern: JI,
      parsePattern: XI,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }),
    era: Le({
      matchPatterns: ZI,
      defaultMatchWidth: "wide",
      parsePatterns: eM,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: tM,
      defaultMatchWidth: "wide",
      parsePatterns: nM,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: rM,
      defaultMatchWidth: "wide",
      parsePatterns: aM,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: iM,
      defaultMatchWidth: "wide",
      parsePatterns: oM,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: sM,
      defaultMatchWidth: "any",
      parsePatterns: uM,
      defaultParseWidth: "any"
    })
  };
var cM = lM;
var fM = {
  code: "it",
  formatDistance: CI,
  formatLong: MI,
  formatRelative: VI,
  localize: KI,
  match: cM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var dM = fM;
var hM = {
    lessThanXSeconds: {
      one: "minder dan een seconde",
      other: "minder dan {{count}} seconden"
    },
    xSeconds: {
      one: "1 seconde",
      other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
      one: "minder dan een minuut",
      other: "minder dan {{count}} minuten"
    },
    xMinutes: {
      one: "een minuut",
      other: "{{count}} minuten"
    },
    aboutXHours: {
      one: "ongeveer 1 uur",
      other: "ongeveer {{count}} uur"
    },
    xHours: {
      one: "1 uur",
      other: "{{count}} uur"
    },
    xDays: {
      one: "1 dag",
      other: "{{count}} dagen"
    },
    aboutXWeeks: {
      one: "ongeveer 1 week",
      other: "ongeveer {{count}} weken"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weken"
    },
    aboutXMonths: {
      one: "ongeveer 1 maand",
      other: "ongeveer {{count}} maanden"
    },
    xMonths: {
      one: "1 maand",
      other: "{{count}} maanden"
    },
    aboutXYears: {
      one: "ongeveer 1 jaar",
      other: "ongeveer {{count}} jaar"
    },
    xYears: {
      one: "1 jaar",
      other: "{{count}} jaar"
    },
    overXYears: {
      one: "meer dan 1 jaar",
      other: "meer dan {{count}} jaar"
    },
    almostXYears: {
      one: "bijna 1 jaar",
      other: "bijna {{count}} jaar"
    }
  },
  pM = function pM(t, n, r) {
    var a,
      i = hM[t];
    return typeof i == "string" ? a = i : n === 1 ? a = i.one : a = i.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "over " + a : a + " geleden" : a;
  };
var mM = pM;
var vM = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
  },
  yM = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
  },
  gM = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  },
  bM = {
    date: dt({
      formats: vM,
      defaultWidth: "full"
    }),
    time: dt({
      formats: yM,
      defaultWidth: "full"
    }),
    dateTime: dt({
      formats: gM,
      defaultWidth: "full"
    })
  };
var _M = bM;
var wM = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
  },
  OM = function OM(t, n, r, a) {
    return wM[t];
  };
var SM = OM;
var EM = {
    narrow: ["v.C.", "n.C."],
    abbreviated: ["v.Chr.", "n.Chr."],
    wide: ["voor Christus", "na Christus"]
  },
  PM = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["K1", "K2", "K3", "K4"],
    wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
  },
  TM = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
    wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
  },
  kM = {
    narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
    short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
    wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
  },
  DM = {
    narrow: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    },
    wide: {
      am: "AM",
      pm: "PM",
      midnight: "middernacht",
      noon: "het middaguur",
      morning: "'s ochtends",
      afternoon: "'s middags",
      evening: "'s avonds",
      night: "'s nachts"
    }
  },
  xM = function xM(t, n) {
    var r = Number(t);
    return r + "e";
  },
  $M = {
    ordinalNumber: xM,
    era: Fe({
      values: EM,
      defaultWidth: "wide"
    }),
    quarter: Fe({
      values: PM,
      defaultWidth: "wide",
      argumentCallback: function argumentCallback(t) {
        return t - 1;
      }
    }),
    month: Fe({
      values: TM,
      defaultWidth: "wide"
    }),
    day: Fe({
      values: kM,
      defaultWidth: "wide"
    }),
    dayPeriod: Fe({
      values: DM,
      defaultWidth: "wide"
    })
  };
var CM = $M;
var RM = /^(\d+)e?/i,
  NM = /\d+/i,
  AM = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
  },
  IM = {
    any: [/^v/, /^n/]
  },
  MM = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
  },
  FM = {
    any: [/1/i, /2/i, /3/i, /4/i]
  },
  LM = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
  },
  jM = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
  },
  BM = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
  },
  VM = {
    narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
    any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
  },
  qM = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
  },
  UM = {
    any: {
      am: /^am/i,
      pm: /^pm/i,
      midnight: /^middernacht/i,
      noon: /^het middaguur/i,
      morning: /ochtend/i,
      afternoon: /middag/i,
      evening: /avond/i,
      night: /nacht/i
    }
  },
  zM = {
    ordinalNumber: Dr({
      matchPattern: RM,
      parsePattern: NM,
      valueCallback: function valueCallback(t) {
        return parseInt(t, 10);
      }
    }),
    era: Le({
      matchPatterns: AM,
      defaultMatchWidth: "wide",
      parsePatterns: IM,
      defaultParseWidth: "any"
    }),
    quarter: Le({
      matchPatterns: MM,
      defaultMatchWidth: "wide",
      parsePatterns: FM,
      defaultParseWidth: "any",
      valueCallback: function valueCallback(t) {
        return t + 1;
      }
    }),
    month: Le({
      matchPatterns: LM,
      defaultMatchWidth: "wide",
      parsePatterns: jM,
      defaultParseWidth: "any"
    }),
    day: Le({
      matchPatterns: BM,
      defaultMatchWidth: "wide",
      parsePatterns: VM,
      defaultParseWidth: "any"
    }),
    dayPeriod: Le({
      matchPatterns: qM,
      defaultMatchWidth: "any",
      parsePatterns: UM,
      defaultParseWidth: "any"
    })
  };
var HM = zM;
var WM = {
  code: "nl",
  formatDistance: mM,
  formatLong: _M,
  formatRelative: SM,
  localize: CM,
  match: HM,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var GM = WM,
  YM = {
    en: cA,
    nl: GM,
    de: rA,
    fr: DI,
    it: dM,
    es: GA
  };
function jt(e, t) {
  return la(e, t, {
    locale: YM[window.__localeId__]
    // or global.__localeId__
  });
}

function $t(e) {
  return vD(e, "yyyy-MM-dd", new Date());
}
var QM = "MMMM yyyy",
  gr = "EEEE dd MMMM yyyy",
  Vt = React.createContext({
    locale: "nl",
    portalCode: "",
    objectCode: ""
  });
function KM(_ref49) {
  var e = _ref49.filters,
    t = _ref49.PortalSite,
    n = _ref49.limit,
    r = _ref49.skip,
    a = _ref49.onPageChange,
    i = _ref49.activePage;
  var _React$useContext = React.useContext(Vt),
    o = _React$useContext.portalCode;
  var s = null,
    u = !1;
  e.departure_date && e.arrival_date ? (s = _n($t(e.departure_date), $t(e.arrival_date)), u = !0) : e.arrival_date && (s = 1);
  var l = e.properties || [];
  l = l.map(function (b) {
    return JSON.stringify(b);
  });
  var c = l.join(","),
    f = {
      id: o,
      country_id: e.countries || null,
      region_id: e.regions || null,
      city_id: e.cities,
      persons_min: Number(e.persons_min) || null,
      persons_max: Number(e.persons_max) || null,
      bedrooms_min: Number(e.bedrooms_min),
      bathrooms_min: Number(e.bathrooms_min),
      arrival_date: e.arrival_date,
      starts_at: e.arrival_date,
      ends_at: e.departure_date,
      no_nights: Number(s) || null,
      extra_search: e.extra_search,
      properties: c,
      weekprice_max: Number(e.weekprice_max) || null,
      limit: n,
      skip: r
    };
  var _ln2 = ln(u ? vN : mN, {
      variables: f
    }),
    h = _ln2.loading,
    p = _ln2.error,
    v = _ln2.data;
  if (h) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Dn, {})
  });
  if (p) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Zn, {
      errors: p
    })
  });
  var m = /* @__PURE__ */d(_N, {
      variables: f,
      activePage: i,
      limit: n,
      onPageChange: a
    }),
    g = v.PortalSite.houses;
  return /* @__PURE__ */F("div", {
    id: "results",
    className: t.options.filtersForm ? t.options.filtersForm.mode : "",
    children: [m, g.length === 0 ? /* @__PURE__ */d("div", {
      className: "bu-noresults",
      children: /* @__PURE__ */d(J, {
        id: "no_results"
      })
    }) : null, g.map(function (b) {
      return /* @__PURE__ */d(pN, {
        result: b,
        options: t.options.filtersForm
      }, b.id);
    }), m]
  });
}
var JM = /*#__PURE__*/function (_React$Component2) {
  _inherits2(JM, _React$Component2);
  var _super29 = _createSuper2(JM);
  function JM(t) {
    var _this42;
    _classCallCheck2(this, JM);
    _this42 = _super29.call(this, t);
    var n = _this42.props.options.filtersForm ? Number(_this42.props.options.filtersForm.no_results) : 20;
    _this42.state = {
      filters: _this42.props.filters || {},
      activePage: 1,
      limit: n,
      skip: 0
    }, _this42.onFilterChange = _this42.onFilterChange.bind(_assertThisInitialized2(_this42)), _this42.pageChange = _this42.pageChange.bind(_assertThisInitialized2(_this42));
    return _this42;
  }
  _createClass2(JM, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var t = localStorage.getItem("bukazuFilters"),
        n = localStorage.getItem("bukazuActivePage");
      t && this.setState({
        filters: JSON.parse(t)
      }), n && this.pageChange(parseInt(n) || 0);
    }
  }, {
    key: "onFilterChange",
    value: function onFilterChange(t) {
      var n = t;
      this.setState({
        filters: n
      }), localStorage.setItem("bukazuFilters", JSON.stringify(n)), this.pageChange(0);
    }
  }, {
    key: "pageChange",
    value: function pageChange(t) {
      var n = this.state.limit;
      var r = t * n;
      localStorage.setItem("bukazuActivePage", t.toString()), this.setState({
        activePage: t,
        skip: r
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        t = _this$state.filters,
        n = _this$state.activePage,
        r = _this$state.limit,
        a = _this$state.skip,
        _this$props3 = this.props,
        i = _this$props3.options,
        o = _this$props3.PortalSite;
      return /* @__PURE__ */F("div", {
        id: "search-page",
        className: i.filtersForm ? i.filtersForm.location === "right" ? "bu-reverse" : i.filtersForm.location === "top" ? "bu-column" : "" : "",
        children: [/* @__PURE__ */d(hN, {
          PortalSite: o,
          filters: t,
          onFilterChange: this.onFilterChange,
          options: i
        }), /* @__PURE__ */d(KM, {
          PortalSite: o,
          filters: t,
          activePage: n,
          onPageChange: this.pageChange,
          skip: a,
          limit: r
        })]
      });
    }
  }]);
  return JM;
}(React.Component);
var Um = Array.isArray,
  zm = Object.keys,
  XM = Object.prototype.hasOwnProperty,
  ZM = typeof Element < "u";
function Ec(e, t) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    var n = Um(e),
      r = Um(t),
      a,
      i,
      o;
    if (n && r) {
      if (i = e.length, i != t.length) return !1;
      for (a = i; a-- !== 0;) if (!Ec(e[a], t[a])) return !1;
      return !0;
    }
    if (n != r) return !1;
    var s = e instanceof Date,
      u = t instanceof Date;
    if (s != u) return !1;
    if (s && u) return e.getTime() == t.getTime();
    var l = e instanceof RegExp,
      c = t instanceof RegExp;
    if (l != c) return !1;
    if (l && c) return e.toString() == t.toString();
    var f = zm(e);
    if (i = f.length, i !== zm(t).length) return !1;
    for (a = i; a-- !== 0;) if (!XM.call(t, f[a])) return !1;
    if (ZM && e instanceof Element && t instanceof Element) return e === t;
    for (a = i; a-- !== 0;) if (o = f[a], !(o === "_owner" && e.$$typeof) && !Ec(e[o], t[o])) return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var gn = function gn(t, n) {
    try {
      return Ec(t, n);
    } catch (r) {
      if (r.message && r.message.match(/stack|recursion/i) || r.number === -2146828260) return console.warn("Warning: react-fast-compare does not handle circular references.", r.name, r.message), !1;
      throw r;
    }
  },
  eF = function eF(t) {
    return tF(t) && !nF(t);
  };
function tF(e) {
  return !!e && typeof e == "object";
}
function nF(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || iF(e);
}
var rF = typeof Symbol == "function" && Symbol.for,
  aF = rF ? Symbol.for("react.element") : 60103;
function iF(e) {
  return e.$$typeof === aF;
}
function oF(e) {
  return Array.isArray(e) ? [] : {};
}
function Bo(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? va(oF(e), e, t) : e;
}
function sF(e, t, n) {
  return e.concat(t).map(function (r) {
    return Bo(r, n);
  });
}
function uF(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && Object.keys(e).forEach(function (a) {
    r[a] = Bo(e[a], n);
  }), Object.keys(t).forEach(function (a) {
    !n.isMergeableObject(t[a]) || !e[a] ? r[a] = Bo(t[a], n) : r[a] = va(e[a], t[a], n);
  }), r;
}
function va(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || sF, n.isMergeableObject = n.isMergeableObject || eF;
  var r = Array.isArray(t),
    a = Array.isArray(e),
    i = r === a;
  return i ? r ? n.arrayMerge(e, t, n) : uF(e, t, n) : Bo(t, n);
}
va.all = function (t, n) {
  if (!Array.isArray(t)) throw new Error("first argument should be an array");
  return t.reduce(function (r, a) {
    return va(r, a, n);
  }, {});
};
var Pc = va,
  lF = typeof global == "object" && global && global.Object === Object && global;
var r_ = lF;
var cF = typeof self == "object" && self && self.Object === Object && self,
  fF = r_ || cF || Function("return this")();
var nn = fF;
var dF = nn.Symbol;
var Tn = dF;
var a_ = Object.prototype,
  hF = a_.hasOwnProperty,
  pF = a_.toString,
  zr = Tn ? Tn.toStringTag : void 0;
function mF(e) {
  var t = hF.call(e, zr),
    n = e[zr];
  try {
    e[zr] = void 0;
    var r = !0;
  } catch (_unused58) {}
  var a = pF.call(e);
  return r && (t ? e[zr] = n : delete e[zr]), a;
}
var vF = Object.prototype,
  yF = vF.toString;
function gF(e) {
  return yF.call(e);
}
var bF = "[object Null]",
  _F = "[object Undefined]",
  Hm = Tn ? Tn.toStringTag : void 0;
function er(e) {
  return e == null ? e === void 0 ? _F : bF : Hm && Hm in Object(e) ? mF(e) : gF(e);
}
function i_(e, t) {
  return function (n) {
    return e(t(n));
  };
}
var wF = i_(Object.getPrototypeOf, Object);
var Yf = wF;
function tr(e) {
  return e != null && typeof e == "object";
}
var OF = "[object Object]",
  SF = Function.prototype,
  EF = Object.prototype,
  o_ = SF.toString,
  PF = EF.hasOwnProperty,
  TF = o_.call(Object);
function Wm(e) {
  if (!tr(e) || er(e) != OF) return !1;
  var t = Yf(e);
  if (t === null) return !0;
  var n = PF.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && o_.call(n) == TF;
}
function kF() {
  this.__data__ = [], this.size = 0;
}
function s_(e, t) {
  return e === t || e !== e && t !== t;
}
function ls(e, t) {
  for (var n = e.length; n--;) if (s_(e[n][0], t)) return n;
  return -1;
}
var DF = Array.prototype,
  xF = DF.splice;
function $F(e) {
  var t = this.__data__,
    n = ls(t, e);
  if (n < 0) return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : xF.call(t, n, 1), --this.size, !0;
}
function CF(e) {
  var t = this.__data__,
    n = ls(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function RF(e) {
  return ls(this.__data__, e) > -1;
}
function NF(e, t) {
  var n = this.__data__,
    r = ls(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function dn(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
dn.prototype.clear = kF;
dn.prototype.delete = $F;
dn.prototype.get = CF;
dn.prototype.has = RF;
dn.prototype.set = NF;
function AF() {
  this.__data__ = new dn(), this.size = 0;
}
function IF(e) {
  var t = this.__data__,
    n = t.delete(e);
  return this.size = t.size, n;
}
function MF(e) {
  return this.__data__.get(e);
}
function FF(e) {
  return this.__data__.has(e);
}
function Aa(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var LF = "[object AsyncFunction]",
  jF = "[object Function]",
  BF = "[object GeneratorFunction]",
  VF = "[object Proxy]";
function u_(e) {
  if (!Aa(e)) return !1;
  var t = er(e);
  return t == jF || t == BF || t == LF || t == VF;
}
var qF = nn["__core-js_shared__"];
var Zs = qF;
var Gm = function () {
  var e = /[^.]+$/.exec(Zs && Zs.keys && Zs.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function UF(e) {
  return !!Gm && Gm in e;
}
var zF = Function.prototype,
  HF = zF.toString;
function nr(e) {
  if (e != null) {
    try {
      return HF.call(e);
    } catch (_unused59) {}
    try {
      return e + "";
    } catch (_unused60) {}
  }
  return "";
}
var WF = /[\\^$.*+?()[\]{}|]/g,
  GF = /^\[object .+?Constructor\]$/,
  YF = Function.prototype,
  QF = Object.prototype,
  KF = YF.toString,
  JF = QF.hasOwnProperty,
  XF = RegExp("^" + KF.call(JF).replace(WF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function ZF(e) {
  if (!Aa(e) || UF(e)) return !1;
  var t = u_(e) ? XF : GF;
  return t.test(nr(e));
}
function eL(e, t) {
  return e == null ? void 0 : e[t];
}
function rr(e, t) {
  var n = eL(e, t);
  return ZF(n) ? n : void 0;
}
var tL = rr(nn, "Map");
var ya = tL;
var nL = rr(Object, "create");
var ga = nL;
function rL() {
  this.__data__ = ga ? ga(null) : {}, this.size = 0;
}
function aL(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var iL = "__lodash_hash_undefined__",
  oL = Object.prototype,
  sL = oL.hasOwnProperty;
function uL(e) {
  var t = this.__data__;
  if (ga) {
    var n = t[e];
    return n === iL ? void 0 : n;
  }
  return sL.call(t, e) ? t[e] : void 0;
}
var lL = Object.prototype,
  cL = lL.hasOwnProperty;
function fL(e) {
  var t = this.__data__;
  return ga ? t[e] !== void 0 : cL.call(t, e);
}
var dL = "__lodash_hash_undefined__";
function hL(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ga && t === void 0 ? dL : t, this;
}
function Hn(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Hn.prototype.clear = rL;
Hn.prototype.delete = aL;
Hn.prototype.get = uL;
Hn.prototype.has = fL;
Hn.prototype.set = hL;
function pL() {
  this.size = 0, this.__data__ = {
    hash: new Hn(),
    map: new (ya || dn)(),
    string: new Hn()
  };
}
function mL(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function cs(e, t) {
  var n = e.__data__;
  return mL(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function vL(e) {
  var t = cs(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function yL(e) {
  return cs(this, e).get(e);
}
function gL(e) {
  return cs(this, e).has(e);
}
function bL(e, t) {
  var n = cs(this, e),
    r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function Nn(e) {
  var t = -1,
    n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n;) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Nn.prototype.clear = pL;
Nn.prototype.delete = vL;
Nn.prototype.get = yL;
Nn.prototype.has = gL;
Nn.prototype.set = bL;
var _L = 200;
function wL(e, t) {
  var n = this.__data__;
  if (n instanceof dn) {
    var r = n.__data__;
    if (!ya || r.length < _L - 1) return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Nn(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function Fr(e) {
  var t = this.__data__ = new dn(e);
  this.size = t.size;
}
Fr.prototype.clear = AF;
Fr.prototype.delete = IF;
Fr.prototype.get = MF;
Fr.prototype.has = FF;
Fr.prototype.set = wL;
function OL(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
  return e;
}
var SL = function () {
  try {
    var e = rr(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (_unused61) {}
}();
var Ym = SL;
function l_(e, t, n) {
  t == "__proto__" && Ym ? Ym(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var EL = Object.prototype,
  PL = EL.hasOwnProperty;
function c_(e, t, n) {
  var r = e[t];
  (!(PL.call(e, t) && s_(r, n)) || n === void 0 && !(t in e)) && l_(e, t, n);
}
function fs(e, t, n, r) {
  var a = !n;
  n || (n = {});
  for (var i = -1, o = t.length; ++i < o;) {
    var s = t[i],
      u = r ? r(n[s], e[s], s, n, e) : void 0;
    u === void 0 && (u = e[s]), a ? l_(n, s, u) : c_(n, s, u);
  }
  return n;
}
function TL(e, t) {
  for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
  return r;
}
var kL = "[object Arguments]";
function Qm(e) {
  return tr(e) && er(e) == kL;
}
var f_ = Object.prototype,
  DL = f_.hasOwnProperty,
  xL = f_.propertyIsEnumerable,
  $L = Qm(function () {
    return arguments;
  }()) ? Qm : function (e) {
    return tr(e) && DL.call(e, "callee") && !xL.call(e, "callee");
  };
var CL = $L;
var RL = Array.isArray;
var Ia = RL;
function NL() {
  return !1;
}
var d_ = typeof exports == "object" && exports && !exports.nodeType && exports,
  Km = d_ && typeof module == "object" && module && !module.nodeType && module,
  AL = Km && Km.exports === d_,
  Jm = AL ? nn.Buffer : void 0,
  IL = Jm ? Jm.isBuffer : void 0,
  ML = IL || NL;
var h_ = ML;
var FL = 9007199254740991,
  LL = /^(?:0|[1-9]\d*)$/;
function jL(e, t) {
  var _t4;
  var n = typeof e;
  return t = (_t4 = t) !== null && _t4 !== void 0 ? _t4 : FL, !!t && (n == "number" || n != "symbol" && LL.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var BL = 9007199254740991;
function p_(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= BL;
}
var VL = "[object Arguments]",
  qL = "[object Array]",
  UL = "[object Boolean]",
  zL = "[object Date]",
  HL = "[object Error]",
  WL = "[object Function]",
  GL = "[object Map]",
  YL = "[object Number]",
  QL = "[object Object]",
  KL = "[object RegExp]",
  JL = "[object Set]",
  XL = "[object String]",
  ZL = "[object WeakMap]",
  ej = "[object ArrayBuffer]",
  tj = "[object DataView]",
  nj = "[object Float32Array]",
  rj = "[object Float64Array]",
  aj = "[object Int8Array]",
  ij = "[object Int16Array]",
  oj = "[object Int32Array]",
  sj = "[object Uint8Array]",
  uj = "[object Uint8ClampedArray]",
  lj = "[object Uint16Array]",
  cj = "[object Uint32Array]",
  We = {};
We[nj] = We[rj] = We[aj] = We[ij] = We[oj] = We[sj] = We[uj] = We[lj] = We[cj] = !0;
We[VL] = We[qL] = We[ej] = We[UL] = We[tj] = We[zL] = We[HL] = We[WL] = We[GL] = We[YL] = We[QL] = We[KL] = We[JL] = We[XL] = We[ZL] = !1;
function fj(e) {
  return tr(e) && p_(e.length) && !!We[er(e)];
}
function Qf(e) {
  return function (t) {
    return e(t);
  };
}
var m_ = typeof exports == "object" && exports && !exports.nodeType && exports,
  ea = m_ && typeof module == "object" && module && !module.nodeType && module,
  dj = ea && ea.exports === m_,
  eu = dj && r_.process,
  hj = function () {
    try {
      var e = ea && ea.require && ea.require("util").types;
      return e || eu && eu.binding && eu.binding("util");
    } catch (_unused62) {}
  }();
var Tr = hj;
var Xm = Tr && Tr.isTypedArray,
  pj = Xm ? Qf(Xm) : fj;
var mj = pj;
var vj = Object.prototype,
  yj = vj.hasOwnProperty;
function v_(e, t) {
  var n = Ia(e),
    r = !n && CL(e),
    a = !n && !r && h_(e),
    i = !n && !r && !a && mj(e),
    o = n || r || a || i,
    s = o ? TL(e.length, String) : [],
    u = s.length;
  for (var l in e) (t || yj.call(e, l)) && !(o && (
  // Safari 9 has enumerable `arguments.length` in strict mode.
  l == "length" ||
  // Node.js 0.10 has enumerable non-index properties on buffers.
  a && (l == "offset" || l == "parent") ||
  // PhantomJS 2 has enumerable non-index properties on typed arrays.
  i && (l == "buffer" || l == "byteLength" || l == "byteOffset") ||
  // Skip index properties.
  jL(l, u))) && s.push(l);
  return s;
}
var gj = Object.prototype;
function Kf(e) {
  var t = e && e.constructor,
    n = typeof t == "function" && t.prototype || gj;
  return e === n;
}
var bj = i_(Object.keys, Object);
var _j = bj;
var wj = Object.prototype,
  Oj = wj.hasOwnProperty;
function Sj(e) {
  if (!Kf(e)) return _j(e);
  var t = [];
  for (var n in Object(e)) Oj.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function y_(e) {
  return e != null && p_(e.length) && !u_(e);
}
function Jf(e) {
  return y_(e) ? v_(e) : Sj(e);
}
function Ej(e, t) {
  return e && fs(t, Jf(t), e);
}
function Pj(e) {
  var t = [];
  if (e != null) for (var n in Object(e)) t.push(n);
  return t;
}
var Tj = Object.prototype,
  kj = Tj.hasOwnProperty;
function Dj(e) {
  if (!Aa(e)) return Pj(e);
  var t = Kf(e),
    n = [];
  for (var r in e) r == "constructor" && (t || !kj.call(e, r)) || n.push(r);
  return n;
}
function Xf(e) {
  return y_(e) ? v_(e, !0) : Dj(e);
}
function xj(e, t) {
  return e && fs(t, Xf(t), e);
}
var g_ = typeof exports == "object" && exports && !exports.nodeType && exports,
  Zm = g_ && typeof module == "object" && module && !module.nodeType && module,
  $j = Zm && Zm.exports === g_,
  ev = $j ? nn.Buffer : void 0,
  tv = ev ? ev.allocUnsafe : void 0;
function Cj(e, t) {
  if (t) return e.slice();
  var n = e.length,
    r = tv ? tv(n) : new e.constructor(n);
  return e.copy(r), r;
}
function b_(e, t) {
  var n = -1,
    r = e.length;
  for (t || (t = Array(r)); ++n < r;) t[n] = e[n];
  return t;
}
function Rj(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = 0, i = []; ++n < r;) {
    var o = e[n];
    t(o, n, e) && (i[a++] = o);
  }
  return i;
}
function __() {
  return [];
}
var Nj = Object.prototype,
  Aj = Nj.propertyIsEnumerable,
  nv = Object.getOwnPropertySymbols,
  Ij = nv ? function (e) {
    return e == null ? [] : (e = Object(e), Rj(nv(e), function (t) {
      return Aj.call(e, t);
    }));
  } : __;
var Zf = Ij;
function Mj(e, t) {
  return fs(e, Zf(e), t);
}
function w_(e, t) {
  for (var n = -1, r = t.length, a = e.length; ++n < r;) e[a + n] = t[n];
  return e;
}
var Fj = Object.getOwnPropertySymbols,
  Lj = Fj ? function (e) {
    for (var t = []; e;) w_(t, Zf(e)), e = Yf(e);
    return t;
  } : __;
var O_ = Lj;
function jj(e, t) {
  return fs(e, O_(e), t);
}
function S_(e, t, n) {
  var r = t(e);
  return Ia(e) ? r : w_(r, n(e));
}
function Bj(e) {
  return S_(e, Jf, Zf);
}
function Vj(e) {
  return S_(e, Xf, O_);
}
var qj = rr(nn, "DataView");
var Tc = qj;
var Uj = rr(nn, "Promise");
var kc = Uj;
var zj = rr(nn, "Set");
var Dc = zj;
var Hj = rr(nn, "WeakMap");
var xc = Hj;
var rv = "[object Map]",
  Wj = "[object Object]",
  av = "[object Promise]",
  iv = "[object Set]",
  ov = "[object WeakMap]",
  sv = "[object DataView]",
  Gj = nr(Tc),
  Yj = nr(ya),
  Qj = nr(kc),
  Kj = nr(Dc),
  Jj = nr(xc),
  Fn = er;
(Tc && Fn(new Tc(new ArrayBuffer(1))) != sv || ya && Fn(new ya()) != rv || kc && Fn(kc.resolve()) != av || Dc && Fn(new Dc()) != iv || xc && Fn(new xc()) != ov) && (Fn = function Fn(e) {
  var t = er(e),
    n = t == Wj ? e.constructor : void 0,
    r = n ? nr(n) : "";
  if (r) switch (r) {
    case Gj:
      return sv;
    case Yj:
      return rv;
    case Qj:
      return av;
    case Kj:
      return iv;
    case Jj:
      return ov;
  }
  return t;
});
var ed = Fn;
var Xj = Object.prototype,
  Zj = Xj.hasOwnProperty;
function eB(e) {
  var t = e.length,
    n = new e.constructor(t);
  return t && typeof e[0] == "string" && Zj.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var tB = nn.Uint8Array;
var uv = tB;
function td(e) {
  var t = new e.constructor(e.byteLength);
  return new uv(t).set(new uv(e)), t;
}
function nB(e, t) {
  var n = t ? td(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var rB = /\w*$/;
function aB(e) {
  var t = new e.constructor(e.source, rB.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var lv = Tn ? Tn.prototype : void 0,
  cv = lv ? lv.valueOf : void 0;
function iB(e) {
  return cv ? Object(cv.call(e)) : {};
}
function oB(e, t) {
  var n = t ? td(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var sB = "[object Boolean]",
  uB = "[object Date]",
  lB = "[object Map]",
  cB = "[object Number]",
  fB = "[object RegExp]",
  dB = "[object Set]",
  hB = "[object String]",
  pB = "[object Symbol]",
  mB = "[object ArrayBuffer]",
  vB = "[object DataView]",
  yB = "[object Float32Array]",
  gB = "[object Float64Array]",
  bB = "[object Int8Array]",
  _B = "[object Int16Array]",
  wB = "[object Int32Array]",
  OB = "[object Uint8Array]",
  SB = "[object Uint8ClampedArray]",
  EB = "[object Uint16Array]",
  PB = "[object Uint32Array]";
function TB(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case mB:
      return td(e);
    case sB:
    case uB:
      return new r(+e);
    case vB:
      return nB(e, n);
    case yB:
    case gB:
    case bB:
    case _B:
    case wB:
    case OB:
    case SB:
    case EB:
    case PB:
      return oB(e, n);
    case lB:
      return new r();
    case cB:
    case hB:
      return new r(e);
    case fB:
      return aB(e);
    case dB:
      return new r();
    case pB:
      return iB(e);
  }
}
var fv = Object.create,
  kB = function () {
    function e() {}
    return function (t) {
      if (!Aa(t)) return {};
      if (fv) return fv(t);
      e.prototype = t;
      var n = new e();
      return e.prototype = void 0, n;
    };
  }();
var DB = kB;
function xB(e) {
  return typeof e.constructor == "function" && !Kf(e) ? DB(Yf(e)) : {};
}
var $B = "[object Map]";
function CB(e) {
  return tr(e) && ed(e) == $B;
}
var dv = Tr && Tr.isMap,
  RB = dv ? Qf(dv) : CB;
var NB = RB;
var AB = "[object Set]";
function IB(e) {
  return tr(e) && ed(e) == AB;
}
var hv = Tr && Tr.isSet,
  MB = hv ? Qf(hv) : IB;
var FB = MB;
var LB = 1,
  jB = 2,
  BB = 4,
  E_ = "[object Arguments]",
  VB = "[object Array]",
  qB = "[object Boolean]",
  UB = "[object Date]",
  zB = "[object Error]",
  P_ = "[object Function]",
  HB = "[object GeneratorFunction]",
  WB = "[object Map]",
  GB = "[object Number]",
  T_ = "[object Object]",
  YB = "[object RegExp]",
  QB = "[object Set]",
  KB = "[object String]",
  JB = "[object Symbol]",
  XB = "[object WeakMap]",
  ZB = "[object ArrayBuffer]",
  eV = "[object DataView]",
  tV = "[object Float32Array]",
  nV = "[object Float64Array]",
  rV = "[object Int8Array]",
  aV = "[object Int16Array]",
  iV = "[object Int32Array]",
  oV = "[object Uint8Array]",
  sV = "[object Uint8ClampedArray]",
  uV = "[object Uint16Array]",
  lV = "[object Uint32Array]",
  He = {};
He[E_] = He[VB] = He[ZB] = He[eV] = He[qB] = He[UB] = He[tV] = He[nV] = He[rV] = He[aV] = He[iV] = He[WB] = He[GB] = He[T_] = He[YB] = He[QB] = He[KB] = He[JB] = He[oV] = He[sV] = He[uV] = He[lV] = !0;
He[zB] = He[P_] = He[XB] = !1;
function ta(e, t, n, r, a, i) {
  var o,
    s = t & LB,
    u = t & jB,
    l = t & BB;
  if (n && (o = a ? n(e, r, a, i) : n(e)), o !== void 0) return o;
  if (!Aa(e)) return e;
  var c = Ia(e);
  if (c) {
    if (o = eB(e), !s) return b_(e, o);
  } else {
    var f = ed(e),
      h = f == P_ || f == HB;
    if (h_(e)) return Cj(e, s);
    if (f == T_ || f == E_ || h && !a) {
      if (o = u || h ? {} : xB(e), !s) return u ? jj(e, xj(o, e)) : Mj(e, Ej(o, e));
    } else {
      if (!He[f]) return a ? e : {};
      o = TB(e, f, s);
    }
  }
  i || (i = new Fr());
  var p = i.get(e);
  if (p) return p;
  i.set(e, o), FB(e) ? e.forEach(function (g) {
    o.add(ta(g, t, n, g, e, i));
  }) : NB(e) && e.forEach(function (g, b) {
    o.set(b, ta(g, t, n, b, e, i));
  });
  var v = l ? u ? Vj : Bj : u ? Xf : Jf,
    m = c ? void 0 : v(e);
  return OL(m || e, function (g, b) {
    m && (b = g, g = e[b]), c_(o, b, ta(g, t, n, b, e, i));
  }), o;
}
var cV = 4;
function pv(e) {
  return ta(e, cV);
}
function k_(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, a = Array(r); ++n < r;) a[n] = t(e[n], n, e);
  return a;
}
var fV = "[object Symbol]";
function nd(e) {
  return typeof e == "symbol" || tr(e) && er(e) == fV;
}
var dV = "Expected a function";
function rd(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function") throw new TypeError(dV);
  var n = function n() {
    var r = arguments,
      a = t ? t.apply(this, r) : r[0],
      i = n.cache;
    if (i.has(a)) return i.get(a);
    var o = e.apply(this, r);
    return n.cache = i.set(a, o) || i, o;
  };
  return n.cache = new (rd.Cache || Nn)(), n;
}
rd.Cache = Nn;
var hV = 500;
function pV(e) {
  var t = rd(e, function (r) {
      return n.size === hV && n.clear(), r;
    }),
    n = t.cache;
  return t;
}
var mV = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
  vV = /\\(\\)?/g,
  yV = pV(function (e) {
    var t = [];
    return e.charCodeAt(0) === 46 && t.push(""), e.replace(mV, function (n, r, a, i) {
      t.push(a ? i.replace(vV, "$1") : r || n);
    }), t;
  });
var gV = yV;
var bV = 1 / 0;
function _V(e) {
  if (typeof e == "string" || nd(e)) return e;
  var t = e + "";
  return t == "0" && 1 / e == -bV ? "-0" : t;
}
var wV = 1 / 0,
  mv = Tn ? Tn.prototype : void 0,
  vv = mv ? mv.toString : void 0;
function D_(e) {
  if (typeof e == "string") return e;
  if (Ia(e)) return k_(e, D_) + "";
  if (nd(e)) return vv ? vv.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -wV ? "-0" : t;
}
function OV(e) {
  return e == null ? "" : D_(e);
}
function x_(e) {
  return Ia(e) ? k_(e, _V) : nd(e) ? [e] : b_(gV(OV(e)));
}
function ze() {
  return ze = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ze.apply(this, arguments);
}
function Ln(e, t) {
  if (e == null) return {};
  var n = {},
    r = Object.keys(e),
    a,
    i;
  for (i = 0; i < r.length; i++) a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
var Et = function Et(t) {
    return typeof t == "function";
  },
  ds = function ds(t) {
    return t !== null && typeof t == "object";
  },
  kV = function kV(t) {
    return String(Math.floor(Number(t))) === t;
  },
  tu = function tu(t) {
    return Object.prototype.toString.call(t) === "[object String]";
  },
  ad = function ad(t) {
    return React.Children.count(t) === 0;
  },
  nu = function nu(t) {
    return ds(t) && Et(t.then);
  };
function DV(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
  try {
    return e.activeElement || e.body;
  } catch (_unused63) {
    return e.body;
  }
}
function bt(e, t, n, r) {
  r === void 0 && (r = 0);
  for (var a = x_(t); e && r < a.length;) e = e[a[r++]];
  return e === void 0 ? n : e;
}
function Zt(e, t, n) {
  for (var r = pv(e), a = r, i = 0, o = x_(t); i < o.length - 1; i++) {
    var s = o[i],
      u = bt(e, o.slice(0, i + 1));
    if (u && (ds(u) || Array.isArray(u))) a = a[s] = pv(u);else {
      var l = o[i + 1];
      a = a[s] = kV(l) && Number(l) >= 0 ? [] : {};
    }
  }
  return (i === 0 ? e : a)[o[i]] === n ? e : (n === void 0 ? delete a[o[i]] : a[o[i]] = n, i === 0 && n === void 0 && delete r[o[i]], r);
}
function $_(e, t, n, r) {
  n === void 0 && (n = /* @__PURE__ */new WeakMap()), r === void 0 && (r = {});
  for (var a = 0, i = Object.keys(e); a < i.length; a++) {
    var o = i[a],
      s = e[o];
    ds(s) ? n.get(s) || (n.set(s, !0), r[o] = Array.isArray(s) ? [] : {}, $_(s, t, n, r[o])) : r[o] = t;
  }
  return r;
}
var hs = /* @__PURE__ */React.createContext(void 0);
hs.displayName = "FormikContext";
var xV = hs.Provider;
hs.Consumer;
function C_() {
  var e = React.useContext(hs);
  return e || (process.env.NODE_ENV !== "production" ? pt(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : pt(!1)), e;
}
function $V(e, t) {
  switch (t.type) {
    case "SET_VALUES":
      return ze({}, e, {
        values: t.payload
      });
    case "SET_TOUCHED":
      return ze({}, e, {
        touched: t.payload
      });
    case "SET_ERRORS":
      return gn(e.errors, t.payload) ? e : ze({}, e, {
        errors: t.payload
      });
    case "SET_STATUS":
      return ze({}, e, {
        status: t.payload
      });
    case "SET_ISSUBMITTING":
      return ze({}, e, {
        isSubmitting: t.payload
      });
    case "SET_ISVALIDATING":
      return ze({}, e, {
        isValidating: t.payload
      });
    case "SET_FIELD_VALUE":
      return ze({}, e, {
        values: Zt(e.values, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return ze({}, e, {
        touched: Zt(e.touched, t.payload.field, t.payload.value)
      });
    case "SET_FIELD_ERROR":
      return ze({}, e, {
        errors: Zt(e.errors, t.payload.field, t.payload.value)
      });
    case "RESET_FORM":
      return ze({}, e, t.payload);
    case "SET_FORMIK_STATE":
      return t.payload(e);
    case "SUBMIT_ATTEMPT":
      return ze({}, e, {
        touched: $_(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return ze({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return ze({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var In = {},
  Ha = {};
function CV(e) {
  var t = e.validateOnChange,
    n = t === void 0 ? !0 : t,
    r = e.validateOnBlur,
    a = r === void 0 ? !0 : r,
    i = e.validateOnMount,
    o = i === void 0 ? !1 : i,
    s = e.isInitialValid,
    u = e.enableReinitialize,
    l = u === void 0 ? !1 : u,
    c = e.onSubmit,
    f = Ln(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]),
    h = ze({
      validateOnChange: n,
      validateOnBlur: a,
      validateOnMount: o,
      onSubmit: c
    }, f),
    p = React.useRef(h.initialValues),
    v = React.useRef(h.initialErrors || In),
    m = React.useRef(h.initialTouched || Ha),
    g = React.useRef(h.initialStatus),
    b = React.useRef(!1),
    y = React.useRef({});
  process.env.NODE_ENV !== "production" && React.useEffect(function () {
    typeof s > "u" || (process.env.NODE_ENV !== "production" ? pt(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : pt(!1));
  }, []), React.useEffect(function () {
    return b.current = !0, function () {
      b.current = !1;
    };
  }, []);
  var E = React.useReducer($V, {
      values: h.initialValues,
      errors: h.initialErrors || In,
      touched: h.initialTouched || Ha,
      status: h.initialStatus,
      isSubmitting: !1,
      isValidating: !1,
      submitCount: 0
    }),
    w = E[0],
    _ = E[1],
    C = React.useCallback(function ($, oe) {
      return new Promise(function (T, R) {
        var z = h.validate($, oe);
        z == null ? T(In) : nu(z) ? z.then(function (j) {
          T(j || In);
        }, function (j) {
          process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", j), R(j);
        }) : T(z);
      });
    }, [h.validate]),
    D = React.useCallback(function ($, oe) {
      var T = h.validationSchema,
        R = Et(T) ? T(oe) : T,
        z = oe && R.validateAt ? R.validateAt(oe, $) : AV($, R);
      return new Promise(function (j, ae) {
        z.then(function () {
          j(In);
        }, function (ge) {
          ge.name === "ValidationError" ? j(NV(ge)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", ge), ae(ge));
        });
      });
    }, [h.validationSchema]),
    U = React.useCallback(function ($, oe) {
      return new Promise(function (T) {
        return T(y.current[$].validate(oe));
      });
    }, []),
    Z = React.useCallback(function ($) {
      var oe = Object.keys(y.current).filter(function (R) {
          return Et(y.current[R].validate);
        }),
        T = oe.length > 0 ? oe.map(function (R) {
          return U(R, bt($, R));
        }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
      return Promise.all(T).then(function (R) {
        return R.reduce(function (z, j, ae) {
          return j === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || j && (z = Zt(z, oe[ae], j)), z;
        }, {});
      });
    }, [U]),
    me = React.useCallback(function ($) {
      return Promise.all([Z($), h.validationSchema ? D($) : {}, h.validate ? C($) : {}]).then(function (oe) {
        var T = oe[0],
          R = oe[1],
          z = oe[2],
          j = Pc.all([T, R, z], {
            arrayMerge: IV
          });
        return j;
      });
    }, [h.validate, h.validationSchema, Z, C, D]),
    ye = Ft(function ($) {
      return $ === void 0 && ($ = w.values), _({
        type: "SET_ISVALIDATING",
        payload: !0
      }), me($).then(function (oe) {
        return b.current && (_({
          type: "SET_ISVALIDATING",
          payload: !1
        }), _({
          type: "SET_ERRORS",
          payload: oe
        })), oe;
      });
    });
  React.useEffect(function () {
    o && b.current === !0 && gn(p.current, h.initialValues) && ye(p.current);
  }, [o, ye]);
  var Y = React.useCallback(function ($) {
    var oe = $ && $.values ? $.values : p.current,
      T = $ && $.errors ? $.errors : v.current ? v.current : h.initialErrors || {},
      R = $ && $.touched ? $.touched : m.current ? m.current : h.initialTouched || {},
      z = $ && $.status ? $.status : g.current ? g.current : h.initialStatus;
    p.current = oe, v.current = T, m.current = R, g.current = z;
    var j = function j() {
      _({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!$ && !!$.isSubmitting,
          errors: T,
          touched: R,
          status: z,
          values: oe,
          isValidating: !!$ && !!$.isValidating,
          submitCount: $ && $.submitCount && typeof $.submitCount == "number" ? $.submitCount : 0
        }
      });
    };
    if (h.onReset) {
      var ae = h.onReset(w.values, Q);
      nu(ae) ? ae.then(j) : j();
    } else j();
  }, [h.initialErrors, h.initialStatus, h.initialTouched]);
  React.useEffect(function () {
    b.current === !0 && !gn(p.current, h.initialValues) && (l && (p.current = h.initialValues, Y()), o && ye(p.current));
  }, [l, h.initialValues, Y, o, ye]), React.useEffect(function () {
    l && b.current === !0 && !gn(v.current, h.initialErrors) && (v.current = h.initialErrors || In, _({
      type: "SET_ERRORS",
      payload: h.initialErrors || In
    }));
  }, [l, h.initialErrors]), React.useEffect(function () {
    l && b.current === !0 && !gn(m.current, h.initialTouched) && (m.current = h.initialTouched || Ha, _({
      type: "SET_TOUCHED",
      payload: h.initialTouched || Ha
    }));
  }, [l, h.initialTouched]), React.useEffect(function () {
    l && b.current === !0 && !gn(g.current, h.initialStatus) && (g.current = h.initialStatus, _({
      type: "SET_STATUS",
      payload: h.initialStatus
    }));
  }, [l, h.initialStatus, h.initialTouched]);
  var K = Ft(function ($) {
      if (y.current[$] && Et(y.current[$].validate)) {
        var oe = bt(w.values, $),
          T = y.current[$].validate(oe);
        return nu(T) ? (_({
          type: "SET_ISVALIDATING",
          payload: !0
        }), T.then(function (R) {
          return R;
        }).then(function (R) {
          _({
            type: "SET_FIELD_ERROR",
            payload: {
              field: $,
              value: R
            }
          }), _({
            type: "SET_ISVALIDATING",
            payload: !1
          });
        })) : (_({
          type: "SET_FIELD_ERROR",
          payload: {
            field: $,
            value: T
          }
        }), Promise.resolve(T));
      } else if (h.validationSchema) return _({
        type: "SET_ISVALIDATING",
        payload: !0
      }), D(w.values, $).then(function (R) {
        return R;
      }).then(function (R) {
        _({
          type: "SET_FIELD_ERROR",
          payload: {
            field: $,
            value: R[$]
          }
        }), _({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
      return Promise.resolve();
    }),
    ee = React.useCallback(function ($, oe) {
      var T = oe.validate;
      y.current[$] = {
        validate: T
      };
    }, []),
    ne = React.useCallback(function ($) {
      delete y.current[$];
    }, []),
    ie = Ft(function ($, oe) {
      _({
        type: "SET_TOUCHED",
        payload: $
      });
      var T = oe === void 0 ? a : oe;
      return T ? ye(w.values) : Promise.resolve();
    }),
    fe = React.useCallback(function ($) {
      _({
        type: "SET_ERRORS",
        payload: $
      });
    }, []),
    ce = Ft(function ($, oe) {
      var T = Et($) ? $(w.values) : $;
      _({
        type: "SET_VALUES",
        payload: T
      });
      var R = oe === void 0 ? n : oe;
      return R ? ye(T) : Promise.resolve();
    }),
    H = React.useCallback(function ($, oe) {
      _({
        type: "SET_FIELD_ERROR",
        payload: {
          field: $,
          value: oe
        }
      });
    }, []),
    O = Ft(function ($, oe, T) {
      _({
        type: "SET_FIELD_VALUE",
        payload: {
          field: $,
          value: oe
        }
      });
      var R = T === void 0 ? n : T;
      return R ? ye(Zt(w.values, $, oe)) : Promise.resolve();
    }),
    I = React.useCallback(function ($, oe) {
      var T = oe,
        R = $,
        z;
      if (!tu($)) {
        $.persist && $.persist();
        var j = $.target ? $.target : $.currentTarget,
          ae = j.type,
          ge = j.name,
          Pe = j.id,
          de = j.value,
          Oe = j.checked,
          S = j.outerHTML,
          V = j.options,
          X = j.multiple;
        T = oe || ge || Pe, !T && process.env.NODE_ENV !== "production" && bv({
          htmlContent: S,
          documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
          handlerName: "handleChange"
        }), R = /number|range/.test(ae) ? (z = parseFloat(de), isNaN(z) ? "" : z) : /checkbox/.test(ae) ? FV(bt(w.values, T), Oe, de) : V && X ? MV(V) : de;
      }
      T && O(T, R);
    }, [O, w.values]),
    B = Ft(function ($) {
      if (tu($)) return function (oe) {
        return I(oe, $);
      };
      I($);
    }),
    W = Ft(function ($, oe, T) {
      oe === void 0 && (oe = !0), _({
        type: "SET_FIELD_TOUCHED",
        payload: {
          field: $,
          value: oe
        }
      });
      var R = T === void 0 ? a : T;
      return R ? ye(w.values) : Promise.resolve();
    }),
    G = React.useCallback(function ($, oe) {
      $.persist && $.persist();
      var T = $.target,
        R = T.name,
        z = T.id,
        j = T.outerHTML,
        ae = oe || R || z;
      !ae && process.env.NODE_ENV !== "production" && bv({
        htmlContent: j,
        documentationAnchorLink: "handleblur-e-any--void",
        handlerName: "handleBlur"
      }), W(ae, !0);
    }, [W]),
    ue = Ft(function ($) {
      if (tu($)) return function (oe) {
        return G(oe, $);
      };
      G($);
    }),
    se = React.useCallback(function ($) {
      Et($) ? _({
        type: "SET_FORMIK_STATE",
        payload: $
      }) : _({
        type: "SET_FORMIK_STATE",
        payload: function payload() {
          return $;
        }
      });
    }, []),
    x = React.useCallback(function ($) {
      _({
        type: "SET_STATUS",
        payload: $
      });
    }, []),
    A = React.useCallback(function ($) {
      _({
        type: "SET_ISSUBMITTING",
        payload: $
      });
    }, []),
    M = Ft(function () {
      return _({
        type: "SUBMIT_ATTEMPT"
      }), ye().then(function ($) {
        var oe = $ instanceof Error,
          T = !oe && Object.keys($).length === 0;
        if (T) {
          var R;
          try {
            if (R = L(), R === void 0) return;
          } catch (z) {
            throw z;
          }
          return Promise.resolve(R).then(function (z) {
            return b.current && _({
              type: "SUBMIT_SUCCESS"
            }), z;
          }).catch(function (z) {
            if (b.current) throw _({
              type: "SUBMIT_FAILURE"
            }), z;
          });
        } else if (b.current && (_({
          type: "SUBMIT_FAILURE"
        }), oe)) throw $;
      });
    }),
    N = Ft(function ($) {
      if ($ && $.preventDefault && Et($.preventDefault) && $.preventDefault(), $ && $.stopPropagation && Et($.stopPropagation) && $.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
        var oe = DV();
        oe !== null && oe instanceof HTMLButtonElement && (oe.attributes && oe.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? pt(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : pt(!1)));
      }
      M().catch(function (T) {
        console.warn("Warning: An unhandled error was caught from submitForm()", T);
      });
    }),
    Q = {
      resetForm: Y,
      validateForm: ye,
      validateField: K,
      setErrors: fe,
      setFieldError: H,
      setFieldTouched: W,
      setFieldValue: O,
      setStatus: x,
      setSubmitting: A,
      setTouched: ie,
      setValues: ce,
      setFormikState: se,
      submitForm: M
    },
    L = Ft(function () {
      return c(w.values, Q);
    }),
    ve = Ft(function ($) {
      $ && $.preventDefault && Et($.preventDefault) && $.preventDefault(), $ && $.stopPropagation && Et($.stopPropagation) && $.stopPropagation(), Y();
    }),
    re = React.useCallback(function ($) {
      return {
        value: bt(w.values, $),
        error: bt(w.errors, $),
        touched: !!bt(w.touched, $),
        initialValue: bt(p.current, $),
        initialTouched: !!bt(m.current, $),
        initialError: bt(v.current, $)
      };
    }, [w.errors, w.touched, w.values]),
    _e = React.useCallback(function ($) {
      return {
        setValue: function setValue(T, R) {
          return O($, T, R);
        },
        setTouched: function setTouched(T, R) {
          return W($, T, R);
        },
        setError: function setError(T) {
          return H($, T);
        }
      };
    }, [O, W, H]),
    xe = React.useCallback(function ($) {
      var oe = ds($),
        T = oe ? $.name : $,
        R = bt(w.values, T),
        z = {
          name: T,
          value: R,
          onChange: B,
          onBlur: ue
        };
      if (oe) {
        var j = $.type,
          ae = $.value,
          ge = $.as,
          Pe = $.multiple;
        j === "checkbox" ? ae === void 0 ? z.checked = !!R : (z.checked = !!(Array.isArray(R) && ~R.indexOf(ae)), z.value = ae) : j === "radio" ? (z.checked = R === ae, z.value = ae) : ge === "select" && Pe && (z.value = z.value || [], z.multiple = !0);
      }
      return z;
    }, [ue, B, w.values]),
    Ee = React.useMemo(function () {
      return !gn(p.current, w.values);
    }, [p.current, w.values]),
    tt = React.useMemo(function () {
      return typeof s < "u" ? Ee ? w.errors && Object.keys(w.errors).length === 0 : s !== !1 && Et(s) ? s(h) : s : w.errors && Object.keys(w.errors).length === 0;
    }, [s, Ee, w.errors, h]),
    nt = ze({}, w, {
      initialValues: p.current,
      initialErrors: v.current,
      initialTouched: m.current,
      initialStatus: g.current,
      handleBlur: ue,
      handleChange: B,
      handleReset: ve,
      handleSubmit: N,
      resetForm: Y,
      setErrors: fe,
      setFormikState: se,
      setFieldTouched: W,
      setFieldValue: O,
      setFieldError: H,
      setStatus: x,
      setSubmitting: A,
      setTouched: ie,
      setValues: ce,
      submitForm: M,
      validateForm: ye,
      validateField: K,
      isValid: tt,
      dirty: Ee,
      unregisterField: ne,
      registerField: ee,
      getFieldProps: xe,
      getFieldMeta: re,
      getFieldHelpers: _e,
      validateOnBlur: a,
      validateOnChange: n,
      validateOnMount: o
    });
  return nt;
}
function RV(e) {
  var t = CV(e),
    n = e.component,
    r = e.children,
    a = e.render,
    i = e.innerRef;
  return React.useImperativeHandle(i, function () {
    return t;
  }), process.env.NODE_ENV !== "production" && React.useEffect(function () {
    e.render && (process.env.NODE_ENV !== "production" ? pt(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : pt(!1));
  }, []), React.createElement(xV, {
    value: t
  }, n ? React.createElement(n, t) : a ? a(t) : r ? Et(r) ? r(t) : ad(r) ? null : React.Children.only(r) : null);
}
function bv(e) {
  var t = e.htmlContent,
    n = e.documentationAnchorLink,
    r = e.handlerName;
  console.warn("Warning: Formik called `" + r + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + t + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + n + "\n  ");
}
function NV(e) {
  var t = {};
  if (e.inner) {
    if (e.inner.length === 0) return Zt(t, e.path, e.message);
    for (var a = e.inner, n = Array.isArray(a), r = 0, a = n ? a : a[Symbol.iterator]();;) {
      var i;
      if (n) {
        if (r >= a.length) break;
        i = a[r++];
      } else {
        if (r = a.next(), r.done) break;
        i = r.value;
      }
      var o = i;
      bt(t, o.path) || (t = Zt(t, o.path, o.message));
    }
  }
  return t;
}
function AV(e, t, n, r) {
  n === void 0 && (n = !1), r === void 0 && (r = {});
  var a = $c(e);
  return t[n ? "validateSync" : "validate"](a, {
    abortEarly: !1,
    context: r
  });
}
function $c(e) {
  var t = Array.isArray(e) ? [] : {};
  for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
    var r = String(n);
    Array.isArray(e[r]) === !0 ? t[r] = e[r].map(function (a) {
      return Array.isArray(a) === !0 || Wm(a) ? $c(a) : a !== "" ? a : void 0;
    }) : Wm(e[r]) ? t[r] = $c(e[r]) : t[r] = e[r] !== "" ? e[r] : void 0;
  }
  return t;
}
function IV(e, t, n) {
  var r = e.slice();
  return t.forEach(function (i, o) {
    if (typeof r[o] > "u") {
      var s = n.clone !== !1,
        u = s && n.isMergeableObject(i);
      r[o] = u ? Pc(Array.isArray(i) ? [] : {}, i, n) : i;
    } else n.isMergeableObject(i) ? r[o] = Pc(e[o], i, n) : e.indexOf(i) === -1 && r.push(i);
  }), r;
}
function MV(e) {
  return Array.from(e).filter(function (t) {
    return t.selected;
  }).map(function (t) {
    return t.value;
  });
}
function FV(e, t, n) {
  if (typeof e == "boolean") return Boolean(t);
  var r = [],
    a = !1,
    i = -1;
  if (Array.isArray(e)) r = e, i = e.indexOf(n), a = i >= 0;else if (!n || n == "true" || n == "false") return Boolean(t);
  return t && n && !a ? r.concat(n) : a ? r.slice(0, i).concat(r.slice(i + 1)) : r;
}
var LV = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? React.useLayoutEffect : React.useEffect;
function Ft(e) {
  var t = React.useRef(e);
  return LV(function () {
    t.current = e;
  }), React.useCallback(function () {
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++) r[a] = arguments[a];
    return t.current.apply(void 0, r);
  }, []);
}
function It(e) {
  var t = e.validate,
    n = e.name,
    r = e.render,
    a = e.children,
    i = e.as,
    o = e.component,
    s = Ln(e, ["validate", "name", "render", "children", "as", "component"]),
    u = C_(),
    l = Ln(u, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && React.useEffect(function () {
    r && (process.env.NODE_ENV !== "production" ? pt(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + n + '" render={({field, form}) => ...} /> with <Field name="' + n + '">{({field, form, meta}) => ...}</Field>') : pt(!1)), i && a && Et(a) && (process.env.NODE_ENV !== "production" ? pt(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : pt(!1)), o && a && Et(a) && (process.env.NODE_ENV !== "production" ? pt(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : pt(!1)), r && a && !ad(a) && (process.env.NODE_ENV !== "production" ? pt(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : pt(!1));
  }, []);
  var c = l.registerField,
    f = l.unregisterField;
  React.useEffect(function () {
    return c(n, {
      validate: t
    }), function () {
      f(n);
    };
  }, [c, f, n, t]);
  var h = l.getFieldProps(ze({
      name: n
    }, s)),
    p = l.getFieldMeta(n),
    v = {
      field: h,
      form: l
    };
  if (r) return r(ze({}, v, {
    meta: p
  }));
  if (Et(a)) return a(ze({}, v, {
    meta: p
  }));
  if (o) {
    if (typeof o == "string") {
      var m = s.innerRef,
        g = Ln(s, ["innerRef"]);
      return React.createElement(o, ze({
        ref: m
      }, h, g), a);
    }
    return React.createElement(o, ze({
      field: h,
      form: l
    }, s), a);
  }
  var b = i || "input";
  if (typeof b == "string") {
    var y = s.innerRef,
      E = Ln(s, ["innerRef"]);
    return React.createElement(b, ze({
      ref: y
    }, h, E), a);
  }
  return React.createElement(b, ze({}, h, s), a);
}
var R_ = /* @__PURE__ */React.forwardRef(function (e, t) {
  var n = e.action,
    r = Ln(e, ["action"]),
    a = n !== null && n !== void 0 ? n : "#",
    i = C_(),
    o = i.handleReset,
    s = i.handleSubmit;
  return React.createElement("form", Object.assign({
    onSubmit: s,
    ref: t,
    onReset: o,
    action: a
  }, r));
});
R_.displayName = "Form";
var Vo = function Vo(_ref50) {
    var _ref50$height = _ref50.height,
      e = _ref50$height === void 0 ? "16px" : _ref50$height,
      _ref50$width = _ref50.width,
      t = _ref50$width === void 0 ? "16px" : _ref50$width;
    return /* @__PURE__ */F("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      version: "1.1",
      x: "0px",
      y: "0px",
      viewBox: "0 0 100 100",
      enableBackground: "new 0 0 100 100",
      xmlSpace: "preserve",
      style: {
        height: e,
        width: t
      },
      children: [/* @__PURE__ */d("path", {
        d: "M50,5c24.813,0,45,20.187,45,45c0,24.813-20.187,45-45,45C25.187,95,5,74.813,5,50C5,25.187,25.187,5,50,5   M50,0C22.386,0,0,22.386,0,50c0,27.614,22.386,50,50,50c27.614,0,50-22.386,50-50C100,22.386,77.614,0,50,0L50,0z"
      }), /* @__PURE__ */d("circle", {
        cx: "50",
        cy: "29.546",
        r: "4.934"
      }), /* @__PURE__ */d("rect", {
        x: "46.5",
        y: "41.21",
        width: "7",
        height: "34.179"
      })]
    });
  },
  UV = {
    nl: "https://insurances.bukazu.com/nl/Voorwaarden%20Annuleringsverzekering.pdf",
    de: "https://insurances.bukazu.com/de/Bedingungen%20Reiseruecktrittsversicherung.pdf",
    en: "https://insurances.bukazu.com/en/Terms%20to%20Cancellation%20Insurance.pdf",
    es: "https://insurances.bukazu.com/en/Terms%20to%20Cancellation%20Insurance.pdf",
    it: "https://insurances.bukazu.com/en/Terms%20to%20Cancellation%20Insurance.pdf",
    fr: "https://insurances.bukazu.com/en/Terms%20to%20Cancellation%20Insurance.pdf"
  },
  zV = function zV() {
    var _React$useContext2 = React.useContext(Vt),
      e = _React$useContext2.locale;
    return /* @__PURE__ */F(vt, {
      children: [/* @__PURE__ */d("h2", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance"
        })
      }), /* @__PURE__ */d("hr", {}), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance_desc"
        })
      }), /* @__PURE__ */d("h3", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance_normal_long"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance_normal_desc"
        })
      }), /* @__PURE__ */d("h3", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance_all_risk_long"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "cancel_insurance_all_risk_desc"
        })
      }), /* @__PURE__ */d("h3", {
        children: /* @__PURE__ */d(J, {
          id: "terms_and_costs"
        })
      }), /* @__PURE__ */d("h4", {
        children: /* @__PURE__ */d(J, {
          id: "costs_normal_cancel_insurance"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "666_costs"
        })
      }), /* @__PURE__ */d("h4", {
        children: /* @__PURE__ */d(J, {
          id: "costs_allrisk_cancel_insurance"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "847_costs"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "more_information"
        })
      }), /* @__PURE__ */d("a", {
        href: UV[e],
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */d(J, {
          id: "show_terms"
        })
      }), /* @__PURE__ */d("h3", {
        children: /* @__PURE__ */d(J, {
          id: "terms"
        })
      }), /* @__PURE__ */F("ul", {
        children: [/* @__PURE__ */d("li", {
          children: /* @__PURE__ */d(J, {
            id: "9persons_9addresses"
          })
        }), /* @__PURE__ */d("li", {
          children: /* @__PURE__ */d("strong", {
            children: /* @__PURE__ */d(J, {
              id: "or"
            })
          })
        }), /* @__PURE__ */d("li", {
          children: /* @__PURE__ */d(J, {
            id: "9persons_4addresses"
          })
        })]
      }), /* @__PURE__ */d("hr", {}), /* @__PURE__ */d("h2", {
        children: /* @__PURE__ */d(J, {
          id: "poliscosts"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "poliscosts_are"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "youwillrecieve"
        })
      })]
    });
  };
function id(e) {
  return Array.apply(null, {
    length: e + 1
  }).map(Number.call, Number);
}
function HV(e) {
  var t = {};
  return e.map(function (n) {
    t[n.id] = "";
  }), t;
}
function _v(e, t) {
  t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, "");
  for (var n = t.split("."), r = 0, a = n.length; r < a; ++r) {
    var i = n[r];
    if (i in e) e = e[i];else return;
  }
  return e;
}
function Wa(e, t) {
  return /* @__PURE__ */d(J, {
    id: e,
    children: function children(n) {
      return /* @__PURE__ */d("option", {
        value: t,
        children: n
      });
    }
  });
}
function WV(e) {
  var t = new Date(e),
    n = _D(new Date(), 18);
  return !!fr(t, n);
}
function zi(_ref51) {
  var e = _ref51.label,
    t = _ref51.description,
    n = _ref51.count,
    r = _objectWithoutProperties2(_ref51, _excluded);
  var a = id(n);
  return /* @__PURE__ */d(It, {
    name: r.name,
    children: function children(_ref52) {
      var i = _ref52.field,
        o = _ref52.meta;
      return /* @__PURE__ */F("div", {
        className: "form-row inline",
        id: "bukazu_form_".concat(r.name),
        children: [/* @__PURE__ */d("label", {
          htmlFor: r.name,
          children: /* @__PURE__ */d(J, {
            id: e
          })
        }), /* @__PURE__ */d("select", _objectSpread2(_objectSpread2(_objectSpread2({}, i), r), {}, {
          children: a.map(function (s) {
            return /* @__PURE__ */d("option", {
              value: s,
              children: s
            }, s);
          })
        })), t, o.touched && o.error && /* @__PURE__ */d("div", {
          className: "error-message",
          children: o.error
        })]
      });
    }
  });
}
zi.defaultProps = {
  count: 2
};
function od(_ref53) {
  var e = _ref53.label,
    t = _ref53.description,
    n = _ref53.name,
    r = _ref53.inline;
  return /* @__PURE__ */d(It, {
    name: n,
    children: function children(_ref54) {
      var a = _ref54.field,
        i = _ref54.meta,
        o = _ref54.form;
      var s = a.value,
        u = a.name;
      var l;
      return s === "" || !s ? l = null : l = new Date(s), /* @__PURE__ */F("div", {
        className: "form-row ".concat(r && "inline"),
        id: "bukazu_form_".concat(u),
        children: [/* @__PURE__ */d("label", {
          htmlFor: u,
          children: /* @__PURE__ */d(J, {
            id: e
          })
        }), /* @__PURE__ */d(Sb, {
          className: "bukazu-date-picker",
          name: u,
          format: "dd-MM-y",
          value: l,
          onChange: function onChange(c) {
            a.onChange(la(c, "yyyy-MM-dd")), o.setFieldValue(u, la(c, "yyyy-MM-dd"));
          }
        }), /* @__PURE__ */d("span", {
          className: "bu-input-description",
          children: t
        }), i.touched && i.error && /* @__PURE__ */d("div", {
          className: "error-message",
          children: i.error
        })]
      });
    }
  });
}
od.defaultValues = {
  inline: !0
};
function GV(e) {
  if (e.cancel_insurance) return /* @__PURE__ */F("div", {
    className: "form-row inline",
    children: [/* @__PURE__ */d("label", {
      htmlFor: "cancel_insurance",
      children: /* @__PURE__ */d(J, {
        id: "cancel_insurance"
      })
    }), /* @__PURE__ */F(It, {
      component: "select",
      name: "cancel_insurance",
      required: !0,
      children: [Wa("choose", ""), Wa("cancel_insurance_all_risk", "2"), Wa("cancel_insurance_normal", "1"), Wa("none", "0")]
    }), /* @__PURE__ */d(on, {
      buttonText: /* @__PURE__ */d(Vo, {}),
      children: /* @__PURE__ */d(zV, {})
    })]
  });
}
var YV = function YV(_ref55) {
  var e = _ref55.house,
    t = _ref55.values;
  return e.cancel_insurance ? /* @__PURE__ */F("div", {
    className: "form-section",
    id: "insurances",
    children: [/* @__PURE__ */d("h2", {
      children: /* @__PURE__ */d(J, {
        id: "insurances"
      })
    }), GV(e), t.cancel_insurance && t.cancel_insurance !== "0" && /* @__PURE__ */d(od, {
      label: "extra_fields.date_of_birth",
      name: "extra_fields.date_of_birth",
      required: !0,
      inline: !1,
      description: /* @__PURE__ */d(J, {
        id: "insurance_company_needs_date_of_birth"
      })
    })]
  }) : /* @__PURE__ */d("div", {});
};
function QV(_ref56) {
  var e = _ref56.house;
  var _Py = Py(KV),
    _Py2 = _slicedToArray2(_Py, 2),
    t = _Py2[0],
    _Py2$ = _Py2[1],
    n = _Py2$.loading,
    r = _Py2$.error,
    a = _Py2$.data;
  return /* @__PURE__ */F("div", {
    className: "form-row inline",
    children: [/* @__PURE__ */d("label", {
      htmlFor: "discount_code",
      children: /* @__PURE__ */d(J, {
        id: "discount_code"
      })
    }), /* @__PURE__ */d(It, {
      name: "discount_code",
      children: function children(_ref57) {
        var i = _ref57.field,
          o = _ref57.form;
        return /* @__PURE__ */d("input", _objectSpread2(_objectSpread2({}, i), {}, {
          onChange: function onChange(s) {
            t({
              variables: {
                code: s.target.value,
                house_code: e.code
              }
            }), o.setFieldValue(i.name, s.target.value);
          }
        }));
      }
    }), n && /* @__PURE__ */d("div", {
      className: "bu_discount_code",
      children: "Loading..."
    }), r && /* @__PURE__ */d("div", {
      className: "bu_discount_code",
      children: /* @__PURE__ */d(J, {
        id: "no_discount_code_found"
      })
    }), a && /* @__PURE__ */F("div", {
      className: "bu_discount_code",
      children: [/* @__PURE__ */d("div", {
        children: a.checkDiscountCode.name
      }), a.checkDiscountCode.use_price ? /* @__PURE__ */F("div", {
        children: ["€ ", a.checkDiscountCode.price]
      }) : /* @__PURE__ */F("div", {
        children: [a.checkDiscountCode.percentage, "%"]
      })]
    })]
  });
}
var KV = wt(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral2(["\n  mutation CheckDiscountCode($code: String!, $house_code: String!) {\n    checkDiscountCode(code: $code, house_code: $house_code) {\n      name\n      use_price\n      percentage\n      price\n    }\n  }\n"]))),
  N_ = function N_(_ref58) {
    var e = _ref58.errors,
      t = _ref58.house,
      n = _ref58.options,
      r = _ref58.values;
    var a, i;
    if (t.discounts && t.discounts !== "0" || (a = n.bookingForm) != null && a.showDiscountCode) {
      var o = t.discounts ? t.discounts.split(",") : [];
      return /* @__PURE__ */F("div", {
        className: "form-section",
        children: [t.discounts && t.discounts !== "0" && /* @__PURE__ */F(vt, {
          children: [/* @__PURE__ */F("div", {
            className: "form-row inline",
            children: [/* @__PURE__ */d("label", {
              htmlFor: "discount",
              children: /* @__PURE__ */d(J, {
                id: "discount"
              })
            }), /* @__PURE__ */d(It, {
              component: "select",
              name: "discount",
              children: o.map(function (s) {
                return /* @__PURE__ */F("option", {
                  value: s,
                  children: [s, "%"]
                }, s);
              })
            })]
          }), /* @__PURE__ */F("div", {
            className: "form-row inline",
            children: [/* @__PURE__ */d("label", {
              htmlFor: "discount_reason",
              children: /* @__PURE__ */d(J, {
                id: "discount_reason"
              })
            }), /* @__PURE__ */d(It, {
              name: "discount_reason"
            }), e.discount_reason && /* @__PURE__ */d("div", {
              className: "error-message",
              children: e.discount_reason
            })]
          }), /* @__PURE__ */d("div", {
            children: /* @__PURE__ */d("i", {
              style: {
                fontSize: 14
              },
              children: t.discounts_info
            })
          })]
        }), ((i = n.bookingForm) == null ? void 0 : i.showDiscountCode) && /* @__PURE__ */d(QV, {
          errors: e,
          house: t,
          values: r
        })]
      });
    } else return null;
  };
N_.propTypes = {
  house: k.object.isRequired,
  errors: k.object.isRequired
};
var A_ = function A_(_ref59) {
  var e = _ref59.error;
  return e ? /* @__PURE__ */d("div", {
    className: "input-feedback",
    children: e
  }) : null;
};
A_.propTypes = {
  error: k.object
};
var Cc = function Cc(_ref60) {
  var _ref60$field = _ref60.field,
    e = _ref60$field.name,
    t = _ref60$field.value,
    n = _ref60$field.onChange,
    r = _ref60$field.onBlur,
    a = _ref60.id,
    i = _ref60.label,
    o = _objectWithoutProperties2(_ref60, _excluded2);
  return /* @__PURE__ */F("div", {
    children: [/* @__PURE__ */d("input", _objectSpread2({
      name: e,
      id: a,
      type: "radio",
      value: a,
      checked: a === t,
      onChange: n,
      onBlur: r,
      className: "radio-button"
    }, o)), /* @__PURE__ */d("label", {
      htmlFor: a,
      children: i
    })]
  });
};
Cc.propTypes = {
  field: k.object,
  id: k.string,
  label: k.object
};
var I_ = function I_(_ref61) {
  var e = _ref61.error,
    t = _ref61.touched,
    n = _ref61.label,
    r = _ref61.className,
    a = _ref61.children;
  return /* @__PURE__ */F("div", {
    className: r,
    children: [/* @__PURE__ */d("div", {
      className: "legend",
      children: n
    }), a, t && /* @__PURE__ */d(A_, {
      error: e
    })]
  });
};
I_.propTypes = {
  error: k.object,
  touched: k.object,
  className: k.string,
  label: k.string,
  children: k.node.isRequired
};
function JV(_ref62) {
  var e = _ref62.house;
  return /* @__PURE__ */d(vt, {
    children: e.allow_option && /* @__PURE__ */d("div", {
      children: /* @__PURE__ */F(I_, {
        id: "is_option",
        className: "booking_option",
        children: [/* @__PURE__ */d(It, {
          component: Cc,
          name: "is_option",
          id: "true",
          disabled: !e.allow_option,
          label: /* @__PURE__ */d(J, {
            id: "option"
          })
        }), /* @__PURE__ */d(It, {
          component: Cc,
          name: "is_option",
          id: "false",
          label: /* @__PURE__ */d(J, {
            id: "booking"
          })
        })]
      })
    })
  });
}
function XV(_ref63) {
  var e = _ref63.description;
  var t = /* @__PURE__ */d("span", {});
  return e && (t = /* @__PURE__ */d("span", {
    style: {
      padding: "0 0 0 8px"
    },
    children: /* @__PURE__ */d(on, {
      buttonText: /* @__PURE__ */d(Vo, {}),
      children: /* @__PURE__ */d("p", {
        children: e
      })
    })
  })), t;
}
function Pt(_ref64) {
  var e = _ref64.name,
    t = _ref64.amount,
    n = _ref64.description,
    r = _ref64.method_name,
    a = _ref64.formatName,
    i = _ref64.forceMethod;
  return /* @__PURE__ */F("tr", {
    children: [/* @__PURE__ */F("td", {
      children: [a ? /* @__PURE__ */d(J, {
        id: e
      }) : e, n && /* @__PURE__ */F(vt, {
        children: [" ", /* @__PURE__ */d(XV, {
          description: n
        })]
      })]
    }), /* @__PURE__ */d("td", {
      className: "price",
      children: t && t > 0 ? /* @__PURE__ */F(vt, {
        children: ["€", " ", /* @__PURE__ */d(Pn, {
          value: t,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }), i && /* @__PURE__ */F(vt, {
          children: [" ", r]
        })]
      }) : /* @__PURE__ */d(vt, {
        children: r
      })
    })]
  });
}
Pt.defaultValues = {
  formatName: !1,
  forceMethod: !1
};
function ZV(_ref65) {
  var e = _ref65.prices;
  var _e$total_costs = e.total_costs,
    t = _e$total_costs.insurances,
    n = _e$total_costs.required_costs,
    r = n.not_on_site;
  return /* @__PURE__ */d("div", {
    className: "costs-section",
    children: /* @__PURE__ */d("table", {
      children: /* @__PURE__ */F("tbody", {
        children: [t.cancel_insurance && /* @__PURE__ */d(vt, {
          children: Object.keys(t).map(function (a) {
            return /* @__PURE__ */d(Pt, {
              name: a,
              formatName: !0,
              amount: t[a]
            }, a);
          })
        }), e.required_house_costs.map(function (a) {
          if (!a.on_site && a.gl !== "0120") return a.method === "none" ? /* @__PURE__ */d(Pt, _objectSpread2({}, a), a.id) : a.amount === 0 ? null : /* @__PURE__ */d(Pt, {
            name: a.name,
            amount: r == null ? void 0 : r.find(function (i) {
              return i.id == a.id;
            }).amount
          }, a.id);
        })]
      })
    })
  });
}
var eq = wt(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral2(["\n  query BookingPriceTotalQuery(\n    $id: ID!\n    $house_id: String!\n    $starts_at: Date!\n    $ends_at: Date!\n    $persons: Int\n    $costs: Json\n    $cancel_insurance: Int\n    $discount: Int\n    $discount_code: String\n  ) {\n    PortalSite(id: $id) {\n      houses(house_code: $house_id) {\n        id\n        name\n        booking_price(\n          starts_at: $starts_at\n          ends_at: $ends_at\n          persons: $persons\n          costs: $costs\n          cancel_insurance: $cancel_insurance\n          discount: $discount\n          discount_code: $discount_code\n        )\n      }\n    }\n  }\n"])));
function tq(_ref66) {
  var e = _ref66.prices;
  var t = e.rent_price,
    n = e.discount,
    r = e.discounted_price;
  return /* @__PURE__ */d("div", {
    className: "costs-section",
    children: /* @__PURE__ */d("table", {
      children: /* @__PURE__ */F("tbody", {
        children: [/* @__PURE__ */d(Pt, {
          name: "rent_price",
          formatName: !0,
          amount: t
        }), n > 0 ? /* @__PURE__ */F(vt, {
          children: [/* @__PURE__ */d(Pt, {
            name: "discount",
            formatName: !0,
            amount: n
          }), /* @__PURE__ */d(Pt, {
            name: "price_after_discount",
            formatName: !0,
            amount: r
          })]
        }) : null]
      })
    })
  });
}
function nq(_ref67) {
  var e = _ref67.prices;
  var t = e.total_costs.optional_costs,
    n = t.not_on_site;
  return /* @__PURE__ */d("div", {
    className: "costs-section",
    children: /* @__PURE__ */d("table", {
      children: /* @__PURE__ */d("tbody", {
        children: e.optional_house_costs.map(function (r) {
          if (!r.on_site && r.gl !== "0120") {
            if (r.method === "none") return /* @__PURE__ */d(Pt, _objectSpread2({}, r), r.id);
            if (r.method === "on_site") {
              if (n.find(function (a) {
                return a.id == r.id;
              }).nr_of_items > 0) return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, r), {}, {
                amount: r.amount,
                forceMethod: !0
              }), r.id);
            } else {
              var a = n.find(function (i) {
                return i.id == r.id;
              }).amount;
              if (a > 0) return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, r), {}, {
                amount: a
              }), r.id);
            }
          }
        })
      })
    })
  });
}
function rq(_ref68) {
  var e = _ref68.prices;
  var t = e.total_costs.optional_costs,
    n = t.on_site;
  return /* @__PURE__ */d(vt, {
    children: e.optional_house_costs.map(function (r) {
      if (r.on_site && r.gl !== "0120") {
        if (r.method === "none") return /* @__PURE__ */d(Pt, _objectSpread2({}, r), r.id);
        if (r.method === "on_site") {
          if ((n == null ? void 0 : n.find(function (a) {
            return a.id == r.id;
          }).nr_of_items) > 0) return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, r), {}, {
            amount: r.amount,
            forceMethod: !0
          }), r.id);
        } else {
          var a = n == null ? void 0 : n.find(function (i) {
            return i.id == r.id;
          }).amount;
          if (a > 0) return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, r), {}, {
            amount: a
          }), r.id);
        }
      }
    })
  });
}
function aq(_ref69) {
  var e = _ref69.prices;
  var t = e.total_costs.required_costs,
    n = t.on_site;
  return /* @__PURE__ */F("div", {
    className: "costs-section",
    children: [/* @__PURE__ */d("strong", {
      children: /* @__PURE__ */d(J, {
        id: "costs_on_site"
      })
    }), /* @__PURE__ */d("table", {
      children: /* @__PURE__ */F("tbody", {
        children: [e.required_house_costs.map(function (r) {
          var a;
          if (r.on_site && r.gl !== "0120") {
            if (r.method === "none") return /* @__PURE__ */d(Pt, _objectSpread2({}, r), r.id);
            {
              var i = (a = n.find(function (o) {
                return o.id == r.id;
              })) == null ? void 0 : a.amount;
              return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, r), {}, {
                amount: i
              }), r.id);
            }
          }
        }), /* @__PURE__ */d(rq, {
          prices: e
        })]
      })
    })]
  });
}
function au(_ref70) {
  var e = _ref70.children;
  return /* @__PURE__ */d("div", {
    className: "costs-section",
    children: /* @__PURE__ */d("table", {
      children: /* @__PURE__ */d("tbody", {
        children: e
      })
    })
  });
}
function iq(_ref71) {
  var e = _ref71.prices;
  return /* @__PURE__ */F(vt, {
    children: [/* @__PURE__ */d(au, {
      children: /* @__PURE__ */F("tr", {
        children: [/* @__PURE__ */d("th", {
          style: {
            textAlign: "left",
            testTransform: "capitalize"
          },
          children: /* @__PURE__ */d(J, {
            id: "total"
          })
        }), /* @__PURE__ */F("th", {
          className: "price",
          style: {
            fontSize: 18
          },
          children: ["€", " ", /* @__PURE__ */d(Pn, {
            value: e.total_costs.sub_total,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })]
        })]
      })
    }), /* @__PURE__ */F(au, {
      children: [/* @__PURE__ */d(Ga, {
        cost_array: e.required_house_costs,
        price_array: e.total_costs.required_costs.on_site
      }), /* @__PURE__ */d(Ga, {
        cost_array: e.required_house_costs,
        price_array: e.total_costs.required_costs.not_on_site
      }), /* @__PURE__ */d(Ga, {
        cost_array: e.optional_house_costs,
        price_array: e.total_costs.optional_costs.on_site
      }), /* @__PURE__ */d(Ga, {
        cost_array: e.optional_house_costs,
        price_array: e.total_costs.optional_costs.not_on_site
      })]
    }), /* @__PURE__ */d(au, {
      children: /* @__PURE__ */F("tr", {
        children: [/* @__PURE__ */d("th", {
          style: {
            textAlign: "left",
            testTransform: "capitalize"
          },
          children: /* @__PURE__ */d(J, {
            id: "total"
          })
        }), /* @__PURE__ */F("td", {
          className: "price",
          children: ["€", " ", /* @__PURE__ */d(Pn, {
            value: e.total_costs.total_price,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })]
        })]
      })
    })]
  });
}
function Ga(_ref72) {
  var e = _ref72.cost_array,
    t = _ref72.price_array;
  return /* @__PURE__ */d(vt, {
    children: e.map(function (n) {
      var r = t.find(function (a) {
        return a.id == n.id;
      });
      if (n.gl === "0120" && (r == null ? void 0 : r.amount) > 0) return /* @__PURE__ */d(Pt, _objectSpread2(_objectSpread2({}, n), {}, {
        amount: r.amount
      }), n.id);
    })
  });
}
function oq(_ref73) {
  var e = _ref73.values,
    t = _ref73.house;
  var n = Number(e.babies) - Number(t.babies_extra);
  n < 0 && (n = 0);
  var r = Number(e.children) + Number(e.adults) + n,
    _React$useContext3 = React.useContext(Vt),
    a = _React$useContext3.portalCode,
    i = _React$useContext3.objectCode,
    _ln3 = ln(eq, {
      variables: {
        id: a,
        persons: r,
        house_id: i,
        starts_at: JSON.stringify(e.arrivalDate.date),
        ends_at: JSON.stringify(e.departureDate.date),
        costs: JSON.stringify(e.costs),
        discount: Number(e.discount),
        discount_code: e.discount_code,
        cancel_insurance: Number(e.cancel_insurance)
      },
      fetchPolicy: "network-only"
    }),
    o = _ln3.loading,
    s = _ln3.error,
    u = _ln3.data;
  if (o) return "Loading...";
  if (s) return /* @__PURE__ */d("div", {
    children: JSON.stringify(s)
  });
  var l = u.PortalSite.houses[0].booking_price;
  return /* @__PURE__ */F(vt, {
    children: [/* @__PURE__ */d(tq, {
      prices: l
    }), /* @__PURE__ */d(ZV, {
      prices: l
    }), /* @__PURE__ */d(nq, {
      prices: l
    }), /* @__PURE__ */d(aq, {
      prices: l
    }), /* @__PURE__ */d(iq, {
      prices: l
    })]
  });
}
var M_ = function M_(_ref74) {
  var e = _ref74.house,
    t = _ref74.values;
  var n = t.arrivalDate,
    r = t.departureDate;
  return /* @__PURE__ */F(React__default["default"].Fragment, {
    children: [/* @__PURE__ */d("h2", {
      children: /* @__PURE__ */d(J, {
        id: "booking_details"
      })
    }), /* @__PURE__ */F("div", {
      className: "house-details",
      children: [/* @__PURE__ */d("div", {
        children: e.name
      }), /* @__PURE__ */d("img", {
        src: e.image_url,
        alt: ""
      }), /* @__PURE__ */d("table", {
        children: /* @__PURE__ */F("tbody", {
          children: [/* @__PURE__ */F("tr", {
            children: [/* @__PURE__ */d("th", {
              children: /* @__PURE__ */d(J, {
                id: "".concat(e.house_type, ".arrival")
              })
            }), /* @__PURE__ */d("td", {
              className: "price",
              children: jt($t(n.date), gr)
            }), /* @__PURE__ */F("td", {
              children: [n.arrival_time_from, " - ", n.arrival_time_to]
            })]
          }), /* @__PURE__ */F("tr", {
            children: [/* @__PURE__ */d("th", {
              children: /* @__PURE__ */d(J, {
                id: "".concat(e.house_type, ".departure")
              })
            }), /* @__PURE__ */d("td", {
              className: "price",
              children: jt($t(r.date), gr)
            }), /* @__PURE__ */d("td", {
              children: r.departure_time
            })]
          })]
        })
      })]
    })]
  });
};
M_.propTypes = {
  house: k.object.isRequired,
  values: k.object.isRequired
};
function sq(_ref75) {
  var e = _ref75.values,
    t = _ref75.house;
  return /* @__PURE__ */F("div", {
    children: [/* @__PURE__ */d(M_, {
      house: t,
      values: e
    }), /* @__PURE__ */d(JV, {
      house: t
    }), /* @__PURE__ */d(oq, {
      values: e,
      house: t
    })]
  });
}
var Rc = [{
    id: "first_name",
    label: "Voornaam",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "preposition",
    label: "Tussenvoegsel",
    type: "text",
    options: ["text"],
    required: !1,
    placeholder: ""
  }, {
    id: "last_name",
    label: "Achternaam",
    type: "text",
    options: ["text"],
    required: !0,
    mandatory: !0,
    placeholder: ""
  }, {
    id: "address",
    label: "Adres",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "house_number",
    label: "Huisnummer",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "zipcode",
    label: "Postcode",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "city",
    label: "Plaats",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "country",
    label: "Land",
    type: "select",
    options: ["select"],
    required: !0,
    mandatory: !0,
    placeholder: ""
  }, {
    id: "email",
    label: "E-mail",
    type: "email",
    options: ["email"],
    required: !0,
    mandatory: !0,
    placeholder: ""
  }, {
    id: "phone_mobile",
    label: "Mobiel telefoonnummer",
    type: "text",
    options: ["text"],
    required: !1,
    placeholder: ""
  }, {
    id: "phone",
    label: "Telefoonnummer",
    type: "text",
    options: ["text"],
    required: !0,
    placeholder: ""
  }, {
    id: "comment",
    label: "Opmerking",
    type: "textarea",
    options: ["textarea"],
    required: !1,
    rows: 10
  }],
  uq = function uq() {
    return /* @__PURE__ */F("div", {
      className: "success-message",
      children: [/* @__PURE__ */d("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 125",
        style: {
          enableBackground: "new 0 0 100 100;",
          fill: "green",
          height: "150px"
        },
        xmlSpace: "preserve",
        children: /* @__PURE__ */d("path", {
          d: "M50,5C25.2,5,5,25.1,5,50c0,24.8,20.2,45,45,45s45-20.2,45-45C95,25.1,74.8,5,50,5z M72.7,38.2L44.2,66.7  c-0.4,0.4-0.9,0.6-1.4,0.6s-1-0.2-1.4-0.6l-14-14c-0.8-0.8-0.8-2,0-2.8c0.8-0.8,2-0.8,2.8,0l12.6,12.6l27.1-27.1  c0.8-0.8,2-0.8,2.8,0C73.5,36.1,73.5,37.4,72.7,38.2z"
        })
      }), /* @__PURE__ */d("h3", {
        children: /* @__PURE__ */d(J, {
          id: "thank_you_for_your_request"
        })
      }), /* @__PURE__ */d("p", {
        children: /* @__PURE__ */d(J, {
          id: "we_sent_confirmation_check_email"
        })
      })]
    });
  },
  lq = [{
    name: "Afghanistan",
    alpha2: "af"
  }, {
    name: "Åland",
    alpha2: "ax"
  }, {
    name: "Albanië",
    alpha2: "al"
  }, {
    name: "Algerije",
    alpha2: "dz"
  }, {
    name: "Amerikaanse Maagdeneilanden",
    alpha2: "vi"
  }, {
    name: "Amerikaans-Samoa",
    alpha2: "as"
  }, {
    name: "Andorra",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguilla",
    alpha2: "ai"
  }, {
    name: "Antarctica",
    alpha2: "aq"
  }, {
    name: "Antigua en Barbuda",
    alpha2: "ag"
  }, {
    name: "Argentinië",
    alpha2: "ar"
  }, {
    name: "Armenië",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Australië",
    alpha2: "au"
  }, {
    name: "Azerbeidzjan",
    alpha2: "az"
  }, {
    name: "Bahama's",
    alpha2: "bs"
  }, {
    name: "Bahrein",
    alpha2: "bh"
  }, {
    name: "Bangladesh",
    alpha2: "bd"
  }, {
    name: "Barbados",
    alpha2: "bb"
  }, {
    name: "België",
    alpha2: "be"
  }, {
    name: "Belize",
    alpha2: "bz"
  }, {
    name: "Benin",
    alpha2: "bj"
  }, {
    name: "Bermuda",
    alpha2: "bm"
  }, {
    name: "Bhutan",
    alpha2: "bt"
  }, {
    name: "Bolivia",
    alpha2: "bo"
  }, {
    name: "Caribisch Nederland",
    alpha2: "bq"
  }, {
    name: "Bosnië en Herzegovina",
    alpha2: "ba"
  }, {
    name: "Botswana",
    alpha2: "bw"
  }, {
    name: "Bouveteiland",
    alpha2: "bv"
  }, {
    name: "Brazilië",
    alpha2: "br"
  }, {
    name: "Britse Maagdeneilanden",
    alpha2: "vg"
  }, {
    name: "Brits Indische Oceaanterritorium",
    alpha2: "io"
  }, {
    name: "Brunei",
    alpha2: "bn"
  }, {
    name: "Bulgarije",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Cambodja",
    alpha2: "kh"
  }, {
    name: "Canada",
    alpha2: "ca"
  }, {
    name: "Centraal-Afrikaanse Republiek",
    alpha2: "cf"
  }, {
    name: "Chili",
    alpha2: "cl"
  }, {
    name: "China",
    alpha2: "cn"
  }, {
    name: "Christmaseiland",
    alpha2: "cx"
  }, {
    name: "Cocoseilanden",
    alpha2: "cc"
  }, {
    name: "Colombia",
    alpha2: "co"
  }, {
    name: "Comoren",
    alpha2: "km"
  }, {
    name: "Congo-Brazzaville",
    alpha2: "cg"
  }, {
    name: "Congo-Kinshasa",
    alpha2: "cd"
  }, {
    name: "Cookeilanden",
    alpha2: "ck"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Cuba",
    alpha2: "cu"
  }, {
    name: "Curaçao",
    alpha2: "cw"
  }, {
    name: "Cyprus",
    alpha2: "cy"
  }, {
    name: "Denemarken",
    alpha2: "dk"
  }, {
    name: "Djibouti",
    alpha2: "dj"
  }, {
    name: "Dominica",
    alpha2: "dm"
  }, {
    name: "Dominicaanse Republiek",
    alpha2: "do"
  }, {
    name: "Duitsland",
    alpha2: "de"
  }, {
    name: "Ecuador",
    alpha2: "ec"
  }, {
    name: "Egypte",
    alpha2: "eg"
  }, {
    name: "El Salvador",
    alpha2: "sv"
  }, {
    name: "Equatoriaal-Guinea",
    alpha2: "gq"
  }, {
    name: "Eritrea",
    alpha2: "er"
  }, {
    name: "Estland",
    alpha2: "ee"
  }, {
    name: "Ethiopië",
    alpha2: "et"
  }, {
    name: "Faeröer",
    alpha2: "fo"
  }, {
    name: "Falklandeilanden",
    alpha2: "fk"
  }, {
    name: "Fiji",
    alpha2: "fj"
  }, {
    name: "Filipijnen",
    alpha2: "ph"
  }, {
    name: "Finland",
    alpha2: "fi"
  }, {
    name: "Frankrijk",
    alpha2: "fr"
  }, {
    name: "Franse Zuidelijke en Antarctische Gebieden",
    alpha2: "tf"
  }, {
    name: "Frans-Guyana",
    alpha2: "gf"
  }, {
    name: "Frans-Polynesië",
    alpha2: "pf"
  }, {
    name: "Gabon",
    alpha2: "ga"
  }, {
    name: "Gambia",
    alpha2: "gm"
  }, {
    name: "Georgië",
    alpha2: "ge"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Gibraltar",
    alpha2: "gi"
  }, {
    name: "Grenada",
    alpha2: "gd"
  }, {
    name: "Griekenland",
    alpha2: "gr"
  }, {
    name: "Groenland",
    alpha2: "gl"
  }, {
    name: "Guadeloupe",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guernsey",
    alpha2: "gg"
  }, {
    name: "Guinee",
    alpha2: "gn"
  }, {
    name: "Guinee-Bissau",
    alpha2: "gw"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Haïti",
    alpha2: "ht"
  }, {
    name: "Heard en McDonaldeilanden",
    alpha2: "hm"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hongarije",
    alpha2: "hu"
  }, {
    name: "Hongkong",
    alpha2: "hk"
  }, {
    name: "Ierland",
    alpha2: "ie"
  }, {
    name: "IJsland",
    alpha2: "is"
  }, {
    name: "India",
    alpha2: "in"
  }, {
    name: "Indonesië",
    alpha2: "id"
  }, {
    name: "Irak",
    alpha2: "iq"
  }, {
    name: "Iran",
    alpha2: "ir"
  }, {
    name: "Israël",
    alpha2: "il"
  }, {
    name: "Italië",
    alpha2: "it"
  }, {
    name: "Ivoorkust",
    alpha2: "ci"
  }, {
    name: "Jamaica",
    alpha2: "jm"
  }, {
    name: "Japan",
    alpha2: "jp"
  }, {
    name: "Jemen",
    alpha2: "ye"
  }, {
    name: "Jersey",
    alpha2: "je"
  }, {
    name: "Jordanië",
    alpha2: "jo"
  }, {
    name: "Kaaimaneilanden",
    alpha2: "ky"
  }, {
    name: "Kaapverdië",
    alpha2: "cv"
  }, {
    name: "Kameroen",
    alpha2: "cm"
  }, {
    name: "Kazachstan",
    alpha2: "kz"
  }, {
    name: "Kenia",
    alpha2: "ke"
  }, {
    name: "Kirgizië",
    alpha2: "kg"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Kleine afgelegen eilanden van de Verenigde Staten",
    alpha2: "um"
  }, {
    name: "Koeweit",
    alpha2: "kw"
  }, {
    name: "Kroatië",
    alpha2: "hr"
  }, {
    name: "Laos",
    alpha2: "la"
  }, {
    name: "Lesotho",
    alpha2: "ls"
  }, {
    name: "Letland",
    alpha2: "lv"
  }, {
    name: "Libanon",
    alpha2: "lb"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libië",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Litouwen",
    alpha2: "lt"
  }, {
    name: "Luxemburg",
    alpha2: "lu"
  }, {
    name: "Macau",
    alpha2: "mo"
  }, {
    name: "Macedonië",
    alpha2: "mk"
  }, {
    name: "Madagaskar",
    alpha2: "mg"
  }, {
    name: "Malawi",
    alpha2: "mw"
  }, {
    name: "Maldiven",
    alpha2: "mv"
  }, {
    name: "Maleisië",
    alpha2: "my"
  }, {
    name: "Mali",
    alpha2: "ml"
  }, {
    name: "Malta",
    alpha2: "mt"
  }, {
    name: "Man",
    alpha2: "im"
  }, {
    name: "Marokko",
    alpha2: "ma"
  }, {
    name: "Marshalleilanden",
    alpha2: "mh"
  }, {
    name: "Martinique",
    alpha2: "mq"
  }, {
    name: "Mauritanië",
    alpha2: "mr"
  }, {
    name: "Mauritius",
    alpha2: "mu"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "Mexico",
    alpha2: "mx"
  }, {
    name: "Micronesia",
    alpha2: "fm"
  }, {
    name: "Moldavië",
    alpha2: "md"
  }, {
    name: "Monaco",
    alpha2: "mc"
  }, {
    name: "Mongolië",
    alpha2: "mn"
  }, {
    name: "Montenegro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Mozambique",
    alpha2: "mz"
  }, {
    name: "Myanmar",
    alpha2: "mm"
  }, {
    name: "Namibië",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Nederland",
    alpha2: "nl"
  }, {
    name: "Nepal",
    alpha2: "np"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Nieuw-Caledonië",
    alpha2: "nc"
  }, {
    name: "Nieuw-Zeeland",
    alpha2: "nz"
  }, {
    name: "Niger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Noordelijke Marianen",
    alpha2: "mp"
  }, {
    name: "Noord-Korea",
    alpha2: "kp"
  }, {
    name: "Noorwegen",
    alpha2: "no"
  }, {
    name: "Norfolk",
    alpha2: "nf"
  }, {
    name: "Oeganda",
    alpha2: "ug"
  }, {
    name: "Oekraïne",
    alpha2: "ua"
  }, {
    name: "Oezbekistan",
    alpha2: "uz"
  }, {
    name: "Oman",
    alpha2: "om"
  }, {
    name: "Oostenrijk",
    alpha2: "at"
  }, {
    name: "Oost-Timor",
    alpha2: "tl"
  }, {
    name: "Pakistan",
    alpha2: "pk"
  }, {
    name: "Palau",
    alpha2: "pw"
  }, {
    name: "Palestina",
    alpha2: "ps"
  }, {
    name: "Panama",
    alpha2: "pa"
  }, {
    name: "Papoea-Nieuw-Guinea",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Peru",
    alpha2: "pe"
  }, {
    name: "Pitcairneilanden",
    alpha2: "pn"
  }, {
    name: "Polen",
    alpha2: "pl"
  }, {
    name: "Portugal",
    alpha2: "pt"
  }, {
    name: "Puerto Rico",
    alpha2: "pr"
  }, {
    name: "Qatar",
    alpha2: "qa"
  }, {
    name: "Réunion",
    alpha2: "re"
  }, {
    name: "Roemenië",
    alpha2: "ro"
  }, {
    name: "Rusland",
    alpha2: "ru"
  }, {
    name: "Rwanda",
    alpha2: "rw"
  }, {
    name: "Saint-Barthélemy",
    alpha2: "bl"
  }, {
    name: "Saint Kitts en Nevis",
    alpha2: "kn"
  }, {
    name: "Saint Lucia",
    alpha2: "lc"
  }, {
    name: "Saint-Pierre en Miquelon",
    alpha2: "pm"
  }, {
    name: "Saint Vincent en de Grenadines",
    alpha2: "vc"
  }, {
    name: "Salomonseilanden",
    alpha2: "sb"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "San Marino",
    alpha2: "sm"
  }, {
    name: "Saoedi-Arabië",
    alpha2: "sa"
  }, {
    name: "Sao Tomé en Principe",
    alpha2: "st"
  }, {
    name: "Senegal",
    alpha2: "sn"
  }, {
    name: "Servië",
    alpha2: "rs"
  }, {
    name: "Seychellen",
    alpha2: "sc"
  }, {
    name: "Sierra Leone",
    alpha2: "sl"
  }, {
    name: "Singapore",
    alpha2: "sg"
  }, {
    name: "Sint-Helena, Ascension en Tristan da Cunha",
    alpha2: "sh"
  }, {
    name: "Sint-Maarten",
    alpha2: "mf"
  }, {
    name: "Sint Maarten",
    alpha2: "sx"
  }, {
    name: "Slovenië",
    alpha2: "si"
  }, {
    name: "Slowakije",
    alpha2: "sk"
  }, {
    name: "Soedan",
    alpha2: "sd"
  }, {
    name: "Somalië",
    alpha2: "so"
  }, {
    name: "Spanje",
    alpha2: "es"
  }, {
    name: "Spitsbergen en Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "Suriname",
    alpha2: "sr"
  }, {
    name: "Swaziland",
    alpha2: "sz"
  }, {
    name: "Syrië",
    alpha2: "sy"
  }, {
    name: "Tadzjikistan",
    alpha2: "tj"
  }, {
    name: "Taiwan",
    alpha2: "tw"
  }, {
    name: "Tanzania",
    alpha2: "tz"
  }, {
    name: "Thailand",
    alpha2: "th"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinidad en Tobago",
    alpha2: "tt"
  }, {
    name: "Tsjaad",
    alpha2: "td"
  }, {
    name: "Tsjechië",
    alpha2: "cz"
  }, {
    name: "Tunesië",
    alpha2: "tn"
  }, {
    name: "Turkije",
    alpha2: "tr"
  }, {
    name: "Turkmenistan",
    alpha2: "tm"
  }, {
    name: "Turks- en Caicoseilanden",
    alpha2: "tc"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Vaticaanstad",
    alpha2: "va"
  }, {
    name: "Venezuela",
    alpha2: "ve"
  }, {
    name: "Verenigde Arabische Emiraten",
    alpha2: "ae"
  }, {
    name: "Verenigde Staten",
    alpha2: "us"
  }, {
    name: "Verenigd Koninkrijk",
    alpha2: "gb"
  }, {
    name: "Vietnam",
    alpha2: "vn"
  }, {
    name: "Wallis en Futuna",
    alpha2: "wf"
  }, {
    name: "Westelijke Sahara",
    alpha2: "eh"
  }, {
    name: "Wit-Rusland",
    alpha2: "by"
  }, {
    name: "Zambia",
    alpha2: "zm"
  }, {
    name: "Zimbabwe",
    alpha2: "zw"
  }, {
    name: "Zuid-Afrika",
    alpha2: "za"
  }, {
    name: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    alpha2: "gs"
  }, {
    name: "Zuid-Korea",
    alpha2: "kr"
  }, {
    name: "Zuid-Soedan",
    alpha2: "ss"
  }, {
    name: "Zweden",
    alpha2: "se"
  }, {
    name: "Zwitserland",
    alpha2: "ch"
  }],
  cq = [{
    name: "Afghanistan",
    alpha2: "af"
  }, {
    name: "Åland Islands",
    alpha2: "ax"
  }, {
    name: "Albania",
    alpha2: "al"
  }, {
    name: "Algeria",
    alpha2: "dz"
  }, {
    name: "American Samoa",
    alpha2: "as"
  }, {
    name: "Andorra",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguilla",
    alpha2: "ai"
  }, {
    name: "Antarctica",
    alpha2: "aq"
  }, {
    name: "Antigua and Barbuda",
    alpha2: "ag"
  }, {
    name: "Argentina",
    alpha2: "ar"
  }, {
    name: "Armenia",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Australia",
    alpha2: "au"
  }, {
    name: "Austria",
    alpha2: "at"
  }, {
    name: "Azerbaijan",
    alpha2: "az"
  }, {
    name: "Bahamas",
    alpha2: "bs"
  }, {
    name: "Bahrain",
    alpha2: "bh"
  }, {
    name: "Bangladesh",
    alpha2: "bd"
  }, {
    name: "Barbados",
    alpha2: "bb"
  }, {
    name: "Belarus",
    alpha2: "by"
  }, {
    name: "Belgium",
    alpha2: "be"
  }, {
    name: "Belize",
    alpha2: "bz"
  }, {
    name: "Benin",
    alpha2: "bj"
  }, {
    name: "Bermuda",
    alpha2: "bm"
  }, {
    name: "Bhutan",
    alpha2: "bt"
  }, {
    name: "Bolivia (Plurinational State of)",
    alpha2: "bo"
  }, {
    name: "Bonaire, Sint Eustatius and Saba",
    alpha2: "bq"
  }, {
    name: "Bosnia and Herzegovina",
    alpha2: "ba"
  }, {
    name: "Botswana",
    alpha2: "bw"
  }, {
    name: "Bouvet Island",
    alpha2: "bv"
  }, {
    name: "Brazil",
    alpha2: "br"
  }, {
    name: "British Indian Ocean Territory",
    alpha2: "io"
  }, {
    name: "Brunei Darussalam",
    alpha2: "bn"
  }, {
    name: "Bulgaria",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Cabo Verde",
    alpha2: "cv"
  }, {
    name: "Cambodia",
    alpha2: "kh"
  }, {
    name: "Cameroon",
    alpha2: "cm"
  }, {
    name: "Canada",
    alpha2: "ca"
  }, {
    name: "Cayman Islands",
    alpha2: "ky"
  }, {
    name: "Central African Republic",
    alpha2: "cf"
  }, {
    name: "Chad",
    alpha2: "td"
  }, {
    name: "Chile",
    alpha2: "cl"
  }, {
    name: "China",
    alpha2: "cn"
  }, {
    name: "Christmas Island",
    alpha2: "cx"
  }, {
    name: "Cocos (Keeling) Islands",
    alpha2: "cc"
  }, {
    name: "Colombia",
    alpha2: "co"
  }, {
    name: "Comoros",
    alpha2: "km"
  }, {
    name: "Congo",
    alpha2: "cg"
  }, {
    name: "Congo (Democratic Republic of the)",
    alpha2: "cd"
  }, {
    name: "Cook Islands",
    alpha2: "ck"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Côte d'Ivoire",
    alpha2: "ci"
  }, {
    name: "Croatia",
    alpha2: "hr"
  }, {
    name: "Cuba",
    alpha2: "cu"
  }, {
    name: "Curaçao",
    alpha2: "cw"
  }, {
    name: "Cyprus",
    alpha2: "cy"
  }, {
    name: "Czechia",
    alpha2: "cz"
  }, {
    name: "Denmark",
    alpha2: "dk"
  }, {
    name: "Djibouti",
    alpha2: "dj"
  }, {
    name: "Dominica",
    alpha2: "dm"
  }, {
    name: "Dominican Republic",
    alpha2: "do"
  }, {
    name: "Ecuador",
    alpha2: "ec"
  }, {
    name: "Egypt",
    alpha2: "eg"
  }, {
    name: "El Salvador",
    alpha2: "sv"
  }, {
    name: "Equatorial Guinea",
    alpha2: "gq"
  }, {
    name: "Eritrea",
    alpha2: "er"
  }, {
    name: "Estonia",
    alpha2: "ee"
  }, {
    name: "Eswatini",
    alpha2: "sz"
  }, {
    name: "Ethiopia",
    alpha2: "et"
  }, {
    name: "Falkland Islands (Malvinas)",
    alpha2: "fk"
  }, {
    name: "Faroe Islands",
    alpha2: "fo"
  }, {
    name: "Fiji",
    alpha2: "fj"
  }, {
    name: "Finland",
    alpha2: "fi"
  }, {
    name: "France",
    alpha2: "fr"
  }, {
    name: "French Guiana",
    alpha2: "gf"
  }, {
    name: "French Polynesia",
    alpha2: "pf"
  }, {
    name: "French Southern Territories",
    alpha2: "tf"
  }, {
    name: "Gabon",
    alpha2: "ga"
  }, {
    name: "Gambia",
    alpha2: "gm"
  }, {
    name: "Georgia",
    alpha2: "ge"
  }, {
    name: "Germany",
    alpha2: "de"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Gibraltar",
    alpha2: "gi"
  }, {
    name: "Greece",
    alpha2: "gr"
  }, {
    name: "Greenland",
    alpha2: "gl"
  }, {
    name: "Grenada",
    alpha2: "gd"
  }, {
    name: "Guadeloupe",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guernsey",
    alpha2: "gg"
  }, {
    name: "Guinea",
    alpha2: "gn"
  }, {
    name: "Guinea-Bissau",
    alpha2: "gw"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Haiti",
    alpha2: "ht"
  }, {
    name: "Heard Island and McDonald Islands",
    alpha2: "hm"
  }, {
    name: "Holy See",
    alpha2: "va"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hong Kong",
    alpha2: "hk"
  }, {
    name: "Hungary",
    alpha2: "hu"
  }, {
    name: "Iceland",
    alpha2: "is"
  }, {
    name: "India",
    alpha2: "in"
  }, {
    name: "Indonesia",
    alpha2: "id"
  }, {
    name: "Iran (Islamic Republic of)",
    alpha2: "ir"
  }, {
    name: "Iraq",
    alpha2: "iq"
  }, {
    name: "Ireland",
    alpha2: "ie"
  }, {
    name: "Isle of Man",
    alpha2: "im"
  }, {
    name: "Israel",
    alpha2: "il"
  }, {
    name: "Italy",
    alpha2: "it"
  }, {
    name: "Jamaica",
    alpha2: "jm"
  }, {
    name: "Japan",
    alpha2: "jp"
  }, {
    name: "Jersey",
    alpha2: "je"
  }, {
    name: "Jordan",
    alpha2: "jo"
  }, {
    name: "Kazakhstan",
    alpha2: "kz"
  }, {
    name: "Kenya",
    alpha2: "ke"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Korea (Democratic People's Republic of)",
    alpha2: "kp"
  }, {
    name: "Korea (Republic of)",
    alpha2: "kr"
  }, {
    name: "Kuwait",
    alpha2: "kw"
  }, {
    name: "Kyrgyzstan",
    alpha2: "kg"
  }, {
    name: "Lao People's Democratic Republic",
    alpha2: "la"
  }, {
    name: "Latvia",
    alpha2: "lv"
  }, {
    name: "Lebanon",
    alpha2: "lb"
  }, {
    name: "Lesotho",
    alpha2: "ls"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libya",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Lithuania",
    alpha2: "lt"
  }, {
    name: "Luxembourg",
    alpha2: "lu"
  }, {
    name: "Macao",
    alpha2: "mo"
  }, {
    name: "Macedonia (the former Yugoslav Republic of)",
    alpha2: "mk"
  }, {
    name: "Madagascar",
    alpha2: "mg"
  }, {
    name: "Malawi",
    alpha2: "mw"
  }, {
    name: "Malaysia",
    alpha2: "my"
  }, {
    name: "Maldives",
    alpha2: "mv"
  }, {
    name: "Mali",
    alpha2: "ml"
  }, {
    name: "Malta",
    alpha2: "mt"
  }, {
    name: "Marshall Islands",
    alpha2: "mh"
  }, {
    name: "Martinique",
    alpha2: "mq"
  }, {
    name: "Mauritania",
    alpha2: "mr"
  }, {
    name: "Mauritius",
    alpha2: "mu"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "Mexico",
    alpha2: "mx"
  }, {
    name: "Micronesia (Federated States of)",
    alpha2: "fm"
  }, {
    name: "Moldova (Republic of)",
    alpha2: "md"
  }, {
    name: "Monaco",
    alpha2: "mc"
  }, {
    name: "Mongolia",
    alpha2: "mn"
  }, {
    name: "Montenegro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Morocco",
    alpha2: "ma"
  }, {
    name: "Mozambique",
    alpha2: "mz"
  }, {
    name: "Myanmar",
    alpha2: "mm"
  }, {
    name: "Namibia",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Nepal",
    alpha2: "np"
  }, {
    name: "Netherlands",
    alpha2: "nl"
  }, {
    name: "New Caledonia",
    alpha2: "nc"
  }, {
    name: "New Zealand",
    alpha2: "nz"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Niger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Norfolk Island",
    alpha2: "nf"
  }, {
    name: "Northern Mariana Islands",
    alpha2: "mp"
  }, {
    name: "Norway",
    alpha2: "no"
  }, {
    name: "Oman",
    alpha2: "om"
  }, {
    name: "Pakistan",
    alpha2: "pk"
  }, {
    name: "Palau",
    alpha2: "pw"
  }, {
    name: "Palestine, State of",
    alpha2: "ps"
  }, {
    name: "Panama",
    alpha2: "pa"
  }, {
    name: "Papua New Guinea",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Peru",
    alpha2: "pe"
  }, {
    name: "Philippines",
    alpha2: "ph"
  }, {
    name: "Pitcairn",
    alpha2: "pn"
  }, {
    name: "Poland",
    alpha2: "pl"
  }, {
    name: "Portugal",
    alpha2: "pt"
  }, {
    name: "Puerto Rico",
    alpha2: "pr"
  }, {
    name: "Qatar",
    alpha2: "qa"
  }, {
    name: "Réunion",
    alpha2: "re"
  }, {
    name: "Romania",
    alpha2: "ro"
  }, {
    name: "Russian Federation",
    alpha2: "ru"
  }, {
    name: "Rwanda",
    alpha2: "rw"
  }, {
    name: "Saint Barthélemy",
    alpha2: "bl"
  }, {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    alpha2: "sh"
  }, {
    name: "Saint Kitts and Nevis",
    alpha2: "kn"
  }, {
    name: "Saint Lucia",
    alpha2: "lc"
  }, {
    name: "Saint Martin (French part)",
    alpha2: "mf"
  }, {
    name: "Saint Pierre and Miquelon",
    alpha2: "pm"
  }, {
    name: "Saint Vincent and the Grenadines",
    alpha2: "vc"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "San Marino",
    alpha2: "sm"
  }, {
    name: "Sao Tome and Principe",
    alpha2: "st"
  }, {
    name: "Saudi Arabia",
    alpha2: "sa"
  }, {
    name: "Senegal",
    alpha2: "sn"
  }, {
    name: "Serbia",
    alpha2: "rs"
  }, {
    name: "Seychelles",
    alpha2: "sc"
  }, {
    name: "Sierra Leone",
    alpha2: "sl"
  }, {
    name: "Singapore",
    alpha2: "sg"
  }, {
    name: "Sint Maarten (Dutch part)",
    alpha2: "sx"
  }, {
    name: "Slovakia",
    alpha2: "sk"
  }, {
    name: "Slovenia",
    alpha2: "si"
  }, {
    name: "Solomon Islands",
    alpha2: "sb"
  }, {
    name: "Somalia",
    alpha2: "so"
  }, {
    name: "South Africa",
    alpha2: "za"
  }, {
    name: "South Georgia and the South Sandwich Islands",
    alpha2: "gs"
  }, {
    name: "South Sudan",
    alpha2: "ss"
  }, {
    name: "Spain",
    alpha2: "es"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "Sudan",
    alpha2: "sd"
  }, {
    name: "Suriname",
    alpha2: "sr"
  }, {
    name: "Svalbard and Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Sweden",
    alpha2: "se"
  }, {
    name: "Switzerland",
    alpha2: "ch"
  }, {
    name: "Syrian Arab Republic",
    alpha2: "sy"
  }, {
    name: "Taiwan, Province of China",
    alpha2: "tw"
  }, {
    name: "Tajikistan",
    alpha2: "tj"
  }, {
    name: "Tanzania, United Republic of",
    alpha2: "tz"
  }, {
    name: "Thailand",
    alpha2: "th"
  }, {
    name: "Timor-Leste",
    alpha2: "tl"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinidad and Tobago",
    alpha2: "tt"
  }, {
    name: "Tunisia",
    alpha2: "tn"
  }, {
    name: "Turkey",
    alpha2: "tr"
  }, {
    name: "Turkmenistan",
    alpha2: "tm"
  }, {
    name: "Turks and Caicos Islands",
    alpha2: "tc"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Uganda",
    alpha2: "ug"
  }, {
    name: "Ukraine",
    alpha2: "ua"
  }, {
    name: "United Arab Emirates",
    alpha2: "ae"
  }, {
    name: "United Kingdom of Great Britain and Northern Ireland",
    alpha2: "gb"
  }, {
    name: "United States of America",
    alpha2: "us"
  }, {
    name: "United States Minor Outlying Islands",
    alpha2: "um"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Uzbekistan",
    alpha2: "uz"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Venezuela (Bolivarian Republic of)",
    alpha2: "ve"
  }, {
    name: "Viet Nam",
    alpha2: "vn"
  }, {
    name: "Virgin Islands (British)",
    alpha2: "vg"
  }, {
    name: "Virgin Islands (U.S.)",
    alpha2: "vi"
  }, {
    name: "Wallis and Futuna",
    alpha2: "wf"
  }, {
    name: "Western Sahara",
    alpha2: "eh"
  }, {
    name: "Yemen",
    alpha2: "ye"
  }, {
    name: "Zambia",
    alpha2: "zm"
  }, {
    name: "Zimbabwe",
    alpha2: "zw"
  }],
  fq = [{
    name: "Afghanistan",
    alpha2: "af"
  }, {
    name: "Ägypten",
    alpha2: "eg"
  }, {
    name: "Åland",
    alpha2: "ax"
  }, {
    name: "Albanien",
    alpha2: "al"
  }, {
    name: "Algerien",
    alpha2: "dz"
  }, {
    name: "Amerikanisch-Samoa",
    alpha2: "as"
  }, {
    name: "Amerikanische Jungferninseln",
    alpha2: "vi"
  }, {
    name: "Andorra",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguilla",
    alpha2: "ai"
  }, {
    name: "Antarktika (Sonderstatus durch Antarktis-Vertrag)",
    alpha2: "aq"
  }, {
    name: "Antigua und Barbuda",
    alpha2: "ag"
  }, {
    name: "Äquatorialguinea",
    alpha2: "gq"
  }, {
    name: "Argentinien",
    alpha2: "ar"
  }, {
    name: "Armenien",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Aserbaidschan",
    alpha2: "az"
  }, {
    name: "Äthiopien",
    alpha2: "et"
  }, {
    name: "Australien",
    alpha2: "au"
  }, {
    name: "Bahamas",
    alpha2: "bs"
  }, {
    name: "Bahrain",
    alpha2: "bh"
  }, {
    name: "Bangladesch",
    alpha2: "bd"
  }, {
    name: "Barbados",
    alpha2: "bb"
  }, {
    name: "Belarus (Weißrussland)",
    alpha2: "by"
  }, {
    name: "Belgien",
    alpha2: "be"
  }, {
    name: "Belize",
    alpha2: "bz"
  }, {
    name: "Benin",
    alpha2: "bj"
  }, {
    name: "Bermuda",
    alpha2: "bm"
  }, {
    name: "Bhutan",
    alpha2: "bt"
  }, {
    name: "Bolivien",
    alpha2: "bo"
  }, {
    name: "Bonaire, Sint Eustatius und Saba (Niederlande)",
    alpha2: "bq"
  }, {
    name: "Bosnien und Herzegowina",
    alpha2: "ba"
  }, {
    name: "Botswana",
    alpha2: "bw"
  }, {
    name: "Bouvetinsel",
    alpha2: "bv"
  }, {
    name: "Brasilien",
    alpha2: "br"
  }, {
    name: "Britische Jungferninseln",
    alpha2: "vg"
  }, {
    name: "Britisches Territorium im Indischen Ozean",
    alpha2: "io"
  }, {
    name: "Brunei Darussalam",
    alpha2: "bn"
  }, {
    name: "Bulgarien",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Chile",
    alpha2: "cl"
  }, {
    name: "China, Volksrepublik",
    alpha2: "cn"
  }, {
    name: "Cookinseln",
    alpha2: "ck"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Côte d’Ivoire (Elfenbeinküste)",
    alpha2: "ci"
  }, {
    name: "Curaçao",
    alpha2: "cw"
  }, {
    name: "Dänemark",
    alpha2: "dk"
  }, {
    name: "Deutschland",
    alpha2: "de"
  }, {
    name: "Dominica",
    alpha2: "dm"
  }, {
    name: "Dominikanische Republik",
    alpha2: "do"
  }, {
    name: "Dschibuti",
    alpha2: "dj"
  }, {
    name: "Ecuador",
    alpha2: "ec"
  }, {
    name: "El Salvador",
    alpha2: "sv"
  }, {
    name: "Eritrea",
    alpha2: "er"
  }, {
    name: "Estland",
    alpha2: "ee"
  }, {
    name: "Falklandinseln",
    alpha2: "fk"
  }, {
    name: "Färöer",
    alpha2: "fo"
  }, {
    name: "Fidschi",
    alpha2: "fj"
  }, {
    name: "Finnland",
    alpha2: "fi"
  }, {
    name: "Frankreich",
    alpha2: "fr"
  }, {
    name: "Französisch-Guayana",
    alpha2: "gf"
  }, {
    name: "Französisch-Polynesien",
    alpha2: "pf"
  }, {
    name: "Französische Süd- und Antarktisgebiete",
    alpha2: "tf"
  }, {
    name: "Gabun",
    alpha2: "ga"
  }, {
    name: "Gambia",
    alpha2: "gm"
  }, {
    name: "Georgien",
    alpha2: "ge"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Gibraltar",
    alpha2: "gi"
  }, {
    name: "Grenada",
    alpha2: "gd"
  }, {
    name: "Griechenland",
    alpha2: "gr"
  }, {
    name: "Grönland",
    alpha2: "gl"
  }, {
    name: "Guadeloupe",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guernsey (Kanalinsel)",
    alpha2: "gg"
  }, {
    name: "Guinea",
    alpha2: "gn"
  }, {
    name: "Guinea-Bissau",
    alpha2: "gw"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Haiti",
    alpha2: "ht"
  }, {
    name: "Heard und McDonaldinseln",
    alpha2: "hm"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hongkong",
    alpha2: "hk"
  }, {
    name: "Indien",
    alpha2: "in"
  }, {
    name: "Indonesien",
    alpha2: "id"
  }, {
    name: "Insel Man",
    alpha2: "im"
  }, {
    name: "Irak",
    alpha2: "iq"
  }, {
    name: "Iran, Islamische Republik",
    alpha2: "ir"
  }, {
    name: "Irland",
    alpha2: "ie"
  }, {
    name: "Island",
    alpha2: "is"
  }, {
    name: "Israel",
    alpha2: "il"
  }, {
    name: "Italien",
    alpha2: "it"
  }, {
    name: "Jamaika",
    alpha2: "jm"
  }, {
    name: "Japan",
    alpha2: "jp"
  }, {
    name: "Jemen",
    alpha2: "ye"
  }, {
    name: "Jersey (Kanalinsel)",
    alpha2: "je"
  }, {
    name: "Jordanien",
    alpha2: "jo"
  }, {
    name: "Kaimaninseln",
    alpha2: "ky"
  }, {
    name: "Kambodscha",
    alpha2: "kh"
  }, {
    name: "Kamerun",
    alpha2: "cm"
  }, {
    name: "Kanada",
    alpha2: "ca"
  }, {
    name: "Kap Verde",
    alpha2: "cv"
  }, {
    name: "Kasachstan",
    alpha2: "kz"
  }, {
    name: "Katar",
    alpha2: "qa"
  }, {
    name: "Kenia",
    alpha2: "ke"
  }, {
    name: "Kirgisistan",
    alpha2: "kg"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Kokosinseln",
    alpha2: "cc"
  }, {
    name: "Kolumbien",
    alpha2: "co"
  }, {
    name: "Komoren",
    alpha2: "km"
  }, {
    name: "Kongo, Demokratische Republik (ehem. Zaire)",
    alpha2: "cd"
  }, {
    name: "Kongo, Republik (ehem. K.-Brazzaville)",
    alpha2: "cg"
  }, {
    name: "Korea, Demokratische Volksrepublik (Nordkorea)",
    alpha2: "kp"
  }, {
    name: "Korea, Republik (Südkorea)",
    alpha2: "kr"
  }, {
    name: "Kroatien",
    alpha2: "hr"
  }, {
    name: "Kuba",
    alpha2: "cu"
  }, {
    name: "Kuwait",
    alpha2: "kw"
  }, {
    name: "Laos, Demokratische Volksrepublik",
    alpha2: "la"
  }, {
    name: "Lesotho",
    alpha2: "ls"
  }, {
    name: "Lettland",
    alpha2: "lv"
  }, {
    name: "Libanon",
    alpha2: "lb"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libyen",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Litauen",
    alpha2: "lt"
  }, {
    name: "Luxemburg",
    alpha2: "lu"
  }, {
    name: "Macau",
    alpha2: "mo"
  }, {
    name: "Madagaskar",
    alpha2: "mg"
  }, {
    name: "Malawi",
    alpha2: "mw"
  }, {
    name: "Malaysia",
    alpha2: "my"
  }, {
    name: "Malediven",
    alpha2: "mv"
  }, {
    name: "Mali",
    alpha2: "ml"
  }, {
    name: "Malta",
    alpha2: "mt"
  }, {
    name: "Marokko",
    alpha2: "ma"
  }, {
    name: "Marshallinseln",
    alpha2: "mh"
  }, {
    name: "Martinique",
    alpha2: "mq"
  }, {
    name: "Mauretanien",
    alpha2: "mr"
  }, {
    name: "Mauritius",
    alpha2: "mu"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "Mazedonien",
    alpha2: "mk"
  }, {
    name: "Mexiko",
    alpha2: "mx"
  }, {
    name: "Mikronesien",
    alpha2: "fm"
  }, {
    name: "Moldawien (Republik Moldau)",
    alpha2: "md"
  }, {
    name: "Monaco",
    alpha2: "mc"
  }, {
    name: "Mongolei",
    alpha2: "mn"
  }, {
    name: "Montenegro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Mosambik",
    alpha2: "mz"
  }, {
    name: "Myanmar (Burma)",
    alpha2: "mm"
  }, {
    name: "Namibia",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Nepal",
    alpha2: "np"
  }, {
    name: "Neukaledonien",
    alpha2: "nc"
  }, {
    name: "Neuseeland",
    alpha2: "nz"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Niederlande",
    alpha2: "nl"
  }, {
    name: "Niger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Nördliche Marianen",
    alpha2: "mp"
  }, {
    name: "Norfolkinsel",
    alpha2: "nf"
  }, {
    name: "Norwegen",
    alpha2: "no"
  }, {
    name: "Oman",
    alpha2: "om"
  }, {
    name: "Österreich",
    alpha2: "at"
  }, {
    name: "Osttimor (Timor-Leste)",
    alpha2: "tl"
  }, {
    name: "Pakistan",
    alpha2: "pk"
  }, {
    name: "Staat Palästina",
    alpha2: "ps"
  }, {
    name: "Palau",
    alpha2: "pw"
  }, {
    name: "Panama",
    alpha2: "pa"
  }, {
    name: "Papua-Neuguinea",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Peru",
    alpha2: "pe"
  }, {
    name: "Philippinen",
    alpha2: "ph"
  }, {
    name: "Pitcairninseln",
    alpha2: "pn"
  }, {
    name: "Polen",
    alpha2: "pl"
  }, {
    name: "Portugal",
    alpha2: "pt"
  }, {
    name: "Puerto Rico",
    alpha2: "pr"
  }, {
    name: "Réunion",
    alpha2: "re"
  }, {
    name: "Ruanda",
    alpha2: "rw"
  }, {
    name: "Rumänien",
    alpha2: "ro"
  }, {
    name: "Russische Föderation",
    alpha2: "ru"
  }, {
    name: "Salomonen",
    alpha2: "sb"
  }, {
    name: "Saint-Barthélemy",
    alpha2: "bl"
  }, {
    name: "Saint-Martin (franz. Teil)",
    alpha2: "mf"
  }, {
    name: "Sambia",
    alpha2: "zm"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "San Marino",
    alpha2: "sm"
  }, {
    name: "São Tomé und Príncipe",
    alpha2: "st"
  }, {
    name: "Saudi-Arabien",
    alpha2: "sa"
  }, {
    name: "Schweden",
    alpha2: "se"
  }, {
    name: "Schweiz (Confoederatio Helvetica)",
    alpha2: "ch"
  }, {
    name: "Senegal",
    alpha2: "sn"
  }, {
    name: "Serbien",
    alpha2: "rs"
  }, {
    name: "Seychellen",
    alpha2: "sc"
  }, {
    name: "Sierra Leone",
    alpha2: "sl"
  }, {
    name: "Simbabwe",
    alpha2: "zw"
  }, {
    name: "Singapur",
    alpha2: "sg"
  }, {
    name: "Sint Maarten (niederl. Teil)",
    alpha2: "sx"
  }, {
    name: "Slowakei",
    alpha2: "sk"
  }, {
    name: "Slowenien",
    alpha2: "si"
  }, {
    name: "Somalia",
    alpha2: "so"
  }, {
    name: "Spanien",
    alpha2: "es"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "St. Helena",
    alpha2: "sh"
  }, {
    name: "St. Kitts und Nevis",
    alpha2: "kn"
  }, {
    name: "St. Lucia",
    alpha2: "lc"
  }, {
    name: "Saint-Pierre und Miquelon",
    alpha2: "pm"
  }, {
    name: "St. Vincent und die Grenadinen",
    alpha2: "vc"
  }, {
    name: "Südafrika",
    alpha2: "za"
  }, {
    name: "Sudan",
    alpha2: "sd"
  }, {
    name: "Südgeorgien und die Südlichen Sandwichinseln",
    alpha2: "gs"
  }, {
    name: "Südsudan",
    alpha2: "ss"
  }, {
    name: "Suriname",
    alpha2: "sr"
  }, {
    name: "Svalbard und Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Swasiland",
    alpha2: "sz"
  }, {
    name: "Syrien, Arabische Republik",
    alpha2: "sy"
  }, {
    name: "Tadschikistan",
    alpha2: "tj"
  }, {
    name: "Republik China (Taiwan)",
    alpha2: "tw"
  }, {
    name: "Tansania, Vereinigte Republik",
    alpha2: "tz"
  }, {
    name: "Thailand",
    alpha2: "th"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinidad und Tobago",
    alpha2: "tt"
  }, {
    name: "Tschad",
    alpha2: "td"
  }, {
    name: "Tschechien",
    alpha2: "cz"
  }, {
    name: "Tunesien",
    alpha2: "tn"
  }, {
    name: "Türkei",
    alpha2: "tr"
  }, {
    name: "Turkmenistan",
    alpha2: "tm"
  }, {
    name: "Turks- und Caicosinseln",
    alpha2: "tc"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Uganda",
    alpha2: "ug"
  }, {
    name: "Ukraine",
    alpha2: "ua"
  }, {
    name: "Ungarn",
    alpha2: "hu"
  }, {
    name: "United States Minor Outlying Islands",
    alpha2: "um"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Usbekistan",
    alpha2: "uz"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Vatikanstadt",
    alpha2: "va"
  }, {
    name: "Venezuela",
    alpha2: "ve"
  }, {
    name: "Vereinigte Arabische Emirate",
    alpha2: "ae"
  }, {
    name: "Vereinigte Staaten von Amerika",
    alpha2: "us"
  }, {
    name: "Vereinigtes Königreich Großbritannien und Nordirland",
    alpha2: "gb"
  }, {
    name: "Vietnam",
    alpha2: "vn"
  }, {
    name: "Wallis und Futuna",
    alpha2: "wf"
  }, {
    name: "Weihnachtsinsel",
    alpha2: "cx"
  }, {
    name: "Westsahara",
    alpha2: "eh"
  }, {
    name: "Zentralafrikanische Republik",
    alpha2: "cf"
  }, {
    name: "Zypern",
    alpha2: "cy"
  }],
  dq = [{
    name: "Afghanistan",
    alpha2: "af"
  }, {
    name: "Afrique du Sud",
    alpha2: "za"
  }, {
    name: "Îles Åland",
    alpha2: "ax"
  }, {
    name: "Albanie",
    alpha2: "al"
  }, {
    name: "Algérie",
    alpha2: "dz"
  }, {
    name: "Allemagne",
    alpha2: "de"
  }, {
    name: "Andorre",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguilla",
    alpha2: "ai"
  }, {
    name: "Antarctique",
    alpha2: "aq"
  }, {
    name: "Antigua-et-Barbuda",
    alpha2: "ag"
  }, {
    name: "Arabie saoudite",
    alpha2: "sa"
  }, {
    name: "Argentine",
    alpha2: "ar"
  }, {
    name: "Arménie",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Australie",
    alpha2: "au"
  }, {
    name: "Autriche",
    alpha2: "at"
  }, {
    name: "Azerbaïdjan",
    alpha2: "az"
  }, {
    name: "Bahamas",
    alpha2: "bs"
  }, {
    name: "Bahreïn",
    alpha2: "bh"
  }, {
    name: "Bangladesh",
    alpha2: "bd"
  }, {
    name: "Barbade",
    alpha2: "bb"
  }, {
    name: "Biélorussie",
    alpha2: "by"
  }, {
    name: "Belgique",
    alpha2: "be"
  }, {
    name: "Belize",
    alpha2: "bz"
  }, {
    name: "Bénin",
    alpha2: "bj"
  }, {
    name: "Bermudes",
    alpha2: "bm"
  }, {
    name: "Bhoutan",
    alpha2: "bt"
  }, {
    name: "Bolivie",
    alpha2: "bo"
  }, {
    name: "Pays-Bas caribéens",
    alpha2: "bq"
  }, {
    name: "Bosnie-Herzégovine",
    alpha2: "ba"
  }, {
    name: "Botswana",
    alpha2: "bw"
  }, {
    name: "Île Bouvet",
    alpha2: "bv"
  }, {
    name: "Brésil",
    alpha2: "br"
  }, {
    name: "Brunei",
    alpha2: "bn"
  }, {
    name: "Bulgarie",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Îles Caïmans",
    alpha2: "ky"
  }, {
    name: "Cambodge",
    alpha2: "kh"
  }, {
    name: "Cameroun",
    alpha2: "cm"
  }, {
    name: "Canada",
    alpha2: "ca"
  }, {
    name: "Cap-Vert",
    alpha2: "cv"
  }, {
    name: "République centrafricaine",
    alpha2: "cf"
  }, {
    name: "Chili",
    alpha2: "cl"
  }, {
    name: "Chine",
    alpha2: "cn"
  }, {
    name: "Île Christmas",
    alpha2: "cx"
  }, {
    name: "Chypre (pays)",
    alpha2: "cy"
  }, {
    name: "Îles Cocos",
    alpha2: "cc"
  }, {
    name: "Colombie",
    alpha2: "co"
  }, {
    name: "Comores (pays)",
    alpha2: "km"
  }, {
    name: "République du Congo",
    alpha2: "cg"
  }, {
    name: "République démocratique du Congo",
    alpha2: "cd"
  }, {
    name: "Îles Cook",
    alpha2: "ck"
  }, {
    name: "Corée du Sud",
    alpha2: "kr"
  }, {
    name: "Corée du Nord",
    alpha2: "kp"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Côte d'Ivoire",
    alpha2: "ci"
  }, {
    name: "Croatie",
    alpha2: "hr"
  }, {
    name: "Cuba",
    alpha2: "cu"
  }, {
    name: "Curaçao",
    alpha2: "cw"
  }, {
    name: "Danemark",
    alpha2: "dk"
  }, {
    name: "Djibouti",
    alpha2: "dj"
  }, {
    name: "République dominicaine",
    alpha2: "do"
  }, {
    name: "Dominique",
    alpha2: "dm"
  }, {
    name: "Égypte",
    alpha2: "eg"
  }, {
    name: "Salvador",
    alpha2: "sv"
  }, {
    name: "Émirats arabes unis",
    alpha2: "ae"
  }, {
    name: "Équateur (pays)",
    alpha2: "ec"
  }, {
    name: "Érythrée",
    alpha2: "er"
  }, {
    name: "Espagne",
    alpha2: "es"
  }, {
    name: "Estonie",
    alpha2: "ee"
  }, {
    name: "États-Unis",
    alpha2: "us"
  }, {
    name: "Éthiopie",
    alpha2: "et"
  }, {
    name: "Malouines",
    alpha2: "fk"
  }, {
    name: "Îles Féroé",
    alpha2: "fo"
  }, {
    name: "Fidji",
    alpha2: "fj"
  }, {
    name: "Finlande",
    alpha2: "fi"
  }, {
    name: "France",
    alpha2: "fr"
  }, {
    name: "Gabon",
    alpha2: "ga"
  }, {
    name: "Gambie",
    alpha2: "gm"
  }, {
    name: "Géorgie (pays)",
    alpha2: "ge"
  }, {
    name: "Géorgie du Sud-et-les îles Sandwich du Sud",
    alpha2: "gs"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Gibraltar",
    alpha2: "gi"
  }, {
    name: "Grèce",
    alpha2: "gr"
  }, {
    name: "Grenade (pays)",
    alpha2: "gd"
  }, {
    name: "Groenland",
    alpha2: "gl"
  }, {
    name: "Guadeloupe",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guernesey",
    alpha2: "gg"
  }, {
    name: "Guinée",
    alpha2: "gn"
  }, {
    name: "Guinée-Bissau",
    alpha2: "gw"
  }, {
    name: "Guinée équatoriale",
    alpha2: "gq"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Guyane",
    alpha2: "gf"
  }, {
    name: "Haïti",
    alpha2: "ht"
  }, {
    name: "Îles Heard-et-MacDonald",
    alpha2: "hm"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hong Kong",
    alpha2: "hk"
  }, {
    name: "Hongrie",
    alpha2: "hu"
  }, {
    name: "Île de Man",
    alpha2: "im"
  }, {
    name: "Îles mineures éloignées des États-Unis",
    alpha2: "um"
  }, {
    name: "Îles Vierges britanniques",
    alpha2: "vg"
  }, {
    name: "Îles Vierges des États-Unis",
    alpha2: "vi"
  }, {
    name: "Inde",
    alpha2: "in"
  }, {
    name: "Indonésie",
    alpha2: "id"
  }, {
    name: "Iran",
    alpha2: "ir"
  }, {
    name: "Irak",
    alpha2: "iq"
  }, {
    name: "Irlande (pays)",
    alpha2: "ie"
  }, {
    name: "Islande",
    alpha2: "is"
  }, {
    name: "Israël",
    alpha2: "il"
  }, {
    name: "Italie",
    alpha2: "it"
  }, {
    name: "Jamaïque",
    alpha2: "jm"
  }, {
    name: "Japon",
    alpha2: "jp"
  }, {
    name: "Jersey",
    alpha2: "je"
  }, {
    name: "Jordanie",
    alpha2: "jo"
  }, {
    name: "Kazakhstan",
    alpha2: "kz"
  }, {
    name: "Kenya",
    alpha2: "ke"
  }, {
    name: "Kirghizistan",
    alpha2: "kg"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Koweït",
    alpha2: "kw"
  }, {
    name: "Laos",
    alpha2: "la"
  }, {
    name: "Lesotho",
    alpha2: "ls"
  }, {
    name: "Lettonie",
    alpha2: "lv"
  }, {
    name: "Liban",
    alpha2: "lb"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libye",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Lituanie",
    alpha2: "lt"
  }, {
    name: "Luxembourg (pays)",
    alpha2: "lu"
  }, {
    name: "Macao",
    alpha2: "mo"
  }, {
    name: "République de Macédoine (pays)",
    alpha2: "mk"
  }, {
    name: "Madagascar",
    alpha2: "mg"
  }, {
    name: "Malaisie",
    alpha2: "my"
  }, {
    name: "Malawi",
    alpha2: "mw"
  }, {
    name: "Maldives",
    alpha2: "mv"
  }, {
    name: "Mali",
    alpha2: "ml"
  }, {
    name: "Malte",
    alpha2: "mt"
  }, {
    name: "Îles Mariannes du Nord",
    alpha2: "mp"
  }, {
    name: "Maroc",
    alpha2: "ma"
  }, {
    name: "Îles Marshall (pays)",
    alpha2: "mh"
  }, {
    name: "Martinique",
    alpha2: "mq"
  }, {
    name: "Maurice (pays)",
    alpha2: "mu"
  }, {
    name: "Mauritanie",
    alpha2: "mr"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "Mexique",
    alpha2: "mx"
  }, {
    name: "Micronésie (pays)",
    alpha2: "fm"
  }, {
    name: "Moldavie",
    alpha2: "md"
  }, {
    name: "Monaco",
    alpha2: "mc"
  }, {
    name: "Mongolie",
    alpha2: "mn"
  }, {
    name: "Monténégro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Mozambique",
    alpha2: "mz"
  }, {
    name: "Birmanie",
    alpha2: "mm"
  }, {
    name: "Namibie",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Népal",
    alpha2: "np"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Niger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Île Norfolk",
    alpha2: "nf"
  }, {
    name: "Norvège",
    alpha2: "no"
  }, {
    name: "Nouvelle-Calédonie",
    alpha2: "nc"
  }, {
    name: "Nouvelle-Zélande",
    alpha2: "nz"
  }, {
    name: "Territoire britannique de l'océan Indien",
    alpha2: "io"
  }, {
    name: "Oman",
    alpha2: "om"
  }, {
    name: "Ouganda",
    alpha2: "ug"
  }, {
    name: "Ouzbékistan",
    alpha2: "uz"
  }, {
    name: "Pakistan",
    alpha2: "pk"
  }, {
    name: "Palaos",
    alpha2: "pw"
  }, {
    name: "Palestine",
    alpha2: "ps"
  }, {
    name: "Panama",
    alpha2: "pa"
  }, {
    name: "Papouasie-Nouvelle-Guinée",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Pays-Bas",
    alpha2: "nl"
  }, {
    name: "Pérou",
    alpha2: "pe"
  }, {
    name: "Philippines",
    alpha2: "ph"
  }, {
    name: "Îles Pitcairn",
    alpha2: "pn"
  }, {
    name: "Pologne",
    alpha2: "pl"
  }, {
    name: "Polynésie française",
    alpha2: "pf"
  }, {
    name: "Porto Rico",
    alpha2: "pr"
  }, {
    name: "Portugal",
    alpha2: "pt"
  }, {
    name: "Qatar",
    alpha2: "qa"
  }, {
    name: "La Réunion",
    alpha2: "re"
  }, {
    name: "Roumanie",
    alpha2: "ro"
  }, {
    name: "Royaume-Uni",
    alpha2: "gb"
  }, {
    name: "Russie",
    alpha2: "ru"
  }, {
    name: "Rwanda",
    alpha2: "rw"
  }, {
    name: "République arabe sahraouie démocratique",
    alpha2: "eh"
  }, {
    name: "Saint-Barthélemy",
    alpha2: "bl"
  }, {
    name: "Saint-Christophe-et-Niévès",
    alpha2: "kn"
  }, {
    name: "Saint-Marin",
    alpha2: "sm"
  }, {
    name: "Saint-Martin",
    alpha2: "mf"
  }, {
    name: "Saint-Martin",
    alpha2: "sx"
  }, {
    name: "Saint-Pierre-et-Miquelon",
    alpha2: "pm"
  }, {
    name: "Saint-Siège (État de la Cité du Vatican)",
    alpha2: "va"
  }, {
    name: "Saint-Vincent-et-les-Grenadines",
    alpha2: "vc"
  }, {
    name: "Sainte-Hélène, Ascension et Tristan da Cunha",
    alpha2: "sh"
  }, {
    name: "Sainte-Lucie",
    alpha2: "lc"
  }, {
    name: "Salomon",
    alpha2: "sb"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "Samoa américaines",
    alpha2: "as"
  }, {
    name: "Sao Tomé-et-Principe",
    alpha2: "st"
  }, {
    name: "Sénégal",
    alpha2: "sn"
  }, {
    name: "Serbie",
    alpha2: "rs"
  }, {
    name: "Seychelles",
    alpha2: "sc"
  }, {
    name: "Sierra Leone",
    alpha2: "sl"
  }, {
    name: "Singapour",
    alpha2: "sg"
  }, {
    name: "Slovaquie",
    alpha2: "sk"
  }, {
    name: "Slovénie",
    alpha2: "si"
  }, {
    name: "Somalie",
    alpha2: "so"
  }, {
    name: "Soudan",
    alpha2: "sd"
  }, {
    name: "Soudan du Sud",
    alpha2: "ss"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "Suède",
    alpha2: "se"
  }, {
    name: "Suisse",
    alpha2: "ch"
  }, {
    name: "Suriname",
    alpha2: "sr"
  }, {
    name: "Svalbard et ile Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Swaziland",
    alpha2: "sz"
  }, {
    name: "Syrie",
    alpha2: "sy"
  }, {
    name: "Tadjikistan",
    alpha2: "tj"
  }, {
    name: "Taïwan / (République de Chine (Taïwan))",
    alpha2: "tw"
  }, {
    name: "Tanzanie",
    alpha2: "tz"
  }, {
    name: "Tchad",
    alpha2: "td"
  }, {
    name: "Tchéquie",
    alpha2: "cz"
  }, {
    name: "Terres australes et antarctiques françaises",
    alpha2: "tf"
  }, {
    name: "Thaïlande",
    alpha2: "th"
  }, {
    name: "Timor oriental",
    alpha2: "tl"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinité-et-Tobago",
    alpha2: "tt"
  }, {
    name: "Tunisie",
    alpha2: "tn"
  }, {
    name: "Turkménistan",
    alpha2: "tm"
  }, {
    name: "Îles Turques-et-Caïques",
    alpha2: "tc"
  }, {
    name: "Turquie",
    alpha2: "tr"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Ukraine",
    alpha2: "ua"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Venezuela",
    alpha2: "ve"
  }, {
    name: "Viêt Nam",
    alpha2: "vn"
  }, {
    name: "Wallis-et-Futuna",
    alpha2: "wf"
  }, {
    name: "Yémen",
    alpha2: "ye"
  }, {
    name: "Zambie",
    alpha2: "zm"
  }, {
    name: "Zimbabwe",
    alpha2: "zw"
  }],
  hq = [{
    name: "Afganistán",
    alpha2: "af"
  }, {
    name: "Åland",
    alpha2: "ax"
  }, {
    name: "Albania",
    alpha2: "al"
  }, {
    name: "Alemania",
    alpha2: "de"
  }, {
    name: "Andorra",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguila",
    alpha2: "ai"
  }, {
    name: "Antártida",
    alpha2: "aq"
  }, {
    name: "Antigua y Barbuda",
    alpha2: "ag"
  }, {
    name: "Arabia Saudita",
    alpha2: "sa"
  }, {
    name: "Argelia",
    alpha2: "dz"
  }, {
    name: "Argentina",
    alpha2: "ar"
  }, {
    name: "Armenia",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Australia",
    alpha2: "au"
  }, {
    name: "Austria",
    alpha2: "at"
  }, {
    name: "Azerbaiyán",
    alpha2: "az"
  }, {
    name: "Bahamas",
    alpha2: "bs"
  }, {
    name: "Bangladés",
    alpha2: "bd"
  }, {
    name: "Barbados",
    alpha2: "bb"
  }, {
    name: "Baréin",
    alpha2: "bh"
  }, {
    name: "Bélgica",
    alpha2: "be"
  }, {
    name: "Belice",
    alpha2: "bz"
  }, {
    name: "Benín",
    alpha2: "bj"
  }, {
    name: "Bermudas",
    alpha2: "bm"
  }, {
    name: "Bielorrusia",
    alpha2: "by"
  }, {
    name: "Bolivia",
    alpha2: "bo"
  }, {
    name: "Bonaire, San Eustaquio y Saba",
    alpha2: "bq"
  }, {
    name: "Bosnia y Herzegovina",
    alpha2: "ba"
  }, {
    name: "Botsuana",
    alpha2: "bw"
  }, {
    name: "Brasil",
    alpha2: "br"
  }, {
    name: "Brunéi",
    alpha2: "bn"
  }, {
    name: "Bulgaria",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Bután",
    alpha2: "bt"
  }, {
    name: "Cabo Verde",
    alpha2: "cv"
  }, {
    name: "Camboya",
    alpha2: "kh"
  }, {
    name: "Camerún",
    alpha2: "cm"
  }, {
    name: "Canadá",
    alpha2: "ca"
  }, {
    name: "Catar",
    alpha2: "qa"
  }, {
    name: "Chad",
    alpha2: "td"
  }, {
    name: "Chile",
    alpha2: "cl"
  }, {
    name: "China",
    alpha2: "cn"
  }, {
    name: "Chipre",
    alpha2: "cy"
  }, {
    name: "Colombia",
    alpha2: "co"
  }, {
    name: "Comoras",
    alpha2: "km"
  }, {
    name: "Corea del Norte",
    alpha2: "kp"
  }, {
    name: "Corea del Sur",
    alpha2: "kr"
  }, {
    name: "Costa de Marfil",
    alpha2: "ci"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Croacia",
    alpha2: "hr"
  }, {
    name: "Cuba",
    alpha2: "cu"
  }, {
    name: "Curazao",
    alpha2: "cw"
  }, {
    name: "Dinamarca",
    alpha2: "dk"
  }, {
    name: "Dominica",
    alpha2: "dm"
  }, {
    name: "Ecuador",
    alpha2: "ec"
  }, {
    name: "Egipto",
    alpha2: "eg"
  }, {
    name: "El Salvador",
    alpha2: "sv"
  }, {
    name: "Emiratos Árabes Unidos",
    alpha2: "ae"
  }, {
    name: "Eritrea",
    alpha2: "er"
  }, {
    name: "Eslovaquia",
    alpha2: "sk"
  }, {
    name: "Eslovenia",
    alpha2: "si"
  }, {
    name: "España",
    alpha2: "es"
  }, {
    name: "Estados Unidos",
    alpha2: "us"
  }, {
    name: "Estonia",
    alpha2: "ee"
  }, {
    name: "Etiopía",
    alpha2: "et"
  }, {
    name: "Filipinas",
    alpha2: "ph"
  }, {
    name: "Finlandia",
    alpha2: "fi"
  }, {
    name: "Fiyi",
    alpha2: "fj"
  }, {
    name: "Francia",
    alpha2: "fr"
  }, {
    name: "Gabón",
    alpha2: "ga"
  }, {
    name: "Gambia",
    alpha2: "gm"
  }, {
    name: "Georgia",
    alpha2: "ge"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Gibraltar",
    alpha2: "gi"
  }, {
    name: "Granada",
    alpha2: "gd"
  }, {
    name: "Grecia",
    alpha2: "gr"
  }, {
    name: "Groenlandia",
    alpha2: "gl"
  }, {
    name: "Guadalupe",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guayana Francesa",
    alpha2: "gf"
  }, {
    name: "Guernsey",
    alpha2: "gg"
  }, {
    name: "Guinea",
    alpha2: "gn"
  }, {
    name: "Guinea-Bisáu",
    alpha2: "gw"
  }, {
    name: "Guinea Ecuatorial",
    alpha2: "gq"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Haití",
    alpha2: "ht"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hong Kong",
    alpha2: "hk"
  }, {
    name: "Hungría",
    alpha2: "hu"
  }, {
    name: "India",
    alpha2: "in"
  }, {
    name: "Indonesia",
    alpha2: "id"
  }, {
    name: "Irak",
    alpha2: "iq"
  }, {
    name: "Irán",
    alpha2: "ir"
  }, {
    name: "Irlanda",
    alpha2: "ie"
  }, {
    name: "Isla Bouvet",
    alpha2: "bv"
  }, {
    name: "Isla de Man",
    alpha2: "im"
  }, {
    name: "Isla de Navidad",
    alpha2: "cx"
  }, {
    name: "Islandia",
    alpha2: "is"
  }, {
    name: "Islas Caimán",
    alpha2: "ky"
  }, {
    name: "Islas Cocos",
    alpha2: "cc"
  }, {
    name: "Islas Cook",
    alpha2: "ck"
  }, {
    name: "Islas Feroe",
    alpha2: "fo"
  }, {
    name: "Islas Georgias del Sur y Sandwich del Sur",
    alpha2: "gs"
  }, {
    name: "Islas Heard y McDonald",
    alpha2: "hm"
  }, {
    name: "Islas Malvinas",
    alpha2: "fk"
  }, {
    name: "Islas Marianas del Norte",
    alpha2: "mp"
  }, {
    name: "Islas Marshall",
    alpha2: "mh"
  }, {
    name: "Islas Pitcairn",
    alpha2: "pn"
  }, {
    name: "Islas Salomón",
    alpha2: "sb"
  }, {
    name: "Islas Turcas y Caicos",
    alpha2: "tc"
  }, {
    name: "Islas ultramarinas de Estados Unidos",
    alpha2: "um"
  }, {
    name: "Islas Vírgenes Británicas",
    alpha2: "vg"
  }, {
    name: "Islas Vírgenes de los Estados Unidos",
    alpha2: "vi"
  }, {
    name: "Israel",
    alpha2: "il"
  }, {
    name: "Italia",
    alpha2: "it"
  }, {
    name: "Jamaica",
    alpha2: "jm"
  }, {
    name: "Japón",
    alpha2: "jp"
  }, {
    name: "Jersey",
    alpha2: "je"
  }, {
    name: "Jordania",
    alpha2: "jo"
  }, {
    name: "Kazajistán",
    alpha2: "kz"
  }, {
    name: "Kenia",
    alpha2: "ke"
  }, {
    name: "Kirguistán",
    alpha2: "kg"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Kuwait",
    alpha2: "kw"
  }, {
    name: "Laos",
    alpha2: "la"
  }, {
    name: "Lesoto",
    alpha2: "ls"
  }, {
    name: "Letonia",
    alpha2: "lv"
  }, {
    name: "Líbano",
    alpha2: "lb"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libia",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Lituania",
    alpha2: "lt"
  }, {
    name: "Luxemburgo",
    alpha2: "lu"
  }, {
    name: "Macao",
    alpha2: "mo"
  }, {
    name: "Macedonia",
    alpha2: "mk"
  }, {
    name: "Madagascar",
    alpha2: "mg"
  }, {
    name: "Malasia",
    alpha2: "my"
  }, {
    name: "Malaui",
    alpha2: "mw"
  }, {
    name: "Maldivas",
    alpha2: "mv"
  }, {
    name: "Malí",
    alpha2: "ml"
  }, {
    name: "Malta",
    alpha2: "mt"
  }, {
    name: "Marruecos",
    alpha2: "ma"
  }, {
    name: "Martinica",
    alpha2: "mq"
  }, {
    name: "Mauricio",
    alpha2: "mu"
  }, {
    name: "Mauritania",
    alpha2: "mr"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "México",
    alpha2: "mx"
  }, {
    name: "Micronesia",
    alpha2: "fm"
  }, {
    name: "Moldavia",
    alpha2: "md"
  }, {
    name: "Mónaco",
    alpha2: "mc"
  }, {
    name: "Mongolia",
    alpha2: "mn"
  }, {
    name: "Montenegro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Mozambique",
    alpha2: "mz"
  }, {
    name: "Myanmar",
    alpha2: "mm"
  }, {
    name: "Namibia",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Nepal",
    alpha2: "np"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Níger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Norfolk",
    alpha2: "nf"
  }, {
    name: "Noruega",
    alpha2: "no"
  }, {
    name: "Nueva Caledonia",
    alpha2: "nc"
  }, {
    name: "Nueva Zelanda",
    alpha2: "nz"
  }, {
    name: "Omán",
    alpha2: "om"
  }, {
    name: "Países Bajos",
    alpha2: "nl"
  }, {
    name: "Pakistán",
    alpha2: "pk"
  }, {
    name: "Palaos",
    alpha2: "pw"
  }, {
    name: "Palestina",
    alpha2: "ps"
  }, {
    name: "Panamá",
    alpha2: "pa"
  }, {
    name: "Papúa Nueva Guinea",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Perú",
    alpha2: "pe"
  }, {
    name: "Polinesia Francesa",
    alpha2: "pf"
  }, {
    name: "Polonia",
    alpha2: "pl"
  }, {
    name: "Portugal",
    alpha2: "pt"
  }, {
    name: "Puerto Rico",
    alpha2: "pr"
  }, {
    name: "Reino Unido",
    alpha2: "gb"
  }, {
    name: "República Árabe Saharaui Democrática",
    alpha2: "eh"
  }, {
    name: "República Centroafricana",
    alpha2: "cf"
  }, {
    name: "República Checa",
    alpha2: "cz"
  }, {
    name: "República del Congo",
    alpha2: "cg"
  }, {
    name: "República Democrática del Congo",
    alpha2: "cd"
  }, {
    name: "República Dominicana",
    alpha2: "do"
  }, {
    name: "Reunión",
    alpha2: "re"
  }, {
    name: "Ruanda",
    alpha2: "rw"
  }, {
    name: "Rumania",
    alpha2: "ro"
  }, {
    name: "Rusia",
    alpha2: "ru"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "Samoa Americana",
    alpha2: "as"
  }, {
    name: "San Bartolomé",
    alpha2: "bl"
  }, {
    name: "San Cristóbal y Nieves",
    alpha2: "kn"
  }, {
    name: "San Marino",
    alpha2: "sm"
  }, {
    name: "San Martín",
    alpha2: "mf"
  }, {
    name: "San Pedro y Miquelón",
    alpha2: "pm"
  }, {
    name: "San Vicente y las Granadinas",
    alpha2: "vc"
  }, {
    name: "Santa Elena, Ascensión y Tristán de Acuña",
    alpha2: "sh"
  }, {
    name: "Santa Lucía",
    alpha2: "lc"
  }, {
    name: "Santo Tomé y Príncipe",
    alpha2: "st"
  }, {
    name: "Senegal",
    alpha2: "sn"
  }, {
    name: "Serbia",
    alpha2: "rs"
  }, {
    name: "Seychelles",
    alpha2: "sc"
  }, {
    name: "Sierra Leona",
    alpha2: "sl"
  }, {
    name: "Singapur",
    alpha2: "sg"
  }, {
    name: "Sint Maarten",
    alpha2: "sx"
  }, {
    name: "Siria",
    alpha2: "sy"
  }, {
    name: "Somalia",
    alpha2: "so"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "Suazilandia",
    alpha2: "sz"
  }, {
    name: "Sudáfrica",
    alpha2: "za"
  }, {
    name: "Sudán",
    alpha2: "sd"
  }, {
    name: "Sudán del Sur",
    alpha2: "ss"
  }, {
    name: "Suecia",
    alpha2: "se"
  }, {
    name: "Suiza",
    alpha2: "ch"
  }, {
    name: "Surinam",
    alpha2: "sr"
  }, {
    name: "Svalbard y Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Tailandia",
    alpha2: "th"
  }, {
    name: "Taiwán (República de China)",
    alpha2: "tw"
  }, {
    name: "Tanzania",
    alpha2: "tz"
  }, {
    name: "Tayikistán",
    alpha2: "tj"
  }, {
    name: "Territorio Británico del Océano Índico",
    alpha2: "io"
  }, {
    name: "Tierras Australes y Antárticas Francesas",
    alpha2: "tf"
  }, {
    name: "Timor Oriental",
    alpha2: "tl"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinidad y Tobago",
    alpha2: "tt"
  }, {
    name: "Túnez",
    alpha2: "tn"
  }, {
    name: "Turkmenistán",
    alpha2: "tm"
  }, {
    name: "Turquía",
    alpha2: "tr"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Ucrania",
    alpha2: "ua"
  }, {
    name: "Uganda",
    alpha2: "ug"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Uzbekistán",
    alpha2: "uz"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Vaticano, Ciudad del",
    alpha2: "va"
  }, {
    name: "Venezuela",
    alpha2: "ve"
  }, {
    name: "Vietnam",
    alpha2: "vn"
  }, {
    name: "Wallis y Futuna",
    alpha2: "wf"
  }, {
    name: "Yemen",
    alpha2: "ye"
  }, {
    name: "Yibuti",
    alpha2: "dj"
  }, {
    name: "Zambia",
    alpha2: "zm"
  }, {
    name: "Zimbabue",
    alpha2: "zw"
  }],
  pq = [{
    name: "Afghanistan",
    alpha2: "af"
  }, {
    name: "Albania",
    alpha2: "al"
  }, {
    name: "Algeria",
    alpha2: "dz"
  }, {
    name: "Andorra",
    alpha2: "ad"
  }, {
    name: "Angola",
    alpha2: "ao"
  }, {
    name: "Anguilla",
    alpha2: "ai"
  }, {
    name: "Antartide",
    alpha2: "aq"
  }, {
    name: "Antigua e Barbuda",
    alpha2: "ag"
  }, {
    name: "Arabia Saudita",
    alpha2: "sa"
  }, {
    name: "Argentina",
    alpha2: "ar"
  }, {
    name: "Armenia",
    alpha2: "am"
  }, {
    name: "Aruba",
    alpha2: "aw"
  }, {
    name: "Australia",
    alpha2: "au"
  }, {
    name: "Austria",
    alpha2: "at"
  }, {
    name: "Azerbaigian",
    alpha2: "az"
  }, {
    name: "Bahamas",
    alpha2: "bs"
  }, {
    name: "Bahrein",
    alpha2: "bh"
  }, {
    name: "Bangladesh",
    alpha2: "bd"
  }, {
    name: "Barbados",
    alpha2: "bb"
  }, {
    name: "Belgio",
    alpha2: "be"
  }, {
    name: "Belize",
    alpha2: "bz"
  }, {
    name: "Benin",
    alpha2: "bj"
  }, {
    name: "Bermuda",
    alpha2: "bm"
  }, {
    name: "Bhutan",
    alpha2: "bt"
  }, {
    name: "Bielorussia",
    alpha2: "by"
  }, {
    name: "Birmania",
    alpha2: "mm"
  }, {
    name: "Bolivia",
    alpha2: "bo"
  }, {
    name: "Bosnia ed Erzegovina",
    alpha2: "ba"
  }, {
    name: "Botswana",
    alpha2: "bw"
  }, {
    name: "Brasile",
    alpha2: "br"
  }, {
    name: "Brunei",
    alpha2: "bn"
  }, {
    name: "Bulgaria",
    alpha2: "bg"
  }, {
    name: "Burkina Faso",
    alpha2: "bf"
  }, {
    name: "Burundi",
    alpha2: "bi"
  }, {
    name: "Cambogia",
    alpha2: "kh"
  }, {
    name: "Camerun",
    alpha2: "cm"
  }, {
    name: "Canada",
    alpha2: "ca"
  }, {
    name: "Capo Verde",
    alpha2: "cv"
  }, {
    name: "Ciad",
    alpha2: "td"
  }, {
    name: "Cile",
    alpha2: "cl"
  }, {
    name: "Cina",
    alpha2: "cn"
  }, {
    name: "Cipro",
    alpha2: "cy"
  }, {
    name: "Città del Vaticano",
    alpha2: "va"
  }, {
    name: "Colombia",
    alpha2: "co"
  }, {
    name: "Comore",
    alpha2: "km"
  }, {
    name: "Corea del Nord",
    alpha2: "kp"
  }, {
    name: "Corea del Sud",
    alpha2: "kr"
  }, {
    name: "Costa d'Avorio",
    alpha2: "ci"
  }, {
    name: "Costa Rica",
    alpha2: "cr"
  }, {
    name: "Croazia",
    alpha2: "hr"
  }, {
    name: "Cuba",
    alpha2: "cu"
  }, {
    name: "Curaçao",
    alpha2: "cw"
  }, {
    name: "Danimarca",
    alpha2: "dk"
  }, {
    name: "Dominica",
    alpha2: "dm"
  }, {
    name: "Ecuador",
    alpha2: "ec"
  }, {
    name: "Egitto",
    alpha2: "eg"
  }, {
    name: "El Salvador",
    alpha2: "sv"
  }, {
    name: "Emirati Arabi Uniti",
    alpha2: "ae"
  }, {
    name: "Eritrea",
    alpha2: "er"
  }, {
    name: "Estonia",
    alpha2: "ee"
  }, {
    name: "Etiopia",
    alpha2: "et"
  }, {
    name: "Figi",
    alpha2: "fj"
  }, {
    name: "Filippine",
    alpha2: "ph"
  }, {
    name: "Finlandia",
    alpha2: "fi"
  }, {
    name: "Francia",
    alpha2: "fr"
  }, {
    name: "Gabon",
    alpha2: "ga"
  }, {
    name: "Gambia",
    alpha2: "gm"
  }, {
    name: "Georgia",
    alpha2: "ge"
  }, {
    name: "Georgia del Sud e Isole Sandwich Australi",
    alpha2: "gs"
  }, {
    name: "Germania",
    alpha2: "de"
  }, {
    name: "Ghana",
    alpha2: "gh"
  }, {
    name: "Giamaica",
    alpha2: "jm"
  }, {
    name: "Giappone",
    alpha2: "jp"
  }, {
    name: "Gibilterra",
    alpha2: "gi"
  }, {
    name: "Gibuti",
    alpha2: "dj"
  }, {
    name: "Giordania",
    alpha2: "jo"
  }, {
    name: "Grecia",
    alpha2: "gr"
  }, {
    name: "Grenada",
    alpha2: "gd"
  }, {
    name: "Groenlandia",
    alpha2: "gl"
  }, {
    name: "Guadalupa",
    alpha2: "gp"
  }, {
    name: "Guam",
    alpha2: "gu"
  }, {
    name: "Guatemala",
    alpha2: "gt"
  }, {
    name: "Guernsey",
    alpha2: "gg"
  }, {
    name: "Guinea",
    alpha2: "gn"
  }, {
    name: "Guinea-Bissau",
    alpha2: "gw"
  }, {
    name: "Guinea Equatoriale",
    alpha2: "gq"
  }, {
    name: "Guyana",
    alpha2: "gy"
  }, {
    name: "Guyana francese",
    alpha2: "gf"
  }, {
    name: "Haiti",
    alpha2: "ht"
  }, {
    name: "Honduras",
    alpha2: "hn"
  }, {
    name: "Hong Kong",
    alpha2: "hk"
  }, {
    name: "India",
    alpha2: "in"
  }, {
    name: "Indonesia",
    alpha2: "id"
  }, {
    name: "Iran",
    alpha2: "ir"
  }, {
    name: "Iraq",
    alpha2: "iq"
  }, {
    name: "Irlanda",
    alpha2: "ie"
  }, {
    name: "Islanda",
    alpha2: "is"
  }, {
    name: "Isola Bouvet",
    alpha2: "bv"
  }, {
    name: "Isola di Man",
    alpha2: "im"
  }, {
    name: "Isola di Natale",
    alpha2: "cx"
  }, {
    name: "Isola Norfolk",
    alpha2: "nf"
  }, {
    name: "Isole Åland",
    alpha2: "ax"
  }, {
    name: "Isole BES",
    alpha2: "bq"
  }, {
    name: "Isole Cayman",
    alpha2: "ky"
  }, {
    name: "Isole Cocos (Keeling)",
    alpha2: "cc"
  }, {
    name: "Isole Cook",
    alpha2: "ck"
  }, {
    name: "Fær Øer",
    alpha2: "fo"
  }, {
    name: "Isole Falkland",
    alpha2: "fk"
  }, {
    name: "Isole Heard e McDonald",
    alpha2: "hm"
  }, {
    name: "Isole Marianne Settentrionali",
    alpha2: "mp"
  }, {
    name: "Isole Marshall",
    alpha2: "mh"
  }, {
    name: "Isole minori esterne degli Stati Uniti",
    alpha2: "um"
  }, {
    name: "Isole Pitcairn",
    alpha2: "pn"
  }, {
    name: "Isole Salomone",
    alpha2: "sb"
  }, {
    name: "Isole Vergini britanniche",
    alpha2: "vg"
  }, {
    name: "Isole Vergini americane",
    alpha2: "vi"
  }, {
    name: "Israele",
    alpha2: "il"
  }, {
    name: "Italia",
    alpha2: "it"
  }, {
    name: "Jersey",
    alpha2: "je"
  }, {
    name: "Kazakistan",
    alpha2: "kz"
  }, {
    name: "Kenya",
    alpha2: "ke"
  }, {
    name: "Kirghizistan",
    alpha2: "kg"
  }, {
    name: "Kiribati",
    alpha2: "ki"
  }, {
    name: "Kuwait",
    alpha2: "kw"
  }, {
    name: "Laos",
    alpha2: "la"
  }, {
    name: "Lesotho",
    alpha2: "ls"
  }, {
    name: "Lettonia",
    alpha2: "lv"
  }, {
    name: "Libano",
    alpha2: "lb"
  }, {
    name: "Liberia",
    alpha2: "lr"
  }, {
    name: "Libia",
    alpha2: "ly"
  }, {
    name: "Liechtenstein",
    alpha2: "li"
  }, {
    name: "Lituania",
    alpha2: "lt"
  }, {
    name: "Lussemburgo",
    alpha2: "lu"
  }, {
    name: "Macao",
    alpha2: "mo"
  }, {
    name: "Macedonia",
    alpha2: "mk"
  }, {
    name: "Madagascar",
    alpha2: "mg"
  }, {
    name: "Malawi",
    alpha2: "mw"
  }, {
    name: "Malaysia",
    alpha2: "my"
  }, {
    name: "Maldive",
    alpha2: "mv"
  }, {
    name: "Mali",
    alpha2: "ml"
  }, {
    name: "Malta",
    alpha2: "mt"
  }, {
    name: "Marocco",
    alpha2: "ma"
  }, {
    name: "Martinica",
    alpha2: "mq"
  }, {
    name: "Mauritania",
    alpha2: "mr"
  }, {
    name: "Mauritius",
    alpha2: "mu"
  }, {
    name: "Mayotte",
    alpha2: "yt"
  }, {
    name: "Messico",
    alpha2: "mx"
  }, {
    name: "Micronesia",
    alpha2: "fm"
  }, {
    name: "Moldavia",
    alpha2: "md"
  }, {
    name: "Mongolia",
    alpha2: "mn"
  }, {
    name: "Montenegro",
    alpha2: "me"
  }, {
    name: "Montserrat",
    alpha2: "ms"
  }, {
    name: "Mozambico",
    alpha2: "mz"
  }, {
    name: "Namibia",
    alpha2: "na"
  }, {
    name: "Nauru",
    alpha2: "nr"
  }, {
    name: "Nepal",
    alpha2: "np"
  }, {
    name: "Nicaragua",
    alpha2: "ni"
  }, {
    name: "Niger",
    alpha2: "ne"
  }, {
    name: "Nigeria",
    alpha2: "ng"
  }, {
    name: "Niue",
    alpha2: "nu"
  }, {
    name: "Norvegia",
    alpha2: "no"
  }, {
    name: "Nuova Caledonia",
    alpha2: "nc"
  }, {
    name: "Nuova Zelanda",
    alpha2: "nz"
  }, {
    name: "Oman",
    alpha2: "om"
  }, {
    name: "Paesi Bassi",
    alpha2: "nl"
  }, {
    name: "Pakistan",
    alpha2: "pk"
  }, {
    name: "Palau",
    alpha2: "pw"
  }, {
    name: "Palestina",
    alpha2: "ps"
  }, {
    name: "Panama",
    alpha2: "pa"
  }, {
    name: "Papua Nuova Guinea",
    alpha2: "pg"
  }, {
    name: "Paraguay",
    alpha2: "py"
  }, {
    name: "Perù",
    alpha2: "pe"
  }, {
    name: "Polinesia Francese",
    alpha2: "pf"
  }, {
    name: "Polonia",
    alpha2: "pl"
  }, {
    name: "Porto Rico",
    alpha2: "pr"
  }, {
    name: "Portogallo",
    alpha2: "pt"
  }, {
    name: "Monaco",
    alpha2: "mc"
  }, {
    name: "Qatar",
    alpha2: "qa"
  }, {
    name: "Regno Unito",
    alpha2: "gb"
  }, {
    name: "RD del Congo",
    alpha2: "cd"
  }, {
    name: "Rep. Ceca",
    alpha2: "cz"
  }, {
    name: "Rep. Centrafricana",
    alpha2: "cf"
  }, {
    name: "Rep. del Congo",
    alpha2: "cg"
  }, {
    name: "Rep. Dominicana",
    alpha2: "do"
  }, {
    name: "Riunione",
    alpha2: "re"
  }, {
    name: "Romania",
    alpha2: "ro"
  }, {
    name: "Ruanda",
    alpha2: "rw"
  }, {
    name: "Russia",
    alpha2: "ru"
  }, {
    name: "Sahara Occidentale",
    alpha2: "eh"
  }, {
    name: "Saint Kitts e Nevis",
    alpha2: "kn"
  }, {
    name: "Saint Lucia",
    alpha2: "lc"
  }, {
    name: "Sant'Elena, Ascensione e Tristan da Cunha",
    alpha2: "sh"
  }, {
    name: "Saint Vincent e Grenadine",
    alpha2: "vc"
  }, {
    name: "Saint-Barthélemy",
    alpha2: "bl"
  }, {
    name: "Saint-Martin",
    alpha2: "mf"
  }, {
    name: "Saint-Pierre e Miquelon",
    alpha2: "pm"
  }, {
    name: "Samoa",
    alpha2: "ws"
  }, {
    name: "Samoa Americane",
    alpha2: "as"
  }, {
    name: "San Marino",
    alpha2: "sm"
  }, {
    name: "São Tomé e Príncipe",
    alpha2: "st"
  }, {
    name: "Senegal",
    alpha2: "sn"
  }, {
    name: "Serbia",
    alpha2: "rs"
  }, {
    name: "Seychelles",
    alpha2: "sc"
  }, {
    name: "Sierra Leone",
    alpha2: "sl"
  }, {
    name: "Singapore",
    alpha2: "sg"
  }, {
    name: "Sint Maarten",
    alpha2: "sx"
  }, {
    name: "Siria",
    alpha2: "sy"
  }, {
    name: "Slovacchia",
    alpha2: "sk"
  }, {
    name: "Slovenia",
    alpha2: "si"
  }, {
    name: "Somalia",
    alpha2: "so"
  }, {
    name: "Spagna",
    alpha2: "es"
  }, {
    name: "Sri Lanka",
    alpha2: "lk"
  }, {
    name: "Stati Uniti",
    alpha2: "us"
  }, {
    name: "Sudafrica",
    alpha2: "za"
  }, {
    name: "Sudan",
    alpha2: "sd"
  }, {
    name: "Sudan del Sud",
    alpha2: "ss"
  }, {
    name: "Suriname",
    alpha2: "sr"
  }, {
    name: "Svalbard e Jan Mayen",
    alpha2: "sj"
  }, {
    name: "Svezia",
    alpha2: "se"
  }, {
    name: "Svizzera",
    alpha2: "ch"
  }, {
    name: "Swaziland",
    alpha2: "sz"
  }, {
    name: "Taiwan",
    alpha2: "tw"
  }, {
    name: "Tagikistan",
    alpha2: "tj"
  }, {
    name: "Tanzania",
    alpha2: "tz"
  }, {
    name: "Terre australi e antartiche francesi",
    alpha2: "tf"
  }, {
    name: "Territorio britannico dell'Oceano Indiano",
    alpha2: "io"
  }, {
    name: "Thailandia",
    alpha2: "th"
  }, {
    name: "Timor Est",
    alpha2: "tl"
  }, {
    name: "Togo",
    alpha2: "tg"
  }, {
    name: "Tokelau",
    alpha2: "tk"
  }, {
    name: "Tonga",
    alpha2: "to"
  }, {
    name: "Trinidad e Tobago",
    alpha2: "tt"
  }, {
    name: "Tunisia",
    alpha2: "tn"
  }, {
    name: "Turchia",
    alpha2: "tr"
  }, {
    name: "Turkmenistan",
    alpha2: "tm"
  }, {
    name: "Turks e Caicos",
    alpha2: "tc"
  }, {
    name: "Tuvalu",
    alpha2: "tv"
  }, {
    name: "Ucraina",
    alpha2: "ua"
  }, {
    name: "Uganda",
    alpha2: "ug"
  }, {
    name: "Ungheria",
    alpha2: "hu"
  }, {
    name: "Uruguay",
    alpha2: "uy"
  }, {
    name: "Uzbekistan",
    alpha2: "uz"
  }, {
    name: "Vanuatu",
    alpha2: "vu"
  }, {
    name: "Venezuela",
    alpha2: "ve"
  }, {
    name: "Vietnam",
    alpha2: "vn"
  }, {
    name: "Wallis e Futuna",
    alpha2: "wf"
  }, {
    name: "Yemen",
    alpha2: "ye"
  }, {
    name: "Zambia",
    alpha2: "zm"
  }, {
    name: "Zimbabwe",
    alpha2: "zw"
  }],
  mq = {
    en: cq,
    nl: lq,
    de: fq,
    fr: dq,
    es: hq,
    it: pq
  };
function F_(e) {
  return !isNaN(e) && function (t) {
    return (t | 0) === t;
  }(parseFloat(e));
}
function L_(_ref76) {
  var e = _ref76.bookingFields,
    t = _ref76.errors,
    n = _ref76.touched,
    r = _ref76.PortalSite,
    a = _ref76.values;
  var i = [].concat(e);
  var o = ["address", "house_number", "zipcode", "city"];
  return (a.cancel_insurance === "1" || a.cancel_insurance === "2") && o.forEach(function (s) {
    var u = e.findIndex(function (l) {
      return l.id === s;
    });
    u !== -1 ? i[u] = Rc.find(function (l) {
      return l.id === s;
    }) : i.push(Rc.find(function (l) {
      return l.id === s;
    }));
  }), /* @__PURE__ */F("div", {
    className: "form-section",
    children: [/* @__PURE__ */d("h2", {
      children: /* @__PURE__ */d(J, {
        id: "personal_details"
      })
    }), i.map(function (s) {
      if (s.id === "telephone" && (s.id = "phonenumber"), s.type === "booking_field" || F_(s.id)) {
        var u = r.booking_fields.find(function (l) {
          return l.id === s.id;
        });
        return /* @__PURE__ */F("div", {
          className: "form-row",
          children: [/* @__PURE__ */F("label", {
            htmlFor: "extra_fields.booking_field_".concat(u.id),
            children: [u.label, " ", s.required && /* @__PURE__ */d("span", {
              children: "*"
            })]
          }), /* @__PURE__ */d(It, {
            onKeyPress: function onKeyPress(l) {
              l.which === 13 && l.preventDefault();
            },
            id: "extra_fields.booking_field_".concat(u.id),
            type: u.field_type === "text" ? "input" : u.field_type,
            component: u.field_type === "text" ? "input" : u.field_type,
            name: "extra_fields.booking_field_".concat(u.id)
          }), t[s.id] && (n.extra_fields && n.extra_fields["booking_field_".concat(u.id)] || n[s.id]) && /* @__PURE__ */d("div", {
            className: "error-message",
            children: t[s.id]
          })]
        }, u.id);
      } else return s.id === "country" ? /* @__PURE__ */F("div", {
        className: "form-row",
        children: [/* @__PURE__ */F("label", {
          htmlFor: s.id,
          children: [r["".concat(s.id, "_label")], " ", s.required && /* @__PURE__ */d("span", {
            children: "*"
          })]
        }), /* @__PURE__ */d(It, {
          component: "select",
          name: s.id,
          children: mq[window.__localeId__].map(function (u) {
            return /* @__PURE__ */d("option", {
              value: u.alpha2,
              children: u.name
            }, u.alpha2);
          })
        }), t[s.id] && /* @__PURE__ */d("div", {
          className: "error-message",
          children: t[s.id]
        })]
      }, s.id) : s.type === "date" ? /* @__PURE__ */d("div", {
        className: "form-row",
        children: /* @__PURE__ */d(od, {
          name: s.id,
          label: s.id,
          inline: !1
        })
      }, s.id) : /* @__PURE__ */F("div", {
        className: "form-row",
        children: [/* @__PURE__ */F("label", {
          htmlFor: s.id,
          name: "".concat(s.id.replace(/\./g, "_"), "_label"),
          children: [r["".concat(s.id.replace(/\./g, "_"), "_label")], " ", s.required && /* @__PURE__ */d("span", {
            children: "*"
          })]
        }), /* @__PURE__ */d(It, {
          type: s.type,
          name: s.id,
          onKeyPress: function onKeyPress(u) {
            u.which === 13 && u.preventDefault();
          }
        }), t[s.id] && n[s.id] && /* @__PURE__ */d("div", {
          className: "error-message",
          children: t[s.id]
        })]
      }, s.id);
    })]
  });
}
L_.propTypes = {
  bookingFields: k.array.isRequired,
  errors: k.object.isRequired,
  PortalSite: k.object.isRequired
};
function vq(_ref77) {
  var e = _ref77.costs;
  return e.length === 0 ? null : /* @__PURE__ */F("div", {
    className: "form-section optional_house_costs",
    children: [/* @__PURE__ */d("h2", {
      children: /* @__PURE__ */d(J, {
        id: "extra_costs_bookable"
      })
    }), /* @__PURE__ */d("div", {
      children: e.map(function (t) {
        return !["none", "total"].includes(t.method) && t.max_available > 0 ? t.max_available === 1 ? /* @__PURE__ */F("div", {
          className: "form-row inline",
          children: [/* @__PURE__ */d("label", {
            htmlFor: t.id,
            children: t.name
          }), /* @__PURE__ */F(It, {
            component: "select",
            name: "costs[".concat(t.id, "]"),
            children: [/* @__PURE__ */d(J, {
              id: "no",
              children: function children(n) {
                return /* @__PURE__ */d("option", {
                  value: 0,
                  children: n
                });
              }
            }), /* @__PURE__ */d(J, {
              id: "yes",
              children: function children(n) {
                return /* @__PURE__ */d("option", {
                  value: 1,
                  children: n
                });
              }
            })]
          }), /* @__PURE__ */F("div", {
            className: "price_per",
            children: ["€", " ", /* @__PURE__ */d(Pn, {
              value: t.amount,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }), " ", t.method_name]
          }), /* @__PURE__ */d("div", {
            children: t.description ? /* @__PURE__ */d("div", {
              children: /* @__PURE__ */d(on, {
                buttonText: /* @__PURE__ */d(Vo, {}),
                children: /* @__PURE__ */d("p", {
                  children: t.description
                })
              })
            }) : null
          })]
        }, t.id) : /* @__PURE__ */F("div", {
          className: "form-row inline",
          children: [/* @__PURE__ */d("label", {
            htmlFor: t.id,
            children: t.name
          }), /* @__PURE__ */d(It, {
            component: "select",
            name: "costs[".concat(t.id, "]"),
            children: id(t.max_available).map(function (n) {
              return /* @__PURE__ */d("option", {
                value: n,
                children: n
              }, n);
            })
          }), /* @__PURE__ */F("div", {
            className: "price_per",
            children: ["€", " ", /* @__PURE__ */d(Pn, {
              value: t.amount,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }), " ", t.method_name]
          }), /* @__PURE__ */d("div", {
            children: t.description ? /* @__PURE__ */d("div", {
              children: /* @__PURE__ */d(on, {
                buttonText: /* @__PURE__ */d(Vo, {}),
                children: /* @__PURE__ */d("p", {
                  children: t.description
                })
              })
            }) : null
          })]
        }, t.id) : "";
      })
    })]
  });
}
function yq(_ref78) {
  var e = _ref78.options,
    t = _ref78.house;
  return /* @__PURE__ */F(vt, {
    children: [/* @__PURE__ */d(zi, {
      name: "adults",
      label: "adults",
      count: t.persons,
      description: /* @__PURE__ */d("div", {
        className: "age-description",
        children: /* @__PURE__ */d(J, {
          id: "adults_from",
          defaultMessage: "> {age}",
          values: {
            age: e.bookingForm && e.bookingForm.adults_from || "18"
          }
        })
      })
    }), e.bookingForm && !e.bookingForm.children ? null : /* @__PURE__ */d(zi, {
      name: "children",
      label: "children",
      count: t.persons - 1,
      description: /* @__PURE__ */d("div", {
        className: "age-description",
        children: /* @__PURE__ */d(J, {
          id: "children_from",
          defaultMessage: "{from} - {til}",
          values: {
            from: e.bookingForm && e.bookingForm.children_from || "3",
            til: e.bookingForm && e.bookingForm.children_til || "17"
          }
        })
      })
    }), e.bookingForm && !e.bookingForm.babies ? null : /* @__PURE__ */d(zi, {
      name: "babies",
      label: "babies",
      count: t.persons - 1,
      description: /* @__PURE__ */d("div", {
        className: "age-description",
        children: /* @__PURE__ */d(J, {
          id: "babies_from",
          defaultMessage: "til {babies_til}",
          values: {
            babies: e.bookingForm && e.bookingForm.babies_til || "2"
          }
        })
      })
    })]
  });
}
function gq(e, t, n) {
  var s;
  var r = t.babies_extra,
    a = t.persons;
  var i = {},
    o = Number(e.babies) - Number(r);
  o < 0 && (o = 0), e.persons = Number(e.children) + Number(e.adults) + o;
  var _iterator9 = _createForOfIteratorHelper(n),
    _step8;
  try {
    for (_iterator9.s(); !(_step8 = _iterator9.n()).done;) {
      var u = _step8.value;
      if (u.required) if (F_(u.id)) {
        var _l3 = _v(e, "extra_fields.booking_field_".concat(u.id));
        (!_l3 || _l3 === "") && (i[u.id] = /* @__PURE__ */d(J, {
          id: "required"
        }));
      } else {
        var _l4 = _v(e, u.id);
        (!_l4 || _l4 === "") && (i[u.id] = /* @__PURE__ */d(J, {
          id: "required"
        }));
      }
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return e.adults < 1 && (i.adults = /* @__PURE__ */d(J, {
    id: "at_least_1_adult"
  })), Number(e.discount) > 0 && !e.discount_reason && (i.discount_reason = /* @__PURE__ */d(J, {
    id: "you_need_to_give_reason"
  })), e.persons > a && (i.max_persons = /* @__PURE__ */d(J, {
    id: "max_persons_reached"
  })), e.cancel_insurance !== 0 && WV((s = e.extra_fields) == null ? void 0 : s.date_of_birth) && (i["extra_fields.date_of_birth"] = /* @__PURE__ */d(J, {
    id: "at_least_18y_old"
  }), i.insurances = /* @__PURE__ */d(J, {
    id: "at_least_18y_old"
  })), parseInt(e.cancel_insurance) !== 0 && !["nl", "de", "be"].includes(e.country) && (i.insurances = /* @__PURE__ */d(J, {
    id: "can_only_take_insurance_in_de_be_nl"
  }), i.country = /* @__PURE__ */d(J, {
    id: "can_only_take_insurance_in_de_be_nl"
  })), i;
}
var sd = {
    selectedDate: null,
    arrivalDate: null,
    departureDate: null,
    bookingStarted: !1,
    persons: 2
  },
  ar = React.createContext(sd),
  Ma = React.createContext(j_);
function bq(_ref79) {
  var e = _ref79.children;
  var _React$useReducer = React.useReducer(j_, sd),
    _React$useReducer2 = _slicedToArray2(_React$useReducer, 2),
    t = _React$useReducer2[0],
    n = _React$useReducer2[1];
  return /* @__PURE__ */d(ar.Provider, {
    value: t,
    children: /* @__PURE__ */d(Ma.Provider, {
      value: n,
      children: e
    })
  });
}
function j_(e, t) {
  switch (console.log({
    action: t
  }), t.type) {
    case "clicked":
      {
        var _n3 = t.day,
          _r2 = t.house,
          a = e.selectedDate,
          i = e.arrivalDate,
          o = $t(_n3.date);
        return _n3.departure && a && i && fr(o, a) && _n(o, a) <= _r2.max_nights && _n(o, a) >= i.min_nights && _n(o, a) <= i.max_nights ? _objectSpread2(_objectSpread2({}, e), {}, {
          departureDate: _n3
        }) : _n3.arrival ? {
          bookingStarted: !1,
          selectedDate: o,
          arrivalDate: _n3,
          departureDate: null,
          persons: 2
        } : e;
      }
    case "reset":
      return sd;
    case "start":
      return _objectSpread2(_objectSpread2({}, e), {}, {
        bookingStarted: !0,
        persons: t.persons
      });
    case "return":
      return _objectSpread2(_objectSpread2({}, e), {}, {
        bookingStarted: !1
      });
    default:
      throw Error("Unknown action: " + t.type);
  }
}
function _q(_ref80) {
  var e = _ref80.house,
    t = _ref80.PortalSite;
  var _React$useContext4 = React.useContext(ar),
    n = _React$useContext4.persons,
    r = _React$useContext4.arrivalDate,
    a = _React$useContext4.departureDate,
    _React$useContext5 = React.useContext(Vt),
    i = _React$useContext5.locale,
    o = _React$useContext5.portalCode,
    s = _React$useContext5.objectCode,
    u = React.useContext(Ma),
    l = t.options,
    c = l.bookingFields || Rc,
    f = e.booking_price;
  var h = {};
  var _iterator10 = _createForOfIteratorHelper(f.optional_house_costs),
    _step9;
  try {
    for (_iterator10.s(); !(_step9 = _iterator10.n()).done;) {
      var _y3 = _step9.value;
      h[_y3.id] = "0";
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }
  var _Py3 = Py(NS),
    _Py4 = _slicedToArray2(_Py3, 2),
    p = _Py4[0],
    _Py4$ = _Py4[1],
    v = _Py4$.loading,
    m = _Py4$.error,
    g = _Py4$.data;
  if (g) return /* @__PURE__ */d(on, {
    show: !0,
    children: /* @__PURE__ */d(uq, {})
  });
  var b = HV(c);
  return /* @__PURE__ */d(RV, {
    validate: function validate(y) {
      return gq(y, e, c);
    },
    initialValues: _objectSpread2(_objectSpread2({}, b), {}, {
      arrivalDate: r,
      departureDate: a,
      is_option: "false",
      costs: h,
      adults: n,
      children: 0,
      babies: 0,
      persons: n,
      discount: 0,
      country: "nl"
    }),
    onSubmit: function onSubmit(y, _ref81) {
      var E = _ref81.setSubmitting;
      var w = _objectSpread2(_objectSpread2({}, y), {}, {
        is_option: JSON.parse(y.is_option),
        house_code: s,
        portal_code: o,
        comment: y.comment || "",
        language: i,
        country: y.country.toUpperCase(),
        adults: Number(y.adults),
        children: Number(y.children) || 0,
        babies: Number(y.babies) || 0,
        discount: Number(y.discount) || 0,
        cancel_insurance: Number(y.cancel_insurance) || 0,
        arrival_date: y.arrivalDate.date,
        departure_date: y.departureDate.date,
        costs: JSON.stringify(y.costs),
        extra_fields: JSON.stringify(y.extra_fields)
      });
      p({
        variables: w
      }).then(function () {
        l.bookingForm && l.bookingForm["redirectUrl_".concat(i)] && l.bookingForm["redirectUrl_".concat(i)] !== "" ? window.location = l.bookingForm["redirectUrl_".concat(i)] : l.bookingForm && l.bookingForm.redirectUrl && l.bookingForm.redirectUrl !== "" ? window.location = l.bookingForm.redirectUrl : setTimeout(function () {
          u({
            type: "return"
          });
        }, 15e3);
      }).catch(function (_) {});
    },
    children: function children(_ref82) {
      var y = _ref82.errors,
        E = _ref82.touched,
        w = _ref82.values,
        _ = _ref82.status,
        C = _ref82.isSubmitting;
      return /* @__PURE__ */F(R_, {
        className: "form",
        children: [v && /* @__PURE__ */d("div", {
          className: "return-message",
          children: "Loading..."
        }), m && /* @__PURE__ */d(on, {
          show: !0,
          children: /* @__PURE__ */d(Zn, {
            errors: m,
            modal: !0
          })
        }), /* @__PURE__ */F("div", {
          className: "form-content",
          children: [/* @__PURE__ */F("div", {
            className: "form-section",
            children: [/* @__PURE__ */d("a", {
              className: "return-link",
              role: "link",
              tabIndex: 0,
              onClick: function onClick() {
                u({
                  type: "return"
                });
              },
              children: /* @__PURE__ */d(J, {
                id: "return_to_calendar"
              })
            }), /* @__PURE__ */d("h2", {
              children: /* @__PURE__ */d(J, {
                id: "stay_details"
              })
            }), /* @__PURE__ */d(yq, {
              options: l,
              house: e
            }), y.max_persons && /* @__PURE__ */d("div", {
              className: "error-message persons",
              children: y.max_persons
            })]
          }), /* @__PURE__ */d(N_, {
            errors: y,
            house: e,
            options: l,
            values: w,
            render: f.optional_house_costs
          }), /* @__PURE__ */d(YV, {
            house: e,
            values: w
          }), /* @__PURE__ */d(vq, {
            costs: f.optional_house_costs
          }), /* @__PURE__ */d(L_, {
            bookingFields: c,
            errors: y,
            touched: E,
            PortalSite: t,
            values: w
          })]
        }), /* @__PURE__ */F("div", {
          className: "form-sum",
          children: [/* @__PURE__ */d(sq, {
            house: e,
            values: w
          }), _ && _.msg && /* @__PURE__ */d("div", {
            children: _.msg
          }), /* @__PURE__ */F("div", {
            className: "terms",
            children: [/* @__PURE__ */d(J, {
              id: "agree_with"
            }), " ", /* @__PURE__ */d(J, {
              id: "terms",
              children: function children(D) {
                return /* @__PURE__ */d(on, {
                  buttonText: D,
                  children: /* @__PURE__ */d("div", {
                    style: {
                      width: "90vh",
                      height: "90vh"
                    },
                    children: /* @__PURE__ */d("iframe", {
                      src: e.rental_terms,
                      width: "100%",
                      height: "100%",
                      title: "Terms"
                    })
                  })
                });
              }
            })]
          }), [1, 2].includes(Number(w.cancel_insurance)) ? /* @__PURE__ */d("div", {
            className: "terms",
            children: /* @__PURE__ */d(J, {
              id: "comply_insurance_card"
            })
          }) : null, /* @__PURE__ */d("button", {
            className: "bu-calendar-button",
            type: "submit",
            disabled: C,
            children: /* @__PURE__ */d(J, {
              id: "book"
            })
          })]
        })]
      });
    }
  });
}
function wq() {
  var _React$useContext6 = React.useContext(Vt),
    e = _React$useContext6.portalCode,
    t = _React$useContext6.objectCode,
    _React$useContext7 = React.useContext(ar),
    n = _React$useContext7.arrivalDate,
    r = _React$useContext7.departureDate,
    _ln4 = ln(RS, {
      variables: {
        portalCode: e,
        objectCode: t,
        starts_at: n.date,
        ends_at: r.date
      }
    }),
    a = _ln4.data,
    i = _ln4.loading,
    o = _ln4.error;
  if (i) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Dn, {})
  });
  if (o) return /* @__PURE__ */d("div", {
    children: "Error"
  });
  var s = a.PortalSite.houses[0];
  return /* @__PURE__ */d(_q, {
    house: s,
    PortalSite: a.PortalSite
  });
}
var Oq = function Oq() {
    return /* @__PURE__ */F("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "data-name": "Layer 1",
      viewBox: "0 0 100 100",
      x: "0px",
      y: "0px",
      children: [/* @__PURE__ */d("title", {
        children: "Forward"
      }), /* @__PURE__ */d("path", {
        d: "M97.64,44.1,64.72,11.18a8.06,8.06,0,1,0-11.4,11.39L72.78,42H8.06a8.06,8.06,0,0,0,0,16.12H72.6L53.32,77.43a8.06,8.06,0,0,0,11.4,11.39L97.64,55.9A8,8,0,0,0,100,50.2a1.27,1.27,0,0,0,0-.2,1.41,1.41,0,0,0,0-.2A8.07,8.07,0,0,0,97.64,44.1Z"
      })]
    });
  },
  Sq = function Sq() {
    return /* @__PURE__ */d("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      version: "1.1",
      x: "0px",
      y: "0px",
      enableBackground: "new 0 0 100 100",
      viewBox: "0 0 100 125",
      xmlSpace: "preserve",
      children: /* @__PURE__ */d("path", {
        d: "M2.4,44.1l32.9-32.9c3.1-3.1,8.2-3.1,11.4,0c1.6,1.6,2.4,3.6,2.4,5.7c0,2.1-0.8,4.1-2.4,5.7L27.2,42h64.7  c2.2,0,4.2,0.9,5.7,2.4c1.5,1.5,2.4,3.5,2.4,5.7c0,4.4-3.6,8.1-8.1,8.1H27.4l19.3,19.3c1.6,1.6,2.4,3.6,2.4,5.7s-0.8,4.1-2.4,5.7  c-3.1,3.1-8.3,3.1-11.4,0L2.4,55.9C0.8,54.3,0,52.3,0,50.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2C0,47.7,0.8,45.7,2.4,44.1z"
      })
    });
  };
function Eq(_ref83) {
  var e = _ref83.changeMonth,
    t = _ref83.currentMonth,
    n = _ref83.numberOfMonths;
  var r = React.useContext(Ma);
  function a() {
    e(Ea(t, n));
  }
  function i() {
    e(bD(t, n));
  }
  return /* @__PURE__ */F("div", {
    className: "calendars-header",
    children: [/* @__PURE__ */d("div", {
      className: "bu-calendar-col bu-prev",
      style: {
        textAlign: "center"
      },
      onClick: i,
      tabIndex: 0,
      role: "button",
      children: /* @__PURE__ */F("div", {
        className: "icon",
        children: [" ", /* @__PURE__ */d(Sq, {})]
      })
    }), /* @__PURE__ */d("div", {
      className: "bu-calendar-col bu-reset",
      onClick: function onClick() {
        r({
          type: "reset"
        });
      },
      style: {
        textAlign: "center"
      },
      tabIndex: 0,
      role: "button",
      children: /* @__PURE__ */d("div", {
        className: "icon",
        children: /* @__PURE__ */d(Eb, {})
      })
    }), /* @__PURE__ */d("div", {
      className: "bu-calendar-col bu-next",
      onClick: a,
      style: {
        textAlign: "center"
      },
      tabIndex: 0,
      role: "button",
      children: /* @__PURE__ */d("div", {
        className: "icon",
        children: /* @__PURE__ */d(Oq, {})
      })
    })]
  });
}
function Pq(_ref84) {
  var e = _ref84.house;
  var _React$useContext8 = React.useContext(ar),
    t = _React$useContext8.departureDate,
    n = _React$useContext8.arrivalDate;
  return t != null && t.date ? /* @__PURE__ */F("div", {
    className: "assistance",
    children: [/* @__PURE__ */d(J, {
      id: "".concat(e.house_type, ".you_picked_arrival_date")
    }), ":", " ", jt($t(n.date), gr), /* @__PURE__ */d("br", {}), /* @__PURE__ */d(J, {
      id: "".concat(e.house_type, ".you_picked_departure_date")
    }), ": ", jt($t(t.date), gr)]
  }) : n != null && n.date ? /* @__PURE__ */F("div", {
    className: "assistance",
    children: [/* @__PURE__ */d(J, {
      id: "".concat(e.house_type, ".you_picked_arrival_date")
    }), ":", " ", jt($t(n.date), gr), /* @__PURE__ */d("br", {}), /* @__PURE__ */d(J, {
      id: "".concat(e.house_type, ".pick_your_departure_in_the_calendar")
    }), /* @__PURE__ */d("br", {}), /* @__PURE__ */d(J, {
      id: "minimum_nights",
      values: {
        minimum: n.min_nights
      },
      defaultMessage: "Minimum {minimum} nights"
    })]
  }) : /* @__PURE__ */d("div", {
    className: "assistance",
    children: /* @__PURE__ */d(J, {
      id: "".concat(e.house_type, ".pick_your_arrivaldate_in_the_calendar")
    })
  });
}
function Tq(_ref85) {
  var e = _ref85.house;
  return /* @__PURE__ */F("div", {
    className: "legend",
    children: [/* @__PURE__ */F("div", {
      children: [/* @__PURE__ */d("span", {
        className: "legend-field arrival"
      }), /* @__PURE__ */d(J, {
        id: "".concat(e.house_type, ".arrival_date")
      })]
    }), /* @__PURE__ */F("div", {
      children: [/* @__PURE__ */d("span", {
        className: "legend-field booked"
      }), /* @__PURE__ */d(J, {
        id: "booked"
      })]
    }), /* @__PURE__ */F("div", {
      children: [/* @__PURE__ */d("span", {
        className: "legend-field departure"
      }), /* @__PURE__ */d(J, {
        id: "".concat(e.house_type, ".departure_date")
      })]
    }), /* @__PURE__ */F("div", {
      children: [/* @__PURE__ */d("span", {
        className: "legend-field last_minute_discount"
      }), /* @__PURE__ */d(J, {
        id: "discount"
      })]
    })]
  });
}
var kq = function kq(_ref86) {
  var e = _ref86.month;
  return /* @__PURE__ */d("div", {
    className: "header bu-calendar-row flex-middle",
    children: /* @__PURE__ */d("div", {
      className: "bu-calendar-col col-center",
      style: {
        textAlign: "center"
      },
      children: /* @__PURE__ */d("span", {
        children: jt(e, QM)
      })
    })
  });
};
function Dq(_ref87) {
  var e = _ref87.day,
    t = _ref87.monthStart,
    n = _ref87.buDate,
    r = _ref87.prevBooked,
    a = _ref87.dates,
    i = _ref87.house,
    o = _ref87.discounts;
  var s = a.selectedDate,
    u = a.departureDate,
    l = a.arrivalDate;
  var c = ["bu-calendar-col", "cell"];
  if (!gD(e, t)) return c.push("disabled"), c.join(" ");
  if (n && (n.arrival && fr(e, new Date()) && n.max_nights !== 0 ? r.max_nights === 0 ? c.push("departure-arrival") : (c.push("arrival"), c.push("arrival")) : n.max_nights === 0 && (r.max_nights !== 0 ? c.push("booked-departure") : c.push("booked"))), s) {
    mh(e, s) && c.push("selected");
    var _v2 = _n(e, s) >= l.min_nights,
      _m2 = _n(e, s) <= i.max_nights && _n(e, s) <= l.max_nights;
    n.departure && fr(e, s) && _v2 && _m2 && r.max_nights !== 0 && c.push("departure");
  }
  u && (fr(e, s) && bh(e, $t(u.date)) && c.push("selected"), mh(e, $t(u.date)) && c.push("selected"));
  var f = _n(e, new Date()),
    h = f <= i.last_minute_days && f > 0,
    p = o.find(function (v) {
      return bh(Gy($t(v.discount_starts_at), 1), e) && fr(Qo($t(v.discount_ends_at), 1), e);
    });
  return (h || p || n.special_offer > 0) && c.push("discount"), c.join(" ");
}
function xq(_ref88) {
  var e = _ref88.availabilities,
    t = _ref88.month,
    n = _ref88.discounts,
    r = _ref88.house;
  var a = React.useContext(Ma),
    i = React.useContext(ar),
    o = ky(t),
    s = Ty(o),
    u = cf(o),
    l = Dy(s),
    c = [];
  var f = [],
    h = u;
  for (; h <= l;) {
    var _loop = function _loop() {
      var v = jt(h, "yyyy-MM-dd"),
        m = jt(Gy(h, 1), "yyyy-MM-dd"),
        g = e.find(function (E) {
          return E.date === v;
        });
      var b = e.find(function (E) {
          return E.date === m;
        }),
        y = g;
      f.push( /* @__PURE__ */d("div", {
        className: Dq({
          day: h,
          monthStart: o,
          discounts: n,
          buDate: g,
          prevBooked: b,
          house: r,
          dates: i
        }),
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          a({
            type: "clicked",
            day: y,
            house: r
          });
        },
        children: /* @__PURE__ */d("span", {
          children: jt(h, "d")
        })
      }, g.date)), h = Qo(h, 1);
    };
    for (var _p5 = 0; _p5 < 7; _p5++) {
      _loop();
    }
    c.push( /* @__PURE__ */d("div", {
      className: "bu-calendar-row",
      children: f
    }, h)), f = [];
  }
  return /* @__PURE__ */d("div", {
    className: "body",
    children: c
  });
}
function $q(_ref89) {
  var e = _ref89.month;
  var t = "E";
  var n = [],
    r = cf(e);
  for (var a = 0; a < 7; a++) n.push( /* @__PURE__ */d("div", {
    className: "bu-calendar-col col-center",
    children: jt(Qo(r, a), t)
  }, a));
  return /* @__PURE__ */d("div", {
    className: "days bu-calendar-row",
    children: n
  });
}
function Cq(_ref90) {
  var e = _ref90.count,
    t = _ref90.currentMonth,
    n = _ref90.house,
    r = _ref90.numberOfMonthsInARow;
  var _React$useContext9 = React.useContext(Vt),
    a = _React$useContext9.portalCode,
    i = _React$useContext9.objectCode;
  var o = Ea(t, e),
    s = ky(o),
    u = Ty(o);
  var l = {
      id: a,
      house_id: i,
      starts_at: cf(s),
      ends_at: Dy(u)
    },
    _ln5 = ln(CS, {
      variables: l
    }),
    c = _ln5.loading,
    f = _ln5.error,
    h = _ln5.data;
  if (c) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Dn, {})
  });
  if (f) return /* @__PURE__ */d("div", {
    children: "Error"
  });
  var p = h.PortalSite.houses[0].availabilities,
    v = h.Discounts;
  return /* @__PURE__ */F("div", {
    className: "bu-calendar calendar-".concat(r),
    children: [/* @__PURE__ */d(kq, {
      month: o
    }), /* @__PURE__ */d($q, {
      month: o
    }), /* @__PURE__ */d(xq, {
      availabilities: p,
      discounts: v,
      month: o,
      house: n
    })]
  }, o);
}
function Rq(_ref91) {
  var e = _ref91.numberOfMonthsInARow,
    t = _ref91.currentMonth,
    n = _ref91.numberOfMonths,
    r = _ref91.house;
  var a = [];
  for (var i = 0; i < n; i++) a.push( /* @__PURE__ */d(Cq, {
    house: r,
    numberOfMonthsInARow: e,
    currentMonth: t,
    count: i
  }, la(Ea(t, i), "MM-yyyy")));
  return /* @__PURE__ */d("div", {
    className: "calendars-row",
    children: a
  });
}
var Nq = wt(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral2(["\n  query BookingPriceQuery(\n    $portalCode: ID!\n    $objectCode: String!\n    $starts_at: Date!\n    $ends_at: Date!\n    $persons: Int\n  ) {\n    PortalSite(id: $portalCode) {\n      houses(house_code: $objectCode) {\n        id\n        name\n        booking_price(\n          starts_at: $starts_at\n          ends_at: $ends_at\n          persons: $persons\n        )\n      }\n    }\n  }\n"])));
function Aq(_ref92) {
  var e = _ref92.persons,
    t = _ref92.variables;
  var _React$useContext10 = React.useContext(Vt),
    n = _React$useContext10.portalCode,
    r = _React$useContext10.objectCode,
    _ln6 = ln(Nq, {
      variables: _objectSpread2(_objectSpread2({}, t), {}, {
        persons: e,
        portalCode: n,
        objectCode: r
      })
    }),
    a = _ln6.loading,
    i = _ln6.error,
    o = _ln6.data;
  if (a) return /* @__PURE__ */d("div", {
    className: "price-overview--build",
    children: /* @__PURE__ */d(Dn, {})
  });
  if (i) return /* @__PURE__ */d("div", {
    className: "price-overview--build",
    children: /* @__PURE__ */d(Zn, {
      errors: i
    })
  });
  var s = o.PortalSite.houses[0].booking_price;
  return /* @__PURE__ */d(vt, {
    children: /* @__PURE__ */F("div", {
      className: "price-overview--book",
      children: [/* @__PURE__ */F("div", {
        className: "price",
        children: ["€", " ", /* @__PURE__ */d(Pn, {
          value: Math.round(s.total_price),
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })]
      }), /* @__PURE__ */d("div", {
        children: /* @__PURE__ */d("i", {
          children: /* @__PURE__ */d(J, {
            id: "based_on_one_person",
            values: {
              persons: e
            }
          })
        })
      })]
    })
  });
}
var wv = gr;
function Iq(_ref93) {
  var e = _ref93.house;
  var _React$useState274 = React.useState(2),
    _React$useState275 = _slicedToArray2(_React$useState274, 2),
    t = _React$useState275[0],
    n = _React$useState275[1],
    _React$useContext11 = React.useContext(ar),
    r = _React$useContext11.arrivalDate,
    a = _React$useContext11.departureDate,
    i = React.useContext(Ma);
  var o = id(e.persons);
  return /* @__PURE__ */F("div", {
    className: "calendar--picker",
    children: [/* @__PURE__ */F("div", {
      className: "calendar--picker--date",
      children: [/* @__PURE__ */d("span", {
        className: "name",
        children: /* @__PURE__ */d(J, {
          id: "".concat(e.house_type, ".arrival")
        })
      }), /* @__PURE__ */d("span", {
        className: "detail",
        children: r != null && r.date ? /* @__PURE__ */d("span", {
          children: jt($t(r == null ? void 0 : r.date), wv)
        }) : /* @__PURE__ */d(J, {
          id: "".concat(e.house_type, ".pick_your_arrivaldate_in_the_calendar")
        })
      })]
    }), /* @__PURE__ */F("div", {
      className: "calendar--picker--date",
      children: [/* @__PURE__ */d("span", {
        className: "name",
        children: /* @__PURE__ */d(J, {
          id: "".concat(e.house_type, ".departure")
        })
      }), /* @__PURE__ */d("span", {
        className: "detail",
        children: a != null && a.date ? /* @__PURE__ */d("span", {
          children: jt($t(a == null ? void 0 : a.date), wv)
        }) : /* @__PURE__ */F("div", {
          children: [/* @__PURE__ */d("div", {
            children: /* @__PURE__ */d(J, {
              id: "".concat(e.house_type, ".pick_your_departure_in_the_calendar")
            })
          }), r && /* @__PURE__ */d(J, {
            id: "minimum_nights",
            defaultMessage: "Minimum {minimum} nights",
            values: {
              minimum: r == null ? void 0 : r.min_nights
            }
          })]
        })
      })]
    }), /* @__PURE__ */d("div", {
      className: "calendar--picker--date",
      children: /* @__PURE__ */d("span", {
        className: "detail",
        children: /* @__PURE__ */d("select", {
          className: "calendar--picker--persons",
          value: t,
          onChange: function onChange(s) {
            n(s.target.value);
          },
          children: o.map(function (s) {
            return /* @__PURE__ */d(J, {
              id: "persons",
              children: function children(u) {
                return /* @__PURE__ */F("option", {
                  value: s,
                  children: [s, " ", u]
                }, s);
              }
            }, s);
          })
        })
      })
    }), /* @__PURE__ */d("div", {
      className: "calendar--picker--date",
      children: r && a && /* @__PURE__ */d(Aq, {
        persons: parseInt(t),
        variables: {
          starts_at: r == null ? void 0 : r.date,
          ends_at: a == null ? void 0 : a.date
        }
      })
    }), /* @__PURE__ */d("button", {
      className: "button",
      disabled: !r || !a,
      onClick: function onClick() {
        r && a && i({
          type: "start",
          persons: t
        });
      },
      children: /* @__PURE__ */d(J, {
        id: "calculate"
      })
    })]
  });
}
function Mq(_ref94) {
  var e = _ref94.house;
  return /* @__PURE__ */d("div", {
    className: "price-overview",
    children: /* @__PURE__ */d(Iq, {
      house: e
    })
  });
}
function B_(_ref95) {
  var e = _ref95.numberOfMonths,
    t = _ref95.house,
    n = _ref95.numberOfMonthsInARow;
  var _React$useState276 = React.useState(new Date()),
    _React$useState277 = _slicedToArray2(_React$useState276, 2),
    r = _React$useState277[0],
    a = _React$useState277[1];
  return /* @__PURE__ */F("div", {
    className: "calendar-container ",
    children: [/* @__PURE__ */d(Mq, {
      house: t
    }), /* @__PURE__ */F("div", {
      className: "calendar-section",
      children: [/* @__PURE__ */d(Eq, {
        changeMonth: a,
        currentMonth: r,
        numberOfMonths: e
      }), /* @__PURE__ */d(Rq, {
        house: t,
        numberOfMonths: e,
        numberOfMonthsInARow: n,
        currentMonth: r
      }), /* @__PURE__ */d(Tq, {
        house: t
      }), /* @__PURE__ */d(Pq, {
        house: t
      })]
    })]
  });
}
B_.defaultProps = {
  numberOfMonths: 4,
  numberOfMonthsInARow: 2
};
function Fq(_ref96) {
  var e = _ref96.PortalSite;
  var _React$useContext12 = React.useContext(Vt),
    t = _React$useContext12.portalCode,
    n = _React$useContext12.objectCode,
    _ln7 = ln(AS, {
      variables: {
        portalCode: t,
        objectCode: n
      }
    }),
    r = _ln7.loading,
    a = _ln7.error,
    i = _ln7.data;
  if (r) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Dn, {})
  });
  if (a) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Zn, {
      errors: a
    })
  });
  var o = i.PortalSite.houses,
    s = e.options.bookingForm ? e.options.bookingForm.numberOfMonths : 4,
    u = e.options.bookingForm ? e.options.bookingForm.numberOfMonthsInARow : 4;
  return /* @__PURE__ */F("div", {
    id: "calendar-container",
    children: [o.length === 0 && /* @__PURE__ */d("div", {
      children: /* @__PURE__ */d(J, {
        id: "no_house_found"
      })
    }), o.map(function (l) {
      return /* @__PURE__ */F("div", {
        children: [/* @__PURE__ */d("div", {
          className: "house-name",
          children: l.name
        }), /* @__PURE__ */d(B_, {
          numberOfMonths: s,
          numberOfMonthsInARow: u,
          house: l
        })]
      }, l.id);
    })]
  });
}
function V_(_ref97) {
  var e = _ref97.PortalSite;
  var _React$useContext13 = React.useContext(ar),
    t = _React$useContext13.bookingStarted;
  return t ? /* @__PURE__ */d(wq, {}) : /* @__PURE__ */d(Fq, {
    PortalSite: e
  });
}
V_.DefaultProps = {
  PortalSite: {
    options: {
      bookingForm: {
        numberOfMonths: 4,
        numberOfMonthsInARow: 2
      }
    }
  }
};
function Lq(_ref98) {
  var e = _ref98.PortalSite;
  return /* @__PURE__ */d(bq, {
    children: /* @__PURE__ */d(V_, {
      PortalSite: e
    })
  });
}
var jq = wt(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral2(["\n  query ReviewPortalSiteQuery($id: ID!, $house_id: String!) {\n    PortalSite(id: $id) {\n      houses(house_code: $house_id) {\n        id\n        name\n        rating\n        scoreAmount\n        reviews {\n          id\n          name\n          review\n          score\n          createdAt\n          reviewCriteria {\n            id\n            name\n            score\n          }\n        }\n      }\n    }\n  }\n"])));
function Nc(_ref99) {
  var e = _ref99.rating,
    t = _ref99.name;
  var n = "low";
  return e > 7 ? n = "best" : e > 6 ? n = "good" : e > 4 && (n = "medium"), /* @__PURE__ */F("div", {
    className: "bu_score",
    children: [/* @__PURE__ */d("div", {
      className: "bu_score__rating bu_card ".concat(n),
      children: e.toFixed(1)
    }), /* @__PURE__ */d("div", {
      children: t
    })]
  });
}
function Bq(_ref100) {
  var e = _ref100.review;
  return /* @__PURE__ */F("div", {
    className: "bu_single_review bu_card",
    children: [/* @__PURE__ */F("div", {
      className: "bu_review_summary",
      children: [/* @__PURE__ */d(Nc, {
        rating: e.score
      }), /* @__PURE__ */F("div", {
        className: "bu_review_summary__date_name",
        children: [/* @__PURE__ */F("div", {
          children: [e.createdAt, ", "]
        }), /* @__PURE__ */d("div", {
          className: "bu_review_summary__name",
          children: e.name
        })]
      })]
    }), /* @__PURE__ */d("blockquote", {
      className: "bu_review",
      children: e.review
    }), /* @__PURE__ */d("div", {
      className: "bu_criteria",
      children: e.reviewCriteria.map(function (t) {
        return /* @__PURE__ */d(Nc, {
          rating: t.score,
          name: t.name
        }, t.id);
      })
    })]
  });
}
var Vq = React.memo(Bq);
function qq() {
  var _React$useContext14 = React.useContext(Vt),
    e = _React$useContext14.objectCode,
    t = _React$useContext14.portalCode,
    _ln8 = ln(jq, {
      variables: {
        id: t,
        house_id: e
      }
    }),
    n = _ln8.data,
    r = _ln8.error,
    a = _ln8.loading;
  if (a) return /* @__PURE__ */d("div", {
    children: /* @__PURE__ */d(Dn, {})
  });
  if (r) return /* @__PURE__ */d(Zn, {
    errors: r
  });
  var i = n.PortalSite.houses[0],
    o = i.reviews;
  return /* @__PURE__ */F("div", {
    className: "bu_reviews",
    children: [/* @__PURE__ */F("div", {
      className: "bu_reviews__overview bu_card",
      children: [/* @__PURE__ */d(Nc, {
        rating: i.rating
      }), /* @__PURE__ */F("div", {
        className: "bu_reviews__overview__number",
        children: [i.scoreAmount, " ", /* @__PURE__ */d(J, {
          id: "reviews"
        })]
      })]
    }), o.map(function (s) {
      return /* @__PURE__ */d(Vq, {
        review: s
      }, s.id);
    })]
  });
}
var Uq = {
    width: "100%",
    padding: "16px",
    display: "flex",
    justifyContent: "center",
    position: "relative"
  },
  zq = {
    color: "#808080",
    fontSize: 14,
    textDecoration: "none"
  },
  Ov = {
    nl: {
      url: "http://bukazu.com/veiligheid",
      label: "Beveiligd en mogelijk gemaakt door BUKAZU"
    },
    en: {
      url: "http://bukazu.com/en/security",
      label: "Secured and made possible by BUKAZU"
    },
    de: {
      url: "http://bukazu.com/de/sicherheit",
      label: "Gesichert und ermöglicht durch BUKAZU"
    },
    fr: {
      url: "http://bukazu.com/fr/securite",
      label: "Sécurisé et rendu possible par BUKAZU"
    },
    es: {
      url: "http://bukazu.com/es/seguridad",
      label: "Asegurado y hecho posible por BUKAZU"
    },
    it: {
      url: "http://bukazu.com/it/sicurezza",
      label: "Protetto e reso possibile da BUKAZU"
    }
  };
function Hq() {
  var _React$useContext15 = React.useContext(Vt),
    e = _React$useContext15.locale;
  return /* @__PURE__ */d("div", {
    style: Uq,
    children: /* @__PURE__ */F("a", {
      href: Ov[e].url,
      style: zq,
      children: [/* @__PURE__ */d("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 100 100",
        enableBackground: "new 0 0 100 100",
        xmlSpace: "preserve",
        width: "16px",
        height: "16px",
        style: {
          marginRight: "4px",
          fill: "#808080"
        },
        children: /* @__PURE__ */d("path", {
          d: "M75.98,41.62h-2.47L73.5,29.31C73.49,15.9,62.58,4.99,49.17,5C35.76,5.01,24.85,15.92,24.86,29.33l0.02,12.31H24  c-4.61,0.01-8.35,3.75-8.34,8.36v36.65c0,4.61,3.75,8.35,8.36,8.35L76,94.97c4.61,0,8.35-3.74,8.34-8.35V49.96  C84.34,45.35,80.59,41.62,75.98,41.62z M33.84,41.64l-0.02-12.31c0-8.47,6.88-15.36,15.35-15.37c8.47,0,15.36,6.89,15.36,15.35  l0.02,12.31L33.84,41.64z"
        })
      }), Ov[e].label, " ", /* @__PURE__ */d("span", {
        style: {
          opacity: 0.5,
          fontSize: 9,
          position: "absolute",
          right: 10,
          bottom: 0
        }
      })]
    })
  });
}
var Wq = /*#__PURE__*/function (_React__default$defau) {
  _inherits2(Wq, _React__default$defau);
  var _super30 = _createSuper2(Wq);
  function Wq(t) {
    var _this43;
    _classCallCheck2(this, Wq);
    _this43 = _super30.call(this, t), _this43.state = {
      hasError: !1
    };
    return _this43;
  }
  _createClass2(Wq, [{
    key: "componentDidCatch",
    value: function componentDidCatch(t, n) {
      console.log(t, n);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.hasError ? /* @__PURE__ */d("h1", {
        children: "Something went wrong."
      }) : this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: !0
      };
    }
  }]);
  return Wq;
}(React__default["default"].Component);
var Sv = function Sv() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
function q_(_ref101) {
  var e = _ref101.pageType,
    t = _ref101.locale,
    n = _ref101.filters;
  var _React$useContext16 = React.useContext(Vt),
    r = _React$useContext16.portalCode,
    a = _React$useContext16.objectCode;
  var _React$useState278 = React.useState(Sv()),
    _React$useState279 = _slicedToArray2(_React$useState278, 2),
    i = _React$useState279[0],
    o = _React$useState279[1];
  React.useEffect(function () {
    var v = function v() {
      o(Sv());
    };
    return window.addEventListener("resize", v), function () {
      window.removeEventListener("resize", v);
    };
  }, []);
  var _ln9 = ln($S, {
      variables: {
        id: r
      }
    }),
    s = _ln9.loading,
    u = _ln9.error,
    l = _ln9.data;
  if (s) return /* @__PURE__ */d(Dn, {});
  if (u) return /* @__PURE__ */d(Zn, {
    errors: _objectSpread2({}, u)
  });
  var c = l.PortalSite;
  var f = l.PortalSite.options,
    h = document.documentElement;
  h.style.setProperty("--bukazu-discount", "".concat(f.colors ? f.colors.discount : "orange")), h.style.setProperty("--bukazu-cell", "".concat(f.colors ? f.colors.cell : "#fff")), h.style.setProperty("--bukazu-arrival", "".concat(f.colors ? f.colors.arrival : "#6eeb83")), h.style.setProperty("--bukazu-booked", "".concat(f.colors ? f.colors.booked : "#ea2b1f")), h.style.setProperty("--bukazu-departure", "".concat(f.colors ? f.colors.departure : "yellow")), h.style.setProperty("--bukazu-button", "".concat(f.colors ? f.colors.button : "rgba(23, 190, 187, 0.75)")), h.style.setProperty("--bukazu-button_cta", "".concat(f.colors ? f.colors.buttonCta : "#e28413")), h.style.setProperty("--bukazu-background_month", "".concat(f.colors ? f.colors.month_background : "#e28413"));
  var p;
  return a && a !== null && e !== "reviews" ? p = /* @__PURE__ */F(Wq, {
    children: [/* @__PURE__ */d(Lq, {
      PortalSite: c
    }), /* @__PURE__ */d(Hq, {})]
  }) : a && a !== null && e === "reviews" ? p = /* @__PURE__ */d(qq, {}) : p = /* @__PURE__ */d(JM, {
    PortalSite: c,
    locale: t,
    options: f,
    filters: n
  }), /* @__PURE__ */d("div", {
    className: i < 875 ? "bu-smaller" : "",
    children: p
  });
}
q_.defaultProps = {
  filters: {}
};
var Gq = "Next",
  Yq = "Previous",
  Qq = "View details",
  Kq = "Price",
  Jq = "Next",
  Xq = "Book",
  Zq = "Booked",
  eU = "Booking",
  tU = "Last minute discount",
  nU = "Discount",
  rU = "Option",
  aU = "Make a short reservation for this period ",
  iU = "including",
  oU = "Rental price",
  sU = "Extra costs included",
  uU = "Extra options",
  lU = "Rental price incl. discount",
  cU = "Booking dates",
  fU = "Total",
  dU = "Travel group",
  hU = "Babies",
  pU = "(up to the age of {babies})",
  mU = "Adults",
  vU = "(from the age of {age})",
  yU = "Children",
  gU = "(from {from} to {til} years inclusive)",
  bU = "Extra options",
  _U = "Additional costs on the spot:",
  wU = "Insurances",
  OU = "Choose at least 1 adult.",
  SU = "Too many people have been selected.",
  EU = "Your information",
  PU = "This field is required.",
  TU = "All Risk",
  kU = "Standard",
  DU = "None",
  xU = "Cancellation insurance",
  $U = "Insurance Costs",
  CU = "Choose",
  RU = "Yes",
  NU = "Booking details",
  AU = "Based on {persons} persons",
  IU = "Back to calendar",
  MU = "Close",
  FU = "Standard Cancellation Insurance",
  LU = "Our standard cancellation insurance means that you are properly insured if you have to cancel your trip. In addition to the cancellation charges, the costs of any unused travel days are also covered. If you miss any part of your trip, because you have to go home earlier for example, you will receive an allowance for each day missed.",
  jU = "All Risk Cancellation Insurance",
  BU = "Unfortunately, circumstances may arise which can force you to cancel your holiday. It might also be necessary to leave or return earlier. Cancellation insurance means you do not have to bear the costs involved. Only residents from the Netherlands, Belgium and Germany can take out the insurance. We offer a choice of two types of cancellation insurance:",
  VU = "With All-Risk Cancellation, you will be reimbursed 100% of the cancellation costs if you cancel for a standard reason, such as an illness that prevents you from traveling. Or the death of a grandparent. Do you want to cancel for another reason that is important to you personally? Then you will be reimbursed 75% of the cancellation costs. But beware: this insurance does set a few conditions for canceling. For example, the reason for cancellation must be 'unforeseen' and 'through no fault of your own'. The insurance therefore does not provide cover for cancellation reasons of which you were already aware before taking out the insurance (not unforeseen) or which you could have done yourself (not through your own fault). Consult the conditions for the exceptions.",
  qU = "Premiums and Conditions",
  UU = "Standard Cancellation Insurance Premium:",
  zU = "All Risk Cancellation Insurance Premium:",
  HU = "More information:",
  WU = "Show conditions",
  GU = "Terms",
  YU = "Remark",
  QU = "or",
  KU = "Policy fee",
  JU = "The cost for an insurance policy is a one-time charge of € 6,95. No matter if you have one or two insuran",
  XU = "You will receive the insurance terms separate from you booking confirmation per email. The insurance starts as soon as the (first) payment has been made.",
  ZU = "Thank you very much for your request.",
  ez = "A copy of your request has been sent to your e-mail address. If you have not received any mail from us, it may be that it is in your spam box.",
  tz = "Oops, something went wrong, please try again later.",
  nz = "persons",
  rz = "bedrooms",
  az = "min. weekly price",
  iz = "No results",
  oz = "By clicking on 'Book', you agree to the",
  sz = "Reason discount.",
  uz = "results",
  lz = "bathrooms",
  cz = "You must indicate a valid discount reason",
  fz = "Filters",
  dz = "I agree that the cancellation insurance insurance card will be digitally issued to me. I receive this card with my booking confirmation.",
  hz = "No",
  pz = "No object found for this combination of PortalCode and ObjectCode",
  mz = "A date of birth is required for taking out insurance",
  vz = "No discount found with entered code",
  yz = "Discount code",
  gz = "At least {minimum} nights",
  bz = "You can only take out insurance if you live in the Netherlands, Germany or Belgium.",
  _z = "Price from",
  wz = "Reviews",
  Oz = {
    next: Gq,
    previous: Yq,
    view_details: Qq,
    price: Kq,
    calculate: Jq,
    book: Xq,
    booked: Zq,
    booking: eU,
    last_minute_discount: tU,
    discount: nU,
    option: rU,
    choose_for_option: aU,
    included_in_price: iU,
    rent_price: oU,
    extra_costs_included: sU,
    optional_costs: uU,
    price_after_discount: lU,
    booking_from_til: cU,
    total: fU,
    stay_details: dU,
    babies: hU,
    babies_from: pU,
    adults: mU,
    adults_from: vU,
    children: yU,
    children_from: gU,
    "house.arrival_date": "Arrival date",
    "house.departure_date": "Departure date",
    "house.arrival": "Arrival",
    "house.departure": "Departure",
    "tent.arrival_date": "Arrival date",
    "tent.departure_date": "Departure date",
    "tent.arrival": "Arrival",
    "tent.departure": "Departure",
    extra_costs_bookable: bU,
    costs_on_site: _U,
    insurances: wU,
    at_least_1_adult: OU,
    max_persons_reached: SU,
    personal_details: EU,
    required: PU,
    cancel_insurance_all_risk: TU,
    cancel_insurance_normal: kU,
    none: DU,
    cancel_insurance: xU,
    insurance_costs: $U,
    choose: CU,
    yes: RU,
    booking_details: NU,
    based_on_one_person: AU,
    return_to_calendar: IU,
    close: MU,
    cancel_insurance_normal_long: FU,
    cancel_insurance_normal_desc: LU,
    cancel_insurance_all_risk_long: jU,
    cancel_insurance_desc: BU,
    cancel_insurance_all_risk_desc: VU,
    terms_and_costs: qU,
    costs_normal_cancel_insurance: UU,
    costs_allrisk_cancel_insurance: zU,
    "666_costs": "6.66% of the travel costs",
    "847_costs": "8.47% of the travel costs",
    more_information: HU,
    show_terms: WU,
    terms: GU,
    remark: YU,
    "9persons_9addresses": "The Insurance will pay for up to 9 persons, who live at 9 different addresses,",
    or: QU,
    "9persons_4addresses": "The insurance pays out for an unlimited number of people who live at a maximum of 4 different addresses.",
    poliscosts: KU,
    poliscosts_are: JU,
    youwillrecieve: XU,
    thank_you_for_your_request: ZU,
    we_sent_confirmation_check_email: ez,
    something_went_wrong_please_try_again: tz,
    persons: nz,
    bedrooms: rz,
    minimum_week_price: az,
    no_results: iz,
    agree_with: oz,
    discount_reason: sz,
    results: uz,
    bathrooms: lz,
    you_need_to_give_reason: cz,
    "camper.arrival_date": "Start date",
    "camper.departure_date": "End date",
    "camper.arrival": "Start date",
    "camper.departure": "End date",
    "boat.arrival_date": "Start date",
    "boat.departure_date": "End date",
    "boat.arrival": "Start date",
    "boat.departure": "End date",
    "caravan.arrival_date": "Arrival date",
    "caravan.departure_date": "Departure date",
    "caravan.arrival": "Arrival",
    "caravan.departure": "Departure",
    filters: fz,
    comply_insurance_card: dz,
    "house.you_picked_arrival_date": "Your arrival date is",
    "house.pick_your_departure_in_the_calendar": "Select a departure date",
    "house.you_picked_departure_date": "Your departure date is",
    "house.pick_your_arrivaldate_in_the_calendar": "Choose an arrival date",
    "tent.you_picked_arrival_date": "Your arrival date is",
    "tent.pick_your_departure_in_the_calendar": "Select a departure date",
    "tent.you_picked_departure_date": "Your departure date is",
    "tent.pick_your_arrivaldate_in_the_calendar": "Choose an arrival date",
    "camper.you_picked_arrival_date": "Your pickup date is",
    "camper.pick_your_departure_in_the_calendar": "Select a return date",
    "camper.you_picked_departure_date": "Your return date is",
    "camper.pick_your_arrivaldate_in_the_calendar": "Choose a pickup date",
    "boat.you_picked_arrival_date": "Your pickup date is",
    "boat.pick_your_departure_in_the_calendar": "Select a return date",
    "boat.you_picked_departure_date": "Your return date is",
    "boat.pick_your_arrivaldate_in_the_calendar": "Choose a pickup date",
    no: hz,
    no_house_found: pz,
    insurance_company_needs_date_of_birth: mz,
    "extra_fields.date_of_birth": "Date of birth",
    no_discount_code_found: vz,
    discount_code: yz,
    minimum_nights: gz,
    can_only_take_insurance_in_de_be_nl: bz,
    price_from: _z,
    reviews: wz
  },
  Sz = "Volgende",
  Ez = "Vorige",
  Pz = "Bekijk details",
  Tz = "Prijs",
  kz = "Volgende",
  Dz = "Boeken",
  xz = "Geboekt",
  $z = "Boeking",
  Cz = "Last minute korting",
  Rz = "Korting",
  Nz = "Optie",
  Az = "Neem een optie op deze periode",
  Iz = "inclusief",
  Mz = "Huurprijs",
  Fz = "Extra kosten inbegrepen",
  Lz = "Extra opties",
  jz = "Huurprijs incl. korting",
  Bz = "Boekingsdata:",
  Vz = "Totaal",
  qz = "Reisgezelschap",
  Uz = "Baby's",
  zz = "(t/m {babies} jaar)",
  Hz = "Volwassenen",
  Wz = "(vanaf {age} jaar)",
  Gz = "Kinderen",
  Yz = "({from} t/m {til} jaar)",
  Qz = "Extra opties",
  Kz = "Bijkomende kosten ter plaatse:",
  Jz = "Verzekeringen",
  Xz = "Kies minstens 1 volwassene.",
  Zz = "Er zijn te veel personen geselecteerd.",
  eH = "Uw gegevens",
  tH = "Dit veld is verplicht.",
  nH = "All Risk",
  rH = "Normaal",
  aH = "Geen",
  iH = "Annuleringsverzekering",
  oH = "Poliskosten",
  sH = "Kies",
  uH = "Ja",
  lH = "Boekingsgegevens",
  cH = "Gebaseerd op {persons} personen",
  fH = "Terug naar de kalender",
  dH = "Sluiten",
  hH = "Standaard Annuleringsverzekering",
  pH = "Met de Standaard Annuleringsverzekering bent u goed verzekerd, als u uw reis moet annuleren. Naast de kosten van de annulering zijn ook de kosten van de ongebruikte reisdagen verzekerd. Dus mist u een deel van uw reis, bijvoorbeeld omdat u eerder naar huis moet? Dan ontvangt u een vergoeding voor iedere dag dat u niet van uw reis heeft kunnen genieten.",
  mH = "Allrisk Annuleringsverzekering",
  vH = "Er kunnen zich helaas altijd situaties voordoen, waardoor u uw vakantie moet afzeggen. Of het kan noodzakelijk zijn dat u later vertrekt of eerder terugkeert. Met een annuleringsverzekering hoeft u zelf niet voor deze kosten op te draaien. Alleen inwoners uit Nederland, België en Duitsland kunnen de verzekeringen afsluiten. U heeft de keuze uit twee annuleringsverzekeringen:",
  yH = "Met Allrisk Annulering krijg je 100% van de annuleringskosten vergoed als je om een standaard reden annuleert, zoals een ziekte waardoor je niet meer op reis kunt. Of het overlijden van een grootouder. Wil je annuleren om een andere reden die voor jou persoonlijk belangrijk is? Dan krijg je 75% van de annuleringskosten vergoed.\n Maar let op: deze verzekering stelt wel een paar voorwaarden aan het annuleren. Zo moet de reden van annulering \u2018onvoorzien\u2019 zijn en \u2018buiten je schuld\u2019. De verzekering biedt dus geen dekking voor annuleringsredenen waarvan je v\xF3\xF3r het afsluiten van de verzekering al op de hoogte was (niet onvoorzien) of waaraan je zelf iets had kunnen doen (niet buiten eigen schuld). Raadpleeg de voorwaarden voor de uitzonderingen.",
  gH = "Premie en voorwaarden",
  bH = "Premie Standaard annuleringsverzekering:",
  _H = "Premie Allrisk annuleringsverzekering:",
  wH = "Meer informatie",
  OH = "Bekijk de voorwaarden",
  SH = "Voorwaarden",
  EH = "Opmerking",
  PH = "of",
  TH = "Poliskosten",
  kH = "De kosten voor het opmaken van een verzekeringspolis zijn eenmalig € 6,95. Ongeacht of u 1 of meerdere verzekeringen heeft afgesloten.",
  DH = "U ontvangt aansluitend op uw boekingsbevestiging de verzekeringspapieren per email toegestuurd. De verzekering treedt in werking zodra u de (aan)betaling gedaan heeft.",
  xH = "Hartelijk dank voor uw boekings/optie-aanvraag.",
  $H = "Een kopie van uw aanvraag is naar uw e-mailadres verstuurd. Als u geen mail van ons ontvangen hebt, kan het zijn dat deze in uw spambox zit. ",
  CH = "Oeps, er is iets mis gegaan, probeert u het later nogmaals.",
  RH = "personen",
  NH = "slaapkamers",
  AH = "min. weekprijs",
  IH = "Geen resultaten",
  MH = "Door op 'Boeken' te klikken gaat u akkoord met de",
  FH = "Reden korting.",
  LH = "resultaten",
  jH = "badkamers",
  BH = "U dient een geldige kortingsreden aan te geven",
  VH = "Filters",
  qH = "Ik ga ermee akkoord dat de verzekeringskaart van de annuleringsverzekering digitaal aan mij verstrekt wordt. Ik ontvang deze bij mijn boekingsbevestiging.",
  UH = "Nee",
  zH = "Geen object gevonden voor deze combinatie van Portal-code en Object-code",
  HH = "Voor het afsluiten van een verzekering is een geboortedatum verplicht",
  WH = "Geen korting gevonden met ingegeven code",
  GH = "Kortingscode",
  YH = "Minstens {minimum} nachten",
  QH = "U kunt alleen een verzekering afsluiten, wanneer u woont in Nederland, Duitsland of België.",
  KH = "Prijs vanaf",
  JH = "Reviews",
  XH = {
    next: Sz,
    previous: Ez,
    view_details: Pz,
    price: Tz,
    calculate: kz,
    book: Dz,
    booked: xz,
    booking: $z,
    last_minute_discount: Cz,
    discount: Rz,
    option: Nz,
    choose_for_option: Az,
    included_in_price: Iz,
    rent_price: Mz,
    extra_costs_included: Fz,
    optional_costs: Lz,
    price_after_discount: jz,
    booking_from_til: Bz,
    total: Vz,
    stay_details: qz,
    babies: Uz,
    babies_from: zz,
    adults: Hz,
    adults_from: Wz,
    children: Gz,
    children_from: Yz,
    "house.arrival_date": "Aankomstdatum",
    "house.departure_date": "Vertrekdatum",
    "house.arrival": "Aankomst",
    "house.departure": "Vertrek ",
    extra_costs_bookable: Qz,
    costs_on_site: Kz,
    insurances: Jz,
    at_least_1_adult: Xz,
    max_persons_reached: Zz,
    personal_details: eH,
    required: tH,
    cancel_insurance_all_risk: nH,
    cancel_insurance_normal: rH,
    none: aH,
    cancel_insurance: iH,
    insurance_costs: oH,
    choose: sH,
    yes: uH,
    booking_details: lH,
    based_on_one_person: cH,
    return_to_calendar: fH,
    close: dH,
    cancel_insurance_normal_long: hH,
    cancel_insurance_normal_desc: pH,
    cancel_insurance_all_risk_long: mH,
    cancel_insurance_desc: vH,
    cancel_insurance_all_risk_desc: yH,
    terms_and_costs: gH,
    costs_normal_cancel_insurance: bH,
    costs_allrisk_cancel_insurance: _H,
    "666_costs": "6.66% van de reissom",
    "847_costs": "8.47% van de reissom",
    more_information: wH,
    show_terms: OH,
    terms: SH,
    remark: EH,
    "9persons_9addresses": "De verzekering keert uit voor maximaal 9 personen die op 9 verschillende adressen wonen,",
    or: PH,
    "9persons_4addresses": "De verzekering keert uit voor een onbeperkt aantal personen die op maximaal 4 verschillende adressen wonen.",
    poliscosts: TH,
    poliscosts_are: kH,
    youwillrecieve: DH,
    thank_you_for_your_request: xH,
    we_sent_confirmation_check_email: $H,
    something_went_wrong_please_try_again: CH,
    persons: RH,
    bedrooms: NH,
    minimum_week_price: AH,
    no_results: IH,
    agree_with: MH,
    discount_reason: FH,
    results: LH,
    bathrooms: jH,
    you_need_to_give_reason: BH,
    "camper.arrival_date": "Ophaaldatum",
    "camper.departure_date": "Inleverdatum",
    "camper.arrival": "Ophalen",
    "camper.departure": "Inleveren",
    "boat.arrival_date": "Ophaaldatum",
    "boat.departure_date": "Inleverdatum",
    "boat.arrival": "Ophalen",
    "boat.departure": "Inleveren",
    "caravan.arrival_date": "Aankomstdatum",
    "caravan.departure_date": "Vertrekdatum",
    "caravan.arrival": "Aankomst",
    "caravan.departure": "Vertrek ",
    "tent.arrival_date": "Aankomstdatum",
    "tent.departure_date": "Vertrekdatum",
    "tent.arrival": "Aankomst",
    "tent.departure": "Vertrek ",
    filters: VH,
    comply_insurance_card: qH,
    "house.you_picked_arrival_date": "Uw aankomstdatum is",
    "house.pick_your_departure_in_the_calendar": "Kies een vertrekdatum",
    "house.you_picked_departure_date": "Uw vertrekdatum is",
    "house.pick_your_arrivaldate_in_the_calendar": "Kies een aankomstdatum",
    "tent.you_picked_arrival_date": "Uw aankomstdatum is",
    "tent.pick_your_departure_in_the_calendar": "Kies een vertrekdatum",
    "tent.you_picked_departure_date": "Uw vertrekdatum is",
    "tent.pick_your_arrivaldate_in_the_calendar": "Kies een aankomstdatum",
    "camper.you_picked_arrival_date": "Uw ophaaldatum is",
    "camper.pick_your_departure_in_the_calendar": "Kies een inleverdatum",
    "camper.you_picked_departure_date": "Uw inleverdatum is",
    "camper.pick_your_arrivaldate_in_the_calendar": "Kies een ophaaldatum",
    "boat.you_picked_arrival_date": "Uw ophaaldatum is",
    "boat.pick_your_departure_in_the_calendar": "Kies een inleverdatum",
    "boat.you_picked_departure_date": "Uw inleverdatum is",
    "boat.pick_your_arrivaldate_in_the_calendar": "Kies een ophaaldatum",
    no: UH,
    no_house_found: zH,
    insurance_company_needs_date_of_birth: HH,
    "extra_fields.date_of_birth": "Geboortedatum",
    no_discount_code_found: WH,
    discount_code: GH,
    minimum_nights: YH,
    can_only_take_insurance_in_de_be_nl: QH,
    price_from: KH,
    reviews: JH
  },
  ZH = "Nächste",
  eW = "Vorherige",
  tW = "Details anzeigen",
  nW = "Preis",
  rW = "Nächst",
  aW = "Buchen",
  iW = "Gebucht",
  oW = "Buchung",
  sW = "Last Minute Rabatt",
  uW = "Option",
  lW = "Machen Sie eine kostenlose Option",
  cW = "inklusive",
  fW = "Reisepreis",
  dW = "Rabatt",
  hW = "Nebenkosten enthalten",
  pW = "Zusätzliche Optionen",
  mW = "Mietpreis inkl. Rabatt",
  vW = "Buchungsdaten",
  yW = "Gesamt",
  gW = "Reisegruppe",
  bW = "Babys",
  _W = "(bis einschl. {babies} Jahre)",
  wW = "Erwachsene",
  OW = "(ab {age} Jahre)",
  SW = "Kinder",
  EW = "(von {from} bis einschl. {til} Jahre)",
  PW = "Zusätzliche Optionen",
  TW = "Zusätzliche Kosten vor Ort:",
  kW = "Versicherungen",
  DW = "Wählen Sie mindestens einen Erwachsenen aus.",
  xW = "Es wurden zu viele Personen ausgewählt.",
  $W = "Ihre Daten",
  CW = "Dieses Feld wird benötigt.",
  RW = "Allrisk",
  NW = "Standard",
  AW = "Keine",
  IW = "Reiserücktrittsversicherung",
  MW = "Policekosten",
  FW = "Wählen",
  LW = "Ja",
  jW = "Buchungsdetails",
  BW = "Basierend auf {persons} Personen",
  VW = "Zurück zum Kalender",
  qW = "Schließen",
  UW = "Standard-Reiserücktrittsversicherung",
  zW = "Mit der Standard-Reiserücktrittsversicherung sind Sie gut versichert, wenn Sie Ihre Reise stornieren müssen. Neben den Stornokosten sind auch die Kosten der ungenutzten Reisetage versichert. Sie können einen Teil Ihrer Reise nicht antreten, da Sie früher nach Hause müssen? Dann erhalten Sie eine Erstattung für jeden Urlaubstag, den Sie nicht genießen konnten.",
  HW = "Allrisk-Reiserücktrittsversicherung",
  WW = "Es können sich leider Umstände ergeben, die einen dazu zwingen, den Urlaub abzusagen. Oder Sie müssen später anreisen oder früher wieder abreisen. Mit einer Reiserücktrittsversicherung müssen Sie nicht selbst für diese Kosten aufkommen. Nur Einwohner aus den Niederlanden, Belgien und Deutschland können die Versicherung abschließen. Sie haben die Wahl zwischen zwei Typen von Reiserücktrittsversicherungen:",
  GW = "Bei der All-Risk-Reiser\xFCcktrittsversicherung werden Ihnen 100% der Stornierungskosten erstattet, wenn Sie aus einem normalen Grund stornieren, z. B. wegen einer Krankheit, die Sie am Reisen hindert. Oder der Tod eines Gro\xDFelternteils. M\xF6chten Sie aus einem anderen Grund stornieren, der Ihnen pers\xF6nlich wichtig ist? Dann werden Ihnen 75% der Stornierungskosten erstattet.\n Aber Vorsicht: Diese Versicherung legt einige Bedingungen f\xFCr die Stornierung fest. Zum Beispiel muss der Grund f\xFCr die Stornierung 'unvorhergesehen' und 'unverschuldet' sein. Die Versicherung bietet daher keinen Versicherungsschutz f\xFCr Stornierungsgr\xFCnde, die Sie bereits vor Abschluss der Versicherung kannten (nicht unvorhergesehen) oder die Sie m\xF6glicherweise gegen sich selbst h\xE4tten tun k\xF6nnen (nicht durch Ihr eigenes Verschulden). Konsultieren Sie die Bedingungen f\xFCr die Ausnahmen.",
  YW = "Prämie und Bedingungen",
  QW = "Prämie Standard-Reiserücktrittsversicherung:",
  KW = "Prämie Allrisk-Reiserücktrittsversicherung:",
  JW = "Weitere Informationen:",
  XW = "Siehe Bedingungen",
  ZW = "Terms",
  e3 = "Anmerkung",
  t3 = "oder",
  n3 = "Police Kosten",
  r3 = "Es gibt einmalig € 6,95 Police-Kosten für die Bearbeitung der Versicherungen. Egal ob Sie 1 oder mehrere Versicherungen abschließen.",
  a3 = "Sie erhalten nach der Buchungsbestätigung im Anschluss an Ihre Buchung die Versicherungsbedingungen per E-Mail. Die Versicherung tritt mit der Ihrer Anzahlung in Kraft.",
  i3 = "Vielen Dank für Ihre Buchungs/Options-Anfrage.",
  o3 = "Eine Kopie Ihrer Anfrage wurde an Ihre E-Mail-Adresse gesendet. Wenn Sie keine E-Mail von uns erhalten haben, befindet sich diese möglicherweise in Ihrer Spam-Box.",
  s3 = "Ups, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
  u3 = "Personen",
  l3 = "Schlafzimmer",
  c3 = "min. Wochenpreis",
  f3 = "Keine Ergebnisse",
  d3 = "Indem Sie auf 'Buchen' klicken, akzeptieren Sie die",
  h3 = "Grund für Rabatt",
  p3 = "Ergebnisse",
  m3 = "Badezimmer",
  v3 = "Sie müssen einen gültigen Rabattgrund angeben",
  y3 = "Filter",
  g3 = "Ich bin damit einverstanden, dass die Versicherungskarte der Reiserücktrittsversicherung digital ausgestellt wird. Ich erhalte diese mit meiner Buchungsbestätigung.",
  b3 = "Nein",
  _3 = "Für den Abschluss einer Versicherung wird ein Geburtsdatum benötigt",
  w3 = "Kein Rabatt mit eingegebenem Code gefunden",
  O3 = "Rabatt-Code",
  S3 = "Mindestens {minimum} Nächte",
  E3 = "Sie können sich nur versichern, wenn Sie in den Niederlanden, Deutschland oder Belgien wohnen.",
  P3 = "Preis von",
  T3 = "Bewertungen",
  k3 = {
    next: ZH,
    previous: eW,
    view_details: tW,
    price: nW,
    calculate: rW,
    book: aW,
    booked: iW,
    booking: oW,
    last_minute_discount: sW,
    option: uW,
    choose_for_option: lW,
    included_in_price: cW,
    rent_price: fW,
    discount: dW,
    extra_costs_included: hW,
    optional_costs: pW,
    price_after_discount: mW,
    booking_from_til: vW,
    total: yW,
    stay_details: gW,
    babies: bW,
    babies_from: _W,
    adults: wW,
    adults_from: OW,
    children: SW,
    children_from: EW,
    "house.arrival_date": "Anreisedatum",
    "house.departure_date": "Abreisedatum",
    "house.arrival": "Ankunft",
    "house.departure": "Abreise",
    "tent.arrival_date": "Anreisedatum",
    "tent.departure_date": "Abreisedatum",
    "tent.arrival": "Ankunft",
    "tent.departure": "Abreise",
    extra_costs_bookable: PW,
    costs_on_site: TW,
    insurances: kW,
    at_least_1_adult: DW,
    max_persons_reached: xW,
    personal_details: $W,
    required: CW,
    cancel_insurance_all_risk: RW,
    cancel_insurance_normal: NW,
    none: AW,
    cancel_insurance: IW,
    insurance_costs: MW,
    choose: FW,
    yes: LW,
    booking_details: jW,
    based_on_one_person: BW,
    return_to_calendar: VW,
    close: qW,
    cancel_insurance_normal_long: UW,
    cancel_insurance_normal_desc: zW,
    cancel_insurance_all_risk_long: HW,
    cancel_insurance_desc: WW,
    cancel_insurance_all_risk_desc: GW,
    terms_and_costs: YW,
    costs_normal_cancel_insurance: QW,
    costs_allrisk_cancel_insurance: KW,
    "666_costs": "6.66% der Reisekosten",
    "847_costs": "8.47% der Reisekosten",
    more_information: JW,
    show_terms: XW,
    terms: ZW,
    remark: e3,
    "9persons_9addresses": "Die Versicherung ist gültig für maximal 9 Personen, die am 9 verschiedene Adressen wohnen,",
    or: t3,
    "9persons_4addresses": "Die Versicherung ist gültig für eine unbegrenzte Anzahl von Personen, die an maximal 4 verschiedenen Adressen wohnen.",
    poliscosts: n3,
    poliscosts_are: r3,
    youwillrecieve: a3,
    thank_you_for_your_request: i3,
    we_sent_confirmation_check_email: o3,
    something_went_wrong_please_try_again: s3,
    persons: u3,
    bedrooms: l3,
    minimum_week_price: c3,
    no_results: f3,
    agree_with: d3,
    discount_reason: h3,
    results: p3,
    bathrooms: m3,
    you_need_to_give_reason: v3,
    "camper.arrival_date": "Abholdatum",
    "camper.departure_date": "Rückgabedatum",
    "camper.arrival": "Abholen",
    "camper.departure": "Rückgabe",
    "boat.arrival_date": "Abholdatum",
    "boat.departure_date": "Rückgabedatum",
    "boat.arrival": "Abholen",
    "boat.departure": "Rückgabe",
    "caravan.arrival_date": "Anreisedatum",
    "caravan.departure_date": "Abreisedatum",
    "caravan.arrival": "Ankunft",
    "caravan.departure": "Abreise",
    filters: y3,
    comply_insurance_card: g3,
    "house.you_picked_arrival_date": "Ihre Ankunft ist",
    "house.pick_your_departure_in_the_calendar": "Wählen Sie ein Abreisedatum",
    "house.you_picked_departure_date": "Ihr Abreisedatum ist",
    "house.pick_your_arrivaldate_in_the_calendar": "Wählen Sie das Ankunftsdatum",
    "tent.you_picked_arrival_date": "Ihre Ankunft ist",
    "tent.pick_your_departure_in_the_calendar": "Wählen Sie ein Abreisedatum",
    "tent.you_picked_departure_date": "Ihr Abreisedatum ist",
    "tent.pick_your_arrivaldate_in_the_calendar": "Wählen Sie das Ankunftsdatum",
    "camper.you_picked_arrival_date": "Ihr Abholdatum ist",
    "camper.pick_your_departure_in_the_calendar": "Wählen Sie ein Rückgabedatum",
    "camper.you_picked_departure_date": "Ihr Rückgabedatum ist",
    "camper.pick_your_arrivaldate_in_the_calendar": "Wählen Sie einen Abholtermin",
    "boat.you_picked_arrival_date": "Ihr Abholdatum ist",
    "boat.pick_your_departure_in_the_calendar": "Wählen Sie ein Rückgabedatum",
    "boat.you_picked_departure_date": "Ihr Rückgabedatum ist",
    "boat.pick_your_arrivaldate_in_the_calendar": "Wählen Sie einen Abholtermin",
    no: b3,
    insurance_company_needs_date_of_birth: _3,
    "extra_fields.date_of_birth": "Geburtsdatum",
    no_discount_code_found: w3,
    discount_code: O3,
    minimum_nights: S3,
    can_only_take_insurance_in_de_be_nl: E3,
    price_from: P3,
    reviews: T3
  },
  D3 = "Suivant",
  x3 = "Précédent",
  $3 = "Voir les détails",
  C3 = "Prix",
  R3 = "Suivante",
  N3 = "Réserver",
  A3 = "Réservé",
  I3 = "Réservation",
  M3 = "Réduction de dernière minute",
  F3 = "Option",
  L3 = "Prendre une option pour cette période",
  j3 = "frais",
  B3 = "Prix de location",
  V3 = "Réduction",
  q3 = "Frais supplémentaires inclus",
  U3 = "Options supplémentaires",
  z3 = "Prix de location incl.",
  H3 = "Dates de réservation",
  W3 = "Total",
  G3 = "Composition du groupe",
  Y3 = "Nombre de bébés",
  Q3 = "(jusqu'a {babies} ans)",
  K3 = "Nombre d'adults",
  J3 = "(à partir de {age} ans)",
  X3 = "Nombre d'enfants",
  Z3 = "(de {from} à {til} ans)",
  e4 = "Options supplémentaires",
  t4 = "Frais supplémentaires sur place:",
  n4 = "Insurances",
  r4 = "Choisissez au moins 1 adulte.",
  a4 = "Trop de personnes ont été sélectionnées.",
  i4 = "Vos données",
  o4 = "Ce champ est requis.",
  s4 = "All Risk",
  u4 = "Standard",
  l4 = "None",
  c4 = "Cancellation insurance",
  f4 = "Insurance Costs",
  d4 = "Choose",
  h4 = "Yes",
  p4 = "Détails de la réservation",
  m4 = "Base {persons} personnes",
  v4 = "Retour au calendrier",
  y4 = "Fermer",
  g4 = "Standard Cancellation Insurance",
  b4 = "Our standard cancellation insurance means that you are properly insured if you have to cancel your trip. In addition to the cancellation charges, the costs of any unused travel days are also covered. If you miss any part of your trip, because you have to go home earlier for example, you will receive an allowance for each day missed.",
  _4 = "All Risk Cancellation Insurance",
  w4 = "Unfortunately, circumstances may arise which can force you to cancel your holiday. It might also be necessary to leave or return earlier. Cancellation insurance means you do not have to bear the costs involved. Only residents from the Netherlands, Belgium and Germany can take out the insurance. We offer a choice of two types of cancellation insurance:",
  O4 = "With All-Risk Cancellation, you will be reimbursed 100% of the cancellation costs if you cancel for a standard reason, such as an illness that prevents you from traveling. Or the death of a grandparent. Do you want to cancel for another reason that is important to you personally? Then you will be reimbursed 75% of the cancellation costs. But beware: this insurance does set a few conditions for canceling. For example, the reason for cancellation must be 'unforeseen' and 'through no fault of your own'. The insurance therefore does not provide cover for cancellation reasons of which you were already aware before taking out the insurance (not unforeseen) or which you could have done yourself (not through your own fault). Consult the conditions for the exceptions.",
  S4 = "Premiums and Conditions",
  E4 = "Standard Cancellation Insurance Premium:",
  P4 = "All Risk Cancellation Insurance Premium:",
  T4 = "More information:",
  k4 = "Show conditions",
  D4 = "Terms",
  x4 = "Remarque",
  $4 = "or",
  C4 = "Policy fee",
  R4 = "The cost for an insurance policy is a one-time charge of € 6,95. No matter if you have one or two insuran",
  N4 = "You will receive the insurance terms separate from you booking confirmation per email. The insurance starts as soon as the (first) payment has been made.",
  A4 = "Merci beaucoup pour votre demande.",
  I4 = "Une copie de votre demande a été envoyée à votre adresse e-mail. Si vous n'avez pas reçu de courrier de notre part, il se peut qu'il soit dans votre boîte de courrier indésirable.",
  M4 = "Oups, quelque chose s'est mal passé, veuillez réessayer plus tard.",
  F4 = "les gens",
  L4 = "chambres a coucher",
  j4 = "min. prix hebdomadaire",
  B4 = "Aucun résultat",
  V4 = "En cliquant maintenant sur 'Réserver', vous adhérez aux",
  q4 = "Raison réduction.",
  U4 = "résultats",
  z4 = "salle de bain",
  H4 = "Debe indicar un motivo de descuento válido.",
  W4 = "Les filtres",
  G4 = "Je conviens que la carte d’assurance annulation me sera délivrée numériquement. Je reçois ceci avec ma confirmation de réservation.",
  Y4 = "Non",
  Q4 = "Au moins {minimum} nuits",
  K4 = "Vous ne pouvez souscrire une assurance que si vous résidez aux Pays-Bas, en Allemagne ou en Belgique.",
  J4 = "Le prix de",
  X4 = "Critiques",
  Z4 = {
    next: D3,
    previous: x3,
    view_details: $3,
    price: C3,
    calculate: R3,
    book: N3,
    booked: A3,
    booking: I3,
    last_minute_discount: M3,
    option: F3,
    choose_for_option: L3,
    included_in_price: j3,
    rent_price: B3,
    discount: V3,
    extra_costs_included: q3,
    optional_costs: U3,
    price_after_discount: z3,
    booking_from_til: H3,
    total: W3,
    stay_details: G3,
    babies: Y3,
    babies_from: Q3,
    adults: K3,
    adults_from: J3,
    children: X3,
    children_from: Z3,
    "house.arrival_date": "Date d'arrivée",
    "house.departure_date": "Date de départ",
    "house.arrival": "Arrivée",
    "house.departure": "Départ",
    "tent.arrival_date": "Date d'arrivée",
    "tent.departure_date": "Date de départ",
    "tent.arrival": "Arrivée",
    "tent.departure": "Départ",
    extra_costs_bookable: e4,
    costs_on_site: t4,
    insurances: n4,
    at_least_1_adult: r4,
    max_persons_reached: a4,
    personal_details: i4,
    required: o4,
    cancel_insurance_all_risk: s4,
    cancel_insurance_normal: u4,
    none: l4,
    cancel_insurance: c4,
    insurance_costs: f4,
    choose: d4,
    yes: h4,
    booking_details: p4,
    based_on_one_person: m4,
    return_to_calendar: v4,
    close: y4,
    cancel_insurance_normal_long: g4,
    cancel_insurance_normal_desc: b4,
    cancel_insurance_all_risk_long: _4,
    cancel_insurance_desc: w4,
    cancel_insurance_all_risk_desc: O4,
    terms_and_costs: S4,
    costs_normal_cancel_insurance: E4,
    costs_allrisk_cancel_insurance: P4,
    "666_costs": "6.66% of the travel costs",
    "847_costs": "8.47% of the travel costs",
    more_information: T4,
    show_terms: k4,
    terms: D4,
    remark: x4,
    "9persons_9addresses": "The Insurance will pay for up to 9 persons, who live at 9 different addresses,",
    or: $4,
    "9persons_4addresses": "The insurance pays out for an unlimited number of people who live at a maximum of 4 different addresses.",
    poliscosts: C4,
    poliscosts_are: R4,
    youwillrecieve: N4,
    thank_you_for_your_request: A4,
    we_sent_confirmation_check_email: I4,
    something_went_wrong_please_try_again: M4,
    persons: F4,
    bedrooms: L4,
    minimum_week_price: j4,
    no_results: B4,
    agree_with: V4,
    discount_reason: q4,
    results: U4,
    bathrooms: z4,
    you_need_to_give_reason: H4,
    "camper.arrival_date": "Date de collecte",
    "camper.departure_date": "Date de retour",
    "camper.arrival": "Ramasser",
    "camper.departure": "Remettre",
    "boat.arrival_date": "Date de collecte",
    "boat.departure_date": "Date de retour",
    "boat.arrival": "Ramasser",
    "boat.departure": "Remettre",
    "caravan.arrival_date": "Date d'arrivée",
    "caravan.departure_date": "Date de départ",
    "caravan.arrival": "Arrivée",
    "caravan.departure": "Départ",
    filters: W4,
    comply_insurance_card: G4,
    "house.you_picked_arrival_date": "Votre date d'arrivée est",
    "house.pick_your_departure_in_the_calendar": "Sélectionnez une date de départ",
    "house.you_picked_departure_date": "Votre date de départ est",
    "house.pick_your_arrivaldate_in_the_calendar": "Choisissez une date d'arrivée",
    "tent.you_picked_arrival_date": "Votre date d'arrivée est",
    "tent.pick_your_departure_in_the_calendar": "Sélectionnez une date de départ",
    "tent.you_picked_departure_date": "Votre date de départ est",
    "tent.pick_your_arrivaldate_in_the_calendar": "Choisissez une date d'arrivée",
    "camper.you_picked_arrival_date": "Votre date pick-up est",
    "camper.pick_your_departure_in_the_calendar": "Sélectionnez une date de retour",
    "camper.you_picked_departure_date": "Votre date de retour est",
    "camper.pick_your_arrivaldate_in_the_calendar": "Choisissez une date de pick-up",
    "boat.you_picked_arrival_date": "Your pickup date is",
    "boat.pick_your_departure_in_the_calendar": "Select a return date",
    "boat.you_picked_departure_date": "Your return date is",
    "boat.pick_your_arrivaldate_in_the_calendar": "Choose a pickup date",
    no: Y4,
    minimum_nights: Q4,
    can_only_take_insurance_in_de_be_nl: K4,
    price_from: J4,
    reviews: X4
  },
  eG = "Siguiente",
  tG = "Anterior",
  nG = "Ver detalles",
  rG = "Precio",
  aG = "Próximo",
  iG = "Reservar",
  oG = "Reservado",
  sG = "Reserva",
  uG = "Descuento de ultimo minuto",
  lG = "Opción",
  cG = "Tome una opción para este período",
  fG = "Incluido",
  dG = "Precio de alquiler",
  hG = "Reducción",
  pG = "Costes extras incluidos",
  mG = "Opciones extra",
  vG = "Precio de alquiler con descuento.",
  yG = "Fechas de reserva",
  gG = "Total",
  bG = "Grupo de viaje",
  _G = "Numero de bebes",
  wG = "(hasta {babies} años)",
  OG = "Numero de adultos",
  SG = "(a partir de {age} años)",
  EG = "Numero de niños",
  PG = "(de {from} a {til} años)",
  TG = "Opciones extra",
  kG = "Costos adicionales en el lugar:",
  DG = "Insurances",
  xG = "Elige al menos 1 adulto.",
  $G = "Demasiadas personas han sido seleccionadas.",
  CG = "Tus datos",
  RG = "Este campo es requerido.",
  NG = "All Risk",
  AG = "Standard",
  IG = "None",
  MG = "Cancellation insurance",
  FG = "Insurance Costs",
  LG = "Choose",
  jG = "Yes",
  BG = "Detalles de la reserva",
  VG = "Basado en {persons} personas",
  qG = "Volver al calendario",
  UG = "Cerrar",
  zG = "Standard Cancellation Insurance",
  HG = "Our standard cancellation insurance means that you are properly insured if you have to cancel your trip. In addition to the cancellation charges, the costs of any unused travel days are also covered. If you miss any part of your trip, because you have to go home earlier for example, you will receive an allowance for each day missed.",
  WG = "All Risk Cancellation Insurance",
  GG = "Unfortunately, circumstances may arise which can force you to cancel your holiday. It might also be necessary to leave or return earlier. Cancellation insurance means you do not have to bear the costs involved. Only residents from the Netherlands, Belgium and Germany can take out the insurance. We offer a choice of two types of cancellation insurance:",
  YG = "With All-Risk Cancellation, you will be reimbursed 100% of the cancellation costs if you cancel for a standard reason, such as an illness that prevents you from traveling. Or the death of a grandparent. Do you want to cancel for another reason that is important to you personally? Then you will be reimbursed 75% of the cancellation costs. But beware: this insurance does set a few conditions for canceling. For example, the reason for cancellation must be 'unforeseen' and 'through no fault of your own'. The insurance therefore does not provide cover for cancellation reasons of which you were already aware before taking out the insurance (not unforeseen) or which you could have done yourself (not through your own fault). Consult the conditions for the exceptions.",
  QG = "Premiums and Conditions",
  KG = "Standard Cancellation Insurance Premium:",
  JG = "All Risk Cancellation Insurance Premium:",
  XG = "More information:",
  ZG = "Show conditions",
  e5 = "Terms",
  t5 = "Observación",
  n5 = "or",
  r5 = "Policy fee",
  a5 = "The cost for an insurance policy is a one-time charge of € 6,95. No matter if you have one or two insuran",
  i5 = "You will receive the insurance terms separate from you booking confirmation per email. The insurance starts as soon as the (first) payment has been made.",
  o5 = "Muchas gracias por su solicitud.",
  s5 = "Se ha enviado una copia de su solicitud a su dirección de correo electrónico. Si no ha recibido ningún correo de nuestra parte, es posible que esté en su buzón de correo no deseado.",
  u5 = "Vaya, algo salió mal, inténtalo de nuevo más tarde.",
  l5 = "personas",
  c5 = "dormitorios",
  f5 = "min. precio semanal",
  d5 = "Sin resultados",
  h5 = "Al hacer clic en ‘Reservar’, acepta los Términos y condiciones",
  p5 = "Razón de descuento.",
  m5 = "resultados",
  v5 = "baños",
  y5 = "Vous devez indiquer un motif de réduction valide",
  g5 = "Filtros",
  b5 = "Estoy de acuerdo en que la tarjeta de seguro de cancelación será emitida digitalmente para mí. Recibo esto con mi confirmación de reserva.",
  _5 = "No",
  w5 = "Al menos {minimum} noches",
  O5 = "Solo puede contratar un seguro si vive en los Países Bajos, Alemania o Bélgica.",
  S5 = "Precio de",
  E5 = "Comentarios",
  P5 = {
    next: eG,
    previous: tG,
    view_details: nG,
    price: rG,
    calculate: aG,
    book: iG,
    booked: oG,
    booking: sG,
    last_minute_discount: uG,
    option: lG,
    choose_for_option: cG,
    included_in_price: fG,
    rent_price: dG,
    discount: hG,
    extra_costs_included: pG,
    optional_costs: mG,
    price_after_discount: vG,
    booking_from_til: yG,
    total: gG,
    stay_details: bG,
    babies: _G,
    babies_from: wG,
    adults: OG,
    adults_from: SG,
    children: EG,
    children_from: PG,
    "house.arrival_date": "Fecha de llegada",
    "house.departure_date": "Fecha de salida",
    "house.arrival": "llegada",
    "house.departure": "Salida",
    "tent.arrival_date": "Fecha de llegada",
    "tent.departure_date": "Fecha de salida",
    "tent.arrival": "llegada",
    "tent.departure": "Salida",
    extra_costs_bookable: TG,
    costs_on_site: kG,
    insurances: DG,
    at_least_1_adult: xG,
    max_persons_reached: $G,
    personal_details: CG,
    required: RG,
    cancel_insurance_all_risk: NG,
    cancel_insurance_normal: AG,
    none: IG,
    cancel_insurance: MG,
    insurance_costs: FG,
    choose: LG,
    yes: jG,
    booking_details: BG,
    based_on_one_person: VG,
    return_to_calendar: qG,
    close: UG,
    cancel_insurance_normal_long: zG,
    cancel_insurance_normal_desc: HG,
    cancel_insurance_all_risk_long: WG,
    cancel_insurance_desc: GG,
    cancel_insurance_all_risk_desc: YG,
    terms_and_costs: QG,
    costs_normal_cancel_insurance: KG,
    costs_allrisk_cancel_insurance: JG,
    "666_costs": "6.66% of the travel costs",
    "847_costs": "8.47% of the travel costs",
    more_information: XG,
    show_terms: ZG,
    terms: e5,
    remark: t5,
    "9persons_9addresses": "The Insurance will pay for up to 9 persons, who live at 9 different addresses,",
    or: n5,
    "9persons_4addresses": "The insurance pays out for an unlimited number of people who live at a maximum of 4 different addresses.",
    poliscosts: r5,
    poliscosts_are: a5,
    youwillrecieve: i5,
    thank_you_for_your_request: o5,
    we_sent_confirmation_check_email: s5,
    something_went_wrong_please_try_again: u5,
    persons: l5,
    bedrooms: c5,
    minimum_week_price: f5,
    no_results: d5,
    agree_with: h5,
    discount_reason: p5,
    results: m5,
    bathrooms: v5,
    you_need_to_give_reason: y5,
    "camper.arrival_date": "Fecha de recogida",
    "camper.departure_date": "Fecha de regreso",
    "camper.arrival": "Recoger",
    "camper.departure": "Entregar",
    "boat.arrival_date": "Fecha de recogida",
    "boat.departure_date": "Fecha de regreso",
    "boat.arrival": "Recoger",
    "boat.departure": "Entregar",
    "caravan.arrival_date": "Fecha de llegada",
    "caravan.departure_date": "Fecha de salida",
    "caravan.arrival": "llegada",
    "caravan.departure": "Salida",
    filters: g5,
    comply_insurance_card: b5,
    "house.you_picked_arrival_date": "Su fecha de llegada es",
    "house.pick_your_departure_in_the_calendar": "Seleccione una fecha de salida",
    "house.you_picked_departure_date": "Su fecha de salida es",
    "house.pick_your_arrivaldate_in_the_calendar": "Elija una fecha de llegada",
    "tent.you_picked_arrival_date": "Su fecha de llegada es",
    "tent.pick_your_departure_in_the_calendar": "Seleccione una fecha de salida",
    "tent.you_picked_departure_date": "Su fecha de salida es",
    "tent.pick_your_arrivaldate_in_the_calendar": "Elija una fecha de llegada",
    "camper.you_picked_arrival_date": "Su fecha de recogida es",
    "camper.pick_your_departure_in_the_calendar": "Seleccione una fecha de regreso",
    "camper.you_picked_departure_date": "Su fecha de retorno es",
    "camper.pick_your_arrivaldate_in_the_calendar": "Elija una fecha de recogida",
    "boat.you_picked_arrival_date": "Your pickup date is",
    "boat.pick_your_departure_in_the_calendar": "Select a return date",
    "boat.you_picked_departure_date": "Your return date is",
    "boat.pick_your_arrivaldate_in_the_calendar": "Choose a pickup date",
    no: _5,
    minimum_nights: w5,
    can_only_take_insurance_in_de_be_nl: O5,
    price_from: S5,
    reviews: E5
  },
  T5 = "Prossimo",
  k5 = "Precedente",
  D5 = "Visualizza dettagli",
  x5 = "Prezzo",
  $5 = "Prossimo",
  C5 = "Prenotare",
  R5 = "Prenotato",
  N5 = "Prenotazione",
  A5 = "Sconto last minute",
  I5 = "Opzione",
  M5 = "Prendi un'opzione per questo periodo",
  F5 = "compreso",
  L5 = "Prezzo di affitto",
  j5 = "Riduzione",
  B5 = "Costi aggiuntivi inclusi",
  V5 = "Opzioni extra",
  q5 = "Prezzo di affitto incluso sconto",
  U5 = "Date di prenotazione",
  z5 = "Total",
  H5 = "Gruppo di viaggio",
  W5 = "Numero di bambini",
  G5 = "(fino a {babies} anni)",
  Y5 = "Numero di adulti",
  Q5 = "(dai {age} anni)",
  K5 = "Numero di bambini",
  J5 = "(da {from} a {til} anni)",
  X5 = "Opzioni extra",
  Z5 = "Possibili costi aggiuntivi sul posto:",
  eY = "Insurances",
  tY = "Scegli almeno 1 adulto.",
  nY = "Sono state selezionate troppe persone.",
  rY = "I tuoi dati",
  aY = "Questo campo è obbligatorio.",
  iY = "All Risk",
  oY = "Standard",
  sY = "None",
  uY = "Cancellation insurance",
  lY = "Insurance Costs",
  cY = "Choose",
  fY = "Yes",
  dY = "Dettagli della prenotazione",
  hY = "Basato su {persons} persone",
  pY = "Ritorna al calendario",
  mY = "Vicino",
  vY = "Standard Cancellation Insurance",
  yY = "Our standard cancellation insurance means that you are properly insured if you have to cancel your trip. In addition to the cancellation charges, the costs of any unused travel days are also covered. If you miss any part of your trip, because you have to go home earlier for example, you will receive an allowance for each day missed.",
  gY = "All Risk Cancellation Insurance",
  bY = "Unfortunately, circumstances may arise which can force you to cancel your holiday. It might also be necessary to leave or return earlier. Cancellation insurance means you do not have to bear the costs involved. Only residents from the Netherlands, Belgium and Germany can take out the insurance. We offer a choice of two types of cancellation insurance:",
  _Y = "With All-Risk Cancellation, you will be reimbursed 100% of the cancellation costs if you cancel for a standard reason, such as an illness that prevents you from traveling. Or the death of a grandparent. Do you want to cancel for another reason that is important to you personally? Then you will be reimbursed 75% of the cancellation costs.\n But beware: this insurance does set a few conditions for canceling. For example, the reason for cancellation must be 'unforeseen' and 'through no fault of your own'. The insurance therefore does not provide cover for cancellation reasons of which you were already aware before taking out the insurance (not unforeseen) or which you could have done yourself (not through your own fault). Consult the conditions for the exceptions.",
  wY = "Premiums and Conditions",
  OY = "Standard Cancellation Insurance Premium:",
  SY = "All Risk Cancellation Insurance Premium:",
  EY = "More information:",
  PY = "Show conditions",
  TY = "Terms",
  kY = "Osservazione",
  DY = "or",
  xY = "Policy fee",
  $Y = "The cost for an insurance policy is a one-time charge of € 6,95. No matter if you have one or two insuran",
  CY = "You will receive the insurance terms separate from you booking confirmation per email. The insurance starts as soon as the (first) payment has been made.",
  RY = "Grazie mille per la tua richiesta.",
  NY = "Una copia della tua richiesta è stata inviata al tuo indirizzo e-mail. Se non hai ricevuto alcuna posta da noi, potrebbe essere che sia nella tua casella di spam.",
  AY = "Oops, qualcosa è andato storto, ti preghiamo di riprovare più tardi.",
  IY = "persone",
  MY = "camere da letto",
  FY = "prezzo settimanale minimo",
  LY = "Nessun risultato",
  jY = "Cliccando ora su 'prenotazione definitiva', ti iscrivi",
  BY = "Sconto di ragione.",
  VY = "risultati",
  qY = "bagni",
  UY = "Devi indicare un motivo di sconto valido",
  zY = "Filtri",
  HY = "Sono d'accordo che la carta di assicurazione di annullamento verrà emessa in digitale. Lo ricevo con la mia conferma di prenotazione.",
  WY = "No",
  GY = "Almeno {minimum} notti",
  YY = "Puoi stipulare un'assicurazione solo se vivi nei Paesi Bassi, in Germania o in Belgio.",
  QY = "Prezzo da",
  KY = "Recensioni",
  JY = {
    next: T5,
    previous: k5,
    view_details: D5,
    price: x5,
    calculate: $5,
    book: C5,
    booked: R5,
    booking: N5,
    last_minute_discount: A5,
    option: I5,
    choose_for_option: M5,
    included_in_price: F5,
    rent_price: L5,
    discount: j5,
    extra_costs_included: B5,
    optional_costs: V5,
    price_after_discount: q5,
    booking_from_til: U5,
    total: z5,
    stay_details: H5,
    babies: W5,
    babies_from: G5,
    adults: Y5,
    adults_from: Q5,
    children: K5,
    children_from: J5,
    "house.arrival_date": "Data di arrivo",
    "house.departure_date": "Data di partenza",
    "house.arrival": "Arrivo",
    "house.departure": "Partenza",
    "tent.arrival_date": "Data di arrivo",
    "tent.departure_date": "Data di partenza",
    "tent.arrival": "Arrivo",
    "tent.departure": "Partenza",
    extra_costs_bookable: X5,
    costs_on_site: Z5,
    insurances: eY,
    at_least_1_adult: tY,
    max_persons_reached: nY,
    personal_details: rY,
    required: aY,
    cancel_insurance_all_risk: iY,
    cancel_insurance_normal: oY,
    none: sY,
    cancel_insurance: uY,
    insurance_costs: lY,
    choose: cY,
    yes: fY,
    booking_details: dY,
    based_on_one_person: hY,
    return_to_calendar: pY,
    close: mY,
    cancel_insurance_normal_long: vY,
    cancel_insurance_normal_desc: yY,
    cancel_insurance_all_risk_long: gY,
    cancel_insurance_desc: bY,
    cancel_insurance_all_risk_desc: _Y,
    terms_and_costs: wY,
    costs_normal_cancel_insurance: OY,
    costs_allrisk_cancel_insurance: SY,
    "666_costs": "6.66% of the travel costs",
    "847_costs": "8.47% of the travel costs",
    more_information: EY,
    show_terms: PY,
    terms: TY,
    remark: kY,
    "9persons_9addresses": "The Insurance will pay for up to 9 persons, who live at 9 different addresses,",
    or: DY,
    "9persons_4addresses": "The insurance pays out for an unlimited number of people who live at a maximum of 4 different addresses.",
    poliscosts: xY,
    poliscosts_are: $Y,
    youwillrecieve: CY,
    thank_you_for_your_request: RY,
    we_sent_confirmation_check_email: NY,
    something_went_wrong_please_try_again: AY,
    persons: IY,
    bedrooms: MY,
    minimum_week_price: FY,
    no_results: LY,
    agree_with: jY,
    discount_reason: BY,
    results: VY,
    bathrooms: qY,
    you_need_to_give_reason: UY,
    "camper.arrival_date": "Data di ritiro",
    "camper.departure_date": "Data di ritorno",
    "camper.arrival": "Pick up",
    "camper.departure": "Mano dentro",
    "boat.arrival_date": "Data di ritiro",
    "boat.departure_date": "Data di ritorno",
    "boat.arrival": "Pick up",
    "boat.departure": "Mano dentro",
    "caravan.arrival_date": "Data di arrivo",
    "caravan.departure_date": "Data di partenza",
    "caravan.arrival": "Arrivo",
    "caravan.departure": "Partenza",
    filters: zY,
    comply_insurance_card: HY,
    "house.you_picked_arrival_date": "La vostra data di arrivo è",
    "house.pick_your_departure_in_the_calendar": "Selezionare una data di partenza",
    "house.you_picked_departure_date": "La data di partenza è",
    "house.pick_your_arrivaldate_in_the_calendar": "Scegliere una data di arrivo",
    "tent.you_picked_arrival_date": "La vostra data di arrivo è",
    "tent.pick_your_departure_in_the_calendar": "Selezionare una data di partenza",
    "tent.you_picked_departure_date": "La data di partenza è",
    "tent.pick_your_arrivaldate_in_the_calendar": "Scegliere una data di arrivo",
    "camper.you_picked_arrival_date": "La vostra data di ritiro è",
    "camper.pick_your_departure_in_the_calendar": "Seleziona una data di ritorno",
    "camper.you_picked_departure_date": "La data di ritorno è",
    "camper.pick_your_arrivaldate_in_the_calendar": "Scegli una data di ritiro",
    "boat.you_picked_arrival_date": "Your pickup date is",
    "boat.pick_your_departure_in_the_calendar": "Select a return date",
    "boat.you_picked_departure_date": "Your return date is",
    "boat.pick_your_arrivaldate_in_the_calendar": "Choose a pickup date",
    no: WY,
    minimum_nights: GY,
    can_only_take_insurance_in_de_be_nl: YY,
    price_from: QY,
    reviews: KY
  };
function XY(_ref102) {
  var e = _ref102.portalCode,
    t = _ref102.objectCode,
    n = _ref102.pageType,
    r = _ref102.locale,
    a = _ref102.filters,
    i = _ref102.api_url;
  var o = wN({
    portalCode: e,
    pageType: n,
    locale: r,
    filters: a
  });
  if (o) return o;
  r || (r = "en");
  var s = new hS({
      uri: i,
      cache: new iS(),
      headers: {
        locale: r
      },
      defaultOptions: {
        watchQuery: {
          fetchPolicy: "cache-and-network"
        }
      }
    }),
    u = {
      en: Oz,
      nl: XH,
      de: k3,
      fr: Z4,
      es: P5,
      it: JY
    };
  return window.__localeId__ = r, /* @__PURE__ */d(OS, {
    client: s,
    children: /* @__PURE__ */d(fN, {
      locale: r,
      messages: u[r],
      children: /* @__PURE__ */d(Vt.Provider, {
        value: {
          portalCode: e,
          objectCode: t,
          locale: r
        },
        children: /* @__PURE__ */d(q_, {
          pageType: n,
          locale: r,
          filters: a
        })
      })
    })
  });
}
XY.defaultProps = {
  pageType: null,
  api_url: "https://api.bukazu.com/graphql"
};

// import 'bukazu-portal-react/build/index.css';

function Portal(_ref) {
  var options = _ref.options;
  if ((typeof window === "undefined" ? "undefined" : _typeof$2(window)) !== "undefined") {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, options.portal_type === 'calendar' && /*#__PURE__*/React__default["default"].createElement("div", {
      id: "bukazu-app"
    }, /*#__PURE__*/React__default["default"].createElement(XY, {
      portalCode: options.portal_code,
      objectCode: options.object_code,
      locale: options.language
    })), options.portal_type === 'search' && /*#__PURE__*/React__default["default"].createElement("div", {
      id: "bukazu-app"
    }, /*#__PURE__*/React__default["default"].createElement(XY, {
      portalCode: options.portal_code,
      locale: options.language
    })));
  } else {
    return /*#__PURE__*/React__default["default"].createElement("div", null);
  }
}
function SearchBar(_ref) {
  _ref.options;
  return /*#__PURE__*/React__default["default"].createElement("div", null, "SearchBar");
}
function Text(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: options.content
    }
  });
}
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var BlockContainer = styled__default["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\ndisplay: flex;\nflex-direction: row;\nflex-wrap: wrap;\n.ql-align-center {\n  text-align: center;\n}\n.justify-evenly {\n  justify-content: space-evenly;\n}\n\n.align-center {\n  align-items: center;\n}\n\nul {\n  list-style: initial;\n  list-style-position: outside;\n  padding: 0 0 0 16px;\n  li {\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    padding: 4px 0;\n  }\n}\nh1 {\n  font-size: 2.8rem;\n  line-height: 3.4rem;\n  padding: 24px 0 16px;\n}\nh2 {\n  font-size: 2.2rem;\n  line-height: 2.8rem;\n  padding: 16px 0 8px;\n}\np {\n  font-size: 1.6rem;\n  line-height: 2.4rem;\n  max-width: 75ch;\n  margin: 0;\n}\ndiv {\n  box-sizing: border-box;\n}\nimg {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  /* position: absolute; */\n}\n.half {\n  width: 50%;\n  ", ";\n}\n.col {\n  &-12 {\n    width: 100%;\n  }\n  &-1 {\n    width: calc(1 / 12 * 100%);\n  }\n  &-2 {\n    width: calc(2 / 12 * 100%);\n  }\n  &-3 {\n    width: calc(3 / 12 * 100%);\n  }\n  &-4 {\n    width: calc(4 / 12 * 100%);\n  }\n  &-5 {\n    width: calc(5 / 12 * 100%);\n  }\n  &-6 {\n    width: calc(50%);\n  }\n  &-7 {\n    width: calc(7 / 12 * 100%);\n  }\n  &-8 {\n    width: calc(8 / 12 * 100%);\n  }\n  &-9 {\n    width: calc(9 / 12 * 100%);\n  }\n  &-10 {\n    width: calc(10 / 12 * 100%);\n  }\n  &-11 {\n    width: calc(11 / 12 * 100%);\n  }\n}\n.center {\n  margin: 0 auto;\n}\n", ";\na {\n  /* padding: 2px 0; */\n  color: ", " !important;\n  text-decoration: none;\n  position: relative;\n  &:before {\n    transition: 0.2s all ease-in;\n    position: absolute;\n    content: '';\n    height: 1px;\n    width: 20px;\n    bottom: 0;\n    left: 0;\n    background: ", ";\n  }\n  &:hover {\n    &:before {\n      width: 100%;\n    }\n  }\n}\n.image-gallery-fullscreen-button.active {\n  top: 0;\n  bottom: auto;\n  background-color: #000;\n  &:before {\n    content: '\\274c';\n  }\n}\n.image-gallery-content {\n  .image-gallery-image {\n    img {\n      max-height: 500px;\n      height: 500px;\n      ", ";\n    }\n  }\n}\n.image-gallery-content.fullscreen {\n  .image-gallery-image {\n    img {\n      /* max-height: 75vh; */\n      width: auto;\n      margin: 0 auto;\n    }\n  }\n}\n\n.image-gallery {\n  max-width: 100%;\n  overflow: hidden;\n}\n.page_row {\n    max-width: 1240px;\n    width: 100%;\n    margin: 0px auto;\n    padding: 16px;\n    width: 100%;\n    flex-direction: column;\n    @media (min-width: 676px) {\n      flex-direction: row;\n    }\n    &.full-width {\n      max-width: 100%;\n      padding: 0;\n    }\n\n    &.container-width {\n      margin: 0 auto;\n      @media (min-width: 676px) {\n        max-width: 640px;\n      }\n\n      @media (min-width: 868px) {\n        max-width: 820px;\n      }\n\n      @media (min-width: 992px) {\n        max-width: 960px;\n      }\n\n      @media (min-width: 1290px) {\n        max-width: 1260px;\n      }\n    }\n  }\n"], ["\ndisplay: flex;\nflex-direction: row;\nflex-wrap: wrap;\n.ql-align-center {\n  text-align: center;\n}\n.justify-evenly {\n  justify-content: space-evenly;\n}\n\n.align-center {\n  align-items: center;\n}\n\nul {\n  list-style: initial;\n  list-style-position: outside;\n  padding: 0 0 0 16px;\n  li {\n    font-size: 1.6rem;\n    line-height: 2.4rem;\n    padding: 4px 0;\n  }\n}\nh1 {\n  font-size: 2.8rem;\n  line-height: 3.4rem;\n  padding: 24px 0 16px;\n}\nh2 {\n  font-size: 2.2rem;\n  line-height: 2.8rem;\n  padding: 16px 0 8px;\n}\np {\n  font-size: 1.6rem;\n  line-height: 2.4rem;\n  max-width: 75ch;\n  margin: 0;\n}\ndiv {\n  box-sizing: border-box;\n}\nimg {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  /* position: absolute; */\n}\n.half {\n  width: 50%;\n  ", ";\n}\n.col {\n  &-12 {\n    width: 100%;\n  }\n  &-1 {\n    width: calc(1 / 12 * 100%);\n  }\n  &-2 {\n    width: calc(2 / 12 * 100%);\n  }\n  &-3 {\n    width: calc(3 / 12 * 100%);\n  }\n  &-4 {\n    width: calc(4 / 12 * 100%);\n  }\n  &-5 {\n    width: calc(5 / 12 * 100%);\n  }\n  &-6 {\n    width: calc(50%);\n  }\n  &-7 {\n    width: calc(7 / 12 * 100%);\n  }\n  &-8 {\n    width: calc(8 / 12 * 100%);\n  }\n  &-9 {\n    width: calc(9 / 12 * 100%);\n  }\n  &-10 {\n    width: calc(10 / 12 * 100%);\n  }\n  &-11 {\n    width: calc(11 / 12 * 100%);\n  }\n}\n.center {\n  margin: 0 auto;\n}\n", ";\na {\n  /* padding: 2px 0; */\n  color: ", " !important;\n  text-decoration: none;\n  position: relative;\n  &:before {\n    transition: 0.2s all ease-in;\n    position: absolute;\n    content: '';\n    height: 1px;\n    width: 20px;\n    bottom: 0;\n    left: 0;\n    background: ", ";\n  }\n  &:hover {\n    &:before {\n      width: 100%;\n    }\n  }\n}\n.image-gallery-fullscreen-button.active {\n  top: 0;\n  bottom: auto;\n  background-color: #000;\n  &:before {\n    content: '\\\\274c';\n  }\n}\n.image-gallery-content {\n  .image-gallery-image {\n    img {\n      max-height: 500px;\n      height: 500px;\n      ", ";\n    }\n  }\n}\n.image-gallery-content.fullscreen {\n  .image-gallery-image {\n    img {\n      /* max-height: 75vh; */\n      width: auto;\n      margin: 0 auto;\n    }\n  }\n}\n\n.image-gallery {\n  max-width: 100%;\n  overflow: hidden;\n}\n.page_row {\n    max-width: 1240px;\n    width: 100%;\n    margin: 0px auto;\n    padding: 16px;\n    width: 100%;\n    flex-direction: column;\n    @media (min-width: 676px) {\n      flex-direction: row;\n    }\n    &.full-width {\n      max-width: 100%;\n      padding: 0;\n    }\n\n    &.container-width {\n      margin: 0 auto;\n      @media (min-width: 676px) {\n        max-width: 640px;\n      }\n\n      @media (min-width: 868px) {\n        max-width: 820px;\n      }\n\n      @media (min-width: 992px) {\n        max-width: 960px;\n      }\n\n      @media (min-width: 1290px) {\n        max-width: 1260px;\n      }\n    }\n  }\n"])), MEDIA.PHONE(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      width: 100%;\n      "]))), MEDIA.TABLET(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12 {\n      width: 100%;\n  }\n      "]))), function (props) {
  return props.theme.linkColor;
}, function (props) {
  return props.theme.primaryColor;
}, MEDIA.TABLET(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: auto;\n      "]))));
var BlockSelf = styled__default["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
function Block(_ref) {
  var pageBlock = _ref.pageBlock,
    houses = _ref.houses,
    locale = _ref.locale;
  var options = pageBlock.options;
  if (!options || options == null) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  }
  switch (options.type) {
    case 'assorted_houses':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(AssortedHouses, {
        options: options,
        houses: houses,
        locale: locale
      }));
    case 'bukazu_portal':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Portal, {
        options: options
      }));
    case 'button':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Button, {
        options: options
      }));
    case 'custom_slider':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(CustomSlider, {
        options: options
      }));
    case 'embed':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Embed, {
        options: options
      }));
    case 'form':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Form, {
        options: options
      }));
    case 'image':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options
      }, /*#__PURE__*/React__default["default"].createElement(Image, {
        options: options
      }));
    case 'image_slider':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(ImageSlider, {
        options: options
      }));
    case 'imageGallery':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(ImageGallery, {
        options: options
      }));
    case 'map':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Map$1, {
        options: options
      }));
    case 'modal':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Modal, {
        options: options
      }));
    case 'searchbar':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(SearchBar, {
        options: options
      }));
    case 'text':
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, /*#__PURE__*/React__default["default"].createElement(Text, {
        options: options
      }));
    default:
      return /*#__PURE__*/React__default["default"].createElement(Wrapper, {
        options: options,
        key: pageBlock.id
      }, options.type);
  }
}
Block.propTypes = {
  pageBlock: PropTypes.object.isRequired
};
function Wrapper(_ref2) {
  var children = _ref2.children,
    options = _ref2.options;
  var type = options.type,
    classes = options.classes,
    id = options.id,
    style = options.style,
    className = options.className;
  var newClasses = "bu_cpb_".concat(type);
  Object.entries(classes).forEach(function (element) {
    newClasses += ' ';
    newClasses += element[1];
  });
  newClasses = classNames(newClasses, classes.width, className);
  return /*#__PURE__*/React__default["default"].createElement(BlockSelf, {
    className: newClasses,
    id: id,
    style: style
  }, children);
}
function Row(_ref) {
  var content = _ref.content,
    houses = _ref.houses,
    locale = _ref.locale;
  var options = content.options;
  var classes = 'page_row';
  if (options.classes) {
    Object.entries(options.classes).forEach(function (element) {
      classes += ' ';
      classes += element[1];
    });
    classes = classNames(classes, options.classes.width, options.className);
  }
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes,
    style: content.options.style
  }, content.page_blocks.map(function (block, index) {
    return /*#__PURE__*/React__default["default"].createElement(Block, {
      pageBlock: block,
      key: index,
      houses: houses,
      locale: locale
    });
  }));
}
function CmsBlocks(_ref) {
  var content = _ref.content,
    houses = _ref.houses,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'nl' : _ref$locale;
  return /*#__PURE__*/React__default["default"].createElement(BlockContainer, null, content.page_rows.map(function (row, index) {
    return /*#__PURE__*/React__default["default"].createElement(Row, {
      content: row,
      key: index,
      houses: houses,
      locale: locale
    });
  }));
}
module.exports = CmsBlocks;